import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: string;
  DateTimeInput: string;
  JSON: any;
  LogSeverityScalar: any;
  ObjectId: string;
  ObjectIdInput: string;
  Upload: any;
}

export interface AcceptImagesResponse {
  failedImages?: Maybe<Array<Maybe<FailedImages>>>;
  successfulSaves: Scalars['Int'];
}

export interface ActivationStatusFilter {
  conventionalChannelStatus: Scalars['String'];
  conventionalChannelStatusDetails: Scalars['String'];
  proprietaryChannelStatus: Scalars['String'];
  proprietaryChannelStatusDetails: Scalars['String'];
}

export interface AddImageToProcessingQueueInput {
  imageIds: Array<Scalars['String']>;
  processingPriority: Scalars['Int'];
  pv2Id: Scalars['String'];
}

export interface AddImageToProcessingQueueResponse {
  failedImages?: Maybe<Array<Maybe<FailedImages>>>;
  successfulSaves: Scalars['Int'];
}

export interface Adp_CreateAttributeFilesResponse {
  success: Scalars['Boolean'];
  table?: Maybe<Scalars['String']>;
}

export interface Adp_CreateHierarchyFileResponse {
  success: Scalars['Boolean'];
  table?: Maybe<Scalars['String']>;
}

export interface AliasMapping {
  _id: Scalars['ObjectId'];
  annotatedSpinsUpc?: Maybe<Scalars['String']>;
  annotatedSpinsUpcUpdatedDate?: Maybe<Scalars['DateTime']>;
  averagePrice?: Maybe<Scalars['Float']>;
  biEncoderScore?: Maybe<Scalars['Float']>;
  binaryScore?: Maybe<Scalars['Float']>;
  confidenceScore?: Maybe<Scalars['Float']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  isPlu?: Maybe<Scalars['String']>;
  itemCode?: Maybe<Scalars['String']>;
  itemDescription: Scalars['String'];
  modelVersion?: Maybe<Scalars['String']>;
  predictedProductType?: Maybe<Scalars['String']>;
  produceMatchedSpinsItemCode?: Maybe<Scalars['String']>;
  pucPredictions?: Maybe<Scalars['String']>;
  spinsItemCode: Scalars['String'];
  spinsRetailerId: Scalars['String'];
  spinsUpc?: Maybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface AliasMappingFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<AliasMapping>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface AliasMappingInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  annotatedSpinsUpc?: InputMaybe<Scalars['String']>;
  annotatedSpinsUpcUpdatedDate?: InputMaybe<Scalars['DateTime']>;
  averagePrice?: InputMaybe<Scalars['Float']>;
  biEncoderScore?: InputMaybe<Scalars['Float']>;
  binaryScore?: InputMaybe<Scalars['Float']>;
  confidenceScore?: InputMaybe<Scalars['Float']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  isPlu?: InputMaybe<Scalars['String']>;
  itemCode?: InputMaybe<Scalars['String']>;
  itemDescription?: InputMaybe<Scalars['String']>;
  modelVersion?: InputMaybe<Scalars['String']>;
  predictedProductType?: InputMaybe<Scalars['String']>;
  produceMatchedSpinsItemCode?: InputMaybe<Scalars['String']>;
  pucPredictions?: InputMaybe<Scalars['String']>;
  spinsItemCode?: InputMaybe<Scalars['String']>;
  spinsRetailerId?: InputMaybe<Scalars['String']>;
  spinsUpc?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

/** Product Description Page scraped from Amazon */
export interface AmazonProduct {
  _id: Scalars['ObjectId'];
  alsoBought: Array<Scalars['JSON']>;
  alsoViewed: Array<Scalars['JSON']>;
  amazonsChoice?: Maybe<Scalars['JSON']>;
  asin?: Maybe<Scalars['String']>;
  attributes: Array<Scalars['JSON']>;
  bestsellersRank: Array<Scalars['JSON']>;
  brand?: Maybe<Scalars['String']>;
  brandStore?: Maybe<Scalars['JSON']>;
  bundleContents: Array<Scalars['JSON']>;
  bundles: Array<Scalars['JSON']>;
  buyboxWinner?: Maybe<Scalars['JSON']>;
  categories: Array<Scalars['JSON']>;
  couponText?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** String date in the format of YYYY-MM-DD */
  dateParsed: Scalars['String'];
  deliveryMessage?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Scalars['String']>;
  featureBullets: Array<Scalars['String']>;
  firstAvailable?: Maybe<Scalars['JSON']>;
  frequentlyBoughtTogether?: Maybe<Scalars['JSON']>;
  gtin: Scalars['String'];
  hasCoupon?: Maybe<Scalars['Boolean']>;
  images: Array<Scalars['JSON']>;
  importantInformation?: Maybe<AmazonProductImportantInformation>;
  isBundle?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Scalars['String']>;
  keywordsList: Array<Scalars['String']>;
  kindleUnlimited?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['JSON']>;
  moreBuyingChoices: Array<Scalars['JSON']>;
  parentAsin?: Maybe<Scalars['String']>;
  promotions: Array<Scalars['JSON']>;
  pv2IdOrigins?: Maybe<Scalars['JSON']>;
  rating?: Maybe<Scalars['Float']>;
  ratingsTotal?: Maybe<Scalars['Float']>;
  requestMetadata?: Maybe<Scalars['JSON']>;
  requestParameters?: Maybe<Scalars['JSON']>;
  reviewsTotal?: Maybe<Scalars['Float']>;
  services: Array<Scalars['JSON']>;
  shippingWeight?: Maybe<Scalars['String']>;
  shopByLook?: Maybe<Scalars['JSON']>;
  specifications: Array<Scalars['JSON']>;
  sponsoredProducts: Array<Scalars['JSON']>;
  status: AmazonProductStatusEnum;
  subTitle?: Maybe<Scalars['JSON']>;
  summarizationAttributes: Array<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
  topReviews: Array<Scalars['JSON']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  variants: Array<Scalars['JSON']>;
  videos: Array<Scalars['JSON']>;
  weight?: Maybe<Scalars['String']>;
}

export interface AmazonProductFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<AmazonProduct>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface AmazonProductImportantInformation {
  sections: Array<Scalars['JSON']>;
}

export interface AmazonProductImportantInformationInput {
  sections?: InputMaybe<Array<Scalars['JSON']>>;
}

/** Product Description Page scraped from Amazon */
export interface AmazonProductInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  alsoBought?: InputMaybe<Array<Scalars['JSON']>>;
  alsoViewed?: InputMaybe<Array<Scalars['JSON']>>;
  amazonsChoice?: InputMaybe<Scalars['JSON']>;
  asin?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Array<Scalars['JSON']>>;
  bestsellersRank?: InputMaybe<Array<Scalars['JSON']>>;
  brand?: InputMaybe<Scalars['String']>;
  brandStore?: InputMaybe<Scalars['JSON']>;
  bundleContents?: InputMaybe<Array<Scalars['JSON']>>;
  bundles?: InputMaybe<Array<Scalars['JSON']>>;
  buyboxWinner?: InputMaybe<Scalars['JSON']>;
  categories?: InputMaybe<Array<Scalars['JSON']>>;
  couponText?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  /** String date in the format of YYYY-MM-DD */
  dateParsed?: InputMaybe<Scalars['String']>;
  deliveryMessage?: InputMaybe<Scalars['String']>;
  dimensions?: InputMaybe<Scalars['String']>;
  featureBullets?: InputMaybe<Array<Scalars['String']>>;
  firstAvailable?: InputMaybe<Scalars['JSON']>;
  frequentlyBoughtTogether?: InputMaybe<Scalars['JSON']>;
  gtin?: InputMaybe<Scalars['String']>;
  hasCoupon?: InputMaybe<Scalars['Boolean']>;
  images?: InputMaybe<Array<Scalars['JSON']>>;
  importantInformation?: InputMaybe<AmazonProductImportantInformationInput>;
  isBundle?: InputMaybe<Scalars['Boolean']>;
  keywords?: InputMaybe<Scalars['String']>;
  keywordsList?: InputMaybe<Array<Scalars['String']>>;
  kindleUnlimited?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<Scalars['String']>;
  mainImage?: InputMaybe<Scalars['JSON']>;
  moreBuyingChoices?: InputMaybe<Array<Scalars['JSON']>>;
  parentAsin?: InputMaybe<Scalars['String']>;
  promotions?: InputMaybe<Array<Scalars['JSON']>>;
  pv2IdOrigins?: InputMaybe<Scalars['JSON']>;
  rating?: InputMaybe<Scalars['Float']>;
  ratingsTotal?: InputMaybe<Scalars['Float']>;
  requestMetadata?: InputMaybe<Scalars['JSON']>;
  requestParameters?: InputMaybe<Scalars['JSON']>;
  reviewsTotal?: InputMaybe<Scalars['Float']>;
  services?: InputMaybe<Array<Scalars['JSON']>>;
  shippingWeight?: InputMaybe<Scalars['String']>;
  shopByLook?: InputMaybe<Scalars['JSON']>;
  specifications?: InputMaybe<Array<Scalars['JSON']>>;
  sponsoredProducts?: InputMaybe<Array<Scalars['JSON']>>;
  status?: InputMaybe<AmazonProductStatusEnum>;
  subTitle?: InputMaybe<Scalars['JSON']>;
  summarizationAttributes?: InputMaybe<Array<Scalars['JSON']>>;
  title?: InputMaybe<Scalars['String']>;
  topReviews?: InputMaybe<Array<Scalars['JSON']>>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  variants?: InputMaybe<Array<Scalars['JSON']>>;
  videos?: InputMaybe<Array<Scalars['JSON']>>;
  weight?: InputMaybe<Scalars['String']>;
}

export enum AmazonProductStatusEnum {
  Active = 'active',
  Inactive = 'inactive',
  Missing = 'missing'
}

export interface AnalyticsClientFeedbackJiraIssue {
  _id: Scalars['ObjectId'];
  archive: Scalars['Boolean'];
  assignee?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  components: Array<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  issueKey: Scalars['String'];
  jiraUpdatedDate: Scalars['DateTime'];
  reporter?: Maybe<Scalars['String']>;
  rootCauses: Array<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface AnalyticsClientFeedbackJiraIssueFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<AnalyticsClientFeedbackJiraIssue>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface AnalyticsClientFeedbackJiraIssueInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  archive?: InputMaybe<Scalars['Boolean']>;
  assignee?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  components?: InputMaybe<Array<Scalars['String']>>;
  created?: InputMaybe<Scalars['DateTime']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  issueKey?: InputMaybe<Scalars['String']>;
  jiraUpdatedDate?: InputMaybe<Scalars['DateTime']>;
  reporter?: InputMaybe<Scalars['String']>;
  rootCauses?: InputMaybe<Array<Scalars['String']>>;
  summary?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface AnalyticsClientFeedbackSpinsAttribute {
  _id: Scalars['ObjectId'];
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  department?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  spinsUpc: Scalars['String'];
  subcategory?: Maybe<Scalars['String']>;
  upcEan13?: Maybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface AnalyticsClientFeedbackSpinsAttributeFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<AnalyticsClientFeedbackSpinsAttribute>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface AnalyticsClientFeedbackSpinsAttributeInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  brand?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  spinsUpc?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  upcEan13?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface AnalyticsClientFeedbackTrackerUpdate {
  _id: Scalars['ObjectId'];
  attributeName: Scalars['String'];
  attributeValue: Scalars['String'];
  clientValidatedCoding: Scalars['Boolean'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  jiraAssignee?: Maybe<Scalars['String']>;
  jiraClientName?: Maybe<Scalars['String']>;
  jiraTicket?: Maybe<Scalars['String']>;
  periodRelease?: Maybe<Scalars['String']>;
  spinsUpc: Scalars['String'];
  trackerId: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface AnalyticsClientFeedbackTrackerUpdateFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<AnalyticsClientFeedbackTrackerUpdate>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface AnalyticsClientFeedbackTrackerUpdateInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  attributeName?: InputMaybe<Scalars['String']>;
  attributeValue?: InputMaybe<Scalars['String']>;
  clientValidatedCoding?: InputMaybe<Scalars['Boolean']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  jiraAssignee?: InputMaybe<Scalars['String']>;
  jiraClientName?: InputMaybe<Scalars['String']>;
  jiraTicket?: InputMaybe<Scalars['String']>;
  periodRelease?: InputMaybe<Scalars['String']>;
  spinsUpc?: InputMaybe<Scalars['String']>;
  trackerId?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface AnalyticsOperationalKpi {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  datePulled: Scalars['DateTime'];
  name: Scalars['String'];
  period?: Maybe<Scalars['String']>;
  /** - enum: "Data Quality", "Customer Acceptance" */
  type: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  value: Scalars['Float'];
  /** - enum: "Percentage", "Total Count", "Distinct Count" */
  valueType: Scalars['String'];
  year?: Maybe<Scalars['Float']>;
}

export interface AnalyticsOperationalKpiFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<AnalyticsOperationalKpi>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface AnalyticsOperationalKpiInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  datePulled?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['String']>;
  /** - enum: "Data Quality", "Customer Acceptance" */
  type?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Float']>;
  /** - enum: "Percentage", "Total Count", "Distinct Count" */
  valueType?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Float']>;
}

export interface AnalyticsProductCount {
  _id: Scalars['ObjectId'];
  collections: Array<Scalars['String']>;
  count: Scalars['Float'];
  countType: AnalyticsProductCountCountTypeEnum;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  query?: Maybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export enum AnalyticsProductCountCountTypeEnum {
  Pv2AsinTotal = 'pv2_asin_total',
  SpinsAttributesTotal = 'spins_attributes_total'
}

export interface AnalyticsProductCountFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<AnalyticsProductCount>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface AnalyticsProductCountInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  collections?: InputMaybe<Array<Scalars['String']>>;
  count?: InputMaybe<Scalars['Float']>;
  countType?: InputMaybe<AnalyticsProductCountCountTypeEnum>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface AnalyticsQcSelfServe {
  _id: Scalars['ObjectId'];
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  channelConv?: Maybe<Scalars['Boolean']>;
  channelProp?: Maybe<Scalars['Boolean']>;
  checkDescription?: Maybe<Scalars['String']>;
  checkId: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  conflictingAttribute?: Maybe<Scalars['String']>;
  conflictingValue?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Whole UTC calendar days from firstFlaggedDate to today. Computed at query time. */
  daysSinceFlagged: Scalars['Int'];
  delivered: Scalars['Boolean'];
  department?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  expectedOutcome?: Maybe<Scalars['String']>;
  expectedValue?: Maybe<Scalars['String']>;
  firstFlaggedDate: Scalars['DateTime'];
  functionalIngredient?: Maybe<Scalars['String']>;
  functionalIngredientFlag?: Maybe<Scalars['String']>;
  lowConfidence?: Maybe<Scalars['Boolean']>;
  mfrCode?: Maybe<Scalars['String']>;
  organic?: Maybe<Scalars['String']>;
  peerSupport?: Maybe<Scalars['String']>;
  primaryAttribute?: Maybe<Scalars['String']>;
  primaryValue?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  pv2Id: Scalars['String'];
  pvlConv?: Maybe<Scalars['Boolean']>;
  pvlProp?: Maybe<Scalars['Boolean']>;
  rowKey: Scalars['String'];
  secondaryAttribute?: Maybe<Scalars['String']>;
  secondaryValue?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  /** - enum: "dh-check", "brand-position-rule" */
  source: Scalars['String'];
  spinsUpc?: Maybe<Scalars['String']>;
  status?: Maybe<AnalyticsQcSelfServeStatusEnum>;
  subcategory?: Maybe<Scalars['String']>;
  /** - enum: "DA&D", "PR" */
  team: Scalars['String'];
  unitOfMeasure?: Maybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface AnalyticsQcSelfServeFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<AnalyticsQcSelfServe>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface AnalyticsQcSelfServeInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  brand?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  channelConv?: InputMaybe<Scalars['Boolean']>;
  channelProp?: InputMaybe<Scalars['Boolean']>;
  checkDescription?: InputMaybe<Scalars['String']>;
  checkId?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  conflictingAttribute?: InputMaybe<Scalars['String']>;
  conflictingValue?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  delivered?: InputMaybe<Scalars['Boolean']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  expectedOutcome?: InputMaybe<Scalars['String']>;
  expectedValue?: InputMaybe<Scalars['String']>;
  firstFlaggedDate?: InputMaybe<Scalars['DateTime']>;
  functionalIngredient?: InputMaybe<Scalars['String']>;
  functionalIngredientFlag?: InputMaybe<Scalars['String']>;
  lowConfidence?: InputMaybe<Scalars['Boolean']>;
  mfrCode?: InputMaybe<Scalars['String']>;
  organic?: InputMaybe<Scalars['String']>;
  peerSupport?: InputMaybe<Scalars['String']>;
  primaryAttribute?: InputMaybe<Scalars['String']>;
  primaryValue?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  pv2Id?: InputMaybe<Scalars['String']>;
  pvlConv?: InputMaybe<Scalars['Boolean']>;
  pvlProp?: InputMaybe<Scalars['Boolean']>;
  rowKey?: InputMaybe<Scalars['String']>;
  secondaryAttribute?: InputMaybe<Scalars['String']>;
  secondaryValue?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  /** - enum: "dh-check", "brand-position-rule" */
  source?: InputMaybe<Scalars['String']>;
  spinsUpc?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AnalyticsQcSelfServeStatusEnum>;
  subcategory?: InputMaybe<Scalars['String']>;
  /** - enum: "DA&D", "PR" */
  team?: InputMaybe<Scalars['String']>;
  unitOfMeasure?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export enum AnalyticsQcSelfServeStatusEnum {
  Mismatch = 'mismatch',
  MismatchLowConfidence = 'mismatch_low_confidence',
  MissingBrandPositionTag = 'missing_brand_position_tag',
  MissingBrandPositionTagLowConfidence = 'missing_brand_position_tag_low_confidence'
}

/** Stores the raw annotation object returned from aperture when running scripts/importlatestApertureImagesAndData */
export interface ApertureAnnotation {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  pv2?: Maybe<Pv2>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  value: Array<ApertureAnnotationStruct>;
}

export interface ApertureAnnotationFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<ApertureAnnotation>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Stores the raw annotation object returned from aperture when running scripts/importlatestApertureImagesAndData */
export interface ApertureAnnotationInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  pv2?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Array<ApertureAnnotationStructInput>>;
}

export interface ApertureAnnotationStruct {
  _id: Scalars['ObjectId'];
  /** Could be string, number, or boolean */
  _value?: Maybe<Scalars['String']>;
  box?: Maybe<Scalars['JSON']>;
  confidence?: Maybe<Scalars['Float']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  /**
   * Determines the shape of the value attribute
   * There can be multiple attributes with the same type in a product
   */
  type: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  /** @virtual */
  value: Scalars['JSON'];
}

export interface ApertureAnnotationStructInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Could be string, number, or boolean */
  _value?: InputMaybe<Scalars['String']>;
  box?: InputMaybe<Scalars['JSON']>;
  confidence?: InputMaybe<Scalars['Float']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * Determines the shape of the value attribute
   * There can be multiple attributes with the same type in a product
   */
  type?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  /** @virtual */
  value?: InputMaybe<Scalars['JSON']>;
}

export interface AsinAttributeLevelCoverageResult {
  asinKnownValuePercent: Scalars['Float'];
  asinUnknownValuePercent: Scalars['Float'];
  asinsWithKnownValue: Scalars['Int'];
  asinsWithUnknownValue: Scalars['Int'];
  attributeThemeType: Scalars['String'];
  displayName: Scalars['String'];
  salesKnownValuePercent: Scalars['Float'];
  salesUnknownValuePercent: Scalars['Float'];
  salesWithKnownValue: Scalars['Float'];
  salesWithUnknownValue: Scalars['Float'];
  top25Attribute: Scalars['String'];
  totalEligibleAsins: Scalars['Int'];
  totalEligibleSales: Scalars['Float'];
}

export interface AsinCoverageAttributeThemeFilter {
  attributeThemeType: Scalars['String'];
  displayName: Scalars['String'];
}

export interface AsinCoverageBrandFilter {
  brand: Scalars['String'];
}

export interface AsinCoverageHierarchyFilter {
  category: Scalars['String'];
  department: Scalars['String'];
  subcategory: Scalars['String'];
}

export interface AsinLevelCoveragePage {
  nodes: Array<AsinLevelCoverageResult>;
  totalCount: Scalars['Int'];
}

export interface AsinLevelCoverageResult {
  asin: Scalars['String'];
  attributeLevelSalesKnownValuePercent: Scalars['Float'];
  attributeLevelSalesKnownValuePercentIncrease: Scalars['Float'];
  attributeThemeType: Scalars['String'];
  brand: Scalars['String'];
  category: Scalars['String'];
  department: Scalars['String'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  subcategory: Scalars['String'];
  subcategoryLevelSalesKnownValuePercent: Scalars['Float'];
  subcategoryLevelSalesKnownValuePercentIncrease: Scalars['Float'];
  top25Attribute: Scalars['String'];
  totalDollarSales: Scalars['Float'];
}

export interface AsinSubcategoryLevelCoverageResult {
  asinKnownValuePercent: Scalars['Float'];
  asinUnknownValuePercent: Scalars['Float'];
  asinsWithKnownValue: Scalars['Int'];
  asinsWithUnknownValue: Scalars['Int'];
  attributeThemeType: Scalars['String'];
  category: Scalars['String'];
  department: Scalars['String'];
  displayName: Scalars['String'];
  salesKnownValuePercent: Scalars['Float'];
  salesUnknownValuePercent: Scalars['Float'];
  salesWithKnownValue: Scalars['Float'];
  salesWithUnknownValue: Scalars['Float'];
  subcategory: Scalars['String'];
  top25Attribute: Scalars['String'];
  totalEligibleAsins: Scalars['Int'];
  totalEligibleSales: Scalars['Float'];
}

export interface Attribute {
  type: Scalars['String'];
  value?: Maybe<Scalars['JSON']>;
}

export interface AttributeCoverageAttributeThemeFilter {
  attributeThemeType: Scalars['String'];
  displayName: Scalars['String'];
}

export interface AttributeCoverageBrandFilter {
  brand: Scalars['String'];
}

export interface AttributeCoverageHierarchyFilter {
  category: Scalars['String'];
  department: Scalars['String'];
  subcategory: Scalars['String'];
}

export interface AttributeLevelCoverageResult {
  attributeThemeType: Scalars['String'];
  displayName: Scalars['String'];
  geography: Scalars['String'];
  salesKnownValuePercent: Scalars['Float'];
  salesUnknownValuePercent: Scalars['Float'];
  salesWithKnownValue: Scalars['Float'];
  salesWithUnknownValue: Scalars['Float'];
  time: Scalars['String'];
  top25Attribute: Scalars['String'];
  totalEligibleSales: Scalars['Float'];
  totalEligibleUpcs: Scalars['Int'];
  upcKnownValuePercent: Scalars['Float'];
  upcUnknownValuePercent: Scalars['Float'];
  upcsWithKnownValue: Scalars['Int'];
  upcsWithUnknownValue: Scalars['Int'];
}

export interface AttributeSalesAssessmentAggregation {
  groupValue?: Maybe<Scalars['String']>;
  salesPercentChangeYago: Scalars['Float'];
  salesPlusOrMinusChgYago: Scalars['Float'];
  totalCurrentSales: Scalars['Float'];
  totalPreviousSales: Scalars['Float'];
  upcCount: Scalars['Int'];
}

export interface AttributeSalesAssessmentResult {
  SPINS_UPC: Scalars['String'];
  brand: Scalars['String'];
  builder_batch_id: Scalars['String'];
  created_date: Scalars['DateTime'];
  error?: Maybe<Scalars['String']>;
  extra_fields?: Maybe<Scalars['String']>;
  full_taxonomy_breadcrumb: Scalars['String'];
  gtin: Scalars['String'];
  in_nhn: Scalars['String'];
  in_snapshot: Scalars['String'];
  most_granular_taxonomy: Scalars['String'];
  most_granular_taxonomy_name: Scalars['String'];
  name: Scalars['String'];
  pv2_id: Scalars['String'];
  report_run_id: Scalars['String'];
  salesPercentChangeYago?: Maybe<Scalars['Float']>;
  salesPlusOrMinusChgYago?: Maybe<Scalars['Float']>;
  spins_brand?: Maybe<Scalars['String']>;
  spins_brand_position?: Maybe<Scalars['String']>;
  spins_category?: Maybe<Scalars['String']>;
  spins_department?: Maybe<Scalars['String']>;
  spins_description?: Maybe<Scalars['String']>;
  spins_positioning_group?: Maybe<Scalars['String']>;
  spins_product_type?: Maybe<Scalars['String']>;
  spins_sca?: Maybe<Scalars['String']>;
  spins_sn?: Maybe<Scalars['String']>;
  spins_subcategory?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  taxonomies: Scalars['String'];
  totalCurrentSales?: Maybe<Scalars['Float']>;
  totalPreviousSales?: Maybe<Scalars['Float']>;
  updated: Scalars['Boolean'];
}

export interface AttributeSalesAssessmentRunResponse {
  error?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['String']>;
  scriptLogsUrl?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
}

export interface AttributeSalesAssessmentStats {
  countOfCategory: Scalars['Int'];
  countOfSubcategory: Scalars['Int'];
  countOfUpc: Scalars['Int'];
  countOfUpcInSnapshot: Scalars['Int'];
  salesPercentChangeYago: Scalars['Float'];
  salesPlusOrMinusChgYago: Scalars['Float'];
  totalCurrentSales: Scalars['Float'];
  totalPreviousSales: Scalars['Float'];
}

export interface AttributeSalesFilterCombo {
  builderBatchId: Scalars['String'];
  reportRunId: Scalars['String'];
}

export interface AttributeTypeWithFieldTypes {
  attributeType: Scalars['String'];
  fields: Array<ModelColumnInfo>;
}

/** Store cron notifications sent to brands/nhn */
export interface AutoNotifications {
  _id: Scalars['ObjectId'];
  createdDate?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Domain>;
  email?: Maybe<Scalars['String']>;
  notificationSubject?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
}

export interface AutoNotificationsFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<AutoNotifications>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Store cron notifications sent to brands/nhn */
export interface AutoNotificationsInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  domain?: InputMaybe<Scalars['ObjectId']>;
  email?: InputMaybe<Scalars['String']>;
  notificationSubject?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

/**
 * Handles situations where the results need to be loaded on-the-fly from another model
 *
 * **Pv2_search type:**
 *
 * ```
 * {
 *     type: 'field';
 *     id: string;
 *     value: ObjectId | ObjectId[];
 * }
 * ```
 */
export interface AutocompleteSearchField extends ISearchField {
  /** Optional section in which this option should be places */
  group?: Maybe<Scalars['String']>;
  /** Unique identifier of a specific operation. It is the main value used for searching */
  id: Scalars['String'];
  /** Human-friendly label */
  label: Scalars['String'];
  /** Which model does this autocomplete refers to */
  model: ModelEnum;
  /** The field which should be used when accessing model data */
  modelField: Scalars['String'];
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: Pv2SearchFieldType;
}

export interface BarcodeStruct {
  GTIN: Scalars['String'];
  date: Scalars['DateTime'];
  domain?: Maybe<Domain>;
  format: Scalars['String'];
  hash?: Maybe<Scalars['String']>;
  isPrivateLabel?: Maybe<Scalars['Boolean']>;
  options?: Maybe<BarcodeStructOptions>;
  original: Scalars['String'];
  source?: Maybe<Scalars['String']>;
}

export interface BarcodeStructInput {
  GTIN?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  domain?: InputMaybe<Scalars['ObjectId']>;
  format?: InputMaybe<Scalars['String']>;
  hash?: InputMaybe<Scalars['String']>;
  isPrivateLabel?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<BarcodeStructOptionsInput>;
  original?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
}

export interface BarcodeStructOptions {
  addCheckDigit?: Maybe<Scalars['Boolean']>;
  shouldTrimLeadingZeros?: Maybe<Scalars['Boolean']>;
}

export interface BarcodeStructOptionsInput {
  addCheckDigit?: InputMaybe<Scalars['Boolean']>;
  shouldTrimLeadingZeros?: InputMaybe<Scalars['Boolean']>;
}

export enum BillingSource {
  GcpDev = 'GCP_DEV',
  GcpProd = 'GCP_PROD',
  GcpUat = 'GCP_UAT',
  MongoAtlas = 'MONGO_ATLAS',
  Snowflake = 'SNOWFLAKE'
}

export enum BrandMatchReasonEnum {
  OneNameInsideTheOther = 'one_name_inside_the_other',
  OneNameStartsTheOther = 'one_name_starts_the_other',
  PossibleMisspelling = 'possible_misspelling',
  SameNameDifferentSpacing = 'same_name_different_spacing'
}

/**
 * A candidate pair of brand values that may be variants of one another, surfaced for manual review.
 * Rows are proposed by `scripts/brand-review-proposer.ts`, which runs one unpartitioned aggregation
 * over `SpinsAttributes.attributes[BRAND]` weekly and upserts the result here, keyed on `pairKey`.
 * This collection holds what the report shows plus the one key the weekly refresh
 * needs; the matching model's thresholds gate inside the aggregation and are not stored.
 * `opsReview` is where a decision lands. A new pair starts as `{ reviewStatus: pending }`
 * from the schema default; the proposer never writes it beyond that, so a weekly run cannot
 * move or clear a decision. Pairs written before that default may have no `opsReview`.
 */
export interface BrandReview {
  _id: Scalars['ObjectId'];
  /** The raw BRAND attributeValue whose separator-free key is the shorter one. */
  brandA: Scalars['String'];
  /** Products carrying brandA, over the whole aggregated slice. */
  brandAItemCount: Scalars['Float'];
  brandB: Scalars['String'];
  brandBItemCount: Scalars['Float'];
  /**
   * Which rule paired these two values.
   * The report's filter column - a reviewer picks one reason and works that batch,
   * since the judgment each reason calls for is different.
   */
  brandMatchReason: BrandMatchReasonEnum;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  merge?: Maybe<BrandReviewMerge>;
  opsReview: BrandReviewOpsReview;
  /**
   * Stable natural key for the pair - the two RAW brand values joined by a double
   * pipe, shorter side first (e.g. "ANNIES||ANNIES HOMEGROWN"). Raw rather than
   * normalized because normalization is many-to-one, and keying on the normalized form
   * would collapse genuinely distinct pairs into one review row. This is the dedupe key
   * the proposer aggregation groups on, and what the weekly upsert matches against.
   */
  pairKey: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface BrandReviewFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<BrandReview>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/**
 * A candidate pair of brand values that may be variants of one another, surfaced for manual review.
 * Rows are proposed by `scripts/brand-review-proposer.ts`, which runs one unpartitioned aggregation
 * over `SpinsAttributes.attributes[BRAND]` weekly and upserts the result here, keyed on `pairKey`.
 * This collection holds what the report shows plus the one key the weekly refresh
 * needs; the matching model's thresholds gate inside the aggregation and are not stored.
 * `opsReview` is where a decision lands. A new pair starts as `{ reviewStatus: pending }`
 * from the schema default; the proposer never writes it beyond that, so a weekly run cannot
 * move or clear a decision. Pairs written before that default may have no `opsReview`.
 */
export interface BrandReviewInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** The raw BRAND attributeValue whose separator-free key is the shorter one. */
  brandA?: InputMaybe<Scalars['String']>;
  /** Products carrying brandA, over the whole aggregated slice. */
  brandAItemCount?: InputMaybe<Scalars['Float']>;
  brandB?: InputMaybe<Scalars['String']>;
  brandBItemCount?: InputMaybe<Scalars['Float']>;
  /**
   * Which rule paired these two values.
   * The report's filter column - a reviewer picks one reason and works that batch,
   * since the judgment each reason calls for is different.
   */
  brandMatchReason?: InputMaybe<BrandMatchReasonEnum>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  merge?: InputMaybe<BrandReviewMergeInput>;
  opsReview?: InputMaybe<BrandReviewOpsReviewInput>;
  /**
   * Stable natural key for the pair - the two RAW brand values joined by a double
   * pipe, shorter side first (e.g. "ANNIES||ANNIES HOMEGROWN"). Raw rather than
   * normalized because normalization is many-to-one, and keying on the normalized form
   * would collapse genuinely distinct pairs into one review row. This is the dedupe key
   * the proposer aggregation groups on, and what the weekly upsert matches against.
   */
  pairKey?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

/**
 * Set by `scripts/brand-review-merge.ts` once an approved review's surviving
 * brand has been written to CleansedData as an `override:brand-review` point
 * and the SPINS Brand build re-triggered. A review is merged at most once; the
 * nightly job only picks up approved reviews without this. Not meant to be set
 * by hand.
 */
export interface BrandReviewMerge {
  /** CleansedData documents the merge wrote a brand point to. */
  cleansedDataCount: Scalars['Float'];
  losingBrand: Scalars['String'];
  mergedDate: Scalars['DateTime'];
  /** Pv2s carrying losingBrand when the merge ran. */
  pv2Count: Scalars['Float'];
  /**
   * The brand written to CleansedData in place of losingBrand. Usually
   * opsReview.survivingBrand, but the end of the chain when that brand was itself
   * merged in the same run.
   */
  winningBrand: Scalars['String'];
}

/**
 * Set by `scripts/brand-review-merge.ts` once an approved review's surviving
 * brand has been written to CleansedData as an `override:brand-review` point
 * and the SPINS Brand build re-triggered. A review is merged at most once; the
 * nightly job only picks up approved reviews without this. Not meant to be set
 * by hand.
 */
export interface BrandReviewMergeInput {
  /** CleansedData documents the merge wrote a brand point to. */
  cleansedDataCount?: InputMaybe<Scalars['Float']>;
  losingBrand?: InputMaybe<Scalars['String']>;
  mergedDate?: InputMaybe<Scalars['DateTime']>;
  /** Pv2s carrying losingBrand when the merge ran. */
  pv2Count?: InputMaybe<Scalars['Float']>;
  /**
   * The brand written to CleansedData in place of losingBrand. Usually
   * opsReview.survivingBrand, but the end of the chain when that brand was itself
   * merged in the same run.
   */
  winningBrand?: InputMaybe<Scalars['String']>;
}

/**
 * An ops decision on the pair. Starts as `{ reviewStatus: pending }` with every
 * other field blank until someone reviews it. The weekly proposer only sets it
 * when inserting a new pair, so a run can never move or clear a decision.
 * reviewStatus is required WITHIN the sub-document, so a decision cannot be
 * recorded without one.
 */
export interface BrandReviewOpsReview {
  reasonCode?: Maybe<BrandReviewReasonEnum>;
  reviewStatus: BrandReviewStatusEnum;
  reviewer?: Maybe<User>;
  /** Which of the two brand values the reviewer kept. */
  survivingBrand?: Maybe<Scalars['String']>;
}

/**
 * An ops decision on the pair. Starts as `{ reviewStatus: pending }` with every
 * other field blank until someone reviews it. The weekly proposer only sets it
 * when inserting a new pair, so a run can never move or clear a decision.
 * reviewStatus is required WITHIN the sub-document, so a decision cannot be
 * recorded without one.
 */
export interface BrandReviewOpsReviewInput {
  reasonCode?: InputMaybe<BrandReviewReasonEnum>;
  reviewStatus?: InputMaybe<BrandReviewStatusEnum>;
  reviewer?: InputMaybe<Scalars['ObjectId']>;
  /** Which of the two brand values the reviewer kept. */
  survivingBrand?: InputMaybe<Scalars['String']>;
}

export enum BrandReviewReasonEnum {
  Other = 'other',
  RetailerPrivateLabelFamily = 'retailer_private_label_family',
  SameBrandSpacingOrPunctuation = 'same_brand_spacing_or_punctuation',
  SameBrandSpellingVariant = 'same_brand_spelling_variant',
  SameBrandTypo = 'same_brand_typo',
  SubBrandDistinct = 'sub_brand_distinct',
  SubBrandShouldMerge = 'sub_brand_should_merge',
  SubstringCollision = 'substring_collision',
  UnrelatedBrands = 'unrelated_brands'
}

export enum BrandReviewStatusEnum {
  Approved = 'approved',
  NeedsAdditionalReview = 'needsAdditionalReview',
  Pending = 'pending',
  Rejected = 'rejected'
}

export interface BuilderBatch {
  _formula: Scalars['String'];
  _id: Scalars['ObjectId'];
  _query?: Maybe<Scalars['String']>;
  _runStats?: Maybe<Scalars['String']>;
  cancellationRequested: Scalars['Boolean'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  /**
   * A descriptive name for the batch to display in the UI when the batch trigger is not a simple/single
   * formula (e.g. triggering a recompute for a resource).
   */
  description?: Maybe<Scalars['String']>;
  environment?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  errorStack?: Maybe<Scalars['String']>;
  /** @virtual */
  formula: Scalars['JSON'];
  includeArtifacts: Scalars['Boolean'];
  limit?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  /** When enabled, an email will be sent to the user that created this batch */
  notifyByEmail: Scalars['Boolean'];
  processing?: Maybe<BuilderBatchProcessing>;
  /** @virtual */
  query?: Maybe<Scalars['JSON']>;
  /** @virtual */
  runStats?: Maybe<Scalars['JSON']>;
  /** Set to true to apply recomputations from the batch back to the database */
  saveComputationsToPv2s: Scalars['Boolean'];
  saveToBigQuery?: Maybe<Scalars['Boolean']>;
  saveToFile?: Maybe<BuilderBatchSaveToFile>;
  status: BuilderBatchStatusEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface BuilderBatchFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<BuilderBatch>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface BuilderBatchInput {
  _formula?: InputMaybe<Scalars['String']>;
  _id?: InputMaybe<Scalars['ObjectId']>;
  _query?: InputMaybe<Scalars['String']>;
  _runStats?: InputMaybe<Scalars['String']>;
  cancellationRequested?: InputMaybe<Scalars['Boolean']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * A descriptive name for the batch to display in the UI when the batch trigger is not a simple/single
   * formula (e.g. triggering a recompute for a resource).
   */
  description?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<Scalars['String']>;
  error?: InputMaybe<Scalars['String']>;
  errorStack?: InputMaybe<Scalars['String']>;
  /** @virtual */
  formula?: InputMaybe<Scalars['JSON']>;
  includeArtifacts?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  /** When enabled, an email will be sent to the user that created this batch */
  notifyByEmail?: InputMaybe<Scalars['Boolean']>;
  processing?: InputMaybe<BuilderBatchProcessingInput>;
  /** @virtual */
  query?: InputMaybe<Scalars['JSON']>;
  /** @virtual */
  runStats?: InputMaybe<Scalars['JSON']>;
  /** Set to true to apply recomputations from the batch back to the database */
  saveComputationsToPv2s?: InputMaybe<Scalars['Boolean']>;
  saveToBigQuery?: InputMaybe<Scalars['Boolean']>;
  saveToFile?: InputMaybe<BuilderBatchSaveToFileInput>;
  status?: InputMaybe<BuilderBatchStatusEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface BuilderBatchProcessing {
  durationInSeconds?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['DateTime']>;
  numProducts?: Maybe<Scalars['Float']>;
  /** While this batch is processing, this field is updated periodically with how many products have been processed */
  progress: Scalars['Float'];
  startDate: Scalars['DateTime'];
}

export interface BuilderBatchProcessingInput {
  durationInSeconds?: InputMaybe<Scalars['Float']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  numProducts?: InputMaybe<Scalars['Float']>;
  /** While this batch is processing, this field is updated periodically with how many products have been processed */
  progress?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
}

export interface BuilderBatchSaveToFile {
  allVariables?: Maybe<Scalars['Boolean']>;
  /** When enabled, product data and artifacts will be stored to s3 and and s3Path will be created */
  enabled?: Maybe<Scalars['Boolean']>;
  fields: Array<Scalars['String']>;
  format: BuilderBatchSaveToFileFormatEnum;
  /**
   * When true, filters output file to only include Pv2's that are (or would be) updated.
   * Otherwise, report file will include all Pv2's from the batch.
   */
  onlyIncludeUpdatedPv2s?: Maybe<Scalars['Boolean']>;
  /** bucket/key */
  s3Path: Scalars['String'];
}

export enum BuilderBatchSaveToFileFormatEnum {
  Csv = 'csv',
  Jsonl = 'jsonl'
}

export interface BuilderBatchSaveToFileInput {
  allVariables?: InputMaybe<Scalars['Boolean']>;
  /** When enabled, product data and artifacts will be stored to s3 and and s3Path will be created */
  enabled?: InputMaybe<Scalars['Boolean']>;
  fields?: InputMaybe<Array<Scalars['String']>>;
  format?: InputMaybe<BuilderBatchSaveToFileFormatEnum>;
  /**
   * When true, filters output file to only include Pv2's that are (or would be) updated.
   * Otherwise, report file will include all Pv2's from the batch.
   */
  onlyIncludeUpdatedPv2s?: InputMaybe<Scalars['Boolean']>;
  /** bucket/key */
  s3Path?: InputMaybe<Scalars['String']>;
}

export enum BuilderBatchStatusEnum {
  Cancelled = 'cancelled',
  Done = 'done',
  Error = 'error',
  Pending = 'pending',
  Processing = 'processing'
}

export interface BuilderRecomputeRun {
  bqDatasetUrl?: Maybe<Scalars['String']>;
  bqTables: Array<Scalars['String']>;
  dagRunId: Scalars['String'];
  dagRunUrl: Scalars['String'];
  dataflowJobId?: Maybe<Scalars['String']>;
  dataflowState?: Maybe<Scalars['String']>;
  dataflowUrl?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  runDescription?: Maybe<Scalars['String']>;
  saveComputationToPv2: Scalars['Boolean'];
  startDate?: Maybe<Scalars['String']>;
  state: Scalars['String'];
}

export interface ChangelogEntryStruct {
  date: Scalars['DateTime'];
  message: Scalars['String'];
  user?: Maybe<User>;
  version: Scalars['Float'];
}

export interface ChangelogEntryStructInput {
  date?: InputMaybe<Scalars['DateTime']>;
  message?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ObjectId']>;
  version?: InputMaybe<Scalars['Float']>;
}

export interface CheckIngredients {
  products: Array<IngredientCheckerProducts>;
  searchId?: Maybe<Scalars['String']>;
}

export interface CheckboxEditableField extends IEditableField {
  /**
   * List of field id-s to reset the value on change.
   *
   * E.g. when `width_mm` is changed `with_inch` should be cleared since those 2 fields are computed based on each-other in the backend
   */
  clearOnChange?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  /** Hidden fields should not be rendered but can still be used to update the Pv2 */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Unique field identifier */
  id: Scalars['String'];
  /** Human-readlabe name */
  label: Scalars['String'];
  readonly: Scalars['Boolean'];
  required: Scalars['Boolean'];
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: IEditableFieldTypeEnum;
  value?: Maybe<Scalars['JSON']>;
}

export interface CircanaBrandMapping {
  _id: Scalars['ObjectId'];
  dictBrand: Scalars['String'];
  manuCode: Scalars['String'];
  spinsBrand: Scalars['String'];
}

export interface CircanaBrandMappingFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<CircanaBrandMapping>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface CircanaBrandMappingInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  dictBrand?: InputMaybe<Scalars['String']>;
  manuCode?: InputMaybe<Scalars['String']>;
  spinsBrand?: InputMaybe<Scalars['String']>;
}

export interface CleansedData {
  _id: Scalars['ObjectId'];
  age: Array<CleansedDataPointString>;
  allergenInformation: Array<CleansedDataPointAllergenInformation>;
  assetStoragePath: Array<CleansedDataPointString>;
  brand: Array<CleansedDataPointString>;
  category: Array<CleansedDataPointString>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  description: Array<CleansedDataPointString>;
  discontinuedIdentifiers?: Maybe<CleansedDataDiscontinuedIdentifiers>;
  flavor: Array<CleansedDataPointString>;
  form: Array<CleansedDataPointString>;
  functionalIngredient: Array<CleansedDataPointString>;
  gender: Array<CleansedDataPointString>;
  gtin?: Maybe<Scalars['String']>;
  healthFocus: Array<CleansedDataPointString>;
  identifiers?: Maybe<CleansedDataIdentifiers>;
  ingestionEvents: Array<RawIngestionEvent>;
  ingredientStatement: Array<CleansedDataPointString>;
  isGtinValid?: Maybe<Scalars['Boolean']>;
  itemDescription: Array<CleansedDataPointString>;
  manufacturer: Array<CleansedDataPointString>;
  name: Array<CleansedDataPointString>;
  nutritionFacts: Array<CleansedDataPointNutritionFacts>;
  packCount: Array<CleansedDataPointString>;
  productType: Array<CleansedDataPointString>;
  scent: Array<CleansedDataPointString>;
  servingInformation: Array<CleansedDataPointServingInformation>;
  size: Array<CleansedDataPointString>;
  sourceSpecific: Array<CleansedDataPointSourceSpecific>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  sources: Array<Scalars['String']>;
  subcategory: Array<CleansedDataPointString>;
  supplementFacts: Array<CleansedDataPointSupplementFacts>;
  unitOfMeasure: Array<CleansedDataPointString>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface CleansedDataAllergenInformation {
  allergenTypeCode?: Maybe<Scalars['String']>;
  levelOfContainmentCode?: Maybe<Scalars['String']>;
}

export interface CleansedDataAllergenInformationInput {
  allergenTypeCode?: InputMaybe<Scalars['String']>;
  levelOfContainmentCode?: InputMaybe<Scalars['String']>;
}

export interface CleansedDataDiscontinuedIdentifiers {
  asins: Array<Scalars['String']>;
  rivirIds: Array<Scalars['String']>;
}

export interface CleansedDataDiscontinuedIdentifiersInput {
  asins?: InputMaybe<Array<Scalars['String']>>;
  rivirIds?: InputMaybe<Array<Scalars['String']>>;
}

export interface CleansedDataFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<CleansedData>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface CleansedDataIdentifiers {
  asins: Array<Scalars['String']>;
  rivirIds: Array<Scalars['String']>;
}

export interface CleansedDataIdentifiersInput {
  asins?: InputMaybe<Array<Scalars['String']>>;
  rivirIds?: InputMaybe<Array<Scalars['String']>>;
}

export interface CleansedDataInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  age?: InputMaybe<Array<CleansedDataPointStringInput>>;
  allergenInformation?: InputMaybe<Array<CleansedDataPointAllergenInformationInput>>;
  assetStoragePath?: InputMaybe<Array<CleansedDataPointStringInput>>;
  brand?: InputMaybe<Array<CleansedDataPointStringInput>>;
  category?: InputMaybe<Array<CleansedDataPointStringInput>>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Array<CleansedDataPointStringInput>>;
  discontinuedIdentifiers?: InputMaybe<CleansedDataDiscontinuedIdentifiersInput>;
  flavor?: InputMaybe<Array<CleansedDataPointStringInput>>;
  form?: InputMaybe<Array<CleansedDataPointStringInput>>;
  functionalIngredient?: InputMaybe<Array<CleansedDataPointStringInput>>;
  gender?: InputMaybe<Array<CleansedDataPointStringInput>>;
  gtin?: InputMaybe<Scalars['String']>;
  healthFocus?: InputMaybe<Array<CleansedDataPointStringInput>>;
  identifiers?: InputMaybe<CleansedDataIdentifiersInput>;
  /**
   * READONLY. The distinct "ingestionEvent" values across every data point on this
   * record. Denormalized so that "which records did ingestion event Y touch?" is a
   * single multikey index lookup rather than an $or across every data point field.
   *
   * Recomputed in the pre.validate middleware, and written directly by
   * CleansedDataMongoUpdateMapper.kt in the pi-engine-dataflow repo.
   */
  ingestionEvents?: InputMaybe<Array<Scalars['ObjectId']>>;
  ingredientStatement?: InputMaybe<Array<CleansedDataPointStringInput>>;
  isGtinValid?: InputMaybe<Scalars['Boolean']>;
  itemDescription?: InputMaybe<Array<CleansedDataPointStringInput>>;
  manufacturer?: InputMaybe<Array<CleansedDataPointStringInput>>;
  name?: InputMaybe<Array<CleansedDataPointStringInput>>;
  nutritionFacts?: InputMaybe<Array<CleansedDataPointNutritionFactsInput>>;
  packCount?: InputMaybe<Array<CleansedDataPointStringInput>>;
  productType?: InputMaybe<Array<CleansedDataPointStringInput>>;
  scent?: InputMaybe<Array<CleansedDataPointStringInput>>;
  servingInformation?: InputMaybe<Array<CleansedDataPointServingInformationInput>>;
  size?: InputMaybe<Array<CleansedDataPointStringInput>>;
  sourceSpecific?: InputMaybe<Array<CleansedDataPointSourceSpecificInput>>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  sources?: InputMaybe<Array<Scalars['String']>>;
  subcategory?: InputMaybe<Array<CleansedDataPointStringInput>>;
  supplementFacts?: InputMaybe<Array<CleansedDataPointSupplementFactsInput>>;
  unitOfMeasure?: InputMaybe<Array<CleansedDataPointStringInput>>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface CleansedDataNutritionFacts {
  dailyValue?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
}

export interface CleansedDataNutritionFactsInput {
  dailyValue?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  panel?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
}

export interface CleansedDataPointAllergenInformation {
  /** The ASIN attached to this data point, if one was included */
  asin?: Maybe<Scalars['String']>;
  /** The first raw ingestion event where this value changed or was introduced */
  ingestionEvent?: Maybe<RawIngestionEvent>;
  /** The Rivir ID attached to this data point, if one was included */
  rivirId?: Maybe<Scalars['String']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source: Scalars['String'];
  /** The task that provided this value, if it was written by tasker */
  task?: Maybe<Task>;
  value: Array<CleansedDataAllergenInformation>;
  /** The date when this value was changed or introduced */
  valueUpdatedDate: Scalars['DateTime'];
}

export interface CleansedDataPointAllergenInformationInput {
  /** The ASIN attached to this data point, if one was included */
  asin?: InputMaybe<Scalars['String']>;
  /** The first raw ingestion event where this value changed or was introduced */
  ingestionEvent?: InputMaybe<Scalars['ObjectId']>;
  /** The Rivir ID attached to this data point, if one was included */
  rivirId?: InputMaybe<Scalars['String']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source?: InputMaybe<Scalars['String']>;
  /** The task that provided this value, if it was written by tasker */
  task?: InputMaybe<Scalars['ObjectId']>;
  value?: InputMaybe<Array<CleansedDataAllergenInformationInput>>;
  /** The date when this value was changed or introduced */
  valueUpdatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface CleansedDataPointNutritionFacts {
  /** The ASIN attached to this data point, if one was included */
  asin?: Maybe<Scalars['String']>;
  /** The first raw ingestion event where this value changed or was introduced */
  ingestionEvent?: Maybe<RawIngestionEvent>;
  /** The Rivir ID attached to this data point, if one was included */
  rivirId?: Maybe<Scalars['String']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source: Scalars['String'];
  /** The task that provided this value, if it was written by tasker */
  task?: Maybe<Task>;
  value: Array<CleansedDataNutritionFacts>;
  /** The date when this value was changed or introduced */
  valueUpdatedDate: Scalars['DateTime'];
}

export interface CleansedDataPointNutritionFactsInput {
  /** The ASIN attached to this data point, if one was included */
  asin?: InputMaybe<Scalars['String']>;
  /** The first raw ingestion event where this value changed or was introduced */
  ingestionEvent?: InputMaybe<Scalars['ObjectId']>;
  /** The Rivir ID attached to this data point, if one was included */
  rivirId?: InputMaybe<Scalars['String']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source?: InputMaybe<Scalars['String']>;
  /** The task that provided this value, if it was written by tasker */
  task?: InputMaybe<Scalars['ObjectId']>;
  value?: InputMaybe<Array<CleansedDataNutritionFactsInput>>;
  /** The date when this value was changed or introduced */
  valueUpdatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface CleansedDataPointServingInformation {
  /** The ASIN attached to this data point, if one was included */
  asin?: Maybe<Scalars['String']>;
  /** The first raw ingestion event where this value changed or was introduced */
  ingestionEvent?: Maybe<RawIngestionEvent>;
  /** The Rivir ID attached to this data point, if one was included */
  rivirId?: Maybe<Scalars['String']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source: Scalars['String'];
  /** The task that provided this value, if it was written by tasker */
  task?: Maybe<Task>;
  value: Array<CleansedDataServingInformation>;
  /** The date when this value was changed or introduced */
  valueUpdatedDate: Scalars['DateTime'];
}

export interface CleansedDataPointServingInformationInput {
  /** The ASIN attached to this data point, if one was included */
  asin?: InputMaybe<Scalars['String']>;
  /** The first raw ingestion event where this value changed or was introduced */
  ingestionEvent?: InputMaybe<Scalars['ObjectId']>;
  /** The Rivir ID attached to this data point, if one was included */
  rivirId?: InputMaybe<Scalars['String']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source?: InputMaybe<Scalars['String']>;
  /** The task that provided this value, if it was written by tasker */
  task?: InputMaybe<Scalars['ObjectId']>;
  value?: InputMaybe<Array<CleansedDataServingInformationInput>>;
  /** The date when this value was changed or introduced */
  valueUpdatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface CleansedDataPointSourceSpecific {
  /** The ASIN attached to this data point, if one was included */
  asin?: Maybe<Scalars['String']>;
  /** The first raw ingestion event where this value changed or was introduced */
  ingestionEvent?: Maybe<RawIngestionEvent>;
  /** The Rivir ID attached to this data point, if one was included */
  rivirId?: Maybe<Scalars['String']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source: Scalars['String'];
  /** The task that provided this value, if it was written by tasker */
  task?: Maybe<Task>;
  value: Scalars['JSON'];
  /** The date when this value was changed or introduced */
  valueUpdatedDate: Scalars['DateTime'];
}

export interface CleansedDataPointSourceSpecificInput {
  /** The ASIN attached to this data point, if one was included */
  asin?: InputMaybe<Scalars['String']>;
  /** The first raw ingestion event where this value changed or was introduced */
  ingestionEvent?: InputMaybe<Scalars['ObjectId']>;
  /** The Rivir ID attached to this data point, if one was included */
  rivirId?: InputMaybe<Scalars['String']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source?: InputMaybe<Scalars['String']>;
  /** The task that provided this value, if it was written by tasker */
  task?: InputMaybe<Scalars['ObjectId']>;
  value?: InputMaybe<Scalars['JSON']>;
  /** The date when this value was changed or introduced */
  valueUpdatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface CleansedDataPointString {
  /** The ASIN attached to this data point, if one was included */
  asin?: Maybe<Scalars['String']>;
  /** The first raw ingestion event where this value changed or was introduced */
  ingestionEvent?: Maybe<RawIngestionEvent>;
  /** The Rivir ID attached to this data point, if one was included */
  rivirId?: Maybe<Scalars['String']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source: Scalars['String'];
  /** The task that provided this value, if it was written by tasker */
  task?: Maybe<Task>;
  value: Scalars['String'];
  /** The date when this value was changed or introduced */
  valueUpdatedDate: Scalars['DateTime'];
}

export interface CleansedDataPointStringInput {
  /** The ASIN attached to this data point, if one was included */
  asin?: InputMaybe<Scalars['String']>;
  /** The first raw ingestion event where this value changed or was introduced */
  ingestionEvent?: InputMaybe<Scalars['ObjectId']>;
  /** The Rivir ID attached to this data point, if one was included */
  rivirId?: InputMaybe<Scalars['String']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source?: InputMaybe<Scalars['String']>;
  /** The task that provided this value, if it was written by tasker */
  task?: InputMaybe<Scalars['ObjectId']>;
  value?: InputMaybe<Scalars['String']>;
  /** The date when this value was changed or introduced */
  valueUpdatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface CleansedDataPointSupplementFacts {
  /** The ASIN attached to this data point, if one was included */
  asin?: Maybe<Scalars['String']>;
  /** The first raw ingestion event where this value changed or was introduced */
  ingestionEvent?: Maybe<RawIngestionEvent>;
  /** The Rivir ID attached to this data point, if one was included */
  rivirId?: Maybe<Scalars['String']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source: Scalars['String'];
  /** The task that provided this value, if it was written by tasker */
  task?: Maybe<Task>;
  value: Array<CleansedDataSupplementFacts>;
  /** The date when this value was changed or introduced */
  valueUpdatedDate: Scalars['DateTime'];
}

export interface CleansedDataPointSupplementFactsInput {
  /** The ASIN attached to this data point, if one was included */
  asin?: InputMaybe<Scalars['String']>;
  /** The first raw ingestion event where this value changed or was introduced */
  ingestionEvent?: InputMaybe<Scalars['ObjectId']>;
  /** The Rivir ID attached to this data point, if one was included */
  rivirId?: InputMaybe<Scalars['String']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source?: InputMaybe<Scalars['String']>;
  /** The task that provided this value, if it was written by tasker */
  task?: InputMaybe<Scalars['ObjectId']>;
  value?: InputMaybe<Array<CleansedDataSupplementFactsInput>>;
  /** The date when this value was changed or introduced */
  valueUpdatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface CleansedDataServingInformation {
  calories?: Maybe<Scalars['Float']>;
  panel?: Maybe<Scalars['String']>;
  servingSize?: Maybe<Scalars['Float']>;
  servingSizeDescription?: Maybe<Scalars['String']>;
  servingSizeMeasurement?: Maybe<Scalars['String']>;
  servingsPerContainer?: Maybe<Scalars['Float']>;
}

export interface CleansedDataServingInformationInput {
  calories?: InputMaybe<Scalars['Float']>;
  panel?: InputMaybe<Scalars['String']>;
  servingSize?: InputMaybe<Scalars['Float']>;
  servingSizeDescription?: InputMaybe<Scalars['String']>;
  servingSizeMeasurement?: InputMaybe<Scalars['String']>;
  servingsPerContainer?: InputMaybe<Scalars['Float']>;
}

export interface CleansedDataSupplementFacts {
  calories?: Maybe<Scalars['Float']>;
  caloriesFromFat?: Maybe<Scalars['Float']>;
  footnotes?: Maybe<Scalars['String']>;
  nutrients: Array<CleansedDataSupplementFactsNutrients>;
  otherIngredients?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  servingSize?: Maybe<Scalars['String']>;
  servingsPerContainer?: Maybe<Scalars['Float']>;
}

export interface CleansedDataSupplementFactsInput {
  calories?: InputMaybe<Scalars['Float']>;
  caloriesFromFat?: InputMaybe<Scalars['Float']>;
  footnotes?: InputMaybe<Scalars['String']>;
  nutrients?: InputMaybe<Array<CleansedDataSupplementFactsNutrientsInput>>;
  otherIngredients?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  servingSize?: InputMaybe<Scalars['String']>;
  servingsPerContainer?: InputMaybe<Scalars['Float']>;
}

export interface CleansedDataSupplementFactsNutrients {
  dailySymbol?: Maybe<Scalars['String']>;
  dailyValue?: Maybe<Scalars['Float']>;
  descriptor?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
}

export interface CleansedDataSupplementFactsNutrientsInput {
  dailySymbol?: InputMaybe<Scalars['String']>;
  dailyValue?: InputMaybe<Scalars['Float']>;
  descriptor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
}

export interface ClientFeedbackAttributeTrendRow {
  attributeName: Scalars['String'];
  avgWeeklyTickets52: Scalars['Float'];
  expectedTickets4: Scalars['Float'];
  expectedTickets12: Scalars['Float'];
  expectedTickets24: Scalars['Float'];
  ticketsLast4: Scalars['Int'];
  ticketsLast12: Scalars['Int'];
  ticketsLast24: Scalars['Int'];
  ticketsLast52: Scalars['Int'];
}

export interface ClientFeedbackAttributeTrends {
  rows: Array<ClientFeedbackAttributeTrendRow>;
  total?: Maybe<ClientFeedbackAttributeTrendRow>;
}

export interface ClientFeedbackAttributeUpdateRow {
  attributeName: Scalars['String'];
  attributeValue?: Maybe<Scalars['String']>;
  ticketCount: Scalars['Int'];
  upcCount: Scalars['Int'];
}

export interface ClientFeedbackAttributeUpdates {
  rows: Array<ClientFeedbackAttributeUpdateRow>;
  totalTicketCount: Scalars['Int'];
  totalUpcCount: Scalars['Int'];
}

export interface ClientFeedbackCategoryUpdateRow {
  category: Scalars['String'];
  subcategory?: Maybe<Scalars['String']>;
  ticketCount: Scalars['Int'];
  upcCount: Scalars['Int'];
}

export interface ClientFeedbackCategoryUpdates {
  rows: Array<ClientFeedbackCategoryUpdateRow>;
  totalTicketCount: Scalars['Int'];
  totalUpcCount: Scalars['Int'];
}

export interface ClientFeedbackFilter {
  attributeName?: InputMaybe<Array<Scalars['String']>>;
  attributeValue?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Array<Scalars['String']>>;
  clientName?: InputMaybe<Array<Scalars['String']>>;
  clientValidatedCoding?: InputMaybe<Scalars['Boolean']>;
  components?: InputMaybe<Array<Scalars['String']>>;
  createdFrom?: InputMaybe<Scalars['String']>;
  createdTo?: InputMaybe<Scalars['String']>;
  periodRelease?: InputMaybe<Array<Scalars['String']>>;
  rootCauses?: InputMaybe<Array<Scalars['String']>>;
  subcategory?: InputMaybe<Array<Scalars['String']>>;
}

export interface ClientFeedbackProductUpdateRow {
  attributeName: Scalars['String'];
  attributeValue?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  periodRelease?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  upc: Scalars['String'];
}

export interface ClientFeedbackProductUpdates {
  rows: Array<ClientFeedbackProductUpdateRow>;
  totalRowCount: Scalars['Int'];
}

export interface ClientFeedbackRootCauseRow {
  rootCause: Scalars['String'];
  ticketCount: Scalars['Int'];
}

export interface ClientFeedbackTicketExtract {
  rows: Array<ClientFeedbackTicketExtractRow>;
  totalRowCount: Scalars['Int'];
}

export interface ClientFeedbackTicketExtractRow {
  assignee?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  issueKey: Scalars['String'];
  reporter?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  upcCount: Scalars['Int'];
}

export interface ClientFeedbackTicketTrendRow {
  avgWeeklyTickets52: Scalars['Float'];
  clientName: Scalars['String'];
  component?: Maybe<Scalars['String']>;
  expectedTickets4: Scalars['Float'];
  expectedTickets12: Scalars['Float'];
  expectedTickets24: Scalars['Float'];
  ticketsLast4: Scalars['Int'];
  ticketsLast12: Scalars['Int'];
  ticketsLast24: Scalars['Int'];
  ticketsLast52: Scalars['Int'];
}

export interface ClientFeedbackWhoIsSubmittingRow {
  clientName: Scalars['String'];
  percentTotalTickets: Scalars['Float'];
  ticketCount: Scalars['Int'];
  upcCount: Scalars['Int'];
}

export interface ClientTrackerIncorrectAttributeNamePage {
  nodes: Array<ClientTrackerIncorrectAttributeNameRow>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface ClientTrackerIncorrectAttributeNameRow {
  _id: Scalars['String'];
  attributeName: Scalars['String'];
  clientValidatedCoding?: Maybe<Scalars['Boolean']>;
  jiraAssignee?: Maybe<Scalars['String']>;
  jiraClientName?: Maybe<Scalars['String']>;
  jiraTicket: Array<Scalars['String']>;
  periodRelease?: Maybe<Scalars['String']>;
  spinsUpc: Scalars['String'];
}

export interface ClientTrackerMismatchAttribute {
  _id: Scalars['String'];
  attributeInSpinsAttributes: Scalars['Boolean'];
  attributeName: Scalars['String'];
  clientTrackerValue?: Maybe<Scalars['String']>;
  mismatchType: Scalars['String'];
  spinsAttributeValue?: Maybe<Scalars['String']>;
}

export interface ClientTrackerMismatchesPage {
  nodes: Array<ClientTrackerMismatchesRow>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface ClientTrackerMismatchesRow {
  clientValidatedCoding?: Maybe<Scalars['Boolean']>;
  jiraAssignee?: Maybe<Scalars['String']>;
  jiraClientName?: Maybe<Scalars['String']>;
  jiraTicket: Array<Scalars['String']>;
  mismatchedAttributes: Array<ClientTrackerMismatchAttribute>;
  periodRelease?: Maybe<Scalars['String']>;
  spinsUpc: Scalars['String'];
}

export interface ClientTrackerValue {
  _id: Scalars['ObjectId'];
  attributeName: Scalars['String'];
  attributeValue: Scalars['String'];
  clientValidatedCoding: Scalars['Boolean'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  jiraAssignee?: Maybe<Scalars['String']>;
  jiraClientName?: Maybe<Scalars['String']>;
  jiraTicket: Array<Scalars['String']>;
  periodRelease?: Maybe<Scalars['String']>;
  spinsUpc: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface ClientTrackerValueFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<ClientTrackerValue>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface ClientTrackerValueInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  attributeName?: InputMaybe<Scalars['String']>;
  attributeValue?: InputMaybe<Scalars['String']>;
  clientValidatedCoding?: InputMaybe<Scalars['Boolean']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  jiraAssignee?: InputMaybe<Scalars['String']>;
  jiraClientName?: InputMaybe<Scalars['String']>;
  jiraTicket?: InputMaybe<Array<Scalars['String']>>;
  periodRelease?: InputMaybe<Scalars['String']>;
  spinsUpc?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface ClientTrackerValueUpsertInput {
  attributeName: Scalars['String'];
  attributeValue: Scalars['String'];
  clientValidatedCoding: Scalars['Boolean'];
  jiraAssignee?: InputMaybe<Scalars['String']>;
  jiraClientName?: InputMaybe<Scalars['String']>;
  jiraTicket?: InputMaybe<Array<Scalars['String']>>;
  periodRelease?: InputMaybe<Scalars['String']>;
  spinsUpc: Scalars['String'];
}

export interface ClientTrackerValueUpsertResponse {
  errors: Array<ClientTrackerValueValidationError>;
  success: Scalars['Boolean'];
}

export interface ClientTrackerValueValidationError {
  message: Scalars['String'];
  path: Scalars['String'];
}

export interface Company {
  _id: Scalars['ObjectId'];
  ancestorCompanies: Array<Company>;
  city?: Maybe<Scalars['String']>;
  contentSupplierSource?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  depth: Scalars['Float'];
  descendentCompanies: Array<Company>;
  digitalAssetManagementSystem?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailVerified: Scalars['Boolean'];
  globalLocationNumber?: Maybe<Scalars['String']>;
  logo?: Maybe<CompanyLogo>;
  /** For companies of type "brand", auto populates with the closest ancestor of type "manufacturer" */
  manufacturer?: Maybe<Company>;
  name: Scalars['String'];
  nameAliases: Array<Scalars['String']>;
  numProducts?: Maybe<Scalars['Int']>;
  parentCompany?: Maybe<Company>;
  phone?: Maybe<Scalars['String']>;
  primaryContact?: Maybe<CompanyPrimaryContact>;
  slug: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  /** The task that updated the company. */
  task?: Maybe<Task>;
  type: CompanyTypeEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  website?: Maybe<Scalars['String']>;
}

export interface CompanyFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Company>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface CompanyInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  ancestorCompanies?: InputMaybe<Array<Scalars['ObjectId']>>;
  city?: InputMaybe<Scalars['String']>;
  contentSupplierSource?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  depth?: InputMaybe<Scalars['Float']>;
  descendentCompanies?: InputMaybe<Array<Scalars['ObjectId']>>;
  digitalAssetManagementSystem?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailVerified?: InputMaybe<Scalars['Boolean']>;
  globalLocationNumber?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<CompanyLogoInput>;
  /** For companies of type "brand", auto populates with the closest ancestor of type "manufacturer" */
  manufacturer?: InputMaybe<Scalars['ObjectId']>;
  name?: InputMaybe<Scalars['String']>;
  nameAliases?: InputMaybe<Array<Scalars['String']>>;
  parentCompany?: InputMaybe<Scalars['ObjectId']>;
  phone?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<CompanyPrimaryContactInput>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  /** The task that updated the company. */
  task?: InputMaybe<Scalars['ObjectId']>;
  type?: InputMaybe<CompanyTypeEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  website?: InputMaybe<Scalars['String']>;
}

export interface CompanyLogo {
  large: Scalars['String'];
  small: Scalars['String'];
}

export interface CompanyLogoInput {
  large?: InputMaybe<Scalars['String']>;
  small?: InputMaybe<Scalars['String']>;
}

export interface CompanyPrimaryContact {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
}

export interface CompanyPrimaryContactInput {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
}

/** Stores the data for company requests */
export interface CompanySignupRequest {
  _id: Scalars['ObjectId'];
  adultBeverage?: Maybe<Scalars['Boolean']>;
  companyAddress: Scalars['String'];
  companyAddress2?: Maybe<Scalars['String']>;
  companyCity: Scalars['String'];
  companyState?: Maybe<Scalars['String']>;
  companyType: CompanySignupRequestCompanyTypeEnum;
  companyZipCode?: Maybe<Scalars['String']>;
  contractPending?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Domain>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  legalCompanyName: Scalars['String'];
  listAllOwnedBrands?: Maybe<Scalars['String']>;
  managerAdminInformation?: Maybe<CompanySignupRequestManagerAdminInformation>;
  numSkusToManage?: Maybe<Scalars['Float']>;
  partnerName?: Maybe<Scalars['String']>;
  planPromoCode?: Maybe<Scalars['String']>;
  planType?: Maybe<CompanySignupRequestPlanTypeEnum>;
  readyForSetup?: Maybe<Scalars['Boolean']>;
  retailerReferral?: Maybe<Scalars['String']>;
  skuCount?: Maybe<CompanySignupRequestSkuCountEnum>;
  sponsored?: Maybe<Scalars['Boolean']>;
  status: CompanySignupRequestStatusEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  userCompany?: Maybe<Scalars['String']>;
  userPhone?: Maybe<Scalars['String']>;
  userTitle?: Maybe<Scalars['String']>;
}

export enum CompanySignupRequestCompanyTypeEnum {
  Agency = 'agency',
  Broker = 'broker',
  Distributor = 'distributor',
  ManufacturerOrBrand = 'manufacturer_or_brand',
  MarketingOrSales = 'marketing_or_sales',
  Other = 'other',
  Retailer = 'retailer',
  ServiceProviderOrAppDeveloper = 'service_provider_or_app_developer'
}

export interface CompanySignupRequestFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<CompanySignupRequest>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Stores the data for company requests */
export interface CompanySignupRequestInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  adultBeverage?: InputMaybe<Scalars['Boolean']>;
  companyAddress?: InputMaybe<Scalars['String']>;
  companyAddress2?: InputMaybe<Scalars['String']>;
  companyCity?: InputMaybe<Scalars['String']>;
  companyState?: InputMaybe<Scalars['String']>;
  companyType?: InputMaybe<CompanySignupRequestCompanyTypeEnum>;
  companyZipCode?: InputMaybe<Scalars['String']>;
  contractPending?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  domain?: InputMaybe<Scalars['ObjectId']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  legalCompanyName?: InputMaybe<Scalars['String']>;
  listAllOwnedBrands?: InputMaybe<Scalars['String']>;
  managerAdminInformation?: InputMaybe<CompanySignupRequestManagerAdminInformationInput>;
  numSkusToManage?: InputMaybe<Scalars['Float']>;
  partnerName?: InputMaybe<Scalars['String']>;
  planPromoCode?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<CompanySignupRequestPlanTypeEnum>;
  readyForSetup?: InputMaybe<Scalars['Boolean']>;
  retailerReferral?: InputMaybe<Scalars['String']>;
  skuCount?: InputMaybe<CompanySignupRequestSkuCountEnum>;
  sponsored?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<CompanySignupRequestStatusEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  userCompany?: InputMaybe<Scalars['String']>;
  userPhone?: InputMaybe<Scalars['String']>;
  userTitle?: InputMaybe<Scalars['String']>;
}

export interface CompanySignupRequestManagerAdminInformation {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface CompanySignupRequestManagerAdminInformationInput {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
}

export enum CompanySignupRequestPlanTypeEnum {
  Basic = 'basic',
  ComplianceBasic = 'complianceBasic',
  Enterprise = 'enterprise',
  Pro = 'pro'
}

export enum CompanySignupRequestSkuCountEnum {
  Max20 = 'max20',
  Min20max100 = 'min20max100',
  Min100 = 'min100'
}

export enum CompanySignupRequestStatusEnum {
  Done = 'done',
  Waiting = 'waiting'
}

export enum CompanyTypeEnum {
  Brand = 'brand',
  Broker = 'broker',
  Distributor = 'distributor',
  Manufacturer = 'manufacturer',
  Other = 'other',
  Provider = 'provider',
  Retailer = 'retailer'
}

/**
 * A Config is a one off configuration object that is needed by one or more applications, but that is not needed to have its own collection.
 *
 * It encodes the unique key of the application and an arbitrary JSON value
 *
 * It's meant to be a permanent way of storing one-offs (more robust than redis),
 *  but less restrictive and easily accessible/query-able (than e.g. aws.SecretsManager).
 *
 * Example applications:
 *  - store which are the current active digitization stores
 *  - whitelist/blacklist queries for each partner for digitization
 */
export interface Config {
  _id: Scalars['ObjectId'];
  _value: Scalars['String'];
  _valueJsonSchema?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  /** @virtual */
  validator?: Maybe<Scalars['JSON']>;
  /** @virtual */
  value: Scalars['JSON'];
  /** @virtual */
  valueJsonSchema?: Maybe<Scalars['JSON']>;
  version: Scalars['Float'];
}

export interface ConfigFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Config>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/**
 * A Config is a one off configuration object that is needed by one or more applications, but that is not needed to have its own collection.
 *
 * It encodes the unique key of the application and an arbitrary JSON value
 *
 * It's meant to be a permanent way of storing one-offs (more robust than redis),
 *  but less restrictive and easily accessible/query-able (than e.g. aws.SecretsManager).
 *
 * Example applications:
 *  - store which are the current active digitization stores
 *  - whitelist/blacklist queries for each partner for digitization
 */
export interface ConfigInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  _value?: InputMaybe<Scalars['String']>;
  _valueJsonSchema?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  /** @virtual */
  validator?: InputMaybe<Scalars['JSON']>;
  /** @virtual */
  value?: InputMaybe<Scalars['JSON']>;
  /** @virtual */
  valueJsonSchema?: InputMaybe<Scalars['JSON']>;
  version?: InputMaybe<Scalars['Float']>;
}

export interface CostBySource {
  cost: Scalars['Float'];
  month: Scalars['String'];
  service: Scalars['String'];
}

export interface CostBySourceDaily {
  cost: Scalars['Float'];
  date: Scalars['String'];
  service: Scalars['String'];
}

export interface CreateSftpCredentialsResult {
  domain: Domain;
  secretPassword?: Maybe<Scalars['String']>;
  secretUrl?: Maybe<Scalars['String']>;
}

export type DataRequirement = DataRequirementModel | DataRequirementModelId | DataRequirementPrimitive;

export interface DataRequirementInterface {
  /** Make this a list of entries */
  isArray?: Maybe<Scalars['Boolean']>;
  kind: DataRequirementKindEnum;
  /** Variable name */
  name?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
}

export enum DataRequirementKindEnum {
  Model = 'model',
  ModelId = 'modelId',
  Primitive = 'primitive'
}

export interface DataRequirementModel extends DataRequirementInterface {
  /** Make this a list of entries */
  isArray?: Maybe<Scalars['Boolean']>;
  kind: DataRequirementKindEnum;
  /** Variable name */
  name?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
  populateFields: Array<Scalars['String']>;
  selectFields: Array<Scalars['String']>;
  targetModel: ModelNameEnum;
}

export interface DataRequirementModelId extends DataRequirementInterface {
  /** Make this a list of entries */
  isArray?: Maybe<Scalars['Boolean']>;
  kind: DataRequirementKindEnum;
  /** Variable name */
  name?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
  targetModel: ModelNameEnum;
}

export interface DataRequirementModelIdInput {
  targetModel?: InputMaybe<ModelNameEnum>;
}

export interface DataRequirementModelInput {
  populateFields?: InputMaybe<Array<Scalars['String']>>;
  selectFields?: InputMaybe<Array<Scalars['String']>>;
  targetModel?: InputMaybe<ModelNameEnum>;
}

export interface DataRequirementPrimitive extends DataRequirementInterface {
  /** Make this a list of entries */
  isArray?: Maybe<Scalars['Boolean']>;
  kind: DataRequirementKindEnum;
  /** Variable name */
  name?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
  primitiveType?: Maybe<DataRequirementPrimitivePrimitiveTypeEnum>;
}

export interface DataRequirementPrimitiveInput {
  primitiveType?: InputMaybe<DataRequirementPrimitivePrimitiveTypeEnum>;
}

export enum DataRequirementPrimitivePrimitiveTypeEnum {
  Boolean = 'boolean',
  Number = 'number',
  Object = 'object',
  String = 'string'
}

/**
 * Handles dates and date ranges
 *
 * **Pv2_search type:**
 *
 * ```
 * {
 *     type: 'field';
 *     id: string;
 *     operation: 'gt' | 'gte' | 'lt' | 'lte' | 'eq';
 *     value: string; // ISO format
 * }
 * ```
 */
export interface DateSearchField extends ISearchField {
  /** Optional section in which this option should be places */
  group?: Maybe<Scalars['String']>;
  /** Unique identifier of a specific operation. It is the main value used for searching */
  id: Scalars['String'];
  /** Human-friendly label */
  label: Scalars['String'];
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: Pv2SearchFieldType;
}

export interface DeleteHistory {
  _id: Scalars['ObjectId'];
  date: Scalars['DateTime'];
  modelID: Scalars['String'];
  modelName: Scalars['String'];
  payload: Scalars['JSON'];
  user?: Maybe<User>;
}

export interface DeleteHistoryFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<DeleteHistory>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface DeleteHistoryInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  date?: InputMaybe<Scalars['DateTime']>;
  modelID?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

export interface DigitizationDomain {
  digitizationMode: DomainDigitizationModeEnum;
  id: Scalars['ObjectId'];
  identifierName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  stores: Array<DigitizationStore>;
}

export interface DigitizationGrantUserAccessResult {
  success: Scalars['Boolean'];
}

export interface DigitizationProductsResult {
  blacklistGtins: Array<Scalars['String']>;
  captureList: Array<Scalars['JSON']>;
  captureListSize: Scalars['Int'];
  cartGtins: Array<Scalars['String']>;
  date: Scalars['String'];
  isDiff: Scalars['Boolean'];
  verificationList: Array<Scalars['JSON']>;
  verificationListSize: Scalars['Int'];
}

export interface DigitizationPv2VerificationResult {
  barcode: Scalars['String'];
  brand: Scalars['String'];
  images: Array<Scalars['String']>;
  name: Scalars['String'];
  netContentTotal: Scalars['String'];
}

export interface DigitizationStore {
  city?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
}

export interface DigitizationUpcScan {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  domain?: Maybe<Domain>;
  originalUpc?: Maybe<Scalars['String']>;
  store?: Maybe<Scalars['String']>;
  upc: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
}

export interface DigitizationUpcScanFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<DigitizationUpcScan>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface DigitizationUpcScanInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  domain?: InputMaybe<Scalars['ObjectId']>;
  originalUpc?: InputMaybe<Scalars['String']>;
  store?: InputMaybe<Scalars['String']>;
  upc?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

export interface DigitizationUpcScanResult {
  failed: Scalars['Int'];
  success: Scalars['Int'];
}

export interface DigitizationUpdate {
  _id: Scalars['ObjectId'];
  date: Scalars['DateTime'];
  domain?: Maybe<Domain>;
  errorMessage?: Maybe<Scalars['String']>;
  failed: Scalars['Boolean'];
  images: Array<Image>;
  payload: Scalars['JSON'];
  pv2Id?: Maybe<Pv2>;
  store?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  uid: Scalars['String'];
  upc: Scalars['String'];
  user?: Maybe<User>;
}

export interface DigitizationUpdateFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<DigitizationUpdate>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface DigitizationUpdateInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  date?: InputMaybe<Scalars['DateTime']>;
  domain?: InputMaybe<Scalars['ObjectId']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  failed?: InputMaybe<Scalars['Boolean']>;
  images?: InputMaybe<Array<Scalars['ObjectId']>>;
  payload?: InputMaybe<Scalars['JSON']>;
  pv2Id?: InputMaybe<Scalars['ObjectId']>;
  store?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  upc?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

export interface DigitizationUploadImagesFinalizeResult {
  success: Scalars['Boolean'];
}

export interface DigitizationUploadImagesItemInput {
  filename: Scalars['String'];
  imageType: ImageTypeEnum;
  side: Scalars['String'];
}

export interface DigitizationUploadImagesResult {
  domainId: Scalars['String'];
  images: Array<DigitizationUploadImagesResultItem>;
  pv2Id?: Maybe<Scalars['String']>;
  s3Prefix: Scalars['String'];
  submissionId: Scalars['String'];
  upc: Scalars['String'];
  upcErrorMessage?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
}

export interface DigitizationUploadImagesResultItem {
  filename: Scalars['String'];
  imageIndex: Scalars['Int'];
  imageType: ImageTypeEnum;
  s3Key: Scalars['String'];
  side: Scalars['String'];
  uploadUrl: Scalars['String'];
}

export interface DigitizationUploadUpcScansInput {
  date: Scalars['DateTimeInput'];
  originalUpc?: InputMaybe<Scalars['String']>;
  upc: Scalars['String'];
}

export interface DigitizationUploadUpdatesResult {
  error?: Maybe<Scalars['String']>;
  failed?: Maybe<Scalars['String']>;
  processed: Array<Scalars['String']>;
  success: Scalars['Boolean'];
}

export interface DigitizationUserStatus {
  _id: Scalars['ObjectId'];
  app?: Maybe<DigitizationUserStatusApp>;
  appState: Scalars['JSON'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  device?: Maybe<DigitizationUserStatusDevice>;
  force?: Maybe<Scalars['Boolean']>;
  photos: Scalars['JSON'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
}

export interface DigitizationUserStatusApp {
  build: Scalars['Float'];
  version: Scalars['String'];
}

export interface DigitizationUserStatusAppInput {
  build?: InputMaybe<Scalars['Float']>;
  version?: InputMaybe<Scalars['String']>;
}

export interface DigitizationUserStatusDevice {
  OS?: Maybe<Scalars['String']>;
  OSVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
}

export interface DigitizationUserStatusDeviceInput {
  OS?: InputMaybe<Scalars['String']>;
  OSVersion?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
}

export interface DigitizationUserStatusFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<DigitizationUserStatus>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface DigitizationUserStatusInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  app?: InputMaybe<DigitizationUserStatusAppInput>;
  appState?: InputMaybe<Scalars['JSON']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  device?: InputMaybe<DigitizationUserStatusDeviceInput>;
  force?: InputMaybe<Scalars['Boolean']>;
  photos?: InputMaybe<Scalars['JSON']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

export interface Domain {
  _id: Scalars['ObjectId'];
  acceptedTOS?: Maybe<DomainAcceptedTos>;
  accountOwner?: Maybe<DomainAccountOwner>;
  billingAddress?: Maybe<DomainBillingAddress>;
  companies: Array<DomainCompany>;
  companySignupRequest?: Maybe<Scalars['ObjectId']>;
  companyType?: Maybe<DomainCompanyTypeEnum>;
  contract?: Maybe<DomainContract>;
  contractPending?: Maybe<Scalars['Boolean']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  dataAccess: DomainDataAccess;
  digitizationMode: DomainDigitizationModeEnum;
  documents: Array<DomainDocuments>;
  estimatedSkuCount?: Maybe<DomainEstimatedSkuCountEnum>;
  hasDigitizationAccess: Scalars['Boolean'];
  hasManagerAccess: Scalars['Boolean'];
  /**
   * Human-readable description for partner identifiers associated with domain for use
   * in the UI (e.g. "TCIN" for Target or "ASIN" for Amazon)
   */
  identifierName?: Maybe<Scalars['String']>;
  /** Identifier prefix for use in generation of Pv2.identifiers.hash field */
  identifierPrefix?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  listAllOwnedBrands?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<DomainMailingAddress>;
  manufactureOrDistributeAlcoholInWF?: Maybe<Scalars['Boolean']>;
  /**
   * Domain membership level
   * - basic: No write access
   * - pro: Write access
   * - enterprise: Write access
   */
  membership: DomainMembershipEnum;
  name: Scalars['String'];
  nucleusRetailerId?: Maybe<Scalars['Float']>;
  numSkusToManage?: Maybe<Scalars['Float']>;
  partnerName?: Maybe<Scalars['String']>;
  planPromoCode?: Maybe<Scalars['String']>;
  primaryContact?: Maybe<DomainPrimaryContact>;
  productExclusivityMode: DomainProductExclusivityModeEnum;
  pv2CustomFieldPrimary?: Maybe<Pv2CustomFieldConfig>;
  pv2CustomFields: Array<Pv2CustomFieldConfig>;
  readyForSetup?: Maybe<Scalars['Boolean']>;
  referredByRetailer?: Maybe<Scalars['String']>;
  sftp?: Maybe<DomainSftp>;
  skusLockDown?: Maybe<SkusInfo>;
  sponsored?: Maybe<Scalars['Boolean']>;
  taxonomies: Array<DomainTaxonomy>;
  trialExpirationDate?: Maybe<Scalars['DateTime']>;
  type: DomainTypeEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  users: Array<DomainUser>;
}

export interface DomainAcceptedTos {
  date: Scalars['DateTime'];
  user?: Maybe<User>;
}

export interface DomainAcceptedTosInput {
  date?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

export interface DomainAccountOwner {
  email: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface DomainAccountOwnerInput {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
}

export interface DomainBillingAddress {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
}

export interface DomainBillingAddressInput {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
}

export interface DomainCompany {
  access?: Maybe<DomainCompanyAccessEnum>;
  company?: Maybe<Company>;
  profileAccess?: Maybe<DomainCompanyProfileAccessEnum>;
}

export enum DomainCompanyAccessEnum {
  Edit = 'edit',
  View = 'view'
}

export interface DomainCompanyInput {
  access?: InputMaybe<DomainCompanyAccessEnum>;
  company?: InputMaybe<Scalars['ObjectId']>;
  profileAccess?: InputMaybe<DomainCompanyProfileAccessEnum>;
}

export enum DomainCompanyProfileAccessEnum {
  Edit = 'edit',
  View = 'view'
}

export enum DomainCompanyTypeEnum {
  Agency = 'agency',
  Broker = 'broker',
  Distributor = 'distributor',
  ManufacturerOrBrand = 'manufacturer_or_brand',
  MarketingOrSales = 'marketing_or_sales',
  Other = 'other',
  Retailer = 'retailer',
  ServiceProviderOrAppDeveloper = 'service_provider_or_app_developer'
}

export interface DomainContract {
  additionalSkuFeePerYear?: Maybe<Scalars['Float']>;
  autoRenewal?: Maybe<Scalars['Boolean']>;
  contractedSkus?: Maybe<Scalars['Float']>;
  feePerYear?: Maybe<Scalars['Float']>;
  lengthInDays?: Maybe<Scalars['Float']>;
  renewalNotificationPeriodInDays: Scalars['Float'];
  startDate: Scalars['DateTime'];
  trialExpirationDate?: Maybe<Scalars['DateTime']>;
}

export interface DomainContractInput {
  additionalSkuFeePerYear?: InputMaybe<Scalars['Float']>;
  autoRenewal?: InputMaybe<Scalars['Boolean']>;
  contractedSkus?: InputMaybe<Scalars['Float']>;
  feePerYear?: InputMaybe<Scalars['Float']>;
  lengthInDays?: InputMaybe<Scalars['Float']>;
  renewalNotificationPeriodInDays?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  trialExpirationDate?: InputMaybe<Scalars['DateTime']>;
}

export interface DomainDataAccess {
  dataAndImages: Scalars['Boolean'];
  dataOnly: Scalars['Boolean'];
}

export interface DomainDataAccessInput {
  dataAndImages?: InputMaybe<Scalars['Boolean']>;
  dataOnly?: InputMaybe<Scalars['Boolean']>;
}

export enum DomainDigitizationModeEnum {
  Blacklist = 'blacklist',
  Whitelist = 'whitelist'
}

export interface DomainDocuments {
  _id: Scalars['ObjectId'];
  fileName: Scalars['String'];
  fileSizeMb: Scalars['Float'];
  name: Scalars['String'];
  s3Key: Scalars['String'];
  uploadedBy?: Maybe<User>;
  uploadedDate: Scalars['DateTime'];
}

export interface DomainDocumentsInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileSizeMb?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
  uploadedBy?: InputMaybe<Scalars['ObjectId']>;
  uploadedDate?: InputMaybe<Scalars['DateTime']>;
}

export enum DomainEstimatedSkuCountEnum {
  Max20 = 'max20',
  Min20max100 = 'min20max100',
  Min100 = 'min100'
}

export interface DomainFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Domain>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface DomainInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  acceptedTOS?: InputMaybe<DomainAcceptedTosInput>;
  accountOwner?: InputMaybe<DomainAccountOwnerInput>;
  billingAddress?: InputMaybe<DomainBillingAddressInput>;
  companies?: InputMaybe<Array<DomainCompanyInput>>;
  companySignupRequest?: InputMaybe<Scalars['ObjectId']>;
  companyType?: InputMaybe<DomainCompanyTypeEnum>;
  contract?: InputMaybe<DomainContractInput>;
  contractPending?: InputMaybe<Scalars['Boolean']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  dataAccess?: InputMaybe<DomainDataAccessInput>;
  digitizationMode?: InputMaybe<DomainDigitizationModeEnum>;
  documents?: InputMaybe<Array<DomainDocumentsInput>>;
  estimatedSkuCount?: InputMaybe<DomainEstimatedSkuCountEnum>;
  hasDigitizationAccess?: InputMaybe<Scalars['Boolean']>;
  hasManagerAccess?: InputMaybe<Scalars['Boolean']>;
  /**
   * Human-readable description for partner identifiers associated with domain for use
   * in the UI (e.g. "TCIN" for Target or "ASIN" for Amazon)
   */
  identifierName?: InputMaybe<Scalars['String']>;
  /** Identifier prefix for use in generation of Pv2.identifiers.hash field */
  identifierPrefix?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  listAllOwnedBrands?: InputMaybe<Scalars['String']>;
  mailingAddress?: InputMaybe<DomainMailingAddressInput>;
  manufactureOrDistributeAlcoholInWF?: InputMaybe<Scalars['Boolean']>;
  /**
   * Domain membership level
   * - basic: No write access
   * - pro: Write access
   * - enterprise: Write access
   */
  membership?: InputMaybe<DomainMembershipEnum>;
  name?: InputMaybe<Scalars['String']>;
  nucleusRetailerId?: InputMaybe<Scalars['Float']>;
  numSkusToManage?: InputMaybe<Scalars['Float']>;
  partnerName?: InputMaybe<Scalars['String']>;
  planPromoCode?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<DomainPrimaryContactInput>;
  productExclusivityMode?: InputMaybe<DomainProductExclusivityModeEnum>;
  pv2CustomFieldPrimary?: InputMaybe<Scalars['ObjectId']>;
  pv2CustomFields?: InputMaybe<Array<Scalars['ObjectId']>>;
  readyForSetup?: InputMaybe<Scalars['Boolean']>;
  referredByRetailer?: InputMaybe<Scalars['String']>;
  sftp?: InputMaybe<DomainSftpInput>;
  sponsored?: InputMaybe<Scalars['Boolean']>;
  taxonomies?: InputMaybe<Array<DomainTaxonomyInput>>;
  type?: InputMaybe<DomainTypeEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<Array<DomainUserInput>>;
}

export interface DomainMailingAddress {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
}

export interface DomainMailingAddressInput {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
}

export enum DomainMembershipEnum {
  Basic = 'basic',
  ComplianceBasic = 'complianceBasic',
  Enterprise = 'enterprise',
  Pro = 'pro'
}

export interface DomainPrimaryContact {
  email: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface DomainPrimaryContactInput {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
}

export enum DomainProductExclusivityModeEnum {
  Global = 'global',
  Retailer = 'retailer'
}

export interface DomainSftp {
  createdDate?: Maybe<Scalars['DateTime']>;
  s3Path: Scalars['String'];
  username: Scalars['String'];
}

export interface DomainSftpInput {
  createdDate?: InputMaybe<Scalars['DateTime']>;
  s3Path?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
}

export interface DomainTaxonomy {
  taxonomy?: Maybe<Taxonomy>;
}

export interface DomainTaxonomyInput {
  taxonomy?: InputMaybe<Scalars['ObjectId']>;
}

export enum DomainTypeEnum {
  Brand = 'brand',
  Broker = 'broker',
  Distributor = 'distributor',
  ManufacturerOrBrand = 'manufacturer_or_brand',
  MarketingOrSalesAgency = 'marketing_or_sales_agency',
  Other = 'other',
  Retailer = 'retailer',
  ServiceProviderOrAppDeveloper = 'service_provider_or_app_developer',
  ThirdParty = 'third_party'
}

export interface DomainUser {
  /**
   * Manual user abilities applied to users by a super admin (or potentially a domain admin)
   *
   * For all computed user abilities see the getUserAbilities() utility
   */
  abilities: Array<DomainUserAbilitiesEnum>;
  acceptedDate?: Maybe<Scalars['DateTime']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  inviteMessage?: Maybe<Scalars['String']>;
  invitedBy?: Maybe<User>;
  /**
   * User access level
   * - user: can only read data
   * - manager: can read and write products
   * - admin: can manage the domain and all its products
   */
  role: DomainUserRoleEnum;
  user?: Maybe<User>;
}

export enum DomainUserAbilitiesEnum {
  UseBatchApi = 'use_batch_api',
  UseDigitizationApp = 'use_digitization_app'
}

export interface DomainUserInput {
  /**
   * Manual user abilities applied to users by a super admin (or potentially a domain admin)
   *
   * For all computed user abilities see the getUserAbilities() utility
   */
  abilities?: InputMaybe<Array<DomainUserAbilitiesEnum>>;
  acceptedDate?: InputMaybe<Scalars['DateTime']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  inviteMessage?: InputMaybe<Scalars['String']>;
  invitedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * User access level
   * - user: can only read data
   * - manager: can read and write products
   * - admin: can manage the domain and all its products
   */
  role?: InputMaybe<DomainUserRoleEnum>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

export enum DomainUserRoleEnum {
  Admin = 'admin',
  ComplianceAdmin = 'complianceAdmin',
  ComplianceBasic = 'complianceBasic',
  Manager = 'manager',
  Standard = 'standard'
}

export interface EnvironmentInfo {
  cloudEnv: Scalars['String'];
  featureName: Scalars['String'];
}

/**
 * Handles exact equality to any given value
 *
 * **Pv2_search type:**
 *
 * ```
 * {
 *     type: 'field';
 *     id: string;
 *     value: any
 * }
 * ```
 */
export interface EqualitySearchField extends ISearchField {
  /** Optional section in which this option should be places */
  group?: Maybe<Scalars['String']>;
  /** Unique identifier of a specific operation. It is the main value used for searching */
  id: Scalars['String'];
  /** Human-friendly label */
  label: Scalars['String'];
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: Pv2SearchFieldType;
  value: Scalars['JSON'];
}

export interface FailedImages {
  failedImageId: Scalars['String'];
  failureReason: Scalars['String'];
}

export interface FeatureFlagConfiguration {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  envName: Scalars['String'];
  featureFlag: FeatureFlagConfigurationFeatureFlagEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export enum FeatureFlagConfigurationFeatureFlagEnum {
  Dummy = 'dummy'
}

export interface FeatureFlagConfigurationFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<FeatureFlagConfiguration>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface FeatureFlagConfigurationInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  envName?: InputMaybe<Scalars['String']>;
  featureFlag?: InputMaybe<FeatureFlagConfigurationFeatureFlagEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface FeatureFlagInfo {
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  flag: FeatureFlagConfigurationFeatureFlagEnum;
}

export interface FeatureFlags_Set_FlagInput {
  enabled: Scalars['Boolean'];
  flag: FeatureFlagConfigurationFeatureFlagEnum;
}

/**
 * Stores forms created via the admin (v2) form builder
 *
 * Rendered forms are used in data entry tasks and are distributed via Tasker to Mturk or internally
 */
export interface Form {
  _id: Scalars['ObjectId'];
  config: Scalars['JSON'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  dataRequirements: Array<DataRequirement>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /**
   * Location in S3 where the value is stored ("Bucket/Key")
   *
   * Form value JSON is fetched via the "getConfig()" method or the "value" virtual type in graphql
   *
   * The format of this field is `<Bucket>/<s3Prefix>/forms/<_id>/<_id>-v<version>.json`
   */
  s3Path: Scalars['String'];
  sideComponent: FormSideComponentEnum;
  tags: Array<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  version: Scalars['Float'];
}

export interface FormFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Form>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/**
 * Stores forms created via the admin (v2) form builder
 *
 * Rendered forms are used in data entry tasks and are distributed via Tasker to Mturk or internally
 */
export interface FormInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Virtual to use when assigning a new JSON structure to this form
   *
   * When changed, if it's different than the existing value, the `doc.version` will be incremented and the new value will be uploaded to S3
   *
   * @virtual
   */
  config?: InputMaybe<Scalars['JSON']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  dataRequirements?: InputMaybe<Array<Scalars['JSON']>>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * Location in S3 where the value is stored ("Bucket/Key")
   *
   * Form value JSON is fetched via the "getConfig()" method or the "value" virtual type in graphql
   *
   * The format of this field is `<Bucket>/<s3Prefix>/forms/<_id>/<_id>-v<version>.json`
   */
  s3Path?: InputMaybe<Scalars['String']>;
  sideComponent?: InputMaybe<FormSideComponentEnum>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  version?: InputMaybe<Scalars['Float']>;
}

export interface FormInstruction {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  form?: Maybe<Form>;
  name: Scalars['String'];
  s3Path: Scalars['String'];
  structure: Scalars['JSON'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface FormInstructionFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<FormInstruction>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface FormInstructionInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  form?: InputMaybe<Scalars['ObjectId']>;
  name?: InputMaybe<Scalars['String']>;
  s3Path?: InputMaybe<Scalars['String']>;
  structure?: InputMaybe<Scalars['JSON']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export enum FormSideComponentEnum {
  Iframe = 'iframe',
  ImageViewer = 'imageViewer',
  None = 'none'
}

export interface Formula {
  _id: Scalars['ObjectId'];
  affectedByFormulas: Array<FormulaAffectedByFormulas>;
  changelog: Array<FormulaChangelog>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exports: Array<FormulaExports>;
  fields: Array<Scalars['String']>;
  filter?: Maybe<Scalars['String']>;
  functions?: Maybe<Scalars['String']>;
  inputAllowedValueAttributeTypes: FormulaInputAllowedValueAttributeTypes;
  inputAttributeTypes: FormulaInputAttributeTypes;
  inputCleansedDataPoints: FormulaInputCleansedDataPoints;
  inputClientTrackerAttributes: FormulaInputClientTrackerAttributes;
  inputProductFields: FormulaInputProductFields;
  inputResources: FormulaInputResources;
  isPublic: Scalars['Boolean'];
  name: Scalars['String'];
  outputAttributeTypes: Array<Scalars['String']>;
  referencedFormulas: Array<FormulaReferencedFormulas>;
  runInPv2Middleware: Scalars['Boolean'];
  structure: Scalars['String'];
  tags: Array<TagStruct>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  version: Scalars['Float'];
}

export interface FormulaAffectedByFormulas {
  formula?: Maybe<Formula>;
  name?: Maybe<Scalars['String']>;
}

export interface FormulaAffectedByFormulasInput {
  formula?: InputMaybe<Scalars['ObjectId']>;
  name?: InputMaybe<Scalars['String']>;
}

export interface FormulaChangelog {
  text: Scalars['String'];
  version: Scalars['Float'];
}

export interface FormulaChangelogInput {
  text?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Float']>;
}

export interface FormulaExports {
  allowedValueAttributeTypes: Array<Scalars['String']>;
  attributeTypes: Array<Scalars['String']>;
  cleansedDataPoints: Array<Scalars['String']>;
  clientTrackerAttributes: Array<Scalars['String']>;
  /** Name of the exported variable */
  name: Scalars['String'];
  productFields: Array<Scalars['String']>;
  resources: Array<FormulaResource>;
}

export interface FormulaExportsInput {
  allowedValueAttributeTypes?: InputMaybe<Array<Scalars['String']>>;
  attributeTypes?: InputMaybe<Array<Scalars['String']>>;
  cleansedDataPoints?: InputMaybe<Array<Scalars['String']>>;
  clientTrackerAttributes?: InputMaybe<Array<Scalars['String']>>;
  /** Name of the exported variable */
  name?: InputMaybe<Scalars['String']>;
  productFields?: InputMaybe<Array<Scalars['String']>>;
  /** Formula resources affecting that variable */
  resources?: InputMaybe<Array<Scalars['ObjectId']>>;
}

export interface FormulaFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Formula>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface FormulaInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  affectedByFormulas?: InputMaybe<Array<FormulaAffectedByFormulasInput>>;
  changelog?: InputMaybe<Array<FormulaChangelogInput>>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  exports?: InputMaybe<Array<FormulaExportsInput>>;
  fields?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<Scalars['String']>;
  functions?: InputMaybe<Scalars['String']>;
  inputAllowedValueAttributeTypes?: InputMaybe<FormulaInputAllowedValueAttributeTypesInput>;
  inputAttributeTypes?: InputMaybe<FormulaInputAttributeTypesInput>;
  inputCleansedDataPoints?: InputMaybe<FormulaInputCleansedDataPointsInput>;
  inputClientTrackerAttributes?: InputMaybe<FormulaInputClientTrackerAttributesInput>;
  inputProductFields?: InputMaybe<FormulaInputProductFieldsInput>;
  inputResources?: InputMaybe<FormulaInputResourcesInput>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  outputAttributeTypes?: InputMaybe<Array<Scalars['String']>>;
  referencedFormulas?: InputMaybe<Array<FormulaReferencedFormulasInput>>;
  runInPv2Middleware?: InputMaybe<Scalars['Boolean']>;
  structure?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagStructInput>>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  version?: InputMaybe<Scalars['Float']>;
}

/** SpinsAttributeType allowed values read by this formula */
export interface FormulaInputAllowedValueAttributeTypes {
  direct: Array<Scalars['String']>;
  indirect: Array<Scalars['String']>;
}

/** SpinsAttributeType allowed values read by this formula */
export interface FormulaInputAllowedValueAttributeTypesInput {
  direct?: InputMaybe<Array<Scalars['String']>>;
  indirect?: InputMaybe<Array<Scalars['String']>>;
}

/** Attribute types read by this formula */
export interface FormulaInputAttributeTypes {
  direct: Array<Scalars['String']>;
  indirect: Array<Scalars['String']>;
}

/** Attribute types read by this formula */
export interface FormulaInputAttributeTypesInput {
  direct?: InputMaybe<Array<Scalars['String']>>;
  indirect?: InputMaybe<Array<Scalars['String']>>;
}

/** Top-level product fields read by this formula */
export interface FormulaInputCleansedDataPoints {
  direct: Array<Scalars['String']>;
  indirect: Array<Scalars['String']>;
}

/** Top-level product fields read by this formula */
export interface FormulaInputCleansedDataPointsInput {
  direct?: InputMaybe<Array<Scalars['String']>>;
  indirect?: InputMaybe<Array<Scalars['String']>>;
}

/** Client tracker data points read by this formula */
export interface FormulaInputClientTrackerAttributes {
  direct: Array<Scalars['String']>;
  indirect: Array<Scalars['String']>;
}

/** Client tracker data points read by this formula */
export interface FormulaInputClientTrackerAttributesInput {
  direct?: InputMaybe<Array<Scalars['String']>>;
  indirect?: InputMaybe<Array<Scalars['String']>>;
}

/** Top-level product fields read by this formula */
export interface FormulaInputProductFields {
  direct: Array<Scalars['String']>;
  indirect: Array<Scalars['String']>;
}

/** Top-level product fields read by this formula */
export interface FormulaInputProductFieldsInput {
  direct?: InputMaybe<Array<Scalars['String']>>;
  indirect?: InputMaybe<Array<Scalars['String']>>;
}

/** FormulaResource _ids read by this formula */
export interface FormulaInputResources {
  direct: Array<FormulaResource>;
  indirect: Array<FormulaResource>;
}

/** FormulaResource _ids read by this formula */
export interface FormulaInputResourcesInput {
  /** Formula resources read directly by this formula */
  direct?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Formula resources referenced by way of formula imports */
  indirect?: InputMaybe<Array<Scalars['ObjectId']>>;
}

export interface FormulaReferencedFormulas {
  /** _id of the referenced formula */
  formula?: Maybe<Formula>;
  imports: Array<Scalars['String']>;
  /** Convenience field showing the name of the referenced formula, could be removed once QA review is complete */
  name?: Maybe<Scalars['String']>;
}

export interface FormulaReferencedFormulasInput {
  /** _id of the referenced formula */
  formula?: InputMaybe<Scalars['ObjectId']>;
  imports?: InputMaybe<Array<Scalars['String']>>;
  /** Convenience field showing the name of the referenced formula, could be removed once QA review is complete */
  name?: InputMaybe<Scalars['String']>;
}

export interface FormulaResource {
  _id: Scalars['ObjectId'];
  children: Array<FormulaResource>;
  config?: Maybe<Scalars['JSON']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  descendents: Array<FormulaResource>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownItems: Scalars['Float'];
  s3Path: Scalars['String'];
  slug: Scalars['String'];
  tags: Array<TagStruct>;
  totalChildren: Scalars['Float'];
  totalItems: Scalars['Float'];
  type: FormulaResourceTypeEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
  /** @virtual */
  valueJSON: Scalars['JSON'];
  version: Scalars['Float'];
}

export interface FormulaResourceFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<FormulaResource>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface FormulaResourceInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  children?: InputMaybe<Array<Scalars['ObjectId']>>;
  config?: InputMaybe<Scalars['JSON']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  descendents?: InputMaybe<Array<Scalars['ObjectId']>>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownItems?: InputMaybe<Scalars['Float']>;
  s3Path?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagStructInput>>;
  totalChildren?: InputMaybe<Scalars['Float']>;
  totalItems?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<FormulaResourceTypeEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['String']>;
  /** @virtual */
  valueJSON?: InputMaybe<Scalars['JSON']>;
  version?: InputMaybe<Scalars['Float']>;
}

export enum FormulaResourceTypeEnum {
  List = 'list',
  Table = 'table'
}

export interface GcpAccessToken {
  token?: Maybe<Scalars['String']>;
}

/** Stores the taxonomy ref id and gpcCode to map taxonomies for Metro GS1 ingestion */
export interface Gs1TaxonomyMapping {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  gpcCode: Scalars['String'];
  taxonomyId?: Maybe<Taxonomy>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface Gs1TaxonomyMappingFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Gs1TaxonomyMapping>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Stores the taxonomy ref id and gpcCode to map taxonomies for Metro GS1 ingestion */
export interface Gs1TaxonomyMappingInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  gpcCode?: InputMaybe<Scalars['String']>;
  taxonomyId?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface GcpScriptLog {
  _id: Scalars['ObjectId'];
  executionId: Scalars['String'];
  executionUrl: Scalars['String'];
  namespace: Scalars['String'];
  timestamp: Scalars['DateTime'];
  userId: Scalars['String'];
}

export interface GcpScriptLogFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<GcpScriptLog>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface GcpScriptLogInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  executionId?: InputMaybe<Scalars['String']>;
  executionUrl?: InputMaybe<Scalars['String']>;
  namespace?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
}

export interface GetPublicSignedFileLink {
  url: Scalars['String'];
}

export interface HeartBeatItem {
  displayName: Scalars['String'];
  isRunning: Scalars['Boolean'];
  lastCheckedTimestamp: Scalars['DateTime'];
}

export interface HierarchyAllowedValues {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  hierarchyId?: Maybe<Taxonomy>;
  spinsAttributeTypeId?: Maybe<SpinsAttributeType>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  values: Array<Scalars['String']>;
}

export interface HierarchyAllowedValuesFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<HierarchyAllowedValues>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface HierarchyAllowedValuesInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  hierarchyId?: InputMaybe<Scalars['ObjectId']>;
  spinsAttributeTypeId?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  values?: InputMaybe<Array<Scalars['String']>>;
}

export interface HierarchyConditionEvaluation {
  attrValue?: Maybe<Scalars['String']>;
  attribute: Scalars['String'];
  isMatch: Scalars['Boolean'];
  shortCircuited: Scalars['Boolean'];
}

export interface HierarchyLookupOptionEvaluation {
  isMatch: Scalars['Boolean'];
  shortCircuited: Scalars['Boolean'];
}

export interface HierarchyMapping {
  _id: Scalars['ObjectId'];
  circanaKeyCat: Scalars['String'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  fallbackTaxonomy?: Maybe<Taxonomy>;
  parentTaxonomies: Array<Taxonomy>;
  rules: Array<HierarchyMappingRule>;
  taxonomies: Array<Taxonomy>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface HierarchyMappingAttributeValue {
  attribute: Scalars['String'];
  value?: Maybe<Scalars['String']>;
}

export interface HierarchyMappingBulkEvaluationResult {
  hierarchies: Array<HierarchyMappingTaxonomyInfo>;
  keycatInfo: Array<HierarchyMappingKeycatInfo>;
  results: Array<HierarchyMappingBulkEvaluationResultItem>;
}

export interface HierarchyMappingBulkEvaluationResultItem {
  attributeValues: Array<HierarchyMappingAttributeValue>;
  existingHierarchy?: Maybe<Scalars['ObjectId']>;
  hierarchyOverride?: Maybe<Pv2HierarchyOverrideEnum>;
  isDifferent: Scalars['Boolean'];
  keycat?: Maybe<Scalars['String']>;
  mappedHierarchy?: Maybe<Scalars['ObjectId']>;
  name?: Maybe<Scalars['String']>;
  pv2Id: Scalars['ObjectId'];
}

export interface HierarchyMappingChildRule {
  conditions: Array<HierarchyMappingCondition>;
  lookupAttribute?: Maybe<Scalars['String']>;
  lookupOptions: Array<HierarchyMappingLookupOption>;
  taxonomy?: Maybe<Taxonomy>;
  type: HierarchyMappingChildRuleTypeEnum;
}

export interface HierarchyMappingChildRuleInput {
  conditions?: InputMaybe<Array<HierarchyMappingConditionInput>>;
  lookupAttribute?: InputMaybe<Scalars['String']>;
  lookupOptions?: InputMaybe<Array<HierarchyMappingLookupOptionInput>>;
  taxonomy?: InputMaybe<Scalars['ObjectId']>;
  type?: InputMaybe<HierarchyMappingChildRuleTypeEnum>;
}

export enum HierarchyMappingChildRuleTypeEnum {
  Lookup = 'lookup',
  Standard = 'standard'
}

export interface HierarchyMappingCondition {
  attribute: Scalars['String'];
  matchType: HierarchyMappingConditionMatchTypeEnum;
  values: Array<Scalars['String']>;
}

export interface HierarchyMappingConditionInput {
  attribute?: InputMaybe<Scalars['String']>;
  matchType?: InputMaybe<HierarchyMappingConditionMatchTypeEnum>;
  values?: InputMaybe<Array<Scalars['String']>>;
}

export enum HierarchyMappingConditionMatchTypeEnum {
  Contains = 'contains',
  ContainsWord = 'containsWord',
  Exact = 'exact',
  Exists = 'exists',
  NotContains = 'notContains',
  NotContainsWord = 'notContainsWord',
  NotExists = 'notExists'
}

export interface HierarchyMappingEvaluationResult {
  isApplicable: Scalars['Boolean'];
  keycat?: Maybe<Scalars['String']>;
  mappedTaxonomyId?: Maybe<Scalars['ObjectId']>;
  rules: Array<HierarchyRuleEvaluation>;
}

export interface HierarchyMappingFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<HierarchyMapping>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface HierarchyMappingInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  circanaKeyCat?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  fallbackTaxonomy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * All parent/ancestor taxonomies (e.g. department and category) for taxonomies
   * output by this mapping.
   */
  parentTaxonomies?: InputMaybe<Array<Scalars['ObjectId']>>;
  rules?: InputMaybe<Array<HierarchyMappingRuleInput>>;
  /** All taxonomies directly output by any mapping rules or fallback. */
  taxonomies?: InputMaybe<Array<Scalars['ObjectId']>>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface HierarchyMappingKeycatInfo {
  keycat: Scalars['String'];
  mappingId?: Maybe<Scalars['ObjectId']>;
  relevantAttributes: Array<Scalars['String']>;
}

export interface HierarchyMappingLookupOption {
  taxonomy?: Maybe<Taxonomy>;
  values: Array<Scalars['String']>;
}

export interface HierarchyMappingLookupOptionInput {
  taxonomy?: InputMaybe<Scalars['ObjectId']>;
  values?: InputMaybe<Array<Scalars['String']>>;
}

export interface HierarchyMappingRule {
  children: Array<HierarchyMappingChildRule>;
  conditions: Array<HierarchyMappingCondition>;
  lookupAttribute?: Maybe<Scalars['String']>;
  lookupOptions: Array<HierarchyMappingLookupOption>;
  taxonomy?: Maybe<Taxonomy>;
  type: HierarchyMappingRuleTypeEnum;
}

export interface HierarchyMappingRuleInput {
  children?: InputMaybe<Array<HierarchyMappingChildRuleInput>>;
  conditions?: InputMaybe<Array<HierarchyMappingConditionInput>>;
  lookupAttribute?: InputMaybe<Scalars['String']>;
  lookupOptions?: InputMaybe<Array<HierarchyMappingLookupOptionInput>>;
  taxonomy?: InputMaybe<Scalars['ObjectId']>;
  type?: InputMaybe<HierarchyMappingRuleTypeEnum>;
}

export enum HierarchyMappingRuleTypeEnum {
  Lookup = 'lookup',
  Standard = 'standard'
}

export interface HierarchyMappingTaxonomyInfo {
  productType?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  taxonomyId: Scalars['ObjectId'];
}

export interface HierarchyRuleEvaluation {
  children: Array<HierarchyRuleEvaluation>;
  conditions: Array<HierarchyConditionEvaluation>;
  isMatch: Scalars['Boolean'];
  lookupAttributeValue?: Maybe<Scalars['String']>;
  lookupOptions?: Maybe<Array<HierarchyLookupOptionEvaluation>>;
  shortCircuited: Scalars['Boolean'];
  taxonomyId?: Maybe<Scalars['ObjectId']>;
}

export interface IEditableField {
  /**
   * List of field id-s to reset the value on change.
   *
   * E.g. when `width_mm` is changed `with_inch` should be cleared since those 2 fields are computed based on each-other in the backend
   */
  clearOnChange?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  /** Hidden fields should not be rendered but can still be used to update the Pv2 */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Unique field identifier */
  id: Scalars['String'];
  /** Human-readlabe name */
  label: Scalars['String'];
  readonly: Scalars['Boolean'];
  required: Scalars['Boolean'];
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: IEditableFieldTypeEnum;
  value?: Maybe<Scalars['JSON']>;
}

export enum IEditableFieldTypeEnum {
  CheckboxEditableField = 'CheckboxEditableField',
  ImageListEditableField = 'ImageListEditableField',
  NumberEditableField = 'NumberEditableField',
  SelectEditableField = 'SelectEditableField',
  StringEditableField = 'StringEditableField'
}

export interface ISearchField {
  /** Optional section in which this option should be places */
  group?: Maybe<Scalars['String']>;
  /** Unique identifier of a specific operation. It is the main value used for searching */
  id: Scalars['String'];
  /** Human-friendly label */
  label: Scalars['String'];
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: Pv2SearchFieldType;
}

export interface Image {
  /** Unique MongoDB _id */
  _id?: Maybe<Scalars['ObjectId']>;
  acceptedTimestamp: Scalars['DateTime'];
  /** @virtual */
  angle: Scalars['JSON'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** @virtual */
  croppedUrl?: Maybe<ImageUrl>;
  /** Raw URL for images with source: digitization-app */
  digitizationOriginalUrls: Array<ImageUrl>;
  downloaded?: Maybe<ImageDownloaded>;
  isInImageProcessingQueue: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  mainUrl?: Maybe<ImageUrl>;
  name?: Maybe<Scalars['String']>;
  /** Image Id reference to the original image the current image will replace during the image processing pipeline process */
  overrides?: Maybe<Image>;
  pv2?: Maybe<Pv2>;
  pv2ProcessingPriority: Scalars['Float'];
  rejectionReason?: Maybe<ImageRejectionReasonEnum>;
  scannedBarcodes: Array<ScannedBarcodes>;
  side: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  status: ImageStatusEnum;
  thumbnailUrl?: Maybe<ImageUrl>;
  type: ImageTypeEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  uploaded?: Maybe<ImageUploaded>;
  urls: Array<ImageUrl>;
}

export interface ImageAnnotatorAnnotationInfo {
  default_position?: Maybe<Scalars['Float']>;
  display_name: Scalars['String'];
  prerequisites?: Maybe<Array<Scalars['String']>>;
  ref_name: Scalars['String'];
  reference_confidence_value?: Maybe<Scalars['Float']>;
  returns?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
}

export interface ImageAnnotatorInfo {
  annotations: Array<ImageAnnotatorAnnotationInfo>;
  durationInSeconds: Scalars['Float'];
  prerequisites: Array<Scalars['String']>;
}

export interface ImageDownloaded {
  timestamp: Scalars['DateTime'];
  user?: Maybe<User>;
}

export interface ImageDownloadedInput {
  timestamp?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

export interface ImageFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Image>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface ImageInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  acceptedTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** @virtual */
  angle?: InputMaybe<Scalars['JSON']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  /** @virtual */
  croppedUrl?: InputMaybe<ImageUrlInput>;
  /** Raw URL for images with source: digitization-app */
  digitizationOriginalUrls?: InputMaybe<Array<ImageUrlInput>>;
  downloaded?: InputMaybe<ImageDownloadedInput>;
  isInImageProcessingQueue?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  /** @virtual */
  mainUrl?: InputMaybe<ImageUrlInput>;
  name?: InputMaybe<Scalars['String']>;
  /** Image Id reference to the original image the current image will replace during the image processing pipeline process */
  overrides?: InputMaybe<Scalars['ObjectId']>;
  pv2?: InputMaybe<Scalars['ObjectId']>;
  pv2ProcessingPriority?: InputMaybe<Scalars['Float']>;
  rejectionReason?: InputMaybe<ImageRejectionReasonEnum>;
  scannedBarcodes?: InputMaybe<Array<ScannedBarcodesInput>>;
  side?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ImageStatusEnum>;
  /** @virtual */
  thumbnailUrl?: InputMaybe<ImageUrlInput>;
  type?: InputMaybe<ImageTypeEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  uploaded?: InputMaybe<ImageUploadedInput>;
  urls?: InputMaybe<Array<ImageUrlInput>>;
}

/** A list of image IDs */
export interface ImageListEditableField extends IEditableField {
  /**
   * List of field id-s to reset the value on change.
   *
   * E.g. when `width_mm` is changed `with_inch` should be cleared since those 2 fields are computed based on each-other in the backend
   */
  clearOnChange?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  /** Hidden fields should not be rendered but can still be used to update the Pv2 */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Unique field identifier */
  id: Scalars['String'];
  images: Array<Image>;
  /** Human-readlabe name */
  label: Scalars['String'];
  readonly: Scalars['Boolean'];
  required: Scalars['Boolean'];
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: IEditableFieldTypeEnum;
  value?: Maybe<Scalars['JSON']>;
}

export interface ImageProcessingQueueAcceptInput {
  imageIds: Array<Scalars['String']>;
  pv2Id: Scalars['String'];
}

export enum ImageRejectionReasonEnum {
  CroppingIssue = 'Cropping_Issue',
  ExposureIssue = 'Exposure_Issue',
  ImageOrientationIssue = 'Image_Orientation_Issue',
  WhiteBalanceIssue = 'White_Balance_Issue',
  Other = 'other'
}

export interface ImageSides {
  sides: Array<Scalars['String']>;
}

export interface ImageSources {
  sources: Array<Scalars['String']>;
}

export enum ImageStatusEnum {
  Done = 'done',
  Failed = 'failed',
  Outdated = 'outdated',
  Pending = 'pending',
  PendingReview = 'pending_review',
  Processing = 'processing',
  Raw = 'raw'
}

export enum ImageTypeEnum {
  Closeup = 'closeup',
  Glamor = 'glamor'
}

export interface ImageUploaded {
  timestamp: Scalars['DateTime'];
  user?: Maybe<User>;
}

export interface ImageUploadedInput {
  timestamp?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

export interface ImageUrl {
  date: Scalars['DateTime'];
  height?: Maybe<Scalars['Float']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeMb?: Maybe<Scalars['Float']>;
  type: ImageUrlTypeEnum;
  url?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  width?: Maybe<Scalars['Float']>;
}

export interface ImageUrlInput {
  date?: InputMaybe<Scalars['DateTime']>;
  height?: InputMaybe<Scalars['Float']>;
  s3Key?: InputMaybe<Scalars['String']>;
  sizeMb?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ImageUrlTypeEnum>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ObjectId']>;
  width?: InputMaybe<Scalars['Float']>;
}

export enum ImageUrlTypeEnum {
  Crop = 'crop',
  Main = 'main',
  Raw = 'raw',
  Thumbnail = 'thumbnail'
}

export interface Images {
  fileName: Scalars['String'];
  highPriorityImageCount: Scalars['Int'];
  url: Scalars['String'];
}

/** Retains details about Ingestions */
export interface Ingestion {
  _id: Scalars['ObjectId'];
  _query?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  internalError?: Maybe<Scalars['String']>;
  message?: Maybe<IngestionMessage>;
  name: Scalars['String'];
  processing?: Maybe<IngestionProcessing>;
  /** @virtual */
  query?: Maybe<Scalars['JSON']>;
  retailerId: Scalars['Float'];
  statsItems?: Maybe<IngestionStatsItems>;
  statsSales?: Maybe<IngestionStatsSales>;
  statsStores?: Maybe<IngestionStatsStores>;
  status: IngestionStatusEnum;
  type: IngestionTypeEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface IngestionFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Ingestion>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Retains details about Ingestions */
export interface IngestionInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  _query?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  internalError?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<IngestionMessageInput>;
  name?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<IngestionProcessingInput>;
  /** @virtual */
  query?: InputMaybe<Scalars['JSON']>;
  retailerId?: InputMaybe<Scalars['Float']>;
  statsItems?: InputMaybe<IngestionStatsItemsInput>;
  statsSales?: InputMaybe<IngestionStatsSalesInput>;
  statsStores?: InputMaybe<IngestionStatsStoresInput>;
  status?: InputMaybe<IngestionStatusEnum>;
  type?: InputMaybe<IngestionTypeEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface IngestionMessage {
  completionDate: Scalars['DateTime'];
  domain: Scalars['String'];
  fileLocation: Scalars['String'];
  latestEffectiveDate: Scalars['String'];
  process: Scalars['String'];
  projectId: Scalars['String'];
  topicId: Scalars['String'];
}

export interface IngestionMessageInput {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  domain?: InputMaybe<Scalars['String']>;
  fileLocation?: InputMaybe<Scalars['String']>;
  latestEffectiveDate?: InputMaybe<Scalars['String']>;
  process?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  topicId?: InputMaybe<Scalars['String']>;
}

export interface IngestionProcessing {
  durationInSeconds?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['DateTime']>;
  numProducts?: Maybe<Scalars['Float']>;
  startDate: Scalars['DateTime'];
}

export interface IngestionProcessingInput {
  durationInSeconds?: InputMaybe<Scalars['Float']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  numProducts?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
}

export interface IngestionStatsItems {
  created: Scalars['Float'];
  duplicateItemCodes: Array<Scalars['String']>;
  duplicates: Scalars['Float'];
  ignored: Scalars['Float'];
  rows: Scalars['Float'];
  unique: Scalars['Float'];
  updated: Scalars['Float'];
  whitelisted: Scalars['Float'];
  whitelistedPrivateLabel: Scalars['Float'];
}

export interface IngestionStatsItemsInput {
  created?: InputMaybe<Scalars['Float']>;
  duplicateItemCodes?: InputMaybe<Array<Scalars['String']>>;
  duplicates?: InputMaybe<Scalars['Float']>;
  ignored?: InputMaybe<Scalars['Float']>;
  rows?: InputMaybe<Scalars['Float']>;
  unique?: InputMaybe<Scalars['Float']>;
  updated?: InputMaybe<Scalars['Float']>;
  whitelisted?: InputMaybe<Scalars['Float']>;
  whitelistedPrivateLabel?: InputMaybe<Scalars['Float']>;
}

export interface IngestionStatsSales {
  created: Scalars['Float'];
  ignored: Scalars['Float'];
  rows: Scalars['Float'];
  updated: Scalars['Float'];
}

export interface IngestionStatsSalesInput {
  created?: InputMaybe<Scalars['Float']>;
  ignored?: InputMaybe<Scalars['Float']>;
  rows?: InputMaybe<Scalars['Float']>;
  updated?: InputMaybe<Scalars['Float']>;
}

export interface IngestionStatsStores {
  created: Scalars['Float'];
  ignored: Scalars['Float'];
  rows: Scalars['Float'];
  updated: Scalars['Float'];
}

export interface IngestionStatsStoresInput {
  created?: InputMaybe<Scalars['Float']>;
  ignored?: InputMaybe<Scalars['Float']>;
  rows?: InputMaybe<Scalars['Float']>;
  updated?: InputMaybe<Scalars['Float']>;
}

export enum IngestionStatusEnum {
  Done = 'done',
  Error = 'error',
  Pending = 'pending',
  Processing = 'processing'
}

export enum IngestionTypeEnum {
  Items = 'items',
  Product = 'product',
  Sales = 'sales',
  Stores = 'stores'
}

export interface IngredientCheckerLists {
  acceptable: Array<Maybe<Scalars['String']>>;
  highriskbe: Array<Maybe<Scalars['String']>>;
  special: Array<Maybe<Scalars['String']>>;
  unacceptable: Array<Maybe<Scalars['String']>>;
  unreviewed: Array<Maybe<Scalars['String']>>;
}

export interface IngredientCheckerProducts {
  identifier?: Maybe<Scalars['String']>;
  lists: IngredientCheckerLists;
  name?: Maybe<Scalars['String']>;
}

export interface IngredientDetailsPv2 {
  id: Scalars['String'];
  ingredientAttributes: Array<IngredientAttribute>;
  name: Scalars['String'];
}

export interface IngredientDetailsResult {
  attributes?: Maybe<Array<Attribute>>;
  /** Taxonomy data for the ingredient. */
  leafTaxonomies?: Maybe<Array<LeafTaxonomy>>;
  pv2Total: Scalars['Int'];
}

export interface IngredientFormulaReferences {
  _id: Scalars['String'];
  formulas: Array<IngredientFormulaReferencesFormula>;
  name: Scalars['String'];
}

export interface IngredientFormulaReferencesFormula {
  _id: Scalars['String'];
  name: Scalars['String'];
}

export enum IngredientReviewStatusEnum {
  Done = 'done',
  NeedsAdditionalReview = 'needsAdditionalReview',
  Pending = 'pending',
  Processing = 'processing'
}

export interface InstacartProduct {
  attributes: Array<InstacartProductAttribute>;
  brand?: Maybe<Scalars['String']>;
  gtin: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
  taxonomies: Array<InstacartTaxonomy>;
  updatedDate: Scalars['DateTime'];
}

export interface InstacartProductAttribute {
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
}

export interface InstacartProductsPage {
  nodes: Array<InstacartProduct>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface InstacartTaxonomy {
  breadcrumb: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
}

export interface Jwt {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  expiresAt: Scalars['DateTime'];
  name: Scalars['String'];
  token: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  valid: Scalars['Boolean'];
}

export interface JwtFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Jwt>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface JwtInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  valid?: InputMaybe<Scalars['Boolean']>;
}

export interface LeafTaxonomy {
  breadcrumb?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  pv2Count: Scalars['Int'];
  pv2s: Array<IngredientDetailsPv2>;
}

export interface ListVariable {
  list: Array<Scalars['String']>;
  name: Scalars['String'];
}

export interface LockedValues {
  _id: Scalars['ObjectId'];
  animalType?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  chocolateType?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  department?: Maybe<Scalars['String']>;
  flavor?: Maybe<Scalars['String']>;
  form?: Maybe<Scalars['String']>;
  gtin: Scalars['String'];
  maskedBrand?: Maybe<Scalars['String']>;
  packCount?: Maybe<Scalars['String']>;
  packagingTypePrimary?: Maybe<Scalars['String']>;
  privateLabelConventional?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  pv2Override?: Maybe<Pv2>;
  size?: Maybe<Scalars['String']>;
  /** The spinsUpc of the Pv2 in "pv2Override", or an empty string if there is no override */
  spinsUpc?: Maybe<Scalars['String']>;
  storage?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  unitOfMeasurement?: Maybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface LockedValuesFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<LockedValues>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface LockedValuesInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  animalType?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  chocolateType?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  department?: InputMaybe<Scalars['String']>;
  flavor?: InputMaybe<Scalars['String']>;
  form?: InputMaybe<Scalars['String']>;
  gtin?: InputMaybe<Scalars['String']>;
  maskedBrand?: InputMaybe<Scalars['String']>;
  packCount?: InputMaybe<Scalars['String']>;
  packagingTypePrimary?: InputMaybe<Scalars['String']>;
  privateLabelConventional?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  pv2Override?: InputMaybe<Scalars['ObjectId']>;
  size?: InputMaybe<Scalars['String']>;
  /** The spinsUpc of the Pv2 in "pv2Override", or an empty string if there is no override */
  spinsUpc?: InputMaybe<Scalars['String']>;
  storage?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  unitOfMeasurement?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface LoginResult {
  jwt?: Maybe<Scalars['String']>;
  session?: Maybe<Session>;
}

export interface MaskedUpc {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  gtin: Scalars['String'];
  /**
   * READONLY.
   * This will computed on pre.validate. It will always be the max masked upc + 1;
   */
  maskedUpc: Scalars['String'];
  upc: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface MaskedUpcFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<MaskedUpc>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface MaskedUpcInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  gtin?: InputMaybe<Scalars['String']>;
  /**
   * READONLY.
   * This will computed on pre.validate. It will always be the max masked upc + 1;
   */
  maskedUpc?: InputMaybe<Scalars['String']>;
  upc?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface ModelAggregateResult {
  results: Array<Scalars['JSON']>;
  steps: Array<ModelAggregateStep>;
}

/**
 * The intermediate output of a single aggregation stage, used to preview what each stage of a
 * pipeline produces.
 */
export interface ModelAggregateStep {
  results: Array<Scalars['JSON']>;
  stageIndex: Scalars['Int'];
}

export interface ModelColumnInfo {
  children: Array<ModelColumnInfo>;
  /** List of possible enum values if the field is an enum type. */
  enum?: Maybe<Array<Scalars['String']>>;
  hasDefault: Scalars['Boolean'];
  isList: Scalars['Boolean'];
  isRequired?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  refModel?: Maybe<ModelNameEnum>;
  type: ModelColumnType;
}

export enum ModelColumnType {
  Boolean = 'boolean',
  Date = 'date',
  Id = 'id',
  Number = 'number',
  Object = 'object',
  Ref = 'ref',
  String = 'string',
  Unknown = 'unknown'
}

export interface ModelDistinctItem {
  count: Scalars['Int'];
  value: Scalars['JSON'];
}

export enum ModelEnum {
  AliasMapping = 'AliasMapping',
  AmazonProduct = 'AmazonProduct',
  AnalyticsClientFeedbackJiraIssue = 'AnalyticsClientFeedbackJiraIssue',
  AnalyticsClientFeedbackSpinsAttribute = 'AnalyticsClientFeedbackSpinsAttribute',
  AnalyticsClientFeedbackTrackerUpdate = 'AnalyticsClientFeedbackTrackerUpdate',
  AnalyticsOperationalKpi = 'AnalyticsOperationalKPI',
  AnalyticsProductCount = 'AnalyticsProductCount',
  AnalyticsQcSelfServe = 'AnalyticsQCSelfServe',
  ApertureAnnotation = 'ApertureAnnotation',
  AutoNotifications = 'AutoNotifications',
  BrandReview = 'BrandReview',
  BuilderBatch = 'BuilderBatch',
  CircanaBrandMapping = 'CircanaBrandMapping',
  CleansedData = 'CleansedData',
  ClientTrackerValue = 'ClientTrackerValue',
  Company = 'Company',
  CompanySignupRequest = 'CompanySignupRequest',
  Config = 'Config',
  DeleteHistory = 'DeleteHistory',
  DigitizationUpcScan = 'DigitizationUpcScan',
  DigitizationUpdate = 'DigitizationUpdate',
  DigitizationUserStatus = 'DigitizationUserStatus',
  Domain = 'Domain',
  FeatureFlagConfiguration = 'FeatureFlagConfiguration',
  Form = 'Form',
  FormInstruction = 'FormInstruction',
  Formula = 'Formula',
  FormulaResource = 'FormulaResource',
  Gs1TaxonomyMapping = 'GS1TaxonomyMapping',
  GcpScriptLog = 'GcpScriptLog',
  HierarchyAllowedValues = 'HierarchyAllowedValues',
  HierarchyMapping = 'HierarchyMapping',
  Image = 'Image',
  Ingestion = 'Ingestion',
  Jwt = 'Jwt',
  LockedValues = 'LockedValues',
  MaskedUpc = 'MaskedUpc',
  MturkHit = 'MturkHIT',
  MturkWorker = 'MturkWorker',
  NfpAttributeMapping = 'NfpAttributeMapping',
  Period = 'Period',
  PreProductionNtc = 'PreProductionNtc',
  PreProductionNtu = 'PreProductionNtu',
  PredictionOverride = 'PredictionOverride',
  PrivateLabelPermanentProduct = 'PrivateLabelPermanentProduct',
  PrivateLabelProduct = 'PrivateLabelProduct',
  ProductEditRequest = 'ProductEditRequest',
  ProductSentToTarget = 'ProductSentToTarget',
  Pv2 = 'Pv2',
  Pv2AttributeDefinition = 'Pv2AttributeDefinition',
  Pv2CustomFieldConfig = 'Pv2CustomFieldConfig',
  Pv2Ingredient = 'Pv2Ingredient',
  Pv2Verification = 'Pv2Verification',
  RawIngestionData = 'RawIngestionData',
  RawIngestionEvent = 'RawIngestionEvent',
  RetailItemsExtract = 'RetailItemsExtract',
  RetailerPrivateLabel = 'RetailerPrivateLabel',
  Script = 'Script',
  ServicesHeartbeat = 'ServicesHeartbeat',
  SnapshotTags = 'SnapshotTags',
  SpinsAttributeType = 'SpinsAttributeType',
  SpinsAttributes = 'SpinsAttributes',
  Store = 'Store',
  Tag = 'Tag',
  Task = 'Task',
  TaskDefinition = 'TaskDefinition',
  Taxonomy = 'Taxonomy',
  TransformerExpression = 'TransformerExpression',
  TransformerResource = 'TransformerResource',
  User = 'User',
  UserBatch = 'UserBatch',
  UserSearch = 'UserSearch',
  Whitelist = 'Whitelist'
}

export interface ModelHistory {
  data: Scalars['JSON'];
  date?: Maybe<Scalars['DateTime']>;
  model: Scalars['String'];
  modelId: Scalars['ObjectId'];
  s3Key?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  version: Scalars['Int'];
}

export enum ModelNameEnum {
  AliasMapping = 'AliasMapping',
  AmazonProduct = 'AmazonProduct',
  AnalyticsClientFeedbackJiraIssue = 'AnalyticsClientFeedbackJiraIssue',
  AnalyticsClientFeedbackSpinsAttribute = 'AnalyticsClientFeedbackSpinsAttribute',
  AnalyticsClientFeedbackTrackerUpdate = 'AnalyticsClientFeedbackTrackerUpdate',
  AnalyticsOperationalKpi = 'AnalyticsOperationalKPI',
  AnalyticsProductCount = 'AnalyticsProductCount',
  AnalyticsQcSelfServe = 'AnalyticsQCSelfServe',
  ApertureAnnotation = 'ApertureAnnotation',
  AutoNotifications = 'AutoNotifications',
  BrandReview = 'BrandReview',
  BuilderBatch = 'BuilderBatch',
  CircanaBrandMapping = 'CircanaBrandMapping',
  CleansedData = 'CleansedData',
  ClientTrackerValue = 'ClientTrackerValue',
  Company = 'Company',
  CompanySignupRequest = 'CompanySignupRequest',
  Config = 'Config',
  DeleteHistory = 'DeleteHistory',
  DigitizationUpcScan = 'DigitizationUpcScan',
  DigitizationUpdate = 'DigitizationUpdate',
  DigitizationUserStatus = 'DigitizationUserStatus',
  Domain = 'Domain',
  FeatureFlagConfiguration = 'FeatureFlagConfiguration',
  Form = 'Form',
  FormInstruction = 'FormInstruction',
  Formula = 'Formula',
  FormulaResource = 'FormulaResource',
  Gs1TaxonomyMapping = 'GS1TaxonomyMapping',
  GcpScriptLog = 'GcpScriptLog',
  HierarchyAllowedValues = 'HierarchyAllowedValues',
  HierarchyMapping = 'HierarchyMapping',
  Image = 'Image',
  Ingestion = 'Ingestion',
  Jwt = 'Jwt',
  LockedValues = 'LockedValues',
  MaskedUpc = 'MaskedUpc',
  MturkHit = 'MturkHIT',
  MturkWorker = 'MturkWorker',
  NfpAttributeMapping = 'NfpAttributeMapping',
  Period = 'Period',
  PreProductionNtc = 'PreProductionNtc',
  PreProductionNtu = 'PreProductionNtu',
  PredictionOverride = 'PredictionOverride',
  PrivateLabelPermanentProduct = 'PrivateLabelPermanentProduct',
  PrivateLabelProduct = 'PrivateLabelProduct',
  ProductEditRequest = 'ProductEditRequest',
  ProductSentToTarget = 'ProductSentToTarget',
  Pv2 = 'Pv2',
  Pv2AttributeDefinition = 'Pv2AttributeDefinition',
  Pv2CustomFieldConfig = 'Pv2CustomFieldConfig',
  Pv2Ingredient = 'Pv2Ingredient',
  Pv2Verification = 'Pv2Verification',
  RawIngestionData = 'RawIngestionData',
  RawIngestionEvent = 'RawIngestionEvent',
  RetailItemsExtract = 'RetailItemsExtract',
  RetailerPrivateLabel = 'RetailerPrivateLabel',
  Script = 'Script',
  ServicesHeartbeat = 'ServicesHeartbeat',
  SnapshotTags = 'SnapshotTags',
  SpinsAttributeType = 'SpinsAttributeType',
  SpinsAttributes = 'SpinsAttributes',
  Store = 'Store',
  Tag = 'Tag',
  Task = 'Task',
  TaskDefinition = 'TaskDefinition',
  Taxonomy = 'Taxonomy',
  TransformerExpression = 'TransformerExpression',
  TransformerResource = 'TransformerResource',
  User = 'User',
  UserBatch = 'UserBatch',
  UserSearch = 'UserSearch',
  Whitelist = 'Whitelist'
}

export interface ModelResult {
  /**
   * The underlying MongoDB collection name, which is not always derivable from the
   * model name (Pv2 lives in "pv2", Company in "companies"). Needed by callers
   * building their own aggregation pipelines to fill in a $lookup's "from".
   */
  collectionName: Scalars['String'];
  /** The columns for a given model with their types and children. */
  columns: Array<ModelColumnInfo>;
  /** Whether history tracking is enabled for this model. */
  hasHistoryTracking: Scalars['Boolean'];
  /** Whether the model has a top-level tags field of type TagStruct[]. */
  isTaggable: Scalars['Boolean'];
}

/** Lightweight schema metadata for a single model, suitable for populating model pickers. */
export interface ModelSummary {
  /** Whether history tracking is enabled for this model. */
  hasHistoryTracking: Scalars['Boolean'];
  /** Whether the model has a top-level tags field of type TagStruct[]. */
  isTaggable: Scalars['Boolean'];
  name: ModelNameEnum;
}

export interface ModelTagCount {
  /** The number of records carrying this tag name. */
  count: Scalars['Int'];
  name: Scalars['String'];
}

/** The outcome of a batched tag add or remove. */
export interface ModelTagUpdateResult {
  /** How many of the given records needed the change. */
  matched: Scalars['Int'];
  /** How many records were actually changed. */
  modified: Scalars['Int'];
}

export interface MturkHit {
  AssignmentDurationInSeconds: Scalars['Float'];
  CreationTime?: Maybe<Scalars['String']>;
  Expiration: Scalars['DateTime'];
  HITGroupId: Scalars['String'];
  HITId: Scalars['String'];
  HITTypeId: Scalars['String'];
  MaxAssignments: Scalars['Float'];
  Reward: Scalars['String'];
  _id: Scalars['ObjectId'];
  assignmentList: Array<MturkHitAssignmentList>;
  config?: Maybe<Scalars['JSON']>;
  /** The full cost of this task, including amazon's cut */
  cost: Scalars['Float'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  empty: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  invalidAssignments?: Maybe<Scalars['JSON']>;
  /** temporary flag for the few weeks while we have both mturk pipelines running in the same time. once legacy mturk is deprecated this can be removed */
  isV2: Scalars['Boolean'];
  /**
   * How many workers have to agree in order for this task to validate successfully.
   *
   * When majorityScore === 1 no consensus validation will be performed
   *
   * When majorityScore > 1, the task will start with majorityScore workers and continue asking for more workers until majorityScore workers agree (up to the maxAllowedAssignments limit)
   */
  majorityScore: Scalars['Float'];
  /**
   * When majorityScore > 1 this field controls the maximum number of workers that will be added onto a task to attempt to get a majority.
   *
   * The task is considered failed if more workers are needed past this point
   */
  maxAllowedAssignments: Scalars['Float'];
  result?: Maybe<Scalars['JSON']>;
  stats?: Maybe<Scalars['JSON']>;
  status: MturkHitStatusEnum;
  task?: Maybe<Task>;
  taskDefinition?: Maybe<TaskDefinition>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  workers: Array<MturkHitWorkers>;
}

export interface MturkHitAssignmentList {
  AcceptTime?: Maybe<Scalars['String']>;
  ApprovalTime?: Maybe<Scalars['String']>;
  AssignmentId: Scalars['String'];
  AssignmentStatus?: Maybe<Scalars['String']>;
  AutoApprovalTime?: Maybe<Scalars['String']>;
  Reason?: Maybe<Scalars['String']>;
  SubmitTime?: Maybe<Scalars['String']>;
  WorkerId: Scalars['String'];
  data: Scalars['JSON'];
  weight?: Maybe<Scalars['Float']>;
}

export interface MturkHitAssignmentListInput {
  AcceptTime?: InputMaybe<Scalars['String']>;
  ApprovalTime?: InputMaybe<Scalars['String']>;
  AssignmentId?: InputMaybe<Scalars['String']>;
  AssignmentStatus?: InputMaybe<Scalars['String']>;
  AutoApprovalTime?: InputMaybe<Scalars['String']>;
  Reason?: InputMaybe<Scalars['String']>;
  SubmitTime?: InputMaybe<Scalars['String']>;
  WorkerId?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['JSON']>;
  weight?: InputMaybe<Scalars['Float']>;
}

export interface MturkHitFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<MturkHit>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface MturkHitInput {
  AssignmentDurationInSeconds?: InputMaybe<Scalars['Float']>;
  CreationTime?: InputMaybe<Scalars['String']>;
  Expiration?: InputMaybe<Scalars['DateTime']>;
  HITGroupId?: InputMaybe<Scalars['String']>;
  HITId?: InputMaybe<Scalars['String']>;
  HITTypeId?: InputMaybe<Scalars['String']>;
  MaxAssignments?: InputMaybe<Scalars['Float']>;
  Reward?: InputMaybe<Scalars['String']>;
  _id?: InputMaybe<Scalars['ObjectId']>;
  assignmentList?: InputMaybe<Array<MturkHitAssignmentListInput>>;
  config?: InputMaybe<Scalars['JSON']>;
  /** The full cost of this task, including amazon's cut */
  cost?: InputMaybe<Scalars['Float']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  empty?: InputMaybe<Scalars['Boolean']>;
  error?: InputMaybe<Scalars['String']>;
  invalidAssignments?: InputMaybe<Scalars['JSON']>;
  /** temporary flag for the few weeks while we have both mturk pipelines running in the same time. once legacy mturk is deprecated this can be removed */
  isV2?: InputMaybe<Scalars['Boolean']>;
  /**
   * How many workers have to agree in order for this task to validate successfully.
   *
   * When majorityScore === 1 no consensus validation will be performed
   *
   * When majorityScore > 1, the task will start with majorityScore workers and continue asking for more workers until majorityScore workers agree (up to the maxAllowedAssignments limit)
   */
  majorityScore?: InputMaybe<Scalars['Float']>;
  /**
   * When majorityScore > 1 this field controls the maximum number of workers that will be added onto a task to attempt to get a majority.
   *
   * The task is considered failed if more workers are needed past this point
   */
  maxAllowedAssignments?: InputMaybe<Scalars['Float']>;
  result?: InputMaybe<Scalars['JSON']>;
  stats?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<MturkHitStatusEnum>;
  task?: InputMaybe<Scalars['ObjectId']>;
  taskDefinition?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  workers?: InputMaybe<Array<MturkHitWorkersInput>>;
}

export enum MturkHitStatusEnum {
  Done = 'done',
  Error = 'error',
  Expired = 'expired',
  Processing = 'processing',
  Skip = 'skip'
}

export interface MturkHitWorkers {
  AssignmentId: Scalars['String'];
  WorkerId: Scalars['String'];
  bonus: Scalars['Float'];
  fullBonus: Scalars['Float'];
  info?: Maybe<Scalars['JSON']>;
  /**
   * When a worker sends us a message disputing some fields, and they turn out to be currect, we set isCorrect on the MturkMessage, and mark both the message and the worker as isConsolidated to show that these issues have overwritten the result
   *
   * NOTE: Consolidation is not yet implemented in mturk v2
   */
  isConsolidated?: Maybe<Scalars['Boolean']>;
  /** Feedback generated from the form-builder package that is used to display on the mturk feedback page. Every score reduction will be accompanied by an issue entry */
  issues: Array<Scalars['JSON']>;
  mturkWorker?: Maybe<MturkWorker>;
  rejected?: Maybe<Scalars['String']>;
  score: Scalars['Float'];
  skipped?: Maybe<Scalars['String']>;
}

export interface MturkHitWorkersInput {
  AssignmentId?: InputMaybe<Scalars['String']>;
  WorkerId?: InputMaybe<Scalars['String']>;
  bonus?: InputMaybe<Scalars['Float']>;
  fullBonus?: InputMaybe<Scalars['Float']>;
  info?: InputMaybe<Scalars['JSON']>;
  /**
   * When a worker sends us a message disputing some fields, and they turn out to be currect, we set isCorrect on the MturkMessage, and mark both the message and the worker as isConsolidated to show that these issues have overwritten the result
   *
   * NOTE: Consolidation is not yet implemented in mturk v2
   */
  isConsolidated?: InputMaybe<Scalars['Boolean']>;
  /** Feedback generated from the form-builder package that is used to display on the mturk feedback page. Every score reduction will be accompanied by an issue entry */
  issues?: InputMaybe<Array<Scalars['JSON']>>;
  mturkWorker?: InputMaybe<Scalars['ObjectId']>;
  rejected?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
  skipped?: InputMaybe<Scalars['String']>;
}

export interface MturkWorker {
  WorkerId: Scalars['String'];
  _id: Scalars['ObjectId'];
  attributes: Array<MturkWorkerAttributes>;
  createdDate?: Maybe<Scalars['DateTime']>;
  isBlocked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  qualifications: Array<MturkWorkerQualification>;
  qualificationsCount: Scalars['Float'];
  revokedQualifications: Array<MturkWorkerQualification>;
  revokedQualificationsCount: Scalars['Float'];
  stats?: Maybe<MturkWorkerStats>;
}

export interface MturkWorkerAttributes {
  _id: Scalars['ObjectId'];
  createdBy?: Maybe<User>;
  createdDate?: Maybe<Scalars['DateTime']>;
  type: Scalars['String'];
  value: Scalars['Float'];
}

export interface MturkWorkerAttributesInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
}

export interface MturkWorkerFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<MturkWorker>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface MturkWorkerInput {
  WorkerId?: InputMaybe<Scalars['String']>;
  _id?: InputMaybe<Scalars['ObjectId']>;
  attributes?: InputMaybe<Array<MturkWorkerAttributesInput>>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  isBlocked?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  qualifications?: InputMaybe<Array<MturkWorkerQualificationInput>>;
  qualificationsCount?: InputMaybe<Scalars['Float']>;
  revokedQualifications?: InputMaybe<Array<MturkWorkerQualificationInput>>;
  revokedQualificationsCount?: InputMaybe<Scalars['Float']>;
  stats?: InputMaybe<MturkWorkerStatsInput>;
}

export interface MturkWorkerQualification {
  GrantTime: Scalars['DateTime'];
  IntegerValue: Scalars['Float'];
  QualificationTypeId: Scalars['String'];
  Reason?: Maybe<Scalars['String']>;
}

export interface MturkWorkerQualificationInput {
  GrantTime?: InputMaybe<Scalars['DateTime']>;
  IntegerValue?: InputMaybe<Scalars['Float']>;
  QualificationTypeId?: InputMaybe<Scalars['String']>;
  Reason?: InputMaybe<Scalars['String']>;
}

export interface MturkWorkerStats {
  date: Scalars['DateTime'];
  oneMonth?: Maybe<MturkWorkerStatsOneMonth>;
  perTaskOneMonth: Array<MturkWorkerStatsPerTaskOneMonth>;
  perTaskThreeMonths: Array<MturkWorkerStatsPerTaskThreeMonths>;
  perTaskTotal: Array<MturkWorkerStatsPerTaskTotal>;
  threeMonths?: Maybe<MturkWorkerStatsThreeMonths>;
  total?: Maybe<MturkWorkerStatsTotal>;
}

export interface MturkWorkerStatsInput {
  date?: InputMaybe<Scalars['DateTime']>;
  oneMonth?: InputMaybe<MturkWorkerStatsOneMonthInput>;
  perTaskOneMonth?: InputMaybe<Array<MturkWorkerStatsPerTaskOneMonthInput>>;
  perTaskThreeMonths?: InputMaybe<Array<MturkWorkerStatsPerTaskThreeMonthsInput>>;
  perTaskTotal?: InputMaybe<Array<MturkWorkerStatsPerTaskTotalInput>>;
  threeMonths?: InputMaybe<MturkWorkerStatsThreeMonthsInput>;
  total?: InputMaybe<MturkWorkerStatsTotalInput>;
}

export interface MturkWorkerStatsOneMonth {
  averageBonus?: Maybe<Scalars['Float']>;
  averageIssues?: Maybe<Scalars['Float']>;
  averageScore?: Maybe<Scalars['Float']>;
  correctMessageRatio?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  totalBonus?: Maybe<Scalars['Float']>;
  totalCorrectMessages?: Maybe<Scalars['Float']>;
  totalFullBonus?: Maybe<Scalars['Float']>;
  totalIssues?: Maybe<Scalars['Float']>;
  totalMessages?: Maybe<Scalars['Float']>;
}

export interface MturkWorkerStatsOneMonthInput {
  averageBonus?: InputMaybe<Scalars['Float']>;
  averageIssues?: InputMaybe<Scalars['Float']>;
  averageScore?: InputMaybe<Scalars['Float']>;
  correctMessageRatio?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Float']>;
  totalBonus?: InputMaybe<Scalars['Float']>;
  totalCorrectMessages?: InputMaybe<Scalars['Float']>;
  totalFullBonus?: InputMaybe<Scalars['Float']>;
  totalIssues?: InputMaybe<Scalars['Float']>;
  totalMessages?: InputMaybe<Scalars['Float']>;
}

export interface MturkWorkerStatsPerTaskOneMonth {
  averageBonus?: Maybe<Scalars['Float']>;
  averageIssues?: Maybe<Scalars['Float']>;
  averageScore?: Maybe<Scalars['Float']>;
  correctMessageRatio?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  totalBonus?: Maybe<Scalars['Float']>;
  totalCorrectMessages?: Maybe<Scalars['Float']>;
  totalFullBonus?: Maybe<Scalars['Float']>;
  totalIssues?: Maybe<Scalars['Float']>;
  totalMessages?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
}

export interface MturkWorkerStatsPerTaskOneMonthInput {
  averageBonus?: InputMaybe<Scalars['Float']>;
  averageIssues?: InputMaybe<Scalars['Float']>;
  averageScore?: InputMaybe<Scalars['Float']>;
  correctMessageRatio?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Float']>;
  totalBonus?: InputMaybe<Scalars['Float']>;
  totalCorrectMessages?: InputMaybe<Scalars['Float']>;
  totalFullBonus?: InputMaybe<Scalars['Float']>;
  totalIssues?: InputMaybe<Scalars['Float']>;
  totalMessages?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
}

export interface MturkWorkerStatsPerTaskThreeMonths {
  averageBonus?: Maybe<Scalars['Float']>;
  averageIssues?: Maybe<Scalars['Float']>;
  averageScore?: Maybe<Scalars['Float']>;
  correctMessageRatio?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  totalBonus?: Maybe<Scalars['Float']>;
  totalCorrectMessages?: Maybe<Scalars['Float']>;
  totalFullBonus?: Maybe<Scalars['Float']>;
  totalIssues?: Maybe<Scalars['Float']>;
  totalMessages?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
}

export interface MturkWorkerStatsPerTaskThreeMonthsInput {
  averageBonus?: InputMaybe<Scalars['Float']>;
  averageIssues?: InputMaybe<Scalars['Float']>;
  averageScore?: InputMaybe<Scalars['Float']>;
  correctMessageRatio?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Float']>;
  totalBonus?: InputMaybe<Scalars['Float']>;
  totalCorrectMessages?: InputMaybe<Scalars['Float']>;
  totalFullBonus?: InputMaybe<Scalars['Float']>;
  totalIssues?: InputMaybe<Scalars['Float']>;
  totalMessages?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
}

export interface MturkWorkerStatsPerTaskTotal {
  averageBonus?: Maybe<Scalars['Float']>;
  averageIssues?: Maybe<Scalars['Float']>;
  averageScore?: Maybe<Scalars['Float']>;
  correctMessageRatio?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  totalBonus?: Maybe<Scalars['Float']>;
  totalCorrectMessages?: Maybe<Scalars['Float']>;
  totalFullBonus?: Maybe<Scalars['Float']>;
  totalIssues?: Maybe<Scalars['Float']>;
  totalMessages?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
}

export interface MturkWorkerStatsPerTaskTotalInput {
  averageBonus?: InputMaybe<Scalars['Float']>;
  averageIssues?: InputMaybe<Scalars['Float']>;
  averageScore?: InputMaybe<Scalars['Float']>;
  correctMessageRatio?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Float']>;
  totalBonus?: InputMaybe<Scalars['Float']>;
  totalCorrectMessages?: InputMaybe<Scalars['Float']>;
  totalFullBonus?: InputMaybe<Scalars['Float']>;
  totalIssues?: InputMaybe<Scalars['Float']>;
  totalMessages?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
}

export interface MturkWorkerStatsThreeMonths {
  averageBonus?: Maybe<Scalars['Float']>;
  averageIssues?: Maybe<Scalars['Float']>;
  averageScore?: Maybe<Scalars['Float']>;
  correctMessageRatio?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  totalBonus?: Maybe<Scalars['Float']>;
  totalCorrectMessages?: Maybe<Scalars['Float']>;
  totalFullBonus?: Maybe<Scalars['Float']>;
  totalIssues?: Maybe<Scalars['Float']>;
  totalMessages?: Maybe<Scalars['Float']>;
}

export interface MturkWorkerStatsThreeMonthsInput {
  averageBonus?: InputMaybe<Scalars['Float']>;
  averageIssues?: InputMaybe<Scalars['Float']>;
  averageScore?: InputMaybe<Scalars['Float']>;
  correctMessageRatio?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Float']>;
  totalBonus?: InputMaybe<Scalars['Float']>;
  totalCorrectMessages?: InputMaybe<Scalars['Float']>;
  totalFullBonus?: InputMaybe<Scalars['Float']>;
  totalIssues?: InputMaybe<Scalars['Float']>;
  totalMessages?: InputMaybe<Scalars['Float']>;
}

export interface MturkWorkerStatsTotal {
  averageBonus?: Maybe<Scalars['Float']>;
  averageIssues?: Maybe<Scalars['Float']>;
  averageScore?: Maybe<Scalars['Float']>;
  correctMessageRatio?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  totalBonus?: Maybe<Scalars['Float']>;
  totalCorrectMessages?: Maybe<Scalars['Float']>;
  totalFullBonus?: Maybe<Scalars['Float']>;
  totalIssues?: Maybe<Scalars['Float']>;
  totalMessages?: Maybe<Scalars['Float']>;
}

export interface MturkWorkerStatsTotalInput {
  averageBonus?: InputMaybe<Scalars['Float']>;
  averageIssues?: InputMaybe<Scalars['Float']>;
  averageScore?: InputMaybe<Scalars['Float']>;
  correctMessageRatio?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Float']>;
  totalBonus?: InputMaybe<Scalars['Float']>;
  totalCorrectMessages?: InputMaybe<Scalars['Float']>;
  totalFullBonus?: InputMaybe<Scalars['Float']>;
  totalIssues?: InputMaybe<Scalars['Float']>;
  totalMessages?: InputMaybe<Scalars['Float']>;
}

export interface Mutation {
  AcceptImages: AcceptImagesResponse;
  AddImageToProcessingQueue: AddImageToProcessingQueueResponse;
  Adp_createAttributeFiles: Adp_CreateAttributeFilesResponse;
  Adp_createHierarchyFile: Adp_CreateHierarchyFileResponse;
  AliasMapping_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  AliasMapping_create?: Maybe<AliasMapping>;
  AliasMapping_remove?: Maybe<AliasMapping>;
  AliasMapping_removeMany?: Maybe<Scalars['JSON']>;
  AliasMapping_update?: Maybe<AliasMapping>;
  AmazonProduct_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  AmazonProduct_create?: Maybe<AmazonProduct>;
  AmazonProduct_remove?: Maybe<AmazonProduct>;
  AmazonProduct_removeMany?: Maybe<Scalars['JSON']>;
  AmazonProduct_update?: Maybe<AmazonProduct>;
  AnalyticsClientFeedbackJiraIssue_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  AnalyticsClientFeedbackJiraIssue_create?: Maybe<AnalyticsClientFeedbackJiraIssue>;
  AnalyticsClientFeedbackJiraIssue_remove?: Maybe<AnalyticsClientFeedbackJiraIssue>;
  AnalyticsClientFeedbackJiraIssue_removeMany?: Maybe<Scalars['JSON']>;
  AnalyticsClientFeedbackJiraIssue_update?: Maybe<AnalyticsClientFeedbackJiraIssue>;
  AnalyticsClientFeedbackSpinsAttribute_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  AnalyticsClientFeedbackSpinsAttribute_create?: Maybe<AnalyticsClientFeedbackSpinsAttribute>;
  AnalyticsClientFeedbackSpinsAttribute_remove?: Maybe<AnalyticsClientFeedbackSpinsAttribute>;
  AnalyticsClientFeedbackSpinsAttribute_removeMany?: Maybe<Scalars['JSON']>;
  AnalyticsClientFeedbackSpinsAttribute_update?: Maybe<AnalyticsClientFeedbackSpinsAttribute>;
  AnalyticsClientFeedbackTrackerUpdate_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  AnalyticsClientFeedbackTrackerUpdate_create?: Maybe<AnalyticsClientFeedbackTrackerUpdate>;
  AnalyticsClientFeedbackTrackerUpdate_remove?: Maybe<AnalyticsClientFeedbackTrackerUpdate>;
  AnalyticsClientFeedbackTrackerUpdate_removeMany?: Maybe<Scalars['JSON']>;
  AnalyticsClientFeedbackTrackerUpdate_update?: Maybe<AnalyticsClientFeedbackTrackerUpdate>;
  AnalyticsOperationalKPI_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  AnalyticsOperationalKPI_create?: Maybe<AnalyticsOperationalKpi>;
  AnalyticsOperationalKPI_remove?: Maybe<AnalyticsOperationalKpi>;
  AnalyticsOperationalKPI_removeMany?: Maybe<Scalars['JSON']>;
  AnalyticsOperationalKPI_update?: Maybe<AnalyticsOperationalKpi>;
  AnalyticsProductCount_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  AnalyticsProductCount_create?: Maybe<AnalyticsProductCount>;
  AnalyticsProductCount_remove?: Maybe<AnalyticsProductCount>;
  AnalyticsProductCount_removeMany?: Maybe<Scalars['JSON']>;
  AnalyticsProductCount_update?: Maybe<AnalyticsProductCount>;
  AnalyticsQCSelfServe_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  AnalyticsQCSelfServe_create?: Maybe<AnalyticsQcSelfServe>;
  AnalyticsQCSelfServe_remove?: Maybe<AnalyticsQcSelfServe>;
  AnalyticsQCSelfServe_removeMany?: Maybe<Scalars['JSON']>;
  AnalyticsQCSelfServe_update?: Maybe<AnalyticsQcSelfServe>;
  ApertureAnnotation_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  ApertureAnnotation_create?: Maybe<ApertureAnnotation>;
  ApertureAnnotation_remove?: Maybe<ApertureAnnotation>;
  ApertureAnnotation_removeMany?: Maybe<Scalars['JSON']>;
  ApertureAnnotation_update?: Maybe<ApertureAnnotation>;
  AttributeSalesAssessmentRun: AttributeSalesAssessmentRunResponse;
  AutoNotifications_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  AutoNotifications_create?: Maybe<AutoNotifications>;
  AutoNotifications_remove?: Maybe<AutoNotifications>;
  AutoNotifications_removeMany?: Maybe<Scalars['JSON']>;
  AutoNotifications_update?: Maybe<AutoNotifications>;
  BrandReview_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  BrandReview_create?: Maybe<BrandReview>;
  BrandReview_remove?: Maybe<BrandReview>;
  BrandReview_removeMany?: Maybe<Scalars['JSON']>;
  BrandReview_update?: Maybe<BrandReview>;
  BuilderBatch_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  BuilderBatch_create?: Maybe<BuilderBatch>;
  BuilderBatch_remove?: Maybe<BuilderBatch>;
  BuilderBatch_removeMany?: Maybe<Scalars['JSON']>;
  BuilderBatch_update?: Maybe<BuilderBatch>;
  /** Triggers the endpoint for the ingredient checker service */
  CheckIngredients: CheckIngredients;
  CircanaBrandMapping_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  CircanaBrandMapping_create?: Maybe<CircanaBrandMapping>;
  CircanaBrandMapping_remove?: Maybe<CircanaBrandMapping>;
  CircanaBrandMapping_removeMany?: Maybe<Scalars['JSON']>;
  CircanaBrandMapping_update?: Maybe<CircanaBrandMapping>;
  CleansedData_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  CleansedData_create?: Maybe<CleansedData>;
  CleansedData_remove?: Maybe<CleansedData>;
  CleansedData_removeMany?: Maybe<Scalars['JSON']>;
  CleansedData_update?: Maybe<CleansedData>;
  ClientTrackerValue_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  ClientTrackerValue_create?: Maybe<ClientTrackerValue>;
  ClientTrackerValue_remove?: Maybe<ClientTrackerValue>;
  ClientTrackerValue_removeMany?: Maybe<Scalars['JSON']>;
  ClientTrackerValue_update?: Maybe<ClientTrackerValue>;
  ClientTrackerValue_upsert: ClientTrackerValueUpsertResponse;
  CompanySignupRequest_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  CompanySignupRequest_create?: Maybe<CompanySignupRequest>;
  CompanySignupRequest_remove?: Maybe<CompanySignupRequest>;
  CompanySignupRequest_removeMany?: Maybe<Scalars['JSON']>;
  CompanySignupRequest_update?: Maybe<CompanySignupRequest>;
  Company_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Company_create?: Maybe<Company>;
  Company_remove?: Maybe<Company>;
  Company_removeMany?: Maybe<Scalars['JSON']>;
  Company_setLogo: Company;
  Company_update?: Maybe<Company>;
  Config_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Config_create?: Maybe<Config>;
  Config_remove?: Maybe<Config>;
  Config_removeMany?: Maybe<Scalars['JSON']>;
  Config_update?: Maybe<Config>;
  CreateAdminToken?: Maybe<Scalars['String']>;
  DeleteHistory_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  DeleteHistory_create?: Maybe<DeleteHistory>;
  DeleteHistory_remove?: Maybe<DeleteHistory>;
  DeleteHistory_removeMany?: Maybe<Scalars['JSON']>;
  DeleteHistory_update?: Maybe<DeleteHistory>;
  DigitizationUpcScan_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  DigitizationUpcScan_create?: Maybe<DigitizationUpcScan>;
  DigitizationUpcScan_remove?: Maybe<DigitizationUpcScan>;
  DigitizationUpcScan_removeMany?: Maybe<Scalars['JSON']>;
  DigitizationUpcScan_update?: Maybe<DigitizationUpcScan>;
  DigitizationUpdate_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  DigitizationUpdate_create?: Maybe<DigitizationUpdate>;
  DigitizationUpdate_remove?: Maybe<DigitizationUpdate>;
  DigitizationUpdate_removeMany?: Maybe<Scalars['JSON']>;
  DigitizationUpdate_update?: Maybe<DigitizationUpdate>;
  DigitizationUserStatus_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  DigitizationUserStatus_create?: Maybe<DigitizationUserStatus>;
  DigitizationUserStatus_remove?: Maybe<DigitizationUserStatus>;
  DigitizationUserStatus_removeMany?: Maybe<Scalars['JSON']>;
  DigitizationUserStatus_update?: Maybe<DigitizationUserStatus>;
  /** Set a user's digitization app domain, and if needed them grant access */
  Digitization_grantUserAccess: DigitizationGrantUserAccessResult;
  Digitization_uploadImages: DigitizationUploadImagesResult;
  Digitization_uploadImages_finalize?: Maybe<DigitizationUploadImagesFinalizeResult>;
  Digitization_uploadUpcScans: DigitizationUpcScanResult;
  Digitization_uploadUpdates: DigitizationUploadUpdatesResult;
  Digitization_uploadUserStatus: UploadUserStatusResult;
  Domain_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Domain_cancelTrial?: Maybe<Domain>;
  Domain_create?: Maybe<Domain>;
  /**
   * If publicKey is not provided, a public + private key will be generated and returned
   *
   * The publicKey is saved under domain.sftp.publicKey
   *
   * The privateKey is not stored anywhere and cannot be retrieved again after creation
   */
  Domain_createSftpCredentials?: Maybe<CreateSftpCredentialsResult>;
  Domain_remove?: Maybe<Domain>;
  Domain_removeMany?: Maybe<Scalars['JSON']>;
  Domain_update?: Maybe<Domain>;
  FeatureFlagConfiguration_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  FeatureFlagConfiguration_create?: Maybe<FeatureFlagConfiguration>;
  FeatureFlagConfiguration_remove?: Maybe<FeatureFlagConfiguration>;
  FeatureFlagConfiguration_removeMany?: Maybe<Scalars['JSON']>;
  FeatureFlagConfiguration_update?: Maybe<FeatureFlagConfiguration>;
  /** Sets the enabled status for a list of feature flags, and returns the full list of flags with their status */
  FeatureFlags_set: Array<FeatureFlagInfo>;
  FormInstruction_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  FormInstruction_create?: Maybe<FormInstruction>;
  FormInstruction_remove?: Maybe<FormInstruction>;
  FormInstruction_removeMany?: Maybe<Scalars['JSON']>;
  FormInstruction_update?: Maybe<FormInstruction>;
  Form_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Form_create?: Maybe<Form>;
  Form_remove?: Maybe<Form>;
  Form_removeMany?: Maybe<Scalars['JSON']>;
  Form_update?: Maybe<Form>;
  FormulaResource_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  FormulaResource_create?: Maybe<FormulaResource>;
  FormulaResource_remove?: Maybe<FormulaResource>;
  FormulaResource_removeMany?: Maybe<Scalars['JSON']>;
  FormulaResource_update?: Maybe<FormulaResource>;
  Formula_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Formula_create?: Maybe<Formula>;
  Formula_remove?: Maybe<Formula>;
  Formula_removeMany?: Maybe<Scalars['JSON']>;
  Formula_update?: Maybe<Formula>;
  GS1TaxonomyMapping_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  GS1TaxonomyMapping_create?: Maybe<Gs1TaxonomyMapping>;
  GS1TaxonomyMapping_remove?: Maybe<Gs1TaxonomyMapping>;
  GS1TaxonomyMapping_removeMany?: Maybe<Scalars['JSON']>;
  GS1TaxonomyMapping_update?: Maybe<Gs1TaxonomyMapping>;
  GcpScriptLog_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  GcpScriptLog_create?: Maybe<GcpScriptLog>;
  GcpScriptLog_remove?: Maybe<GcpScriptLog>;
  GcpScriptLog_removeMany?: Maybe<Scalars['JSON']>;
  GcpScriptLog_update?: Maybe<GcpScriptLog>;
  HierarchyAllowedValues_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  HierarchyAllowedValues_create?: Maybe<HierarchyAllowedValues>;
  HierarchyAllowedValues_remove?: Maybe<HierarchyAllowedValues>;
  HierarchyAllowedValues_removeMany?: Maybe<Scalars['JSON']>;
  HierarchyAllowedValues_update?: Maybe<HierarchyAllowedValues>;
  HierarchyMapping_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  HierarchyMapping_create?: Maybe<HierarchyMapping>;
  HierarchyMapping_remove?: Maybe<HierarchyMapping>;
  HierarchyMapping_removeMany?: Maybe<Scalars['JSON']>;
  HierarchyMapping_update?: Maybe<HierarchyMapping>;
  Image_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Image_create?: Maybe<Image>;
  Image_remove?: Maybe<Image>;
  Image_removeMany?: Maybe<Scalars['JSON']>;
  Image_update?: Maybe<Image>;
  Ingestion_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Ingestion_create?: Maybe<Ingestion>;
  Ingestion_remove?: Maybe<Ingestion>;
  Ingestion_removeMany?: Maybe<Scalars['JSON']>;
  Ingestion_update?: Maybe<Ingestion>;
  Jwt_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Jwt_create?: Maybe<Jwt>;
  Jwt_remove?: Maybe<Jwt>;
  Jwt_removeMany?: Maybe<Scalars['JSON']>;
  Jwt_update?: Maybe<Jwt>;
  LockedValues_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  LockedValues_create?: Maybe<LockedValues>;
  LockedValues_remove?: Maybe<LockedValues>;
  LockedValues_removeMany?: Maybe<Scalars['JSON']>;
  LockedValues_update?: Maybe<LockedValues>;
  MaskedUpc_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  MaskedUpc_create?: Maybe<MaskedUpc>;
  MaskedUpc_remove?: Maybe<MaskedUpc>;
  MaskedUpc_removeMany?: Maybe<Scalars['JSON']>;
  MaskedUpc_update?: Maybe<MaskedUpc>;
  /**
   * Adds a tag name to the given records, along with updatedDate and updatedBy.
   *
   * Records that already carry the tag are left alone, so a batch is safe to retry. At most
   * 1000 ids may be given at a time — fetch ids in pages and call this
   * once per page.
   */
  ModelAddTag: ModelTagUpdateResult;
  /**
   * Removes a tag name from the given records, along with updatedDate and updatedBy.
   *
   * Every tags entry with that name is removed, including entries that also reference a Tag
   * document. Records that do not carry the tag are left alone, so a batch is safe to retry. At
   * most 1000 ids may be given at a time — fetch ids in pages and call
   * this once per page.
   */
  ModelRemoveTag: ModelTagUpdateResult;
  /** Update a single document by _id from the given model */
  ModelUpdateById?: Maybe<Scalars['JSON']>;
  MturkHIT_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  MturkHIT_create?: Maybe<MturkHit>;
  MturkHIT_remove?: Maybe<MturkHit>;
  MturkHIT_removeMany?: Maybe<Scalars['JSON']>;
  MturkHIT_update?: Maybe<MturkHit>;
  MturkWorker_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  MturkWorker_create?: Maybe<MturkWorker>;
  MturkWorker_remove?: Maybe<MturkWorker>;
  MturkWorker_removeMany?: Maybe<Scalars['JSON']>;
  MturkWorker_update?: Maybe<MturkWorker>;
  /** Update a single document by _id from the given model */
  MutateTaxonomy?: Maybe<Scalars['JSON']>;
  NfpAttributeMapping_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  NfpAttributeMapping_create?: Maybe<NfpAttributeMapping>;
  NfpAttributeMapping_remove?: Maybe<NfpAttributeMapping>;
  NfpAttributeMapping_removeMany?: Maybe<Scalars['JSON']>;
  NfpAttributeMapping_update?: Maybe<NfpAttributeMapping>;
  Period_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Period_create?: Maybe<Period>;
  Period_remove?: Maybe<Period>;
  Period_removeMany?: Maybe<Scalars['JSON']>;
  Period_update?: Maybe<Period>;
  PreProductionNtc_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  PreProductionNtc_create?: Maybe<PreProductionNtc>;
  PreProductionNtc_remove?: Maybe<PreProductionNtc>;
  PreProductionNtc_removeMany?: Maybe<Scalars['JSON']>;
  PreProductionNtc_update?: Maybe<PreProductionNtc>;
  PreProductionNtu_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  PreProductionNtu_create?: Maybe<PreProductionNtu>;
  PreProductionNtu_remove?: Maybe<PreProductionNtu>;
  PreProductionNtu_removeMany?: Maybe<Scalars['JSON']>;
  PreProductionNtu_update?: Maybe<PreProductionNtu>;
  PredictionOverride_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  PredictionOverride_create?: Maybe<PredictionOverride>;
  PredictionOverride_remove?: Maybe<PredictionOverride>;
  PredictionOverride_removeMany?: Maybe<Scalars['JSON']>;
  /**
   * Saves prediction overrides from the Prediction Override page. For each edited CleansedData
   * record the corrected value is written back to the record as a "predictions:override" data
   * point, and an audit row is upserted into the PredictionOverride collection.
   *
   * Predictions are stored per-ASIN, so an edit carrying an "asin" targets only that ASIN's data
   * point. An edit carrying none targets the record-level prediction, i.e. the one carrying no
   * ASIN.
   *
   * Besides subcategory and brand, the attributes predicted by the attribution agent (age,
   * flavor, form, ...) can be overridden the same way. The override must be one of the values
   * PredictionOverride_allowedValues lists for the attribute in the record's SPINS subcategory,
   * if it lists any. Subcategory edits are applied first, so an attribute is checked against a
   * subcategory saved alongside it.
   *
   * A subcategory edit must name a SPINS subcategory, and is also written to the matching Pv2s as
   * an "ops" hierarchy override: the Pv2s carrying the targeted ASIN, or for a record-level
   * prediction, the Pv2s sharing the record's GTIN. A Pv2 whose existing hierarchy override
   * outranks "ops" (i.e. "client") is left alone.
   *
   * Each edit is applied independently, so one bad entry does not discard the rest of the batch.
   */
  PredictionOverride_save: PredictionOverrideSaveResponse;
  PredictionOverride_update?: Maybe<PredictionOverride>;
  PrivateLabelPermanentProduct_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  PrivateLabelPermanentProduct_create?: Maybe<PrivateLabelPermanentProduct>;
  PrivateLabelPermanentProduct_remove?: Maybe<PrivateLabelPermanentProduct>;
  PrivateLabelPermanentProduct_removeMany?: Maybe<Scalars['JSON']>;
  PrivateLabelPermanentProduct_update?: Maybe<PrivateLabelPermanentProduct>;
  PrivateLabelProduct_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  PrivateLabelProduct_create?: Maybe<PrivateLabelProduct>;
  PrivateLabelProduct_remove?: Maybe<PrivateLabelProduct>;
  PrivateLabelProduct_removeMany?: Maybe<Scalars['JSON']>;
  PrivateLabelProduct_update?: Maybe<PrivateLabelProduct>;
  ProductEditRequest_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  ProductEditRequest_create?: Maybe<ProductEditRequest>;
  ProductEditRequest_remove?: Maybe<ProductEditRequest>;
  ProductEditRequest_removeMany?: Maybe<Scalars['JSON']>;
  ProductEditRequest_update?: Maybe<ProductEditRequest>;
  ProductSentToTarget_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  ProductSentToTarget_create?: Maybe<ProductSentToTarget>;
  ProductSentToTarget_remove?: Maybe<ProductSentToTarget>;
  ProductSentToTarget_removeMany?: Maybe<Scalars['JSON']>;
  ProductSentToTarget_update?: Maybe<ProductSentToTarget>;
  Pv2AttributeDefinition_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Pv2AttributeDefinition_create?: Maybe<Pv2AttributeDefinition>;
  Pv2AttributeDefinition_remove?: Maybe<Pv2AttributeDefinition>;
  Pv2AttributeDefinition_removeMany?: Maybe<Scalars['JSON']>;
  Pv2AttributeDefinition_update?: Maybe<Pv2AttributeDefinition>;
  Pv2CustomFieldConfig_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Pv2CustomFieldConfig_create?: Maybe<Pv2CustomFieldConfig>;
  Pv2CustomFieldConfig_remove?: Maybe<Pv2CustomFieldConfig>;
  Pv2CustomFieldConfig_removeMany?: Maybe<Scalars['JSON']>;
  Pv2CustomFieldConfig_update?: Maybe<Pv2CustomFieldConfig>;
  Pv2IngredientSetReviewStatus?: Maybe<Scalars['Boolean']>;
  Pv2Ingredient_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Pv2Ingredient_create?: Maybe<Pv2Ingredient>;
  Pv2Ingredient_remove?: Maybe<Pv2Ingredient>;
  Pv2Ingredient_removeMany?: Maybe<Scalars['JSON']>;
  Pv2Ingredient_update?: Maybe<Pv2Ingredient>;
  Pv2Verification_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Pv2Verification_create?: Maybe<Pv2Verification>;
  Pv2Verification_remove?: Maybe<Pv2Verification>;
  Pv2Verification_removeMany?: Maybe<Scalars['JSON']>;
  Pv2Verification_update?: Maybe<Pv2Verification>;
  Pv2_addTags?: Maybe<Scalars['JSON']>;
  Pv2_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Pv2_create?: Maybe<Pv2>;
  Pv2_discontinue?: Maybe<Scalars['JSON']>;
  /**
   * Creates asynchronously a batch for product data and optionally another one for images.
   *
   * When each batch completes/fails the user will be notified via email with a download link
   */
  Pv2_export?: Maybe<Scalars['Boolean']>;
  /**
   * Provides data for a product referenced by GTIN or Id.
   *
   * Returns either serialized JSON or a serialized CSV.
   */
  Pv2_export_single?: Maybe<Scalars['String']>;
  Pv2_remove?: Maybe<Pv2>;
  Pv2_removeMany?: Maybe<Scalars['JSON']>;
  Pv2_removeTags?: Maybe<Scalars['JSON']>;
  Pv2_setVerification: Array<Pv2>;
  /** Complete a product submission after all images have been uploaded */
  Pv2_submitProducts_submit?: Maybe<Scalars['Boolean']>;
  /** Prepares for product submission  */
  Pv2_submitProducts_uploadImages: Pv2SubmissionResult;
  Pv2_update?: Maybe<Pv2>;
  Pv2_updateEditableFields: Pv2;
  /**
   * Starts the QC Self-Serve analysis Cloud Run job and returns as soon as it has started. The
   * job rewrites the AnalyticsQCSelfServe collection; completion is visible via
   * QCSelfServeSummary.lastUpdatedDate.
   */
  QCSelfServeRunAnalysis: QcSelfServeRunAnalysisResponse;
  RawIngestionData_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  RawIngestionData_create?: Maybe<RawIngestionData>;
  RawIngestionData_remove?: Maybe<RawIngestionData>;
  RawIngestionData_removeMany?: Maybe<Scalars['JSON']>;
  RawIngestionData_update?: Maybe<RawIngestionData>;
  RawIngestionEvent_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  RawIngestionEvent_create?: Maybe<RawIngestionEvent>;
  RawIngestionEvent_remove?: Maybe<RawIngestionEvent>;
  RawIngestionEvent_removeMany?: Maybe<Scalars['JSON']>;
  RawIngestionEvent_update?: Maybe<RawIngestionEvent>;
  RejectImages: RejectImagesResponse;
  RestartService?: Maybe<Scalars['String']>;
  RetailItemsExtract_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  RetailItemsExtract_create?: Maybe<RetailItemsExtract>;
  RetailItemsExtract_remove?: Maybe<RetailItemsExtract>;
  RetailItemsExtract_removeMany?: Maybe<Scalars['JSON']>;
  RetailItemsExtract_update?: Maybe<RetailItemsExtract>;
  RetailerPrivateLabel_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  RetailerPrivateLabel_create?: Maybe<RetailerPrivateLabel>;
  RetailerPrivateLabel_remove?: Maybe<RetailerPrivateLabel>;
  RetailerPrivateLabel_removeMany?: Maybe<Scalars['JSON']>;
  RetailerPrivateLabel_update?: Maybe<RetailerPrivateLabel>;
  /** Triggers the cloud function for provided script args */
  RunScript: RunScript;
  Script_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Script_create?: Maybe<Script>;
  Script_remove?: Maybe<Script>;
  Script_removeMany?: Maybe<Scalars['JSON']>;
  Script_update?: Maybe<Script>;
  ServicesHeartbeat_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  ServicesHeartbeat_create?: Maybe<ServicesHeartbeat>;
  ServicesHeartbeat_remove?: Maybe<ServicesHeartbeat>;
  ServicesHeartbeat_removeMany?: Maybe<Scalars['JSON']>;
  ServicesHeartbeat_update?: Maybe<ServicesHeartbeat>;
  SnapshotTags_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  SnapshotTags_create?: Maybe<SnapshotTags>;
  SnapshotTags_remove?: Maybe<SnapshotTags>;
  SnapshotTags_removeMany?: Maybe<Scalars['JSON']>;
  SnapshotTags_update?: Maybe<SnapshotTags>;
  SpinsAttributeType_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  SpinsAttributeType_create?: Maybe<SpinsAttributeType>;
  SpinsAttributeType_remove?: Maybe<SpinsAttributeType>;
  SpinsAttributeType_removeMany?: Maybe<Scalars['JSON']>;
  SpinsAttributeType_update?: Maybe<SpinsAttributeType>;
  SpinsAttributes_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  SpinsAttributes_create?: Maybe<SpinsAttributes>;
  SpinsAttributes_remove?: Maybe<SpinsAttributes>;
  SpinsAttributes_removeMany?: Maybe<Scalars['JSON']>;
  SpinsAttributes_update?: Maybe<SpinsAttributes>;
  Store_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Store_create?: Maybe<Store>;
  Store_remove?: Maybe<Store>;
  Store_removeMany?: Maybe<Scalars['JSON']>;
  Store_update?: Maybe<Store>;
  Tag_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Tag_create?: Maybe<Tag>;
  Tag_remove?: Maybe<Tag>;
  Tag_removeMany?: Maybe<Scalars['JSON']>;
  Tag_update?: Maybe<Tag>;
  TaskDefinition_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  TaskDefinition_create?: Maybe<TaskDefinition>;
  TaskDefinition_remove?: Maybe<TaskDefinition>;
  TaskDefinition_removeMany?: Maybe<Scalars['JSON']>;
  TaskDefinition_update?: Maybe<TaskDefinition>;
  Task_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Task_assign: Task;
  Task_create?: Maybe<Task>;
  Task_remove?: Maybe<Task>;
  Task_removeMany?: Maybe<Scalars['JSON']>;
  /** Re-publishes the tasker PubSub message for the Task's *current* status, without changing the status. Used to retry a task whose error was recorded but which is not in an "error" status, once the underlying issue has been addressed. */
  Task_retrigger: Task;
  Task_submit: Task;
  Task_update?: Maybe<Task>;
  Taxonomy_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Taxonomy_create?: Maybe<Taxonomy>;
  Taxonomy_remove?: Maybe<Taxonomy>;
  Taxonomy_removeMany?: Maybe<Scalars['JSON']>;
  Taxonomy_update?: Maybe<Taxonomy>;
  Team_editUser: Domain;
  Team_inviteUserToDomains: Array<Maybe<Domain>>;
  /** Revoke domain invitations for a given user */
  Team_removeUserFromDomains?: Maybe<Array<Maybe<Domain>>>;
  Team_resendInvite: Array<Domain>;
  Team_userAcceptDomainInvite?: Maybe<Array<Maybe<Domain>>>;
  TransformerExpression_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  TransformerExpression_create?: Maybe<TransformerExpression>;
  TransformerExpression_remove?: Maybe<TransformerExpression>;
  TransformerExpression_removeMany?: Maybe<Scalars['JSON']>;
  TransformerExpression_update?: Maybe<TransformerExpression>;
  TransformerResource_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  TransformerResource_create?: Maybe<TransformerResource>;
  TransformerResource_remove?: Maybe<TransformerResource>;
  TransformerResource_removeMany?: Maybe<Scalars['JSON']>;
  TransformerResource_update?: Maybe<TransformerResource>;
  /**
   * Queues a run of the builder recompute Dataflow pipeline via its Airflow DAG. Airflow serializes
   * the runs: only one recompute executes at a time and the rest queue behind it.
   *
   * Omit pv2Query to process every Pv2, and omit formulaIds to run every Pv2 middleware formula.
   */
  TriggerBuilderRecompute: TriggerBuilderRecompute;
  /** Deletes the content of a collection */
  TruncateCollection?: Maybe<Scalars['String']>;
  /** Reset all associated Pv2 priorities for uploaded images via admin-v2 */
  UpdatePv2sForUploadedImages: UpdatePv2sForUploadedImagesResult;
  /** Returns path for the uploaded file */
  UploadFile: UploadFile;
  /** Upload processed images for admin-v2 */
  UploadProcessedImages: UploadProcessedImagesResult;
  /** Returns the public url in s3 for the uploaded asset */
  UploadPublicAsset: Scalars['String'];
  UserBatch_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  UserBatch_create?: Maybe<UserBatch>;
  UserBatch_remove?: Maybe<UserBatch>;
  UserBatch_removeMany?: Maybe<Scalars['JSON']>;
  UserBatch_update?: Maybe<UserBatch>;
  UserSearch_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  UserSearch_create?: Maybe<UserSearch>;
  UserSearch_remove?: Maybe<UserSearch>;
  UserSearch_removeMany?: Maybe<Scalars['JSON']>;
  UserSearch_update?: Maybe<UserSearch>;
  User_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  User_create?: Maybe<User>;
  User_remove?: Maybe<User>;
  User_removeMany?: Maybe<Scalars['JSON']>;
  User_setAvatar?: Maybe<User>;
  User_update?: Maybe<User>;
  Whitelist_aggregate?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  Whitelist_create?: Maybe<Whitelist>;
  Whitelist_remove?: Maybe<Whitelist>;
  Whitelist_removeMany?: Maybe<Scalars['JSON']>;
  Whitelist_update?: Maybe<Whitelist>;
  createS3PresignedImageProcessingPutUrl: S3PresignedPutObjectUrl;
  createTasks?: Maybe<Scalars['JSON']>;
  generateJwt?: Maybe<LoginResult>;
  login?: Maybe<LoginResult>;
  loginAsUser?: Maybe<LoginResult>;
  register?: Maybe<Session>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  resetPasswordUpdate?: Maybe<User>;
}


export interface MutationAcceptImagesArgs {
  imageProcessingQueueAcceptInput: Array<ImageProcessingQueueAcceptInput>;
}


export interface MutationAddImageToProcessingQueueArgs {
  addImageToProcessingQueueInput: Array<AddImageToProcessingQueueInput>;
}


export interface MutationAliasMapping_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationAliasMapping_CreateArgs {
  data: AliasMappingInput;
}


export interface MutationAliasMapping_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationAliasMapping_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationAliasMapping_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: AliasMappingInput;
}


export interface MutationAmazonProduct_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationAmazonProduct_CreateArgs {
  data: AmazonProductInput;
}


export interface MutationAmazonProduct_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationAmazonProduct_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationAmazonProduct_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: AmazonProductInput;
}


export interface MutationAnalyticsClientFeedbackJiraIssue_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationAnalyticsClientFeedbackJiraIssue_CreateArgs {
  data: AnalyticsClientFeedbackJiraIssueInput;
}


export interface MutationAnalyticsClientFeedbackJiraIssue_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationAnalyticsClientFeedbackJiraIssue_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationAnalyticsClientFeedbackJiraIssue_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: AnalyticsClientFeedbackJiraIssueInput;
}


export interface MutationAnalyticsClientFeedbackSpinsAttribute_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationAnalyticsClientFeedbackSpinsAttribute_CreateArgs {
  data: AnalyticsClientFeedbackSpinsAttributeInput;
}


export interface MutationAnalyticsClientFeedbackSpinsAttribute_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationAnalyticsClientFeedbackSpinsAttribute_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationAnalyticsClientFeedbackSpinsAttribute_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: AnalyticsClientFeedbackSpinsAttributeInput;
}


export interface MutationAnalyticsClientFeedbackTrackerUpdate_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationAnalyticsClientFeedbackTrackerUpdate_CreateArgs {
  data: AnalyticsClientFeedbackTrackerUpdateInput;
}


export interface MutationAnalyticsClientFeedbackTrackerUpdate_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationAnalyticsClientFeedbackTrackerUpdate_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationAnalyticsClientFeedbackTrackerUpdate_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: AnalyticsClientFeedbackTrackerUpdateInput;
}


export interface MutationAnalyticsOperationalKpi_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationAnalyticsOperationalKpi_CreateArgs {
  data: AnalyticsOperationalKpiInput;
}


export interface MutationAnalyticsOperationalKpi_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationAnalyticsOperationalKpi_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationAnalyticsOperationalKpi_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: AnalyticsOperationalKpiInput;
}


export interface MutationAnalyticsProductCount_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationAnalyticsProductCount_CreateArgs {
  data: AnalyticsProductCountInput;
}


export interface MutationAnalyticsProductCount_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationAnalyticsProductCount_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationAnalyticsProductCount_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: AnalyticsProductCountInput;
}


export interface MutationAnalyticsQcSelfServe_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationAnalyticsQcSelfServe_CreateArgs {
  data: AnalyticsQcSelfServeInput;
}


export interface MutationAnalyticsQcSelfServe_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationAnalyticsQcSelfServe_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationAnalyticsQcSelfServe_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: AnalyticsQcSelfServeInput;
}


export interface MutationApertureAnnotation_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationApertureAnnotation_CreateArgs {
  data: ApertureAnnotationInput;
}


export interface MutationApertureAnnotation_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationApertureAnnotation_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationApertureAnnotation_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: ApertureAnnotationInput;
}


export interface MutationAttributeSalesAssessmentRunArgs {
  builderBatchId: Scalars['String'];
  reportRunId: Scalars['String'];
}


export interface MutationAutoNotifications_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationAutoNotifications_CreateArgs {
  data: AutoNotificationsInput;
}


export interface MutationAutoNotifications_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationAutoNotifications_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationAutoNotifications_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: AutoNotificationsInput;
}


export interface MutationBrandReview_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationBrandReview_CreateArgs {
  data: BrandReviewInput;
}


export interface MutationBrandReview_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationBrandReview_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationBrandReview_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: BrandReviewInput;
}


export interface MutationBuilderBatch_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationBuilderBatch_CreateArgs {
  data: BuilderBatchInput;
}


export interface MutationBuilderBatch_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationBuilderBatch_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationBuilderBatch_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: BuilderBatchInput;
}


export interface MutationCheckIngredientsArgs {
  products: Scalars['JSON'];
  searchId?: InputMaybe<Scalars['String']>;
}


export interface MutationCircanaBrandMapping_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationCircanaBrandMapping_CreateArgs {
  data: CircanaBrandMappingInput;
}


export interface MutationCircanaBrandMapping_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationCircanaBrandMapping_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationCircanaBrandMapping_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: CircanaBrandMappingInput;
}


export interface MutationCleansedData_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationCleansedData_CreateArgs {
  data: CleansedDataInput;
}


export interface MutationCleansedData_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationCleansedData_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationCleansedData_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: CleansedDataInput;
}


export interface MutationClientTrackerValue_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationClientTrackerValue_CreateArgs {
  data: ClientTrackerValueInput;
}


export interface MutationClientTrackerValue_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationClientTrackerValue_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationClientTrackerValue_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: ClientTrackerValueInput;
}


export interface MutationClientTrackerValue_UpsertArgs {
  data: ClientTrackerValueUpsertInput;
}


export interface MutationCompanySignupRequest_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationCompanySignupRequest_CreateArgs {
  data: CompanySignupRequestInput;
}


export interface MutationCompanySignupRequest_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationCompanySignupRequest_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationCompanySignupRequest_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: CompanySignupRequestInput;
}


export interface MutationCompany_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationCompany_CreateArgs {
  data: CompanyInput;
}


export interface MutationCompany_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationCompany_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationCompany_SetLogoArgs {
  companyId: Scalars['ObjectId'];
  logo: Scalars['Upload'];
}


export interface MutationCompany_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: CompanyInput;
}


export interface MutationConfig_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationConfig_CreateArgs {
  data: ConfigInput;
}


export interface MutationConfig_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationConfig_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationConfig_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: ConfigInput;
}


export interface MutationDeleteHistory_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationDeleteHistory_CreateArgs {
  data: DeleteHistoryInput;
}


export interface MutationDeleteHistory_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationDeleteHistory_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationDeleteHistory_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: DeleteHistoryInput;
}


export interface MutationDigitizationUpcScan_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationDigitizationUpcScan_CreateArgs {
  data: DigitizationUpcScanInput;
}


export interface MutationDigitizationUpcScan_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationDigitizationUpcScan_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationDigitizationUpcScan_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: DigitizationUpcScanInput;
}


export interface MutationDigitizationUpdate_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationDigitizationUpdate_CreateArgs {
  data: DigitizationUpdateInput;
}


export interface MutationDigitizationUpdate_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationDigitizationUpdate_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationDigitizationUpdate_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: DigitizationUpdateInput;
}


export interface MutationDigitizationUserStatus_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationDigitizationUserStatus_CreateArgs {
  data: DigitizationUserStatusInput;
}


export interface MutationDigitizationUserStatus_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationDigitizationUserStatus_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationDigitizationUserStatus_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: DigitizationUserStatusInput;
}


export interface MutationDigitization_GrantUserAccessArgs {
  domainId: Scalars['ObjectId'];
  userId: Scalars['ObjectId'];
}


export interface MutationDigitization_UploadImagesArgs {
  images: Array<DigitizationUploadImagesItemInput>;
  name?: InputMaybe<Scalars['String']>;
  timestamp: Scalars['String'];
  upc: Scalars['String'];
}


export interface MutationDigitization_UploadImages_FinalizeArgs {
  submissionId: Scalars['String'];
}


export interface MutationDigitization_UploadUpcScansArgs {
  list: Array<DigitizationUploadUpcScansInput>;
}


export interface MutationDigitization_UploadUpdatesArgs {
  list: Array<InputMaybe<Scalars['JSON']>>;
}


export interface MutationDigitization_UploadUserStatusArgs {
  data: UserStatusInput;
}


export interface MutationDomain_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationDomain_CancelTrialArgs {
  domainId: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
}


export interface MutationDomain_CreateArgs {
  data: DomainInput;
}


export interface MutationDomain_CreateSftpCredentialsArgs {
  domainId: Scalars['ObjectId'];
  publicKey?: InputMaybe<Scalars['String']>;
}


export interface MutationDomain_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationDomain_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationDomain_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: DomainInput;
}


export interface MutationFeatureFlagConfiguration_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationFeatureFlagConfiguration_CreateArgs {
  data: FeatureFlagConfigurationInput;
}


export interface MutationFeatureFlagConfiguration_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationFeatureFlagConfiguration_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationFeatureFlagConfiguration_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: FeatureFlagConfigurationInput;
}


export interface MutationFeatureFlags_SetArgs {
  flags: Array<FeatureFlags_Set_FlagInput>;
}


export interface MutationFormInstruction_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationFormInstruction_CreateArgs {
  data: FormInstructionInput;
}


export interface MutationFormInstruction_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationFormInstruction_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationFormInstruction_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: FormInstructionInput;
}


export interface MutationForm_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationForm_CreateArgs {
  data: FormInput;
}


export interface MutationForm_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationForm_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationForm_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: FormInput;
}


export interface MutationFormulaResource_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationFormulaResource_CreateArgs {
  data: FormulaResourceInput;
}


export interface MutationFormulaResource_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationFormulaResource_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationFormulaResource_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: FormulaResourceInput;
}


export interface MutationFormula_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationFormula_CreateArgs {
  data: FormulaInput;
}


export interface MutationFormula_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationFormula_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationFormula_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: FormulaInput;
}


export interface MutationGs1TaxonomyMapping_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationGs1TaxonomyMapping_CreateArgs {
  data: Gs1TaxonomyMappingInput;
}


export interface MutationGs1TaxonomyMapping_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationGs1TaxonomyMapping_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationGs1TaxonomyMapping_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: Gs1TaxonomyMappingInput;
}


export interface MutationGcpScriptLog_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationGcpScriptLog_CreateArgs {
  data: GcpScriptLogInput;
}


export interface MutationGcpScriptLog_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationGcpScriptLog_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationGcpScriptLog_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: GcpScriptLogInput;
}


export interface MutationHierarchyAllowedValues_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationHierarchyAllowedValues_CreateArgs {
  data: HierarchyAllowedValuesInput;
}


export interface MutationHierarchyAllowedValues_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationHierarchyAllowedValues_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationHierarchyAllowedValues_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: HierarchyAllowedValuesInput;
}


export interface MutationHierarchyMapping_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationHierarchyMapping_CreateArgs {
  data: HierarchyMappingInput;
}


export interface MutationHierarchyMapping_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationHierarchyMapping_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationHierarchyMapping_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: HierarchyMappingInput;
}


export interface MutationImage_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationImage_CreateArgs {
  data: ImageInput;
  imageFile: Scalars['Upload'];
}


export interface MutationImage_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationImage_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationImage_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: ImageInput;
}


export interface MutationIngestion_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationIngestion_CreateArgs {
  data: IngestionInput;
}


export interface MutationIngestion_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationIngestion_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationIngestion_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: IngestionInput;
}


export interface MutationJwt_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationJwt_CreateArgs {
  data: JwtInput;
}


export interface MutationJwt_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationJwt_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationJwt_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: JwtInput;
}


export interface MutationLockedValues_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationLockedValues_CreateArgs {
  data: LockedValuesInput;
}


export interface MutationLockedValues_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationLockedValues_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationLockedValues_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: LockedValuesInput;
}


export interface MutationMaskedUpc_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationMaskedUpc_CreateArgs {
  data: MaskedUpcInput;
}


export interface MutationMaskedUpc_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationMaskedUpc_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationMaskedUpc_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: MaskedUpcInput;
}


export interface MutationModelAddTagArgs {
  ids: Array<Scalars['ObjectId']>;
  model: ModelNameEnum;
  name: Scalars['String'];
}


export interface MutationModelRemoveTagArgs {
  ids: Array<Scalars['ObjectId']>;
  model: ModelNameEnum;
  name: Scalars['String'];
}


export interface MutationModelUpdateByIdArgs {
  data: Scalars['JSON'];
  id: Scalars['ObjectId'];
  model: ModelNameEnum;
}


export interface MutationMturkHit_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationMturkHit_CreateArgs {
  data: MturkHitInput;
}


export interface MutationMturkHit_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationMturkHit_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationMturkHit_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: MturkHitInput;
}


export interface MutationMturkWorker_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationMturkWorker_CreateArgs {
  data: MturkWorkerInput;
}


export interface MutationMturkWorker_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationMturkWorker_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationMturkWorker_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: MturkWorkerInput;
}


export interface MutationMutateTaxonomyArgs {
  payload: Array<TaxonomyActionsInput>;
}


export interface MutationNfpAttributeMapping_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationNfpAttributeMapping_CreateArgs {
  data: NfpAttributeMappingInput;
}


export interface MutationNfpAttributeMapping_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationNfpAttributeMapping_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationNfpAttributeMapping_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: NfpAttributeMappingInput;
}


export interface MutationPeriod_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationPeriod_CreateArgs {
  data: PeriodInput;
}


export interface MutationPeriod_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationPeriod_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationPeriod_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: PeriodInput;
}


export interface MutationPreProductionNtc_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationPreProductionNtc_CreateArgs {
  data: PreProductionNtcInput;
}


export interface MutationPreProductionNtc_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationPreProductionNtc_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationPreProductionNtc_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: PreProductionNtcInput;
}


export interface MutationPreProductionNtu_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationPreProductionNtu_CreateArgs {
  data: PreProductionNtuInput;
}


export interface MutationPreProductionNtu_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationPreProductionNtu_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationPreProductionNtu_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: PreProductionNtuInput;
}


export interface MutationPredictionOverride_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationPredictionOverride_CreateArgs {
  data: PredictionOverrideInput;
}


export interface MutationPredictionOverride_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationPredictionOverride_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationPredictionOverride_SaveArgs {
  data: Array<PredictionOverrideSaveInput>;
}


export interface MutationPredictionOverride_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: PredictionOverrideInput;
}


export interface MutationPrivateLabelPermanentProduct_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationPrivateLabelPermanentProduct_CreateArgs {
  data: PrivateLabelPermanentProductInput;
}


export interface MutationPrivateLabelPermanentProduct_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationPrivateLabelPermanentProduct_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationPrivateLabelPermanentProduct_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: PrivateLabelPermanentProductInput;
}


export interface MutationPrivateLabelProduct_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationPrivateLabelProduct_CreateArgs {
  data: PrivateLabelProductInput;
}


export interface MutationPrivateLabelProduct_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationPrivateLabelProduct_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationPrivateLabelProduct_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: PrivateLabelProductInput;
}


export interface MutationProductEditRequest_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationProductEditRequest_CreateArgs {
  data: ProductEditRequestInput;
}


export interface MutationProductEditRequest_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationProductEditRequest_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationProductEditRequest_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: ProductEditRequestInput;
}


export interface MutationProductSentToTarget_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationProductSentToTarget_CreateArgs {
  data: ProductSentToTargetInput;
}


export interface MutationProductSentToTarget_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationProductSentToTarget_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationProductSentToTarget_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: ProductSentToTargetInput;
}


export interface MutationPv2AttributeDefinition_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationPv2AttributeDefinition_CreateArgs {
  data: Pv2AttributeDefinitionInput;
}


export interface MutationPv2AttributeDefinition_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationPv2AttributeDefinition_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationPv2AttributeDefinition_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: Pv2AttributeDefinitionInput;
}


export interface MutationPv2CustomFieldConfig_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationPv2CustomFieldConfig_CreateArgs {
  data: Pv2CustomFieldConfigInput;
}


export interface MutationPv2CustomFieldConfig_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationPv2CustomFieldConfig_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationPv2CustomFieldConfig_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: Pv2CustomFieldConfigInput;
}


export interface MutationPv2IngredientSetReviewStatusArgs {
  id: Scalars['String'];
  status: IngredientReviewStatusEnum;
}


export interface MutationPv2Ingredient_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationPv2Ingredient_CreateArgs {
  data: Pv2IngredientInput;
}


export interface MutationPv2Ingredient_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationPv2Ingredient_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationPv2Ingredient_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: Pv2IngredientInput;
}


export interface MutationPv2Verification_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationPv2Verification_CreateArgs {
  data: Pv2VerificationInput;
}


export interface MutationPv2Verification_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationPv2Verification_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationPv2Verification_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: Pv2VerificationInput;
}


export interface MutationPv2_AddTagsArgs {
  productIds: Array<Scalars['ObjectId']>;
  tags: Array<InputMaybe<TagStructInput>>;
}


export interface MutationPv2_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationPv2_CreateArgs {
  data: Pv2Input;
}


export interface MutationPv2_DiscontinueArgs {
  discontinued: Scalars['Boolean'];
  productIds: Array<InputMaybe<Scalars['ObjectId']>>;
}


export interface MutationPv2_ExportArgs {
  all?: InputMaybe<Scalars['Boolean']>;
  filetype?: InputMaybe<Pv2ExportFileTypeEnum>;
  gtins?: InputMaybe<Array<Scalars['String']>>;
  images?: InputMaybe<Array<Pv2ExportImageTypeEnum>>;
  name?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  sections?: InputMaybe<Array<Scalars['String']>>;
  urlFormat?: InputMaybe<Pv2ExportUrlFormatTypeEnum>;
}


export interface MutationPv2_Export_SingleArgs {
  filetype?: InputMaybe<Pv2ExportFileTypeEnum>;
  gtin?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ObjectId']>;
}


export interface MutationPv2_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationPv2_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationPv2_RemoveTagsArgs {
  productIds: Array<Scalars['ObjectId']>;
  tagIds: Array<Scalars['ObjectId']>;
}


export interface MutationPv2_SetVerificationArgs {
  productIds: Array<Scalars['ObjectId']>;
  upToDate: Scalars['Boolean'];
}


export interface MutationPv2_SubmitProducts_SubmitArgs {
  submissionId: Scalars['String'];
}


export interface MutationPv2_SubmitProducts_UploadImagesArgs {
  products: Array<Pv2ProductSubmission>;
  upcStandardizeOptions?: InputMaybe<UpcStandardizeOptions>;
}


export interface MutationPv2_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: Pv2Input;
}


export interface MutationPv2_UpdateEditableFieldsArgs {
  fields: Array<Pv2EditableFieldInput>;
  productId: Scalars['ObjectId'];
}


export interface MutationRawIngestionData_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationRawIngestionData_CreateArgs {
  data: RawIngestionDataInput;
}


export interface MutationRawIngestionData_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationRawIngestionData_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationRawIngestionData_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: RawIngestionDataInput;
}


export interface MutationRawIngestionEvent_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationRawIngestionEvent_CreateArgs {
  data: RawIngestionEventInput;
}


export interface MutationRawIngestionEvent_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationRawIngestionEvent_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationRawIngestionEvent_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: RawIngestionEventInput;
}


export interface MutationRejectImagesArgs {
  imageIds: Array<Scalars['String']>;
  processingPriority?: InputMaybe<Scalars['Int']>;
  rejectionReason: ImageRejectionReasonEnum;
}


export interface MutationRestartServiceArgs {
  serviceName: ServiceNameEnum;
}


export interface MutationRetailItemsExtract_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationRetailItemsExtract_CreateArgs {
  data: RetailItemsExtractInput;
}


export interface MutationRetailItemsExtract_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationRetailItemsExtract_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationRetailItemsExtract_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: RetailItemsExtractInput;
}


export interface MutationRetailerPrivateLabel_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationRetailerPrivateLabel_CreateArgs {
  data: RetailerPrivateLabelInput;
}


export interface MutationRetailerPrivateLabel_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationRetailerPrivateLabel_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationRetailerPrivateLabel_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: RetailerPrivateLabelInput;
}


export interface MutationRunScriptArgs {
  runId: Scalars['String'];
  scriptArgs: Scalars['JSON'];
  scriptName: ScriptKey;
}


export interface MutationScript_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationScript_CreateArgs {
  data: ScriptInput;
}


export interface MutationScript_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationScript_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationScript_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: ScriptInput;
}


export interface MutationServicesHeartbeat_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationServicesHeartbeat_CreateArgs {
  data: ServicesHeartbeatInput;
}


export interface MutationServicesHeartbeat_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationServicesHeartbeat_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationServicesHeartbeat_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: ServicesHeartbeatInput;
}


export interface MutationSnapshotTags_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationSnapshotTags_CreateArgs {
  data: SnapshotTagsInput;
}


export interface MutationSnapshotTags_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationSnapshotTags_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationSnapshotTags_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: SnapshotTagsInput;
}


export interface MutationSpinsAttributeType_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationSpinsAttributeType_CreateArgs {
  data: SpinsAttributeTypeInput;
}


export interface MutationSpinsAttributeType_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationSpinsAttributeType_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationSpinsAttributeType_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: SpinsAttributeTypeInput;
}


export interface MutationSpinsAttributes_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationSpinsAttributes_CreateArgs {
  data: SpinsAttributesInput;
}


export interface MutationSpinsAttributes_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationSpinsAttributes_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationSpinsAttributes_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: SpinsAttributesInput;
}


export interface MutationStore_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationStore_CreateArgs {
  data: StoreInput;
}


export interface MutationStore_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationStore_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationStore_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: StoreInput;
}


export interface MutationTag_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationTag_CreateArgs {
  data: TagInput;
}


export interface MutationTag_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationTag_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationTag_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: TagInput;
}


export interface MutationTaskDefinition_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationTaskDefinition_CreateArgs {
  data: TaskDefinitionInput;
}


export interface MutationTaskDefinition_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationTaskDefinition_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationTaskDefinition_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: TaskDefinitionInput;
}


export interface MutationTask_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationTask_AssignArgs {
  id: Scalars['ObjectId'];
  unassign?: InputMaybe<Scalars['Boolean']>;
}


export interface MutationTask_CreateArgs {
  data: TaskInput;
}


export interface MutationTask_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationTask_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationTask_RetriggerArgs {
  id: Scalars['ObjectId'];
}


export interface MutationTask_SubmitArgs {
  error?: InputMaybe<Scalars['String']>;
  errorCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ObjectId'];
  result?: InputMaybe<Scalars['JSON']>;
}


export interface MutationTask_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: TaskInput;
}


export interface MutationTaxonomy_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationTaxonomy_CreateArgs {
  data: TaxonomyInput;
}


export interface MutationTaxonomy_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationTaxonomy_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationTaxonomy_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: TaxonomyInput;
}


export interface MutationTeam_EditUserArgs {
  abilities?: InputMaybe<Array<DomainUserAbilitiesEnum>>;
  domainId: Scalars['ObjectId'];
  role: DomainUserRoleEnum;
  userId: Scalars['ObjectId'];
}


export interface MutationTeam_InviteUserToDomainsArgs {
  abilities?: InputMaybe<Array<DomainUserAbilitiesEnum>>;
  domainIds: Array<Scalars['ObjectId']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  role: DomainUserRoleEnum;
}


export interface MutationTeam_RemoveUserFromDomainsArgs {
  domainIds: Array<Scalars['ObjectId']>;
  userId: Scalars['ObjectId'];
}


export interface MutationTeam_ResendInviteArgs {
  userId: Scalars['ObjectId'];
}


export interface MutationTeam_UserAcceptDomainInviteArgs {
  inviteCode: Scalars['String'];
}


export interface MutationTransformerExpression_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationTransformerExpression_CreateArgs {
  data: TransformerExpressionInput;
}


export interface MutationTransformerExpression_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationTransformerExpression_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationTransformerExpression_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: TransformerExpressionInput;
}


export interface MutationTransformerResource_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationTransformerResource_CreateArgs {
  data: TransformerResourceInput;
}


export interface MutationTransformerResource_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationTransformerResource_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationTransformerResource_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: TransformerResourceInput;
}


export interface MutationTriggerBuilderRecomputeArgs {
  formulaIds?: InputMaybe<Array<Scalars['String']>>;
  pv2Query?: InputMaybe<Scalars['String']>;
  reportSuffix?: InputMaybe<Scalars['String']>;
  requestId: Scalars['String'];
  runDescription: Scalars['String'];
  saveComputationToPv2: Scalars['Boolean'];
}


export interface MutationTruncateCollectionArgs {
  collectionName: Scalars['String'];
}


export interface MutationUpdatePv2sForUploadedImagesArgs {
  imageIds?: InputMaybe<Array<Scalars['ObjectId']>>;
}


export interface MutationUploadFileArgs {
  bucketSubdirectory: Scalars['String'];
  fileContents: Scalars['Upload'];
  fileName: Scalars['String'];
}


export interface MutationUploadProcessedImagesArgs {
  fileName: Scalars['String'];
}


export interface MutationUploadPublicAssetArgs {
  addTimestamp?: InputMaybe<Scalars['Boolean']>;
  file: Scalars['Upload'];
  s3Key: Scalars['String'];
}


export interface MutationUserBatch_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationUserBatch_CreateArgs {
  data: UserBatchInput;
}


export interface MutationUserBatch_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationUserBatch_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationUserBatch_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: UserBatchInput;
}


export interface MutationUserSearch_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationUserSearch_CreateArgs {
  data: UserSearchInput;
}


export interface MutationUserSearch_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationUserSearch_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationUserSearch_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: UserSearchInput;
}


export interface MutationUser_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationUser_CreateArgs {
  data: UserInput;
}


export interface MutationUser_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationUser_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationUser_SetAvatarArgs {
  avatar?: InputMaybe<Scalars['Upload']>;
  defaultAvatar?: InputMaybe<Scalars['String']>;
}


export interface MutationUser_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: UserInput;
}


export interface MutationWhitelist_AggregateArgs {
  options?: InputMaybe<Scalars['JSON']>;
  pipeline: Array<Scalars['JSON']>;
}


export interface MutationWhitelist_CreateArgs {
  data: WhitelistInput;
}


export interface MutationWhitelist_RemoveArgs {
  _id: Scalars['ObjectId'];
}


export interface MutationWhitelist_RemoveManyArgs {
  query: Scalars['JSON'];
}


export interface MutationWhitelist_UpdateArgs {
  _id: Scalars['ObjectId'];
  data: WhitelistInput;
}


export interface MutationCreateS3PresignedImageProcessingPutUrlArgs {
  fileName: Scalars['String'];
}


export interface MutationCreateTasksArgs {
  inputs: Array<Scalars['JSON']>;
  taskDefinition: Scalars['ObjectId'];
}


export interface MutationGenerateJwtArgs {
  email: Scalars['String'];
}


export interface MutationLoginArgs {
  email: Scalars['String'];
  password: Scalars['String'];
}


export interface MutationLoginAsUserArgs {
  email: Scalars['String'];
}


export interface MutationRegisterArgs {
  defaultAvatar?: Scalars['Int'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  inviteCode: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
}


export interface MutationResetPasswordArgs {
  email: Scalars['String'];
}


export interface MutationResetPasswordUpdateArgs {
  code: Scalars['String'];
  password: Scalars['String'];
}

/**
 * Handles multiple field types grouped together, useful for matching object shapes where different properties have different values.
 *
 * **Pv2_search type:**
 * Its value is a list of other nodes from the `options`
 *
 * ```
 * {
 *     type: 'field';
 *     id: string;
 *     value: Pv2SearchField[];
 * }
 * ```
 */
export interface NestedSearchField extends ISearchField {
  /** Optional section in which this option should be places */
  group?: Maybe<Scalars['String']>;
  /** Unique identifier of a specific operation. It is the main value used for searching */
  id: Scalars['String'];
  /** Human-friendly label */
  label: Scalars['String'];
  options: Array<Maybe<Pv2SearchField>>;
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: Pv2SearchFieldType;
}

export interface NewItemActivation {
  brandChange?: Maybe<Scalars['String']>;
  brandpositionChange?: Maybe<Scalars['String']>;
  categoryChange?: Maybe<Scalars['String']>;
  compChange?: Maybe<Scalars['String']>;
  conventionalChannelStatus?: Maybe<Scalars['String']>;
  conventionalChannelStatusDetails?: Maybe<Scalars['String']>;
  currentBrand?: Maybe<Scalars['String']>;
  currentBrandPosition?: Maybe<Scalars['String']>;
  currentCategory?: Maybe<Scalars['String']>;
  currentCompany?: Maybe<Scalars['String']>;
  currentDepartment?: Maybe<Scalars['String']>;
  currentPackCount?: Maybe<Scalars['String']>;
  currentPositioningGroup?: Maybe<Scalars['String']>;
  currentPrivateLabelConventional?: Maybe<Scalars['String']>;
  currentProductDescription?: Maybe<Scalars['String']>;
  currentProductType?: Maybe<Scalars['String']>;
  currentSize?: Maybe<Scalars['String']>;
  currentSubcategory?: Maybe<Scalars['String']>;
  currentUnitOfMeasure?: Maybe<Scalars['String']>;
  departmentChange?: Maybe<Scalars['String']>;
  descriptionChange?: Maybe<Scalars['String']>;
  expectedChangeForAtLeastOneAttribute?: Maybe<Scalars['String']>;
  identifiedAttributeChanges?: Maybe<Scalars['String']>;
  newUpc?: Maybe<Scalars['String']>;
  numberOfAttributesWithChange?: Maybe<Scalars['Int']>;
  packChange?: Maybe<Scalars['String']>;
  plcChange?: Maybe<Scalars['String']>;
  positionChange?: Maybe<Scalars['String']>;
  producttypeChange?: Maybe<Scalars['String']>;
  proprietaryChannelStatus?: Maybe<Scalars['String']>;
  proprietaryChannelStatusDetails?: Maybe<Scalars['String']>;
  sizeChange?: Maybe<Scalars['String']>;
  stagedBrand?: Maybe<Scalars['String']>;
  stagedBrandPosition?: Maybe<Scalars['String']>;
  stagedCategory?: Maybe<Scalars['String']>;
  stagedCompany?: Maybe<Scalars['String']>;
  stagedDepartment?: Maybe<Scalars['String']>;
  stagedPackCount?: Maybe<Scalars['String']>;
  stagedPositioningGroup?: Maybe<Scalars['String']>;
  stagedPrivateLabelConventional?: Maybe<Scalars['String']>;
  stagedProductDescription?: Maybe<Scalars['String']>;
  stagedProductType?: Maybe<Scalars['String']>;
  stagedSize?: Maybe<Scalars['String']>;
  stagedSubcategory?: Maybe<Scalars['String']>;
  stagedUnitOfMeasure?: Maybe<Scalars['String']>;
  subcategoryChange?: Maybe<Scalars['String']>;
  uomChange?: Maybe<Scalars['String']>;
  upc: Scalars['String'];
  upcEan13?: Maybe<Scalars['String']>;
}

export interface NewItemActivationCount {
  itemCount: Scalars['String'];
}

export interface NfpAttributeMapping {
  _id: Scalars['ObjectId'];
  attributeName: Scalars['String'];
  attributeUofM: Scalars['String'];
  attributeValue: Scalars['String'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface NfpAttributeMappingFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<NfpAttributeMapping>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface NfpAttributeMappingInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  attributeName?: InputMaybe<Scalars['String']>;
  attributeUofM?: InputMaybe<Scalars['String']>;
  attributeValue?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface NumberEditableField extends IEditableField {
  /**
   * List of field id-s to reset the value on change.
   *
   * E.g. when `width_mm` is changed `with_inch` should be cleared since those 2 fields are computed based on each-other in the backend
   */
  clearOnChange?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  /** Hidden fields should not be rendered but can still be used to update the Pv2 */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Unique field identifier */
  id: Scalars['String'];
  /** Human-readlabe name */
  label: Scalars['String'];
  readonly: Scalars['Boolean'];
  required: Scalars['Boolean'];
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: IEditableFieldTypeEnum;
  value?: Maybe<Scalars['JSON']>;
}

/**
 * Handles numerical values meant to be compared
 *
 * **Pv2_search type:**
 *
 * ```
 * {
 *     type: 'field';
 *     id: string;
 *     operation: 'gt' | 'gte' | 'lt' | 'lte' | 'eq';
 *     value: number;
 * }
 * ```
 */
export interface NumericalSearchField extends ISearchField {
  /** Optional section in which this option should be places */
  group?: Maybe<Scalars['String']>;
  /** Unique identifier of a specific operation. It is the main value used for searching */
  id: Scalars['String'];
  /** Human-friendly label */
  label: Scalars['String'];
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: Pv2SearchFieldType;
}

export interface PageInfo {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
}

export interface Period {
  _id: Scalars['ObjectId'];
  adpEndTime?: Maybe<Scalars['DateTime']>;
  adpStartTime?: Maybe<Scalars['DateTime']>;
  circanaWeek: Scalars['String'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  period: Scalars['String'];
  snapshotEndTime?: Maybe<Scalars['DateTime']>;
  snapshotStartTime?: Maybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  year: Scalars['String'];
}

export interface PeriodFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Period>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface PeriodInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  adpEndTime?: InputMaybe<Scalars['DateTime']>;
  adpStartTime?: InputMaybe<Scalars['DateTime']>;
  circanaWeek?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  period?: InputMaybe<Scalars['String']>;
  snapshotEndTime?: InputMaybe<Scalars['DateTime']>;
  snapshotStartTime?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['String']>;
}

/** Rows of a pre-production "new to code" (NTC) file, as loaded from the curvball GCS bucket. One document per row per ingestion event. */
export interface PreProductionNtc {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  dollars?: Maybe<Scalars['Float']>;
  ingestionEventId?: Maybe<RawIngestionEvent>;
  /** File column ITEM */
  itemDescription?: Maybe<Scalars['String']>;
  manufacturerCode?: Maybe<Scalars['String']>;
  /** Period the file covers, as "YYYYPP" (file column PERIOD) */
  period?: Maybe<Scalars['String']>;
  /** File column RETAILERBRAND */
  retailerBrand?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  /** File column SA, which carries "X" or a blank */
  spinsAlternative?: Maybe<Scalars['Boolean']>;
  /** File column SA_DOLLARS */
  spinsAlternativeDollars?: Maybe<Scalars['Float']>;
  /** File column SA_UNITS */
  spinsAlternativeUnits?: Maybe<Scalars['Float']>;
  /** File column SG, which carries "X" or a blank */
  spinsGourmet?: Maybe<Scalars['Boolean']>;
  /** File column SG_DOLLARS */
  spinsGourmetDollars?: Maybe<Scalars['Float']>;
  /** File column SG_UNITS */
  spinsGourmetUnits?: Maybe<Scalars['Float']>;
  /** File column SN, which carries "X" or a blank */
  spinsNatural?: Maybe<Scalars['Boolean']>;
  /** File column SN_DOLLARS */
  spinsNaturalDollars?: Maybe<Scalars['Float']>;
  /** File column SN_UNITS */
  spinsNaturalUnits?: Maybe<Scalars['Float']>;
  /** File column U_OF_M */
  unitOfMeasure?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Float']>;
  upc: Scalars['String'];
  /** File column UPC_E */
  upcE?: Maybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  /** File column YTD_DOLLARS */
  ytdDollars?: Maybe<Scalars['Float']>;
}

export interface PreProductionNtcFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<PreProductionNtc>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Rows of a pre-production "new to code" (NTC) file, as loaded from the curvball GCS bucket. One document per row per ingestion event. */
export interface PreProductionNtcInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  dollars?: InputMaybe<Scalars['Float']>;
  ingestionEventId?: InputMaybe<Scalars['ObjectId']>;
  /** File column ITEM */
  itemDescription?: InputMaybe<Scalars['String']>;
  manufacturerCode?: InputMaybe<Scalars['String']>;
  /** Period the file covers, as "YYYYPP" (file column PERIOD) */
  period?: InputMaybe<Scalars['String']>;
  /** File column RETAILERBRAND */
  retailerBrand?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  /** File column SA, which carries "X" or a blank */
  spinsAlternative?: InputMaybe<Scalars['Boolean']>;
  /** File column SA_DOLLARS */
  spinsAlternativeDollars?: InputMaybe<Scalars['Float']>;
  /** File column SA_UNITS */
  spinsAlternativeUnits?: InputMaybe<Scalars['Float']>;
  /** File column SG, which carries "X" or a blank */
  spinsGourmet?: InputMaybe<Scalars['Boolean']>;
  /** File column SG_DOLLARS */
  spinsGourmetDollars?: InputMaybe<Scalars['Float']>;
  /** File column SG_UNITS */
  spinsGourmetUnits?: InputMaybe<Scalars['Float']>;
  /** File column SN, which carries "X" or a blank */
  spinsNatural?: InputMaybe<Scalars['Boolean']>;
  /** File column SN_DOLLARS */
  spinsNaturalDollars?: InputMaybe<Scalars['Float']>;
  /** File column SN_UNITS */
  spinsNaturalUnits?: InputMaybe<Scalars['Float']>;
  /** File column U_OF_M */
  unitOfMeasure?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['Float']>;
  upc?: InputMaybe<Scalars['String']>;
  /** File column UPC_E */
  upcE?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  /** File column YTD_DOLLARS */
  ytdDollars?: InputMaybe<Scalars['Float']>;
}

/** Rows of a pre-production "new to update" (NTU) file, as loaded from the curvball GCS bucket. One document per row per ingestion event. */
export interface PreProductionNtu {
  _id: Scalars['ObjectId'];
  /** File column BRAND */
  brand?: Maybe<Scalars['String']>;
  /** File column CATEGORY_TAG */
  categoryTag?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  dollars?: Maybe<Scalars['Float']>;
  /** File column GROUP_TAG */
  groupTag?: Maybe<Scalars['String']>;
  ingestionEventId?: Maybe<RawIngestionEvent>;
  /** File column ITEM */
  itemDescription?: Maybe<Scalars['String']>;
  manufacturerCode?: Maybe<Scalars['String']>;
  /** Period the file covers, as "YYYYPP" (file column PERIOD) */
  period?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  /** File column SA, which carries "X" or a blank */
  spinsAlternative?: Maybe<Scalars['Boolean']>;
  /** File column SA_DOLLARS */
  spinsAlternativeDollars?: Maybe<Scalars['Float']>;
  /** File column SA_UNITS */
  spinsAlternativeUnits?: Maybe<Scalars['Float']>;
  /** File column SG, which carries "X" or a blank */
  spinsGourmet?: Maybe<Scalars['Boolean']>;
  /** File column SG_DOLLARS */
  spinsGourmetDollars?: Maybe<Scalars['Float']>;
  /** File column SG_UNITS */
  spinsGourmetUnits?: Maybe<Scalars['Float']>;
  /** File column SN, which carries "X" or a blank */
  spinsNatural?: Maybe<Scalars['Boolean']>;
  /** File column SN_DOLLARS */
  spinsNaturalDollars?: Maybe<Scalars['Float']>;
  /** File column SN_UNITS */
  spinsNaturalUnits?: Maybe<Scalars['Float']>;
  /** File column U_OF_M */
  unitOfMeasure?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Float']>;
  upc: Scalars['String'];
  /** File column UPC_E */
  upcE?: Maybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface PreProductionNtuFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<PreProductionNtu>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Rows of a pre-production "new to update" (NTU) file, as loaded from the curvball GCS bucket. One document per row per ingestion event. */
export interface PreProductionNtuInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** File column BRAND */
  brand?: InputMaybe<Scalars['String']>;
  /** File column CATEGORY_TAG */
  categoryTag?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  dollars?: InputMaybe<Scalars['Float']>;
  /** File column GROUP_TAG */
  groupTag?: InputMaybe<Scalars['String']>;
  ingestionEventId?: InputMaybe<Scalars['ObjectId']>;
  /** File column ITEM */
  itemDescription?: InputMaybe<Scalars['String']>;
  manufacturerCode?: InputMaybe<Scalars['String']>;
  /** Period the file covers, as "YYYYPP" (file column PERIOD) */
  period?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  /** File column SA, which carries "X" or a blank */
  spinsAlternative?: InputMaybe<Scalars['Boolean']>;
  /** File column SA_DOLLARS */
  spinsAlternativeDollars?: InputMaybe<Scalars['Float']>;
  /** File column SA_UNITS */
  spinsAlternativeUnits?: InputMaybe<Scalars['Float']>;
  /** File column SG, which carries "X" or a blank */
  spinsGourmet?: InputMaybe<Scalars['Boolean']>;
  /** File column SG_DOLLARS */
  spinsGourmetDollars?: InputMaybe<Scalars['Float']>;
  /** File column SG_UNITS */
  spinsGourmetUnits?: InputMaybe<Scalars['Float']>;
  /** File column SN, which carries "X" or a blank */
  spinsNatural?: InputMaybe<Scalars['Boolean']>;
  /** File column SN_DOLLARS */
  spinsNaturalDollars?: InputMaybe<Scalars['Float']>;
  /** File column SN_UNITS */
  spinsNaturalUnits?: InputMaybe<Scalars['Float']>;
  /** File column U_OF_M */
  unitOfMeasure?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['Float']>;
  upc?: InputMaybe<Scalars['String']>;
  /** File column UPC_E */
  upcE?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface PredictionOverride {
  _id: Scalars['ObjectId'];
  asin?: Maybe<Scalars['String']>;
  attributeType: Scalars['String'];
  cleansedDataId?: Maybe<CleansedData>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  /**
   * The GTIN of the CleansedData record this override was made against, denormalized so
   * the audit row remains identifiable if that record is merged away or deleted. Absent
   * for ASIN-only records, which legitimately carry no GTIN.
   */
  gtin?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  predictedValue?: Maybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  updatedValue?: Maybe<Scalars['String']>;
}

export interface PredictionOverrideAllowedValues {
  attributeType: PredictionOverrideAttributeTypeEnum;
  values: Array<Scalars['String']>;
}

export enum PredictionOverrideAttributeTypeEnum {
  Age = 'age',
  Brand = 'brand',
  Flavor = 'flavor',
  Form = 'form',
  FunctionalIngredient = 'functionalIngredient',
  Gender = 'gender',
  HealthFocus = 'healthFocus',
  PackCount = 'packCount',
  ProductType = 'productType',
  Scent = 'scent',
  Size = 'size',
  Subcategory = 'subcategory',
  UnitOfMeasure = 'unitOfMeasure'
}

export interface PredictionOverrideFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<PredictionOverride>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface PredictionOverrideInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  asin?: InputMaybe<Scalars['String']>;
  attributeType?: InputMaybe<Scalars['String']>;
  cleansedDataId?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * The GTIN of the CleansedData record this override was made against, denormalized so
   * the audit row remains identifiable if that record is merged away or deleted. Absent
   * for ASIN-only records, which legitimately carry no GTIN.
   */
  gtin?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  predictedValue?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  updatedValue?: InputMaybe<Scalars['String']>;
}

export interface PredictionOverrideSaveError {
  /**
   * The ASIN the failed edit targeted, when it named one. An error with no ASIN came
   * from an edit targeting the record-level prediction, so a caller can tell which of a
   * record's edits to keep pending.
   */
  asin?: Maybe<Scalars['String']>;
  attributeType: PredictionOverrideAttributeTypeEnum;
  cleansedDataId: Scalars['String'];
  message: Scalars['String'];
}

export interface PredictionOverrideSaveInput {
  /**
   * The ASIN whose prediction is being corrected. Predictions are stored per-ASIN, so
   * supply this to target the data point for that one ASIN. Omit it to override the
   * record-level prediction, i.e. the one carrying no ASIN.
   */
  asin?: InputMaybe<Scalars['String']>;
  attributeType: PredictionOverrideAttributeTypeEnum;
  cleansedDataId: Scalars['ObjectId'];
  updatedValue: Scalars['String'];
}

export interface PredictionOverrideSaveResponse {
  errors: Array<PredictionOverrideSaveError>;
  savedCount: Scalars['Int'];
  success: Scalars['Boolean'];
}

export interface PrivateLabelPermanentProduct {
  _id: Scalars['ObjectId'];
  oldUpc: Scalars['String'];
  upc: Scalars['String'];
}

export interface PrivateLabelPermanentProductFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<PrivateLabelPermanentProduct>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface PrivateLabelPermanentProductInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  oldUpc?: InputMaybe<Scalars['String']>;
  upc?: InputMaybe<Scalars['String']>;
}

export interface PrivateLabelProduct {
  _id: Scalars['ObjectId'];
  controlBrand?: Maybe<Scalars['Boolean']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  privateLabelBrand?: Maybe<Scalars['String']>;
  privateLabelDescription?: Maybe<Scalars['String']>;
  retailTag?: Maybe<Scalars['Float']>;
  upc: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface PrivateLabelProductFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<PrivateLabelProduct>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface PrivateLabelProductInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  controlBrand?: InputMaybe<Scalars['Boolean']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  privateLabelBrand?: InputMaybe<Scalars['String']>;
  privateLabelDescription?: InputMaybe<Scalars['String']>;
  retailTag?: InputMaybe<Scalars['Float']>;
  upc?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface ProductEditRequest {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  message: Scalars['String'];
  paths: Array<Scalars['String']>;
  products: Array<Pv2>;
  resolved: Scalars['Boolean'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface ProductEditRequestFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<ProductEditRequest>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface ProductEditRequestInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  message?: InputMaybe<Scalars['String']>;
  paths?: InputMaybe<Array<Scalars['String']>>;
  products?: InputMaybe<Array<Scalars['ObjectId']>>;
  resolved?: InputMaybe<Scalars['Boolean']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

/** Record of product submission to Target from the target-publish-updated-products script. */
export interface ProductSentToTarget {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  pv2Id?: Maybe<Pv2>;
  targetEnv?: Maybe<Scalars['String']>;
  transformedVersion?: Maybe<Scalars['JSON']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface ProductSentToTargetFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<ProductSentToTarget>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Record of product submission to Target from the target-publish-updated-products script. */
export interface ProductSentToTargetInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  pv2Id?: InputMaybe<Scalars['ObjectId']>;
  targetEnv?: InputMaybe<Scalars['String']>;
  transformedVersion?: InputMaybe<Scalars['JSON']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface Pv2 {
  _id: Scalars['ObjectId'];
  asin?: Maybe<Pv2Asin>;
  asinChildren: Array<Pv2>;
  /** Pv2 attributes that have gone through domain enforcement based on `User.domains`. */
  attributes: Array<Pv2AttributeStruct>;
  barcode128?: Maybe<Scalars['String']>;
  barcodes: Array<BarcodeStruct>;
  brand?: Maybe<Company>;
  /** Synchronized value from the circana:keycat attribute */
  circanaKeycat?: Maybe<Scalars['String']>;
  cleansedData?: Maybe<CleansedData>;
  companies: Array<Company>;
  containerChildren: Array<Pv2>;
  copy?: Maybe<Pv2>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  dataUpdatedDate: Scalars['DateTime'];
  dedupeDomains: Array<Domain>;
  deliveredToCircana: Scalars['Boolean'];
  digitizationOutOfStock: Array<Pv2DigitizationOutOfStock>;
  digitizationStatus?: Maybe<Pv2DigitizationStatus>;
  digitizationStoreDone?: Maybe<Pv2DigitizationStoreDone>;
  digitizationStores: Array<Store>;
  /** Indicates if the stores list has ever been fully rebuilt. */
  digitizationStoresInitialized: Scalars['Boolean'];
  discontinued?: Maybe<Pv2Discontinued>;
  exclusivity?: Maybe<Pv2Exclusivity>;
  failedFormulas: Array<Formula>;
  firstDeliveredToSnapshot?: Maybe<Scalars['DateTime']>;
  /** Convenience method to extract the front image thumbnail URL without accessing .images */
  frontImageThumbnailUrl?: Maybe<Scalars['String']>;
  /** Convenience method to extract the front image URL without accessing .images */
  frontImageUrl?: Maybe<Scalars['String']>;
  /** Computed alias of barcodes[0].GTIN, or an empty string if there are no barcodes */
  gtin: Scalars['String'];
  /** A flag indicating if failedFormulas is non-empty. */
  hasFailedFormulas: Scalars['Boolean'];
  /** A flag indicating if invalidAttributeParents is non-empty. */
  hasInvalidAttributeParents: Scalars['Boolean'];
  hierarchies: Array<Taxonomy>;
  hierarchyOverride?: Maybe<Pv2HierarchyOverrideEnum>;
  identifiers: Array<Pv2Identifier>;
  imageStatus?: Maybe<Pv2ImageStatus>;
  imageUpdatedDate?: Maybe<Scalars['DateTime']>;
  images: Array<Image>;
  imagesCount?: Maybe<Scalars['Float']>;
  ingestionMetadata: Array<Pv2IngestionMetadata>;
  /**
   * The uids of attributes whose "parent" references an attribute uid that does not exist
   * on this Pv2. Only populated while parent validation is relaxed (i.e. the Pv2 is in the
   * pending or processing status); a non-empty list blocks promotion to the active status
   * and, for a copy, the merge back into its original.
   */
  invalidAttributeParents: Array<Scalars['String']>;
  /** Indicates whether this Pv2 document is a draft version, i.e., the 'original' field is defined. */
  isCopy: Scalars['Boolean'];
  itemType: Pv2ItemTypeEnum;
  lastVerification?: Maybe<Pv2LastVerification>;
  /** Manufacturer is computed from brand, but can sometimes be null which computed doesn't seem to allow for */
  manufacturer?: Maybe<Company>;
  maskedUpc: Scalars['String'];
  mergedCopyPv2Ids: Array<Pv2>;
  /** Full product name, user-friendly */
  name: Scalars['String'];
  needsVerification: Scalars['Boolean'];
  notification?: Maybe<Pv2Notification>;
  original?: Maybe<Pv2>;
  outdatedImages: Array<Image>;
  overrideBarcodeGtinGeneration: Scalars['Boolean'];
  overrideExclusivity: Scalars['Boolean'];
  parentGTIN?: Maybe<Scalars['String']>;
  permissions: Array<Pv2PermissionEnum>;
  preview?: Maybe<Pv2Preview>;
  processingPriority: Scalars['Float'];
  pv2Ingredients: Array<Pv2Pv2Ingredients>;
  /** URL-friendly unique identifier for this product. It is generated from the product name and updates every time the name or brand changes */
  slug: Scalars['String'];
  /** - enum: "manager", "aperture", "metro-gs1", "foodfacts", "product-library", "circana", "amazon", "ix-one" */
  source?: Maybe<Scalars['String']>;
  spinsAttributesEligibilityOverride?: Maybe<Scalars['Boolean']>;
  spinsUpc: Scalars['String'];
  status: Pv2StatusEnum;
  tags?: Maybe<Array<Maybe<TagStruct>>>;
  taskerStatus?: Maybe<Pv2TaskerStatus>;
  taxonomies: Array<Taxonomy>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  whitelists: Array<Whitelist>;
}

export interface Pv2Asin {
  asin?: Maybe<Scalars['String']>;
  associatedGtin?: Maybe<Scalars['String']>;
}

export interface Pv2AsinInput {
  asin?: InputMaybe<Scalars['String']>;
  associatedGtin?: InputMaybe<Scalars['String']>;
}

export interface Pv2Attribute {
  createdBy?: Maybe<User>;
  createdDate?: Maybe<Scalars['DateTime']>;
  key?: Maybe<Scalars['String']>;
  parent?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedDate?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['JSON']>;
}

/**
 * Every single attribute "type" found in Pv2Attribute must be defined in here
 *
 * This collection stores the schema of every single attribute
 *
 * When Pv2 gets saved, all attributes are validated against this collection
 */
export interface Pv2AttributeDefinition {
  _id: Scalars['ObjectId'];
  _valueSchema?: Maybe<Scalars['String']>;
  /** Inactive attributes are ignored anywhere user-facing and are only used in internal tools. Mostly used during development */
  active: Scalars['Boolean'];
  changelog: Array<ChangelogEntryStruct>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** External-facing description. Used in auto-generated attribute docs */
  description?: Maybe<Scalars['String']>;
  domains: Array<Domain>;
  /** Attributes that do not have a key can only show up at most once in a Pv2 */
  hasKey: Scalars['Boolean'];
  /** If true "valueSchema" must be defined as a valid JSON Schema */
  hasValue: Scalars['Boolean'];
  hierarchies: Array<Taxonomy>;
  /**
   * Internal description that will only show up in the admin dashboard.
   *
   * Store attribute-specific notes in here where needed
   */
  internalDescription?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** All possible Pv2AttributeDefinition.type fields that this attribute can reference as a parent */
  parents: Array<Scalars['String']>;
  /** Mark extra fields as required. "type" and "uid" are always required */
  required: Array<Pv2AttributeDefinitionRequiredEnum>;
  taxonomies: Array<Taxonomy>;
  /** The attribute type for this definition. */
  type: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  /** @virtual */
  valueSchema?: Maybe<Scalars['JSON']>;
  /** When the shape of this attribute meaningfully changes (schema, parents or hasKey is changed) this version number will auto-increment */
  version: Scalars['Float'];
  /**
   * Date at which the shape of this attribute has been changed.
   *
   * Previous versions of this attribute likely need to be updated via a database migration
   */
  versionDate: Scalars['DateTime'];
}

export interface Pv2AttributeDefinitionFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Pv2AttributeDefinition>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/**
 * Every single attribute "type" found in Pv2Attribute must be defined in here
 *
 * This collection stores the schema of every single attribute
 *
 * When Pv2 gets saved, all attributes are validated against this collection
 */
export interface Pv2AttributeDefinitionInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  _valueSchema?: InputMaybe<Scalars['String']>;
  /** Inactive attributes are ignored anywhere user-facing and are only used in internal tools. Mostly used during development */
  active?: InputMaybe<Scalars['Boolean']>;
  changelog?: InputMaybe<Array<ChangelogEntryStructInput>>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  /** External-facing description. Used in auto-generated attribute docs */
  description?: InputMaybe<Scalars['String']>;
  /** Setting one or more domains will cause this attribute to be private and only visible to users of the given domains */
  domains?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Attributes that do not have a key can only show up at most once in a Pv2 */
  hasKey?: InputMaybe<Scalars['Boolean']>;
  /** If true "valueSchema" must be defined as a valid JSON Schema */
  hasValue?: InputMaybe<Scalars['Boolean']>;
  /** Eligible spins hierarchies for this attribute. */
  hierarchies?: InputMaybe<Array<Scalars['ObjectId']>>;
  /**
   * Internal description that will only show up in the admin dashboard.
   *
   * Store attribute-specific notes in here where needed
   */
  internalDescription?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** All possible Pv2AttributeDefinition.type fields that this attribute can reference as a parent */
  parents?: InputMaybe<Array<Scalars['String']>>;
  /** Mark extra fields as required. "type" and "uid" are always required */
  required?: InputMaybe<Array<Pv2AttributeDefinitionRequiredEnum>>;
  /** Eligible legacy taxonomies for this attribute. */
  taxonomies?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The attribute type for this definition. */
  type?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  /** @virtual */
  valueSchema?: InputMaybe<Scalars['JSON']>;
  /** When the shape of this attribute meaningfully changes (schema, parents or hasKey is changed) this version number will auto-increment */
  version?: InputMaybe<Scalars['Float']>;
  /**
   * Date at which the shape of this attribute has been changed.
   *
   * Previous versions of this attribute likely need to be updated via a database migration
   */
  versionDate?: InputMaybe<Scalars['DateTime']>;
}

/** Mark extra fields as required. "type" and "uid" are always required */
export enum Pv2AttributeDefinitionRequiredEnum {
  Key = 'key',
  Parent = 'parent',
  Source = 'source',
  Value = 'value'
}

export interface Pv2AttributeStruct {
  createdDate?: Maybe<Scalars['DateTime']>;
  /** The data source that provided this attribute value */
  dataProvider?: Maybe<Pv2AttributeStructDataProviderEnum>;
  /**
   * Distinguishes between multiple attributes of the same __type__, when necessary
   *
   * Usually used in conjunction with the __parent__ attribute to reference unique fields
   * We use keys instead of attribute ___id__s since we usually don't know the ids at creation time
   *
   * ### Example:
   *
   * A product with multiple __nutrition: panel__ attributes needs to distinguish between them
   *
   * At creation time, each get an unique __key__ (unique among all other __nutrition: panel__ attributes in this Pv2)
   */
  key?: Maybe<Scalars['String']>;
  /**
   * Standard way of linking attributes together within the same Pv2 document
   *
   * The reference is to another attribute's __uid__ field
   */
  parent?: Maybe<Scalars['String']>;
  /** - enum: "computed", "on-package", "off-package", "third-party", "multisource" */
  source?: Maybe<Scalars['String']>;
  /** The task that provided the attribute value. */
  task?: Maybe<Task>;
  /**
   * Determines the shape of the value attribute
   * There can be multiple attributes with the same type in a product
   */
  type: Scalars['String'];
  /**
   * Combination of __type__ + __key__ to create an unique identifier for this attribute
   *
   * The __parent__ field will reference another attribute's __uid__ for explicit linking
   */
  uid?: Maybe<Scalars['String']>;
  /** Specific shape depending on each attribute type */
  value?: Maybe<Scalars['JSON']>;
  valueUpdatedDate: Scalars['DateTime'];
}

/** The data source that provided this attribute value */
export enum Pv2AttributeStructDataProviderEnum {
  Circana = 'circana'
}

export interface Pv2AttributeStructInput {
  createdDate?: InputMaybe<Scalars['DateTime']>;
  /** The data source that provided this attribute value */
  dataProvider?: InputMaybe<Pv2AttributeStructDataProviderEnum>;
  /**
   * Distinguishes between multiple attributes of the same __type__, when necessary
   *
   * Usually used in conjunction with the __parent__ attribute to reference unique fields
   * We use keys instead of attribute ___id__s since we usually don't know the ids at creation time
   *
   * ### Example:
   *
   * A product with multiple __nutrition: panel__ attributes needs to distinguish between them
   *
   * At creation time, each get an unique __key__ (unique among all other __nutrition: panel__ attributes in this Pv2)
   */
  key?: InputMaybe<Scalars['String']>;
  /**
   * Standard way of linking attributes together within the same Pv2 document
   *
   * The reference is to another attribute's __uid__ field
   */
  parent?: InputMaybe<Scalars['String']>;
  /** - enum: "computed", "on-package", "off-package", "third-party", "multisource" */
  source?: InputMaybe<Scalars['String']>;
  /** The task that provided the attribute value. */
  task?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Determines the shape of the value attribute
   * There can be multiple attributes with the same type in a product
   */
  type?: InputMaybe<Scalars['String']>;
  /**
   * Combination of __type__ + __key__ to create an unique identifier for this attribute
   *
   * The __parent__ field will reference another attribute's __uid__ for explicit linking
   */
  uid?: InputMaybe<Scalars['String']>;
  /** Specific shape depending on each attribute type */
  value?: InputMaybe<Scalars['JSON']>;
  valueUpdatedDate?: InputMaybe<Scalars['DateTime']>;
}

/**
 * Pv2CustomFieldsConfig stores configurations for each use-case.
 * Configurations are attached to a domain and can optionally be scoped to one or more taxonomies.
 */
export interface Pv2CustomFieldConfig {
  _id: Scalars['ObjectId'];
  _value?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Domain>;
  name: Scalars['String'];
  taxonomies: Array<Taxonomy>;
  type?: Maybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  /** @virtual */
  value: Scalars['JSON'];
}

export interface Pv2CustomFieldConfigFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Pv2CustomFieldConfig>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/**
 * Pv2CustomFieldsConfig stores configurations for each use-case.
 * Configurations are attached to a domain and can optionally be scoped to one or more taxonomies.
 */
export interface Pv2CustomFieldConfigInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  _value?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['ObjectId']>;
  name?: InputMaybe<Scalars['String']>;
  taxonomies?: InputMaybe<Array<Scalars['ObjectId']>>;
  type?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  /** @virtual */
  value?: InputMaybe<Scalars['JSON']>;
}

export interface Pv2DigitizationOutOfStock {
  date: Scalars['DateTime'];
  store: Scalars['String'];
  user?: Maybe<User>;
}

export interface Pv2DigitizationOutOfStockInput {
  date?: InputMaybe<Scalars['DateTime']>;
  store?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

export interface Pv2DigitizationStatus {
  date: Scalars['DateTime'];
  domain?: Maybe<Domain>;
  status: Pv2DigitizationStatusStatusEnum;
  store?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
}

export interface Pv2DigitizationStatusInput {
  date?: InputMaybe<Scalars['DateTime']>;
  domain?: InputMaybe<Scalars['ObjectId']>;
  status?: InputMaybe<Pv2DigitizationStatusStatusEnum>;
  store?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

export enum Pv2DigitizationStatusStatusEnum {
  Cart = 'cart',
  Done = 'done',
  None = 'none',
  Pending = 'pending'
}

export interface Pv2DigitizationStoreDone {
  date: Scalars['DateTime'];
  store?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
}

export interface Pv2DigitizationStoreDoneInput {
  date?: InputMaybe<Scalars['DateTime']>;
  store?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

export interface Pv2Discontinued {
  date: Scalars['DateTime'];
  user?: Maybe<User>;
}

export interface Pv2DiscontinuedInput {
  date?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<Scalars['ObjectId']>;
}

/** Union of all valid Search Fields. It's not mean to be used as-is, instead spread on the different types and select each type's fields */
export type Pv2EditableField = CheckboxEditableField | ImageListEditableField | NumberEditableField | SelectEditableField | StringEditableField;

export interface Pv2EditableFieldInput {
  id: Scalars['String'];
  value?: InputMaybe<Scalars['JSON']>;
}

export interface Pv2Exclusivity {
  domain?: Maybe<Domain>;
  type: Pv2ExclusivityTypeEnum;
}

export interface Pv2ExclusivityInput {
  domain?: InputMaybe<Scalars['ObjectId']>;
  type?: InputMaybe<Pv2ExclusivityTypeEnum>;
}

export enum Pv2ExclusivityTypeEnum {
  Domain = 'domain',
  None = 'none',
  Retailer = 'retailer'
}

export enum Pv2ExportFileTypeEnum {
  Csv = 'CSV',
  Json = 'JSON'
}

export enum Pv2ExportImageTypeEnum {
  All = 'ALL',
  AllPlanogram = 'ALL_PLANOGRAM',
  AllThumbnail = 'ALL_THUMBNAIL',
  Front = 'FRONT',
  FrontPlanogram = 'FRONT_PLANOGRAM',
  FrontThumbnail = 'FRONT_THUMBNAIL'
}

export interface Pv2ExportSection {
  id: Scalars['String'];
  label: Scalars['String'];
}

export enum Pv2ExportUrlFormatTypeEnum {
  Gs1 = 'GS1',
  Standard = 'STANDARD',
  Wfmoa = 'WFMOA'
}

export interface Pv2FindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Pv2>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface Pv2FromIngredientResultItem {
  _id: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  breadcrumb: Scalars['String'];
  falsePositiveMatches: Array<Scalars['String']>;
  gtin: Scalars['String'];
  ingredientStatement: Scalars['String'];
  matchedNames: Array<Scalars['String']>;
  matchedTerms: Array<Scalars['String']>;
  name: Scalars['String'];
}

export enum Pv2HierarchyOverrideEnum {
  Client = 'client',
  Ops = 'ops',
  Tasker = 'tasker'
}

export interface Pv2Identifier {
  domain?: Maybe<Domain>;
  hash: Scalars['String'];
  value: Scalars['String'];
}

export interface Pv2IdentifierInput {
  domain?: InputMaybe<Scalars['ObjectId']>;
  hash?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
}

export interface Pv2Image {
  createdDate: Scalars['DateTime'];
  imageId: Scalars['String'];
  s3Key?: Maybe<Scalars['String']>;
  side: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
}

export interface Pv2ImageStatus {
  doneDate?: Maybe<Scalars['DateTime']>;
  state: Pv2ImageStatusStateEnum;
}

export interface Pv2ImageStatusInput {
  doneDate?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<Pv2ImageStatusStateEnum>;
}

export enum Pv2ImageStatusStateEnum {
  Done = 'done',
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing'
}

export interface Pv2Info {
  /**
   * Returns the default blacklisted Tag for the current user.
   * Creates one if it does not exist.
   */
  blacklistedTag?: Maybe<Tag>;
  docs: Pv2InfoDocs;
  /**
   * Returns the list of sections available when exporting product data.
   *
   * All fields have an unique `id` and a human-friendly `label`.
   */
  exportSections?: Maybe<Array<Maybe<Pv2ExportSection>>>;
  /**
   * Returns the list of fields available to for advanced search for the current user.
   *
   * All fields have an unique `id`, a human-friendly `label` and a `type` to resolve against
   */
  searchFields?: Maybe<Array<Maybe<Pv2SearchField>>>;
}

export interface Pv2InfoDocs {
  /**
   * All the sections that should show up in the Attribute Library part of the Data Spec.
   *
   * This is a flattened list of the entiere tree, you'll have to rebuild the tree:
   *
   * It's flattened to not have to spread an ever-growing number of fragments in graphql since the max depth might change at any given time.
   *
   * Example tree rebuild utility:
   *
   * ```
   * const makeSectionTree = (list: Pv2InfoDocsSection[]) => {
   *     const rootSections = [];
   *     const idMap = {};
   *     for (const item of list) {
   *         const section = { ...item, children: [] };
   *         idMap[section.id] = item;
   *         if (item.parent) {
   *             idMap[item.parent].children.push(item);
   *         } else {
   *             rootSections.push(item);
   *         }
   *     }
   *     return rootSections;
   * };
   * ```
   */
  attributeSections: Array<Maybe<Pv2InfoDocsSection>>;
}

export interface Pv2InfoDocsAttribute {
  description?: Maybe<Scalars['String']>;
  /** Optional example annotated JSON object */
  example?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  source: Pv2InfoDocsSource;
  /** Attribute type field */
  type: Scalars['String'];
}

export interface Pv2InfoDocsSection {
  attributes: Array<Maybe<Pv2InfoDocsAttribute>>;
  depth: Scalars['Int'];
  /** Optional section description */
  description?: Maybe<Scalars['String']>;
  /** Globally unique section id */
  id: Scalars['ID'];
  /** Section Title */
  name: Scalars['String'];
  /** Optional parent section id. If not provided, this section is a top-level section. Otherwise it is nested under the parent */
  parent?: Maybe<Scalars['String']>;
}

export enum Pv2InfoDocsSource {
  Brand = 'BRAND',
  Computed = 'COMPUTED',
  OffPackage = 'OFF_PACKAGE',
  OnPackage = 'ON_PACKAGE'
}

export interface Pv2IngestionMetadata {
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  domain?: Maybe<Domain>;
  rawPayload?: Maybe<Scalars['JSON']>;
  subcategory?: Maybe<Scalars['String']>;
}

export interface Pv2IngestionMetadataInput {
  brand?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['ObjectId']>;
  rawPayload?: InputMaybe<Scalars['JSON']>;
  subcategory?: InputMaybe<Scalars['String']>;
}

export interface Pv2Ingredient {
  _id: Scalars['ObjectId'];
  componentType: Pv2IngredientComponentTypeEnum;
  createdDate?: Maybe<Scalars['DateTime']>;
  ingredientReview?: Maybe<Pv2IngredientIngredientReview>;
  name: Scalars['String'];
}

export enum Pv2IngredientComponentTypeEnum {
  Majority = 'majority',
  Parsed = 'parsed',
  ParsedCleaned = 'parsed_cleaned',
  Sanitized = 'sanitized'
}

export interface Pv2IngredientFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Pv2Ingredient>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface Pv2IngredientIngredientReview {
  additionalReviewCompleteDate?: Maybe<Scalars['DateTime']>;
  additionalReviewStartDate?: Maybe<Scalars['DateTime']>;
  additionalReviewer?: Maybe<User>;
  reviewCompleteDate?: Maybe<Scalars['DateTime']>;
  reviewStartDate?: Maybe<Scalars['DateTime']>;
  reviewStatus: Pv2IngredientIngredientReviewReviewStatusEnum;
  reviewer?: Maybe<User>;
}

export interface Pv2IngredientIngredientReviewInput {
  additionalReviewCompleteDate?: InputMaybe<Scalars['DateTime']>;
  additionalReviewStartDate?: InputMaybe<Scalars['DateTime']>;
  additionalReviewer?: InputMaybe<Scalars['ObjectId']>;
  reviewCompleteDate?: InputMaybe<Scalars['DateTime']>;
  reviewStartDate?: InputMaybe<Scalars['DateTime']>;
  reviewStatus?: InputMaybe<Pv2IngredientIngredientReviewReviewStatusEnum>;
  reviewer?: InputMaybe<Scalars['ObjectId']>;
}

export enum Pv2IngredientIngredientReviewReviewStatusEnum {
  Done = 'done',
  NeedsAdditionalReview = 'needsAdditionalReview',
  Pending = 'pending',
  Processing = 'processing'
}

export interface Pv2IngredientInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  componentType?: InputMaybe<Pv2IngredientComponentTypeEnum>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  ingredientReview?: InputMaybe<Pv2IngredientIngredientReviewInput>;
  name?: InputMaybe<Scalars['String']>;
}

export interface Pv2IngredientsSearchResult {
  count: Scalars['Int'];
  results: Array<Pv2IngredientsSearchResultItem>;
}

export interface Pv2IngredientsSearchResultItem {
  _id: Scalars['String'];
  createdDate: Scalars['DateTime'];
  name: Scalars['String'];
  pv2Count: Scalars['Int'];
  reviewStatus?: Maybe<Scalars['String']>;
}

export interface Pv2Input {
  _id?: InputMaybe<Scalars['ObjectId']>;
  asin?: InputMaybe<Pv2AsinInput>;
  asinChildren?: InputMaybe<Array<Scalars['ObjectId']>>;
  attributes?: InputMaybe<Array<Pv2AttributeStructInput>>;
  barcode128?: InputMaybe<Scalars['String']>;
  barcodes?: InputMaybe<Array<BarcodeStructInput>>;
  brand?: InputMaybe<Scalars['ObjectId']>;
  /** Synchronized value from the circana:keycat attribute */
  circanaKeycat?: InputMaybe<Scalars['String']>;
  cleansedData?: InputMaybe<Scalars['ObjectId']>;
  companies?: InputMaybe<Array<Scalars['ObjectId']>>;
  containerChildren?: InputMaybe<Array<Scalars['ObjectId']>>;
  copy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  dataUpdatedDate?: InputMaybe<Scalars['DateTime']>;
  /** A list of domain IDs for which this Pv2 qualifies for visibility under GTIN de-duping logic */
  dedupeDomains?: InputMaybe<Array<Scalars['ObjectId']>>;
  deliveredToCircana?: InputMaybe<Scalars['Boolean']>;
  digitizationOutOfStock?: InputMaybe<Array<Pv2DigitizationOutOfStockInput>>;
  digitizationStatus?: InputMaybe<Pv2DigitizationStatusInput>;
  digitizationStoreDone?: InputMaybe<Pv2DigitizationStoreDoneInput>;
  digitizationStores?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Indicates if the stores list has ever been fully rebuilt. */
  digitizationStoresInitialized?: InputMaybe<Scalars['Boolean']>;
  discontinued?: InputMaybe<Pv2DiscontinuedInput>;
  exclusivity?: InputMaybe<Pv2ExclusivityInput>;
  /** A list of formulas that output one or more invalid attributes on the last run (and thus did not get saved). */
  failedFormulas?: InputMaybe<Array<Scalars['ObjectId']>>;
  firstDeliveredToSnapshot?: InputMaybe<Scalars['DateTime']>;
  /** Computed alias of barcodes[0].GTIN, or an empty string if there are no barcodes */
  gtin?: InputMaybe<Scalars['String']>;
  /** A flag indicating if failedFormulas is non-empty. */
  hasFailedFormulas?: InputMaybe<Scalars['Boolean']>;
  /** A flag indicating if invalidAttributeParents is non-empty. */
  hasInvalidAttributeParents?: InputMaybe<Scalars['Boolean']>;
  /**
   * Temporary field for SPINS hierarchy that behaves similarly to the taxonomies field. Ultimately this should
   * go away in favor of referencing SPINS hierarchy in the taxonomies field instead once the legacy Pinto
   * taxonomies are retired.
   */
  hierarchies?: InputMaybe<Array<Scalars['ObjectId']>>;
  hierarchyOverride?: InputMaybe<Pv2HierarchyOverrideEnum>;
  identifiers?: InputMaybe<Array<Pv2IdentifierInput>>;
  imageStatus?: InputMaybe<Pv2ImageStatusInput>;
  imageUpdatedDate?: InputMaybe<Scalars['DateTime']>;
  images?: InputMaybe<Array<Scalars['ObjectId']>>;
  imagesCount?: InputMaybe<Scalars['Float']>;
  ingestionMetadata?: InputMaybe<Array<Pv2IngestionMetadataInput>>;
  /**
   * The uids of attributes whose "parent" references an attribute uid that does not exist
   * on this Pv2. Only populated while parent validation is relaxed (i.e. the Pv2 is in the
   * pending or processing status); a non-empty list blocks promotion to the active status
   * and, for a copy, the merge back into its original.
   */
  invalidAttributeParents?: InputMaybe<Array<Scalars['String']>>;
  /** Indicates whether this Pv2 document is a draft version, i.e., the 'original' field is defined. */
  isCopy?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Pv2ItemTypeEnum>;
  lastVerification?: InputMaybe<Pv2LastVerificationInput>;
  /** Manufacturer is computed from brand, but can sometimes be null which computed doesn't seem to allow for */
  manufacturer?: InputMaybe<Scalars['ObjectId']>;
  maskedUpc?: InputMaybe<Scalars['String']>;
  mergedCopyPv2Ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Full product name, user-friendly */
  name?: InputMaybe<Scalars['String']>;
  needsVerification?: InputMaybe<Scalars['Boolean']>;
  notification?: InputMaybe<Pv2NotificationInput>;
  original?: InputMaybe<Scalars['ObjectId']>;
  /** Once new images are uploaded via the manager platform, all existing images are moved to outdatedImages for historical purposes */
  outdatedImages?: InputMaybe<Array<Scalars['ObjectId']>>;
  overrideBarcodeGtinGeneration?: InputMaybe<Scalars['Boolean']>;
  overrideExclusivity?: InputMaybe<Scalars['Boolean']>;
  parentGTIN?: InputMaybe<Scalars['String']>;
  processingPriority?: InputMaybe<Scalars['Float']>;
  pv2Ingredients?: InputMaybe<Array<Pv2Pv2IngredientsInput>>;
  /** URL-friendly unique identifier for this product. It is generated from the product name and updates every time the name or brand changes */
  slug?: InputMaybe<Scalars['String']>;
  /** - enum: "manager", "aperture", "metro-gs1", "foodfacts", "product-library", "circana", "amazon", "ix-one" */
  source?: InputMaybe<Scalars['String']>;
  spinsAttributesEligibilityOverride?: InputMaybe<Scalars['Boolean']>;
  spinsUpc?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Pv2StatusEnum>;
  tags?: InputMaybe<Array<TagStructInput>>;
  taskerStatus?: InputMaybe<Pv2TaskerStatusInput>;
  taxonomies?: InputMaybe<Array<Scalars['ObjectId']>>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  whitelists?: InputMaybe<Array<Scalars['ObjectId']>>;
}

export enum Pv2ItemType {
  Case = 'case',
  InnerPack = 'innerPack',
  Pallet = 'pallet',
  Unit = 'unit'
}

export enum Pv2ItemTypeEnum {
  Case = 'case',
  InnerPack = 'innerPack',
  Pallet = 'pallet',
  Unit = 'unit'
}

export interface Pv2LastVerification {
  _id?: Maybe<Scalars['ObjectId']>;
  date: Scalars['DateTime'];
  upToDate: Scalars['Boolean'];
  verifier?: Maybe<User>;
}

export interface Pv2LastVerificationInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  date?: InputMaybe<Scalars['DateTime']>;
  upToDate?: InputMaybe<Scalars['Boolean']>;
  verifier?: InputMaybe<Scalars['ObjectId']>;
}

export interface Pv2Notification {
  date: Scalars['DateTime'];
  userId?: Maybe<User>;
}

export interface Pv2NotificationInput {
  date?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['ObjectId']>;
}

export enum Pv2PermissionEnum {
  Discontinue = 'discontinue',
  Edit = 'edit'
}

export interface Pv2Preview {
  editableFields: Array<Pv2EditableField>;
  tables?: Maybe<Array<Maybe<Pv2PreviewTable>>>;
}

export interface Pv2PreviewTable {
  description?: Maybe<Scalars['String']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** If true, this table needs to be blurred out on the UI */
  needsUpgradeToAccess: Scalars['Boolean'];
  rows: Array<Pv2PreviewTableRow>;
  title: Scalars['String'];
}

export interface Pv2PreviewTableRow {
  /** The attributes from which this row was derived, if any */
  attributes?: Maybe<Array<Scalars['String']>>;
  /** Determines if this datapoint was sourced from the packaging or from a computation */
  computed?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use Pv2.preview.tables instead that already has the data grouped */
  group?: Maybe<Scalars['String']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** Human friendly name */
  label: Scalars['String'];
  source: Pv2InfoDocsSource;
  tooltip?: Maybe<Scalars['String']>;
  type: Pv2PreviewTableRowType;
  value?: Maybe<Scalars['JSON']>;
}

/** The type of the row to be rendered. All rows of the same type should be rendered the same way */
export enum Pv2PreviewTableRowType {
  Boolean = 'boolean',
  Json = 'json',
  Number = 'number',
  Text = 'text',
  Url = 'url'
}

export interface Pv2ProductSubmission {
  barcode: Scalars['String'];
  /** Data uploaded from the CSV file */
  data: Scalars['JSON'];
  images: Array<Pv2ProductSubmissionImage>;
}

export interface Pv2ProductSubmissionImage {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fileName: Scalars['String'];
  side: Pv2ProductSubmissionSide;
  source: Scalars['String'];
}

export interface Pv2ProductSubmissionSide {
  amazon?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['String']>;
  gs1?: InputMaybe<Scalars['String']>;
}

export interface Pv2Pv2Ingredients {
  componentType: Pv2Pv2IngredientsComponentTypeEnum;
  pv2Ingredient?: Maybe<Pv2Ingredient>;
}

export enum Pv2Pv2IngredientsComponentTypeEnum {
  Majority = 'majority',
  Parsed = 'parsed',
  ParsedCleaned = 'parsed_cleaned',
  Sanitized = 'sanitized'
}

export interface Pv2Pv2IngredientsInput {
  componentType?: InputMaybe<Pv2Pv2IngredientsComponentTypeEnum>;
  pv2Ingredient?: InputMaybe<Scalars['ObjectId']>;
}

/** Union of all valid Search Fields. It's not mean to be used as-is, instead spread on the different types and select each type's fields */
export type Pv2SearchField = AutocompleteSearchField | DateSearchField | EqualitySearchField | NestedSearchField | NumericalSearchField | SelectSearchField | StringSearchField;

export enum Pv2SearchFieldType {
  AutocompleteSearchField = 'AutocompleteSearchField',
  DateSearchField = 'DateSearchField',
  EqualitySearchField = 'EqualitySearchField',
  NestedSearchField = 'NestedSearchField',
  NumericalSearchField = 'NumericalSearchField',
  SelectSearchField = 'SelectSearchField',
  StringSearchField = 'StringSearchField'
}

export interface Pv2SearchResult {
  nodes: Array<Pv2>;
  pageInfo: PageInfo;
  /** The underlying Mongo query. Only useful for debugging purposes */
  query: Scalars['JSON'];
  total: Scalars['Int'];
}

export enum Pv2StatusEnum {
  Active = 'active',
  ActiveReprocessing = 'active_reprocessing',
  Disabled = 'disabled',
  Discontinued = 'discontinued',
  Draft = 'draft',
  Pending = 'pending',
  Processing = 'processing'
}

export interface Pv2SubmissionResult {
  date: Scalars['String'];
  images: Array<Pv2SubmissionUploadUrl>;
  numImages: Scalars['Int'];
  numProducts: Scalars['Int'];
  products: Array<Scalars['JSON']>;
  s3Prefix: Scalars['String'];
  submissionId: Scalars['String'];
  upcStandardizeOptions?: Maybe<Pv2SubmissionUpcStandardizeOptions>;
  userId: Scalars['String'];
}

export interface Pv2SubmissionUpcStandardizeOptions {
  addCheckDigit?: Maybe<Scalars['Boolean']>;
  shouldTrimLeadingZeros?: Maybe<Scalars['Boolean']>;
}

export interface Pv2SubmissionUploadUrl {
  barcode: Scalars['String'];
  imageIndex: Scalars['Int'];
  imageName: Scalars['String'];
  productIndex: Scalars['Int'];
  s3Key: Scalars['String'];
  source: Scalars['String'];
  uploadUrl: Scalars['String'];
}

export interface Pv2TaskerStatus {
  assigned: Scalars['Float'];
  async_done: Scalars['Float'];
  async_expired: Scalars['Float'];
  async_sent: Scalars['Float'];
  blocked: Scalars['Float'];
  cancelled: Scalars['Float'];
  disabled: Scalars['Float'];
  done: Scalars['Float'];
  doneDate?: Maybe<Scalars['DateTime']>;
  error: Scalars['Float'];
  invalid: Scalars['Float'];
  pending: Scalars['Float'];
  processing: Scalars['Float'];
  startDate?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Pv2TaskerStatusStateEnum>;
}

export interface Pv2TaskerStatusInput {
  assigned?: InputMaybe<Scalars['Float']>;
  async_done?: InputMaybe<Scalars['Float']>;
  async_expired?: InputMaybe<Scalars['Float']>;
  async_sent?: InputMaybe<Scalars['Float']>;
  blocked?: InputMaybe<Scalars['Float']>;
  cancelled?: InputMaybe<Scalars['Float']>;
  disabled?: InputMaybe<Scalars['Float']>;
  done?: InputMaybe<Scalars['Float']>;
  doneDate?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['Float']>;
  invalid?: InputMaybe<Scalars['Float']>;
  pending?: InputMaybe<Scalars['Float']>;
  processing?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<Pv2TaskerStatusStateEnum>;
}

export enum Pv2TaskerStatusStateEnum {
  Done = 'done',
  Pending = 'pending',
  Processing = 'processing'
}

export interface Pv2Verification {
  _id: Scalars['ObjectId'];
  date: Scalars['DateTime'];
  product?: Maybe<Pv2>;
  upToDate: Scalars['Boolean'];
  verifier?: Maybe<User>;
}

export interface Pv2VerificationFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Pv2Verification>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface Pv2VerificationInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  date?: InputMaybe<Scalars['DateTime']>;
  product?: InputMaybe<Scalars['ObjectId']>;
  upToDate?: InputMaybe<Scalars['Boolean']>;
  verifier?: InputMaybe<Scalars['ObjectId']>;
}

export interface Pv2WithImage {
  images: Array<Pv2Image>;
  pv2Domain: Scalars['String'];
  pv2GTIN: Scalars['String'];
  pv2Id: Scalars['ObjectId'];
  pv2Name: Scalars['String'];
}

export interface Pv2sByIngredientsSearchResult {
  count: Scalars['Int'];
  results: Array<Pv2FromIngredientResultItem>;
}

export interface QcSelfServeCheckCountRow {
  checkDescription?: Maybe<Scalars['String']>;
  checkId: Scalars['String'];
  count: Scalars['Int'];
}

export interface QcSelfServeCheckDescriptionCounts {
  rows: Array<QcSelfServeCheckCountRow>;
  totalRowCount: Scalars['Int'];
}

export interface QcSelfServeFilter {
  brand?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Array<Scalars['String']>>;
  checkId?: InputMaybe<Array<Scalars['String']>>;
  daysSinceFlaggedMax?: InputMaybe<Scalars['Int']>;
  daysSinceFlaggedMin?: InputMaybe<Scalars['Int']>;
  delivered?: InputMaybe<Scalars['Boolean']>;
  department?: InputMaybe<Array<Scalars['String']>>;
  firstFlaggedFrom?: InputMaybe<Scalars['String']>;
  firstFlaggedTo?: InputMaybe<Scalars['String']>;
  lowConfidence?: InputMaybe<Scalars['Boolean']>;
  productType?: InputMaybe<Array<Scalars['String']>>;
  pv2Id?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<Scalars['String']>>;
  spinsUpc?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  subcategory?: InputMaybe<Array<Scalars['String']>>;
  team?: InputMaybe<Array<Scalars['String']>>;
}

export interface QcSelfServeFilterOptions {
  category: Array<Scalars['String']>;
  checkId: Array<Scalars['String']>;
  department: Array<Scalars['String']>;
  productType: Array<Scalars['String']>;
  source: Array<Scalars['String']>;
  status: Array<Scalars['String']>;
  subcategory: Array<Scalars['String']>;
  team: Array<Scalars['String']>;
}

export interface QcSelfServeRows {
  rows: Array<AnalyticsQcSelfServe>;
  totalRowCount: Scalars['Int'];
}

export interface QcSelfServeRunAnalysisResponse {
  error?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['String']>;
  scriptLogsUrl?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
}

export interface QcSelfServeSummary {
  dadCount: Scalars['Int'];
  lastUpdatedDate?: Maybe<Scalars['String']>;
  prCount: Scalars['Int'];
  totalCount: Scalars['Int'];
}

export interface Query {
  /** Status Filter for Item Activation Report */
  ActivationStatusFilter: Array<ActivationStatusFilter>;
  AliasMapping?: Maybe<AliasMapping>;
  AliasMapping_count?: Maybe<Scalars['Int']>;
  AliasMapping_find?: Maybe<AliasMappingFindResult>;
  AliasMapping_query?: Maybe<Array<AliasMapping>>;
  AliasMapping_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  AmazonProduct?: Maybe<AmazonProduct>;
  AmazonProduct_count?: Maybe<Scalars['Int']>;
  AmazonProduct_find?: Maybe<AmazonProductFindResult>;
  AmazonProduct_query?: Maybe<Array<AmazonProduct>>;
  AmazonProduct_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  AnalyticsClientFeedbackJiraIssue?: Maybe<AnalyticsClientFeedbackJiraIssue>;
  AnalyticsClientFeedbackJiraIssue_count?: Maybe<Scalars['Int']>;
  AnalyticsClientFeedbackJiraIssue_find?: Maybe<AnalyticsClientFeedbackJiraIssueFindResult>;
  AnalyticsClientFeedbackJiraIssue_query?: Maybe<Array<AnalyticsClientFeedbackJiraIssue>>;
  AnalyticsClientFeedbackJiraIssue_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  AnalyticsClientFeedbackSpinsAttribute?: Maybe<AnalyticsClientFeedbackSpinsAttribute>;
  AnalyticsClientFeedbackSpinsAttribute_count?: Maybe<Scalars['Int']>;
  AnalyticsClientFeedbackSpinsAttribute_find?: Maybe<AnalyticsClientFeedbackSpinsAttributeFindResult>;
  AnalyticsClientFeedbackSpinsAttribute_query?: Maybe<Array<AnalyticsClientFeedbackSpinsAttribute>>;
  AnalyticsClientFeedbackSpinsAttribute_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  AnalyticsClientFeedbackTrackerUpdate?: Maybe<AnalyticsClientFeedbackTrackerUpdate>;
  AnalyticsClientFeedbackTrackerUpdate_count?: Maybe<Scalars['Int']>;
  AnalyticsClientFeedbackTrackerUpdate_find?: Maybe<AnalyticsClientFeedbackTrackerUpdateFindResult>;
  AnalyticsClientFeedbackTrackerUpdate_query?: Maybe<Array<AnalyticsClientFeedbackTrackerUpdate>>;
  AnalyticsClientFeedbackTrackerUpdate_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  AnalyticsOperationalKPI?: Maybe<AnalyticsOperationalKpi>;
  AnalyticsOperationalKPI_count?: Maybe<Scalars['Int']>;
  AnalyticsOperationalKPI_find?: Maybe<AnalyticsOperationalKpiFindResult>;
  AnalyticsOperationalKPI_query?: Maybe<Array<AnalyticsOperationalKpi>>;
  AnalyticsOperationalKPI_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  AnalyticsProductCount?: Maybe<AnalyticsProductCount>;
  AnalyticsProductCount_count?: Maybe<Scalars['Int']>;
  AnalyticsProductCount_find?: Maybe<AnalyticsProductCountFindResult>;
  AnalyticsProductCount_query?: Maybe<Array<AnalyticsProductCount>>;
  AnalyticsProductCount_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  AnalyticsQCSelfServe?: Maybe<AnalyticsQcSelfServe>;
  AnalyticsQCSelfServe_count?: Maybe<Scalars['Int']>;
  AnalyticsQCSelfServe_find?: Maybe<AnalyticsQcSelfServeFindResult>;
  AnalyticsQCSelfServe_query?: Maybe<Array<AnalyticsQcSelfServe>>;
  AnalyticsQCSelfServe_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  ApertureAnnotation?: Maybe<ApertureAnnotation>;
  ApertureAnnotation_count?: Maybe<Scalars['Int']>;
  ApertureAnnotation_find?: Maybe<ApertureAnnotationFindResult>;
  ApertureAnnotation_query?: Maybe<Array<ApertureAnnotation>>;
  ApertureAnnotation_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /**
   * Queries attribute-level ASIN and sales coverage from BigQuery.
   * Filterable by top25Attribute, displayName, and attributeThemeType.
   * Sortable by any column (ASC or DESC).
   */
  AsinAttributeLevelCoverage: Array<AsinAttributeLevelCoverageResult>;
  /**
   * Attribute Name and Theme Filter for ASIN Coverage.
   * Pass department, category, or subcategory to scope the options to that hierarchy.
   */
  AsinCoverageAttributeThemeFilter: Array<AsinCoverageAttributeThemeFilter>;
  /** Brand Filter for ASIN Coverage */
  AsinCoverageBrandFilter: Array<AsinCoverageBrandFilter>;
  /** Hierarchy Filter for ASIN Coverage */
  AsinCoverageHierarchyFilter: Array<AsinCoverageHierarchyFilter>;
  /**
   * Queries ASIN-level coverage and sales from BigQuery.
   * Filterable by asin (prefix match), brand, department, category, subcategory,
   * top25Attribute, displayName, and attributeThemeType.
   * Sortable by any column (ASC or DESC).
   */
  AsinLevelCoverage: AsinLevelCoveragePage;
  /**
   * Queries subcategory-level ASIN and sales coverage from BigQuery.
   * Filterable by department, category, subcategory,
   * top25Attribute, displayName, and attributeThemeType.
   * Sortable by any column (ASC or DESC).
   */
  AsinSubcategoryLevelCoverage: Array<AsinSubcategoryLevelCoverageResult>;
  /**
   * Attribute Name and Theme Filter for Attribute Coverage.
   * Pass department, category, or subcategory to scope the options to that hierarchy;
   * geography and time narrow the clustered subcategory table scan.
   */
  AttributeCoverageAttributeThemeFilter: Array<AttributeCoverageAttributeThemeFilter>;
  /** Brand Filter for Attribute Coverage */
  AttributeCoverageBrandFilter: Array<AttributeCoverageBrandFilter>;
  /** Hierarchy Filter for Attribute Coverage */
  AttributeCoverageHierarchyFilter: Array<AttributeCoverageHierarchyFilter>;
  /**
   * Queries attribute-level UPC and sales coverage from BigQuery.
   * Filterable by geography, time, top25Attribute, displayName, and attributeThemeType.
   * Sortable by any column (ASC or DESC).
   */
  AttributeLevelCoverage: Array<AttributeLevelCoverageResult>;
  /** Queries the AttributeSalesAssessment results from BigQuery. */
  AttributeSalesAssessment: Array<AttributeSalesAssessmentResult>;
  /** Returns high-level statistics for the dataset. */
  AttributeSalesAssessmentStats: AttributeSalesAssessmentStats;
  /** Returns aggregations grouped by selected field. */
  AttributeSalesAssessmentTotals: Array<AttributeSalesAssessmentAggregation>;
  /**
   * Returns all valid builder_batch_id and report_run_id combinations.
   * Used to power UI filters.
   */
  AttributeSalesFilterCombos: Array<AttributeSalesFilterCombo>;
  AutoNotifications?: Maybe<AutoNotifications>;
  AutoNotifications_count?: Maybe<Scalars['Int']>;
  AutoNotifications_find?: Maybe<AutoNotificationsFindResult>;
  AutoNotifications_query?: Maybe<Array<AutoNotifications>>;
  AutoNotifications_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  BrandReview?: Maybe<BrandReview>;
  BrandReview_count?: Maybe<Scalars['Int']>;
  BrandReview_find?: Maybe<BrandReviewFindResult>;
  BrandReview_query?: Maybe<Array<BrandReview>>;
  BrandReview_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  BuilderBatch?: Maybe<BuilderBatch>;
  BuilderBatch_count?: Maybe<Scalars['Int']>;
  BuilderBatch_find?: Maybe<BuilderBatchFindResult>;
  BuilderBatch_query?: Maybe<Array<BuilderBatch>>;
  BuilderBatch_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /**
   * Recent builder recompute runs, newest first, each resolved to its Dataflow job so the pipeline
   * can be opened directly rather than hunted for in the Dataflow job list.
   *
   * Airflow is the source of truth: the run conf carries everything needed to describe the run.
   */
  BuilderRecomputeRuns: Array<BuilderRecomputeRun>;
  CircanaBrandMapping?: Maybe<CircanaBrandMapping>;
  CircanaBrandMapping_count?: Maybe<Scalars['Int']>;
  CircanaBrandMapping_find?: Maybe<CircanaBrandMappingFindResult>;
  CircanaBrandMapping_query?: Maybe<Array<CircanaBrandMapping>>;
  CircanaBrandMapping_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  CleansedData?: Maybe<CleansedData>;
  CleansedData_count?: Maybe<Scalars['Int']>;
  CleansedData_find?: Maybe<CleansedDataFindResult>;
  CleansedData_query?: Maybe<Array<CleansedData>>;
  CleansedData_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /**
   * Windowed distinct JIRA ticket counts per client-tracker attribute, with the deviation
   * from each attribute's 52-week weekly average. Joins tracker attributes to JIRA issues.
   */
  ClientFeedbackAttributeTrends: ClientFeedbackAttributeTrends;
  /**
   * Distinct UPC and JIRA ticket counts per client-tracker attribute, with attribute values
   * nested under each attribute. Sourced entirely from the tracker collection.
   */
  ClientFeedbackAttributeUpdates: ClientFeedbackAttributeUpdates;
  /**
   * Distinct UPC and JIRA ticket counts per SPINS category (subcategories nested under each),
   * joining client-tracker updates to the spins-attributes dimension on spinsUpc.
   */
  ClientFeedbackCategoryUpdates: ClientFeedbackCategoryUpdates;
  /** Distinct JIRA client names, for the Client Feedback page filter. */
  ClientFeedbackClientNames: Array<Scalars['String']>;
  /** Distinct tracker period releases, for the Client Feedback page filter. */
  ClientFeedbackPeriodReleases: Array<Scalars['String']>;
  /**
   * Per-UPC attribute updates from the client tracker, enriched with spins product
   * attributes. Grain is one row per spinsUpc / attribute / value / period release.
   */
  ClientFeedbackProductUpdates: ClientFeedbackProductUpdates;
  /** Distinct JIRA ticket count per root cause. */
  ClientFeedbackRootCauses: Array<ClientFeedbackRootCauseRow>;
  /**
   * JIRA tickets with the distinct count of spinsUpc updated in each, for extract and
   * communication purposes. UPC counts come from the tracker collection.
   */
  ClientFeedbackTicketExtract: ClientFeedbackTicketExtract;
  /**
   * Windowed distinct JIRA ticket counts per client and per component, with the deviation
   * from each client/component's 52-week weekly average. Counts use the issue created date.
   */
  ClientFeedbackTicketTrends: Array<ClientFeedbackTicketTrendRow>;
  /**
   * Distinct JIRA tickets and UPCs per client, from the analyticsclientfeedback collections.
   * Each JIRA issue has exactly one client, so summing ticketCount yields the total distinct
   * ticket count used for percentTotalTickets.
   */
  ClientFeedbackWhoIsSubmitting: Array<ClientFeedbackWhoIsSubmittingRow>;
  ClientTrackerIncorrectAttributeName: ClientTrackerIncorrectAttributeNamePage;
  ClientTrackerMismatches: ClientTrackerMismatchesPage;
  ClientTrackerValue?: Maybe<ClientTrackerValue>;
  ClientTrackerValue_count?: Maybe<Scalars['Int']>;
  ClientTrackerValue_find?: Maybe<ClientTrackerValueFindResult>;
  ClientTrackerValue_query?: Maybe<Array<ClientTrackerValue>>;
  ClientTrackerValue_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Company?: Maybe<Company>;
  CompanySignupRequest?: Maybe<CompanySignupRequest>;
  CompanySignupRequest_count?: Maybe<Scalars['Int']>;
  CompanySignupRequest_find?: Maybe<CompanySignupRequestFindResult>;
  CompanySignupRequest_query?: Maybe<Array<CompanySignupRequest>>;
  CompanySignupRequest_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Company_count?: Maybe<Scalars['Int']>;
  Company_find?: Maybe<CompanyFindResult>;
  Company_query?: Maybe<Array<Company>>;
  Company_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Config?: Maybe<Config>;
  Config_count?: Maybe<Scalars['Int']>;
  Config_find?: Maybe<ConfigFindResult>;
  Config_query?: Maybe<Array<Config>>;
  Config_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Returns public configs */
  Config_queryPublic: Array<Config>;
  /** Returns total cost for the last 30 days, broken out by source (GCP, Mongo, Snowflake) */
  Cost_And_Billing_Daily: Array<TotalCostDaily>;
  /** Returns total cost per month, broken out by source (GCP, Mongo, Snowflake) */
  Cost_And_Billing_Monthly: Array<TotalCostPerMonth>;
  /**
   * Counts the number of image documents that fulfills the provided arguments. If no filters are provided, attempts to
   * return all the image documents associated with at least one Pv2. Due to the potentially large size, make sure to
   * have handling for possible timeouts.
   */
  CountImagesToProcess?: Maybe<Scalars['Int']>;
  DeleteHistory?: Maybe<DeleteHistory>;
  DeleteHistory_count?: Maybe<Scalars['Int']>;
  DeleteHistory_find?: Maybe<DeleteHistoryFindResult>;
  DeleteHistory_query?: Maybe<Array<DeleteHistory>>;
  DeleteHistory_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  DigitizationUpcScan?: Maybe<DigitizationUpcScan>;
  DigitizationUpcScan_count?: Maybe<Scalars['Int']>;
  DigitizationUpcScan_find?: Maybe<DigitizationUpcScanFindResult>;
  DigitizationUpcScan_query?: Maybe<Array<DigitizationUpcScan>>;
  DigitizationUpcScan_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  DigitizationUpdate?: Maybe<DigitizationUpdate>;
  DigitizationUpdate_count?: Maybe<Scalars['Int']>;
  DigitizationUpdate_find?: Maybe<DigitizationUpdateFindResult>;
  DigitizationUpdate_query?: Maybe<Array<DigitizationUpdate>>;
  DigitizationUpdate_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  DigitizationUserStatus?: Maybe<DigitizationUserStatus>;
  DigitizationUserStatus_count?: Maybe<Scalars['Int']>;
  DigitizationUserStatus_find?: Maybe<DigitizationUserStatusFindResult>;
  DigitizationUserStatus_query?: Maybe<Array<DigitizationUserStatus>>;
  DigitizationUserStatus_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Digitization_domains: Array<DigitizationDomain>;
  Digitization_products: DigitizationProductsResult;
  Digitization_pv2Verification?: Maybe<DigitizationPv2VerificationResult>;
  Domain?: Maybe<Domain>;
  Domain_count?: Maybe<Scalars['Int']>;
  Domain_find?: Maybe<DomainFindResult>;
  Domain_query?: Maybe<Array<Domain>>;
  Domain_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Creates a zip file of images in the image processing queue and uploads zip to S3 */
  DownloadImages: Images;
  EnvironmentInfo_get: EnvironmentInfo;
  FeatureFlagConfiguration?: Maybe<FeatureFlagConfiguration>;
  FeatureFlagConfiguration_count?: Maybe<Scalars['Int']>;
  FeatureFlagConfiguration_find?: Maybe<FeatureFlagConfigurationFindResult>;
  FeatureFlagConfiguration_query?: Maybe<Array<FeatureFlagConfiguration>>;
  FeatureFlagConfiguration_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Returns a list of all feature flags with their enabled state and description */
  FeatureFlags_get: Array<FeatureFlagInfo>;
  /** returns all existing `Image.side` values */
  FetchImageSides: ImageSides;
  /** returns all existing `Image.source` values */
  FetchImageSources: ImageSources;
  /** Finds images to process */
  FindImagesToProcess: Array<Pv2WithImage>;
  Form?: Maybe<Form>;
  FormInstruction?: Maybe<FormInstruction>;
  FormInstruction_count?: Maybe<Scalars['Int']>;
  FormInstruction_find?: Maybe<FormInstructionFindResult>;
  FormInstruction_query?: Maybe<Array<FormInstruction>>;
  FormInstruction_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Form_count?: Maybe<Scalars['Int']>;
  Form_find?: Maybe<FormFindResult>;
  Form_query?: Maybe<Array<Form>>;
  Form_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Formula?: Maybe<Formula>;
  FormulaResource?: Maybe<FormulaResource>;
  FormulaResource_count?: Maybe<Scalars['Int']>;
  FormulaResource_find?: Maybe<FormulaResourceFindResult>;
  FormulaResource_query?: Maybe<Array<FormulaResource>>;
  FormulaResource_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Formula_count?: Maybe<Scalars['Int']>;
  Formula_find?: Maybe<FormulaFindResult>;
  Formula_query?: Maybe<Array<Formula>>;
  Formula_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  GS1TaxonomyMapping?: Maybe<Gs1TaxonomyMapping>;
  GS1TaxonomyMapping_count?: Maybe<Scalars['Int']>;
  GS1TaxonomyMapping_find?: Maybe<Gs1TaxonomyMappingFindResult>;
  GS1TaxonomyMapping_query?: Maybe<Array<Gs1TaxonomyMapping>>;
  GS1TaxonomyMapping_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  GcpScriptLog?: Maybe<GcpScriptLog>;
  GcpScriptLog_count?: Maybe<Scalars['Int']>;
  GcpScriptLog_find?: Maybe<GcpScriptLogFindResult>;
  GcpScriptLog_query?: Maybe<Array<GcpScriptLog>>;
  GcpScriptLog_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Generates a new token to authorize GCP requests */
  GenerateToken: GcpAccessToken;
  GetAllServices: Array<Service>;
  /** Returns a signed GCP file link for downloading a file on manager */
  GetPublicSignedFileLink: GetPublicSignedFileLink;
  /** Returns a signed GCP file link for downloading a file on the frontend */
  GetSignedFileLink: SignedFileLink;
  HierarchyAllowedValues?: Maybe<HierarchyAllowedValues>;
  HierarchyAllowedValues_count?: Maybe<Scalars['Int']>;
  HierarchyAllowedValues_find?: Maybe<HierarchyAllowedValuesFindResult>;
  HierarchyAllowedValues_query?: Maybe<Array<HierarchyAllowedValues>>;
  HierarchyAllowedValues_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  HierarchyMapping?: Maybe<HierarchyMapping>;
  HierarchyMapping_bulkEvaluate: HierarchyMappingBulkEvaluationResult;
  HierarchyMapping_count?: Maybe<Scalars['Int']>;
  HierarchyMapping_evaluate?: Maybe<HierarchyMappingEvaluationResult>;
  HierarchyMapping_find?: Maybe<HierarchyMappingFindResult>;
  HierarchyMapping_query?: Maybe<Array<HierarchyMapping>>;
  HierarchyMapping_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Get list of historical versions of a given API model */
  HistoryGet: Array<ModelHistory>;
  /** Get a specific historical version of a given API model */
  HistoryGetVersion?: Maybe<ModelHistory>;
  Image?: Maybe<Image>;
  /** Returns information about the annotator like the available annotations */
  ImageAnnotator_info: ImageAnnotatorInfo;
  /** Returns number of images in Image Processing Queue */
  ImageProcessingQueueStats: Stats;
  Image_count?: Maybe<Scalars['Int']>;
  Image_find?: Maybe<ImageFindResult>;
  Image_query?: Maybe<Array<Image>>;
  Image_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Ingestion?: Maybe<Ingestion>;
  Ingestion_count?: Maybe<Scalars['Int']>;
  Ingestion_find?: Maybe<IngestionFindResult>;
  Ingestion_query?: Maybe<Array<Ingestion>>;
  Ingestion_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Returns the total number of pv2s that contain the ingredient id, what taxonomies they fall under, what attributes their pv2s have, and how many pv2s belong to the taxonomy for that ingredient. */
  IngredientDetails?: Maybe<IngredientDetailsResult>;
  IngredientFormulaReferences?: Maybe<Array<IngredientFormulaReferences>>;
  Jwt?: Maybe<Jwt>;
  Jwt_count?: Maybe<Scalars['Int']>;
  Jwt_find?: Maybe<JwtFindResult>;
  Jwt_query?: Maybe<Array<Jwt>>;
  Jwt_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  LockedValues?: Maybe<LockedValues>;
  LockedValues_count?: Maybe<Scalars['Int']>;
  LockedValues_find?: Maybe<LockedValuesFindResult>;
  LockedValues_query?: Maybe<Array<LockedValues>>;
  LockedValues_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  MaskedUpc?: Maybe<MaskedUpc>;
  MaskedUpc_count?: Maybe<Scalars['Int']>;
  MaskedUpc_find?: Maybe<MaskedUpcFindResult>;
  MaskedUpc_query?: Maybe<Array<MaskedUpc>>;
  MaskedUpc_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Model: ModelResult;
  /**
   * Runs a read-only MongoDB aggregation pipeline against a model.
   *
   * Stage values accept the same sugar as the other model queries ("~text" => /text/i,
   * "text~" => /^text/i, "#date +/- N unit" for relative dates, and 24-char hex strings become
   * ObjectIds).
   *
   * Write operators ($out, $merge) are rejected anywhere in the pipeline. Server-side JavaScript
   * ($function, $accumulator, $where) is permitted — it can compute but not write.
   *
   * A final $limit is always appended, defaulting to 1000 and capped at 1000000.
   *
   * Set "sample" to also return the intermediate output of each stage (capped at
   * 5 documents each). That runs one additional aggregation per
   * stage, so leave it off for expensive pipelines.
   */
  ModelAggregate: ModelAggregateResult;
  /** Returns the count of records for a given model based on an optional query filter. */
  ModelCount: Scalars['Int'];
  /** Returns all distinct values and their counts for a given Model + field */
  ModelDistinctCount: Array<ModelDistinctItem>;
  /** Fetches a single document by _id in the given model */
  ModelFindById?: Maybe<Scalars['JSON']>;
  /** Fetches records based on query. */
  ModelFindMany: Array<Scalars['JSON']>;
  /**
   * Returns the record count for each of the given tag names on a model.
   *
   * Counts are resolved with one indexed equality query per name rather than an aggregation,
   * which is what keeps this usable on collections with millions of records. At most
   * 250 names may be requested at a time — use ModelTagNames
   * to get the full list and request it in chunks.
   */
  ModelTagCounts: Array<ModelTagCount>;
  /**
   * Returns every distinct tag name present on a model's tags field, sorted alphabetically.
   *
   * This is index-backed and stays fast on very large collections. Use ModelTagCounts to
   * fetch the record counts for these names in chunks.
   */
  ModelTagNames: Array<Scalars['String']>;
  /**
   * Returns schema metadata for every model. Use the single Model query when you need the
   * columns for one specific model.
   */
  Models: Array<ModelSummary>;
  MturkHIT?: Maybe<MturkHit>;
  MturkHIT_count?: Maybe<Scalars['Int']>;
  MturkHIT_find?: Maybe<MturkHitFindResult>;
  MturkHIT_query?: Maybe<Array<MturkHit>>;
  MturkHIT_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  MturkWorker?: Maybe<MturkWorker>;
  MturkWorker_count?: Maybe<Scalars['Int']>;
  MturkWorker_find?: Maybe<MturkWorkerFindResult>;
  MturkWorker_query?: Maybe<Array<MturkWorker>>;
  MturkWorker_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Queries new item activation statuses and change report data. */
  NewItemActivation: Array<NewItemActivation>;
  /** Provides Counts for new item activation statuses and change report. */
  NewItemActivationCount: Array<NewItemActivationCount>;
  NfpAttributeMapping?: Maybe<NfpAttributeMapping>;
  NfpAttributeMapping_count?: Maybe<Scalars['Int']>;
  NfpAttributeMapping_find?: Maybe<NfpAttributeMappingFindResult>;
  NfpAttributeMapping_query?: Maybe<Array<NfpAttributeMapping>>;
  NfpAttributeMapping_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Period?: Maybe<Period>;
  Period_count?: Maybe<Scalars['Int']>;
  Period_find?: Maybe<PeriodFindResult>;
  Period_query?: Maybe<Array<Period>>;
  Period_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  PreProductionNtc?: Maybe<PreProductionNtc>;
  PreProductionNtc_count?: Maybe<Scalars['Int']>;
  PreProductionNtc_find?: Maybe<PreProductionNtcFindResult>;
  PreProductionNtc_query?: Maybe<Array<PreProductionNtc>>;
  PreProductionNtc_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  PreProductionNtu?: Maybe<PreProductionNtu>;
  PreProductionNtu_count?: Maybe<Scalars['Int']>;
  PreProductionNtu_find?: Maybe<PreProductionNtuFindResult>;
  PreProductionNtu_query?: Maybe<Array<PreProductionNtu>>;
  PreProductionNtu_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  PredictionOverride?: Maybe<PredictionOverride>;
  /**
   * The values each attribution agent attribute may be overridden to for a product in the given
   * SPINS subcategory: its HierarchyAllowedValues for the subcategory or, where the subcategory
   * does not restrict the attribute, all of the attribute's SnapshotTags. Attributes with neither
   * are omitted, as is everything when the subcategory is not a SPINS subcategory.
   */
  PredictionOverride_allowedValues: Array<PredictionOverrideAllowedValues>;
  PredictionOverride_count?: Maybe<Scalars['Int']>;
  PredictionOverride_find?: Maybe<PredictionOverrideFindResult>;
  PredictionOverride_query?: Maybe<Array<PredictionOverride>>;
  PredictionOverride_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  PrivateLabelPermanentProduct?: Maybe<PrivateLabelPermanentProduct>;
  PrivateLabelPermanentProduct_count?: Maybe<Scalars['Int']>;
  PrivateLabelPermanentProduct_find?: Maybe<PrivateLabelPermanentProductFindResult>;
  PrivateLabelPermanentProduct_query?: Maybe<Array<PrivateLabelPermanentProduct>>;
  PrivateLabelPermanentProduct_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  PrivateLabelProduct?: Maybe<PrivateLabelProduct>;
  PrivateLabelProduct_count?: Maybe<Scalars['Int']>;
  PrivateLabelProduct_find?: Maybe<PrivateLabelProductFindResult>;
  PrivateLabelProduct_query?: Maybe<Array<PrivateLabelProduct>>;
  PrivateLabelProduct_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  ProductEditRequest?: Maybe<ProductEditRequest>;
  ProductEditRequest_count?: Maybe<Scalars['Int']>;
  ProductEditRequest_find?: Maybe<ProductEditRequestFindResult>;
  ProductEditRequest_query?: Maybe<Array<ProductEditRequest>>;
  ProductEditRequest_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  ProductSentToTarget?: Maybe<ProductSentToTarget>;
  ProductSentToTarget_count?: Maybe<Scalars['Int']>;
  ProductSentToTarget_find?: Maybe<ProductSentToTargetFindResult>;
  ProductSentToTarget_query?: Maybe<Array<ProductSentToTarget>>;
  ProductSentToTarget_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Pv2?: Maybe<Pv2>;
  Pv2AttributeDefinition?: Maybe<Pv2AttributeDefinition>;
  Pv2AttributeDefinition_attributeMatches?: Maybe<Scalars['JSON']>;
  Pv2AttributeDefinition_count?: Maybe<Scalars['Int']>;
  Pv2AttributeDefinition_createAttributeSchema?: Maybe<Scalars['JSON']>;
  Pv2AttributeDefinition_find?: Maybe<Pv2AttributeDefinitionFindResult>;
  Pv2AttributeDefinition_query?: Maybe<Array<Pv2AttributeDefinition>>;
  Pv2AttributeDefinition_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /**
   * Returns the value subschema fields for all attribute types. NOTE: this is introspecting the JSON schemas
   * present in the Pv2AttributeDefinition collection, which are not able to represent date or _id fields
   * as distinct from type "string", so if that is something needed (say, for advanced search UI) make sure
   * to cross reference against the results for Pv2.attributes from the Model.columns endpoint.
   * (And there is currently no way to distinguish dates in value schemas from strings.)
   */
  Pv2AttributeDefinitions_schemaFieldsWithTypes: Array<AttributeTypeWithFieldTypes>;
  Pv2CustomFieldConfig?: Maybe<Pv2CustomFieldConfig>;
  Pv2CustomFieldConfig_count?: Maybe<Scalars['Int']>;
  Pv2CustomFieldConfig_find?: Maybe<Pv2CustomFieldConfigFindResult>;
  Pv2CustomFieldConfig_query?: Maybe<Array<Pv2CustomFieldConfig>>;
  Pv2CustomFieldConfig_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Pv2Ingredient?: Maybe<Pv2Ingredient>;
  Pv2Ingredient_count?: Maybe<Scalars['Int']>;
  Pv2Ingredient_find?: Maybe<Pv2IngredientFindResult>;
  Pv2Ingredient_query?: Maybe<Array<Pv2Ingredient>>;
  Pv2Ingredient_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Pv2Ingredients_search: Pv2IngredientsSearchResult;
  Pv2Verification?: Maybe<Pv2Verification>;
  Pv2Verification_count?: Maybe<Scalars['Int']>;
  Pv2Verification_find?: Maybe<Pv2VerificationFindResult>;
  Pv2Verification_query?: Maybe<Array<Pv2Verification>>;
  Pv2Verification_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /**
   * Returns all Pv2 Editable Fields regardless of permissions.
   *
   * NOTE: when editing an existing Pv2, use the `Pv2Type.preview.editableFields` instead since that returns all the relevant editable fields to that specific document, as well as the proper values
   */
  Pv2_allEditableFields: Array<Pv2EditableField>;
  Pv2_count?: Maybe<Scalars['Int']>;
  Pv2_find?: Maybe<Pv2FindResult>;
  /** Returns useful constants used in the Pv2 queries / mutations */
  Pv2_info?: Maybe<Pv2Info>;
  Pv2_query?: Maybe<Array<Pv2>>;
  Pv2_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /**
   * Performs a search given a search expression derived from `Pv2_info.searchFields`
   *
   * See the description of each SearchField type to gets its equivalent Pv2_search result
   */
  Pv2_search?: Maybe<Pv2SearchResult>;
  /** Similar to Pv2_search, just returns a list of product IDs instead */
  Pv2_searchIds: Array<Scalars['ObjectId']>;
  /** Query to return a set of Pv2s which contain the provided ingredient strings. For Pv2s with multiple GTINs, multiple instances of the same Pv2 will be returned for each GTIN. Pv2s without barcodes will NOT be included. */
  Pv2sByIngredients_search: Pv2sByIngredientsSearchResult;
  /**
   * Brands starting with the given search text, for the QC Self-Serve brand filter typeahead.
   * Brands are stored uppercase, so the search is uppercased and matched as an anchored prefix
   * against the { team, brand } index. Pass team to scope the options to a single team; without
   * one, every team is matched explicitly so the index can still be used.
   */
  QCSelfServeBrandOptions: Array<Scalars['String']>;
  /** Triggered check counts per checkId, sorted descending, for the QC Self-Serve bar chart. */
  QCSelfServeCheckCounts: Array<QcSelfServeCheckCountRow>;
  /**
   * Triggered check counts per checkId + checkDescription pair, for the QC Self-Serve count
   * table.
   */
  QCSelfServeCheckDescriptionCounts: QcSelfServeCheckDescriptionCounts;
  /**
   * Distinct values for the QC Self-Serve filter dropdowns. Pass team to scope the options to a
   * single team.
   */
  QCSelfServeFilterOptions: QcSelfServeFilterOptions;
  /**
   * Row-level QC Self-Serve records for the data table and CSV export. Supports filtering,
   * sorting by an allow-listed column, and offset/limit paging.
   */
  QCSelfServeRows: QcSelfServeRows;
  /**
   * Aggregate row counts for the QC Self-Serve report: all records, DA&D records and PR
   * records and most recent updatedDate.
   */
  QCSelfServeSummary: QcSelfServeSummary;
  RawIngestionData?: Maybe<RawIngestionData>;
  RawIngestionData_count?: Maybe<Scalars['Int']>;
  RawIngestionData_find?: Maybe<RawIngestionDataFindResult>;
  RawIngestionData_query?: Maybe<Array<RawIngestionData>>;
  RawIngestionData_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  RawIngestionEvent?: Maybe<RawIngestionEvent>;
  RawIngestionEvent_count?: Maybe<Scalars['Int']>;
  RawIngestionEvent_find?: Maybe<RawIngestionEventFindResult>;
  RawIngestionEvent_query?: Maybe<Array<RawIngestionEvent>>;
  RawIngestionEvent_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  RetailItemsExtract?: Maybe<RetailItemsExtract>;
  RetailItemsExtract_count?: Maybe<Scalars['Int']>;
  RetailItemsExtract_find?: Maybe<RetailItemsExtractFindResult>;
  RetailItemsExtract_query?: Maybe<Array<RetailItemsExtract>>;
  RetailItemsExtract_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  RetailerPrivateLabel?: Maybe<RetailerPrivateLabel>;
  RetailerPrivateLabel_count?: Maybe<Scalars['Int']>;
  RetailerPrivateLabel_find?: Maybe<RetailerPrivateLabelFindResult>;
  RetailerPrivateLabel_query?: Maybe<Array<RetailerPrivateLabel>>;
  RetailerPrivateLabel_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Script?: Maybe<Script>;
  ScriptInfo?: Maybe<ScriptMetadata>;
  Script_count?: Maybe<Scalars['Int']>;
  Script_find?: Maybe<ScriptFindResult>;
  Script_query?: Maybe<Array<Script>>;
  Script_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Get data about scripts to run from Admin-v2 */
  ScriptsList: Array<ScriptMetadata>;
  /** Returns information about the annotator like the available annotations */
  ServiceHeartbeat_check?: Maybe<Array<ServiceHeartbeatCheck>>;
  ServicesHeartbeat?: Maybe<ServicesHeartbeat>;
  ServicesHeartbeat_count?: Maybe<Scalars['Int']>;
  ServicesHeartbeat_find?: Maybe<ServicesHeartbeatFindResult>;
  ServicesHeartbeat_query?: Maybe<Array<ServicesHeartbeat>>;
  ServicesHeartbeat_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  SnapshotTags?: Maybe<SnapshotTags>;
  SnapshotTags_count?: Maybe<Scalars['Int']>;
  SnapshotTags_find?: Maybe<SnapshotTagsFindResult>;
  SnapshotTags_query?: Maybe<Array<SnapshotTags>>;
  SnapshotTags_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  SpinsAttributeType?: Maybe<SpinsAttributeType>;
  SpinsAttributeType_count?: Maybe<Scalars['Int']>;
  SpinsAttributeType_find?: Maybe<SpinsAttributeTypeFindResult>;
  SpinsAttributeType_query?: Maybe<Array<SpinsAttributeType>>;
  SpinsAttributeType_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  SpinsAttributes?: Maybe<SpinsAttributes>;
  SpinsAttributes_count?: Maybe<Scalars['Int']>;
  SpinsAttributes_find?: Maybe<SpinsAttributesFindResult>;
  SpinsAttributes_query?: Maybe<Array<SpinsAttributes>>;
  SpinsAttributes_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /**
   * Returns distinct Pv2 "spins:brand" attribute values starting with the given (case-insensitive,
   * untrimmed) prefix, sorted alphabetically.
   *
   * Values come from a cache that is rebuilt by the "refresh_spins_brand_values_cache" script,
   * so recently added brands may not show up until the next refresh.
   */
  SpinsBrandValues: Array<Scalars['String']>;
  Store?: Maybe<Store>;
  Store_count?: Maybe<Scalars['Int']>;
  Store_find?: Maybe<StoreFindResult>;
  Store_query?: Maybe<Array<Store>>;
  Store_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /**
   * Queries subcategory-level UPC and sales coverage from BigQuery.
   * Filterable by department, category, subcategory, geography, time,
   * top25Attribute, displayName, and attributeThemeType.
   * Sortable by any column (ASC or DESC).
   */
  SubcategoryLevelCoverage: Array<SubcategoryLevelCoverageResult>;
  Tag?: Maybe<Tag>;
  Tag_count?: Maybe<Scalars['Int']>;
  Tag_find?: Maybe<TagFindResult>;
  Tag_query?: Maybe<Array<Tag>>;
  Tag_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Task?: Maybe<Task>;
  TaskDefinition?: Maybe<TaskDefinition>;
  TaskDefinition_count?: Maybe<Scalars['Int']>;
  /** Returns all data requirements for any TaskDefinition configuration */
  TaskDefinition_dataRequirements: Array<DataRequirement>;
  TaskDefinition_find?: Maybe<TaskDefinitionFindResult>;
  TaskDefinition_query?: Maybe<Array<TaskDefinition>>;
  TaskDefinition_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  TaskDefinitions_workflow?: Maybe<TaskDefinitionsWorkflowResult>;
  TaskQueue?: Maybe<TaskFindResult>;
  Task_count?: Maybe<Scalars['Int']>;
  Task_find?: Maybe<TaskFindResult>;
  Task_query?: Maybe<Array<Task>>;
  Task_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Taxonomy?: Maybe<Taxonomy>;
  Taxonomy_count?: Maybe<Scalars['Int']>;
  Taxonomy_find?: Maybe<TaxonomyFindResult>;
  Taxonomy_query?: Maybe<Array<Taxonomy>>;
  Taxonomy_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /**
   * Returns the full Taxonomy tree with the following type:
   *
   * ```
   * type TreeNode = {
   *     _id: string;
   *     name: string;
   *     breadcrumb: string;
   *     children?: TreeNode[];
   * };
   * ```
   */
  Taxonomy_tree?: Maybe<Scalars['JSON']>;
  TransformerExpression?: Maybe<TransformerExpression>;
  TransformerExpression_count?: Maybe<Scalars['Int']>;
  TransformerExpression_find?: Maybe<TransformerExpressionFindResult>;
  TransformerExpression_query?: Maybe<Array<TransformerExpression>>;
  TransformerExpression_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  TransformerResource?: Maybe<TransformerResource>;
  TransformerResource_count?: Maybe<Scalars['Int']>;
  TransformerResource_find?: Maybe<TransformerResourceFindResult>;
  TransformerResource_query?: Maybe<Array<TransformerResource>>;
  TransformerResource_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /**
   * Queries UPC-level coverage and sales from BigQuery.
   * Filterable by maskedUpc (prefix match), brand, department, category, subcategory,
   * geography, time, top25Attribute, displayName, and attributeThemeType.
   * Sortable by any column (ASC or DESC).
   */
  UpcLevelCoverage: UpcLevelCoveragePage;
  User?: Maybe<User>;
  UserBatch?: Maybe<UserBatch>;
  UserBatch_count?: Maybe<Scalars['Int']>;
  UserBatch_find?: Maybe<UserBatchFindResult>;
  UserBatch_query?: Maybe<Array<UserBatch>>;
  UserBatch_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  UserSearch?: Maybe<UserSearch>;
  UserSearch_count?: Maybe<Scalars['Int']>;
  UserSearch_find?: Maybe<UserSearchFindResult>;
  UserSearch_query?: Maybe<Array<UserSearch>>;
  UserSearch_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  User_count?: Maybe<Scalars['Int']>;
  User_find?: Maybe<UserFindResult>;
  /** Returns list of Companies the user has "edit" access to */
  User_ownCompanies: Array<Company>;
  User_ownDomains?: Maybe<Array<Domain>>;
  User_ownMembership?: Maybe<DomainMembershipEnum>;
  User_ownPermissions: Array<UserPermissionEnum>;
  /** Pv2s that the current user has Write access to */
  User_ownPv2s?: Maybe<UserOwnPv2sFindQueryResult>;
  User_query?: Maybe<Array<User>>;
  User_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  Whitelist?: Maybe<Whitelist>;
  Whitelist_count?: Maybe<Scalars['Int']>;
  Whitelist_find?: Maybe<WhitelistFindResult>;
  Whitelist_query?: Maybe<Array<Whitelist>>;
  Whitelist_queryIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Returns a collection of data accessible to the Instacart domain, with the Instacart transformation already applied to each record. */
  instacartProducts?: Maybe<InstacartProductsPage>;
  session?: Maybe<Session>;
}


export interface QueryAliasMappingArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryAliasMapping_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAliasMapping_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAliasMapping_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAliasMapping_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAmazonProductArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryAmazonProduct_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAmazonProduct_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAmazonProduct_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAmazonProduct_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAnalyticsClientFeedbackJiraIssueArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryAnalyticsClientFeedbackJiraIssue_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAnalyticsClientFeedbackJiraIssue_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAnalyticsClientFeedbackJiraIssue_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAnalyticsClientFeedbackJiraIssue_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAnalyticsClientFeedbackSpinsAttributeArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryAnalyticsClientFeedbackSpinsAttribute_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAnalyticsClientFeedbackSpinsAttribute_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAnalyticsClientFeedbackSpinsAttribute_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAnalyticsClientFeedbackSpinsAttribute_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAnalyticsClientFeedbackTrackerUpdateArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryAnalyticsClientFeedbackTrackerUpdate_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAnalyticsClientFeedbackTrackerUpdate_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAnalyticsClientFeedbackTrackerUpdate_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAnalyticsClientFeedbackTrackerUpdate_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAnalyticsOperationalKpiArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryAnalyticsOperationalKpi_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAnalyticsOperationalKpi_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAnalyticsOperationalKpi_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAnalyticsOperationalKpi_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAnalyticsProductCountArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryAnalyticsProductCount_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAnalyticsProductCount_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAnalyticsProductCount_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAnalyticsProductCount_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAnalyticsQcSelfServeArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryAnalyticsQcSelfServe_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAnalyticsQcSelfServe_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAnalyticsQcSelfServe_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAnalyticsQcSelfServe_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryApertureAnnotationArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryApertureAnnotation_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryApertureAnnotation_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryApertureAnnotation_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryApertureAnnotation_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAsinAttributeLevelCoverageArgs {
  attributeThemeType?: InputMaybe<Array<Scalars['String']>>;
  displayName?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  top25Attribute?: InputMaybe<Scalars['String']>;
}


export interface QueryAsinCoverageAttributeThemeFilterArgs {
  category?: InputMaybe<Array<Scalars['String']>>;
  department?: InputMaybe<Array<Scalars['String']>>;
  subcategory?: InputMaybe<Array<Scalars['String']>>;
}


export interface QueryAsinLevelCoverageArgs {
  asin?: InputMaybe<Array<Scalars['String']>>;
  attributeThemeType?: InputMaybe<Array<Scalars['String']>>;
  brand?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Array<Scalars['String']>>;
  department?: InputMaybe<Array<Scalars['String']>>;
  displayName?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Array<Scalars['String']>>;
  top25Attribute?: InputMaybe<Scalars['String']>;
}


export interface QueryAsinSubcategoryLevelCoverageArgs {
  attributeThemeType?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Array<Scalars['String']>>;
  department?: InputMaybe<Array<Scalars['String']>>;
  displayName?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Array<Scalars['String']>>;
  top25Attribute?: InputMaybe<Scalars['String']>;
}


export interface QueryAttributeCoverageAttributeThemeFilterArgs {
  category?: InputMaybe<Array<Scalars['String']>>;
  department?: InputMaybe<Array<Scalars['String']>>;
  geography?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Array<Scalars['String']>>;
  time?: InputMaybe<Scalars['String']>;
}


export interface QueryAttributeLevelCoverageArgs {
  attributeThemeType?: InputMaybe<Array<Scalars['String']>>;
  displayName?: InputMaybe<Array<Scalars['String']>>;
  geography?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
  top25Attribute?: InputMaybe<Scalars['String']>;
}


export interface QueryAttributeSalesAssessmentArgs {
  builderBatchId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  reportRunId: Scalars['String'];
  sortDirection?: InputMaybe<Scalars['String']>;
  spins_sca?: InputMaybe<Scalars['String']>;
  spins_sn?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
}


export interface QueryAttributeSalesAssessmentStatsArgs {
  builderBatchId: Scalars['String'];
  reportRunId: Scalars['String'];
  spins_sca?: InputMaybe<Scalars['String']>;
  spins_sn?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
}


export interface QueryAttributeSalesAssessmentTotalsArgs {
  builderBatchId: Scalars['String'];
  groupBy: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  reportRunId: Scalars['String'];
  sortDirection?: InputMaybe<Scalars['String']>;
  spins_sca?: InputMaybe<Scalars['String']>;
  spins_sn?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
}


export interface QueryAutoNotificationsArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryAutoNotifications_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryAutoNotifications_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAutoNotifications_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryAutoNotifications_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryBrandReviewArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryBrandReview_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryBrandReview_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryBrandReview_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryBrandReview_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryBuilderBatchArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryBuilderBatch_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryBuilderBatch_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryBuilderBatch_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryBuilderBatch_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryBuilderRecomputeRunsArgs {
  limit?: InputMaybe<Scalars['Int']>;
}


export interface QueryCircanaBrandMappingArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryCircanaBrandMapping_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryCircanaBrandMapping_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryCircanaBrandMapping_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryCircanaBrandMapping_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryCleansedDataArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryCleansedData_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryCleansedData_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryCleansedData_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryCleansedData_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryClientFeedbackAttributeTrendsArgs {
  filter?: InputMaybe<ClientFeedbackFilter>;
}


export interface QueryClientFeedbackAttributeUpdatesArgs {
  filter?: InputMaybe<ClientFeedbackFilter>;
}


export interface QueryClientFeedbackCategoryUpdatesArgs {
  filter?: InputMaybe<ClientFeedbackFilter>;
}


export interface QueryClientFeedbackProductUpdatesArgs {
  filter?: InputMaybe<ClientFeedbackFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDir?: InputMaybe<Scalars['String']>;
}


export interface QueryClientFeedbackRootCausesArgs {
  filter?: InputMaybe<ClientFeedbackFilter>;
}


export interface QueryClientFeedbackTicketExtractArgs {
  filter?: InputMaybe<ClientFeedbackFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDir?: InputMaybe<Scalars['String']>;
}


export interface QueryClientFeedbackTicketTrendsArgs {
  filter?: InputMaybe<ClientFeedbackFilter>;
}


export interface QueryClientFeedbackWhoIsSubmittingArgs {
  filter?: InputMaybe<ClientFeedbackFilter>;
}


export interface QueryClientTrackerIncorrectAttributeNameArgs {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  periodReleaseFilter?: InputMaybe<Scalars['String']>;
  searchFilter?: InputMaybe<Scalars['String']>;
}


export interface QueryClientTrackerMismatchesArgs {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  periodReleaseFilter?: InputMaybe<Scalars['String']>;
  searchFilter?: InputMaybe<Scalars['String']>;
}


export interface QueryClientTrackerValueArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryClientTrackerValue_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryClientTrackerValue_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryClientTrackerValue_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryClientTrackerValue_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryCompanyArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryCompanySignupRequestArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryCompanySignupRequest_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryCompanySignupRequest_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryCompanySignupRequest_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryCompanySignupRequest_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryCompany_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryCompany_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryCompany_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryCompany_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryConfigArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryConfig_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryConfig_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryConfig_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryConfig_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryConfig_QueryPublicArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryCost_And_Billing_MonthlyArgs {
  numberOfMonths: Scalars['Int'];
}


export interface QueryCountImagesToProcessArgs {
  endDate?: InputMaybe<Scalars['String']>;
  pv2Filter?: InputMaybe<Scalars['String']>;
  sides?: InputMaybe<Array<Scalars['String']>>;
  sources?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  tag?: InputMaybe<Scalars['String']>;
}


export interface QueryDeleteHistoryArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryDeleteHistory_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryDeleteHistory_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryDeleteHistory_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryDeleteHistory_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryDigitizationUpcScanArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryDigitizationUpcScan_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryDigitizationUpcScan_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryDigitizationUpcScan_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryDigitizationUpcScan_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryDigitizationUpdateArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryDigitizationUpdate_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryDigitizationUpdate_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryDigitizationUpdate_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryDigitizationUpdate_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryDigitizationUserStatusArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryDigitizationUserStatus_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryDigitizationUserStatus_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryDigitizationUserStatus_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryDigitizationUserStatus_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryDigitization_ProductsArgs {
  updatedDate?: InputMaybe<Scalars['String']>;
}


export interface QueryDigitization_Pv2VerificationArgs {
  id: Scalars['String'];
}


export interface QueryDomainArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryDomain_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryDomain_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryDomain_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryDomain_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryFeatureFlagConfigurationArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryFeatureFlagConfiguration_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryFeatureFlagConfiguration_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryFeatureFlagConfiguration_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryFeatureFlagConfiguration_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryFindImagesToProcessArgs {
  endDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  pv2Filter?: InputMaybe<Scalars['String']>;
  sides?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  sources?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  tag?: InputMaybe<Scalars['String']>;
}


export interface QueryFormArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryFormInstructionArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryFormInstruction_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryFormInstruction_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryFormInstruction_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryFormInstruction_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryForm_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryForm_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryForm_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryForm_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryFormulaArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryFormulaResourceArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryFormulaResource_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryFormulaResource_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryFormulaResource_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryFormulaResource_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryFormula_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryFormula_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryFormula_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryFormula_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryGs1TaxonomyMappingArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryGs1TaxonomyMapping_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryGs1TaxonomyMapping_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryGs1TaxonomyMapping_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryGs1TaxonomyMapping_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryGcpScriptLogArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryGcpScriptLog_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryGcpScriptLog_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryGcpScriptLog_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryGcpScriptLog_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryGetPublicSignedFileLinkArgs {
  filename: Scalars['String'];
}


export interface QueryGetSignedFileLinkArgs {
  filename: Scalars['String'];
}


export interface QueryHierarchyAllowedValuesArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryHierarchyAllowedValues_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryHierarchyAllowedValues_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryHierarchyAllowedValues_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryHierarchyAllowedValues_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryHierarchyMappingArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryHierarchyMapping_BulkEvaluateArgs {
  pv2Ids: Array<Scalars['ObjectId']>;
}


export interface QueryHierarchyMapping_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryHierarchyMapping_EvaluateArgs {
  mapping: HierarchyMappingInput;
  pv2Id: Scalars['ObjectId'];
}


export interface QueryHierarchyMapping_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryHierarchyMapping_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryHierarchyMapping_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryHistoryGetArgs {
  model: Scalars['String'];
  modelId: Scalars['ObjectId'];
}


export interface QueryHistoryGetVersionArgs {
  model: Scalars['String'];
  modelId: Scalars['ObjectId'];
  version: Scalars['Int'];
}


export interface QueryImageArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryImage_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryImage_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryImage_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryImage_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryIngestionArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryIngestion_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryIngestion_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryIngestion_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryIngestion_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryIngredientDetailsArgs {
  id: Scalars['String'];
}


export interface QueryIngredientFormulaReferencesArgs {
  ingredientName: Scalars['String'];
}


export interface QueryJwtArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryJwt_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryJwt_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryJwt_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryJwt_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryLockedValuesArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryLockedValues_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryLockedValues_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryLockedValues_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryLockedValues_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryMaskedUpcArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryMaskedUpc_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryMaskedUpc_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryMaskedUpc_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryMaskedUpc_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryModelArgs {
  model: ModelNameEnum;
}


export interface QueryModelAggregateArgs {
  allowDiskUse?: InputMaybe<Scalars['Boolean']>;
  inputList?: InputMaybe<Array<ListVariable>>;
  limit?: InputMaybe<Scalars['Int']>;
  model: ModelNameEnum;
  pipeline: Array<Scalars['JSON']>;
  sample?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryModelCountArgs {
  inputList?: InputMaybe<Array<ListVariable>>;
  model: ModelNameEnum;
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryModelDistinctCountArgs {
  field?: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  model: ModelNameEnum;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
  unwind?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryModelFindByIdArgs {
  id: Scalars['ObjectId'];
  model: ModelNameEnum;
  populate?: InputMaybe<Array<Scalars['String']>>;
  select?: InputMaybe<Array<Scalars['String']>>;
  virtuals?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryModelFindManyArgs {
  distinct?: InputMaybe<Scalars['String']>;
  inputList?: InputMaybe<Array<ListVariable>>;
  limit?: InputMaybe<Scalars['Int']>;
  model: ModelNameEnum;
  project?: InputMaybe<Scalars['JSON']>;
  query?: InputMaybe<Scalars['JSON']>;
  select?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}


export interface QueryModelTagCountsArgs {
  model: ModelNameEnum;
  names: Array<Scalars['String']>;
}


export interface QueryModelTagNamesArgs {
  model: ModelNameEnum;
}


export interface QueryMturkHitArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryMturkHit_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryMturkHit_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryMturkHit_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryMturkHit_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryMturkWorkerArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryMturkWorker_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryMturkWorker_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryMturkWorker_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryMturkWorker_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryNewItemActivationArgs {
  brandChange?: InputMaybe<Scalars['String']>;
  brandpositionChange?: InputMaybe<Scalars['String']>;
  categoryChange?: InputMaybe<Scalars['String']>;
  compChange?: InputMaybe<Scalars['String']>;
  conventionalChannelStatus?: InputMaybe<Scalars['String']>;
  conventionalChannelStatusDetails?: InputMaybe<Scalars['String']>;
  currentBrand?: InputMaybe<Scalars['String']>;
  currentCompany?: InputMaybe<Scalars['String']>;
  departmentChange?: InputMaybe<Scalars['String']>;
  descriptionChange?: InputMaybe<Scalars['String']>;
  expectedChangeForAtLeastOneAttribute?: InputMaybe<Scalars['String']>;
  identifiedAttributeChanges?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  numberOfAttributesWithChange?: InputMaybe<Scalars['Int']>;
  packChange?: InputMaybe<Scalars['String']>;
  plcChange?: InputMaybe<Scalars['String']>;
  positionChange?: InputMaybe<Scalars['String']>;
  producttypeChange?: InputMaybe<Scalars['String']>;
  proprietaryChannelStatus?: InputMaybe<Scalars['String']>;
  proprietaryChannelStatusDetails?: InputMaybe<Scalars['String']>;
  sizeChange?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  stagedBrand?: InputMaybe<Scalars['String']>;
  stagedCompany?: InputMaybe<Scalars['String']>;
  subcategoryChange?: InputMaybe<Scalars['String']>;
  uomChange?: InputMaybe<Scalars['String']>;
  upc?: InputMaybe<Scalars['String']>;
}


export interface QueryNewItemActivationCountArgs {
  brandChange?: InputMaybe<Scalars['String']>;
  brandpositionChange?: InputMaybe<Scalars['String']>;
  categoryChange?: InputMaybe<Scalars['String']>;
  compChange?: InputMaybe<Scalars['String']>;
  conventionalChannelStatus?: InputMaybe<Scalars['String']>;
  conventionalChannelStatusDetails?: InputMaybe<Scalars['String']>;
  currentBrand?: InputMaybe<Scalars['String']>;
  currentCompany?: InputMaybe<Scalars['String']>;
  departmentChange?: InputMaybe<Scalars['String']>;
  descriptionChange?: InputMaybe<Scalars['String']>;
  expectedChangeForAtLeastOneAttribute?: InputMaybe<Scalars['String']>;
  identifiedAttributeChanges?: InputMaybe<Scalars['String']>;
  numberOfAttributesWithChange?: InputMaybe<Scalars['Int']>;
  packChange?: InputMaybe<Scalars['String']>;
  plcChange?: InputMaybe<Scalars['String']>;
  positionChange?: InputMaybe<Scalars['String']>;
  producttypeChange?: InputMaybe<Scalars['String']>;
  proprietaryChannelStatus?: InputMaybe<Scalars['String']>;
  proprietaryChannelStatusDetails?: InputMaybe<Scalars['String']>;
  sizeChange?: InputMaybe<Scalars['String']>;
  stagedBrand?: InputMaybe<Scalars['String']>;
  stagedCompany?: InputMaybe<Scalars['String']>;
  subcategoryChange?: InputMaybe<Scalars['String']>;
  uomChange?: InputMaybe<Scalars['String']>;
  upc?: InputMaybe<Scalars['String']>;
}


export interface QueryNfpAttributeMappingArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryNfpAttributeMapping_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryNfpAttributeMapping_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryNfpAttributeMapping_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryNfpAttributeMapping_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPeriodArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryPeriod_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPeriod_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPeriod_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPeriod_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPreProductionNtcArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryPreProductionNtc_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPreProductionNtc_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPreProductionNtc_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPreProductionNtc_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPreProductionNtuArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryPreProductionNtu_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPreProductionNtu_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPreProductionNtu_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPreProductionNtu_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPredictionOverrideArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryPredictionOverride_AllowedValuesArgs {
  subcategory: Scalars['String'];
}


export interface QueryPredictionOverride_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPredictionOverride_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPredictionOverride_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPredictionOverride_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPrivateLabelPermanentProductArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryPrivateLabelPermanentProduct_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPrivateLabelPermanentProduct_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPrivateLabelPermanentProduct_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPrivateLabelPermanentProduct_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPrivateLabelProductArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryPrivateLabelProduct_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPrivateLabelProduct_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPrivateLabelProduct_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPrivateLabelProduct_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryProductEditRequestArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryProductEditRequest_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryProductEditRequest_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryProductEditRequest_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryProductEditRequest_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryProductSentToTargetArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryProductSentToTarget_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryProductSentToTarget_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryProductSentToTarget_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryProductSentToTarget_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPv2Args {
  _id?: InputMaybe<Scalars['ObjectId']>;
  slug?: InputMaybe<Scalars['String']>;
}


export interface QueryPv2AttributeDefinitionArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryPv2AttributeDefinition_AttributeMatchesArgs {
  attributes?: InputMaybe<Array<InputMaybe<Pv2AttributeDefinitionInput>>>;
}


export interface QueryPv2AttributeDefinition_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPv2AttributeDefinition_CreateAttributeSchemaArgs {
  attributeDefinition: Pv2AttributeDefinitionInput;
  full?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPv2AttributeDefinition_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPv2AttributeDefinition_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPv2AttributeDefinition_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPv2CustomFieldConfigArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryPv2CustomFieldConfig_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPv2CustomFieldConfig_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPv2CustomFieldConfig_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPv2CustomFieldConfig_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPv2IngredientArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryPv2Ingredient_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPv2Ingredient_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPv2Ingredient_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPv2Ingredient_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPv2Ingredients_SearchArgs {
  componentType?: InputMaybe<Pv2IngredientComponentTypeEnum>;
  endDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  nameFilters?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['String']>;
  withReviewStatus?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPv2VerificationArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryPv2Verification_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPv2Verification_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPv2Verification_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPv2Verification_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPv2_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPv2_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPv2_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryPv2_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryPv2_SearchArgs {
  after?: InputMaybe<Scalars['String']>;
  expression: Scalars['JSON'];
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['String']>;
}


export interface QueryPv2_SearchIdsArgs {
  expression: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
}


export interface QueryPv2sByIngredients_SearchArgs {
  componentType: Pv2IngredientComponentTypeEnum;
  falsePositives?: InputMaybe<Array<Scalars['String']>>;
  ingredientFilters: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}


export interface QueryQcSelfServeBrandOptionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
  team?: InputMaybe<Scalars['String']>;
}


export interface QueryQcSelfServeCheckCountsArgs {
  filter?: InputMaybe<QcSelfServeFilter>;
  team?: InputMaybe<Scalars['String']>;
}


export interface QueryQcSelfServeCheckDescriptionCountsArgs {
  filter?: InputMaybe<QcSelfServeFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDir?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Scalars['String']>;
}


export interface QueryQcSelfServeFilterOptionsArgs {
  team?: InputMaybe<Scalars['String']>;
}


export interface QueryQcSelfServeRowsArgs {
  filter?: InputMaybe<QcSelfServeFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDir?: InputMaybe<Scalars['String']>;
}


export interface QueryQcSelfServeSummaryArgs {
  filter?: InputMaybe<QcSelfServeFilter>;
}


export interface QueryRawIngestionDataArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryRawIngestionData_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryRawIngestionData_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryRawIngestionData_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryRawIngestionData_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryRawIngestionEventArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryRawIngestionEvent_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryRawIngestionEvent_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryRawIngestionEvent_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryRawIngestionEvent_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryRetailItemsExtractArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryRetailItemsExtract_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryRetailItemsExtract_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryRetailItemsExtract_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryRetailItemsExtract_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryRetailerPrivateLabelArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryRetailerPrivateLabel_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryRetailerPrivateLabel_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryRetailerPrivateLabel_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryRetailerPrivateLabel_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryScriptArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryScriptInfoArgs {
  key?: InputMaybe<ScriptKey>;
}


export interface QueryScript_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryScript_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryScript_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryScript_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryScriptsListArgs {
  isCircana?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryServiceHeartbeat_CheckArgs {
  isScheduler?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryServicesHeartbeatArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryServicesHeartbeat_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryServicesHeartbeat_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryServicesHeartbeat_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryServicesHeartbeat_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QuerySnapshotTagsArgs {
  _id: Scalars['ObjectId'];
}


export interface QuerySnapshotTags_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QuerySnapshotTags_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QuerySnapshotTags_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QuerySnapshotTags_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QuerySpinsAttributeTypeArgs {
  _id: Scalars['ObjectId'];
}


export interface QuerySpinsAttributeType_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QuerySpinsAttributeType_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QuerySpinsAttributeType_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QuerySpinsAttributeType_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QuerySpinsAttributesArgs {
  _id: Scalars['ObjectId'];
}


export interface QuerySpinsAttributes_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QuerySpinsAttributes_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QuerySpinsAttributes_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QuerySpinsAttributes_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QuerySpinsBrandValuesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  startsWith: Scalars['String'];
}


export interface QueryStoreArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryStore_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryStore_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryStore_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryStore_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QuerySubcategoryLevelCoverageArgs {
  attributeThemeType?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Array<Scalars['String']>>;
  department?: InputMaybe<Array<Scalars['String']>>;
  displayName?: InputMaybe<Array<Scalars['String']>>;
  geography?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Array<Scalars['String']>>;
  time?: InputMaybe<Scalars['String']>;
  top25Attribute?: InputMaybe<Scalars['String']>;
}


export interface QueryTagArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryTag_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryTag_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTag_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTag_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryTaskArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryTaskDefinitionArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryTaskDefinition_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryTaskDefinition_DataRequirementsArgs {
  _id?: InputMaybe<Scalars['ObjectId']>;
  config?: InputMaybe<Scalars['JSON']>;
  type: TaskDefinitionTypeEnum;
}


export interface QueryTaskDefinition_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTaskDefinition_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTaskDefinition_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryTaskQueueArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTask_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryTask_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTask_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTask_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryTaxonomyArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryTaxonomy_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryTaxonomy_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTaxonomy_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTaxonomy_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryTransformerExpressionArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryTransformerExpression_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryTransformerExpression_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTransformerExpression_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTransformerExpression_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryTransformerResourceArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryTransformerResource_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryTransformerResource_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTransformerResource_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTransformerResource_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryUpcLevelCoverageArgs {
  attributeThemeType?: InputMaybe<Array<Scalars['String']>>;
  brand?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Array<Scalars['String']>>;
  department?: InputMaybe<Array<Scalars['String']>>;
  displayName?: InputMaybe<Array<Scalars['String']>>;
  geography?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  maskedUpc?: InputMaybe<Array<Scalars['String']>>;
  privateLabel?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Array<Scalars['String']>>;
  time?: InputMaybe<Scalars['String']>;
  top25Attribute?: InputMaybe<Scalars['String']>;
}


export interface QueryUserArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryUserBatchArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryUserBatch_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryUserBatch_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryUserBatch_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryUserBatch_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryUserSearchArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryUserSearch_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryUserSearch_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryUserSearch_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryUserSearch_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryUser_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryUser_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryUser_OwnCompaniesArgs {
  limit?: Scalars['Int'];
  query?: InputMaybe<Scalars['JSON']>;
  skip?: Scalars['Int'];
  sort?: Scalars['String'];
  type?: InputMaybe<CompanyTypeEnum>;
}


export interface QueryUser_OwnPv2sArgs {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['String']>;
}


export interface QueryUser_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryUser_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryWhitelistArgs {
  _id: Scalars['ObjectId'];
}


export interface QueryWhitelist_CountArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryWhitelist_FindArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryWhitelist_QueryArgs {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortWithCollation?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryWhitelist_QueryIdsArgs {
  query?: InputMaybe<Scalars['JSON']>;
}


export interface QueryInstacartProductsArgs {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  updatedBefore?: InputMaybe<Scalars['DateTimeInput']>;
  updatedSince?: InputMaybe<Scalars['DateTimeInput']>;
}

/** Retains metadata for each row ingested during Circana or similar processes. Eventually pre-prod */
export interface RawIngestionData {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  gtin: Scalars['String'];
  ingestionEventId?: Maybe<Ingestion>;
  source: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface RawIngestionDataFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<RawIngestionData>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Retains metadata for each row ingested during Circana or similar processes. Eventually pre-prod */
export interface RawIngestionDataInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['JSON']>;
  gtin?: InputMaybe<Scalars['String']>;
  ingestionEventId?: InputMaybe<Scalars['ObjectId']>;
  source?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

/** Retains metadata for each ingestion event. Circana currently and eventually pre-prod */
export interface RawIngestionEvent {
  _id: Scalars['ObjectId'];
  cleansedDataIngestionCompleted?: Maybe<Scalars['DateTime']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  rawIngestionCompleted?: Maybe<Scalars['DateTime']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source: Scalars['String'];
  /** - enum: "In Progress", "Completed", "Failed" */
  status?: Maybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface RawIngestionEventFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<RawIngestionEvent>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Retains metadata for each ingestion event. Circana currently and eventually pre-prod */
export interface RawIngestionEventInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  cleansedDataIngestionCompleted?: InputMaybe<Scalars['DateTime']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  rawIngestionCompleted?: InputMaybe<Scalars['DateTime']>;
  /** - enum: "rivir", "stackline", "stacklineSales", "clearcut", "keepa", "predictions:daap-hierarchy", "predictions:attribution-agent", "predictions:override", "predictions:nfp-agent", "aperture", "circana", "preprod:ntc", "preprod:ntu", "preprod:sales", "ops:tasker", "override:brand-review" */
  source?: InputMaybe<Scalars['String']>;
  /** - enum: "In Progress", "Completed", "Failed" */
  status?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface RejectImagesResponse {
  failedImages?: Maybe<Array<Maybe<FailedImages>>>;
  successfulSaves: Scalars['Int'];
}

/** Retains details about retail items extract jobs. */
export interface RetailItemsExtract {
  _id: Scalars['ObjectId'];
  _rawPayload: Scalars['String'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  fileLocation: RetailItemsExtractFileLocation;
  name: Scalars['String'];
  /** @virtual */
  rawPayload: Scalars['JSON'];
  status: RetailItemsExtractStatusEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface RetailItemsExtractFileLocation {
  awsS3Url?: Maybe<Scalars['String']>;
  googleCloudStorageUrl?: Maybe<Scalars['String']>;
}

export interface RetailItemsExtractFileLocationInput {
  awsS3Url?: InputMaybe<Scalars['String']>;
  googleCloudStorageUrl?: InputMaybe<Scalars['String']>;
}

export interface RetailItemsExtractFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<RetailItemsExtract>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Retains details about retail items extract jobs. */
export interface RetailItemsExtractInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  _rawPayload?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  fileLocation?: InputMaybe<RetailItemsExtractFileLocationInput>;
  name?: InputMaybe<Scalars['String']>;
  /** @virtual */
  rawPayload?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<RetailItemsExtractStatusEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export enum RetailItemsExtractStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/** Stores retailerId , retailTag, plBrand, controlBrand, and mfrCode information for retailers. */
export interface RetailerPrivateLabel {
  _id: Scalars['ObjectId'];
  controlBrand?: Maybe<Scalars['Boolean']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  mfrCode?: Maybe<Scalars['String']>;
  plBrand?: Maybe<Scalars['String']>;
  retailerId: Scalars['Float'];
  retailerTag?: Maybe<Scalars['Float']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface RetailerPrivateLabelFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<RetailerPrivateLabel>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Stores retailerId , retailTag, plBrand, controlBrand, and mfrCode information for retailers. */
export interface RetailerPrivateLabelInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  controlBrand?: InputMaybe<Scalars['Boolean']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  mfrCode?: InputMaybe<Scalars['String']>;
  plBrand?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['Float']>;
  retailerTag?: InputMaybe<Scalars['Float']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface RunScript {
  error?: Maybe<Scalars['String']>;
  executionId: Scalars['String'];
  message: Scalars['String'];
  scriptLogsUrl: Scalars['String'];
}

export interface S3PresignedPutObjectUrl {
  presignedUrl: Scalars['String'];
}

export interface ScannedBarcodes {
  type: Scalars['String'];
  value: Scalars['String'];
}

export interface ScannedBarcodesInput {
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
}

export interface Script {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** - enum: "api", "api-v2", "data-engineering" */
  fileLocation: Scalars['String'];
  fileName: Scalars['String'];
  heapStatistics?: Maybe<ScriptHeapStatistics>;
  isCron: Scalars['Boolean'];
  lastRunSucceeded?: Maybe<Scalars['Boolean']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface ScriptFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Script>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/** Heap statistics of script process recorded from the most previous run. For more details see the following: https://nodejs.org/api/v8.html#v8getheapspacestatistics */
export interface ScriptHeapStatistics {
  heapSizeLimit?: Maybe<Scalars['Float']>;
  mallocedMemory?: Maybe<Scalars['Float']>;
  numberOfDetachedContexts?: Maybe<Scalars['Float']>;
  numberOfNativeContexts?: Maybe<Scalars['Float']>;
  peakMallocedMemory?: Maybe<Scalars['Float']>;
  timestamp: Scalars['DateTime'];
  totalHeapSize?: Maybe<Scalars['Float']>;
  totalHeapSizeExecutable?: Maybe<Scalars['Float']>;
  usedHeapSize?: Maybe<Scalars['Float']>;
}

/** Heap statistics of script process recorded from the most previous run. For more details see the following: https://nodejs.org/api/v8.html#v8getheapspacestatistics */
export interface ScriptHeapStatisticsInput {
  heapSizeLimit?: InputMaybe<Scalars['Float']>;
  mallocedMemory?: InputMaybe<Scalars['Float']>;
  numberOfDetachedContexts?: InputMaybe<Scalars['Float']>;
  numberOfNativeContexts?: InputMaybe<Scalars['Float']>;
  peakMallocedMemory?: InputMaybe<Scalars['Float']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  totalHeapSize?: InputMaybe<Scalars['Float']>;
  totalHeapSizeExecutable?: InputMaybe<Scalars['Float']>;
  usedHeapSize?: InputMaybe<Scalars['Float']>;
}

export interface ScriptInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  /** - enum: "api", "api-v2", "data-engineering" */
  fileLocation?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  heapStatistics?: InputMaybe<ScriptHeapStatisticsInput>;
  isCron?: InputMaybe<Scalars['Boolean']>;
  lastRunSucceeded?: InputMaybe<Scalars['Boolean']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export enum ScriptKey {
  ApplyHierarchyMappings = 'apply_hierarchy_mappings',
  ArchiveMturkhits = 'archive_mturkhits',
  BulkCloneTasks = 'bulk_clone_tasks',
  BulkModifyTaskStatus = 'bulk_modify_task_status',
  DataDelete = 'data_delete',
  DigitizationActiveStoresUpdate = 'digitization_activeStores_update',
  DigitizationUploadProductBundle = 'digitization_upload_product_bundle',
  DownloadQueryToFile = 'download_query_to_file',
  GenerateTemplatedBuilderFormulas = 'generate_templated_builder_formulas',
  ImageUpdate = 'image_update',
  IngestProductLibraryData = 'ingest_product_library_data',
  ItemActivationFileLoad = 'item_activation_file_load',
  MturkSyncWorkerQualifications = 'mturk_sync_worker_qualifications',
  PreprodFileLoad = 'preprod_file_load',
  PrivateLabelPermanentProductUpsert = 'private_label_permanent_product_upsert',
  PrivateLabelProductUpsert = 'private_label_product_upsert',
  PushPv2RecordToSproutsIxOneInstance = 'push_pv2_record_to_sprouts_ix_one_instance',
  Pv2ApplyGenericFrontImage = 'pv2_apply_generic_front_image',
  Pv2Create = 'pv2_create',
  Pv2ReparseIngredients = 'pv2_reparse_ingredients',
  Pv2Update = 'pv2_update',
  Pv2UpdateAttributes = 'pv2_update_attributes',
  Pv2UpdateImages = 'pv2_update_images',
  ReApplyBrandMappings = 're_apply_brand_mappings',
  ReApplyBucketing = 're_apply_bucketing',
  RefreshSpinsBrandValuesCache = 'refresh_spins_brand_values_cache',
  RetailerPrivateLabelUpsert = 'retailer_private_label_upsert',
  RetriggerPubsubDeadletter = 'retrigger_pubsub_deadletter',
  SnapshotTagsUpsert = 'snapshot_tags_upsert',
  SpinsAttributeTypeBulkModify = 'spins_attribute_type_bulk_modify',
  SpinsAttributeTypeNewEntries = 'spins_attribute_type_new_entries',
  TargetImportItemData = 'target_import_item_data',
  TargetPublishUpdatedProducts = 'target_publish_updated_products',
  TriggerNewToOldReport = 'trigger_new_to_old_report',
  UpdateLockedValues = 'update_locked_values'
}

export interface ScriptMetadata {
  bucketUrl?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  exampleFileName?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  key: ScriptKey;
  name: Scalars['String'];
  options: Array<ScriptOption>;
  recentRuns: Array<ScriptRunInfo>;
  subdirectory?: Maybe<Scalars['String']>;
  successMessage?: Maybe<Scalars['String']>;
  warning?: Maybe<Scalars['String']>;
}

export interface ScriptOption {
  acceptFileType?: Maybe<Scalars['String']>;
  choices?: Maybe<Array<Maybe<Scalars['String']>>>;
  default?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  optionalWithWarning?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  type: ScriptOptionType;
}

export enum ScriptOptionType {
  Array = 'array',
  Boolean = 'boolean',
  Enum = 'enum',
  File = 'file',
  String = 'string'
}

export interface ScriptRunInfo {
  executionId: Scalars['String'];
  executionUrl: Scalars['String'];
  timestamp: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
}

export interface SelectEditableField extends IEditableField {
  /**
   * List of field id-s to reset the value on change.
   *
   * E.g. when `width_mm` is changed `with_inch` should be cleared since those 2 fields are computed based on each-other in the backend
   */
  clearOnChange?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  /** Hidden fields should not be rendered but can still be used to update the Pv2 */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Unique field identifier */
  id: Scalars['String'];
  /** Human-readlabe name */
  label: Scalars['String'];
  options: Array<SelectEditableFieldOption>;
  readonly: Scalars['Boolean'];
  required: Scalars['Boolean'];
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: IEditableFieldTypeEnum;
  value?: Maybe<Scalars['JSON']>;
}

export interface SelectEditableFieldOption {
  label: Scalars['String'];
  value: Scalars['JSON'];
}

/**
 * Handles selecting one-or-more options from a given list of possibilities
 *
 * **Pv2_search type:**
 *
 * ```
 * {
 *     type: 'field';
 *     id: string;
 *     operation: 'in' | 'nin';
 *     value: string | string[];
 * }
 * ```
 */
export interface SelectSearchField extends ISearchField {
  /** Optional section in which this option should be places */
  group?: Maybe<Scalars['String']>;
  /** Unique identifier of a specific operation. It is the main value used for searching */
  id: Scalars['String'];
  /** Human-friendly label */
  label: Scalars['String'];
  /** Allow selecting multiple values */
  multiple?: Maybe<Scalars['Boolean']>;
  options: Array<Maybe<SelectSearchFieldOption>>;
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: Pv2SearchFieldType;
}

export interface SelectSearchFieldOption {
  /** Unique identifier of this option, passed to search */
  id: Scalars['String'];
  /** Human-friendy label */
  label: Scalars['String'];
}

export interface Service {
  displayName: Scalars['String'];
  name: ServiceNameEnum;
  vmLoggingUrl: Scalars['String'];
}

export interface ServiceHeartbeatCheck {
  heartbeats: Array<HeartBeatItem>;
  name: Scalars['String'];
}

export enum ServiceNameEnum {
  BatchService = 'batch_service',
  BuilderBatchService = 'builder_batch_service'
}

export interface ServicesHeartbeat {
  _id: Scalars['ObjectId'];
  branchName?: Maybe<Scalars['String']>;
  lastCheckIn: Array<ServicesHeartbeatLastCheckIn>;
  name: Scalars['String'];
}

export interface ServicesHeartbeatFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<ServicesHeartbeat>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface ServicesHeartbeatInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  branchName?: InputMaybe<Scalars['String']>;
  lastCheckIn?: InputMaybe<Array<ServicesHeartbeatLastCheckInInput>>;
  name?: InputMaybe<Scalars['String']>;
}

export interface ServicesHeartbeatLastCheckIn {
  displayName: Scalars['String'];
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface ServicesHeartbeatLastCheckInInput {
  displayName?: InputMaybe<Scalars['String']>;
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface Session {
  isAuthenticated?: Maybe<Scalars['Boolean']>;
  originalUser?: Maybe<User>;
  user?: Maybe<User>;
}

export interface SignedFileLink {
  url: Scalars['String'];
}

export interface SnapshotTags {
  _id: Scalars['ObjectId'];
  availableHierarchies: Array<Taxonomy>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  descriptionValue: Scalars['String'];
  spinsAttributeTypeId?: Maybe<SpinsAttributeType>;
  tagValue: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface SnapshotTagsFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<SnapshotTags>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface SnapshotTagsInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  availableHierarchies?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  descriptionValue?: InputMaybe<Scalars['String']>;
  spinsAttributeTypeId?: InputMaybe<Scalars['ObjectId']>;
  tagValue?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface SpinsAttributeType {
  _id: Scalars['ObjectId'];
  adpConvEligible?: Maybe<Scalars['Boolean']>;
  adpIsMeasure?: Maybe<Scalars['Boolean']>;
  adpPropEligible?: Maybe<Scalars['Boolean']>;
  adpReleasable?: Maybe<Scalars['Boolean']>;
  attributeTheme?: Maybe<SpinsAttributeTypeAttributeTheme>;
  availableHierarchies: Array<Taxonomy>;
  clientTrackerEligible?: Maybe<Scalars['Boolean']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  displayName: Scalars['String'];
  measureUofM?: Maybe<Scalars['String']>;
  piDirectEligible?: Maybe<Scalars['Boolean']>;
  privateLabelAvailableHierarchies: Array<Taxonomy>;
  pv2SourceAttributes: Array<Pv2AttributeDefinition>;
  snapshotComputed?: Maybe<Scalars['Boolean']>;
  snapshotDescription?: Maybe<Scalars['String']>;
  snapshotEligible?: Maybe<Scalars['Boolean']>;
  snapshotTag?: Maybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface SpinsAttributeTypeAttributeTheme {
  theme?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  useCase?: Maybe<Scalars['String']>;
}

export interface SpinsAttributeTypeAttributeThemeInput {
  theme?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  useCase?: InputMaybe<Scalars['String']>;
}

export interface SpinsAttributeTypeFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<SpinsAttributeType>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface SpinsAttributeTypeInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  adpConvEligible?: InputMaybe<Scalars['Boolean']>;
  adpIsMeasure?: InputMaybe<Scalars['Boolean']>;
  adpPropEligible?: InputMaybe<Scalars['Boolean']>;
  adpReleasable?: InputMaybe<Scalars['Boolean']>;
  attributeTheme?: InputMaybe<SpinsAttributeTypeAttributeThemeInput>;
  availableHierarchies?: InputMaybe<Array<Scalars['ObjectId']>>;
  clientTrackerEligible?: InputMaybe<Scalars['Boolean']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  displayName?: InputMaybe<Scalars['String']>;
  measureUofM?: InputMaybe<Scalars['String']>;
  piDirectEligible?: InputMaybe<Scalars['Boolean']>;
  privateLabelAvailableHierarchies?: InputMaybe<Array<Scalars['ObjectId']>>;
  pv2SourceAttributes?: InputMaybe<Array<Scalars['ObjectId']>>;
  snapshotComputed?: InputMaybe<Scalars['Boolean']>;
  snapshotDescription?: InputMaybe<Scalars['String']>;
  snapshotEligible?: InputMaybe<Scalars['Boolean']>;
  snapshotTag?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface SpinsAttributes {
  _id: Scalars['ObjectId'];
  asin?: Maybe<Scalars['String']>;
  associatedGtin?: Maybe<Scalars['String']>;
  attributes: Array<SpinsAttributesAttributes>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  gtin?: Maybe<Scalars['String']>;
  pv2Id?: Maybe<Pv2>;
  source?: Maybe<Scalars['String']>;
  spinsUpc: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface SpinsAttributesAttributes {
  attributeName: Scalars['String'];
  attributeValue?: Maybe<Scalars['String']>;
}

export interface SpinsAttributesAttributesInput {
  attributeName?: InputMaybe<Scalars['String']>;
  attributeValue?: InputMaybe<Scalars['String']>;
}

export interface SpinsAttributesFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<SpinsAttributes>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface SpinsAttributesInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  asin?: InputMaybe<Scalars['String']>;
  associatedGtin?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Array<SpinsAttributesAttributesInput>>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  gtin?: InputMaybe<Scalars['String']>;
  pv2Id?: InputMaybe<Scalars['ObjectId']>;
  source?: InputMaybe<Scalars['String']>;
  spinsUpc?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface Stats {
  highPriorityImageCount: Scalars['Int'];
  regularPriorityImageCount: Scalars['Int'];
  rejectedImageCount: Scalars['Int'];
}

export interface Store {
  _id: Scalars['ObjectId'];
  activeDigitization?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  /** list of barcodes that are available in this store */
  availableUPCs: Array<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  /** Date when the store was closed. Typically pulled data from retailer ingestion. */
  closedDate?: Maybe<Scalars['DateTime']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Domain>;
  name?: Maybe<Scalars['String']>;
  /** list of barcodes that are available in this store (without the hash prefix like availableUPCs has) */
  rawAvailableUPCs: Array<Scalars['String']>;
  /** raw partner-specific data used to create this store */
  rawData?: Maybe<Scalars['JSON']>;
  state?: Maybe<Scalars['String']>;
  /** partner-supplied Store ID, visible in the Digitization App */
  storeID: Scalars['String'];
  tags: Array<TagStruct>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface StoreFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Store>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface StoreInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  activeDigitization?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  /** list of barcodes that are available in this store */
  availableUPCs?: InputMaybe<Array<Scalars['String']>>;
  city?: InputMaybe<Scalars['String']>;
  /** Date when the store was closed. Typically pulled data from retailer ingestion. */
  closedDate?: InputMaybe<Scalars['DateTime']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  domain?: InputMaybe<Scalars['ObjectId']>;
  name?: InputMaybe<Scalars['String']>;
  /** list of barcodes that are available in this store (without the hash prefix like availableUPCs has) */
  rawAvailableUPCs?: InputMaybe<Array<Scalars['String']>>;
  /** raw partner-specific data used to create this store */
  rawData?: InputMaybe<Scalars['JSON']>;
  state?: InputMaybe<Scalars['String']>;
  /** partner-supplied Store ID, visible in the Digitization App */
  storeID?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagStructInput>>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface StringEditableField extends IEditableField {
  /**
   * List of field id-s to reset the value on change.
   *
   * E.g. when `width_mm` is changed `with_inch` should be cleared since those 2 fields are computed based on each-other in the backend
   */
  clearOnChange?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  /** Hidden fields should not be rendered but can still be used to update the Pv2 */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Unique field identifier */
  id: Scalars['String'];
  /** Human-readlabe name */
  label: Scalars['String'];
  readonly: Scalars['Boolean'];
  required: Scalars['Boolean'];
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: IEditableFieldTypeEnum;
  value?: Maybe<Scalars['JSON']>;
}

/**
 * Handles both exact string matches and free-form partial matches
 *
 * **Pv2_search type:**
 *
 * ```
 * {
 *     type: 'field';
 *     id: string;
 *     value: string;
 *     operation: 'in' | 'nin' | 'eq' | 'ne' | 'contains';
 *     flags?: string;
 * }
 * ```
 */
export interface StringSearchField extends ISearchField {
  /** Optional section in which this option should be places */
  group?: Maybe<Scalars['String']>;
  /** Unique identifier of a specific operation. It is the main value used for searching */
  id: Scalars['String'];
  /** Human-friendly label */
  label: Scalars['String'];
  /** The type of field. Different fields have different structures and likely need a different UI component */
  type: Pv2SearchFieldType;
}

export interface SubcategoryLevelCoverageResult {
  attributeThemeType: Scalars['String'];
  category: Scalars['String'];
  department: Scalars['String'];
  displayName: Scalars['String'];
  geography: Scalars['String'];
  salesKnownValuePercent: Scalars['Float'];
  salesUnknownValuePercent: Scalars['Float'];
  salesWithKnownValue: Scalars['Float'];
  salesWithUnknownValue: Scalars['Float'];
  subcategory: Scalars['String'];
  time: Scalars['String'];
  top25Attribute: Scalars['String'];
  totalEligibleSales: Scalars['Float'];
  totalEligibleUpcs: Scalars['Int'];
  upcKnownValuePercent: Scalars['Float'];
  upcUnknownValuePercent: Scalars['Float'];
  upcsWithKnownValue: Scalars['Int'];
  upcsWithUnknownValue: Scalars['Int'];
}

export interface Tag {
  _id: Scalars['ObjectId'];
  background: Scalars['String'];
  color: Scalars['String'];
  /** Counts the number of documents this tag is applied to. */
  count: Scalars['Int'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  domains: Array<Domain>;
  name: Scalars['String'];
  type: TagTypeEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface TagFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Tag>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface TagInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  background?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  /** All Domains have read and write access to this tag */
  domains?: InputMaybe<Array<Scalars['ObjectId']>>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TagTypeEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface TagStruct {
  createdBy?: Maybe<User>;
  createdDate?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Tag>;
  name: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
}

export interface TagStructInput {
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['ObjectId']>;
  name?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
}

export enum TagTypeEnum {
  System = 'system',
  User = 'user'
}

export interface Task {
  /** serialized JSON. Stores the input configuration for this task */
  _config?: Maybe<Scalars['JSON']>;
  _id: Scalars['ObjectId'];
  /** serialized JSON. Stores the submitted result of this task once the given handler service has finished processing it */
  _result?: Maybe<Scalars['String']>;
  assignee?: Maybe<TaskAssignee>;
  /** @virtual */
  config: Scalars['JSON'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** When status="error", this field will be set to the error body */
  error?: Maybe<Scalars['String']>;
  /** When status="error", this field can optionally be set by the "resultTransformation" */
  errorCode?: Maybe<Scalars['String']>;
  expandedConfig: Scalars['JSON'];
  links: Array<TaskLinks>;
  /** The parent task that created this document */
  parentTask?: Maybe<Task>;
  /** Higher priority tasks will be looked at first */
  priority: Scalars['Float'];
  processing?: Maybe<TaskProcessing>;
  /** @virtual */
  result?: Maybe<Scalars['JSON']>;
  /** The spinsUpc of the associated Pv2 document, if available */
  spinsUpc?: Maybe<Scalars['String']>;
  /**
   * The current status of this Task.
   *
   * | status        | info                                                                                      |
   * |---------------|-------------------------------------------------------------------------------------------|
   * | pending       | Default initial status. Marks that the Task is waiting for processing                     |
   * | disabled      | Task has been disabled from automation. It must be manually set to "pending" status       |
   * | processing    | When Tasker picks up this Task to send it to a handler                                    |
   * | done          | Tasker received a successful result from the Task handler                                 |
   * | error         | Tasker received an error when processing. See "error-code" and "error" fields on the Task |
   * | blocked       | Task is waiting on its "taskDependencies" to start processing                             |
   * | async_sent    | Tasker has delivered this Task to an async handler for processing   |
   * | assigned      | Tasker has been accepted and assigned to a user                                           |
   * | async_done    | Async handler has successfully finished task. Transitions to "done" |
   * | async_expired | Async handler has failed to handle the task before its expiration time |
   * | cancelled     | Cancelled by a sibling task's "cancelSiblings" action                                     |
   */
  status: TaskStatusEnum;
  statusDate: Scalars['DateTime'];
  taskDependencies: Array<Task>;
  type?: Maybe<TaskDefinition>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface TaskAssignee {
  endDate?: Maybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
  /** Some tasks can be directly assigned to a user */
  user?: Maybe<User>;
}

export interface TaskAssigneeInput {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Some tasks can be directly assigned to a user */
  user?: InputMaybe<Scalars['ObjectId']>;
}

export interface TaskDefinition {
  _id: Scalars['ObjectId'];
  /** Configuration specific to the task type + handler */
  config?: Maybe<Scalars['JSON']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  dataRequirements: Array<DataRequirement>;
  /** Optional Markdown description of what this task does */
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  mturk?: Maybe<TaskDefinitionMturk>;
  name: Scalars['String'];
  /** Transformation to run on task completion */
  resultTransformation?: Maybe<TransformerExpression>;
  tags: Array<TagStruct>;
  throttle: TaskDefinitionThrottle;
  /** If set, Tasker will give up waiting on the request after the given period and fail the task with a timeout error */
  timeoutSeconds?: Maybe<Scalars['Float']>;
  type: TaskDefinitionTypeEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface TaskDefinitionFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<TaskDefinition>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface TaskDefinitionInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Configuration specific to the task type + handler */
  config?: InputMaybe<Scalars['JSON']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  /** Optional Markdown description of what this task does */
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  mturk?: InputMaybe<TaskDefinitionMturkInput>;
  name?: InputMaybe<Scalars['String']>;
  /** Transformation to run on task completion */
  resultTransformation?: InputMaybe<Scalars['ObjectId']>;
  tags?: InputMaybe<Array<TagStructInput>>;
  throttle?: InputMaybe<TaskDefinitionThrottleInput>;
  /** If set, Tasker will give up waiting on the request after the given period and fail the task with a timeout error */
  timeoutSeconds?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<TaskDefinitionTypeEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface TaskDefinitionMturk {
  HITTypeId?: Maybe<Scalars['String']>;
  QualificationTypeId?: Maybe<Scalars['String']>;
  qualificationName?: Maybe<Scalars['String']>;
}

export interface TaskDefinitionMturkInput {
  HITTypeId?: InputMaybe<Scalars['String']>;
  QualificationTypeId?: InputMaybe<Scalars['String']>;
  qualificationName?: InputMaybe<Scalars['String']>;
}

export interface TaskDefinitionThrottle {
  /** Max number of tasks to have in a processing state in the same time */
  maxProcessingAtOnce?: Maybe<Scalars['Float']>;
  /** Max number of requests to handle per second */
  perSecond?: Maybe<Scalars['Float']>;
}

export interface TaskDefinitionThrottleInput {
  /** Max number of tasks to have in a processing state in the same time */
  maxProcessingAtOnce?: InputMaybe<Scalars['Float']>;
  /** Max number of requests to handle per second */
  perSecond?: InputMaybe<Scalars['Float']>;
}

export enum TaskDefinitionTypeEnum {
  FormInternal = 'form_internal',
  FormMturk = 'form_mturk',
  ImageAnnotator = 'image_annotator',
  ImageInference = 'image_inference',
  Transformer = 'transformer',
  UrlSearch = 'url_search',
  UrlValidation = 'url_validation'
}

export interface TaskDefinitionWorkflowChild {
  _id: Scalars['String'];
  count: Scalars['Int'];
  many: Scalars['Boolean'];
  optional: Scalars['Boolean'];
  taskDependencies?: Maybe<Scalars['String']>;
  taskGroup?: Maybe<Scalars['String']>;
}

export interface TaskDefinitionWorkflowNode {
  _id: Scalars['String'];
  children: Array<TaskDefinitionWorkflowChild>;
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
  type: TaskDefinitionTypeEnum;
}

export interface TaskDefinitionsWorkflowResult {
  nodes: Array<TaskDefinitionWorkflowNode>;
}

export interface TaskFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Task>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface TaskInput {
  /** serialized JSON. Stores the input configuration for this task */
  _config?: InputMaybe<Scalars['JSON']>;
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** serialized JSON. Stores the submitted result of this task once the given handler service has finished processing it */
  _result?: InputMaybe<Scalars['String']>;
  assignee?: InputMaybe<TaskAssigneeInput>;
  /** @virtual */
  config?: InputMaybe<Scalars['JSON']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  /** When status="error", this field will be set to the error body */
  error?: InputMaybe<Scalars['String']>;
  /** When status="error", this field can optionally be set by the "resultTransformation" */
  errorCode?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<TaskLinksInput>>;
  /** The parent task that created this document */
  parentTask?: InputMaybe<Scalars['ObjectId']>;
  /** Higher priority tasks will be looked at first */
  priority?: InputMaybe<Scalars['Float']>;
  processing?: InputMaybe<TaskProcessingInput>;
  /** @virtual */
  result?: InputMaybe<Scalars['JSON']>;
  /**
   * The current status of this Task.
   *
   * | status        | info                                                                                      |
   * |---------------|-------------------------------------------------------------------------------------------|
   * | pending       | Default initial status. Marks that the Task is waiting for processing                     |
   * | disabled      | Task has been disabled from automation. It must be manually set to "pending" status       |
   * | processing    | When Tasker picks up this Task to send it to a handler                                    |
   * | done          | Tasker received a successful result from the Task handler                                 |
   * | error         | Tasker received an error when processing. See "error-code" and "error" fields on the Task |
   * | blocked       | Task is waiting on its "taskDependencies" to start processing                             |
   * | async_sent    | Tasker has delivered this Task to an async handler for processing   |
   * | assigned      | Tasker has been accepted and assigned to a user                                           |
   * | async_done    | Async handler has successfully finished task. Transitions to "done" |
   * | async_expired | Async handler has failed to handle the task before its expiration time |
   * | cancelled     | Cancelled by a sibling task's "cancelSiblings" action                                     |
   */
  status?: InputMaybe<TaskStatusEnum>;
  statusDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * A task will wait on all its taskDependencies before executing
   *
   * The result of all task dependencies will be available as `taskDependencies` as the task input
   */
  taskDependencies?: InputMaybe<Array<Scalars['ObjectId']>>;
  type?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface TaskLinks {
  _id: Scalars['ObjectId'];
  targetId: Scalars['ObjectId'];
  targetModel: ModelNameEnum;
}

export interface TaskLinksInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  targetId?: InputMaybe<Scalars['ObjectId']>;
  targetModel?: InputMaybe<ModelNameEnum>;
}

export interface TaskProcessing {
  /** The user that processed this task, if any */
  assignee?: Maybe<User>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
}

export interface TaskProcessingInput {
  /** The user that processed this task, if any */
  assignee?: InputMaybe<Scalars['ObjectId']>;
  durationInSeconds?: InputMaybe<Scalars['Float']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
}

export enum TaskStatusEnum {
  Assigned = 'assigned',
  AsyncDone = 'async_done',
  AsyncExpired = 'async_expired',
  AsyncSent = 'async_sent',
  Blocked = 'blocked',
  Cancelled = 'cancelled',
  Disabled = 'disabled',
  Done = 'done',
  Error = 'error',
  Invalid = 'invalid',
  Pending = 'pending',
  Processing = 'processing'
}

export interface Taxonomy {
  RACC?: Maybe<TaxonomyRacc>;
  _id: Scalars['ObjectId'];
  breadcrumb?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  depth: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numProducts?: Maybe<Scalars['Int']>;
  parent?: Maybe<Taxonomy>;
  slug: Scalars['String'];
  type: TaxonomyTypeEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export enum TaxonomyActionEnum {
  Add = 'add',
  Move = 'move',
  Remove = 'remove',
  Update = 'update'
}

export interface TaxonomyActionsInput {
  addOption?: InputMaybe<Scalars['String']>;
  moveDestination?: InputMaybe<Scalars['String']>;
  moveOption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  taxonomyId?: InputMaybe<Scalars['String']>;
  type: TaxonomyActionEnum;
}

export interface TaxonomyFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Taxonomy>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface TaxonomyInput {
  RACC?: InputMaybe<TaxonomyRaccInput>;
  _id?: InputMaybe<Scalars['ObjectId']>;
  breadcrumb?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  depth?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ObjectId']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TaxonomyTypeEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface TaxonomyRacc {
  category: Scalars['String'];
  unit?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
}

export interface TaxonomyRaccInput {
  category?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<Scalars['Float']>;
}

export enum TaxonomyTypeEnum {
  Pinto = 'pinto',
  Spins = 'spins'
}

export interface TotalCostDaily {
  costs: Array<CostBySourceDaily>;
  source: BillingSource;
}

export interface TotalCostPerMonth {
  costs: Array<CostBySource>;
  source: BillingSource;
}

export interface TransformerExpression {
  _id: Scalars['ObjectId'];
  _value: Scalars['String'];
  changelog: Array<ChangelogEntryStruct>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  dataRequirements: Array<DataRequirement>;
  description?: Maybe<Scalars['String']>;
  inputType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  outputType?: Maybe<Scalars['String']>;
  /** Some transformations can be linked directly to a TaskDefinition */
  taskDefinition?: Maybe<TaskDefinition>;
  /** Different transformation types have access to different nodes based un use-case */
  type: TransformerExpressionTypeEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  /** @virtual */
  value: Scalars['JSON'];
  version: Scalars['Float'];
}

export interface TransformerExpressionFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<TransformerExpression>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface TransformerExpressionInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  _value?: InputMaybe<Scalars['String']>;
  changelog?: InputMaybe<Array<ChangelogEntryStructInput>>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  dataRequirements?: InputMaybe<Array<Scalars['JSON']>>;
  description?: InputMaybe<Scalars['String']>;
  inputType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  outputType?: InputMaybe<Scalars['String']>;
  /** Some transformations can be linked directly to a TaskDefinition */
  taskDefinition?: InputMaybe<Scalars['ObjectId']>;
  /** Different transformation types have access to different nodes based un use-case */
  type?: InputMaybe<TransformerExpressionTypeEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  /** @virtual */
  value?: InputMaybe<Scalars['JSON']>;
  version?: InputMaybe<Scalars['Float']>;
}

/** Different transformation types have access to different nodes based un use-case */
export enum TransformerExpressionTypeEnum {
  Default = 'default',
  TaskDependency = 'taskDependency',
  TaskResult = 'taskResult'
}

export interface TransformerResource {
  _id: Scalars['ObjectId'];
  _value: Scalars['String'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  s3Path: Scalars['String'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  /** @virtual */
  value: Scalars['JSON'];
  version: Scalars['Float'];
}

export interface TransformerResourceFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<TransformerResource>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface TransformerResourceInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  _value?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  s3Path?: InputMaybe<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  /** @virtual */
  value?: InputMaybe<Scalars['JSON']>;
  version?: InputMaybe<Scalars['Float']>;
}

export interface TriggerBuilderRecompute {
  alreadyQueued: Scalars['Boolean'];
  bqDataset: Scalars['String'];
  bqDatasetUrl: Scalars['String'];
  bqSuffix: Scalars['String'];
  bqTables: Array<Scalars['String']>;
  dagId: Scalars['String'];
  dagRunId: Scalars['String'];
  dagRunUrl: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  message: Scalars['String'];
}

export interface UpcLevelCoveragePage {
  nodes: Array<UpcLevelCoverageResult>;
  totalCount: Scalars['Int'];
}

export interface UpcLevelCoverageResult {
  attributeLevelSalesKnownValuePercent: Scalars['Float'];
  attributeLevelSalesKnownValuePercentIncrease: Scalars['Float'];
  attributeThemeType: Scalars['String'];
  brand: Scalars['String'];
  category: Scalars['String'];
  department: Scalars['String'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  geography: Scalars['String'];
  maskedUpc: Scalars['String'];
  subcategory: Scalars['String'];
  subcategoryLevelSalesKnownValuePercent: Scalars['Float'];
  subcategoryLevelSalesKnownValuePercentIncrease: Scalars['Float'];
  time: Scalars['String'];
  top25Attribute: Scalars['String'];
  totalDollarSales: Scalars['Float'];
}

export interface UpcStandardizeOptions {
  addCheckDigit?: InputMaybe<Scalars['Boolean']>;
  shouldTrimLeadingZeros?: InputMaybe<Scalars['Boolean']>;
}

export interface UpdatePv2sForUploadedImagesResult {
  success: Scalars['Boolean'];
}

export interface UploadFile {
  uploadedFilename: Scalars['String'];
}

export interface UploadProcessedImagesResult {
  imageId: Scalars['String'];
  success: Scalars['Boolean'];
}

export interface UploadUserStatusResult {
  success?: Maybe<Scalars['Boolean']>;
}

export interface User {
  _id: Scalars['ObjectId'];
  _password?: Maybe<Scalars['String']>;
  /** Global user abilities */
  abilities: Array<UserAbilitiesEnum>;
  auth0Id?: Maybe<Scalars['String']>;
  avatar?: Maybe<UserAvatar>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  digitization?: Maybe<UserDigitization>;
  /** @virtual */
  displayName: Scalars['JSON'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  /** @virtual */
  isAdmin: Scalars['JSON'];
  isBrand?: Maybe<Scalars['Boolean']>;
  isPhotoEntry?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mturkWorker?: Maybe<MturkWorker>;
  /** @virtual */
  password?: Maybe<Scalars['String']>;
  passwordResetCode?: Maybe<Scalars['String']>;
  /** @virtual */
  photoEntry?: Maybe<Scalars['JSON']>;
  pv2CustomFieldPrimary?: Maybe<Pv2CustomFieldConfig>;
  pv2CustomFields: Array<Pv2CustomFieldConfig>;
  receivedGettingStartedEmail?: Maybe<Scalars['Boolean']>;
  role: UserRoleEnum;
  tags: Array<TagStruct>;
  tasker?: Maybe<UserTasker>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export enum UserAbilitiesEnum {
  CircanaManager = 'circana_manager',
  ConfigureFeatureFlags = 'configure_feature_flags',
  CostAndBilling = 'cost_and_billing',
  ImageProcessing = 'image_processing'
}

export interface UserAvatar {
  large?: Maybe<Scalars['String']>;
  small?: Maybe<Scalars['String']>;
}

export interface UserAvatarInput {
  large?: InputMaybe<Scalars['String']>;
  small?: InputMaybe<Scalars['String']>;
}

/** Retains details about user export jobs */
export interface UserBatch {
  _id: Scalars['ObjectId'];
  _query?: Maybe<Scalars['String']>;
  batchServerId?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  exportAllProducts?: Maybe<Scalars['Boolean']>;
  filetype?: Maybe<UserBatchFiletypeEnum>;
  gtins: Array<Scalars['String']>;
  images: Array<UserBatchImagesEnum>;
  internalError?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** When enabled, an email will be sent to the user that created this batch */
  notifyByEmail: Scalars['Boolean'];
  processing?: Maybe<UserBatchProcessing>;
  productIds: Array<Scalars['String']>;
  /** @virtual */
  query?: Maybe<Scalars['JSON']>;
  s3Key: Scalars['String'];
  sections: Array<Scalars['String']>;
  status: UserBatchStatusEnum;
  type: UserBatchTypeEnum;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  urlFormat?: Maybe<UserBatchUrlFormatEnum>;
  userFacingError?: Maybe<Scalars['String']>;
}

export enum UserBatchFiletypeEnum {
  Csv = 'CSV',
  Json = 'JSON'
}

export interface UserBatchFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<UserBatch>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export enum UserBatchImagesEnum {
  All = 'ALL',
  AllPlanogram = 'ALL_PLANOGRAM',
  AllThumbnail = 'ALL_THUMBNAIL',
  Front = 'FRONT',
  FrontPlanogram = 'FRONT_PLANOGRAM',
  FrontThumbnail = 'FRONT_THUMBNAIL'
}

/** Retains details about user export jobs */
export interface UserBatchInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  _query?: InputMaybe<Scalars['String']>;
  batchServerId?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  exportAllProducts?: InputMaybe<Scalars['Boolean']>;
  filetype?: InputMaybe<UserBatchFiletypeEnum>;
  gtins?: InputMaybe<Array<Scalars['String']>>;
  images?: InputMaybe<Array<UserBatchImagesEnum>>;
  internalError?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** When enabled, an email will be sent to the user that created this batch */
  notifyByEmail?: InputMaybe<Scalars['Boolean']>;
  processing?: InputMaybe<UserBatchProcessingInput>;
  productIds?: InputMaybe<Array<Scalars['String']>>;
  /** @virtual */
  query?: InputMaybe<Scalars['JSON']>;
  s3Key?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<UserBatchStatusEnum>;
  type?: InputMaybe<UserBatchTypeEnum>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  urlFormat?: InputMaybe<UserBatchUrlFormatEnum>;
  userFacingError?: InputMaybe<Scalars['String']>;
}

export interface UserBatchProcessing {
  durationInSeconds?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['DateTime']>;
  numProducts?: Maybe<Scalars['Float']>;
  startDate: Scalars['DateTime'];
}

export interface UserBatchProcessingInput {
  durationInSeconds?: InputMaybe<Scalars['Float']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  numProducts?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
}

export enum UserBatchStatusEnum {
  Cancelled = 'cancelled',
  Done = 'done',
  Error = 'error',
  Pending = 'pending',
  Processing = 'processing'
}

export enum UserBatchTypeEnum {
  Data = 'data',
  Images = 'images'
}

export enum UserBatchUrlFormatEnum {
  Gs1 = 'GS1',
  Standard = 'STANDARD',
  Wfmoa = 'WFMOA'
}

export interface UserDigitization {
  domain?: Maybe<Domain>;
  mode: UserDigitizationModeEnum;
  priority: UserDigitizationPriorityEnum;
  store?: Maybe<Scalars['String']>;
  verificationFlow: Scalars['Boolean'];
  workflow?: Maybe<UserDigitizationWorkflowEnum>;
  workflows: Array<UserDigitizationWorkflowsEnum>;
}

export interface UserDigitizationInput {
  domain?: InputMaybe<Scalars['ObjectId']>;
  mode?: InputMaybe<UserDigitizationModeEnum>;
  priority?: InputMaybe<UserDigitizationPriorityEnum>;
  store?: InputMaybe<Scalars['String']>;
  verificationFlow?: InputMaybe<Scalars['Boolean']>;
  workflow?: InputMaybe<UserDigitizationWorkflowEnum>;
  workflows?: InputMaybe<Array<UserDigitizationWorkflowsEnum>>;
}

export enum UserDigitizationModeEnum {
  Photographer = 'photographer',
  Runner = 'runner'
}

export enum UserDigitizationPriorityEnum {
  All = 'all',
  High = 'high',
  Low = 'low'
}

export enum UserDigitizationWorkflowEnum {
  Digitization = 'digitization',
  Dimensions = 'dimensions'
}

export enum UserDigitizationWorkflowsEnum {
  Dimensions = 'dimensions',
  Enterprise = 'enterprise',
  FoodService = 'foodService',
  Photography = 'photography'
}

export interface UserFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<User>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface UserInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  _password?: InputMaybe<Scalars['String']>;
  /** Global user abilities */
  abilities?: InputMaybe<Array<UserAbilitiesEnum>>;
  auth0Id?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<UserAvatarInput>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  digitization?: InputMaybe<UserDigitizationInput>;
  /** @virtual */
  displayName?: InputMaybe<Scalars['JSON']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  /** @virtual */
  isAdmin?: InputMaybe<Scalars['JSON']>;
  isPhotoEntry?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  mturkWorker?: InputMaybe<Scalars['ObjectId']>;
  /** @virtual */
  password?: InputMaybe<Scalars['String']>;
  passwordResetCode?: InputMaybe<Scalars['String']>;
  /** @virtual */
  photoEntry?: InputMaybe<Scalars['JSON']>;
  pv2CustomFieldPrimary?: InputMaybe<Scalars['ObjectId']>;
  pv2CustomFields?: InputMaybe<Array<Scalars['ObjectId']>>;
  receivedGettingStartedEmail?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserRoleEnum>;
  tags?: InputMaybe<Array<TagStructInput>>;
  tasker?: InputMaybe<UserTaskerInput>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface UserOwnPv2sFindQueryResult {
  nodes: Array<Pv2>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
  /** number of Pv2s in the processing stage */
  totalProcessing: Scalars['Int'];
}

export enum UserPermissionEnum {
  AdvancedSearch = 'advanced_search',
  ApiAccess = 'api_access',
  BatchDownload = 'batch_download',
  Catalog = 'catalog',
  ComplianceAdminUserManage = 'compliance_admin_user_manage',
  ComplianceBasicUi = 'compliance_basic_ui',
  DataHealth = 'data_health',
  DomainCancelTrial = 'domain_cancel_trial',
  PintoAdmin = 'pinto_admin',
  ProductDataFull = 'product_data_full',
  ProductDataMarketing = 'product_data_marketing',
  ProductDataPartial = 'product_data_partial',
  ProductDownload = 'product_download',
  ProductEdit = 'product_edit',
  ProductSubmit = 'product_submit',
  ProductTag = 'product_tag',
  ProductVerify = 'product_verify',
  SeeCompanyUi = 'see_company_ui',
  SeeComplianceUi = 'see_compliance_ui',
  SeeManagerUi = 'see_manager_ui',
  UserManage = 'user_manage'
}

export enum UserRoleEnum {
  Admin = 'admin',
  Internal = 'internal',
  User = 'user'
}

/**
 * In the retailer dashboard users can build search queries and optionally save those searches
 * A saved search is stored in the UserSearch model
 */
export interface UserSearch {
  _id: Scalars['ObjectId'];
  _structure?: Maybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  /** @virtual */
  structure: Scalars['JSON'];
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
}

export interface UserSearchFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<UserSearch>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

/**
 * In the retailer dashboard users can build search queries and optionally save those searches
 * A saved search is stored in the UserSearch model
 */
export interface UserSearchInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  _structure?: InputMaybe<Scalars['String']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  /** @virtual */
  structure?: InputMaybe<Scalars['JSON']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
}

export interface UserStatusAppInput {
  build: Scalars['Int'];
  version: Scalars['String'];
}

export interface UserStatusDeviceInput {
  OS?: InputMaybe<Scalars['String']>;
  OSVersion?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
}

export interface UserStatusInput {
  app: UserStatusAppInput;
  appState: Scalars['JSON'];
  device: UserStatusDeviceInput;
  force?: InputMaybe<Scalars['Boolean']>;
  photos: Scalars['JSON'];
}

export interface UserTasker {
  enabled: Scalars['Boolean'];
  tags: Array<Scalars['String']>;
  tasks: Array<TaskDefinition>;
}

export interface UserTaskerInput {
  enabled?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  tasks?: InputMaybe<Array<Scalars['ObjectId']>>;
}

export interface Whitelist {
  _id: Scalars['ObjectId'];
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: Maybe<User>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Domain>;
  name: Scalars['String'];
  normalizedGtins: Array<Scalars['String']>;
  pv2s: Array<Pv2>;
  rawBarcodes: Array<Scalars['String']>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: Maybe<User>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  writeAccess: Scalars['Boolean'];
}

export interface WhitelistFindResult {
  currentPage: Scalars['Int'];
  limit: Scalars['Int'];
  pages: Scalars['Int'];
  results: Array<Whitelist>;
  skip: Scalars['Int'];
  total: Scalars['Int'];
}

export interface WhitelistInput {
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current "doc.context.user" via trackingProps mongoose plugin */
  createdBy?: InputMaybe<Scalars['ObjectId']>;
  /** Defaulted to current date via trackingProps mongoose plugin */
  createdDate?: InputMaybe<Scalars['DateTime']>;
  domain?: InputMaybe<Scalars['ObjectId']>;
  name?: InputMaybe<Scalars['String']>;
  normalizedGtins?: InputMaybe<Array<Scalars['String']>>;
  pv2s?: InputMaybe<Array<Scalars['ObjectId']>>;
  rawBarcodes?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Defaulted to current "Document.context.user" via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedBy?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Defaulted to current date via trackingProps mongoose plugin.
   *
   * Gets overwritten after every "Document.save()", unless it has been manually changed.
   */
  updatedDate?: InputMaybe<Scalars['DateTime']>;
  writeAccess?: InputMaybe<Scalars['Boolean']>;
}

export interface IngredientAttribute {
  id: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['JSON'];
}

export interface SkusInfo {
  /** active skus */
  activeSkus?: Maybe<Scalars['Int']>;
  /** remaining skus: contracted - active */
  remainingSkus?: Maybe<Scalars['Int']>;
  /** sponsored skus */
  sponsoredSkus?: Maybe<Scalars['Int']>;
}

export type BuilderBatchQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type BuilderBatchQuery = { BuilderBatch?: { _id: string, status: BuilderBatchStatusEnum, name: string, description?: string | null, notifyByEmail: boolean, error?: string | null, errorStack?: string | null, saveToBigQuery?: boolean | null, saveComputationsToPv2s: boolean, cancellationRequested: boolean, environment?: string | null, _query?: string | null, _runStats?: string | null, _formula: string, limit?: number | null, includeArtifacts: boolean, createdDate?: string | null, updatedDate?: string | null, query?: any | null, runStats?: any | null, formula: any, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, numProducts?: number | null, progress: number } | null, saveToFile?: { enabled?: boolean | null, fields: Array<string>, allVariables?: boolean | null, format: BuilderBatchSaveToFileFormatEnum, s3Path: string, onlyIncludeUpdatedPv2s?: boolean | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type BuilderBatchFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type BuilderBatchFindQuery = { BuilderBatch_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, status: BuilderBatchStatusEnum, name: string, description?: string | null, notifyByEmail: boolean, error?: string | null, errorStack?: string | null, saveToBigQuery?: boolean | null, saveComputationsToPv2s: boolean, cancellationRequested: boolean, environment?: string | null, _query?: string | null, _runStats?: string | null, _formula: string, limit?: number | null, includeArtifacts: boolean, createdDate?: string | null, updatedDate?: string | null, query?: any | null, runStats?: any | null, formula: any, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, numProducts?: number | null, progress: number } | null, saveToFile?: { enabled?: boolean | null, fields: Array<string>, allVariables?: boolean | null, format: BuilderBatchSaveToFileFormatEnum, s3Path: string, onlyIncludeUpdatedPv2s?: boolean | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type BuilderBatchCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type BuilderBatchCountQuery = { BuilderBatch_count?: number | null };

export type BuilderBatchQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type BuilderBatchQueryIdsQuery = { BuilderBatch_queryIds?: Array<string> | null };

export type BuilderBatchUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: BuilderBatchInput;
}>;


export type BuilderBatchUpdateMutation = { BuilderBatch_update?: { _id: string, status: BuilderBatchStatusEnum, name: string, description?: string | null, notifyByEmail: boolean, error?: string | null, errorStack?: string | null, saveToBigQuery?: boolean | null, saveComputationsToPv2s: boolean, cancellationRequested: boolean, environment?: string | null, _query?: string | null, _runStats?: string | null, _formula: string, limit?: number | null, includeArtifacts: boolean, createdDate?: string | null, updatedDate?: string | null, query?: any | null, runStats?: any | null, formula: any, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, numProducts?: number | null, progress: number } | null, saveToFile?: { enabled?: boolean | null, fields: Array<string>, allVariables?: boolean | null, format: BuilderBatchSaveToFileFormatEnum, s3Path: string, onlyIncludeUpdatedPv2s?: boolean | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type BuilderBatchCreateMutationVariables = Exact<{
  data: BuilderBatchInput;
}>;


export type BuilderBatchCreateMutation = { BuilderBatch_create?: { _id: string, status: BuilderBatchStatusEnum, name: string, description?: string | null, notifyByEmail: boolean, error?: string | null, errorStack?: string | null, saveToBigQuery?: boolean | null, saveComputationsToPv2s: boolean, cancellationRequested: boolean, environment?: string | null, _query?: string | null, _runStats?: string | null, _formula: string, limit?: number | null, includeArtifacts: boolean, createdDate?: string | null, updatedDate?: string | null, query?: any | null, runStats?: any | null, formula: any, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, numProducts?: number | null, progress: number } | null, saveToFile?: { enabled?: boolean | null, fields: Array<string>, allVariables?: boolean | null, format: BuilderBatchSaveToFileFormatEnum, s3Path: string, onlyIncludeUpdatedPv2s?: boolean | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type BuilderBatchRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type BuilderBatchRemoveMutation = { BuilderBatch_remove?: { _id: string, status: BuilderBatchStatusEnum, name: string, description?: string | null, notifyByEmail: boolean, error?: string | null, errorStack?: string | null, saveToBigQuery?: boolean | null, saveComputationsToPv2s: boolean, cancellationRequested: boolean, environment?: string | null, _query?: string | null, _runStats?: string | null, _formula: string, limit?: number | null, includeArtifacts: boolean, createdDate?: string | null, updatedDate?: string | null, query?: any | null, runStats?: any | null, formula: any, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, numProducts?: number | null, progress: number } | null, saveToFile?: { enabled?: boolean | null, fields: Array<string>, allVariables?: boolean | null, format: BuilderBatchSaveToFileFormatEnum, s3Path: string, onlyIncludeUpdatedPv2s?: boolean | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type BuilderBatchRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type BuilderBatchRemoveManyMutation = { BuilderBatch_removeMany?: any | null };

export type BuilderBatchAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type BuilderBatchAggregateMutation = { BuilderBatch_aggregate?: Array<any | null> | null };

export type CompanySignupRequestQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type CompanySignupRequestQuery = { CompanySignupRequest?: { _id: string, email: string, firstName: string, lastName: string, userTitle?: string | null, userCompany?: string | null, userPhone?: string | null, legalCompanyName: string, companyType: CompanySignupRequestCompanyTypeEnum, skuCount?: CompanySignupRequestSkuCountEnum | null, numSkusToManage?: number | null, sponsored?: boolean | null, contractPending?: boolean | null, readyForSetup?: boolean | null, listAllOwnedBrands?: string | null, companyAddress: string, companyAddress2?: string | null, companyCity: string, companyState?: string | null, companyZipCode?: string | null, adultBeverage?: boolean | null, planType?: CompanySignupRequestPlanTypeEnum | null, retailerReferral?: string | null, planPromoCode?: string | null, partnerName?: string | null, status: CompanySignupRequestStatusEnum, country?: string | null, createdDate?: string | null, updatedDate?: string | null, managerAdminInformation?: { firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, title?: string | null } | null, domain?: { _id: string } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type CompanySignupRequestFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type CompanySignupRequestFindQuery = { CompanySignupRequest_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, email: string, firstName: string, lastName: string, userTitle?: string | null, userCompany?: string | null, userPhone?: string | null, legalCompanyName: string, companyType: CompanySignupRequestCompanyTypeEnum, skuCount?: CompanySignupRequestSkuCountEnum | null, numSkusToManage?: number | null, sponsored?: boolean | null, contractPending?: boolean | null, readyForSetup?: boolean | null, listAllOwnedBrands?: string | null, companyAddress: string, companyAddress2?: string | null, companyCity: string, companyState?: string | null, companyZipCode?: string | null, adultBeverage?: boolean | null, planType?: CompanySignupRequestPlanTypeEnum | null, retailerReferral?: string | null, planPromoCode?: string | null, partnerName?: string | null, status: CompanySignupRequestStatusEnum, country?: string | null, createdDate?: string | null, updatedDate?: string | null, managerAdminInformation?: { firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, title?: string | null } | null, domain?: { _id: string } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type CompanySignupRequestCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type CompanySignupRequestCountQuery = { CompanySignupRequest_count?: number | null };

export type CompanySignupRequestQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type CompanySignupRequestQueryIdsQuery = { CompanySignupRequest_queryIds?: Array<string> | null };

export type CompanySignupRequestUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: CompanySignupRequestInput;
}>;


export type CompanySignupRequestUpdateMutation = { CompanySignupRequest_update?: { _id: string, email: string, firstName: string, lastName: string, userTitle?: string | null, userCompany?: string | null, userPhone?: string | null, legalCompanyName: string, companyType: CompanySignupRequestCompanyTypeEnum, skuCount?: CompanySignupRequestSkuCountEnum | null, numSkusToManage?: number | null, sponsored?: boolean | null, contractPending?: boolean | null, readyForSetup?: boolean | null, listAllOwnedBrands?: string | null, companyAddress: string, companyAddress2?: string | null, companyCity: string, companyState?: string | null, companyZipCode?: string | null, adultBeverage?: boolean | null, planType?: CompanySignupRequestPlanTypeEnum | null, retailerReferral?: string | null, planPromoCode?: string | null, partnerName?: string | null, status: CompanySignupRequestStatusEnum, country?: string | null, createdDate?: string | null, updatedDate?: string | null, managerAdminInformation?: { firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, title?: string | null } | null, domain?: { _id: string } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type CompanySignupRequestCreateMutationVariables = Exact<{
  data: CompanySignupRequestInput;
}>;


export type CompanySignupRequestCreateMutation = { CompanySignupRequest_create?: { _id: string, email: string, firstName: string, lastName: string, userTitle?: string | null, userCompany?: string | null, userPhone?: string | null, legalCompanyName: string, companyType: CompanySignupRequestCompanyTypeEnum, skuCount?: CompanySignupRequestSkuCountEnum | null, numSkusToManage?: number | null, sponsored?: boolean | null, contractPending?: boolean | null, readyForSetup?: boolean | null, listAllOwnedBrands?: string | null, companyAddress: string, companyAddress2?: string | null, companyCity: string, companyState?: string | null, companyZipCode?: string | null, adultBeverage?: boolean | null, planType?: CompanySignupRequestPlanTypeEnum | null, retailerReferral?: string | null, planPromoCode?: string | null, partnerName?: string | null, status: CompanySignupRequestStatusEnum, country?: string | null, createdDate?: string | null, updatedDate?: string | null, managerAdminInformation?: { firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, title?: string | null } | null, domain?: { _id: string } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type CompanySignupRequestRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type CompanySignupRequestRemoveMutation = { CompanySignupRequest_remove?: { _id: string, email: string, firstName: string, lastName: string, userTitle?: string | null, userCompany?: string | null, userPhone?: string | null, legalCompanyName: string, companyType: CompanySignupRequestCompanyTypeEnum, skuCount?: CompanySignupRequestSkuCountEnum | null, numSkusToManage?: number | null, sponsored?: boolean | null, contractPending?: boolean | null, readyForSetup?: boolean | null, listAllOwnedBrands?: string | null, companyAddress: string, companyAddress2?: string | null, companyCity: string, companyState?: string | null, companyZipCode?: string | null, adultBeverage?: boolean | null, planType?: CompanySignupRequestPlanTypeEnum | null, retailerReferral?: string | null, planPromoCode?: string | null, partnerName?: string | null, status: CompanySignupRequestStatusEnum, country?: string | null, createdDate?: string | null, updatedDate?: string | null, managerAdminInformation?: { firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, title?: string | null } | null, domain?: { _id: string } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type CompanySignupRequestRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type CompanySignupRequestRemoveManyMutation = { CompanySignupRequest_removeMany?: any | null };

export type CompanySignupRequestAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type CompanySignupRequestAggregateMutation = { CompanySignupRequest_aggregate?: Array<any | null> | null };

export type ConfigQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type ConfigQuery = { Config?: { _id: string, name: string, version: number, description?: string | null, _value: string, _valueJsonSchema?: string | null, createdDate?: string | null, updatedDate?: string | null, validator?: any | null, value: any, valueJsonSchema?: any | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type ConfigFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type ConfigFindQuery = { Config_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, name: string, version: number, description?: string | null, _value: string, _valueJsonSchema?: string | null, createdDate?: string | null, updatedDate?: string | null, validator?: any | null, value: any, valueJsonSchema?: any | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type ConfigCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type ConfigCountQuery = { Config_count?: number | null };

export type ConfigQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type ConfigQueryIdsQuery = { Config_queryIds?: Array<string> | null };

export type ConfigUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: ConfigInput;
}>;


export type ConfigUpdateMutation = { Config_update?: { _id: string, name: string, version: number, description?: string | null, _value: string, _valueJsonSchema?: string | null, createdDate?: string | null, updatedDate?: string | null, validator?: any | null, value: any, valueJsonSchema?: any | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type ConfigCreateMutationVariables = Exact<{
  data: ConfigInput;
}>;


export type ConfigCreateMutation = { Config_create?: { _id: string, name: string, version: number, description?: string | null, _value: string, _valueJsonSchema?: string | null, createdDate?: string | null, updatedDate?: string | null, validator?: any | null, value: any, valueJsonSchema?: any | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type ConfigRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type ConfigRemoveMutation = { Config_remove?: { _id: string, name: string, version: number, description?: string | null, _value: string, _valueJsonSchema?: string | null, createdDate?: string | null, updatedDate?: string | null, validator?: any | null, value: any, valueJsonSchema?: any | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type ConfigRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type ConfigRemoveManyMutation = { Config_removeMany?: any | null };

export type ConfigAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type ConfigAggregateMutation = { Config_aggregate?: Array<any | null> | null };

export type DomainQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type DomainQuery = { Domain?: { _id: string, name: string, type: DomainTypeEnum, nucleusRetailerId?: number | null, membership: DomainMembershipEnum, hasManagerAccess: boolean, hasDigitizationAccess: boolean, digitizationMode: DomainDigitizationModeEnum, identifierPrefix?: string | null, identifierName?: string | null, productExclusivityMode: DomainProductExclusivityModeEnum, planPromoCode?: string | null, estimatedSkuCount?: DomainEstimatedSkuCountEnum | null, numSkusToManage?: number | null, partnerName?: string | null, referredByRetailer?: string | null, manufactureOrDistributeAlcoholInWF?: boolean | null, sponsored?: boolean | null, contractPending?: boolean | null, readyForSetup?: boolean | null, listAllOwnedBrands?: string | null, companyType?: DomainCompanyTypeEnum | null, legalName?: string | null, createdDate?: string | null, updatedDate?: string | null, users: Array<{ role: DomainUserRoleEnum, abilities: Array<DomainUserAbilitiesEnum>, inviteMessage?: string | null, acceptedDate?: string | null, createdDate?: string | null, user?: { _id: string } | null, invitedBy?: { _id: string } | null, createdBy?: { _id: string } | null }>, companies: Array<{ access?: DomainCompanyAccessEnum | null, profileAccess?: DomainCompanyProfileAccessEnum | null, company?: { _id: string } | null }>, taxonomies: Array<{ taxonomy?: { _id: string } | null }>, acceptedTOS?: { date: string, user?: { _id: string } | null } | null, dataAccess: { dataAndImages: boolean, dataOnly: boolean }, contract?: { startDate: string, lengthInDays?: number | null, autoRenewal?: boolean | null, renewalNotificationPeriodInDays: number, feePerYear?: number | null, additionalSkuFeePerYear?: number | null, trialExpirationDate?: string | null, contractedSkus?: number | null } | null, mailingAddress?: { street?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null } | null, billingAddress?: { street?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null } | null, primaryContact?: { name: string, title?: string | null, email: string, phone?: string | null } | null, accountOwner?: { name?: string | null, title?: string | null, email: string, phone?: string | null } | null, documents: Array<{ _id: string, name: string, s3Key: string, fileName: string, fileSizeMb: number, uploadedDate: string, uploadedBy?: { _id: string } | null }>, sftp?: { username: string, s3Path: string, createdDate?: string | null } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type DomainFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type DomainFindQuery = { Domain_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, name: string, type: DomainTypeEnum, nucleusRetailerId?: number | null, membership: DomainMembershipEnum, hasManagerAccess: boolean, hasDigitizationAccess: boolean, digitizationMode: DomainDigitizationModeEnum, identifierPrefix?: string | null, identifierName?: string | null, productExclusivityMode: DomainProductExclusivityModeEnum, planPromoCode?: string | null, estimatedSkuCount?: DomainEstimatedSkuCountEnum | null, numSkusToManage?: number | null, partnerName?: string | null, referredByRetailer?: string | null, manufactureOrDistributeAlcoholInWF?: boolean | null, sponsored?: boolean | null, contractPending?: boolean | null, readyForSetup?: boolean | null, listAllOwnedBrands?: string | null, companyType?: DomainCompanyTypeEnum | null, legalName?: string | null, createdDate?: string | null, updatedDate?: string | null, users: Array<{ role: DomainUserRoleEnum, abilities: Array<DomainUserAbilitiesEnum>, inviteMessage?: string | null, acceptedDate?: string | null, createdDate?: string | null, user?: { _id: string } | null, invitedBy?: { _id: string } | null, createdBy?: { _id: string } | null }>, companies: Array<{ access?: DomainCompanyAccessEnum | null, profileAccess?: DomainCompanyProfileAccessEnum | null, company?: { _id: string } | null }>, taxonomies: Array<{ taxonomy?: { _id: string } | null }>, acceptedTOS?: { date: string, user?: { _id: string } | null } | null, dataAccess: { dataAndImages: boolean, dataOnly: boolean }, contract?: { startDate: string, lengthInDays?: number | null, autoRenewal?: boolean | null, renewalNotificationPeriodInDays: number, feePerYear?: number | null, additionalSkuFeePerYear?: number | null, trialExpirationDate?: string | null, contractedSkus?: number | null } | null, mailingAddress?: { street?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null } | null, billingAddress?: { street?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null } | null, primaryContact?: { name: string, title?: string | null, email: string, phone?: string | null } | null, accountOwner?: { name?: string | null, title?: string | null, email: string, phone?: string | null } | null, documents: Array<{ _id: string, name: string, s3Key: string, fileName: string, fileSizeMb: number, uploadedDate: string, uploadedBy?: { _id: string } | null }>, sftp?: { username: string, s3Path: string, createdDate?: string | null } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type DomainCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type DomainCountQuery = { Domain_count?: number | null };

export type DomainQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type DomainQueryIdsQuery = { Domain_queryIds?: Array<string> | null };

export type DomainUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: DomainInput;
}>;


export type DomainUpdateMutation = { Domain_update?: { _id: string, name: string, type: DomainTypeEnum, nucleusRetailerId?: number | null, membership: DomainMembershipEnum, hasManagerAccess: boolean, hasDigitizationAccess: boolean, digitizationMode: DomainDigitizationModeEnum, identifierPrefix?: string | null, identifierName?: string | null, productExclusivityMode: DomainProductExclusivityModeEnum, planPromoCode?: string | null, estimatedSkuCount?: DomainEstimatedSkuCountEnum | null, numSkusToManage?: number | null, partnerName?: string | null, referredByRetailer?: string | null, manufactureOrDistributeAlcoholInWF?: boolean | null, sponsored?: boolean | null, contractPending?: boolean | null, readyForSetup?: boolean | null, listAllOwnedBrands?: string | null, companyType?: DomainCompanyTypeEnum | null, legalName?: string | null, createdDate?: string | null, updatedDate?: string | null, users: Array<{ role: DomainUserRoleEnum, abilities: Array<DomainUserAbilitiesEnum>, inviteMessage?: string | null, acceptedDate?: string | null, createdDate?: string | null, user?: { _id: string } | null, invitedBy?: { _id: string } | null, createdBy?: { _id: string } | null }>, companies: Array<{ access?: DomainCompanyAccessEnum | null, profileAccess?: DomainCompanyProfileAccessEnum | null, company?: { _id: string } | null }>, taxonomies: Array<{ taxonomy?: { _id: string } | null }>, acceptedTOS?: { date: string, user?: { _id: string } | null } | null, dataAccess: { dataAndImages: boolean, dataOnly: boolean }, contract?: { startDate: string, lengthInDays?: number | null, autoRenewal?: boolean | null, renewalNotificationPeriodInDays: number, feePerYear?: number | null, additionalSkuFeePerYear?: number | null, trialExpirationDate?: string | null, contractedSkus?: number | null } | null, mailingAddress?: { street?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null } | null, billingAddress?: { street?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null } | null, primaryContact?: { name: string, title?: string | null, email: string, phone?: string | null } | null, accountOwner?: { name?: string | null, title?: string | null, email: string, phone?: string | null } | null, documents: Array<{ _id: string, name: string, s3Key: string, fileName: string, fileSizeMb: number, uploadedDate: string, uploadedBy?: { _id: string } | null }>, sftp?: { username: string, s3Path: string, createdDate?: string | null } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type DomainCreateMutationVariables = Exact<{
  data: DomainInput;
}>;


export type DomainCreateMutation = { Domain_create?: { _id: string, name: string, type: DomainTypeEnum, nucleusRetailerId?: number | null, membership: DomainMembershipEnum, hasManagerAccess: boolean, hasDigitizationAccess: boolean, digitizationMode: DomainDigitizationModeEnum, identifierPrefix?: string | null, identifierName?: string | null, productExclusivityMode: DomainProductExclusivityModeEnum, planPromoCode?: string | null, estimatedSkuCount?: DomainEstimatedSkuCountEnum | null, numSkusToManage?: number | null, partnerName?: string | null, referredByRetailer?: string | null, manufactureOrDistributeAlcoholInWF?: boolean | null, sponsored?: boolean | null, contractPending?: boolean | null, readyForSetup?: boolean | null, listAllOwnedBrands?: string | null, companyType?: DomainCompanyTypeEnum | null, legalName?: string | null, createdDate?: string | null, updatedDate?: string | null, users: Array<{ role: DomainUserRoleEnum, abilities: Array<DomainUserAbilitiesEnum>, inviteMessage?: string | null, acceptedDate?: string | null, createdDate?: string | null, user?: { _id: string } | null, invitedBy?: { _id: string } | null, createdBy?: { _id: string } | null }>, companies: Array<{ access?: DomainCompanyAccessEnum | null, profileAccess?: DomainCompanyProfileAccessEnum | null, company?: { _id: string } | null }>, taxonomies: Array<{ taxonomy?: { _id: string } | null }>, acceptedTOS?: { date: string, user?: { _id: string } | null } | null, dataAccess: { dataAndImages: boolean, dataOnly: boolean }, contract?: { startDate: string, lengthInDays?: number | null, autoRenewal?: boolean | null, renewalNotificationPeriodInDays: number, feePerYear?: number | null, additionalSkuFeePerYear?: number | null, trialExpirationDate?: string | null, contractedSkus?: number | null } | null, mailingAddress?: { street?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null } | null, billingAddress?: { street?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null } | null, primaryContact?: { name: string, title?: string | null, email: string, phone?: string | null } | null, accountOwner?: { name?: string | null, title?: string | null, email: string, phone?: string | null } | null, documents: Array<{ _id: string, name: string, s3Key: string, fileName: string, fileSizeMb: number, uploadedDate: string, uploadedBy?: { _id: string } | null }>, sftp?: { username: string, s3Path: string, createdDate?: string | null } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type DomainRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type DomainRemoveMutation = { Domain_remove?: { _id: string, name: string, type: DomainTypeEnum, nucleusRetailerId?: number | null, membership: DomainMembershipEnum, hasManagerAccess: boolean, hasDigitizationAccess: boolean, digitizationMode: DomainDigitizationModeEnum, identifierPrefix?: string | null, identifierName?: string | null, productExclusivityMode: DomainProductExclusivityModeEnum, planPromoCode?: string | null, estimatedSkuCount?: DomainEstimatedSkuCountEnum | null, numSkusToManage?: number | null, partnerName?: string | null, referredByRetailer?: string | null, manufactureOrDistributeAlcoholInWF?: boolean | null, sponsored?: boolean | null, contractPending?: boolean | null, readyForSetup?: boolean | null, listAllOwnedBrands?: string | null, companyType?: DomainCompanyTypeEnum | null, legalName?: string | null, createdDate?: string | null, updatedDate?: string | null, users: Array<{ role: DomainUserRoleEnum, abilities: Array<DomainUserAbilitiesEnum>, inviteMessage?: string | null, acceptedDate?: string | null, createdDate?: string | null, user?: { _id: string } | null, invitedBy?: { _id: string } | null, createdBy?: { _id: string } | null }>, companies: Array<{ access?: DomainCompanyAccessEnum | null, profileAccess?: DomainCompanyProfileAccessEnum | null, company?: { _id: string } | null }>, taxonomies: Array<{ taxonomy?: { _id: string } | null }>, acceptedTOS?: { date: string, user?: { _id: string } | null } | null, dataAccess: { dataAndImages: boolean, dataOnly: boolean }, contract?: { startDate: string, lengthInDays?: number | null, autoRenewal?: boolean | null, renewalNotificationPeriodInDays: number, feePerYear?: number | null, additionalSkuFeePerYear?: number | null, trialExpirationDate?: string | null, contractedSkus?: number | null } | null, mailingAddress?: { street?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null } | null, billingAddress?: { street?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null } | null, primaryContact?: { name: string, title?: string | null, email: string, phone?: string | null } | null, accountOwner?: { name?: string | null, title?: string | null, email: string, phone?: string | null } | null, documents: Array<{ _id: string, name: string, s3Key: string, fileName: string, fileSizeMb: number, uploadedDate: string, uploadedBy?: { _id: string } | null }>, sftp?: { username: string, s3Path: string, createdDate?: string | null } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type DomainRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type DomainRemoveManyMutation = { Domain_removeMany?: any | null };

export type DomainAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type DomainAggregateMutation = { Domain_aggregate?: Array<any | null> | null };

export type FormInstructionQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type FormInstructionQuery = { FormInstruction?: { _id: string, name: string, structure: any, s3Path: string, createdDate?: string | null, updatedDate?: string | null, form?: { _id: string } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormInstructionFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type FormInstructionFindQuery = { FormInstruction_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, name: string, structure: any, s3Path: string, createdDate?: string | null, updatedDate?: string | null, form?: { _id: string } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type FormInstructionCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type FormInstructionCountQuery = { FormInstruction_count?: number | null };

export type FormInstructionQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type FormInstructionQueryIdsQuery = { FormInstruction_queryIds?: Array<string> | null };

export type FormInstructionUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: FormInstructionInput;
}>;


export type FormInstructionUpdateMutation = { FormInstruction_update?: { _id: string, name: string, structure: any, s3Path: string, createdDate?: string | null, updatedDate?: string | null, form?: { _id: string } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormInstructionCreateMutationVariables = Exact<{
  data: FormInstructionInput;
}>;


export type FormInstructionCreateMutation = { FormInstruction_create?: { _id: string, name: string, structure: any, s3Path: string, createdDate?: string | null, updatedDate?: string | null, form?: { _id: string } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormInstructionRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type FormInstructionRemoveMutation = { FormInstruction_remove?: { _id: string, name: string, structure: any, s3Path: string, createdDate?: string | null, updatedDate?: string | null, form?: { _id: string } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormInstructionRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type FormInstructionRemoveManyMutation = { FormInstruction_removeMany?: any | null };

export type FormInstructionAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type FormInstructionAggregateMutation = { FormInstruction_aggregate?: Array<any | null> | null };

export type FormQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type FormQuery = { Form?: { _id: string, name: string, version: number, description?: string | null, s3Path: string, sideComponent: FormSideComponentEnum, tags: Array<string>, createdDate?: string | null, updatedDate?: string | null, config: any, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type FormFindQuery = { Form_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, name: string, version: number, description?: string | null, s3Path: string, sideComponent: FormSideComponentEnum, tags: Array<string>, createdDate?: string | null, updatedDate?: string | null, config: any, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type FormCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type FormCountQuery = { Form_count?: number | null };

export type FormQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type FormQueryIdsQuery = { Form_queryIds?: Array<string> | null };

export type FormUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: FormInput;
}>;


export type FormUpdateMutation = { Form_update?: { _id: string, name: string, version: number, description?: string | null, s3Path: string, sideComponent: FormSideComponentEnum, tags: Array<string>, createdDate?: string | null, updatedDate?: string | null, config: any, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormCreateMutationVariables = Exact<{
  data: FormInput;
}>;


export type FormCreateMutation = { Form_create?: { _id: string, name: string, version: number, description?: string | null, s3Path: string, sideComponent: FormSideComponentEnum, tags: Array<string>, createdDate?: string | null, updatedDate?: string | null, config: any, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type FormRemoveMutation = { Form_remove?: { _id: string, name: string, version: number, description?: string | null, s3Path: string, sideComponent: FormSideComponentEnum, tags: Array<string>, createdDate?: string | null, updatedDate?: string | null, config: any, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type FormRemoveManyMutation = { Form_removeMany?: any | null };

export type FormAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type FormAggregateMutation = { Form_aggregate?: Array<any | null> | null };

export type FormulaQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type FormulaQuery = { Formula?: { _id: string, version: number, name: string, description?: string | null, fields: Array<string>, isPublic: boolean, runInPv2Middleware: boolean, filter?: string | null, structure: string, functions?: string | null, outputAttributeTypes: Array<string>, createdDate?: string | null, updatedDate?: string | null, changelog: Array<{ version: number, text: string }>, inputResources: { direct: Array<{ _id: string }>, indirect: Array<{ _id: string }> }, inputAttributeTypes: { direct: Array<string>, indirect: Array<string> }, inputProductFields: { direct: Array<string>, indirect: Array<string> }, inputCleansedDataPoints: { direct: Array<string>, indirect: Array<string> }, inputClientTrackerAttributes: { direct: Array<string>, indirect: Array<string> }, referencedFormulas: Array<{ name?: string | null, imports: Array<string>, formula?: { _id: string } | null }>, affectedByFormulas: Array<{ name?: string | null, formula?: { _id: string } | null }>, exports: Array<{ name: string, attributeTypes: Array<string>, productFields: Array<string>, cleansedDataPoints: Array<string>, clientTrackerAttributes: Array<string>, resources: Array<{ _id: string }> }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormulaFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type FormulaFindQuery = { Formula_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, version: number, name: string, description?: string | null, fields: Array<string>, isPublic: boolean, runInPv2Middleware: boolean, filter?: string | null, structure: string, functions?: string | null, outputAttributeTypes: Array<string>, createdDate?: string | null, updatedDate?: string | null, changelog: Array<{ version: number, text: string }>, inputResources: { direct: Array<{ _id: string }>, indirect: Array<{ _id: string }> }, inputAttributeTypes: { direct: Array<string>, indirect: Array<string> }, inputProductFields: { direct: Array<string>, indirect: Array<string> }, inputCleansedDataPoints: { direct: Array<string>, indirect: Array<string> }, inputClientTrackerAttributes: { direct: Array<string>, indirect: Array<string> }, referencedFormulas: Array<{ name?: string | null, imports: Array<string>, formula?: { _id: string } | null }>, affectedByFormulas: Array<{ name?: string | null, formula?: { _id: string } | null }>, exports: Array<{ name: string, attributeTypes: Array<string>, productFields: Array<string>, cleansedDataPoints: Array<string>, clientTrackerAttributes: Array<string>, resources: Array<{ _id: string }> }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type FormulaCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type FormulaCountQuery = { Formula_count?: number | null };

export type FormulaQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type FormulaQueryIdsQuery = { Formula_queryIds?: Array<string> | null };

export type FormulaUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: FormulaInput;
}>;


export type FormulaUpdateMutation = { Formula_update?: { _id: string, version: number, name: string, description?: string | null, fields: Array<string>, isPublic: boolean, runInPv2Middleware: boolean, filter?: string | null, structure: string, functions?: string | null, outputAttributeTypes: Array<string>, createdDate?: string | null, updatedDate?: string | null, changelog: Array<{ version: number, text: string }>, inputResources: { direct: Array<{ _id: string }>, indirect: Array<{ _id: string }> }, inputAttributeTypes: { direct: Array<string>, indirect: Array<string> }, inputProductFields: { direct: Array<string>, indirect: Array<string> }, inputCleansedDataPoints: { direct: Array<string>, indirect: Array<string> }, inputClientTrackerAttributes: { direct: Array<string>, indirect: Array<string> }, referencedFormulas: Array<{ name?: string | null, imports: Array<string>, formula?: { _id: string } | null }>, affectedByFormulas: Array<{ name?: string | null, formula?: { _id: string } | null }>, exports: Array<{ name: string, attributeTypes: Array<string>, productFields: Array<string>, cleansedDataPoints: Array<string>, clientTrackerAttributes: Array<string>, resources: Array<{ _id: string }> }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormulaCreateMutationVariables = Exact<{
  data: FormulaInput;
}>;


export type FormulaCreateMutation = { Formula_create?: { _id: string, version: number, name: string, description?: string | null, fields: Array<string>, isPublic: boolean, runInPv2Middleware: boolean, filter?: string | null, structure: string, functions?: string | null, outputAttributeTypes: Array<string>, createdDate?: string | null, updatedDate?: string | null, changelog: Array<{ version: number, text: string }>, inputResources: { direct: Array<{ _id: string }>, indirect: Array<{ _id: string }> }, inputAttributeTypes: { direct: Array<string>, indirect: Array<string> }, inputProductFields: { direct: Array<string>, indirect: Array<string> }, inputCleansedDataPoints: { direct: Array<string>, indirect: Array<string> }, inputClientTrackerAttributes: { direct: Array<string>, indirect: Array<string> }, referencedFormulas: Array<{ name?: string | null, imports: Array<string>, formula?: { _id: string } | null }>, affectedByFormulas: Array<{ name?: string | null, formula?: { _id: string } | null }>, exports: Array<{ name: string, attributeTypes: Array<string>, productFields: Array<string>, cleansedDataPoints: Array<string>, clientTrackerAttributes: Array<string>, resources: Array<{ _id: string }> }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormulaRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type FormulaRemoveMutation = { Formula_remove?: { _id: string, version: number, name: string, description?: string | null, fields: Array<string>, isPublic: boolean, runInPv2Middleware: boolean, filter?: string | null, structure: string, functions?: string | null, outputAttributeTypes: Array<string>, createdDate?: string | null, updatedDate?: string | null, changelog: Array<{ version: number, text: string }>, inputResources: { direct: Array<{ _id: string }>, indirect: Array<{ _id: string }> }, inputAttributeTypes: { direct: Array<string>, indirect: Array<string> }, inputProductFields: { direct: Array<string>, indirect: Array<string> }, inputCleansedDataPoints: { direct: Array<string>, indirect: Array<string> }, inputClientTrackerAttributes: { direct: Array<string>, indirect: Array<string> }, referencedFormulas: Array<{ name?: string | null, imports: Array<string>, formula?: { _id: string } | null }>, affectedByFormulas: Array<{ name?: string | null, formula?: { _id: string } | null }>, exports: Array<{ name: string, attributeTypes: Array<string>, productFields: Array<string>, cleansedDataPoints: Array<string>, clientTrackerAttributes: Array<string>, resources: Array<{ _id: string }> }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormulaRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type FormulaRemoveManyMutation = { Formula_removeMany?: any | null };

export type FormulaAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type FormulaAggregateMutation = { Formula_aggregate?: Array<any | null> | null };

export type FormulaResourceQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type FormulaResourceQuery = { FormulaResource?: { _id: string, version: number, type: FormulaResourceTypeEnum, config?: any | null, name: string, slug: string, description?: string | null, value: string, totalChildren: number, ownItems: number, totalItems: number, s3Path: string, createdDate?: string | null, updatedDate?: string | null, valueJSON: any, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, children: Array<{ _id: string }>, descendents: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormulaResourceFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type FormulaResourceFindQuery = { FormulaResource_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, version: number, type: FormulaResourceTypeEnum, config?: any | null, name: string, slug: string, description?: string | null, value: string, totalChildren: number, ownItems: number, totalItems: number, s3Path: string, createdDate?: string | null, updatedDate?: string | null, valueJSON: any, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, children: Array<{ _id: string }>, descendents: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type FormulaResourceCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type FormulaResourceCountQuery = { FormulaResource_count?: number | null };

export type FormulaResourceQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type FormulaResourceQueryIdsQuery = { FormulaResource_queryIds?: Array<string> | null };

export type FormulaResourceUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: FormulaResourceInput;
}>;


export type FormulaResourceUpdateMutation = { FormulaResource_update?: { _id: string, version: number, type: FormulaResourceTypeEnum, config?: any | null, name: string, slug: string, description?: string | null, value: string, totalChildren: number, ownItems: number, totalItems: number, s3Path: string, createdDate?: string | null, updatedDate?: string | null, valueJSON: any, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, children: Array<{ _id: string }>, descendents: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormulaResourceCreateMutationVariables = Exact<{
  data: FormulaResourceInput;
}>;


export type FormulaResourceCreateMutation = { FormulaResource_create?: { _id: string, version: number, type: FormulaResourceTypeEnum, config?: any | null, name: string, slug: string, description?: string | null, value: string, totalChildren: number, ownItems: number, totalItems: number, s3Path: string, createdDate?: string | null, updatedDate?: string | null, valueJSON: any, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, children: Array<{ _id: string }>, descendents: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormulaResourceRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type FormulaResourceRemoveMutation = { FormulaResource_remove?: { _id: string, version: number, type: FormulaResourceTypeEnum, config?: any | null, name: string, slug: string, description?: string | null, value: string, totalChildren: number, ownItems: number, totalItems: number, s3Path: string, createdDate?: string | null, updatedDate?: string | null, valueJSON: any, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, children: Array<{ _id: string }>, descendents: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type FormulaResourceRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type FormulaResourceRemoveManyMutation = { FormulaResource_removeMany?: any | null };

export type FormulaResourceAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type FormulaResourceAggregateMutation = { FormulaResource_aggregate?: Array<any | null> | null };

export type ImageQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type ImageQuery = { Image?: { _id?: string | null, type: ImageTypeEnum, status: ImageStatusEnum, key?: string | null, side: string, source?: string | null, name?: string | null, rejectionReason?: ImageRejectionReasonEnum | null, acceptedTimestamp: string, isInImageProcessingQueue: boolean, pv2ProcessingPriority: number, createdDate?: string | null, updatedDate?: string | null, angle: any, downloaded?: { timestamp: string, user?: { _id: string } | null } | null, uploaded?: { timestamp: string, user?: { _id: string } | null } | null, scannedBarcodes: Array<{ type: string, value: string }>, urls: Array<{ type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null }>, overrides?: { _id?: string | null } | null, pv2?: { _id: string } | null, digitizationOriginalUrls: Array<{ type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, mainUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null, thumbnailUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null, croppedUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null } | null };

export type ImageFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type ImageFindQuery = { Image_find?: { total: number, skip: number, limit: number, results: Array<{ _id?: string | null, type: ImageTypeEnum, status: ImageStatusEnum, key?: string | null, side: string, source?: string | null, name?: string | null, rejectionReason?: ImageRejectionReasonEnum | null, acceptedTimestamp: string, isInImageProcessingQueue: boolean, pv2ProcessingPriority: number, createdDate?: string | null, updatedDate?: string | null, angle: any, downloaded?: { timestamp: string, user?: { _id: string } | null } | null, uploaded?: { timestamp: string, user?: { _id: string } | null } | null, scannedBarcodes: Array<{ type: string, value: string }>, urls: Array<{ type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null }>, overrides?: { _id?: string | null } | null, pv2?: { _id: string } | null, digitizationOriginalUrls: Array<{ type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, mainUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null, thumbnailUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null, croppedUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null }> } | null };

export type ImageCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type ImageCountQuery = { Image_count?: number | null };

export type ImageQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type ImageQueryIdsQuery = { Image_queryIds?: Array<string> | null };

export type ImageUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: ImageInput;
}>;


export type ImageUpdateMutation = { Image_update?: { _id?: string | null, type: ImageTypeEnum, status: ImageStatusEnum, key?: string | null, side: string, source?: string | null, name?: string | null, rejectionReason?: ImageRejectionReasonEnum | null, acceptedTimestamp: string, isInImageProcessingQueue: boolean, pv2ProcessingPriority: number, createdDate?: string | null, updatedDate?: string | null, angle: any, downloaded?: { timestamp: string, user?: { _id: string } | null } | null, uploaded?: { timestamp: string, user?: { _id: string } | null } | null, scannedBarcodes: Array<{ type: string, value: string }>, urls: Array<{ type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null }>, overrides?: { _id?: string | null } | null, pv2?: { _id: string } | null, digitizationOriginalUrls: Array<{ type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, mainUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null, thumbnailUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null, croppedUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null } | null };

export type Image_CreateMutationVariables = Exact<{
  data: ImageInput;
  imageFile: Scalars['Upload'];
}>;


export type Image_CreateMutation = { Image_create?: { _id?: string | null, type: ImageTypeEnum, status: ImageStatusEnum, key?: string | null, side: string, source?: string | null, name?: string | null, rejectionReason?: ImageRejectionReasonEnum | null, acceptedTimestamp: string, isInImageProcessingQueue: boolean, pv2ProcessingPriority: number, createdDate?: string | null, updatedDate?: string | null, angle: any, downloaded?: { timestamp: string, user?: { _id: string } | null } | null, uploaded?: { timestamp: string, user?: { _id: string } | null } | null, scannedBarcodes: Array<{ type: string, value: string }>, urls: Array<{ type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null }>, overrides?: { _id?: string | null } | null, pv2?: { _id: string } | null, digitizationOriginalUrls: Array<{ type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, mainUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null, thumbnailUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null, croppedUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null } | null };

export type ImageRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type ImageRemoveMutation = { Image_remove?: { _id?: string | null, type: ImageTypeEnum, status: ImageStatusEnum, key?: string | null, side: string, source?: string | null, name?: string | null, rejectionReason?: ImageRejectionReasonEnum | null, acceptedTimestamp: string, isInImageProcessingQueue: boolean, pv2ProcessingPriority: number, createdDate?: string | null, updatedDate?: string | null, angle: any, downloaded?: { timestamp: string, user?: { _id: string } | null } | null, uploaded?: { timestamp: string, user?: { _id: string } | null } | null, scannedBarcodes: Array<{ type: string, value: string }>, urls: Array<{ type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null }>, overrides?: { _id?: string | null } | null, pv2?: { _id: string } | null, digitizationOriginalUrls: Array<{ type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, mainUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null, thumbnailUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null, croppedUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null } | null };

export type ImageRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type ImageRemoveManyMutation = { Image_removeMany?: any | null };

export type ImageAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type ImageAggregateMutation = { Image_aggregate?: Array<any | null> | null };

export type MturkWorkerQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type MturkWorkerQuery = { MturkWorker?: { _id: string, WorkerId: string, name?: string | null, isBlocked?: boolean | null, qualificationsCount: number, revokedQualificationsCount: number, createdDate?: string | null, attributes: Array<{ _id: string, type: string, value: number, createdDate?: string | null, createdBy?: { _id: string } | null }>, qualifications: Array<{ QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null }>, revokedQualifications: Array<{ QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null }>, stats?: { date: string, total?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, threeMonths?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, oneMonth?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, perTaskTotal: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }>, perTaskThreeMonths: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }>, perTaskOneMonth: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }> } | null } | null };

export type MturkWorkerFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type MturkWorkerFindQuery = { MturkWorker_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, WorkerId: string, name?: string | null, isBlocked?: boolean | null, qualificationsCount: number, revokedQualificationsCount: number, createdDate?: string | null, attributes: Array<{ _id: string, type: string, value: number, createdDate?: string | null, createdBy?: { _id: string } | null }>, qualifications: Array<{ QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null }>, revokedQualifications: Array<{ QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null }>, stats?: { date: string, total?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, threeMonths?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, oneMonth?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, perTaskTotal: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }>, perTaskThreeMonths: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }>, perTaskOneMonth: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }> } | null }> } | null };

export type MturkWorkerCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type MturkWorkerCountQuery = { MturkWorker_count?: number | null };

export type MturkWorkerQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type MturkWorkerQueryIdsQuery = { MturkWorker_queryIds?: Array<string> | null };

export type MturkWorkerUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: MturkWorkerInput;
}>;


export type MturkWorkerUpdateMutation = { MturkWorker_update?: { _id: string, WorkerId: string, name?: string | null, isBlocked?: boolean | null, qualificationsCount: number, revokedQualificationsCount: number, createdDate?: string | null, attributes: Array<{ _id: string, type: string, value: number, createdDate?: string | null, createdBy?: { _id: string } | null }>, qualifications: Array<{ QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null }>, revokedQualifications: Array<{ QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null }>, stats?: { date: string, total?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, threeMonths?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, oneMonth?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, perTaskTotal: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }>, perTaskThreeMonths: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }>, perTaskOneMonth: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }> } | null } | null };

export type MturkWorkerCreateMutationVariables = Exact<{
  data: MturkWorkerInput;
}>;


export type MturkWorkerCreateMutation = { MturkWorker_create?: { _id: string, WorkerId: string, name?: string | null, isBlocked?: boolean | null, qualificationsCount: number, revokedQualificationsCount: number, createdDate?: string | null, attributes: Array<{ _id: string, type: string, value: number, createdDate?: string | null, createdBy?: { _id: string } | null }>, qualifications: Array<{ QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null }>, revokedQualifications: Array<{ QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null }>, stats?: { date: string, total?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, threeMonths?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, oneMonth?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, perTaskTotal: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }>, perTaskThreeMonths: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }>, perTaskOneMonth: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }> } | null } | null };

export type MturkWorkerRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type MturkWorkerRemoveMutation = { MturkWorker_remove?: { _id: string, WorkerId: string, name?: string | null, isBlocked?: boolean | null, qualificationsCount: number, revokedQualificationsCount: number, createdDate?: string | null, attributes: Array<{ _id: string, type: string, value: number, createdDate?: string | null, createdBy?: { _id: string } | null }>, qualifications: Array<{ QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null }>, revokedQualifications: Array<{ QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null }>, stats?: { date: string, total?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, threeMonths?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, oneMonth?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, perTaskTotal: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }>, perTaskThreeMonths: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }>, perTaskOneMonth: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }> } | null } | null };

export type MturkWorkerRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type MturkWorkerRemoveManyMutation = { MturkWorker_removeMany?: any | null };

export type MturkWorkerAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type MturkWorkerAggregateMutation = { MturkWorker_aggregate?: Array<any | null> | null };

export type Pv2AttributeDefinitionQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type Pv2AttributeDefinitionQuery = { Pv2AttributeDefinition?: { _id: string, active: boolean, name: string, type: string, version: number, versionDate: string, hasKey: boolean, parents: Array<string>, description?: string | null, internalDescription?: string | null, required: Array<Pv2AttributeDefinitionRequiredEnum>, hasValue: boolean, _valueSchema?: string | null, createdDate?: string | null, updatedDate?: string | null, valueSchema?: any | null, domains: Array<{ _id: string }>, taxonomies: Array<{ _id: string }>, hierarchies: Array<{ _id: string }>, changelog: Array<{ version: number, message: string, date: string, user?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type Pv2AttributeDefinitionFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type Pv2AttributeDefinitionFindQuery = { Pv2AttributeDefinition_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, active: boolean, name: string, type: string, version: number, versionDate: string, hasKey: boolean, parents: Array<string>, description?: string | null, internalDescription?: string | null, required: Array<Pv2AttributeDefinitionRequiredEnum>, hasValue: boolean, _valueSchema?: string | null, createdDate?: string | null, updatedDate?: string | null, valueSchema?: any | null, domains: Array<{ _id: string }>, taxonomies: Array<{ _id: string }>, hierarchies: Array<{ _id: string }>, changelog: Array<{ version: number, message: string, date: string, user?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type Pv2AttributeDefinitionCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type Pv2AttributeDefinitionCountQuery = { Pv2AttributeDefinition_count?: number | null };

export type Pv2AttributeDefinitionQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type Pv2AttributeDefinitionQueryIdsQuery = { Pv2AttributeDefinition_queryIds?: Array<string> | null };

export type Pv2AttributeDefinitionUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: Pv2AttributeDefinitionInput;
}>;


export type Pv2AttributeDefinitionUpdateMutation = { Pv2AttributeDefinition_update?: { _id: string, active: boolean, name: string, type: string, version: number, versionDate: string, hasKey: boolean, parents: Array<string>, description?: string | null, internalDescription?: string | null, required: Array<Pv2AttributeDefinitionRequiredEnum>, hasValue: boolean, _valueSchema?: string | null, createdDate?: string | null, updatedDate?: string | null, valueSchema?: any | null, domains: Array<{ _id: string }>, taxonomies: Array<{ _id: string }>, hierarchies: Array<{ _id: string }>, changelog: Array<{ version: number, message: string, date: string, user?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type Pv2AttributeDefinitionCreateMutationVariables = Exact<{
  data: Pv2AttributeDefinitionInput;
}>;


export type Pv2AttributeDefinitionCreateMutation = { Pv2AttributeDefinition_create?: { _id: string, active: boolean, name: string, type: string, version: number, versionDate: string, hasKey: boolean, parents: Array<string>, description?: string | null, internalDescription?: string | null, required: Array<Pv2AttributeDefinitionRequiredEnum>, hasValue: boolean, _valueSchema?: string | null, createdDate?: string | null, updatedDate?: string | null, valueSchema?: any | null, domains: Array<{ _id: string }>, taxonomies: Array<{ _id: string }>, hierarchies: Array<{ _id: string }>, changelog: Array<{ version: number, message: string, date: string, user?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type Pv2AttributeDefinitionRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type Pv2AttributeDefinitionRemoveMutation = { Pv2AttributeDefinition_remove?: { _id: string, active: boolean, name: string, type: string, version: number, versionDate: string, hasKey: boolean, parents: Array<string>, description?: string | null, internalDescription?: string | null, required: Array<Pv2AttributeDefinitionRequiredEnum>, hasValue: boolean, _valueSchema?: string | null, createdDate?: string | null, updatedDate?: string | null, valueSchema?: any | null, domains: Array<{ _id: string }>, taxonomies: Array<{ _id: string }>, hierarchies: Array<{ _id: string }>, changelog: Array<{ version: number, message: string, date: string, user?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type Pv2AttributeDefinitionRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type Pv2AttributeDefinitionRemoveManyMutation = { Pv2AttributeDefinition_removeMany?: any | null };

export type Pv2AttributeDefinitionAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type Pv2AttributeDefinitionAggregateMutation = { Pv2AttributeDefinition_aggregate?: Array<any | null> | null };

export type Pv2QueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type Pv2Query = { Pv2?: { _id: string, status: Pv2StatusEnum, name: string, slug: string, deliveredToCircana: boolean, firstDeliveredToSnapshot?: string | null, spinsAttributesEligibilityOverride?: boolean | null, gtin: string, spinsUpc: string, maskedUpc: string, digitizationStoresInitialized: boolean, hierarchyOverride?: Pv2HierarchyOverrideEnum | null, source?: string | null, barcode128?: string | null, parentGTIN?: string | null, dataUpdatedDate: string, itemType: Pv2ItemTypeEnum, imagesCount?: number | null, imageUpdatedDate?: string | null, processingPriority: number, overrideExclusivity: boolean, overrideBarcodeGtinGeneration: boolean, needsVerification: boolean, isCopy: boolean, hasFailedFormulas: boolean, invalidAttributeParents: Array<string>, hasInvalidAttributeParents: boolean, circanaKeycat?: string | null, createdDate?: string | null, updatedDate?: string | null, notification?: { date: string, userId?: { _id: string } | null } | null, brand?: { _id: string } | null, manufacturer?: { _id: string } | null, companies: Array<{ _id: string }>, barcodes: Array<{ GTIN: string, source?: string | null, original: string, format: string, date: string, isPrivateLabel?: boolean | null, hash?: string | null, domain?: { _id: string } | null, options?: { addCheckDigit?: boolean | null, shouldTrimLeadingZeros?: boolean | null } | null }>, asinChildren: Array<{ _id: string }>, asin?: { asin?: string | null, associatedGtin?: string | null } | null, identifiers: Array<{ hash: string, value: string, domain?: { _id: string } | null }>, ingestionMetadata: Array<{ brand?: string | null, category?: string | null, subcategory?: string | null, rawPayload?: any | null, domain?: { _id: string } | null }>, whitelists: Array<{ _id: string }>, dedupeDomains: Array<{ _id: string }>, digitizationStores: Array<{ _id: string }>, taxonomies: Array<{ _id: string }>, hierarchies: Array<{ _id: string }>, containerChildren: Array<{ _id: string }>, images: Array<{ _id?: string | null }>, imageStatus?: { state: Pv2ImageStatusStateEnum, doneDate?: string | null } | null, outdatedImages: Array<{ _id?: string | null }>, tags?: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null } | null> | null, exclusivity?: { type: Pv2ExclusivityTypeEnum, domain?: { _id: string } | null } | null, attributes: Array<{ type: string, key?: string | null, uid?: string | null, source?: string | null, parent?: string | null, value?: any | null, dataProvider?: Pv2AttributeStructDataProviderEnum | null, createdDate?: string | null, valueUpdatedDate: string, task?: { _id: string } | null }>, lastVerification?: { _id?: string | null, upToDate: boolean, date: string, verifier?: { _id: string } | null } | null, discontinued?: { date: string, user?: { _id: string } | null } | null, digitizationStatus?: { status: Pv2DigitizationStatusStatusEnum, date: string, store?: string | null, user?: { _id: string } | null, domain?: { _id: string } | null } | null, digitizationOutOfStock: Array<{ store: string, date: string, user?: { _id: string } | null }>, digitizationStoreDone?: { store?: string | null, date: string, user?: { _id: string } | null } | null, copy?: { _id: string } | null, original?: { _id: string } | null, taskerStatus?: { state?: Pv2TaskerStatusStateEnum | null, pending: number, processing: number, async_sent: number, assigned: number, async_done: number, async_expired: number, done: number, error: number, blocked: number, disabled: number, invalid: number, cancelled: number, startDate?: string | null, doneDate?: string | null } | null, pv2Ingredients: Array<{ componentType: Pv2Pv2IngredientsComponentTypeEnum, pv2Ingredient?: { _id: string } | null }>, failedFormulas: Array<{ _id: string }>, cleansedData?: { _id: string } | null, mergedCopyPv2Ids: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type Pv2FindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type Pv2FindQuery = { Pv2_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, status: Pv2StatusEnum, name: string, slug: string, deliveredToCircana: boolean, firstDeliveredToSnapshot?: string | null, spinsAttributesEligibilityOverride?: boolean | null, gtin: string, spinsUpc: string, maskedUpc: string, digitizationStoresInitialized: boolean, hierarchyOverride?: Pv2HierarchyOverrideEnum | null, source?: string | null, barcode128?: string | null, parentGTIN?: string | null, dataUpdatedDate: string, itemType: Pv2ItemTypeEnum, imagesCount?: number | null, imageUpdatedDate?: string | null, processingPriority: number, overrideExclusivity: boolean, overrideBarcodeGtinGeneration: boolean, needsVerification: boolean, isCopy: boolean, hasFailedFormulas: boolean, invalidAttributeParents: Array<string>, hasInvalidAttributeParents: boolean, circanaKeycat?: string | null, createdDate?: string | null, updatedDate?: string | null, notification?: { date: string, userId?: { _id: string } | null } | null, brand?: { _id: string } | null, manufacturer?: { _id: string } | null, companies: Array<{ _id: string }>, barcodes: Array<{ GTIN: string, source?: string | null, original: string, format: string, date: string, isPrivateLabel?: boolean | null, hash?: string | null, domain?: { _id: string } | null, options?: { addCheckDigit?: boolean | null, shouldTrimLeadingZeros?: boolean | null } | null }>, asinChildren: Array<{ _id: string }>, asin?: { asin?: string | null, associatedGtin?: string | null } | null, identifiers: Array<{ hash: string, value: string, domain?: { _id: string } | null }>, ingestionMetadata: Array<{ brand?: string | null, category?: string | null, subcategory?: string | null, rawPayload?: any | null, domain?: { _id: string } | null }>, whitelists: Array<{ _id: string }>, dedupeDomains: Array<{ _id: string }>, digitizationStores: Array<{ _id: string }>, taxonomies: Array<{ _id: string }>, hierarchies: Array<{ _id: string }>, containerChildren: Array<{ _id: string }>, images: Array<{ _id?: string | null }>, imageStatus?: { state: Pv2ImageStatusStateEnum, doneDate?: string | null } | null, outdatedImages: Array<{ _id?: string | null }>, tags?: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null } | null> | null, exclusivity?: { type: Pv2ExclusivityTypeEnum, domain?: { _id: string } | null } | null, attributes: Array<{ type: string, key?: string | null, uid?: string | null, source?: string | null, parent?: string | null, value?: any | null, dataProvider?: Pv2AttributeStructDataProviderEnum | null, createdDate?: string | null, valueUpdatedDate: string, task?: { _id: string } | null }>, lastVerification?: { _id?: string | null, upToDate: boolean, date: string, verifier?: { _id: string } | null } | null, discontinued?: { date: string, user?: { _id: string } | null } | null, digitizationStatus?: { status: Pv2DigitizationStatusStatusEnum, date: string, store?: string | null, user?: { _id: string } | null, domain?: { _id: string } | null } | null, digitizationOutOfStock: Array<{ store: string, date: string, user?: { _id: string } | null }>, digitizationStoreDone?: { store?: string | null, date: string, user?: { _id: string } | null } | null, copy?: { _id: string } | null, original?: { _id: string } | null, taskerStatus?: { state?: Pv2TaskerStatusStateEnum | null, pending: number, processing: number, async_sent: number, assigned: number, async_done: number, async_expired: number, done: number, error: number, blocked: number, disabled: number, invalid: number, cancelled: number, startDate?: string | null, doneDate?: string | null } | null, pv2Ingredients: Array<{ componentType: Pv2Pv2IngredientsComponentTypeEnum, pv2Ingredient?: { _id: string } | null }>, failedFormulas: Array<{ _id: string }>, cleansedData?: { _id: string } | null, mergedCopyPv2Ids: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type Pv2CountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type Pv2CountQuery = { Pv2_count?: number | null };

export type Pv2QueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type Pv2QueryIdsQuery = { Pv2_queryIds?: Array<string> | null };

export type Pv2UpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: Pv2Input;
}>;


export type Pv2UpdateMutation = { Pv2_update?: { _id: string, status: Pv2StatusEnum, name: string, slug: string, deliveredToCircana: boolean, firstDeliveredToSnapshot?: string | null, spinsAttributesEligibilityOverride?: boolean | null, gtin: string, spinsUpc: string, maskedUpc: string, digitizationStoresInitialized: boolean, hierarchyOverride?: Pv2HierarchyOverrideEnum | null, source?: string | null, barcode128?: string | null, parentGTIN?: string | null, dataUpdatedDate: string, itemType: Pv2ItemTypeEnum, imagesCount?: number | null, imageUpdatedDate?: string | null, processingPriority: number, overrideExclusivity: boolean, overrideBarcodeGtinGeneration: boolean, needsVerification: boolean, isCopy: boolean, hasFailedFormulas: boolean, invalidAttributeParents: Array<string>, hasInvalidAttributeParents: boolean, circanaKeycat?: string | null, createdDate?: string | null, updatedDate?: string | null, notification?: { date: string, userId?: { _id: string } | null } | null, brand?: { _id: string } | null, manufacturer?: { _id: string } | null, companies: Array<{ _id: string }>, barcodes: Array<{ GTIN: string, source?: string | null, original: string, format: string, date: string, isPrivateLabel?: boolean | null, hash?: string | null, domain?: { _id: string } | null, options?: { addCheckDigit?: boolean | null, shouldTrimLeadingZeros?: boolean | null } | null }>, asinChildren: Array<{ _id: string }>, asin?: { asin?: string | null, associatedGtin?: string | null } | null, identifiers: Array<{ hash: string, value: string, domain?: { _id: string } | null }>, ingestionMetadata: Array<{ brand?: string | null, category?: string | null, subcategory?: string | null, rawPayload?: any | null, domain?: { _id: string } | null }>, whitelists: Array<{ _id: string }>, dedupeDomains: Array<{ _id: string }>, digitizationStores: Array<{ _id: string }>, taxonomies: Array<{ _id: string }>, hierarchies: Array<{ _id: string }>, containerChildren: Array<{ _id: string }>, images: Array<{ _id?: string | null }>, imageStatus?: { state: Pv2ImageStatusStateEnum, doneDate?: string | null } | null, outdatedImages: Array<{ _id?: string | null }>, tags?: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null } | null> | null, exclusivity?: { type: Pv2ExclusivityTypeEnum, domain?: { _id: string } | null } | null, attributes: Array<{ type: string, key?: string | null, uid?: string | null, source?: string | null, parent?: string | null, value?: any | null, dataProvider?: Pv2AttributeStructDataProviderEnum | null, createdDate?: string | null, valueUpdatedDate: string, task?: { _id: string } | null }>, lastVerification?: { _id?: string | null, upToDate: boolean, date: string, verifier?: { _id: string } | null } | null, discontinued?: { date: string, user?: { _id: string } | null } | null, digitizationStatus?: { status: Pv2DigitizationStatusStatusEnum, date: string, store?: string | null, user?: { _id: string } | null, domain?: { _id: string } | null } | null, digitizationOutOfStock: Array<{ store: string, date: string, user?: { _id: string } | null }>, digitizationStoreDone?: { store?: string | null, date: string, user?: { _id: string } | null } | null, copy?: { _id: string } | null, original?: { _id: string } | null, taskerStatus?: { state?: Pv2TaskerStatusStateEnum | null, pending: number, processing: number, async_sent: number, assigned: number, async_done: number, async_expired: number, done: number, error: number, blocked: number, disabled: number, invalid: number, cancelled: number, startDate?: string | null, doneDate?: string | null } | null, pv2Ingredients: Array<{ componentType: Pv2Pv2IngredientsComponentTypeEnum, pv2Ingredient?: { _id: string } | null }>, failedFormulas: Array<{ _id: string }>, cleansedData?: { _id: string } | null, mergedCopyPv2Ids: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type Pv2CreateMutationVariables = Exact<{
  data: Pv2Input;
}>;


export type Pv2CreateMutation = { Pv2_create?: { _id: string, status: Pv2StatusEnum, name: string, slug: string, deliveredToCircana: boolean, firstDeliveredToSnapshot?: string | null, spinsAttributesEligibilityOverride?: boolean | null, gtin: string, spinsUpc: string, maskedUpc: string, digitizationStoresInitialized: boolean, hierarchyOverride?: Pv2HierarchyOverrideEnum | null, source?: string | null, barcode128?: string | null, parentGTIN?: string | null, dataUpdatedDate: string, itemType: Pv2ItemTypeEnum, imagesCount?: number | null, imageUpdatedDate?: string | null, processingPriority: number, overrideExclusivity: boolean, overrideBarcodeGtinGeneration: boolean, needsVerification: boolean, isCopy: boolean, hasFailedFormulas: boolean, invalidAttributeParents: Array<string>, hasInvalidAttributeParents: boolean, circanaKeycat?: string | null, createdDate?: string | null, updatedDate?: string | null, notification?: { date: string, userId?: { _id: string } | null } | null, brand?: { _id: string } | null, manufacturer?: { _id: string } | null, companies: Array<{ _id: string }>, barcodes: Array<{ GTIN: string, source?: string | null, original: string, format: string, date: string, isPrivateLabel?: boolean | null, hash?: string | null, domain?: { _id: string } | null, options?: { addCheckDigit?: boolean | null, shouldTrimLeadingZeros?: boolean | null } | null }>, asinChildren: Array<{ _id: string }>, asin?: { asin?: string | null, associatedGtin?: string | null } | null, identifiers: Array<{ hash: string, value: string, domain?: { _id: string } | null }>, ingestionMetadata: Array<{ brand?: string | null, category?: string | null, subcategory?: string | null, rawPayload?: any | null, domain?: { _id: string } | null }>, whitelists: Array<{ _id: string }>, dedupeDomains: Array<{ _id: string }>, digitizationStores: Array<{ _id: string }>, taxonomies: Array<{ _id: string }>, hierarchies: Array<{ _id: string }>, containerChildren: Array<{ _id: string }>, images: Array<{ _id?: string | null }>, imageStatus?: { state: Pv2ImageStatusStateEnum, doneDate?: string | null } | null, outdatedImages: Array<{ _id?: string | null }>, tags?: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null } | null> | null, exclusivity?: { type: Pv2ExclusivityTypeEnum, domain?: { _id: string } | null } | null, attributes: Array<{ type: string, key?: string | null, uid?: string | null, source?: string | null, parent?: string | null, value?: any | null, dataProvider?: Pv2AttributeStructDataProviderEnum | null, createdDate?: string | null, valueUpdatedDate: string, task?: { _id: string } | null }>, lastVerification?: { _id?: string | null, upToDate: boolean, date: string, verifier?: { _id: string } | null } | null, discontinued?: { date: string, user?: { _id: string } | null } | null, digitizationStatus?: { status: Pv2DigitizationStatusStatusEnum, date: string, store?: string | null, user?: { _id: string } | null, domain?: { _id: string } | null } | null, digitizationOutOfStock: Array<{ store: string, date: string, user?: { _id: string } | null }>, digitizationStoreDone?: { store?: string | null, date: string, user?: { _id: string } | null } | null, copy?: { _id: string } | null, original?: { _id: string } | null, taskerStatus?: { state?: Pv2TaskerStatusStateEnum | null, pending: number, processing: number, async_sent: number, assigned: number, async_done: number, async_expired: number, done: number, error: number, blocked: number, disabled: number, invalid: number, cancelled: number, startDate?: string | null, doneDate?: string | null } | null, pv2Ingredients: Array<{ componentType: Pv2Pv2IngredientsComponentTypeEnum, pv2Ingredient?: { _id: string } | null }>, failedFormulas: Array<{ _id: string }>, cleansedData?: { _id: string } | null, mergedCopyPv2Ids: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type Pv2RemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type Pv2RemoveMutation = { Pv2_remove?: { _id: string, status: Pv2StatusEnum, name: string, slug: string, deliveredToCircana: boolean, firstDeliveredToSnapshot?: string | null, spinsAttributesEligibilityOverride?: boolean | null, gtin: string, spinsUpc: string, maskedUpc: string, digitizationStoresInitialized: boolean, hierarchyOverride?: Pv2HierarchyOverrideEnum | null, source?: string | null, barcode128?: string | null, parentGTIN?: string | null, dataUpdatedDate: string, itemType: Pv2ItemTypeEnum, imagesCount?: number | null, imageUpdatedDate?: string | null, processingPriority: number, overrideExclusivity: boolean, overrideBarcodeGtinGeneration: boolean, needsVerification: boolean, isCopy: boolean, hasFailedFormulas: boolean, invalidAttributeParents: Array<string>, hasInvalidAttributeParents: boolean, circanaKeycat?: string | null, createdDate?: string | null, updatedDate?: string | null, notification?: { date: string, userId?: { _id: string } | null } | null, brand?: { _id: string } | null, manufacturer?: { _id: string } | null, companies: Array<{ _id: string }>, barcodes: Array<{ GTIN: string, source?: string | null, original: string, format: string, date: string, isPrivateLabel?: boolean | null, hash?: string | null, domain?: { _id: string } | null, options?: { addCheckDigit?: boolean | null, shouldTrimLeadingZeros?: boolean | null } | null }>, asinChildren: Array<{ _id: string }>, asin?: { asin?: string | null, associatedGtin?: string | null } | null, identifiers: Array<{ hash: string, value: string, domain?: { _id: string } | null }>, ingestionMetadata: Array<{ brand?: string | null, category?: string | null, subcategory?: string | null, rawPayload?: any | null, domain?: { _id: string } | null }>, whitelists: Array<{ _id: string }>, dedupeDomains: Array<{ _id: string }>, digitizationStores: Array<{ _id: string }>, taxonomies: Array<{ _id: string }>, hierarchies: Array<{ _id: string }>, containerChildren: Array<{ _id: string }>, images: Array<{ _id?: string | null }>, imageStatus?: { state: Pv2ImageStatusStateEnum, doneDate?: string | null } | null, outdatedImages: Array<{ _id?: string | null }>, tags?: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null } | null> | null, exclusivity?: { type: Pv2ExclusivityTypeEnum, domain?: { _id: string } | null } | null, attributes: Array<{ type: string, key?: string | null, uid?: string | null, source?: string | null, parent?: string | null, value?: any | null, dataProvider?: Pv2AttributeStructDataProviderEnum | null, createdDate?: string | null, valueUpdatedDate: string, task?: { _id: string } | null }>, lastVerification?: { _id?: string | null, upToDate: boolean, date: string, verifier?: { _id: string } | null } | null, discontinued?: { date: string, user?: { _id: string } | null } | null, digitizationStatus?: { status: Pv2DigitizationStatusStatusEnum, date: string, store?: string | null, user?: { _id: string } | null, domain?: { _id: string } | null } | null, digitizationOutOfStock: Array<{ store: string, date: string, user?: { _id: string } | null }>, digitizationStoreDone?: { store?: string | null, date: string, user?: { _id: string } | null } | null, copy?: { _id: string } | null, original?: { _id: string } | null, taskerStatus?: { state?: Pv2TaskerStatusStateEnum | null, pending: number, processing: number, async_sent: number, assigned: number, async_done: number, async_expired: number, done: number, error: number, blocked: number, disabled: number, invalid: number, cancelled: number, startDate?: string | null, doneDate?: string | null } | null, pv2Ingredients: Array<{ componentType: Pv2Pv2IngredientsComponentTypeEnum, pv2Ingredient?: { _id: string } | null }>, failedFormulas: Array<{ _id: string }>, cleansedData?: { _id: string } | null, mergedCopyPv2Ids: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type Pv2RemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type Pv2RemoveManyMutation = { Pv2_removeMany?: any | null };

export type Pv2AggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type Pv2AggregateMutation = { Pv2_aggregate?: Array<any | null> | null };

export type TaskDefinitionQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type TaskDefinitionQuery = { TaskDefinition?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null };

export type TaskDefinitionFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type TaskDefinitionFindQuery = { TaskDefinition_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> }> } | null };

export type TaskDefinitionCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type TaskDefinitionCountQuery = { TaskDefinition_count?: number | null };

export type TaskDefinitionQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type TaskDefinitionQueryIdsQuery = { TaskDefinition_queryIds?: Array<string> | null };

export type TaskDefinitionUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: TaskDefinitionInput;
}>;


export type TaskDefinitionUpdateMutation = { TaskDefinition_update?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null };

export type TaskDefinitionCreateMutationVariables = Exact<{
  data: TaskDefinitionInput;
}>;


export type TaskDefinitionCreateMutation = { TaskDefinition_create?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null };

export type TaskDefinitionRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type TaskDefinitionRemoveMutation = { TaskDefinition_remove?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null };

export type TaskDefinitionRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type TaskDefinitionRemoveManyMutation = { TaskDefinition_removeMany?: any | null };

export type TaskDefinitionAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type TaskDefinitionAggregateMutation = { TaskDefinition_aggregate?: Array<any | null> | null };

export type TaskQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type TaskQuery = { Task?: { _id: string, status: TaskStatusEnum, statusDate: string, error?: string | null, errorCode?: string | null, priority: number, _config?: any | null, _result?: string | null, createdDate?: string | null, updatedDate?: string | null, config: any, result?: any | null, expandedConfig: any, type?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null, assignee?: { startDate: string, endDate?: string | null, user?: { _id: string } | null } | null, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, assignee?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null, parentTask?: { _id: string } | null, taskDependencies: Array<{ _id: string }>, links: Array<{ _id: string, targetModel: ModelNameEnum, targetId: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TaskFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type TaskFindQuery = { Task_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, status: TaskStatusEnum, statusDate: string, error?: string | null, errorCode?: string | null, priority: number, _config?: any | null, _result?: string | null, createdDate?: string | null, updatedDate?: string | null, config: any, result?: any | null, expandedConfig: any, type?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null, assignee?: { startDate: string, endDate?: string | null, user?: { _id: string } | null } | null, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, assignee?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null, parentTask?: { _id: string } | null, taskDependencies: Array<{ _id: string }>, links: Array<{ _id: string, targetModel: ModelNameEnum, targetId: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type TaskCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type TaskCountQuery = { Task_count?: number | null };

export type TaskQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type TaskQueryIdsQuery = { Task_queryIds?: Array<string> | null };

export type TaskUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: TaskInput;
}>;


export type TaskUpdateMutation = { Task_update?: { _id: string, status: TaskStatusEnum, statusDate: string, error?: string | null, errorCode?: string | null, priority: number, _config?: any | null, _result?: string | null, createdDate?: string | null, updatedDate?: string | null, config: any, result?: any | null, expandedConfig: any, type?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null, assignee?: { startDate: string, endDate?: string | null, user?: { _id: string } | null } | null, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, assignee?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null, parentTask?: { _id: string } | null, taskDependencies: Array<{ _id: string }>, links: Array<{ _id: string, targetModel: ModelNameEnum, targetId: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TaskCreateMutationVariables = Exact<{
  data: TaskInput;
}>;


export type TaskCreateMutation = { Task_create?: { _id: string, status: TaskStatusEnum, statusDate: string, error?: string | null, errorCode?: string | null, priority: number, _config?: any | null, _result?: string | null, createdDate?: string | null, updatedDate?: string | null, config: any, result?: any | null, expandedConfig: any, type?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null, assignee?: { startDate: string, endDate?: string | null, user?: { _id: string } | null } | null, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, assignee?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null, parentTask?: { _id: string } | null, taskDependencies: Array<{ _id: string }>, links: Array<{ _id: string, targetModel: ModelNameEnum, targetId: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TaskRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type TaskRemoveMutation = { Task_remove?: { _id: string, status: TaskStatusEnum, statusDate: string, error?: string | null, errorCode?: string | null, priority: number, _config?: any | null, _result?: string | null, createdDate?: string | null, updatedDate?: string | null, config: any, result?: any | null, expandedConfig: any, type?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null, assignee?: { startDate: string, endDate?: string | null, user?: { _id: string } | null } | null, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, assignee?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null, parentTask?: { _id: string } | null, taskDependencies: Array<{ _id: string }>, links: Array<{ _id: string, targetModel: ModelNameEnum, targetId: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TaskRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type TaskRemoveManyMutation = { Task_removeMany?: any | null };

export type TaskAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type TaskAggregateMutation = { Task_aggregate?: Array<any | null> | null };

export type TaxonomyQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type TaxonomyQuery = { Taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TaxonomyFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type TaxonomyFindQuery = { Taxonomy_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type TaxonomyCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type TaxonomyCountQuery = { Taxonomy_count?: number | null };

export type TaxonomyQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type TaxonomyQueryIdsQuery = { Taxonomy_queryIds?: Array<string> | null };

export type TaxonomyUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: TaxonomyInput;
}>;


export type TaxonomyUpdateMutation = { Taxonomy_update?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TaxonomyCreateMutationVariables = Exact<{
  data: TaxonomyInput;
}>;


export type TaxonomyCreateMutation = { Taxonomy_create?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TaxonomyRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type TaxonomyRemoveMutation = { Taxonomy_remove?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TaxonomyRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type TaxonomyRemoveManyMutation = { Taxonomy_removeMany?: any | null };

export type TaxonomyAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type TaxonomyAggregateMutation = { Taxonomy_aggregate?: Array<any | null> | null };

export type TransformerExpressionQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type TransformerExpressionQuery = { TransformerExpression?: { _id: string, version: number, name: string, type: TransformerExpressionTypeEnum, description?: string | null, _value: string, outputType?: string | null, inputType?: string | null, createdDate?: string | null, updatedDate?: string | null, value: any, taskDefinition?: { _id: string } | null, changelog: Array<{ version: number, message: string, date: string, user?: { _id: string } | null }>, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TransformerExpressionFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type TransformerExpressionFindQuery = { TransformerExpression_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, version: number, name: string, type: TransformerExpressionTypeEnum, description?: string | null, _value: string, outputType?: string | null, inputType?: string | null, createdDate?: string | null, updatedDate?: string | null, value: any, taskDefinition?: { _id: string } | null, changelog: Array<{ version: number, message: string, date: string, user?: { _id: string } | null }>, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type TransformerExpressionCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type TransformerExpressionCountQuery = { TransformerExpression_count?: number | null };

export type TransformerExpressionQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type TransformerExpressionQueryIdsQuery = { TransformerExpression_queryIds?: Array<string> | null };

export type TransformerExpressionUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: TransformerExpressionInput;
}>;


export type TransformerExpressionUpdateMutation = { TransformerExpression_update?: { _id: string, version: number, name: string, type: TransformerExpressionTypeEnum, description?: string | null, _value: string, outputType?: string | null, inputType?: string | null, createdDate?: string | null, updatedDate?: string | null, value: any, taskDefinition?: { _id: string } | null, changelog: Array<{ version: number, message: string, date: string, user?: { _id: string } | null }>, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TransformerExpressionCreateMutationVariables = Exact<{
  data: TransformerExpressionInput;
}>;


export type TransformerExpressionCreateMutation = { TransformerExpression_create?: { _id: string, version: number, name: string, type: TransformerExpressionTypeEnum, description?: string | null, _value: string, outputType?: string | null, inputType?: string | null, createdDate?: string | null, updatedDate?: string | null, value: any, taskDefinition?: { _id: string } | null, changelog: Array<{ version: number, message: string, date: string, user?: { _id: string } | null }>, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TransformerExpressionRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type TransformerExpressionRemoveMutation = { TransformerExpression_remove?: { _id: string, version: number, name: string, type: TransformerExpressionTypeEnum, description?: string | null, _value: string, outputType?: string | null, inputType?: string | null, createdDate?: string | null, updatedDate?: string | null, value: any, taskDefinition?: { _id: string } | null, changelog: Array<{ version: number, message: string, date: string, user?: { _id: string } | null }>, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TransformerExpressionRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type TransformerExpressionRemoveManyMutation = { TransformerExpression_removeMany?: any | null };

export type TransformerExpressionAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type TransformerExpressionAggregateMutation = { TransformerExpression_aggregate?: Array<any | null> | null };

export type TransformerResourceQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type TransformerResourceQuery = { TransformerResource?: { _id: string, version: number, name: string, description?: string | null, _value: string, s3Path: string, createdDate?: string | null, updatedDate?: string | null, value: any, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TransformerResourceFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type TransformerResourceFindQuery = { TransformerResource_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, version: number, name: string, description?: string | null, _value: string, s3Path: string, createdDate?: string | null, updatedDate?: string | null, value: any, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type TransformerResourceCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type TransformerResourceCountQuery = { TransformerResource_count?: number | null };

export type TransformerResourceQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type TransformerResourceQueryIdsQuery = { TransformerResource_queryIds?: Array<string> | null };

export type TransformerResourceUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: TransformerResourceInput;
}>;


export type TransformerResourceUpdateMutation = { TransformerResource_update?: { _id: string, version: number, name: string, description?: string | null, _value: string, s3Path: string, createdDate?: string | null, updatedDate?: string | null, value: any, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TransformerResourceCreateMutationVariables = Exact<{
  data: TransformerResourceInput;
}>;


export type TransformerResourceCreateMutation = { TransformerResource_create?: { _id: string, version: number, name: string, description?: string | null, _value: string, s3Path: string, createdDate?: string | null, updatedDate?: string | null, value: any, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TransformerResourceRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type TransformerResourceRemoveMutation = { TransformerResource_remove?: { _id: string, version: number, name: string, description?: string | null, _value: string, s3Path: string, createdDate?: string | null, updatedDate?: string | null, value: any, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type TransformerResourceRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type TransformerResourceRemoveManyMutation = { TransformerResource_removeMany?: any | null };

export type TransformerResourceAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type TransformerResourceAggregateMutation = { TransformerResource_aggregate?: Array<any | null> | null };

export type UserQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type UserQuery = { User?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type UserFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type UserFindQuery = { User_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type UserCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type UserCountQuery = { User_count?: number | null };

export type UserQueryIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type UserQueryIdsQuery = { User_queryIds?: Array<string> | null };

export type UserUpdateMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  data: UserInput;
}>;


export type UserUpdateMutation = { User_update?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type UserCreateMutationVariables = Exact<{
  data: UserInput;
}>;


export type UserCreateMutation = { User_create?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type UserRemoveMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type UserRemoveMutation = { User_remove?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type UserRemoveManyMutationVariables = Exact<{
  query: Scalars['JSON'];
}>;


export type UserRemoveManyMutation = { User_removeMany?: any | null };

export type UserAggregateMutationVariables = Exact<{
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type UserAggregateMutation = { User_aggregate?: Array<any | null> | null };

export type BarcodeStructFragmentFragment = { GTIN: string, source?: string | null, original: string, format: string, date: string, isPrivateLabel?: boolean | null, hash?: string | null, domain?: { _id: string } | null, options?: { addCheckDigit?: boolean | null, shouldTrimLeadingZeros?: boolean | null } | null };

export type BuilderBatchFragmentFragment = { _id: string, status: BuilderBatchStatusEnum, name: string, description?: string | null, notifyByEmail: boolean, error?: string | null, errorStack?: string | null, saveToBigQuery?: boolean | null, saveComputationsToPv2s: boolean, cancellationRequested: boolean, environment?: string | null, _query?: string | null, _runStats?: string | null, _formula: string, limit?: number | null, includeArtifacts: boolean, createdDate?: string | null, updatedDate?: string | null, query?: any | null, runStats?: any | null, formula: any, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, numProducts?: number | null, progress: number } | null, saveToFile?: { enabled?: boolean | null, fields: Array<string>, allVariables?: boolean | null, format: BuilderBatchSaveToFileFormatEnum, s3Path: string, onlyIncludeUpdatedPv2s?: boolean | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type ChangelogEntryStructFragmentFragment = { version: number, message: string, date: string, user?: { _id: string } | null };

export type CompanySignupRequestFragmentFragment = { _id: string, email: string, firstName: string, lastName: string, userTitle?: string | null, userCompany?: string | null, userPhone?: string | null, legalCompanyName: string, companyType: CompanySignupRequestCompanyTypeEnum, skuCount?: CompanySignupRequestSkuCountEnum | null, numSkusToManage?: number | null, sponsored?: boolean | null, contractPending?: boolean | null, readyForSetup?: boolean | null, listAllOwnedBrands?: string | null, companyAddress: string, companyAddress2?: string | null, companyCity: string, companyState?: string | null, companyZipCode?: string | null, adultBeverage?: boolean | null, planType?: CompanySignupRequestPlanTypeEnum | null, retailerReferral?: string | null, planPromoCode?: string | null, partnerName?: string | null, status: CompanySignupRequestStatusEnum, country?: string | null, createdDate?: string | null, updatedDate?: string | null, managerAdminInformation?: { firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, title?: string | null } | null, domain?: { _id: string } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type ConfigFragmentFragment = { _id: string, name: string, version: number, description?: string | null, _value: string, _valueJsonSchema?: string | null, createdDate?: string | null, updatedDate?: string | null, validator?: any | null, value: any, valueJsonSchema?: any | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

type DataRequirementFragment_DataRequirementModel_Fragment = { targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum };

type DataRequirementFragment_DataRequirementModelId_Fragment = { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum };

type DataRequirementFragment_DataRequirementPrimitive_Fragment = { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum };

export type DataRequirementFragmentFragment = DataRequirementFragment_DataRequirementModel_Fragment | DataRequirementFragment_DataRequirementModelId_Fragment | DataRequirementFragment_DataRequirementPrimitive_Fragment;

export type DomainCompanyFragmentFragment = { access?: DomainCompanyAccessEnum | null, profileAccess?: DomainCompanyProfileAccessEnum | null, company?: { _id: string } | null };

export type DomainFragmentFragment = { _id: string, name: string, type: DomainTypeEnum, nucleusRetailerId?: number | null, membership: DomainMembershipEnum, hasManagerAccess: boolean, hasDigitizationAccess: boolean, digitizationMode: DomainDigitizationModeEnum, identifierPrefix?: string | null, identifierName?: string | null, productExclusivityMode: DomainProductExclusivityModeEnum, planPromoCode?: string | null, estimatedSkuCount?: DomainEstimatedSkuCountEnum | null, numSkusToManage?: number | null, partnerName?: string | null, referredByRetailer?: string | null, manufactureOrDistributeAlcoholInWF?: boolean | null, sponsored?: boolean | null, contractPending?: boolean | null, readyForSetup?: boolean | null, listAllOwnedBrands?: string | null, companyType?: DomainCompanyTypeEnum | null, legalName?: string | null, createdDate?: string | null, updatedDate?: string | null, users: Array<{ role: DomainUserRoleEnum, abilities: Array<DomainUserAbilitiesEnum>, inviteMessage?: string | null, acceptedDate?: string | null, createdDate?: string | null, user?: { _id: string } | null, invitedBy?: { _id: string } | null, createdBy?: { _id: string } | null }>, companies: Array<{ access?: DomainCompanyAccessEnum | null, profileAccess?: DomainCompanyProfileAccessEnum | null, company?: { _id: string } | null }>, taxonomies: Array<{ taxonomy?: { _id: string } | null }>, acceptedTOS?: { date: string, user?: { _id: string } | null } | null, dataAccess: { dataAndImages: boolean, dataOnly: boolean }, contract?: { startDate: string, lengthInDays?: number | null, autoRenewal?: boolean | null, renewalNotificationPeriodInDays: number, feePerYear?: number | null, additionalSkuFeePerYear?: number | null, trialExpirationDate?: string | null, contractedSkus?: number | null } | null, mailingAddress?: { street?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null } | null, billingAddress?: { street?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null } | null, primaryContact?: { name: string, title?: string | null, email: string, phone?: string | null } | null, accountOwner?: { name?: string | null, title?: string | null, email: string, phone?: string | null } | null, documents: Array<{ _id: string, name: string, s3Key: string, fileName: string, fileSizeMb: number, uploadedDate: string, uploadedBy?: { _id: string } | null }>, sftp?: { username: string, s3Path: string, createdDate?: string | null } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type DomainTaxonomyFragmentFragment = { taxonomy?: { _id: string } | null };

export type DomainUserFragmentFragment = { role: DomainUserRoleEnum, abilities: Array<DomainUserAbilitiesEnum>, inviteMessage?: string | null, acceptedDate?: string | null, createdDate?: string | null, user?: { _id: string } | null, invitedBy?: { _id: string } | null, createdBy?: { _id: string } | null };

export type FormFragmentFragment = { _id: string, name: string, version: number, description?: string | null, s3Path: string, sideComponent: FormSideComponentEnum, tags: Array<string>, createdDate?: string | null, updatedDate?: string | null, config: any, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type FormInstructionFragmentFragment = { _id: string, name: string, structure: any, s3Path: string, createdDate?: string | null, updatedDate?: string | null, form?: { _id: string } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type FormulaFragmentFragment = { _id: string, version: number, name: string, description?: string | null, fields: Array<string>, isPublic: boolean, runInPv2Middleware: boolean, filter?: string | null, structure: string, functions?: string | null, outputAttributeTypes: Array<string>, createdDate?: string | null, updatedDate?: string | null, changelog: Array<{ version: number, text: string }>, inputResources: { direct: Array<{ _id: string }>, indirect: Array<{ _id: string }> }, inputAttributeTypes: { direct: Array<string>, indirect: Array<string> }, inputProductFields: { direct: Array<string>, indirect: Array<string> }, inputCleansedDataPoints: { direct: Array<string>, indirect: Array<string> }, inputClientTrackerAttributes: { direct: Array<string>, indirect: Array<string> }, referencedFormulas: Array<{ name?: string | null, imports: Array<string>, formula?: { _id: string } | null }>, affectedByFormulas: Array<{ name?: string | null, formula?: { _id: string } | null }>, exports: Array<{ name: string, attributeTypes: Array<string>, productFields: Array<string>, cleansedDataPoints: Array<string>, clientTrackerAttributes: Array<string>, resources: Array<{ _id: string }> }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type FormulaResourceFragmentFragment = { _id: string, version: number, type: FormulaResourceTypeEnum, config?: any | null, name: string, slug: string, description?: string | null, value: string, totalChildren: number, ownItems: number, totalItems: number, s3Path: string, createdDate?: string | null, updatedDate?: string | null, valueJSON: any, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, children: Array<{ _id: string }>, descendents: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type ImageFragmentFragment = { _id?: string | null, type: ImageTypeEnum, status: ImageStatusEnum, key?: string | null, side: string, source?: string | null, name?: string | null, rejectionReason?: ImageRejectionReasonEnum | null, acceptedTimestamp: string, isInImageProcessingQueue: boolean, pv2ProcessingPriority: number, createdDate?: string | null, updatedDate?: string | null, angle: any, downloaded?: { timestamp: string, user?: { _id: string } | null } | null, uploaded?: { timestamp: string, user?: { _id: string } | null } | null, scannedBarcodes: Array<{ type: string, value: string }>, urls: Array<{ type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null }>, overrides?: { _id?: string | null } | null, pv2?: { _id: string } | null, digitizationOriginalUrls: Array<{ type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, mainUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null, thumbnailUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null, croppedUrl?: { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null } | null };

export type ImageUrlFragmentFragment = { type: ImageUrlTypeEnum, url?: string | null, s3Key?: string | null, sizeMb?: number | null, width?: number | null, height?: number | null, date: string, user?: { _id: string } | null };

export type MturkWorkerFragmentFragment = { _id: string, WorkerId: string, name?: string | null, isBlocked?: boolean | null, qualificationsCount: number, revokedQualificationsCount: number, createdDate?: string | null, attributes: Array<{ _id: string, type: string, value: number, createdDate?: string | null, createdBy?: { _id: string } | null }>, qualifications: Array<{ QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null }>, revokedQualifications: Array<{ QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null }>, stats?: { date: string, total?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, threeMonths?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, oneMonth?: { total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null } | null, perTaskTotal: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }>, perTaskThreeMonths: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }>, perTaskOneMonth: Array<{ type: string, total: number, averageScore?: number | null, totalIssues?: number | null, averageIssues?: number | null, totalBonus?: number | null, totalFullBonus?: number | null, averageBonus?: number | null, totalMessages?: number | null, totalCorrectMessages?: number | null, correctMessageRatio?: number | null }> } | null };

export type MturkWorkerQualificationFragmentFragment = { QualificationTypeId: string, IntegerValue: number, GrantTime: string, Reason?: string | null };

export type Pv2AttributeDefinitionFragmentFragment = { _id: string, active: boolean, name: string, type: string, version: number, versionDate: string, hasKey: boolean, parents: Array<string>, description?: string | null, internalDescription?: string | null, required: Array<Pv2AttributeDefinitionRequiredEnum>, hasValue: boolean, _valueSchema?: string | null, createdDate?: string | null, updatedDate?: string | null, valueSchema?: any | null, domains: Array<{ _id: string }>, taxonomies: Array<{ _id: string }>, hierarchies: Array<{ _id: string }>, changelog: Array<{ version: number, message: string, date: string, user?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type Pv2AttributeStructFragmentFragment = { type: string, key?: string | null, uid?: string | null, source?: string | null, parent?: string | null, value?: any | null, dataProvider?: Pv2AttributeStructDataProviderEnum | null, createdDate?: string | null, valueUpdatedDate: string, task?: { _id: string } | null };

export type Pv2DigitizationOutOfStockFragmentFragment = { store: string, date: string, user?: { _id: string } | null };

export type Pv2DigitizationStatusFragmentFragment = { status: Pv2DigitizationStatusStatusEnum, date: string, store?: string | null, user?: { _id: string } | null, domain?: { _id: string } | null };

export type Pv2DigitizationStoreDoneFragmentFragment = { store?: string | null, date: string, user?: { _id: string } | null };

export type Pv2FragmentFragment = { _id: string, status: Pv2StatusEnum, name: string, slug: string, deliveredToCircana: boolean, firstDeliveredToSnapshot?: string | null, spinsAttributesEligibilityOverride?: boolean | null, gtin: string, spinsUpc: string, maskedUpc: string, digitizationStoresInitialized: boolean, hierarchyOverride?: Pv2HierarchyOverrideEnum | null, source?: string | null, barcode128?: string | null, parentGTIN?: string | null, dataUpdatedDate: string, itemType: Pv2ItemTypeEnum, imagesCount?: number | null, imageUpdatedDate?: string | null, processingPriority: number, overrideExclusivity: boolean, overrideBarcodeGtinGeneration: boolean, needsVerification: boolean, isCopy: boolean, hasFailedFormulas: boolean, invalidAttributeParents: Array<string>, hasInvalidAttributeParents: boolean, circanaKeycat?: string | null, createdDate?: string | null, updatedDate?: string | null, notification?: { date: string, userId?: { _id: string } | null } | null, brand?: { _id: string } | null, manufacturer?: { _id: string } | null, companies: Array<{ _id: string }>, barcodes: Array<{ GTIN: string, source?: string | null, original: string, format: string, date: string, isPrivateLabel?: boolean | null, hash?: string | null, domain?: { _id: string } | null, options?: { addCheckDigit?: boolean | null, shouldTrimLeadingZeros?: boolean | null } | null }>, asinChildren: Array<{ _id: string }>, asin?: { asin?: string | null, associatedGtin?: string | null } | null, identifiers: Array<{ hash: string, value: string, domain?: { _id: string } | null }>, ingestionMetadata: Array<{ brand?: string | null, category?: string | null, subcategory?: string | null, rawPayload?: any | null, domain?: { _id: string } | null }>, whitelists: Array<{ _id: string }>, dedupeDomains: Array<{ _id: string }>, digitizationStores: Array<{ _id: string }>, taxonomies: Array<{ _id: string }>, hierarchies: Array<{ _id: string }>, containerChildren: Array<{ _id: string }>, images: Array<{ _id?: string | null }>, imageStatus?: { state: Pv2ImageStatusStateEnum, doneDate?: string | null } | null, outdatedImages: Array<{ _id?: string | null }>, tags?: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null } | null> | null, exclusivity?: { type: Pv2ExclusivityTypeEnum, domain?: { _id: string } | null } | null, attributes: Array<{ type: string, key?: string | null, uid?: string | null, source?: string | null, parent?: string | null, value?: any | null, dataProvider?: Pv2AttributeStructDataProviderEnum | null, createdDate?: string | null, valueUpdatedDate: string, task?: { _id: string } | null }>, lastVerification?: { _id?: string | null, upToDate: boolean, date: string, verifier?: { _id: string } | null } | null, discontinued?: { date: string, user?: { _id: string } | null } | null, digitizationStatus?: { status: Pv2DigitizationStatusStatusEnum, date: string, store?: string | null, user?: { _id: string } | null, domain?: { _id: string } | null } | null, digitizationOutOfStock: Array<{ store: string, date: string, user?: { _id: string } | null }>, digitizationStoreDone?: { store?: string | null, date: string, user?: { _id: string } | null } | null, copy?: { _id: string } | null, original?: { _id: string } | null, taskerStatus?: { state?: Pv2TaskerStatusStateEnum | null, pending: number, processing: number, async_sent: number, assigned: number, async_done: number, async_expired: number, done: number, error: number, blocked: number, disabled: number, invalid: number, cancelled: number, startDate?: string | null, doneDate?: string | null } | null, pv2Ingredients: Array<{ componentType: Pv2Pv2IngredientsComponentTypeEnum, pv2Ingredient?: { _id: string } | null }>, failedFormulas: Array<{ _id: string }>, cleansedData?: { _id: string } | null, mergedCopyPv2Ids: Array<{ _id: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type Pv2IdentifierFragmentFragment = { hash: string, value: string, domain?: { _id: string } | null };

export type Pv2IngestionMetadataFragmentFragment = { brand?: string | null, category?: string | null, subcategory?: string | null, rawPayload?: any | null, domain?: { _id: string } | null };

export type ScannedBarcodesFragmentFragment = { type: string, value: string };

export type TagStructFragmentFragment = { name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null };

export type TaskDefinitionFragmentFragment = { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> };

export type TaskFragmentFragment = { _id: string, status: TaskStatusEnum, statusDate: string, error?: string | null, errorCode?: string | null, priority: number, _config?: any | null, _result?: string | null, createdDate?: string | null, updatedDate?: string | null, config: any, result?: any | null, expandedConfig: any, type?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null, assignee?: { startDate: string, endDate?: string | null, user?: { _id: string } | null } | null, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, assignee?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null, parentTask?: { _id: string } | null, taskDependencies: Array<{ _id: string }>, links: Array<{ _id: string, targetModel: ModelNameEnum, targetId: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type TaxonomyFragmentFragment = { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type TransformerExpressionFragmentFragment = { _id: string, version: number, name: string, type: TransformerExpressionTypeEnum, description?: string | null, _value: string, outputType?: string | null, inputType?: string | null, createdDate?: string | null, updatedDate?: string | null, value: any, taskDefinition?: { _id: string } | null, changelog: Array<{ version: number, message: string, date: string, user?: { _id: string } | null }>, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type TransformerResourceFragmentFragment = { _id: string, version: number, name: string, description?: string | null, _value: string, s3Path: string, createdDate?: string | null, updatedDate?: string | null, value: any, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type UserFragmentFragment = { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type AcceptImagesMutationVariables = Exact<{
  imageProcessingQueueAcceptInput: Array<ImageProcessingQueueAcceptInput> | ImageProcessingQueueAcceptInput;
}>;


export type AcceptImagesMutation = { AcceptImages: { successfulSaves: number, failedImages?: Array<{ failedImageId: string, failureReason: string } | null> | null } };

export type AddImageToProcessingQueueMutationVariables = Exact<{
  addImageToProcessingQueueInput: Array<AddImageToProcessingQueueInput> | AddImageToProcessingQueueInput;
}>;


export type AddImageToProcessingQueueMutation = { AddImageToProcessingQueue: { successfulSaves: number, failedImages?: Array<{ failedImageId: string, failureReason: string } | null> | null } };

export type AttributeSalesAssessmentRunMutationVariables = Exact<{
  builderBatchId: Scalars['String'];
  reportRunId: Scalars['String'];
}>;


export type AttributeSalesAssessmentRunMutation = { AttributeSalesAssessmentRun: { error?: string | null, success: boolean, executionId?: string | null, scriptLogsUrl?: string | null } };

export type BrandReview_UpdateMutationVariables = Exact<{
  _id: Scalars['ObjectId'];
  data: BrandReviewInput;
}>;


export type BrandReview_UpdateMutation = { BrandReview_update?: { _id: string, opsReview: { reviewStatus: BrandReviewStatusEnum, reasonCode?: BrandReviewReasonEnum | null, survivingBrand?: string | null } } | null };

export type ClientTrackerValue_CreateMutationVariables = Exact<{
  data: ClientTrackerValueInput;
}>;


export type ClientTrackerValue_CreateMutation = { ClientTrackerValue_create?: { _id: string } | null };

export type ClientTrackerValue_UpdateMutationVariables = Exact<{
  _id: Scalars['ObjectId'];
  data: ClientTrackerValueInput;
}>;


export type ClientTrackerValue_UpdateMutation = { ClientTrackerValue_update?: { _id: string } | null };

export type ClientTrackerValue_UpsertMutationVariables = Exact<{
  data: ClientTrackerValueUpsertInput;
}>;


export type ClientTrackerValue_UpsertMutation = { ClientTrackerValue_upsert: { success: boolean, errors: Array<{ message: string, path: string }> } };

export type CreateAdminTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateAdminTokenMutation = { CreateAdminToken?: string | null };

export type DigitizationGrantUserAccessMutationVariables = Exact<{
  userId: Scalars['ObjectId'];
  domainId: Scalars['ObjectId'];
}>;


export type DigitizationGrantUserAccessMutation = { Digitization_grantUserAccess: { success: boolean } };

export type FeatureFlags_SetMutationVariables = Exact<{
  flags: Array<FeatureFlags_Set_FlagInput> | FeatureFlags_Set_FlagInput;
}>;


export type FeatureFlags_SetMutation = { FeatureFlags_set: Array<{ description?: string | null, enabled: boolean, flag: FeatureFlagConfigurationFeatureFlagEnum }> };

export type HierarchyMapping_CreateMutationVariables = Exact<{
  data: HierarchyMappingInput;
}>;


export type HierarchyMapping_CreateMutation = { HierarchyMapping_create?: { _id: string, circanaKeyCat: string, fallbackTaxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null, rules: Array<{ type: HierarchyMappingRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null, children: Array<{ type: HierarchyMappingChildRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }> }>, taxonomies: Array<{ _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }>, parentTaxonomies: Array<{ _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type HierarchyMapping_RemoveMutationVariables = Exact<{
  _id: Scalars['ObjectId'];
}>;


export type HierarchyMapping_RemoveMutation = { HierarchyMapping_remove?: { _id: string, circanaKeyCat: string } | null };

export type HierarchyMapping_UpdateMutationVariables = Exact<{
  _id: Scalars['ObjectId'];
  data: HierarchyMappingInput;
}>;


export type HierarchyMapping_UpdateMutation = { HierarchyMapping_update?: { _id: string, circanaKeyCat: string, fallbackTaxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null, rules: Array<{ type: HierarchyMappingRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null, children: Array<{ type: HierarchyMappingChildRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }> }>, taxonomies: Array<{ _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }>, parentTaxonomies: Array<{ _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type ModelAddTagMutationVariables = Exact<{
  model: ModelNameEnum;
  ids: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
  name: Scalars['String'];
}>;


export type ModelAddTagMutation = { ModelAddTag: { matched: number, modified: number } };

export type ModelRemoveTagMutationVariables = Exact<{
  model: ModelNameEnum;
  ids: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
  name: Scalars['String'];
}>;


export type ModelRemoveTagMutation = { ModelRemoveTag: { matched: number, modified: number } };

export type ModelUpdateByIdMutationVariables = Exact<{
  model: ModelNameEnum;
  id: Scalars['ObjectId'];
  data: Scalars['JSON'];
}>;


export type ModelUpdateByIdMutation = { ModelUpdateById?: any | null };

export type PredictionOverride_SaveMutationVariables = Exact<{
  data: Array<PredictionOverrideSaveInput> | PredictionOverrideSaveInput;
}>;


export type PredictionOverride_SaveMutation = { PredictionOverride_save: { success: boolean, savedCount: number, errors: Array<{ cleansedDataId: string, asin?: string | null, attributeType: PredictionOverrideAttributeTypeEnum, message: string }> } };

export type Pv2IngredientSetReviewStatusMutationVariables = Exact<{
  id: Scalars['String'];
  status: IngredientReviewStatusEnum;
}>;


export type Pv2IngredientSetReviewStatusMutation = { Pv2IngredientSetReviewStatus?: boolean | null };

export type QcSelfServeRunAnalysisMutationVariables = Exact<{ [key: string]: never; }>;


export type QcSelfServeRunAnalysisMutation = { QCSelfServeRunAnalysis: { success: boolean, error?: string | null, executionId?: string | null, scriptLogsUrl?: string | null } };

export type RejectImagesMutationVariables = Exact<{
  imageIds: Array<Scalars['String']> | Scalars['String'];
  rejectionReason: ImageRejectionReasonEnum;
  processingPriority?: InputMaybe<Scalars['Int']>;
}>;


export type RejectImagesMutation = { RejectImages: { successfulSaves: number, failedImages?: Array<{ failedImageId: string, failureReason: string } | null> | null } };

export type RestartServiceMutationVariables = Exact<{
  serviceName: ServiceNameEnum;
}>;


export type RestartServiceMutation = { RestartService?: string | null };

export type RunScriptMutationVariables = Exact<{
  scriptName: ScriptKey;
  scriptArgs: Scalars['JSON'];
  runId: Scalars['String'];
}>;


export type RunScriptMutation = { RunScript: { message: string, executionId: string, scriptLogsUrl: string, error?: string | null } };

export type TaskAssignMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  unassign?: InputMaybe<Scalars['Boolean']>;
}>;


export type TaskAssignMutation = { Task_assign: { _id: string, status: TaskStatusEnum, statusDate: string, error?: string | null, errorCode?: string | null, priority: number, _config?: any | null, _result?: string | null, createdDate?: string | null, updatedDate?: string | null, config: any, result?: any | null, expandedConfig: any, type?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null, assignee?: { startDate: string, endDate?: string | null, user?: { _id: string } | null } | null, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, assignee?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null, parentTask?: { _id: string } | null, taskDependencies: Array<{ _id: string }>, links: Array<{ _id: string, targetModel: ModelNameEnum, targetId: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } };

export type TaskRetriggerMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type TaskRetriggerMutation = { Task_retrigger: { _id: string, status: TaskStatusEnum, statusDate: string, error?: string | null, errorCode?: string | null, priority: number, _config?: any | null, _result?: string | null, createdDate?: string | null, updatedDate?: string | null, config: any, result?: any | null, expandedConfig: any, type?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null, assignee?: { startDate: string, endDate?: string | null, user?: { _id: string } | null } | null, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, assignee?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null, parentTask?: { _id: string } | null, taskDependencies: Array<{ _id: string }>, links: Array<{ _id: string, targetModel: ModelNameEnum, targetId: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } };

export type TaskSubmitMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  errorCode?: InputMaybe<Scalars['String']>;
  error?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['JSON']>;
}>;


export type TaskSubmitMutation = { Task_submit: { _id: string, status: TaskStatusEnum, statusDate: string, error?: string | null, errorCode?: string | null, priority: number, _config?: any | null, _result?: string | null, createdDate?: string | null, updatedDate?: string | null, config: any, result?: any | null, expandedConfig: any, type?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null, assignee?: { startDate: string, endDate?: string | null, user?: { _id: string } | null } | null, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, assignee?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null, parentTask?: { _id: string } | null, taskDependencies: Array<{ _id: string }>, links: Array<{ _id: string, targetModel: ModelNameEnum, targetId: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } };

export type TriggerBuilderRecomputeMutationVariables = Exact<{
  requestId: Scalars['String'];
  runDescription: Scalars['String'];
  saveComputationToPv2: Scalars['Boolean'];
  pv2Query?: InputMaybe<Scalars['String']>;
  formulaIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  reportSuffix?: InputMaybe<Scalars['String']>;
}>;


export type TriggerBuilderRecomputeMutation = { TriggerBuilderRecompute: { message: string, dagId: string, dagRunId: string, dagRunUrl: string, bqSuffix: string, bqDataset: string, bqDatasetUrl: string, bqTables: Array<string>, alreadyQueued: boolean, error?: string | null } };

export type UpdatePv2sForUploadedImagesMutationVariables = Exact<{
  imageIds?: InputMaybe<Array<Scalars['ObjectId']> | Scalars['ObjectId']>;
}>;


export type UpdatePv2sForUploadedImagesMutation = { UpdatePv2sForUploadedImages: { success: boolean } };

export type UploadProcessedImagesMutationVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type UploadProcessedImagesMutation = { UploadProcessedImages: { imageId: string, success: boolean } };

export type UploadPublicAssetMutationVariables = Exact<{
  file: Scalars['Upload'];
  s3Key: Scalars['String'];
  addTimestamp?: InputMaybe<Scalars['Boolean']>;
}>;


export type UploadPublicAssetMutation = { UploadPublicAsset: string };

export type CreateS3PresignedImageProcessingPutUrlMutationVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type CreateS3PresignedImageProcessingPutUrlMutation = { createS3PresignedImageProcessingPutUrl: { presignedUrl: string } };

export type CreateTasksMutationVariables = Exact<{
  taskDefinition: Scalars['ObjectId'];
  inputs: Array<Scalars['JSON']> | Scalars['JSON'];
}>;


export type CreateTasksMutation = { createTasks?: any | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { login?: { jwt?: string | null, session?: { isAuthenticated?: boolean | null, user?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null } | null };

export type AsinAttributeLevelCoverageQueryVariables = Exact<{
  top25Attribute?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  attributeThemeType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AsinAttributeLevelCoverageQuery = { AsinAttributeLevelCoverage: Array<{ displayName: string, top25Attribute: string, attributeThemeType: string, totalEligibleSales: number, salesWithUnknownValue: number, salesWithKnownValue: number, salesUnknownValuePercent: number, salesKnownValuePercent: number, totalEligibleUpcs: number, upcsWithUnknownValue: number, upcsWithKnownValue: number, upcUnknownValuePercent: number, upcKnownValuePercent: number }> };

export type AsinSubcategoryLevelCoverageQueryVariables = Exact<{
  department?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  category?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subcategory?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  top25Attribute?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  attributeThemeType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AsinSubcategoryLevelCoverageQuery = { AsinSubcategoryLevelCoverage: Array<{ department: string, category: string, subcategory: string, displayName: string, top25Attribute: string, attributeThemeType: string, totalEligibleSales: number, salesWithUnknownValue: number, salesWithKnownValue: number, salesUnknownValuePercent: number, salesKnownValuePercent: number, totalEligibleUpcs: number, upcsWithUnknownValue: number, upcsWithKnownValue: number, upcUnknownValuePercent: number, upcKnownValuePercent: number }> };

export type AsinLevelCoverageQueryVariables = Exact<{
  asin?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  brand?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  department?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  category?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subcategory?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  top25Attribute?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  attributeThemeType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AsinLevelCoverageQuery = { AsinLevelCoverage: { totalCount: number, nodes: Array<{ description: string, brand: string, department: string, category: string, subcategory: string, displayName: string, top25Attribute: string, attributeThemeType: string, totalDollarSales: number, attributeLevelSalesKnownValuePercent: number, attributeLevelSalesKnownValuePercentIncrease: number, subcategoryLevelSalesKnownValuePercent: number, subcategoryLevelSalesKnownValuePercentIncrease: number, maskedUpc: string }> } };

export type AsinCoverageHierarchyFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type AsinCoverageHierarchyFilterQuery = { AsinCoverageHierarchyFilter: Array<{ category: string, department: string, subcategory: string }> };

export type AsinCoverageAttributeThemeFilterQueryVariables = Exact<{
  department?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  category?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subcategory?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AsinCoverageAttributeThemeFilterQuery = { AsinCoverageAttributeThemeFilter: Array<{ attributeThemeType: string, displayName: string }> };

export type AttributeLevelCoverageQueryVariables = Exact<{
  geography: Scalars['String'];
  time: Scalars['String'];
  top25Attribute?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  attributeThemeType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AttributeLevelCoverageQuery = { AttributeLevelCoverage: Array<{ geography: string, time: string, displayName: string, top25Attribute: string, attributeThemeType: string, totalEligibleUpcs: number, upcsWithUnknownValue: number, upcsWithKnownValue: number, upcUnknownValuePercent: number, upcKnownValuePercent: number, totalEligibleSales: number, salesWithUnknownValue: number, salesWithKnownValue: number, salesUnknownValuePercent: number, salesKnownValuePercent: number }> };

export type SubcategoryLevelCoverageQueryVariables = Exact<{
  department?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  category?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subcategory?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  geography: Scalars['String'];
  time: Scalars['String'];
  top25Attribute?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  attributeThemeType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SubcategoryLevelCoverageQuery = { SubcategoryLevelCoverage: Array<{ geography: string, time: string, department: string, category: string, subcategory: string, displayName: string, top25Attribute: string, attributeThemeType: string, totalEligibleUpcs: number, upcsWithUnknownValue: number, upcsWithKnownValue: number, upcUnknownValuePercent: number, upcKnownValuePercent: number, totalEligibleSales: number, salesWithUnknownValue: number, salesWithKnownValue: number, salesUnknownValuePercent: number, salesKnownValuePercent: number }> };

export type UpcLevelCoverageQueryVariables = Exact<{
  maskedUpc?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  brand?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  department?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  category?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subcategory?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  geography: Scalars['String'];
  time: Scalars['String'];
  top25Attribute?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  attributeThemeType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  privateLabel?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type UpcLevelCoverageQuery = { UpcLevelCoverage: { totalCount: number, nodes: Array<{ geography: string, time: string, maskedUpc: string, description: string, brand: string, department: string, category: string, subcategory: string, displayName: string, top25Attribute: string, attributeThemeType: string, totalDollarSales: number, attributeLevelSalesKnownValuePercent: number, attributeLevelSalesKnownValuePercentIncrease: number, subcategoryLevelSalesKnownValuePercent: number, subcategoryLevelSalesKnownValuePercentIncrease: number }> } };

export type AttributeCoverageHierarchyFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributeCoverageHierarchyFilterQuery = { AttributeCoverageHierarchyFilter: Array<{ category: string, department: string, subcategory: string }> };

export type AttributeCoverageAttributeThemeFilterQueryVariables = Exact<{
  department?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  category?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subcategory?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  geography?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
}>;


export type AttributeCoverageAttributeThemeFilterQuery = { AttributeCoverageAttributeThemeFilter: Array<{ attributeThemeType: string, displayName: string }> };

export type AttributeSalesAssessmentAggregationQueryVariables = Exact<{
  builderBatchId: Scalars['String'];
  reportRunId: Scalars['String'];
  groupBy: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  spinsSn?: InputMaybe<Scalars['String']>;
  spinsSca?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<Scalars['String']>;
}>;


export type AttributeSalesAssessmentAggregationQuery = { AttributeSalesAssessmentTotals: Array<{ groupValue?: string | null, salesPercentChangeYago: number, salesPlusOrMinusChgYago: number, totalCurrentSales: number, totalPreviousSales: number, upcCount: number }> };

export type AttributeSalesFilterCombosQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributeSalesFilterCombosQuery = { AttributeSalesFilterCombos: Array<{ builderBatchId: string, reportRunId: string }> };

export type AttributeSalesAssessmentStatsQueryVariables = Exact<{
  builderBatchId: Scalars['String'];
  reportRunId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  spinsSn?: InputMaybe<Scalars['String']>;
  spinsSca?: InputMaybe<Scalars['String']>;
}>;


export type AttributeSalesAssessmentStatsQuery = { AttributeSalesAssessmentStats: { countOfCategory: number, countOfSubcategory: number, countOfUpc: number, countOfUpcInSnapshot: number, salesPercentChangeYago: number, salesPlusOrMinusChgYago: number, totalCurrentSales: number, totalPreviousSales: number } };

export type AttributeSalesAssessmentQueryVariables = Exact<{
  builderBatchId: Scalars['String'];
  reportRunId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  spinsSn?: InputMaybe<Scalars['String']>;
  spinsSca?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<Scalars['String']>;
}>;


export type AttributeSalesAssessmentQuery = { AttributeSalesAssessment: Array<{ SPINS_UPC: string, spins_brand?: string | null, spins_description?: string | null, spins_department?: string | null, spins_category?: string | null, spins_subcategory?: string | null, salesPercentChangeYago?: number | null, salesPlusOrMinusChgYago?: number | null, totalCurrentSales?: number | null, totalPreviousSales?: number | null }> };

export type BrandReviewFindQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type BrandReviewFindQuery = { BrandReview_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, brandA: string, brandB: string, brandAItemCount: number, brandBItemCount: number, brandMatchReason: BrandMatchReasonEnum, opsReview: { reviewStatus: BrandReviewStatusEnum, reasonCode?: BrandReviewReasonEnum | null, survivingBrand?: string | null } }> } | null };

export type BrandReviewReasonCountsQueryVariables = Exact<{
  sameNameDifferentSpacing?: InputMaybe<Scalars['JSON']>;
  oneNameStartsTheOther?: InputMaybe<Scalars['JSON']>;
  oneNameInsideTheOther?: InputMaybe<Scalars['JSON']>;
  possibleMisspelling?: InputMaybe<Scalars['JSON']>;
}>;


export type BrandReviewReasonCountsQuery = { sameNameDifferentSpacing?: number | null, oneNameStartsTheOther?: number | null, oneNameInsideTheOther?: number | null, possibleMisspelling?: number | null };

export type BrandReviewStatusCountsQueryVariables = Exact<{
  markedForMerge?: InputMaybe<Scalars['JSON']>;
  ignoreMerge?: InputMaybe<Scalars['JSON']>;
  notReviewed?: InputMaybe<Scalars['JSON']>;
}>;


export type BrandReviewStatusCountsQuery = { markedForMerge?: number | null, ignoreMerge?: number | null, notReviewed?: number | null };

export type BuilderRecomputeRunsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type BuilderRecomputeRunsQuery = { BuilderRecomputeRuns: Array<{ dagRunId: string, dagRunUrl: string, state: string, startDate?: string | null, endDate?: string | null, saveComputationToPv2: boolean, runDescription?: string | null, bqTables: Array<string>, bqDatasetUrl?: string | null, dataflowJobId?: string | null, dataflowState?: string | null, dataflowUrl?: string | null }> };

export type ClientFeedbackClientNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientFeedbackClientNamesQuery = { ClientFeedbackClientNames: Array<string> };

export type ClientFeedbackPeriodReleasesQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientFeedbackPeriodReleasesQuery = { ClientFeedbackPeriodReleases: Array<string> };

export type ClientFeedbackWhoIsSubmittingQueryVariables = Exact<{
  filter?: InputMaybe<ClientFeedbackFilter>;
}>;


export type ClientFeedbackWhoIsSubmittingQuery = { ClientFeedbackWhoIsSubmitting: Array<{ clientName: string, ticketCount: number, upcCount: number, percentTotalTickets: number }> };

export type ClientFeedbackTicketTrendsQueryVariables = Exact<{
  filter?: InputMaybe<ClientFeedbackFilter>;
}>;


export type ClientFeedbackTicketTrendsQuery = { ClientFeedbackTicketTrends: Array<{ clientName: string, component?: string | null, ticketsLast52: number, avgWeeklyTickets52: number, ticketsLast24: number, expectedTickets24: number, ticketsLast12: number, expectedTickets12: number, ticketsLast4: number, expectedTickets4: number }> };

export type ClientFeedbackAttributeUpdatesQueryVariables = Exact<{
  filter?: InputMaybe<ClientFeedbackFilter>;
}>;


export type ClientFeedbackAttributeUpdatesQuery = { ClientFeedbackAttributeUpdates: { totalUpcCount: number, totalTicketCount: number, rows: Array<{ attributeName: string, attributeValue?: string | null, upcCount: number, ticketCount: number }> } };

export type ClientFeedbackTicketExtractQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ClientFeedbackFilter>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDir?: InputMaybe<Scalars['String']>;
}>;


export type ClientFeedbackTicketExtractQuery = { ClientFeedbackTicketExtract: { totalRowCount: number, rows: Array<{ issueKey: string, clientName?: string | null, upcCount: number, assignee?: string | null, created?: string | null, reporter?: string | null, summary?: string | null }> } };

export type ClientFeedbackCategoryUpdatesQueryVariables = Exact<{
  filter?: InputMaybe<ClientFeedbackFilter>;
}>;


export type ClientFeedbackCategoryUpdatesQuery = { ClientFeedbackCategoryUpdates: { totalUpcCount: number, totalTicketCount: number, rows: Array<{ category: string, subcategory?: string | null, upcCount: number, ticketCount: number }> } };

export type ClientFeedbackProductUpdatesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ClientFeedbackFilter>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDir?: InputMaybe<Scalars['String']>;
}>;


export type ClientFeedbackProductUpdatesQuery = { ClientFeedbackProductUpdates: { totalRowCount: number, rows: Array<{ upc: string, brand?: string | null, description?: string | null, department?: string | null, category?: string | null, subcategory?: string | null, attributeName: string, attributeValue?: string | null, periodRelease?: string | null }> } };

export type ClientFeedbackRootCausesQueryVariables = Exact<{
  filter?: InputMaybe<ClientFeedbackFilter>;
}>;


export type ClientFeedbackRootCausesQuery = { ClientFeedbackRootCauses: Array<{ rootCause: string, ticketCount: number }> };

export type ClientFeedbackAttributeTrendsQueryVariables = Exact<{
  filter?: InputMaybe<ClientFeedbackFilter>;
}>;


export type ClientFeedbackAttributeTrendsQuery = { ClientFeedbackAttributeTrends: { rows: Array<{ attributeName: string, ticketsLast52: number, avgWeeklyTickets52: number, ticketsLast24: number, expectedTickets24: number, ticketsLast12: number, expectedTickets12: number, ticketsLast4: number, expectedTickets4: number }>, total?: { attributeName: string, ticketsLast52: number, avgWeeklyTickets52: number, ticketsLast24: number, expectedTickets24: number, ticketsLast12: number, expectedTickets12: number, ticketsLast4: number, expectedTickets4: number } | null } };

export type ClientTrackerIncorrectAttributeNameQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  searchFilter?: InputMaybe<Scalars['String']>;
  periodReleaseFilter?: InputMaybe<Scalars['String']>;
}>;


export type ClientTrackerIncorrectAttributeNameQuery = { ClientTrackerIncorrectAttributeName: { totalCount: number, nodes: Array<{ _id: string, spinsUpc: string, attributeName: string, jiraAssignee?: string | null, jiraClientName?: string | null, jiraTicket: Array<string>, clientValidatedCoding?: boolean | null, periodRelease?: string | null }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean } } };

export type ClientTrackerMismatchesPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  searchFilter?: InputMaybe<Scalars['String']>;
  periodReleaseFilter?: InputMaybe<Scalars['String']>;
}>;


export type ClientTrackerMismatchesPageQuery = { ClientTrackerMismatches: { nodes: Array<{ spinsUpc: string, jiraTicket: Array<string>, jiraClientName?: string | null, jiraAssignee?: string | null, clientValidatedCoding?: boolean | null, periodRelease?: string | null, mismatchedAttributes: Array<{ _id: string, attributeName: string, attributeInSpinsAttributes: boolean, clientTrackerValue?: string | null, spinsAttributeValue?: string | null, mismatchType: string }> }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean } } };

export type ClientTrackerMismatchesCountQueryVariables = Exact<{
  periodReleaseFilter?: InputMaybe<Scalars['String']>;
}>;


export type ClientTrackerMismatchesCountQuery = { ClientTrackerMismatches: { totalCount: number } };

export type ClientTrackerValueCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type ClientTrackerValueCountQuery = { ClientTrackerValue_count?: number | null };

export type ClientTrackerValueFindQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type ClientTrackerValueFindQuery = { ClientTrackerValue_find?: { total: number, results: Array<{ _id: string, spinsUpc: string, attributeName: string, attributeValue: string, clientValidatedCoding: boolean, jiraTicket: Array<string>, jiraClientName?: string | null, jiraAssignee?: string | null, periodRelease?: string | null }> } | null };

export type CostAndBillingMonthlyQueryVariables = Exact<{
  numberOfMonths: Scalars['Int'];
}>;


export type CostAndBillingMonthlyQuery = { Cost_And_Billing_Monthly: Array<{ source: BillingSource, costs: Array<{ service: string, cost: number, month: string }> }> };

export type CostAndBillingDailyQueryVariables = Exact<{ [key: string]: never; }>;


export type CostAndBillingDailyQuery = { Cost_And_Billing_Daily: Array<{ source: BillingSource, costs: Array<{ service: string, cost: number, date: string }> }> };

export type CountImagesToProcessQueryVariables = Exact<{
  pv2Filter?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  sides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sources?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CountImagesToProcessQuery = { CountImagesToProcess?: number | null };

export type DownloadImagesQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadImagesQuery = { DownloadImages: { fileName: string, url: string, highPriorityImageCount: number } };

export type EnvironmentInfo_GetQueryVariables = Exact<{ [key: string]: never; }>;


export type EnvironmentInfo_GetQuery = { EnvironmentInfo_get: { featureName: string, cloudEnv: string } };

export type FeatureFlags_GetQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlags_GetQuery = { FeatureFlags_get: Array<{ description?: string | null, enabled: boolean, flag: FeatureFlagConfigurationFeatureFlagEnum }> };

export type FetchImageSidesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchImageSidesQuery = { FetchImageSides: { sides: Array<string> } };

export type FetchImageSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchImageSourcesQuery = { FetchImageSources: { sources: Array<string> } };

export type FindImagesToProcessQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  pv2Filter?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  sides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sources?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type FindImagesToProcessQuery = { FindImagesToProcess: Array<{ pv2Id: string, pv2Name: string, pv2GTIN: string, pv2Domain: string, images: Array<{ imageId: string, type: string, url: string, status: string, side: string, createdDate: string }> }> };

export type GenerateTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateTokenQuery = { GenerateToken: { token?: string | null } };

export type GetAllServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllServicesQuery = { GetAllServices: Array<{ name: ServiceNameEnum, displayName: string, vmLoggingUrl: string }> };

export type GetSignedFileLinkQueryVariables = Exact<{
  filename: Scalars['String'];
}>;


export type GetSignedFileLinkQuery = { GetSignedFileLink: { url: string } };

export type ModelCountQueryVariables = Exact<{
  model: ModelNameEnum;
  query?: InputMaybe<Scalars['JSON']>;
  inputList?: InputMaybe<Array<ListVariable> | ListVariable>;
}>;


export type ModelCountQuery = { ModelCount: number };

export type HierarchyMapping_FindQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type HierarchyMapping_FindQuery = { HierarchyMapping_find?: { total: number, results: Array<{ _id: string, circanaKeyCat: string, fallbackTaxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null, rules: Array<{ type: HierarchyMappingRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null, children: Array<{ type: HierarchyMappingChildRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }> }>, taxonomies: Array<{ _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }>, parentTaxonomies: Array<{ _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> }> } | null };

export type HierarchyMappingQueryVariables = Exact<{
  _id: Scalars['ObjectId'];
}>;


export type HierarchyMappingQuery = { HierarchyMapping?: { _id: string, circanaKeyCat: string, fallbackTaxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null, rules: Array<{ type: HierarchyMappingRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null, children: Array<{ type: HierarchyMappingChildRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }> }>, taxonomies: Array<{ _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }>, parentTaxonomies: Array<{ _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type HierarchyMappingFragmentFragment = { _id: string, circanaKeyCat: string, fallbackTaxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null, rules: Array<{ type: HierarchyMappingRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null, children: Array<{ type: HierarchyMappingChildRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }> }>, taxonomies: Array<{ _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }>, parentTaxonomies: Array<{ _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> };

export type HierarchyMappingChildRuleFragment = { type: HierarchyMappingChildRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type HierarchyMappingRuleFragment = { type: HierarchyMappingRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null, children: Array<{ type: HierarchyMappingChildRuleTypeEnum, lookupAttribute?: string | null, lookupOptions: Array<{ values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }>, conditions: Array<{ attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> }>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }> };

export type HierarchyMappingConditionFragment = { attribute: string, matchType: HierarchyMappingConditionMatchTypeEnum, values: Array<string> };

export type HierarchyMappingLookupOptionFragment = { values: Array<string>, taxonomy?: { _id: string, name: string, slug: string, depth: number, breadcrumb?: string | null, description?: string | null, type: TaxonomyTypeEnum, createdDate?: string | null, updatedDate?: string | null, parent?: { _id: string } | null, RACC?: { category: string, value?: number | null, unit?: number | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null };

export type HierarchyMapping_BulkEvaluateQueryVariables = Exact<{
  pv2Ids: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type HierarchyMapping_BulkEvaluateQuery = { HierarchyMapping_bulkEvaluate: { results: Array<{ pv2Id: string, name?: string | null, keycat?: string | null, isDifferent: boolean, mappedHierarchy?: string | null, existingHierarchy?: string | null, hierarchyOverride?: Pv2HierarchyOverrideEnum | null, attributeValues: Array<{ attribute: string, value?: string | null }> }>, keycatInfo: Array<{ keycat: string, mappingId?: string | null, relevantAttributes: Array<string> }>, hierarchies: Array<{ taxonomyId: string, subcategory?: string | null, productType?: string | null }> } };

export type HierarchyMappingBulkEvaluationResultItemFragment = { pv2Id: string, name?: string | null, keycat?: string | null, isDifferent: boolean, mappedHierarchy?: string | null, existingHierarchy?: string | null, hierarchyOverride?: Pv2HierarchyOverrideEnum | null, attributeValues: Array<{ attribute: string, value?: string | null }> };

export type HierarchyMappingAttributeValueFragment = { attribute: string, value?: string | null };

export type HierarchyMappingTaxonomyInfoFragment = { taxonomyId: string, subcategory?: string | null, productType?: string | null };

export type HierarchyMappingKeycatInfoFragment = { keycat: string, mappingId?: string | null, relevantAttributes: Array<string> };

export type HierarchyMapping_EvaluateQueryVariables = Exact<{
  pv2Id: Scalars['ObjectId'];
  mapping: HierarchyMappingInput;
}>;


export type HierarchyMapping_EvaluateQuery = { HierarchyMapping_evaluate?: { mappedTaxonomyId?: string | null, keycat?: string | null, isApplicable: boolean, rules: Array<{ isMatch: boolean, shortCircuited: boolean, lookupAttributeValue?: string | null, children: Array<{ isMatch: boolean, shortCircuited: boolean, lookupAttributeValue?: string | null, lookupOptions?: Array<{ shortCircuited: boolean, isMatch: boolean }> | null, conditions: Array<{ attribute: string, attrValue?: string | null, isMatch: boolean, shortCircuited: boolean }> }>, lookupOptions?: Array<{ shortCircuited: boolean, isMatch: boolean }> | null, conditions: Array<{ attribute: string, attrValue?: string | null, isMatch: boolean, shortCircuited: boolean }> }> } | null };

export type HierarchyMappingLeafRuleEvaluationFragment = { isMatch: boolean, shortCircuited: boolean, lookupAttributeValue?: string | null, lookupOptions?: Array<{ shortCircuited: boolean, isMatch: boolean }> | null, conditions: Array<{ attribute: string, attrValue?: string | null, isMatch: boolean, shortCircuited: boolean }> };

export type HierarchyMappingOuterRuleEvaluationFragment = { isMatch: boolean, shortCircuited: boolean, lookupAttributeValue?: string | null, children: Array<{ isMatch: boolean, shortCircuited: boolean, lookupAttributeValue?: string | null, lookupOptions?: Array<{ shortCircuited: boolean, isMatch: boolean }> | null, conditions: Array<{ attribute: string, attrValue?: string | null, isMatch: boolean, shortCircuited: boolean }> }>, lookupOptions?: Array<{ shortCircuited: boolean, isMatch: boolean }> | null, conditions: Array<{ attribute: string, attrValue?: string | null, isMatch: boolean, shortCircuited: boolean }> };

export type HierarchyConditionEvaluationFragment = { attribute: string, attrValue?: string | null, isMatch: boolean, shortCircuited: boolean };

export type HistoryGetSummariesQueryVariables = Exact<{
  model: Scalars['String'];
  modelId: Scalars['ObjectId'];
}>;


export type HistoryGetSummariesQuery = { HistoryGet: Array<{ model: string, modelId: string, version: number, date?: string | null, user?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null }> };

export type HistoryGetVersionQueryVariables = Exact<{
  model: Scalars['String'];
  modelId: Scalars['ObjectId'];
  version: Scalars['Int'];
}>;


export type HistoryGetVersionQuery = { HistoryGetVersion?: { model: string, modelId: string, version: number, date?: string | null, data: any, user?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null };

export type ImageAnnotatorInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ImageAnnotatorInfoQuery = { ImageAnnotator_info: { durationInSeconds: number, prerequisites: Array<string>, annotations: Array<{ default_position?: number | null, display_name: string, prerequisites?: Array<string> | null, ref_name: string, reference_confidence_value?: number | null, returns?: string | null, tags?: Array<string> | null }> } };

export type ImageProcessingQueueStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ImageProcessingQueueStatsQuery = { ImageProcessingQueueStats: { highPriorityImageCount: number, regularPriorityImageCount: number, rejectedImageCount: number } };

export type IngredientDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IngredientDetailsQuery = { IngredientDetails?: { pv2Total: number, leafTaxonomies?: Array<{ id: string, breadcrumb?: string | null, pv2Count: number, pv2s: Array<{ id: string, name: string, ingredientAttributes: Array<{ id: string, type: string, value: any }> }> }> | null, attributes?: Array<{ type: string, value?: any | null }> | null } | null };

export type IngredientFormulaReferencesQueryVariables = Exact<{
  ingredientName: Scalars['String'];
}>;


export type IngredientFormulaReferencesQuery = { IngredientFormulaReferences?: Array<{ _id: string, name: string, formulas: Array<{ _id: string, name: string }> }> | null };

export type NewItemActivationQueryVariables = Exact<{
  upc?: InputMaybe<Scalars['String']>;
  currentCompany?: InputMaybe<Scalars['String']>;
  stagedCompany?: InputMaybe<Scalars['String']>;
  currentBrand?: InputMaybe<Scalars['String']>;
  stagedBrand?: InputMaybe<Scalars['String']>;
  brandChange?: InputMaybe<Scalars['String']>;
  compChange?: InputMaybe<Scalars['String']>;
  descriptionChange?: InputMaybe<Scalars['String']>;
  departmentChange?: InputMaybe<Scalars['String']>;
  categoryChange?: InputMaybe<Scalars['String']>;
  subcategoryChange?: InputMaybe<Scalars['String']>;
  sizeChange?: InputMaybe<Scalars['String']>;
  uomChange?: InputMaybe<Scalars['String']>;
  packChange?: InputMaybe<Scalars['String']>;
  positionChange?: InputMaybe<Scalars['String']>;
  brandpositionChange?: InputMaybe<Scalars['String']>;
  producttypeChange?: InputMaybe<Scalars['String']>;
  plcChange?: InputMaybe<Scalars['String']>;
  identifiedAttributeChanges?: InputMaybe<Scalars['String']>;
  numberOfAttributesWithChange?: InputMaybe<Scalars['Int']>;
  expectedChangeForAtLeastOneAttribute?: InputMaybe<Scalars['String']>;
  conventionalChannelStatus?: InputMaybe<Scalars['String']>;
  conventionalChannelStatusDetails?: InputMaybe<Scalars['String']>;
  proprietaryChannelStatus?: InputMaybe<Scalars['String']>;
  proprietaryChannelStatusDetails?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type NewItemActivationQuery = { NewItemActivation: Array<{ upc: string, stagedCompany?: string | null, currentCompany?: string | null, compChange?: string | null, currentBrand?: string | null, stagedBrand?: string | null, brandChange?: string | null, currentProductDescription?: string | null, stagedProductDescription?: string | null, descriptionChange?: string | null, currentDepartment?: string | null, stagedDepartment?: string | null, departmentChange?: string | null, currentCategory?: string | null, stagedCategory?: string | null, categoryChange?: string | null, currentSubcategory?: string | null, stagedSubcategory?: string | null, subcategoryChange?: string | null, currentSize?: string | null, stagedSize?: string | null, sizeChange?: string | null, currentUnitOfMeasure?: string | null, stagedUnitOfMeasure?: string | null, uomChange?: string | null, currentPackCount?: string | null, stagedPackCount?: string | null, packChange?: string | null, currentPositioningGroup?: string | null, stagedPositioningGroup?: string | null, positionChange?: string | null, currentBrandPosition?: string | null, stagedBrandPosition?: string | null, brandpositionChange?: string | null, currentProductType?: string | null, stagedProductType?: string | null, producttypeChange?: string | null, currentPrivateLabelConventional?: string | null, stagedPrivateLabelConventional?: string | null, plcChange?: string | null, identifiedAttributeChanges?: string | null, numberOfAttributesWithChange?: number | null, expectedChangeForAtLeastOneAttribute?: string | null, conventionalChannelStatus?: string | null, conventionalChannelStatusDetails?: string | null, proprietaryChannelStatus?: string | null, proprietaryChannelStatusDetails?: string | null, newUpc?: string | null, upcEan13?: string | null }> };

export type ActivationStatusFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivationStatusFilterQuery = { ActivationStatusFilter: Array<{ conventionalChannelStatus: string, conventionalChannelStatusDetails: string, proprietaryChannelStatus: string, proprietaryChannelStatusDetails: string }> };

export type NewItemActivationCountQueryVariables = Exact<{
  upc?: InputMaybe<Scalars['String']>;
  currentCompany?: InputMaybe<Scalars['String']>;
  stagedCompany?: InputMaybe<Scalars['String']>;
  currentBrand?: InputMaybe<Scalars['String']>;
  stagedBrand?: InputMaybe<Scalars['String']>;
  brandChange?: InputMaybe<Scalars['String']>;
  compChange?: InputMaybe<Scalars['String']>;
  descriptionChange?: InputMaybe<Scalars['String']>;
  departmentChange?: InputMaybe<Scalars['String']>;
  categoryChange?: InputMaybe<Scalars['String']>;
  subcategoryChange?: InputMaybe<Scalars['String']>;
  sizeChange?: InputMaybe<Scalars['String']>;
  uomChange?: InputMaybe<Scalars['String']>;
  packChange?: InputMaybe<Scalars['String']>;
  positionChange?: InputMaybe<Scalars['String']>;
  brandpositionChange?: InputMaybe<Scalars['String']>;
  producttypeChange?: InputMaybe<Scalars['String']>;
  plcChange?: InputMaybe<Scalars['String']>;
  identifiedAttributeChanges?: InputMaybe<Scalars['String']>;
  numberOfAttributesWithChange?: InputMaybe<Scalars['Int']>;
  expectedChangeForAtLeastOneAttribute?: InputMaybe<Scalars['String']>;
  conventionalChannelStatus?: InputMaybe<Scalars['String']>;
  conventionalChannelStatusDetails?: InputMaybe<Scalars['String']>;
  proprietaryChannelStatus?: InputMaybe<Scalars['String']>;
  proprietaryChannelStatusDetails?: InputMaybe<Scalars['String']>;
}>;


export type NewItemActivationCountQuery = { NewItemActivationCount: Array<{ itemCount: string }> };

export type MiddlewareFormulasQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type MiddlewareFormulasQuery = { Formula_find?: { results: Array<{ _id: string, name: string, tags: Array<{ name: string }> }> } | null };

export type ModelQueryVariables = Exact<{
  model: ModelNameEnum;
}>;


export type ModelQuery = { Model: { hasHistoryTracking: boolean, isTaggable: boolean, collectionName: string, columns: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean, children: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean, children: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean, children: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean }> }> }> }> } };

export type Pv2AttributeDefinitions_SchemaFieldsWithTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type Pv2AttributeDefinitions_SchemaFieldsWithTypesQuery = { Pv2AttributeDefinitions_schemaFieldsWithTypes: Array<{ attributeType: string, fields: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean, children: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean, children: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean, children: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean }> }> }> }> }> };

export type AttributeTypeWithFieldTypesFragment = { attributeType: string, fields: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean, children: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean, children: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean, children: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean }> }> }> }> };

export type ModelColumnInfoFragment = { name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean, children: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean, children: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean, children: Array<{ name: string, isList: boolean, type: ModelColumnType, refModel?: ModelNameEnum | null, enum?: Array<string> | null, isRequired?: boolean | null, hasDefault: boolean }> }> }> };

export type ModelAggregateQueryVariables = Exact<{
  model: ModelNameEnum;
  pipeline: Array<Scalars['JSON']> | Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  sample?: InputMaybe<Scalars['Boolean']>;
  allowDiskUse?: InputMaybe<Scalars['Boolean']>;
  inputList?: InputMaybe<Array<ListVariable> | ListVariable>;
}>;


export type ModelAggregateQuery = { ModelAggregate: { results: Array<any>, steps: Array<{ stageIndex: number, results: Array<any> }> } };

export type ModelDistinctCountQueryVariables = Exact<{
  model: ModelNameEnum;
  field?: Scalars['String'];
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
  unwind?: InputMaybe<Scalars['Boolean']>;
}>;


export type ModelDistinctCountQuery = { ModelDistinctCount: Array<{ value: any, count: number }> };

export type ModelFindByIdQueryVariables = Exact<{
  model: ModelNameEnum;
  id: Scalars['ObjectId'];
  select?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  populate?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  virtuals?: InputMaybe<Scalars['Boolean']>;
}>;


export type ModelFindByIdQuery = { ModelFindById?: any | null };

export type ModelFindManyQueryVariables = Exact<{
  model: ModelNameEnum;
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  project?: InputMaybe<Scalars['JSON']>;
  distinct?: InputMaybe<Scalars['String']>;
  inputList?: InputMaybe<Array<ListVariable> | ListVariable>;
  sort?: InputMaybe<Scalars['String']>;
  select?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ModelFindManyQuery = { ModelFindMany: Array<any> };

export type ModelTagNamesQueryVariables = Exact<{
  model: ModelNameEnum;
}>;


export type ModelTagNamesQuery = { ModelTagNames: Array<string> };

export type ModelTagCountsQueryVariables = Exact<{
  model: ModelNameEnum;
  names: Array<Scalars['String']> | Scalars['String'];
}>;


export type ModelTagCountsQuery = { ModelTagCounts: Array<{ name: string, count: number }> };

export type ModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type ModelsQuery = { Models: Array<{ name: ModelNameEnum, isTaggable: boolean, hasHistoryTracking: boolean }> };

export type PredictionOverrideAllowedValuesQueryVariables = Exact<{
  subcategory: Scalars['String'];
}>;


export type PredictionOverrideAllowedValuesQuery = { PredictionOverride_allowedValues: Array<{ attributeType: PredictionOverrideAttributeTypeEnum, values: Array<string> }> };

export type PredictionOverrideBulkLookupQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PredictionOverrideBulkLookupQuery = { CleansedData_find?: { results: Array<{ _id: string, gtin?: string | null, identifiers?: { asins: Array<string> } | null }> } | null };

export type PredictionOverrideCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type PredictionOverrideCountQuery = { CleansedData_count?: number | null };

export type PredictionOverrideFindQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type PredictionOverrideFindQuery = { CleansedData_find?: { skip: number, limit: number, results: Array<{ _id: string, gtin?: string | null, createdDate?: string | null, identifiers?: { asins: Array<string> } | null, description: Array<{ source: string, value: string, asin?: string | null }>, brand: Array<{ source: string, value: string, asin?: string | null }>, category: Array<{ source: string, value: string, asin?: string | null }>, subcategory: Array<{ source: string, value: string, asin?: string | null }>, age: Array<{ source: string, value: string, asin?: string | null }>, flavor: Array<{ source: string, value: string, asin?: string | null }>, form: Array<{ source: string, value: string, asin?: string | null }>, functionalIngredient: Array<{ source: string, value: string, asin?: string | null }>, gender: Array<{ source: string, value: string, asin?: string | null }>, healthFocus: Array<{ source: string, value: string, asin?: string | null }>, packCount: Array<{ source: string, value: string, asin?: string | null }>, productType: Array<{ source: string, value: string, asin?: string | null }>, scent: Array<{ source: string, value: string, asin?: string | null }>, size: Array<{ source: string, value: string, asin?: string | null }>, sourceSpecific: Array<{ source: string, asin?: string | null, value: any }>, unitOfMeasure: Array<{ source: string, value: string, asin?: string | null }> }> } | null };

export type Pv2AttributeDefinitionCreateAttributeSchemaQueryVariables = Exact<{
  attributeDefinition: Pv2AttributeDefinitionInput;
  full?: InputMaybe<Scalars['Boolean']>;
}>;


export type Pv2AttributeDefinitionCreateAttributeSchemaQuery = { Pv2AttributeDefinition_createAttributeSchema?: any | null };

export type Pv2FetchIdsQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type Pv2FetchIdsQuery = { Pv2_searchIds: Array<string> };

export type Pv2SpinsUpcFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type Pv2SpinsUpcFindQuery = { Pv2_find?: { results: Array<{ _id: string, spinsUpc: string }> } | null };

export type Pv2Ingredients_SearchQueryVariables = Exact<{
  componentType?: InputMaybe<Pv2IngredientComponentTypeEnum>;
  nameFilters?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  withReviewStatus?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type Pv2Ingredients_SearchQuery = { Pv2Ingredients_search: { count: number, results: Array<{ _id: string, name: string, pv2Count: number, reviewStatus?: string | null, createdDate: string }> } };

export type Pv2sByIngredients_SearchQueryVariables = Exact<{
  componentType: Pv2IngredientComponentTypeEnum;
  ingredientFilters: Array<Scalars['String']> | Scalars['String'];
  falsePositives?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type Pv2sByIngredients_SearchQuery = { Pv2sByIngredients_search: { count: number, results: Array<{ _id: string, gtin: string, name: string, brand?: string | null, breadcrumb: string, ingredientStatement: string, matchedNames: Array<string>, matchedTerms: Array<string>, falsePositiveMatches: Array<string> }> } };

export type QcSelfServeSummaryQueryVariables = Exact<{
  filter?: InputMaybe<QcSelfServeFilter>;
}>;


export type QcSelfServeSummaryQuery = { QCSelfServeSummary: { totalCount: number, dadCount: number, prCount: number, lastUpdatedDate?: string | null } };

export type QcSelfServeCheckCountsQueryVariables = Exact<{
  team?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<QcSelfServeFilter>;
}>;


export type QcSelfServeCheckCountsQuery = { QCSelfServeCheckCounts: Array<{ checkId: string, checkDescription?: string | null, count: number }> };

export type QcSelfServeCheckDescriptionCountsQueryVariables = Exact<{
  team?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<QcSelfServeFilter>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDir?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type QcSelfServeCheckDescriptionCountsQuery = { QCSelfServeCheckDescriptionCounts: { totalRowCount: number, rows: Array<{ checkId: string, checkDescription?: string | null, count: number }> } };

export type QcSelfServeFilterOptionsQueryVariables = Exact<{
  team?: InputMaybe<Scalars['String']>;
}>;


export type QcSelfServeFilterOptionsQuery = { QCSelfServeFilterOptions: { team: Array<string>, source: Array<string>, checkId: Array<string>, status: Array<string>, department: Array<string>, category: Array<string>, subcategory: Array<string>, productType: Array<string> } };

export type QcSelfServeBrandOptionsQueryVariables = Exact<{
  search: Scalars['String'];
  team?: InputMaybe<Scalars['String']>;
}>;


export type QcSelfServeBrandOptionsQuery = { QCSelfServeBrandOptions: Array<string> };

export type QcSelfServeRowsQueryVariables = Exact<{
  filter?: InputMaybe<QcSelfServeFilter>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDir?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type QcSelfServeRowsQuery = { QCSelfServeRows: { totalRowCount: number, rows: Array<{ _id: string, team: string, source: string, checkId: string, checkDescription?: string | null, expectedOutcome?: string | null, pv2Id: string, spinsUpc?: string | null, mfrCode?: string | null, status?: AnalyticsQcSelfServeStatusEnum | null, primaryAttribute?: string | null, primaryValue?: string | null, secondaryAttribute?: string | null, secondaryValue?: string | null, conflictingAttribute?: string | null, conflictingValue?: string | null, expectedValue?: string | null, peerSupport?: string | null, brand?: string | null, company?: string | null, description?: string | null, size?: string | null, unitOfMeasure?: string | null, department?: string | null, category?: string | null, subcategory?: string | null, productType?: string | null, functionalIngredient?: string | null, functionalIngredientFlag?: string | null, organic?: string | null, delivered: boolean, lowConfidence?: boolean | null, pvlProp?: boolean | null, pvlConv?: boolean | null, channelProp?: boolean | null, channelConv?: boolean | null, firstFlaggedDate: string, daysSinceFlagged: number, updatedDate?: string | null }> } };

export type ScriptsListQueryVariables = Exact<{
  isCircana?: InputMaybe<Scalars['Boolean']>;
}>;


export type ScriptsListQuery = { ScriptsList: Array<{ key: ScriptKey, name: string, description: string }> };

export type ScriptInfoQueryVariables = Exact<{
  scriptKey?: InputMaybe<ScriptKey>;
}>;


export type ScriptInfoQuery = { ScriptInfo?: { subdirectory?: string | null, exampleFileName?: string | null, instructions?: string | null, successMessage?: string | null, warning?: string | null, bucketUrl?: string | null, key: ScriptKey, name: string, description: string, options: Array<{ key: string, description?: string | null, required?: boolean | null, type: ScriptOptionType, acceptFileType?: string | null, optionalWithWarning?: string | null, choices?: Array<string | null> | null, default?: string | null }>, recentRuns: Array<{ executionId: string, executionUrl: string, userId: string, timestamp: string, user: { displayName: any } }> } | null };

export type ScriptMetadataSummaryFragment = { key: ScriptKey, name: string, description: string };

export type ScriptMetadataDetailFragment = { subdirectory?: string | null, exampleFileName?: string | null, instructions?: string | null, successMessage?: string | null, warning?: string | null, bucketUrl?: string | null, key: ScriptKey, name: string, description: string, options: Array<{ key: string, description?: string | null, required?: boolean | null, type: ScriptOptionType, acceptFileType?: string | null, optionalWithWarning?: string | null, choices?: Array<string | null> | null, default?: string | null }>, recentRuns: Array<{ executionId: string, executionUrl: string, userId: string, timestamp: string, user: { displayName: any } }> };

export type ScriptRunInfoFragment = { executionId: string, executionUrl: string, userId: string, timestamp: string, user: { displayName: any } };

export type GetServiceHeartbeatQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceHeartbeatQuery = { ServiceHeartbeat_check?: Array<{ name: string, heartbeats: Array<{ isRunning: boolean, displayName: string, lastCheckedTimestamp: string }> }> | null };

export type SpinsAttributeType_NamesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type SpinsAttributeType_NamesQuery = { SpinsAttributeType_query?: Array<{ displayName: string }> | null };

export type TaskDefinitionSummaryFindQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type TaskDefinitionSummaryFindQuery = { TaskDefinition_find?: { total: number, skip: number, limit: number, results: Array<{ _id: string, name: string, enabled: boolean, type: TaskDefinitionTypeEnum, tags: Array<{ name: string }> }> } | null };

export type TaskDefinitionSummaryFragmentFragment = { _id: string, name: string, enabled: boolean, type: TaskDefinitionTypeEnum, tags: Array<{ name: string }> };

export type TaskDefinitionDataRequirementsQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['ObjectId']>;
  type: TaskDefinitionTypeEnum;
  config?: InputMaybe<Scalars['JSON']>;
}>;


export type TaskDefinitionDataRequirementsQuery = { TaskDefinition_dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> };

export type TaskDefinitionsWorkflowQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskDefinitionsWorkflowQuery = { TaskDefinitions_workflow?: { nodes: Array<{ _id: string, name: string, type: TaskDefinitionTypeEnum, enabled: boolean, children: Array<{ _id: string, taskGroup?: string | null, taskDependencies?: string | null, many: boolean, optional: boolean, count: number }> }> } | null };

export type TaskDefinitionWorkflowNodeFragmentFragment = { _id: string, name: string, type: TaskDefinitionTypeEnum, enabled: boolean, children: Array<{ _id: string, taskGroup?: string | null, taskDependencies?: string | null, many: boolean, optional: boolean, count: number }> };

export type TaskDefinitionWorkflowChildFragmentFragment = { _id: string, taskGroup?: string | null, taskDependencies?: string | null, many: boolean, optional: boolean, count: number };

export type TaskFindPageQueryVariables = Exact<{
  query: Scalars['JSON'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type TaskFindPageQuery = { Task_find?: { skip: number, limit: number, results: Array<{ _id: string, status: TaskStatusEnum, statusDate: string, error?: string | null, errorCode?: string | null, priority: number, _config?: any | null, _result?: string | null, createdDate?: string | null, updatedDate?: string | null, config: any, result?: any | null, expandedConfig: any, type?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null, assignee?: { startDate: string, endDate?: string | null, user?: { _id: string } | null } | null, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, assignee?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null, parentTask?: { _id: string } | null, taskDependencies: Array<{ _id: string }>, links: Array<{ _id: string, targetModel: ModelNameEnum, targetId: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type TaskQueueQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSON']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type TaskQueueQuery = { TaskQueue?: { total: number, skip: number, limit: number, results: Array<{ spinsUpc?: string | null, _id: string, status: TaskStatusEnum, statusDate: string, error?: string | null, errorCode?: string | null, priority: number, _config?: any | null, _result?: string | null, createdDate?: string | null, updatedDate?: string | null, config: any, result?: any | null, expandedConfig: any, type?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null, assignee?: { startDate: string, endDate?: string | null, user?: { _id: string } | null } | null, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, assignee?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null, parentTask?: { _id: string } | null, taskDependencies: Array<{ _id: string }>, links: Array<{ _id: string, targetModel: ModelNameEnum, targetId: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null }> } | null };

export type InternalTaskFragment = { spinsUpc?: string | null, _id: string, status: TaskStatusEnum, statusDate: string, error?: string | null, errorCode?: string | null, priority: number, _config?: any | null, _result?: string | null, createdDate?: string | null, updatedDate?: string | null, config: any, result?: any | null, expandedConfig: any, type?: { _id: string, enabled: boolean, name: string, type: TaskDefinitionTypeEnum, config?: any | null, description?: string | null, timeoutSeconds?: number | null, createdDate?: string | null, updatedDate?: string | null, throttle: { perSecond?: number | null, maxProcessingAtOnce?: number | null }, resultTransformation?: { _id: string } | null, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, mturk?: { HITTypeId?: string | null, qualificationName?: string | null, QualificationTypeId?: string | null } | null, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null, dataRequirements: Array<{ targetModel: ModelNameEnum, selectFields: Array<string>, populateFields: Array<string>, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { targetModel: ModelNameEnum, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum } | { primitiveType?: DataRequirementPrimitivePrimitiveTypeEnum | null, name?: string | null, isArray?: boolean | null, optional?: boolean | null, kind: DataRequirementKindEnum }> } | null, assignee?: { startDate: string, endDate?: string | null, user?: { _id: string } | null } | null, processing?: { startDate: string, endDate?: string | null, durationInSeconds?: number | null, assignee?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null, parentTask?: { _id: string } | null, taskDependencies: Array<{ _id: string }>, links: Array<{ _id: string, targetModel: ModelNameEnum, targetId: string }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null };

export type CompanyAutocompleteQueryVariables = Exact<{
  query: Scalars['JSON'];
  sort?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CompanyAutocompleteQuery = { Company_find?: { results: Array<{ _id: string, name: string }> } | null };

export type FormulaAutocompleteQueryVariables = Exact<{
  query: Scalars['JSON'];
  sort?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type FormulaAutocompleteQuery = { Formula_find?: { results: Array<{ _id: string, name: string }> } | null };

export type FormulaResourceAutocompleteQueryVariables = Exact<{
  query: Scalars['JSON'];
  sort?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type FormulaResourceAutocompleteQuery = { FormulaResource_find?: { results: Array<{ _id: string, name: string }> } | null };

export type SpinsBrandValuesAutocompleteQueryVariables = Exact<{
  startsWith: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SpinsBrandValuesAutocompleteQuery = { SpinsBrandValues: Array<string> };

export type SessionQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionQuery = { session?: { isAuthenticated?: boolean | null, user?: { _id: string, firstName: string, lastName?: string | null, _password?: string | null, email: string, auth0Id?: string | null, isPhotoEntry?: boolean | null, role: UserRoleEnum, receivedGettingStartedEmail?: boolean | null, abilities: Array<UserAbilitiesEnum>, createdDate?: string | null, updatedDate?: string | null, passwordResetCode?: string | null, isAdmin: any, password?: string | null, displayName: any, photoEntry?: any | null, avatar?: { small?: string | null, large?: string | null } | null, mturkWorker?: { _id: string } | null, digitization?: { store?: string | null, priority: UserDigitizationPriorityEnum, mode: UserDigitizationModeEnum, workflow?: UserDigitizationWorkflowEnum | null, workflows: Array<UserDigitizationWorkflowsEnum>, verificationFlow: boolean, domain?: { _id: string } | null } | null, tasker?: { enabled: boolean, tags: Array<string>, tasks: Array<{ _id: string }> } | null, pv2CustomFieldPrimary?: { _id: string } | null, pv2CustomFields: Array<{ _id: string }>, tags: Array<{ name: string, reason?: string | null, createdDate?: string | null, data?: { _id: string } | null, createdBy?: { _id: string } | null }>, createdBy?: { _id: string } | null, updatedBy?: { _id: string } | null } | null } | null };

export const BuilderBatchFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuilderBatchFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BuilderBatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"durationInSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"numProducts"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"notifyByEmail"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"errorStack"}},{"kind":"Field","name":{"kind":"Name","value":"saveToFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"fields"}},{"kind":"Field","name":{"kind":"Name","value":"allVariables"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"s3Path"}},{"kind":"Field","name":{"kind":"Name","value":"onlyIncludeUpdatedPv2s"}}]}},{"kind":"Field","name":{"kind":"Name","value":"saveToBigQuery"}},{"kind":"Field","name":{"kind":"Name","value":"saveComputationsToPv2s"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationRequested"}},{"kind":"Field","name":{"kind":"Name","value":"environment"}},{"kind":"Field","name":{"kind":"Name","value":"_query"}},{"kind":"Field","name":{"kind":"Name","value":"_runStats"}},{"kind":"Field","name":{"kind":"Name","value":"_formula"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"includeArtifacts"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"query"}},{"kind":"Field","name":{"kind":"Name","value":"runStats"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}}]}}]} as unknown as DocumentNode;
export const CompanySignupRequestFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanySignupRequestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySignupRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userTitle"}},{"kind":"Field","name":{"kind":"Name","value":"userCompany"}},{"kind":"Field","name":{"kind":"Name","value":"userPhone"}},{"kind":"Field","name":{"kind":"Name","value":"managerAdminInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyType"}},{"kind":"Field","name":{"kind":"Name","value":"skuCount"}},{"kind":"Field","name":{"kind":"Name","value":"numSkusToManage"}},{"kind":"Field","name":{"kind":"Name","value":"sponsored"}},{"kind":"Field","name":{"kind":"Name","value":"contractPending"}},{"kind":"Field","name":{"kind":"Name","value":"readyForSetup"}},{"kind":"Field","name":{"kind":"Name","value":"listAllOwnedBrands"}},{"kind":"Field","name":{"kind":"Name","value":"companyAddress"}},{"kind":"Field","name":{"kind":"Name","value":"companyAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"companyCity"}},{"kind":"Field","name":{"kind":"Name","value":"companyState"}},{"kind":"Field","name":{"kind":"Name","value":"companyZipCode"}},{"kind":"Field","name":{"kind":"Name","value":"adultBeverage"}},{"kind":"Field","name":{"kind":"Name","value":"planType"}},{"kind":"Field","name":{"kind":"Name","value":"retailerReferral"}},{"kind":"Field","name":{"kind":"Name","value":"planPromoCode"}},{"kind":"Field","name":{"kind":"Name","value":"partnerName"}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const ConfigFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConfigFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Config"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"_value"}},{"kind":"Field","name":{"kind":"Name","value":"_valueJsonSchema"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validator"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"valueJsonSchema"}}]}}]} as unknown as DocumentNode;
export const DomainUserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DomainUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DomainUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"abilities"}},{"kind":"Field","name":{"kind":"Name","value":"invitedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inviteMessage"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const DomainCompanyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DomainCompanyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DomainCompany"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"access"}},{"kind":"Field","name":{"kind":"Name","value":"profileAccess"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const DomainTaxonomyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DomainTaxonomyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DomainTaxonomy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxonomy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const DomainFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DomainFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Domain"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"nucleusRetailerId"}},{"kind":"Field","name":{"kind":"Name","value":"membership"}},{"kind":"Field","name":{"kind":"Name","value":"hasManagerAccess"}},{"kind":"Field","name":{"kind":"Name","value":"hasDigitizationAccess"}},{"kind":"Field","name":{"kind":"Name","value":"digitizationMode"}},{"kind":"Field","name":{"kind":"Name","value":"identifierPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"identifierName"}},{"kind":"Field","name":{"kind":"Name","value":"productExclusivityMode"}},{"kind":"Field","name":{"kind":"Name","value":"planPromoCode"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSkuCount"}},{"kind":"Field","name":{"kind":"Name","value":"numSkusToManage"}},{"kind":"Field","name":{"kind":"Name","value":"partnerName"}},{"kind":"Field","name":{"kind":"Name","value":"referredByRetailer"}},{"kind":"Field","name":{"kind":"Name","value":"manufactureOrDistributeAlcoholInWF"}},{"kind":"Field","name":{"kind":"Name","value":"sponsored"}},{"kind":"Field","name":{"kind":"Name","value":"contractPending"}},{"kind":"Field","name":{"kind":"Name","value":"readyForSetup"}},{"kind":"Field","name":{"kind":"Name","value":"listAllOwnedBrands"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DomainUserFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DomainCompanyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyType"}},{"kind":"Field","name":{"kind":"Name","value":"taxonomies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DomainTaxonomyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalName"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedTOS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataAndImages"}},{"kind":"Field","name":{"kind":"Name","value":"dataOnly"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"lengthInDays"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"renewalNotificationPeriodInDays"}},{"kind":"Field","name":{"kind":"Name","value":"feePerYear"}},{"kind":"Field","name":{"kind":"Name","value":"additionalSkuFeePerYear"}},{"kind":"Field","name":{"kind":"Name","value":"trialExpirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractedSkus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountOwner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileSizeMb"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedDate"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sftp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"s3Path"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pv2CustomFieldPrimary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pv2CustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const DataRequirementFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DataRequirementFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataRequirement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetModel"}},{"kind":"Field","name":{"kind":"Name","value":"selectFields"}},{"kind":"Field","name":{"kind":"Name","value":"populateFields"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isArray"}},{"kind":"Field","name":{"kind":"Name","value":"optional"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataRequirementModelId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetModel"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isArray"}},{"kind":"Field","name":{"kind":"Name","value":"optional"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataRequirementPrimitive"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primitiveType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isArray"}},{"kind":"Field","name":{"kind":"Name","value":"optional"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}}]} as unknown as DocumentNode;
export const FormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Form"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"s3Path"}},{"kind":"Field","name":{"kind":"Name","value":"sideComponent"}},{"kind":"Field","name":{"kind":"Name","value":"dataRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DataRequirementFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"}}]}}]} as unknown as DocumentNode;
export const FormInstructionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormInstructionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormInstruction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"structure"}},{"kind":"Field","name":{"kind":"Name","value":"s3Path"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const TagStructFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagStructFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TagStruct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}}]} as unknown as DocumentNode;
export const FormulaFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormulaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Formula"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fields"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"runInPv2Middleware"}},{"kind":"Field","name":{"kind":"Name","value":"filter"}},{"kind":"Field","name":{"kind":"Name","value":"structure"}},{"kind":"Field","name":{"kind":"Name","value":"functions"}},{"kind":"Field","name":{"kind":"Name","value":"changelog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outputAttributeTypes"}},{"kind":"Field","name":{"kind":"Name","value":"inputResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"direct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indirect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributeTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"direct"}},{"kind":"Field","name":{"kind":"Name","value":"indirect"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputProductFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"direct"}},{"kind":"Field","name":{"kind":"Name","value":"indirect"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputCleansedDataPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"direct"}},{"kind":"Field","name":{"kind":"Name","value":"indirect"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputClientTrackerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"direct"}},{"kind":"Field","name":{"kind":"Name","value":"indirect"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencedFormulas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formula"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imports"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affectedByFormulas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formula"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"attributeTypes"}},{"kind":"Field","name":{"kind":"Name","value":"productFields"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cleansedDataPoints"}},{"kind":"Field","name":{"kind":"Name","value":"clientTrackerAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagStructFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const FormulaResourceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormulaResourceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormulaResource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagStructFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descendents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalChildren"}},{"kind":"Field","name":{"kind":"Name","value":"ownItems"}},{"kind":"Field","name":{"kind":"Name","value":"totalItems"}},{"kind":"Field","name":{"kind":"Name","value":"s3Path"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valueJSON"}}]}}]} as unknown as DocumentNode;
export const ScannedBarcodesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScannedBarcodesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScannedBarcodes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode;
export const ImageUrlFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageUrlFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageUrl"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"sizeMb"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const ImageFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"downloaded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scannedBarcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScannedBarcodesFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageUrlFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectionReason"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"overrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isInImageProcessingQueue"}},{"kind":"Field","name":{"kind":"Name","value":"pv2ProcessingPriority"}},{"kind":"Field","name":{"kind":"Name","value":"pv2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"digitizationOriginalUrls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageUrlFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"angle"}},{"kind":"Field","name":{"kind":"Name","value":"mainUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageUrlFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageUrlFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"croppedUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageUrlFragment"}}]}}]}}]} as unknown as DocumentNode;
export const MturkWorkerQualificationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MturkWorkerQualificationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MturkWorkerQualification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"QualificationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"IntegerValue"}},{"kind":"Field","name":{"kind":"Name","value":"GrantTime"}},{"kind":"Field","name":{"kind":"Name","value":"Reason"}}]}}]} as unknown as DocumentNode;
export const MturkWorkerFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MturkWorkerFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MturkWorker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"WorkerId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isBlocked"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MturkWorkerQualificationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualificationsCount"}},{"kind":"Field","name":{"kind":"Name","value":"revokedQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MturkWorkerQualificationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"revokedQualificationsCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"averageScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalIssues"}},{"kind":"Field","name":{"kind":"Name","value":"averageIssues"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonus"}},{"kind":"Field","name":{"kind":"Name","value":"totalFullBonus"}},{"kind":"Field","name":{"kind":"Name","value":"averageBonus"}},{"kind":"Field","name":{"kind":"Name","value":"totalMessages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCorrectMessages"}},{"kind":"Field","name":{"kind":"Name","value":"correctMessageRatio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"threeMonths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"averageScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalIssues"}},{"kind":"Field","name":{"kind":"Name","value":"averageIssues"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonus"}},{"kind":"Field","name":{"kind":"Name","value":"totalFullBonus"}},{"kind":"Field","name":{"kind":"Name","value":"averageBonus"}},{"kind":"Field","name":{"kind":"Name","value":"totalMessages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCorrectMessages"}},{"kind":"Field","name":{"kind":"Name","value":"correctMessageRatio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oneMonth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"averageScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalIssues"}},{"kind":"Field","name":{"kind":"Name","value":"averageIssues"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonus"}},{"kind":"Field","name":{"kind":"Name","value":"totalFullBonus"}},{"kind":"Field","name":{"kind":"Name","value":"averageBonus"}},{"kind":"Field","name":{"kind":"Name","value":"totalMessages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCorrectMessages"}},{"kind":"Field","name":{"kind":"Name","value":"correctMessageRatio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"perTaskTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"averageScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalIssues"}},{"kind":"Field","name":{"kind":"Name","value":"averageIssues"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonus"}},{"kind":"Field","name":{"kind":"Name","value":"totalFullBonus"}},{"kind":"Field","name":{"kind":"Name","value":"averageBonus"}},{"kind":"Field","name":{"kind":"Name","value":"totalMessages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCorrectMessages"}},{"kind":"Field","name":{"kind":"Name","value":"correctMessageRatio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"perTaskThreeMonths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"averageScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalIssues"}},{"kind":"Field","name":{"kind":"Name","value":"averageIssues"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonus"}},{"kind":"Field","name":{"kind":"Name","value":"totalFullBonus"}},{"kind":"Field","name":{"kind":"Name","value":"averageBonus"}},{"kind":"Field","name":{"kind":"Name","value":"totalMessages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCorrectMessages"}},{"kind":"Field","name":{"kind":"Name","value":"correctMessageRatio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"perTaskOneMonth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"averageScore"}},{"kind":"Field","name":{"kind":"Name","value":"totalIssues"}},{"kind":"Field","name":{"kind":"Name","value":"averageIssues"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonus"}},{"kind":"Field","name":{"kind":"Name","value":"totalFullBonus"}},{"kind":"Field","name":{"kind":"Name","value":"averageBonus"}},{"kind":"Field","name":{"kind":"Name","value":"totalMessages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCorrectMessages"}},{"kind":"Field","name":{"kind":"Name","value":"correctMessageRatio"}}]}}]}}]}}]} as unknown as DocumentNode;
export const ChangelogEntryStructFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangelogEntryStructFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangelogEntryStruct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const Pv2AttributeDefinitionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pv2AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2AttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"versionDate"}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxonomies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hierarchies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasKey"}},{"kind":"Field","name":{"kind":"Name","value":"parents"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"internalDescription"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"hasValue"}},{"kind":"Field","name":{"kind":"Name","value":"_valueSchema"}},{"kind":"Field","name":{"kind":"Name","value":"changelog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangelogEntryStructFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valueSchema"}}]}}]} as unknown as DocumentNode;
export const BarcodeStructFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BarcodeStructFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BarcodeStruct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GTIN"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCheckDigit"}},{"kind":"Field","name":{"kind":"Name","value":"shouldTrimLeadingZeros"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"isPrivateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}}]} as unknown as DocumentNode;
export const Pv2IdentifierFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pv2IdentifierFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2Identifier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode;
export const Pv2IngestionMetadataFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pv2IngestionMetadataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2IngestionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"rawPayload"}}]}}]} as unknown as DocumentNode;
export const Pv2AttributeStructFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pv2AttributeStructFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2AttributeStruct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"dataProvider"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"valueUpdatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const Pv2DigitizationStatusFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pv2DigitizationStatusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2DigitizationStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"store"}}]}}]} as unknown as DocumentNode;
export const Pv2DigitizationOutOfStockFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pv2DigitizationOutOfStockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2DigitizationOutOfStock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"store"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]} as unknown as DocumentNode;
export const Pv2DigitizationStoreDoneFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pv2DigitizationStoreDoneFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2DigitizationStoreDone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"store"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]} as unknown as DocumentNode;
export const Pv2FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pv2Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BarcodeStructFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveredToCircana"}},{"kind":"Field","name":{"kind":"Name","value":"firstDeliveredToSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"spinsAttributesEligibilityOverride"}},{"kind":"Field","name":{"kind":"Name","value":"gtin"}},{"kind":"Field","name":{"kind":"Name","value":"spinsUpc"}},{"kind":"Field","name":{"kind":"Name","value":"maskedUpc"}},{"kind":"Field","name":{"kind":"Name","value":"asinChildren"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asin"}},{"kind":"Field","name":{"kind":"Name","value":"associatedGtin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2IdentifierFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ingestionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2IngestionMetadataFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"whitelists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dedupeDomains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"digitizationStores"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"digitizationStoresInitialized"}},{"kind":"Field","name":{"kind":"Name","value":"taxonomies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hierarchies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hierarchyOverride"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"barcode128"}},{"kind":"Field","name":{"kind":"Name","value":"parentGTIN"}},{"kind":"Field","name":{"kind":"Name","value":"containerChildren"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataUpdatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imagesCount"}},{"kind":"Field","name":{"kind":"Name","value":"imageUpdatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"imageStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"doneDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processingPriority"}},{"kind":"Field","name":{"kind":"Name","value":"outdatedImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagStructFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"overrideExclusivity"}},{"kind":"Field","name":{"kind":"Name","value":"exclusivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"overrideBarcodeGtinGeneration"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2AttributeStructFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastVerification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"verifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"upToDate"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"needsVerification"}},{"kind":"Field","name":{"kind":"Name","value":"discontinued"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"digitizationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2DigitizationStatusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"digitizationOutOfStock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2DigitizationOutOfStockFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"digitizationStoreDone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2DigitizationStoreDoneFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"original"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCopy"}},{"kind":"Field","name":{"kind":"Name","value":"taskerStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"processing"}},{"kind":"Field","name":{"kind":"Name","value":"async_sent"}},{"kind":"Field","name":{"kind":"Name","value":"assigned"}},{"kind":"Field","name":{"kind":"Name","value":"async_done"}},{"kind":"Field","name":{"kind":"Name","value":"async_expired"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"invalid"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"doneDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pv2Ingredients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pv2Ingredient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"componentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failedFormulas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasFailedFormulas"}},{"kind":"Field","name":{"kind":"Name","value":"invalidAttributeParents"}},{"kind":"Field","name":{"kind":"Name","value":"hasInvalidAttributeParents"}},{"kind":"Field","name":{"kind":"Name","value":"circanaKeycat"}},{"kind":"Field","name":{"kind":"Name","value":"cleansedData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mergedCopyPv2Ids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const TransformerExpressionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransformerExpressionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TransformerExpression"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"taskDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"_value"}},{"kind":"Field","name":{"kind":"Name","value":"changelog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangelogEntryStructFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outputType"}},{"kind":"Field","name":{"kind":"Name","value":"inputType"}},{"kind":"Field","name":{"kind":"Name","value":"dataRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DataRequirementFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode;
export const TransformerResourceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransformerResourceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TransformerResource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"_value"}},{"kind":"Field","name":{"kind":"Name","value":"s3Path"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode;
export const TaxonomyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxonomyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Taxonomy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"breadcrumb"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"RACC"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const HierarchyMappingLookupOptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HierarchyMappingLookupOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyMappingLookupOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxonomy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxonomyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}}]} as unknown as DocumentNode;
export const HierarchyMappingConditionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HierarchyMappingCondition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyMappingCondition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"}},{"kind":"Field","name":{"kind":"Name","value":"matchType"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}}]} as unknown as DocumentNode;
export const HierarchyMappingChildRuleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HierarchyMappingChildRule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyMappingChildRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"lookupAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"lookupOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingLookupOption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingCondition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxonomy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxonomyFragment"}}]}}]}}]} as unknown as DocumentNode;
export const HierarchyMappingRuleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HierarchyMappingRule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyMappingRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"lookupAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"lookupOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingLookupOption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingCondition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxonomy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxonomyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingChildRule"}}]}}]}}]} as unknown as DocumentNode;
export const HierarchyMappingFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HierarchyMappingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyMapping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"circanaKeyCat"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackTaxonomy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxonomyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingRule"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxonomies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxonomyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentTaxonomies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxonomyFragment"}}]}}]}}]} as unknown as DocumentNode;
export const HierarchyMappingAttributeValueFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HierarchyMappingAttributeValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyMappingAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode;
export const HierarchyMappingBulkEvaluationResultItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HierarchyMappingBulkEvaluationResultItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyMappingBulkEvaluationResultItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pv2Id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"keycat"}},{"kind":"Field","name":{"kind":"Name","value":"isDifferent"}},{"kind":"Field","name":{"kind":"Name","value":"mappedHierarchy"}},{"kind":"Field","name":{"kind":"Name","value":"existingHierarchy"}},{"kind":"Field","name":{"kind":"Name","value":"hierarchyOverride"}},{"kind":"Field","name":{"kind":"Name","value":"attributeValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingAttributeValue"}}]}}]}}]} as unknown as DocumentNode;
export const HierarchyMappingTaxonomyInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HierarchyMappingTaxonomyInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyMappingTaxonomyInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxonomyId"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}}]}}]} as unknown as DocumentNode;
export const HierarchyMappingKeycatInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HierarchyMappingKeycatInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyMappingKeycatInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keycat"}},{"kind":"Field","name":{"kind":"Name","value":"mappingId"}},{"kind":"Field","name":{"kind":"Name","value":"relevantAttributes"}}]}}]} as unknown as DocumentNode;
export const HierarchyConditionEvaluationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HierarchyConditionEvaluation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyConditionEvaluation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"}},{"kind":"Field","name":{"kind":"Name","value":"attrValue"}},{"kind":"Field","name":{"kind":"Name","value":"isMatch"}},{"kind":"Field","name":{"kind":"Name","value":"shortCircuited"}}]}}]} as unknown as DocumentNode;
export const HierarchyMappingLeafRuleEvaluationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HierarchyMappingLeafRuleEvaluation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyRuleEvaluation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isMatch"}},{"kind":"Field","name":{"kind":"Name","value":"shortCircuited"}},{"kind":"Field","name":{"kind":"Name","value":"lookupOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortCircuited"}},{"kind":"Field","name":{"kind":"Name","value":"isMatch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lookupAttributeValue"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyConditionEvaluation"}}]}}]}}]} as unknown as DocumentNode;
export const HierarchyMappingOuterRuleEvaluationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HierarchyMappingOuterRuleEvaluation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyRuleEvaluation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingLeafRuleEvaluation"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingLeafRuleEvaluation"}}]}}]}}]} as unknown as DocumentNode;
export const ModelColumnInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModelColumnInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ModelColumnInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isList"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"refModel"}},{"kind":"Field","name":{"kind":"Name","value":"enum"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasDefault"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isList"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"refModel"}},{"kind":"Field","name":{"kind":"Name","value":"enum"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasDefault"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isList"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"refModel"}},{"kind":"Field","name":{"kind":"Name","value":"enum"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasDefault"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isList"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"refModel"}},{"kind":"Field","name":{"kind":"Name","value":"enum"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasDefault"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const AttributeTypeWithFieldTypesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeTypeWithFieldTypes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AttributeTypeWithFieldTypes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributeType"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModelColumnInfo"}}]}}]}}]} as unknown as DocumentNode;
export const ScriptMetadataSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScriptMetadataSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScriptMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode;
export const ScriptRunInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScriptRunInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScriptRunInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executionId"}},{"kind":"Field","name":{"kind":"Name","value":"executionUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]} as unknown as DocumentNode;
export const ScriptMetadataDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScriptMetadataDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScriptMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScriptMetadataSummary"}},{"kind":"Field","name":{"kind":"Name","value":"subdirectory"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"acceptFileType"}},{"kind":"Field","name":{"kind":"Name","value":"optionalWithWarning"}},{"kind":"Field","name":{"kind":"Name","value":"choices"}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exampleFileName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"successMessage"}},{"kind":"Field","name":{"kind":"Name","value":"warning"}},{"kind":"Field","name":{"kind":"Name","value":"bucketUrl"}},{"kind":"Field","name":{"kind":"Name","value":"recentRuns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScriptRunInfo"}}]}}]}}]} as unknown as DocumentNode;
export const TaskDefinitionSummaryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskDefinitionSummaryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export const TaskDefinitionWorkflowChildFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskDefinitionWorkflowChildFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskDefinitionWorkflowChild"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"taskGroup"}},{"kind":"Field","name":{"kind":"Name","value":"taskDependencies"}},{"kind":"Field","name":{"kind":"Name","value":"many"}},{"kind":"Field","name":{"kind":"Name","value":"optional"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]} as unknown as DocumentNode;
export const TaskDefinitionWorkflowNodeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskDefinitionWorkflowNodeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskDefinitionWorkflowNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskDefinitionWorkflowChildFragment"}}]}}]}}]} as unknown as DocumentNode;
export const TaskDefinitionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"timeoutSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"throttle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"perSecond"}},{"kind":"Field","name":{"kind":"Name","value":"maxProcessingAtOnce"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resultTransformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagStructFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mturk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"HITTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"qualificationName"}},{"kind":"Field","name":{"kind":"Name","value":"QualificationTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DataRequirementFragment"}}]}}]}}]} as unknown as DocumentNode;
export const UserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"_password"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"auth0Id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"large"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPhotoEntry"}},{"kind":"Field","name":{"kind":"Name","value":"mturkWorker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"receivedGettingStartedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"digitization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"store"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"}},{"kind":"Field","name":{"kind":"Name","value":"workflows"}},{"kind":"Field","name":{"kind":"Name","value":"verificationFlow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abilities"}},{"kind":"Field","name":{"kind":"Name","value":"tasker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pv2CustomFieldPrimary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pv2CustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passwordResetCode"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"photoEntry"}}]}}]} as unknown as DocumentNode;
export const TaskFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskDefinitionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusDate"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"processing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"durationInSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskDependencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_config"}},{"kind":"Field","name":{"kind":"Name","value":"_result"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"targetModel"}},{"kind":"Field","name":{"kind":"Name","value":"targetId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"expandedConfig"}}]}}]} as unknown as DocumentNode;
export const InternalTaskFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalTask"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFragment"}},{"kind":"Field","name":{"kind":"Name","value":"spinsUpc"}}]}}]} as unknown as DocumentNode;
export const BuilderBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuilderBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BuilderBatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuilderBatchFragment"}}]}}]}},...BuilderBatchFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useBuilderBatchQuery__
 *
 * To run a query within a React component, call `useBuilderBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuilderBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuilderBatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuilderBatchQuery(baseOptions: Apollo.QueryHookOptions<BuilderBatchQuery, BuilderBatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuilderBatchQuery, BuilderBatchQueryVariables>(BuilderBatchDocument, options);
      }
export function useBuilderBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuilderBatchQuery, BuilderBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuilderBatchQuery, BuilderBatchQueryVariables>(BuilderBatchDocument, options);
        }
export type BuilderBatchQueryHookResult = ReturnType<typeof useBuilderBatchQuery>;
export type BuilderBatchLazyQueryHookResult = ReturnType<typeof useBuilderBatchLazyQuery>;
export type BuilderBatchQueryResult = Apollo.QueryResult<BuilderBatchQuery, BuilderBatchQueryVariables>;
export const BuilderBatchFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuilderBatchFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BuilderBatch_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuilderBatchFragment"}}]}}]}}]}},...BuilderBatchFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useBuilderBatchFindQuery__
 *
 * To run a query within a React component, call `useBuilderBatchFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuilderBatchFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuilderBatchFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useBuilderBatchFindQuery(baseOptions: Apollo.QueryHookOptions<BuilderBatchFindQuery, BuilderBatchFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuilderBatchFindQuery, BuilderBatchFindQueryVariables>(BuilderBatchFindDocument, options);
      }
export function useBuilderBatchFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuilderBatchFindQuery, BuilderBatchFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuilderBatchFindQuery, BuilderBatchFindQueryVariables>(BuilderBatchFindDocument, options);
        }
export type BuilderBatchFindQueryHookResult = ReturnType<typeof useBuilderBatchFindQuery>;
export type BuilderBatchFindLazyQueryHookResult = ReturnType<typeof useBuilderBatchFindLazyQuery>;
export type BuilderBatchFindQueryResult = Apollo.QueryResult<BuilderBatchFindQuery, BuilderBatchFindQueryVariables>;
export const BuilderBatchCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuilderBatchCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BuilderBatch_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useBuilderBatchCountQuery__
 *
 * To run a query within a React component, call `useBuilderBatchCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuilderBatchCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuilderBatchCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useBuilderBatchCountQuery(baseOptions?: Apollo.QueryHookOptions<BuilderBatchCountQuery, BuilderBatchCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuilderBatchCountQuery, BuilderBatchCountQueryVariables>(BuilderBatchCountDocument, options);
      }
export function useBuilderBatchCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuilderBatchCountQuery, BuilderBatchCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuilderBatchCountQuery, BuilderBatchCountQueryVariables>(BuilderBatchCountDocument, options);
        }
export type BuilderBatchCountQueryHookResult = ReturnType<typeof useBuilderBatchCountQuery>;
export type BuilderBatchCountLazyQueryHookResult = ReturnType<typeof useBuilderBatchCountLazyQuery>;
export type BuilderBatchCountQueryResult = Apollo.QueryResult<BuilderBatchCountQuery, BuilderBatchCountQueryVariables>;
export const BuilderBatchQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuilderBatchQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BuilderBatch_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useBuilderBatchQueryIdsQuery__
 *
 * To run a query within a React component, call `useBuilderBatchQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuilderBatchQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuilderBatchQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useBuilderBatchQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<BuilderBatchQueryIdsQuery, BuilderBatchQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuilderBatchQueryIdsQuery, BuilderBatchQueryIdsQueryVariables>(BuilderBatchQueryIdsDocument, options);
      }
export function useBuilderBatchQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuilderBatchQueryIdsQuery, BuilderBatchQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuilderBatchQueryIdsQuery, BuilderBatchQueryIdsQueryVariables>(BuilderBatchQueryIdsDocument, options);
        }
export type BuilderBatchQueryIdsQueryHookResult = ReturnType<typeof useBuilderBatchQueryIdsQuery>;
export type BuilderBatchQueryIdsLazyQueryHookResult = ReturnType<typeof useBuilderBatchQueryIdsLazyQuery>;
export type BuilderBatchQueryIdsQueryResult = Apollo.QueryResult<BuilderBatchQueryIdsQuery, BuilderBatchQueryIdsQueryVariables>;
export const BuilderBatchUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BuilderBatchUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BuilderBatchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BuilderBatch_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuilderBatchFragment"}}]}}]}},...BuilderBatchFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type BuilderBatchUpdateMutationFn = Apollo.MutationFunction<BuilderBatchUpdateMutation, BuilderBatchUpdateMutationVariables>;

/**
 * __useBuilderBatchUpdateMutation__
 *
 * To run a mutation, you first call `useBuilderBatchUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuilderBatchUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [builderBatchUpdateMutation, { data, loading, error }] = useBuilderBatchUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBuilderBatchUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BuilderBatchUpdateMutation, BuilderBatchUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuilderBatchUpdateMutation, BuilderBatchUpdateMutationVariables>(BuilderBatchUpdateDocument, options);
      }
export type BuilderBatchUpdateMutationHookResult = ReturnType<typeof useBuilderBatchUpdateMutation>;
export type BuilderBatchUpdateMutationResult = Apollo.MutationResult<BuilderBatchUpdateMutation>;
export type BuilderBatchUpdateMutationOptions = Apollo.BaseMutationOptions<BuilderBatchUpdateMutation, BuilderBatchUpdateMutationVariables>;
export const BuilderBatchCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BuilderBatchCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BuilderBatchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BuilderBatch_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuilderBatchFragment"}}]}}]}},...BuilderBatchFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type BuilderBatchCreateMutationFn = Apollo.MutationFunction<BuilderBatchCreateMutation, BuilderBatchCreateMutationVariables>;

/**
 * __useBuilderBatchCreateMutation__
 *
 * To run a mutation, you first call `useBuilderBatchCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuilderBatchCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [builderBatchCreateMutation, { data, loading, error }] = useBuilderBatchCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBuilderBatchCreateMutation(baseOptions?: Apollo.MutationHookOptions<BuilderBatchCreateMutation, BuilderBatchCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuilderBatchCreateMutation, BuilderBatchCreateMutationVariables>(BuilderBatchCreateDocument, options);
      }
export type BuilderBatchCreateMutationHookResult = ReturnType<typeof useBuilderBatchCreateMutation>;
export type BuilderBatchCreateMutationResult = Apollo.MutationResult<BuilderBatchCreateMutation>;
export type BuilderBatchCreateMutationOptions = Apollo.BaseMutationOptions<BuilderBatchCreateMutation, BuilderBatchCreateMutationVariables>;
export const BuilderBatchRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BuilderBatchRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BuilderBatch_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuilderBatchFragment"}}]}}]}},...BuilderBatchFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type BuilderBatchRemoveMutationFn = Apollo.MutationFunction<BuilderBatchRemoveMutation, BuilderBatchRemoveMutationVariables>;

/**
 * __useBuilderBatchRemoveMutation__
 *
 * To run a mutation, you first call `useBuilderBatchRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuilderBatchRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [builderBatchRemoveMutation, { data, loading, error }] = useBuilderBatchRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuilderBatchRemoveMutation(baseOptions?: Apollo.MutationHookOptions<BuilderBatchRemoveMutation, BuilderBatchRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuilderBatchRemoveMutation, BuilderBatchRemoveMutationVariables>(BuilderBatchRemoveDocument, options);
      }
export type BuilderBatchRemoveMutationHookResult = ReturnType<typeof useBuilderBatchRemoveMutation>;
export type BuilderBatchRemoveMutationResult = Apollo.MutationResult<BuilderBatchRemoveMutation>;
export type BuilderBatchRemoveMutationOptions = Apollo.BaseMutationOptions<BuilderBatchRemoveMutation, BuilderBatchRemoveMutationVariables>;
export const BuilderBatchRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BuilderBatchRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BuilderBatch_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type BuilderBatchRemoveManyMutationFn = Apollo.MutationFunction<BuilderBatchRemoveManyMutation, BuilderBatchRemoveManyMutationVariables>;

/**
 * __useBuilderBatchRemoveManyMutation__
 *
 * To run a mutation, you first call `useBuilderBatchRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuilderBatchRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [builderBatchRemoveManyMutation, { data, loading, error }] = useBuilderBatchRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useBuilderBatchRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<BuilderBatchRemoveManyMutation, BuilderBatchRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuilderBatchRemoveManyMutation, BuilderBatchRemoveManyMutationVariables>(BuilderBatchRemoveManyDocument, options);
      }
export type BuilderBatchRemoveManyMutationHookResult = ReturnType<typeof useBuilderBatchRemoveManyMutation>;
export type BuilderBatchRemoveManyMutationResult = Apollo.MutationResult<BuilderBatchRemoveManyMutation>;
export type BuilderBatchRemoveManyMutationOptions = Apollo.BaseMutationOptions<BuilderBatchRemoveManyMutation, BuilderBatchRemoveManyMutationVariables>;
export const BuilderBatchAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BuilderBatchAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BuilderBatch_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type BuilderBatchAggregateMutationFn = Apollo.MutationFunction<BuilderBatchAggregateMutation, BuilderBatchAggregateMutationVariables>;

/**
 * __useBuilderBatchAggregateMutation__
 *
 * To run a mutation, you first call `useBuilderBatchAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuilderBatchAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [builderBatchAggregateMutation, { data, loading, error }] = useBuilderBatchAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useBuilderBatchAggregateMutation(baseOptions?: Apollo.MutationHookOptions<BuilderBatchAggregateMutation, BuilderBatchAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuilderBatchAggregateMutation, BuilderBatchAggregateMutationVariables>(BuilderBatchAggregateDocument, options);
      }
export type BuilderBatchAggregateMutationHookResult = ReturnType<typeof useBuilderBatchAggregateMutation>;
export type BuilderBatchAggregateMutationResult = Apollo.MutationResult<BuilderBatchAggregateMutation>;
export type BuilderBatchAggregateMutationOptions = Apollo.BaseMutationOptions<BuilderBatchAggregateMutation, BuilderBatchAggregateMutationVariables>;
export const CompanySignupRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanySignupRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CompanySignupRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanySignupRequestFragment"}}]}}]}},...CompanySignupRequestFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useCompanySignupRequestQuery__
 *
 * To run a query within a React component, call `useCompanySignupRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySignupRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySignupRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanySignupRequestQuery(baseOptions: Apollo.QueryHookOptions<CompanySignupRequestQuery, CompanySignupRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySignupRequestQuery, CompanySignupRequestQueryVariables>(CompanySignupRequestDocument, options);
      }
export function useCompanySignupRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySignupRequestQuery, CompanySignupRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySignupRequestQuery, CompanySignupRequestQueryVariables>(CompanySignupRequestDocument, options);
        }
export type CompanySignupRequestQueryHookResult = ReturnType<typeof useCompanySignupRequestQuery>;
export type CompanySignupRequestLazyQueryHookResult = ReturnType<typeof useCompanySignupRequestLazyQuery>;
export type CompanySignupRequestQueryResult = Apollo.QueryResult<CompanySignupRequestQuery, CompanySignupRequestQueryVariables>;
export const CompanySignupRequestFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanySignupRequestFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CompanySignupRequest_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanySignupRequestFragment"}}]}}]}}]}},...CompanySignupRequestFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useCompanySignupRequestFindQuery__
 *
 * To run a query within a React component, call `useCompanySignupRequestFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySignupRequestFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySignupRequestFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCompanySignupRequestFindQuery(baseOptions: Apollo.QueryHookOptions<CompanySignupRequestFindQuery, CompanySignupRequestFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySignupRequestFindQuery, CompanySignupRequestFindQueryVariables>(CompanySignupRequestFindDocument, options);
      }
export function useCompanySignupRequestFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySignupRequestFindQuery, CompanySignupRequestFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySignupRequestFindQuery, CompanySignupRequestFindQueryVariables>(CompanySignupRequestFindDocument, options);
        }
export type CompanySignupRequestFindQueryHookResult = ReturnType<typeof useCompanySignupRequestFindQuery>;
export type CompanySignupRequestFindLazyQueryHookResult = ReturnType<typeof useCompanySignupRequestFindLazyQuery>;
export type CompanySignupRequestFindQueryResult = Apollo.QueryResult<CompanySignupRequestFindQuery, CompanySignupRequestFindQueryVariables>;
export const CompanySignupRequestCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanySignupRequestCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CompanySignupRequest_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useCompanySignupRequestCountQuery__
 *
 * To run a query within a React component, call `useCompanySignupRequestCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySignupRequestCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySignupRequestCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCompanySignupRequestCountQuery(baseOptions?: Apollo.QueryHookOptions<CompanySignupRequestCountQuery, CompanySignupRequestCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySignupRequestCountQuery, CompanySignupRequestCountQueryVariables>(CompanySignupRequestCountDocument, options);
      }
export function useCompanySignupRequestCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySignupRequestCountQuery, CompanySignupRequestCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySignupRequestCountQuery, CompanySignupRequestCountQueryVariables>(CompanySignupRequestCountDocument, options);
        }
export type CompanySignupRequestCountQueryHookResult = ReturnType<typeof useCompanySignupRequestCountQuery>;
export type CompanySignupRequestCountLazyQueryHookResult = ReturnType<typeof useCompanySignupRequestCountLazyQuery>;
export type CompanySignupRequestCountQueryResult = Apollo.QueryResult<CompanySignupRequestCountQuery, CompanySignupRequestCountQueryVariables>;
export const CompanySignupRequestQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanySignupRequestQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CompanySignupRequest_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useCompanySignupRequestQueryIdsQuery__
 *
 * To run a query within a React component, call `useCompanySignupRequestQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySignupRequestQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySignupRequestQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCompanySignupRequestQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<CompanySignupRequestQueryIdsQuery, CompanySignupRequestQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySignupRequestQueryIdsQuery, CompanySignupRequestQueryIdsQueryVariables>(CompanySignupRequestQueryIdsDocument, options);
      }
export function useCompanySignupRequestQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySignupRequestQueryIdsQuery, CompanySignupRequestQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySignupRequestQueryIdsQuery, CompanySignupRequestQueryIdsQueryVariables>(CompanySignupRequestQueryIdsDocument, options);
        }
export type CompanySignupRequestQueryIdsQueryHookResult = ReturnType<typeof useCompanySignupRequestQueryIdsQuery>;
export type CompanySignupRequestQueryIdsLazyQueryHookResult = ReturnType<typeof useCompanySignupRequestQueryIdsLazyQuery>;
export type CompanySignupRequestQueryIdsQueryResult = Apollo.QueryResult<CompanySignupRequestQueryIdsQuery, CompanySignupRequestQueryIdsQueryVariables>;
export const CompanySignupRequestUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompanySignupRequestUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySignupRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CompanySignupRequest_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanySignupRequestFragment"}}]}}]}},...CompanySignupRequestFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type CompanySignupRequestUpdateMutationFn = Apollo.MutationFunction<CompanySignupRequestUpdateMutation, CompanySignupRequestUpdateMutationVariables>;

/**
 * __useCompanySignupRequestUpdateMutation__
 *
 * To run a mutation, you first call `useCompanySignupRequestUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySignupRequestUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySignupRequestUpdateMutation, { data, loading, error }] = useCompanySignupRequestUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCompanySignupRequestUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CompanySignupRequestUpdateMutation, CompanySignupRequestUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySignupRequestUpdateMutation, CompanySignupRequestUpdateMutationVariables>(CompanySignupRequestUpdateDocument, options);
      }
export type CompanySignupRequestUpdateMutationHookResult = ReturnType<typeof useCompanySignupRequestUpdateMutation>;
export type CompanySignupRequestUpdateMutationResult = Apollo.MutationResult<CompanySignupRequestUpdateMutation>;
export type CompanySignupRequestUpdateMutationOptions = Apollo.BaseMutationOptions<CompanySignupRequestUpdateMutation, CompanySignupRequestUpdateMutationVariables>;
export const CompanySignupRequestCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompanySignupRequestCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySignupRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CompanySignupRequest_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanySignupRequestFragment"}}]}}]}},...CompanySignupRequestFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type CompanySignupRequestCreateMutationFn = Apollo.MutationFunction<CompanySignupRequestCreateMutation, CompanySignupRequestCreateMutationVariables>;

/**
 * __useCompanySignupRequestCreateMutation__
 *
 * To run a mutation, you first call `useCompanySignupRequestCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySignupRequestCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySignupRequestCreateMutation, { data, loading, error }] = useCompanySignupRequestCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCompanySignupRequestCreateMutation(baseOptions?: Apollo.MutationHookOptions<CompanySignupRequestCreateMutation, CompanySignupRequestCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySignupRequestCreateMutation, CompanySignupRequestCreateMutationVariables>(CompanySignupRequestCreateDocument, options);
      }
export type CompanySignupRequestCreateMutationHookResult = ReturnType<typeof useCompanySignupRequestCreateMutation>;
export type CompanySignupRequestCreateMutationResult = Apollo.MutationResult<CompanySignupRequestCreateMutation>;
export type CompanySignupRequestCreateMutationOptions = Apollo.BaseMutationOptions<CompanySignupRequestCreateMutation, CompanySignupRequestCreateMutationVariables>;
export const CompanySignupRequestRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompanySignupRequestRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CompanySignupRequest_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanySignupRequestFragment"}}]}}]}},...CompanySignupRequestFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type CompanySignupRequestRemoveMutationFn = Apollo.MutationFunction<CompanySignupRequestRemoveMutation, CompanySignupRequestRemoveMutationVariables>;

/**
 * __useCompanySignupRequestRemoveMutation__
 *
 * To run a mutation, you first call `useCompanySignupRequestRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySignupRequestRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySignupRequestRemoveMutation, { data, loading, error }] = useCompanySignupRequestRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanySignupRequestRemoveMutation(baseOptions?: Apollo.MutationHookOptions<CompanySignupRequestRemoveMutation, CompanySignupRequestRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySignupRequestRemoveMutation, CompanySignupRequestRemoveMutationVariables>(CompanySignupRequestRemoveDocument, options);
      }
export type CompanySignupRequestRemoveMutationHookResult = ReturnType<typeof useCompanySignupRequestRemoveMutation>;
export type CompanySignupRequestRemoveMutationResult = Apollo.MutationResult<CompanySignupRequestRemoveMutation>;
export type CompanySignupRequestRemoveMutationOptions = Apollo.BaseMutationOptions<CompanySignupRequestRemoveMutation, CompanySignupRequestRemoveMutationVariables>;
export const CompanySignupRequestRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompanySignupRequestRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CompanySignupRequest_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type CompanySignupRequestRemoveManyMutationFn = Apollo.MutationFunction<CompanySignupRequestRemoveManyMutation, CompanySignupRequestRemoveManyMutationVariables>;

/**
 * __useCompanySignupRequestRemoveManyMutation__
 *
 * To run a mutation, you first call `useCompanySignupRequestRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySignupRequestRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySignupRequestRemoveManyMutation, { data, loading, error }] = useCompanySignupRequestRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCompanySignupRequestRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<CompanySignupRequestRemoveManyMutation, CompanySignupRequestRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySignupRequestRemoveManyMutation, CompanySignupRequestRemoveManyMutationVariables>(CompanySignupRequestRemoveManyDocument, options);
      }
export type CompanySignupRequestRemoveManyMutationHookResult = ReturnType<typeof useCompanySignupRequestRemoveManyMutation>;
export type CompanySignupRequestRemoveManyMutationResult = Apollo.MutationResult<CompanySignupRequestRemoveManyMutation>;
export type CompanySignupRequestRemoveManyMutationOptions = Apollo.BaseMutationOptions<CompanySignupRequestRemoveManyMutation, CompanySignupRequestRemoveManyMutationVariables>;
export const CompanySignupRequestAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompanySignupRequestAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CompanySignupRequest_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type CompanySignupRequestAggregateMutationFn = Apollo.MutationFunction<CompanySignupRequestAggregateMutation, CompanySignupRequestAggregateMutationVariables>;

/**
 * __useCompanySignupRequestAggregateMutation__
 *
 * To run a mutation, you first call `useCompanySignupRequestAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySignupRequestAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySignupRequestAggregateMutation, { data, loading, error }] = useCompanySignupRequestAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCompanySignupRequestAggregateMutation(baseOptions?: Apollo.MutationHookOptions<CompanySignupRequestAggregateMutation, CompanySignupRequestAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySignupRequestAggregateMutation, CompanySignupRequestAggregateMutationVariables>(CompanySignupRequestAggregateDocument, options);
      }
export type CompanySignupRequestAggregateMutationHookResult = ReturnType<typeof useCompanySignupRequestAggregateMutation>;
export type CompanySignupRequestAggregateMutationResult = Apollo.MutationResult<CompanySignupRequestAggregateMutation>;
export type CompanySignupRequestAggregateMutationOptions = Apollo.BaseMutationOptions<CompanySignupRequestAggregateMutation, CompanySignupRequestAggregateMutationVariables>;
export const ConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Config"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Config"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConfigFragment"}}]}}]}},...ConfigFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useConfigQuery__
 *
 * To run a query within a React component, call `useConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfigQuery(baseOptions: Apollo.QueryHookOptions<ConfigQuery, ConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigQuery, ConfigQueryVariables>(ConfigDocument, options);
      }
export function useConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigQuery, ConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigQuery, ConfigQueryVariables>(ConfigDocument, options);
        }
export type ConfigQueryHookResult = ReturnType<typeof useConfigQuery>;
export type ConfigLazyQueryHookResult = ReturnType<typeof useConfigLazyQuery>;
export type ConfigQueryResult = Apollo.QueryResult<ConfigQuery, ConfigQueryVariables>;
export const ConfigFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConfigFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Config_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConfigFragment"}}]}}]}}]}},...ConfigFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useConfigFindQuery__
 *
 * To run a query within a React component, call `useConfigFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useConfigFindQuery(baseOptions: Apollo.QueryHookOptions<ConfigFindQuery, ConfigFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigFindQuery, ConfigFindQueryVariables>(ConfigFindDocument, options);
      }
export function useConfigFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigFindQuery, ConfigFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigFindQuery, ConfigFindQueryVariables>(ConfigFindDocument, options);
        }
export type ConfigFindQueryHookResult = ReturnType<typeof useConfigFindQuery>;
export type ConfigFindLazyQueryHookResult = ReturnType<typeof useConfigFindLazyQuery>;
export type ConfigFindQueryResult = Apollo.QueryResult<ConfigFindQuery, ConfigFindQueryVariables>;
export const ConfigCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConfigCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Config_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useConfigCountQuery__
 *
 * To run a query within a React component, call `useConfigCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useConfigCountQuery(baseOptions?: Apollo.QueryHookOptions<ConfigCountQuery, ConfigCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigCountQuery, ConfigCountQueryVariables>(ConfigCountDocument, options);
      }
export function useConfigCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigCountQuery, ConfigCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigCountQuery, ConfigCountQueryVariables>(ConfigCountDocument, options);
        }
export type ConfigCountQueryHookResult = ReturnType<typeof useConfigCountQuery>;
export type ConfigCountLazyQueryHookResult = ReturnType<typeof useConfigCountLazyQuery>;
export type ConfigCountQueryResult = Apollo.QueryResult<ConfigCountQuery, ConfigCountQueryVariables>;
export const ConfigQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConfigQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Config_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useConfigQueryIdsQuery__
 *
 * To run a query within a React component, call `useConfigQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useConfigQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<ConfigQueryIdsQuery, ConfigQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigQueryIdsQuery, ConfigQueryIdsQueryVariables>(ConfigQueryIdsDocument, options);
      }
export function useConfigQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigQueryIdsQuery, ConfigQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigQueryIdsQuery, ConfigQueryIdsQueryVariables>(ConfigQueryIdsDocument, options);
        }
export type ConfigQueryIdsQueryHookResult = ReturnType<typeof useConfigQueryIdsQuery>;
export type ConfigQueryIdsLazyQueryHookResult = ReturnType<typeof useConfigQueryIdsLazyQuery>;
export type ConfigQueryIdsQueryResult = Apollo.QueryResult<ConfigQueryIdsQuery, ConfigQueryIdsQueryVariables>;
export const ConfigUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfigUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Config_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConfigFragment"}}]}}]}},...ConfigFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type ConfigUpdateMutationFn = Apollo.MutationFunction<ConfigUpdateMutation, ConfigUpdateMutationVariables>;

/**
 * __useConfigUpdateMutation__
 *
 * To run a mutation, you first call `useConfigUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateMutation, { data, loading, error }] = useConfigUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useConfigUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ConfigUpdateMutation, ConfigUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigUpdateMutation, ConfigUpdateMutationVariables>(ConfigUpdateDocument, options);
      }
export type ConfigUpdateMutationHookResult = ReturnType<typeof useConfigUpdateMutation>;
export type ConfigUpdateMutationResult = Apollo.MutationResult<ConfigUpdateMutation>;
export type ConfigUpdateMutationOptions = Apollo.BaseMutationOptions<ConfigUpdateMutation, ConfigUpdateMutationVariables>;
export const ConfigCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfigCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Config_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConfigFragment"}}]}}]}},...ConfigFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type ConfigCreateMutationFn = Apollo.MutationFunction<ConfigCreateMutation, ConfigCreateMutationVariables>;

/**
 * __useConfigCreateMutation__
 *
 * To run a mutation, you first call `useConfigCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configCreateMutation, { data, loading, error }] = useConfigCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useConfigCreateMutation(baseOptions?: Apollo.MutationHookOptions<ConfigCreateMutation, ConfigCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigCreateMutation, ConfigCreateMutationVariables>(ConfigCreateDocument, options);
      }
export type ConfigCreateMutationHookResult = ReturnType<typeof useConfigCreateMutation>;
export type ConfigCreateMutationResult = Apollo.MutationResult<ConfigCreateMutation>;
export type ConfigCreateMutationOptions = Apollo.BaseMutationOptions<ConfigCreateMutation, ConfigCreateMutationVariables>;
export const ConfigRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfigRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Config_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConfigFragment"}}]}}]}},...ConfigFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type ConfigRemoveMutationFn = Apollo.MutationFunction<ConfigRemoveMutation, ConfigRemoveMutationVariables>;

/**
 * __useConfigRemoveMutation__
 *
 * To run a mutation, you first call `useConfigRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configRemoveMutation, { data, loading, error }] = useConfigRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfigRemoveMutation(baseOptions?: Apollo.MutationHookOptions<ConfigRemoveMutation, ConfigRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigRemoveMutation, ConfigRemoveMutationVariables>(ConfigRemoveDocument, options);
      }
export type ConfigRemoveMutationHookResult = ReturnType<typeof useConfigRemoveMutation>;
export type ConfigRemoveMutationResult = Apollo.MutationResult<ConfigRemoveMutation>;
export type ConfigRemoveMutationOptions = Apollo.BaseMutationOptions<ConfigRemoveMutation, ConfigRemoveMutationVariables>;
export const ConfigRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfigRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Config_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type ConfigRemoveManyMutationFn = Apollo.MutationFunction<ConfigRemoveManyMutation, ConfigRemoveManyMutationVariables>;

/**
 * __useConfigRemoveManyMutation__
 *
 * To run a mutation, you first call `useConfigRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configRemoveManyMutation, { data, loading, error }] = useConfigRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useConfigRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<ConfigRemoveManyMutation, ConfigRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigRemoveManyMutation, ConfigRemoveManyMutationVariables>(ConfigRemoveManyDocument, options);
      }
export type ConfigRemoveManyMutationHookResult = ReturnType<typeof useConfigRemoveManyMutation>;
export type ConfigRemoveManyMutationResult = Apollo.MutationResult<ConfigRemoveManyMutation>;
export type ConfigRemoveManyMutationOptions = Apollo.BaseMutationOptions<ConfigRemoveManyMutation, ConfigRemoveManyMutationVariables>;
export const ConfigAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfigAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Config_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type ConfigAggregateMutationFn = Apollo.MutationFunction<ConfigAggregateMutation, ConfigAggregateMutationVariables>;

/**
 * __useConfigAggregateMutation__
 *
 * To run a mutation, you first call `useConfigAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configAggregateMutation, { data, loading, error }] = useConfigAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useConfigAggregateMutation(baseOptions?: Apollo.MutationHookOptions<ConfigAggregateMutation, ConfigAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigAggregateMutation, ConfigAggregateMutationVariables>(ConfigAggregateDocument, options);
      }
export type ConfigAggregateMutationHookResult = ReturnType<typeof useConfigAggregateMutation>;
export type ConfigAggregateMutationResult = Apollo.MutationResult<ConfigAggregateMutation>;
export type ConfigAggregateMutationOptions = Apollo.BaseMutationOptions<ConfigAggregateMutation, ConfigAggregateMutationVariables>;
export const DomainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Domain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Domain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DomainFragment"}}]}}]}},...DomainFragmentFragmentDoc.definitions,...DomainUserFragmentFragmentDoc.definitions,...DomainCompanyFragmentFragmentDoc.definitions,...DomainTaxonomyFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useDomainQuery__
 *
 * To run a query within a React component, call `useDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDomainQuery(baseOptions: Apollo.QueryHookOptions<DomainQuery, DomainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainQuery, DomainQueryVariables>(DomainDocument, options);
      }
export function useDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainQuery, DomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainQuery, DomainQueryVariables>(DomainDocument, options);
        }
export type DomainQueryHookResult = ReturnType<typeof useDomainQuery>;
export type DomainLazyQueryHookResult = ReturnType<typeof useDomainLazyQuery>;
export type DomainQueryResult = Apollo.QueryResult<DomainQuery, DomainQueryVariables>;
export const DomainFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DomainFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Domain_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DomainFragment"}}]}}]}}]}},...DomainFragmentFragmentDoc.definitions,...DomainUserFragmentFragmentDoc.definitions,...DomainCompanyFragmentFragmentDoc.definitions,...DomainTaxonomyFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useDomainFindQuery__
 *
 * To run a query within a React component, call `useDomainFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useDomainFindQuery(baseOptions: Apollo.QueryHookOptions<DomainFindQuery, DomainFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainFindQuery, DomainFindQueryVariables>(DomainFindDocument, options);
      }
export function useDomainFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainFindQuery, DomainFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainFindQuery, DomainFindQueryVariables>(DomainFindDocument, options);
        }
export type DomainFindQueryHookResult = ReturnType<typeof useDomainFindQuery>;
export type DomainFindLazyQueryHookResult = ReturnType<typeof useDomainFindLazyQuery>;
export type DomainFindQueryResult = Apollo.QueryResult<DomainFindQuery, DomainFindQueryVariables>;
export const DomainCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DomainCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Domain_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useDomainCountQuery__
 *
 * To run a query within a React component, call `useDomainCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDomainCountQuery(baseOptions?: Apollo.QueryHookOptions<DomainCountQuery, DomainCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainCountQuery, DomainCountQueryVariables>(DomainCountDocument, options);
      }
export function useDomainCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainCountQuery, DomainCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainCountQuery, DomainCountQueryVariables>(DomainCountDocument, options);
        }
export type DomainCountQueryHookResult = ReturnType<typeof useDomainCountQuery>;
export type DomainCountLazyQueryHookResult = ReturnType<typeof useDomainCountLazyQuery>;
export type DomainCountQueryResult = Apollo.QueryResult<DomainCountQuery, DomainCountQueryVariables>;
export const DomainQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DomainQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Domain_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useDomainQueryIdsQuery__
 *
 * To run a query within a React component, call `useDomainQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDomainQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<DomainQueryIdsQuery, DomainQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainQueryIdsQuery, DomainQueryIdsQueryVariables>(DomainQueryIdsDocument, options);
      }
export function useDomainQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainQueryIdsQuery, DomainQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainQueryIdsQuery, DomainQueryIdsQueryVariables>(DomainQueryIdsDocument, options);
        }
export type DomainQueryIdsQueryHookResult = ReturnType<typeof useDomainQueryIdsQuery>;
export type DomainQueryIdsLazyQueryHookResult = ReturnType<typeof useDomainQueryIdsLazyQuery>;
export type DomainQueryIdsQueryResult = Apollo.QueryResult<DomainQueryIdsQuery, DomainQueryIdsQueryVariables>;
export const DomainUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DomainUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DomainInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Domain_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DomainFragment"}}]}}]}},...DomainFragmentFragmentDoc.definitions,...DomainUserFragmentFragmentDoc.definitions,...DomainCompanyFragmentFragmentDoc.definitions,...DomainTaxonomyFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type DomainUpdateMutationFn = Apollo.MutationFunction<DomainUpdateMutation, DomainUpdateMutationVariables>;

/**
 * __useDomainUpdateMutation__
 *
 * To run a mutation, you first call `useDomainUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainUpdateMutation, { data, loading, error }] = useDomainUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDomainUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DomainUpdateMutation, DomainUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainUpdateMutation, DomainUpdateMutationVariables>(DomainUpdateDocument, options);
      }
export type DomainUpdateMutationHookResult = ReturnType<typeof useDomainUpdateMutation>;
export type DomainUpdateMutationResult = Apollo.MutationResult<DomainUpdateMutation>;
export type DomainUpdateMutationOptions = Apollo.BaseMutationOptions<DomainUpdateMutation, DomainUpdateMutationVariables>;
export const DomainCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DomainCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DomainInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Domain_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DomainFragment"}}]}}]}},...DomainFragmentFragmentDoc.definitions,...DomainUserFragmentFragmentDoc.definitions,...DomainCompanyFragmentFragmentDoc.definitions,...DomainTaxonomyFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type DomainCreateMutationFn = Apollo.MutationFunction<DomainCreateMutation, DomainCreateMutationVariables>;

/**
 * __useDomainCreateMutation__
 *
 * To run a mutation, you first call `useDomainCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainCreateMutation, { data, loading, error }] = useDomainCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDomainCreateMutation(baseOptions?: Apollo.MutationHookOptions<DomainCreateMutation, DomainCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainCreateMutation, DomainCreateMutationVariables>(DomainCreateDocument, options);
      }
export type DomainCreateMutationHookResult = ReturnType<typeof useDomainCreateMutation>;
export type DomainCreateMutationResult = Apollo.MutationResult<DomainCreateMutation>;
export type DomainCreateMutationOptions = Apollo.BaseMutationOptions<DomainCreateMutation, DomainCreateMutationVariables>;
export const DomainRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DomainRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Domain_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DomainFragment"}}]}}]}},...DomainFragmentFragmentDoc.definitions,...DomainUserFragmentFragmentDoc.definitions,...DomainCompanyFragmentFragmentDoc.definitions,...DomainTaxonomyFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type DomainRemoveMutationFn = Apollo.MutationFunction<DomainRemoveMutation, DomainRemoveMutationVariables>;

/**
 * __useDomainRemoveMutation__
 *
 * To run a mutation, you first call `useDomainRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainRemoveMutation, { data, loading, error }] = useDomainRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDomainRemoveMutation(baseOptions?: Apollo.MutationHookOptions<DomainRemoveMutation, DomainRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainRemoveMutation, DomainRemoveMutationVariables>(DomainRemoveDocument, options);
      }
export type DomainRemoveMutationHookResult = ReturnType<typeof useDomainRemoveMutation>;
export type DomainRemoveMutationResult = Apollo.MutationResult<DomainRemoveMutation>;
export type DomainRemoveMutationOptions = Apollo.BaseMutationOptions<DomainRemoveMutation, DomainRemoveMutationVariables>;
export const DomainRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DomainRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Domain_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type DomainRemoveManyMutationFn = Apollo.MutationFunction<DomainRemoveManyMutation, DomainRemoveManyMutationVariables>;

/**
 * __useDomainRemoveManyMutation__
 *
 * To run a mutation, you first call `useDomainRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainRemoveManyMutation, { data, loading, error }] = useDomainRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDomainRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<DomainRemoveManyMutation, DomainRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainRemoveManyMutation, DomainRemoveManyMutationVariables>(DomainRemoveManyDocument, options);
      }
export type DomainRemoveManyMutationHookResult = ReturnType<typeof useDomainRemoveManyMutation>;
export type DomainRemoveManyMutationResult = Apollo.MutationResult<DomainRemoveManyMutation>;
export type DomainRemoveManyMutationOptions = Apollo.BaseMutationOptions<DomainRemoveManyMutation, DomainRemoveManyMutationVariables>;
export const DomainAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DomainAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Domain_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type DomainAggregateMutationFn = Apollo.MutationFunction<DomainAggregateMutation, DomainAggregateMutationVariables>;

/**
 * __useDomainAggregateMutation__
 *
 * To run a mutation, you first call `useDomainAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainAggregateMutation, { data, loading, error }] = useDomainAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useDomainAggregateMutation(baseOptions?: Apollo.MutationHookOptions<DomainAggregateMutation, DomainAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainAggregateMutation, DomainAggregateMutationVariables>(DomainAggregateDocument, options);
      }
export type DomainAggregateMutationHookResult = ReturnType<typeof useDomainAggregateMutation>;
export type DomainAggregateMutationResult = Apollo.MutationResult<DomainAggregateMutation>;
export type DomainAggregateMutationOptions = Apollo.BaseMutationOptions<DomainAggregateMutation, DomainAggregateMutationVariables>;
export const FormInstructionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormInstruction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormInstruction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormInstructionFragment"}}]}}]}},...FormInstructionFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFormInstructionQuery__
 *
 * To run a query within a React component, call `useFormInstructionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormInstructionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormInstructionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormInstructionQuery(baseOptions: Apollo.QueryHookOptions<FormInstructionQuery, FormInstructionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormInstructionQuery, FormInstructionQueryVariables>(FormInstructionDocument, options);
      }
export function useFormInstructionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormInstructionQuery, FormInstructionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormInstructionQuery, FormInstructionQueryVariables>(FormInstructionDocument, options);
        }
export type FormInstructionQueryHookResult = ReturnType<typeof useFormInstructionQuery>;
export type FormInstructionLazyQueryHookResult = ReturnType<typeof useFormInstructionLazyQuery>;
export type FormInstructionQueryResult = Apollo.QueryResult<FormInstructionQuery, FormInstructionQueryVariables>;
export const FormInstructionFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormInstructionFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormInstruction_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormInstructionFragment"}}]}}]}}]}},...FormInstructionFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFormInstructionFindQuery__
 *
 * To run a query within a React component, call `useFormInstructionFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormInstructionFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormInstructionFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFormInstructionFindQuery(baseOptions: Apollo.QueryHookOptions<FormInstructionFindQuery, FormInstructionFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormInstructionFindQuery, FormInstructionFindQueryVariables>(FormInstructionFindDocument, options);
      }
export function useFormInstructionFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormInstructionFindQuery, FormInstructionFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormInstructionFindQuery, FormInstructionFindQueryVariables>(FormInstructionFindDocument, options);
        }
export type FormInstructionFindQueryHookResult = ReturnType<typeof useFormInstructionFindQuery>;
export type FormInstructionFindLazyQueryHookResult = ReturnType<typeof useFormInstructionFindLazyQuery>;
export type FormInstructionFindQueryResult = Apollo.QueryResult<FormInstructionFindQuery, FormInstructionFindQueryVariables>;
export const FormInstructionCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormInstructionCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormInstruction_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useFormInstructionCountQuery__
 *
 * To run a query within a React component, call `useFormInstructionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormInstructionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormInstructionCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFormInstructionCountQuery(baseOptions?: Apollo.QueryHookOptions<FormInstructionCountQuery, FormInstructionCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormInstructionCountQuery, FormInstructionCountQueryVariables>(FormInstructionCountDocument, options);
      }
export function useFormInstructionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormInstructionCountQuery, FormInstructionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormInstructionCountQuery, FormInstructionCountQueryVariables>(FormInstructionCountDocument, options);
        }
export type FormInstructionCountQueryHookResult = ReturnType<typeof useFormInstructionCountQuery>;
export type FormInstructionCountLazyQueryHookResult = ReturnType<typeof useFormInstructionCountLazyQuery>;
export type FormInstructionCountQueryResult = Apollo.QueryResult<FormInstructionCountQuery, FormInstructionCountQueryVariables>;
export const FormInstructionQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormInstructionQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormInstruction_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useFormInstructionQueryIdsQuery__
 *
 * To run a query within a React component, call `useFormInstructionQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormInstructionQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormInstructionQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFormInstructionQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<FormInstructionQueryIdsQuery, FormInstructionQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormInstructionQueryIdsQuery, FormInstructionQueryIdsQueryVariables>(FormInstructionQueryIdsDocument, options);
      }
export function useFormInstructionQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormInstructionQueryIdsQuery, FormInstructionQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormInstructionQueryIdsQuery, FormInstructionQueryIdsQueryVariables>(FormInstructionQueryIdsDocument, options);
        }
export type FormInstructionQueryIdsQueryHookResult = ReturnType<typeof useFormInstructionQueryIdsQuery>;
export type FormInstructionQueryIdsLazyQueryHookResult = ReturnType<typeof useFormInstructionQueryIdsLazyQuery>;
export type FormInstructionQueryIdsQueryResult = Apollo.QueryResult<FormInstructionQueryIdsQuery, FormInstructionQueryIdsQueryVariables>;
export const FormInstructionUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormInstructionUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormInstructionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormInstruction_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormInstructionFragment"}}]}}]}},...FormInstructionFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type FormInstructionUpdateMutationFn = Apollo.MutationFunction<FormInstructionUpdateMutation, FormInstructionUpdateMutationVariables>;

/**
 * __useFormInstructionUpdateMutation__
 *
 * To run a mutation, you first call `useFormInstructionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormInstructionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formInstructionUpdateMutation, { data, loading, error }] = useFormInstructionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFormInstructionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FormInstructionUpdateMutation, FormInstructionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormInstructionUpdateMutation, FormInstructionUpdateMutationVariables>(FormInstructionUpdateDocument, options);
      }
export type FormInstructionUpdateMutationHookResult = ReturnType<typeof useFormInstructionUpdateMutation>;
export type FormInstructionUpdateMutationResult = Apollo.MutationResult<FormInstructionUpdateMutation>;
export type FormInstructionUpdateMutationOptions = Apollo.BaseMutationOptions<FormInstructionUpdateMutation, FormInstructionUpdateMutationVariables>;
export const FormInstructionCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormInstructionCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormInstructionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormInstruction_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormInstructionFragment"}}]}}]}},...FormInstructionFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type FormInstructionCreateMutationFn = Apollo.MutationFunction<FormInstructionCreateMutation, FormInstructionCreateMutationVariables>;

/**
 * __useFormInstructionCreateMutation__
 *
 * To run a mutation, you first call `useFormInstructionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormInstructionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formInstructionCreateMutation, { data, loading, error }] = useFormInstructionCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFormInstructionCreateMutation(baseOptions?: Apollo.MutationHookOptions<FormInstructionCreateMutation, FormInstructionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormInstructionCreateMutation, FormInstructionCreateMutationVariables>(FormInstructionCreateDocument, options);
      }
export type FormInstructionCreateMutationHookResult = ReturnType<typeof useFormInstructionCreateMutation>;
export type FormInstructionCreateMutationResult = Apollo.MutationResult<FormInstructionCreateMutation>;
export type FormInstructionCreateMutationOptions = Apollo.BaseMutationOptions<FormInstructionCreateMutation, FormInstructionCreateMutationVariables>;
export const FormInstructionRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormInstructionRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormInstruction_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormInstructionFragment"}}]}}]}},...FormInstructionFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type FormInstructionRemoveMutationFn = Apollo.MutationFunction<FormInstructionRemoveMutation, FormInstructionRemoveMutationVariables>;

/**
 * __useFormInstructionRemoveMutation__
 *
 * To run a mutation, you first call `useFormInstructionRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormInstructionRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formInstructionRemoveMutation, { data, loading, error }] = useFormInstructionRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormInstructionRemoveMutation(baseOptions?: Apollo.MutationHookOptions<FormInstructionRemoveMutation, FormInstructionRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormInstructionRemoveMutation, FormInstructionRemoveMutationVariables>(FormInstructionRemoveDocument, options);
      }
export type FormInstructionRemoveMutationHookResult = ReturnType<typeof useFormInstructionRemoveMutation>;
export type FormInstructionRemoveMutationResult = Apollo.MutationResult<FormInstructionRemoveMutation>;
export type FormInstructionRemoveMutationOptions = Apollo.BaseMutationOptions<FormInstructionRemoveMutation, FormInstructionRemoveMutationVariables>;
export const FormInstructionRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormInstructionRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormInstruction_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type FormInstructionRemoveManyMutationFn = Apollo.MutationFunction<FormInstructionRemoveManyMutation, FormInstructionRemoveManyMutationVariables>;

/**
 * __useFormInstructionRemoveManyMutation__
 *
 * To run a mutation, you first call `useFormInstructionRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormInstructionRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formInstructionRemoveManyMutation, { data, loading, error }] = useFormInstructionRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFormInstructionRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<FormInstructionRemoveManyMutation, FormInstructionRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormInstructionRemoveManyMutation, FormInstructionRemoveManyMutationVariables>(FormInstructionRemoveManyDocument, options);
      }
export type FormInstructionRemoveManyMutationHookResult = ReturnType<typeof useFormInstructionRemoveManyMutation>;
export type FormInstructionRemoveManyMutationResult = Apollo.MutationResult<FormInstructionRemoveManyMutation>;
export type FormInstructionRemoveManyMutationOptions = Apollo.BaseMutationOptions<FormInstructionRemoveManyMutation, FormInstructionRemoveManyMutationVariables>;
export const FormInstructionAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormInstructionAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormInstruction_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type FormInstructionAggregateMutationFn = Apollo.MutationFunction<FormInstructionAggregateMutation, FormInstructionAggregateMutationVariables>;

/**
 * __useFormInstructionAggregateMutation__
 *
 * To run a mutation, you first call `useFormInstructionAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormInstructionAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formInstructionAggregateMutation, { data, loading, error }] = useFormInstructionAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useFormInstructionAggregateMutation(baseOptions?: Apollo.MutationHookOptions<FormInstructionAggregateMutation, FormInstructionAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormInstructionAggregateMutation, FormInstructionAggregateMutationVariables>(FormInstructionAggregateDocument, options);
      }
export type FormInstructionAggregateMutationHookResult = ReturnType<typeof useFormInstructionAggregateMutation>;
export type FormInstructionAggregateMutationResult = Apollo.MutationResult<FormInstructionAggregateMutation>;
export type FormInstructionAggregateMutationOptions = Apollo.BaseMutationOptions<FormInstructionAggregateMutation, FormInstructionAggregateMutationVariables>;
export const FormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Form"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Form"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFragment"}}]}}]}},...FormFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFormQuery__
 *
 * To run a query within a React component, call `useFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormQuery(baseOptions: Apollo.QueryHookOptions<FormQuery, FormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormQuery, FormQueryVariables>(FormDocument, options);
      }
export function useFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormQuery, FormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormQuery, FormQueryVariables>(FormDocument, options);
        }
export type FormQueryHookResult = ReturnType<typeof useFormQuery>;
export type FormLazyQueryHookResult = ReturnType<typeof useFormLazyQuery>;
export type FormQueryResult = Apollo.QueryResult<FormQuery, FormQueryVariables>;
export const FormFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Form_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFragment"}}]}}]}}]}},...FormFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFormFindQuery__
 *
 * To run a query within a React component, call `useFormFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFormFindQuery(baseOptions: Apollo.QueryHookOptions<FormFindQuery, FormFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormFindQuery, FormFindQueryVariables>(FormFindDocument, options);
      }
export function useFormFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormFindQuery, FormFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormFindQuery, FormFindQueryVariables>(FormFindDocument, options);
        }
export type FormFindQueryHookResult = ReturnType<typeof useFormFindQuery>;
export type FormFindLazyQueryHookResult = ReturnType<typeof useFormFindLazyQuery>;
export type FormFindQueryResult = Apollo.QueryResult<FormFindQuery, FormFindQueryVariables>;
export const FormCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Form_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useFormCountQuery__
 *
 * To run a query within a React component, call `useFormCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFormCountQuery(baseOptions?: Apollo.QueryHookOptions<FormCountQuery, FormCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormCountQuery, FormCountQueryVariables>(FormCountDocument, options);
      }
export function useFormCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormCountQuery, FormCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormCountQuery, FormCountQueryVariables>(FormCountDocument, options);
        }
export type FormCountQueryHookResult = ReturnType<typeof useFormCountQuery>;
export type FormCountLazyQueryHookResult = ReturnType<typeof useFormCountLazyQuery>;
export type FormCountQueryResult = Apollo.QueryResult<FormCountQuery, FormCountQueryVariables>;
export const FormQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Form_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useFormQueryIdsQuery__
 *
 * To run a query within a React component, call `useFormQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFormQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<FormQueryIdsQuery, FormQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormQueryIdsQuery, FormQueryIdsQueryVariables>(FormQueryIdsDocument, options);
      }
export function useFormQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormQueryIdsQuery, FormQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormQueryIdsQuery, FormQueryIdsQueryVariables>(FormQueryIdsDocument, options);
        }
export type FormQueryIdsQueryHookResult = ReturnType<typeof useFormQueryIdsQuery>;
export type FormQueryIdsLazyQueryHookResult = ReturnType<typeof useFormQueryIdsLazyQuery>;
export type FormQueryIdsQueryResult = Apollo.QueryResult<FormQueryIdsQuery, FormQueryIdsQueryVariables>;
export const FormUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Form_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFragment"}}]}}]}},...FormFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type FormUpdateMutationFn = Apollo.MutationFunction<FormUpdateMutation, FormUpdateMutationVariables>;

/**
 * __useFormUpdateMutation__
 *
 * To run a mutation, you first call `useFormUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formUpdateMutation, { data, loading, error }] = useFormUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFormUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FormUpdateMutation, FormUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormUpdateMutation, FormUpdateMutationVariables>(FormUpdateDocument, options);
      }
export type FormUpdateMutationHookResult = ReturnType<typeof useFormUpdateMutation>;
export type FormUpdateMutationResult = Apollo.MutationResult<FormUpdateMutation>;
export type FormUpdateMutationOptions = Apollo.BaseMutationOptions<FormUpdateMutation, FormUpdateMutationVariables>;
export const FormCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Form_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFragment"}}]}}]}},...FormFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type FormCreateMutationFn = Apollo.MutationFunction<FormCreateMutation, FormCreateMutationVariables>;

/**
 * __useFormCreateMutation__
 *
 * To run a mutation, you first call `useFormCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formCreateMutation, { data, loading, error }] = useFormCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFormCreateMutation(baseOptions?: Apollo.MutationHookOptions<FormCreateMutation, FormCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormCreateMutation, FormCreateMutationVariables>(FormCreateDocument, options);
      }
export type FormCreateMutationHookResult = ReturnType<typeof useFormCreateMutation>;
export type FormCreateMutationResult = Apollo.MutationResult<FormCreateMutation>;
export type FormCreateMutationOptions = Apollo.BaseMutationOptions<FormCreateMutation, FormCreateMutationVariables>;
export const FormRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Form_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFragment"}}]}}]}},...FormFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type FormRemoveMutationFn = Apollo.MutationFunction<FormRemoveMutation, FormRemoveMutationVariables>;

/**
 * __useFormRemoveMutation__
 *
 * To run a mutation, you first call `useFormRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formRemoveMutation, { data, loading, error }] = useFormRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormRemoveMutation(baseOptions?: Apollo.MutationHookOptions<FormRemoveMutation, FormRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormRemoveMutation, FormRemoveMutationVariables>(FormRemoveDocument, options);
      }
export type FormRemoveMutationHookResult = ReturnType<typeof useFormRemoveMutation>;
export type FormRemoveMutationResult = Apollo.MutationResult<FormRemoveMutation>;
export type FormRemoveMutationOptions = Apollo.BaseMutationOptions<FormRemoveMutation, FormRemoveMutationVariables>;
export const FormRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Form_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type FormRemoveManyMutationFn = Apollo.MutationFunction<FormRemoveManyMutation, FormRemoveManyMutationVariables>;

/**
 * __useFormRemoveManyMutation__
 *
 * To run a mutation, you first call `useFormRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formRemoveManyMutation, { data, loading, error }] = useFormRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFormRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<FormRemoveManyMutation, FormRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormRemoveManyMutation, FormRemoveManyMutationVariables>(FormRemoveManyDocument, options);
      }
export type FormRemoveManyMutationHookResult = ReturnType<typeof useFormRemoveManyMutation>;
export type FormRemoveManyMutationResult = Apollo.MutationResult<FormRemoveManyMutation>;
export type FormRemoveManyMutationOptions = Apollo.BaseMutationOptions<FormRemoveManyMutation, FormRemoveManyMutationVariables>;
export const FormAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Form_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type FormAggregateMutationFn = Apollo.MutationFunction<FormAggregateMutation, FormAggregateMutationVariables>;

/**
 * __useFormAggregateMutation__
 *
 * To run a mutation, you first call `useFormAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formAggregateMutation, { data, loading, error }] = useFormAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useFormAggregateMutation(baseOptions?: Apollo.MutationHookOptions<FormAggregateMutation, FormAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormAggregateMutation, FormAggregateMutationVariables>(FormAggregateDocument, options);
      }
export type FormAggregateMutationHookResult = ReturnType<typeof useFormAggregateMutation>;
export type FormAggregateMutationResult = Apollo.MutationResult<FormAggregateMutation>;
export type FormAggregateMutationOptions = Apollo.BaseMutationOptions<FormAggregateMutation, FormAggregateMutationVariables>;
export const FormulaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Formula"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Formula"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormulaFragment"}}]}}]}},...FormulaFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFormulaQuery__
 *
 * To run a query within a React component, call `useFormulaQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormulaQuery(baseOptions: Apollo.QueryHookOptions<FormulaQuery, FormulaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulaQuery, FormulaQueryVariables>(FormulaDocument, options);
      }
export function useFormulaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulaQuery, FormulaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulaQuery, FormulaQueryVariables>(FormulaDocument, options);
        }
export type FormulaQueryHookResult = ReturnType<typeof useFormulaQuery>;
export type FormulaLazyQueryHookResult = ReturnType<typeof useFormulaLazyQuery>;
export type FormulaQueryResult = Apollo.QueryResult<FormulaQuery, FormulaQueryVariables>;
export const FormulaFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormulaFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Formula_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormulaFragment"}}]}}]}}]}},...FormulaFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFormulaFindQuery__
 *
 * To run a query within a React component, call `useFormulaFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFormulaFindQuery(baseOptions: Apollo.QueryHookOptions<FormulaFindQuery, FormulaFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulaFindQuery, FormulaFindQueryVariables>(FormulaFindDocument, options);
      }
export function useFormulaFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulaFindQuery, FormulaFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulaFindQuery, FormulaFindQueryVariables>(FormulaFindDocument, options);
        }
export type FormulaFindQueryHookResult = ReturnType<typeof useFormulaFindQuery>;
export type FormulaFindLazyQueryHookResult = ReturnType<typeof useFormulaFindLazyQuery>;
export type FormulaFindQueryResult = Apollo.QueryResult<FormulaFindQuery, FormulaFindQueryVariables>;
export const FormulaCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormulaCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Formula_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useFormulaCountQuery__
 *
 * To run a query within a React component, call `useFormulaCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFormulaCountQuery(baseOptions?: Apollo.QueryHookOptions<FormulaCountQuery, FormulaCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulaCountQuery, FormulaCountQueryVariables>(FormulaCountDocument, options);
      }
export function useFormulaCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulaCountQuery, FormulaCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulaCountQuery, FormulaCountQueryVariables>(FormulaCountDocument, options);
        }
export type FormulaCountQueryHookResult = ReturnType<typeof useFormulaCountQuery>;
export type FormulaCountLazyQueryHookResult = ReturnType<typeof useFormulaCountLazyQuery>;
export type FormulaCountQueryResult = Apollo.QueryResult<FormulaCountQuery, FormulaCountQueryVariables>;
export const FormulaQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormulaQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Formula_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useFormulaQueryIdsQuery__
 *
 * To run a query within a React component, call `useFormulaQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFormulaQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<FormulaQueryIdsQuery, FormulaQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulaQueryIdsQuery, FormulaQueryIdsQueryVariables>(FormulaQueryIdsDocument, options);
      }
export function useFormulaQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulaQueryIdsQuery, FormulaQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulaQueryIdsQuery, FormulaQueryIdsQueryVariables>(FormulaQueryIdsDocument, options);
        }
export type FormulaQueryIdsQueryHookResult = ReturnType<typeof useFormulaQueryIdsQuery>;
export type FormulaQueryIdsLazyQueryHookResult = ReturnType<typeof useFormulaQueryIdsLazyQuery>;
export type FormulaQueryIdsQueryResult = Apollo.QueryResult<FormulaQueryIdsQuery, FormulaQueryIdsQueryVariables>;
export const FormulaUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormulaUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormulaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Formula_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormulaFragment"}}]}}]}},...FormulaFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type FormulaUpdateMutationFn = Apollo.MutationFunction<FormulaUpdateMutation, FormulaUpdateMutationVariables>;

/**
 * __useFormulaUpdateMutation__
 *
 * To run a mutation, you first call `useFormulaUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormulaUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formulaUpdateMutation, { data, loading, error }] = useFormulaUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFormulaUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FormulaUpdateMutation, FormulaUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormulaUpdateMutation, FormulaUpdateMutationVariables>(FormulaUpdateDocument, options);
      }
export type FormulaUpdateMutationHookResult = ReturnType<typeof useFormulaUpdateMutation>;
export type FormulaUpdateMutationResult = Apollo.MutationResult<FormulaUpdateMutation>;
export type FormulaUpdateMutationOptions = Apollo.BaseMutationOptions<FormulaUpdateMutation, FormulaUpdateMutationVariables>;
export const FormulaCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormulaCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormulaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Formula_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormulaFragment"}}]}}]}},...FormulaFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type FormulaCreateMutationFn = Apollo.MutationFunction<FormulaCreateMutation, FormulaCreateMutationVariables>;

/**
 * __useFormulaCreateMutation__
 *
 * To run a mutation, you first call `useFormulaCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormulaCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formulaCreateMutation, { data, loading, error }] = useFormulaCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFormulaCreateMutation(baseOptions?: Apollo.MutationHookOptions<FormulaCreateMutation, FormulaCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormulaCreateMutation, FormulaCreateMutationVariables>(FormulaCreateDocument, options);
      }
export type FormulaCreateMutationHookResult = ReturnType<typeof useFormulaCreateMutation>;
export type FormulaCreateMutationResult = Apollo.MutationResult<FormulaCreateMutation>;
export type FormulaCreateMutationOptions = Apollo.BaseMutationOptions<FormulaCreateMutation, FormulaCreateMutationVariables>;
export const FormulaRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormulaRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Formula_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormulaFragment"}}]}}]}},...FormulaFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type FormulaRemoveMutationFn = Apollo.MutationFunction<FormulaRemoveMutation, FormulaRemoveMutationVariables>;

/**
 * __useFormulaRemoveMutation__
 *
 * To run a mutation, you first call `useFormulaRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormulaRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formulaRemoveMutation, { data, loading, error }] = useFormulaRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormulaRemoveMutation(baseOptions?: Apollo.MutationHookOptions<FormulaRemoveMutation, FormulaRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormulaRemoveMutation, FormulaRemoveMutationVariables>(FormulaRemoveDocument, options);
      }
export type FormulaRemoveMutationHookResult = ReturnType<typeof useFormulaRemoveMutation>;
export type FormulaRemoveMutationResult = Apollo.MutationResult<FormulaRemoveMutation>;
export type FormulaRemoveMutationOptions = Apollo.BaseMutationOptions<FormulaRemoveMutation, FormulaRemoveMutationVariables>;
export const FormulaRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormulaRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Formula_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type FormulaRemoveManyMutationFn = Apollo.MutationFunction<FormulaRemoveManyMutation, FormulaRemoveManyMutationVariables>;

/**
 * __useFormulaRemoveManyMutation__
 *
 * To run a mutation, you first call `useFormulaRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormulaRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formulaRemoveManyMutation, { data, loading, error }] = useFormulaRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFormulaRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<FormulaRemoveManyMutation, FormulaRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormulaRemoveManyMutation, FormulaRemoveManyMutationVariables>(FormulaRemoveManyDocument, options);
      }
export type FormulaRemoveManyMutationHookResult = ReturnType<typeof useFormulaRemoveManyMutation>;
export type FormulaRemoveManyMutationResult = Apollo.MutationResult<FormulaRemoveManyMutation>;
export type FormulaRemoveManyMutationOptions = Apollo.BaseMutationOptions<FormulaRemoveManyMutation, FormulaRemoveManyMutationVariables>;
export const FormulaAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormulaAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Formula_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type FormulaAggregateMutationFn = Apollo.MutationFunction<FormulaAggregateMutation, FormulaAggregateMutationVariables>;

/**
 * __useFormulaAggregateMutation__
 *
 * To run a mutation, you first call `useFormulaAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormulaAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formulaAggregateMutation, { data, loading, error }] = useFormulaAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useFormulaAggregateMutation(baseOptions?: Apollo.MutationHookOptions<FormulaAggregateMutation, FormulaAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormulaAggregateMutation, FormulaAggregateMutationVariables>(FormulaAggregateDocument, options);
      }
export type FormulaAggregateMutationHookResult = ReturnType<typeof useFormulaAggregateMutation>;
export type FormulaAggregateMutationResult = Apollo.MutationResult<FormulaAggregateMutation>;
export type FormulaAggregateMutationOptions = Apollo.BaseMutationOptions<FormulaAggregateMutation, FormulaAggregateMutationVariables>;
export const FormulaResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormulaResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormulaResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormulaResourceFragment"}}]}}]}},...FormulaResourceFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFormulaResourceQuery__
 *
 * To run a query within a React component, call `useFormulaResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormulaResourceQuery(baseOptions: Apollo.QueryHookOptions<FormulaResourceQuery, FormulaResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulaResourceQuery, FormulaResourceQueryVariables>(FormulaResourceDocument, options);
      }
export function useFormulaResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulaResourceQuery, FormulaResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulaResourceQuery, FormulaResourceQueryVariables>(FormulaResourceDocument, options);
        }
export type FormulaResourceQueryHookResult = ReturnType<typeof useFormulaResourceQuery>;
export type FormulaResourceLazyQueryHookResult = ReturnType<typeof useFormulaResourceLazyQuery>;
export type FormulaResourceQueryResult = Apollo.QueryResult<FormulaResourceQuery, FormulaResourceQueryVariables>;
export const FormulaResourceFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormulaResourceFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormulaResource_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormulaResourceFragment"}}]}}]}}]}},...FormulaResourceFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFormulaResourceFindQuery__
 *
 * To run a query within a React component, call `useFormulaResourceFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaResourceFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaResourceFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFormulaResourceFindQuery(baseOptions: Apollo.QueryHookOptions<FormulaResourceFindQuery, FormulaResourceFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulaResourceFindQuery, FormulaResourceFindQueryVariables>(FormulaResourceFindDocument, options);
      }
export function useFormulaResourceFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulaResourceFindQuery, FormulaResourceFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulaResourceFindQuery, FormulaResourceFindQueryVariables>(FormulaResourceFindDocument, options);
        }
export type FormulaResourceFindQueryHookResult = ReturnType<typeof useFormulaResourceFindQuery>;
export type FormulaResourceFindLazyQueryHookResult = ReturnType<typeof useFormulaResourceFindLazyQuery>;
export type FormulaResourceFindQueryResult = Apollo.QueryResult<FormulaResourceFindQuery, FormulaResourceFindQueryVariables>;
export const FormulaResourceCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormulaResourceCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormulaResource_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useFormulaResourceCountQuery__
 *
 * To run a query within a React component, call `useFormulaResourceCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaResourceCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaResourceCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFormulaResourceCountQuery(baseOptions?: Apollo.QueryHookOptions<FormulaResourceCountQuery, FormulaResourceCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulaResourceCountQuery, FormulaResourceCountQueryVariables>(FormulaResourceCountDocument, options);
      }
export function useFormulaResourceCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulaResourceCountQuery, FormulaResourceCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulaResourceCountQuery, FormulaResourceCountQueryVariables>(FormulaResourceCountDocument, options);
        }
export type FormulaResourceCountQueryHookResult = ReturnType<typeof useFormulaResourceCountQuery>;
export type FormulaResourceCountLazyQueryHookResult = ReturnType<typeof useFormulaResourceCountLazyQuery>;
export type FormulaResourceCountQueryResult = Apollo.QueryResult<FormulaResourceCountQuery, FormulaResourceCountQueryVariables>;
export const FormulaResourceQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormulaResourceQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormulaResource_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useFormulaResourceQueryIdsQuery__
 *
 * To run a query within a React component, call `useFormulaResourceQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaResourceQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaResourceQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFormulaResourceQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<FormulaResourceQueryIdsQuery, FormulaResourceQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulaResourceQueryIdsQuery, FormulaResourceQueryIdsQueryVariables>(FormulaResourceQueryIdsDocument, options);
      }
export function useFormulaResourceQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulaResourceQueryIdsQuery, FormulaResourceQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulaResourceQueryIdsQuery, FormulaResourceQueryIdsQueryVariables>(FormulaResourceQueryIdsDocument, options);
        }
export type FormulaResourceQueryIdsQueryHookResult = ReturnType<typeof useFormulaResourceQueryIdsQuery>;
export type FormulaResourceQueryIdsLazyQueryHookResult = ReturnType<typeof useFormulaResourceQueryIdsLazyQuery>;
export type FormulaResourceQueryIdsQueryResult = Apollo.QueryResult<FormulaResourceQueryIdsQuery, FormulaResourceQueryIdsQueryVariables>;
export const FormulaResourceUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormulaResourceUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormulaResourceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormulaResource_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormulaResourceFragment"}}]}}]}},...FormulaResourceFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type FormulaResourceUpdateMutationFn = Apollo.MutationFunction<FormulaResourceUpdateMutation, FormulaResourceUpdateMutationVariables>;

/**
 * __useFormulaResourceUpdateMutation__
 *
 * To run a mutation, you first call `useFormulaResourceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormulaResourceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formulaResourceUpdateMutation, { data, loading, error }] = useFormulaResourceUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFormulaResourceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FormulaResourceUpdateMutation, FormulaResourceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormulaResourceUpdateMutation, FormulaResourceUpdateMutationVariables>(FormulaResourceUpdateDocument, options);
      }
export type FormulaResourceUpdateMutationHookResult = ReturnType<typeof useFormulaResourceUpdateMutation>;
export type FormulaResourceUpdateMutationResult = Apollo.MutationResult<FormulaResourceUpdateMutation>;
export type FormulaResourceUpdateMutationOptions = Apollo.BaseMutationOptions<FormulaResourceUpdateMutation, FormulaResourceUpdateMutationVariables>;
export const FormulaResourceCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormulaResourceCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormulaResourceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormulaResource_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormulaResourceFragment"}}]}}]}},...FormulaResourceFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type FormulaResourceCreateMutationFn = Apollo.MutationFunction<FormulaResourceCreateMutation, FormulaResourceCreateMutationVariables>;

/**
 * __useFormulaResourceCreateMutation__
 *
 * To run a mutation, you first call `useFormulaResourceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormulaResourceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formulaResourceCreateMutation, { data, loading, error }] = useFormulaResourceCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFormulaResourceCreateMutation(baseOptions?: Apollo.MutationHookOptions<FormulaResourceCreateMutation, FormulaResourceCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormulaResourceCreateMutation, FormulaResourceCreateMutationVariables>(FormulaResourceCreateDocument, options);
      }
export type FormulaResourceCreateMutationHookResult = ReturnType<typeof useFormulaResourceCreateMutation>;
export type FormulaResourceCreateMutationResult = Apollo.MutationResult<FormulaResourceCreateMutation>;
export type FormulaResourceCreateMutationOptions = Apollo.BaseMutationOptions<FormulaResourceCreateMutation, FormulaResourceCreateMutationVariables>;
export const FormulaResourceRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormulaResourceRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormulaResource_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormulaResourceFragment"}}]}}]}},...FormulaResourceFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type FormulaResourceRemoveMutationFn = Apollo.MutationFunction<FormulaResourceRemoveMutation, FormulaResourceRemoveMutationVariables>;

/**
 * __useFormulaResourceRemoveMutation__
 *
 * To run a mutation, you first call `useFormulaResourceRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormulaResourceRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formulaResourceRemoveMutation, { data, loading, error }] = useFormulaResourceRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormulaResourceRemoveMutation(baseOptions?: Apollo.MutationHookOptions<FormulaResourceRemoveMutation, FormulaResourceRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormulaResourceRemoveMutation, FormulaResourceRemoveMutationVariables>(FormulaResourceRemoveDocument, options);
      }
export type FormulaResourceRemoveMutationHookResult = ReturnType<typeof useFormulaResourceRemoveMutation>;
export type FormulaResourceRemoveMutationResult = Apollo.MutationResult<FormulaResourceRemoveMutation>;
export type FormulaResourceRemoveMutationOptions = Apollo.BaseMutationOptions<FormulaResourceRemoveMutation, FormulaResourceRemoveMutationVariables>;
export const FormulaResourceRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormulaResourceRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormulaResource_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type FormulaResourceRemoveManyMutationFn = Apollo.MutationFunction<FormulaResourceRemoveManyMutation, FormulaResourceRemoveManyMutationVariables>;

/**
 * __useFormulaResourceRemoveManyMutation__
 *
 * To run a mutation, you first call `useFormulaResourceRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormulaResourceRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formulaResourceRemoveManyMutation, { data, loading, error }] = useFormulaResourceRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFormulaResourceRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<FormulaResourceRemoveManyMutation, FormulaResourceRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormulaResourceRemoveManyMutation, FormulaResourceRemoveManyMutationVariables>(FormulaResourceRemoveManyDocument, options);
      }
export type FormulaResourceRemoveManyMutationHookResult = ReturnType<typeof useFormulaResourceRemoveManyMutation>;
export type FormulaResourceRemoveManyMutationResult = Apollo.MutationResult<FormulaResourceRemoveManyMutation>;
export type FormulaResourceRemoveManyMutationOptions = Apollo.BaseMutationOptions<FormulaResourceRemoveManyMutation, FormulaResourceRemoveManyMutationVariables>;
export const FormulaResourceAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FormulaResourceAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormulaResource_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type FormulaResourceAggregateMutationFn = Apollo.MutationFunction<FormulaResourceAggregateMutation, FormulaResourceAggregateMutationVariables>;

/**
 * __useFormulaResourceAggregateMutation__
 *
 * To run a mutation, you first call `useFormulaResourceAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormulaResourceAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formulaResourceAggregateMutation, { data, loading, error }] = useFormulaResourceAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useFormulaResourceAggregateMutation(baseOptions?: Apollo.MutationHookOptions<FormulaResourceAggregateMutation, FormulaResourceAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormulaResourceAggregateMutation, FormulaResourceAggregateMutationVariables>(FormulaResourceAggregateDocument, options);
      }
export type FormulaResourceAggregateMutationHookResult = ReturnType<typeof useFormulaResourceAggregateMutation>;
export type FormulaResourceAggregateMutationResult = Apollo.MutationResult<FormulaResourceAggregateMutation>;
export type FormulaResourceAggregateMutationOptions = Apollo.BaseMutationOptions<FormulaResourceAggregateMutation, FormulaResourceAggregateMutationVariables>;
export const ImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Image"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},...ImageFragmentFragmentDoc.definitions,...ScannedBarcodesFragmentFragmentDoc.definitions,...ImageUrlFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useImageQuery__
 *
 * To run a query within a React component, call `useImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImageQuery(baseOptions: Apollo.QueryHookOptions<ImageQuery, ImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageQuery, ImageQueryVariables>(ImageDocument, options);
      }
export function useImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageQuery, ImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageQuery, ImageQueryVariables>(ImageDocument, options);
        }
export type ImageQueryHookResult = ReturnType<typeof useImageQuery>;
export type ImageLazyQueryHookResult = ReturnType<typeof useImageLazyQuery>;
export type ImageQueryResult = Apollo.QueryResult<ImageQuery, ImageQueryVariables>;
export const ImageFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImageFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}}]}},...ImageFragmentFragmentDoc.definitions,...ScannedBarcodesFragmentFragmentDoc.definitions,...ImageUrlFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useImageFindQuery__
 *
 * To run a query within a React component, call `useImageFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useImageFindQuery(baseOptions: Apollo.QueryHookOptions<ImageFindQuery, ImageFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageFindQuery, ImageFindQueryVariables>(ImageFindDocument, options);
      }
export function useImageFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageFindQuery, ImageFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageFindQuery, ImageFindQueryVariables>(ImageFindDocument, options);
        }
export type ImageFindQueryHookResult = ReturnType<typeof useImageFindQuery>;
export type ImageFindLazyQueryHookResult = ReturnType<typeof useImageFindLazyQuery>;
export type ImageFindQueryResult = Apollo.QueryResult<ImageFindQuery, ImageFindQueryVariables>;
export const ImageCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImageCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useImageCountQuery__
 *
 * To run a query within a React component, call `useImageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useImageCountQuery(baseOptions?: Apollo.QueryHookOptions<ImageCountQuery, ImageCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageCountQuery, ImageCountQueryVariables>(ImageCountDocument, options);
      }
export function useImageCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageCountQuery, ImageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageCountQuery, ImageCountQueryVariables>(ImageCountDocument, options);
        }
export type ImageCountQueryHookResult = ReturnType<typeof useImageCountQuery>;
export type ImageCountLazyQueryHookResult = ReturnType<typeof useImageCountLazyQuery>;
export type ImageCountQueryResult = Apollo.QueryResult<ImageCountQuery, ImageCountQueryVariables>;
export const ImageQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImageQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useImageQueryIdsQuery__
 *
 * To run a query within a React component, call `useImageQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useImageQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<ImageQueryIdsQuery, ImageQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageQueryIdsQuery, ImageQueryIdsQueryVariables>(ImageQueryIdsDocument, options);
      }
export function useImageQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageQueryIdsQuery, ImageQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageQueryIdsQuery, ImageQueryIdsQueryVariables>(ImageQueryIdsDocument, options);
        }
export type ImageQueryIdsQueryHookResult = ReturnType<typeof useImageQueryIdsQuery>;
export type ImageQueryIdsLazyQueryHookResult = ReturnType<typeof useImageQueryIdsLazyQuery>;
export type ImageQueryIdsQueryResult = Apollo.QueryResult<ImageQueryIdsQuery, ImageQueryIdsQueryVariables>;
export const ImageUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImageUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},...ImageFragmentFragmentDoc.definitions,...ScannedBarcodesFragmentFragmentDoc.definitions,...ImageUrlFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type ImageUpdateMutationFn = Apollo.MutationFunction<ImageUpdateMutation, ImageUpdateMutationVariables>;

/**
 * __useImageUpdateMutation__
 *
 * To run a mutation, you first call `useImageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageUpdateMutation, { data, loading, error }] = useImageUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useImageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ImageUpdateMutation, ImageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageUpdateMutation, ImageUpdateMutationVariables>(ImageUpdateDocument, options);
      }
export type ImageUpdateMutationHookResult = ReturnType<typeof useImageUpdateMutation>;
export type ImageUpdateMutationResult = Apollo.MutationResult<ImageUpdateMutation>;
export type ImageUpdateMutationOptions = Apollo.BaseMutationOptions<ImageUpdateMutation, ImageUpdateMutationVariables>;
export const Image_CreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Image_create"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageFile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"imageFile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageFile"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},...ImageFragmentFragmentDoc.definitions,...ScannedBarcodesFragmentFragmentDoc.definitions,...ImageUrlFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type Image_CreateMutationFn = Apollo.MutationFunction<Image_CreateMutation, Image_CreateMutationVariables>;

/**
 * __useImage_CreateMutation__
 *
 * To run a mutation, you first call `useImage_CreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImage_CreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageCreateMutation, { data, loading, error }] = useImage_CreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      imageFile: // value for 'imageFile'
 *   },
 * });
 */
export function useImage_CreateMutation(baseOptions?: Apollo.MutationHookOptions<Image_CreateMutation, Image_CreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Image_CreateMutation, Image_CreateMutationVariables>(Image_CreateDocument, options);
      }
export type Image_CreateMutationHookResult = ReturnType<typeof useImage_CreateMutation>;
export type Image_CreateMutationResult = Apollo.MutationResult<Image_CreateMutation>;
export type Image_CreateMutationOptions = Apollo.BaseMutationOptions<Image_CreateMutation, Image_CreateMutationVariables>;
export const ImageRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImageRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},...ImageFragmentFragmentDoc.definitions,...ScannedBarcodesFragmentFragmentDoc.definitions,...ImageUrlFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type ImageRemoveMutationFn = Apollo.MutationFunction<ImageRemoveMutation, ImageRemoveMutationVariables>;

/**
 * __useImageRemoveMutation__
 *
 * To run a mutation, you first call `useImageRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageRemoveMutation, { data, loading, error }] = useImageRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImageRemoveMutation(baseOptions?: Apollo.MutationHookOptions<ImageRemoveMutation, ImageRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageRemoveMutation, ImageRemoveMutationVariables>(ImageRemoveDocument, options);
      }
export type ImageRemoveMutationHookResult = ReturnType<typeof useImageRemoveMutation>;
export type ImageRemoveMutationResult = Apollo.MutationResult<ImageRemoveMutation>;
export type ImageRemoveMutationOptions = Apollo.BaseMutationOptions<ImageRemoveMutation, ImageRemoveMutationVariables>;
export const ImageRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImageRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type ImageRemoveManyMutationFn = Apollo.MutationFunction<ImageRemoveManyMutation, ImageRemoveManyMutationVariables>;

/**
 * __useImageRemoveManyMutation__
 *
 * To run a mutation, you first call `useImageRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageRemoveManyMutation, { data, loading, error }] = useImageRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useImageRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<ImageRemoveManyMutation, ImageRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageRemoveManyMutation, ImageRemoveManyMutationVariables>(ImageRemoveManyDocument, options);
      }
export type ImageRemoveManyMutationHookResult = ReturnType<typeof useImageRemoveManyMutation>;
export type ImageRemoveManyMutationResult = Apollo.MutationResult<ImageRemoveManyMutation>;
export type ImageRemoveManyMutationOptions = Apollo.BaseMutationOptions<ImageRemoveManyMutation, ImageRemoveManyMutationVariables>;
export const ImageAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImageAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type ImageAggregateMutationFn = Apollo.MutationFunction<ImageAggregateMutation, ImageAggregateMutationVariables>;

/**
 * __useImageAggregateMutation__
 *
 * To run a mutation, you first call `useImageAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageAggregateMutation, { data, loading, error }] = useImageAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useImageAggregateMutation(baseOptions?: Apollo.MutationHookOptions<ImageAggregateMutation, ImageAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageAggregateMutation, ImageAggregateMutationVariables>(ImageAggregateDocument, options);
      }
export type ImageAggregateMutationHookResult = ReturnType<typeof useImageAggregateMutation>;
export type ImageAggregateMutationResult = Apollo.MutationResult<ImageAggregateMutation>;
export type ImageAggregateMutationOptions = Apollo.BaseMutationOptions<ImageAggregateMutation, ImageAggregateMutationVariables>;
export const MturkWorkerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MturkWorker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MturkWorker"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MturkWorkerFragment"}}]}}]}},...MturkWorkerFragmentFragmentDoc.definitions,...MturkWorkerQualificationFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useMturkWorkerQuery__
 *
 * To run a query within a React component, call `useMturkWorkerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMturkWorkerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMturkWorkerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMturkWorkerQuery(baseOptions: Apollo.QueryHookOptions<MturkWorkerQuery, MturkWorkerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MturkWorkerQuery, MturkWorkerQueryVariables>(MturkWorkerDocument, options);
      }
export function useMturkWorkerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MturkWorkerQuery, MturkWorkerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MturkWorkerQuery, MturkWorkerQueryVariables>(MturkWorkerDocument, options);
        }
export type MturkWorkerQueryHookResult = ReturnType<typeof useMturkWorkerQuery>;
export type MturkWorkerLazyQueryHookResult = ReturnType<typeof useMturkWorkerLazyQuery>;
export type MturkWorkerQueryResult = Apollo.QueryResult<MturkWorkerQuery, MturkWorkerQueryVariables>;
export const MturkWorkerFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MturkWorkerFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MturkWorker_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MturkWorkerFragment"}}]}}]}}]}},...MturkWorkerFragmentFragmentDoc.definitions,...MturkWorkerQualificationFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useMturkWorkerFindQuery__
 *
 * To run a query within a React component, call `useMturkWorkerFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useMturkWorkerFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMturkWorkerFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMturkWorkerFindQuery(baseOptions: Apollo.QueryHookOptions<MturkWorkerFindQuery, MturkWorkerFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MturkWorkerFindQuery, MturkWorkerFindQueryVariables>(MturkWorkerFindDocument, options);
      }
export function useMturkWorkerFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MturkWorkerFindQuery, MturkWorkerFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MturkWorkerFindQuery, MturkWorkerFindQueryVariables>(MturkWorkerFindDocument, options);
        }
export type MturkWorkerFindQueryHookResult = ReturnType<typeof useMturkWorkerFindQuery>;
export type MturkWorkerFindLazyQueryHookResult = ReturnType<typeof useMturkWorkerFindLazyQuery>;
export type MturkWorkerFindQueryResult = Apollo.QueryResult<MturkWorkerFindQuery, MturkWorkerFindQueryVariables>;
export const MturkWorkerCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MturkWorkerCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MturkWorker_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useMturkWorkerCountQuery__
 *
 * To run a query within a React component, call `useMturkWorkerCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMturkWorkerCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMturkWorkerCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useMturkWorkerCountQuery(baseOptions?: Apollo.QueryHookOptions<MturkWorkerCountQuery, MturkWorkerCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MturkWorkerCountQuery, MturkWorkerCountQueryVariables>(MturkWorkerCountDocument, options);
      }
export function useMturkWorkerCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MturkWorkerCountQuery, MturkWorkerCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MturkWorkerCountQuery, MturkWorkerCountQueryVariables>(MturkWorkerCountDocument, options);
        }
export type MturkWorkerCountQueryHookResult = ReturnType<typeof useMturkWorkerCountQuery>;
export type MturkWorkerCountLazyQueryHookResult = ReturnType<typeof useMturkWorkerCountLazyQuery>;
export type MturkWorkerCountQueryResult = Apollo.QueryResult<MturkWorkerCountQuery, MturkWorkerCountQueryVariables>;
export const MturkWorkerQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MturkWorkerQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MturkWorker_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useMturkWorkerQueryIdsQuery__
 *
 * To run a query within a React component, call `useMturkWorkerQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMturkWorkerQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMturkWorkerQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useMturkWorkerQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<MturkWorkerQueryIdsQuery, MturkWorkerQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MturkWorkerQueryIdsQuery, MturkWorkerQueryIdsQueryVariables>(MturkWorkerQueryIdsDocument, options);
      }
export function useMturkWorkerQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MturkWorkerQueryIdsQuery, MturkWorkerQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MturkWorkerQueryIdsQuery, MturkWorkerQueryIdsQueryVariables>(MturkWorkerQueryIdsDocument, options);
        }
export type MturkWorkerQueryIdsQueryHookResult = ReturnType<typeof useMturkWorkerQueryIdsQuery>;
export type MturkWorkerQueryIdsLazyQueryHookResult = ReturnType<typeof useMturkWorkerQueryIdsLazyQuery>;
export type MturkWorkerQueryIdsQueryResult = Apollo.QueryResult<MturkWorkerQueryIdsQuery, MturkWorkerQueryIdsQueryVariables>;
export const MturkWorkerUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MturkWorkerUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MturkWorkerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MturkWorker_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MturkWorkerFragment"}}]}}]}},...MturkWorkerFragmentFragmentDoc.definitions,...MturkWorkerQualificationFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type MturkWorkerUpdateMutationFn = Apollo.MutationFunction<MturkWorkerUpdateMutation, MturkWorkerUpdateMutationVariables>;

/**
 * __useMturkWorkerUpdateMutation__
 *
 * To run a mutation, you first call `useMturkWorkerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMturkWorkerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mturkWorkerUpdateMutation, { data, loading, error }] = useMturkWorkerUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMturkWorkerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MturkWorkerUpdateMutation, MturkWorkerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MturkWorkerUpdateMutation, MturkWorkerUpdateMutationVariables>(MturkWorkerUpdateDocument, options);
      }
export type MturkWorkerUpdateMutationHookResult = ReturnType<typeof useMturkWorkerUpdateMutation>;
export type MturkWorkerUpdateMutationResult = Apollo.MutationResult<MturkWorkerUpdateMutation>;
export type MturkWorkerUpdateMutationOptions = Apollo.BaseMutationOptions<MturkWorkerUpdateMutation, MturkWorkerUpdateMutationVariables>;
export const MturkWorkerCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MturkWorkerCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MturkWorkerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MturkWorker_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MturkWorkerFragment"}}]}}]}},...MturkWorkerFragmentFragmentDoc.definitions,...MturkWorkerQualificationFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type MturkWorkerCreateMutationFn = Apollo.MutationFunction<MturkWorkerCreateMutation, MturkWorkerCreateMutationVariables>;

/**
 * __useMturkWorkerCreateMutation__
 *
 * To run a mutation, you first call `useMturkWorkerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMturkWorkerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mturkWorkerCreateMutation, { data, loading, error }] = useMturkWorkerCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMturkWorkerCreateMutation(baseOptions?: Apollo.MutationHookOptions<MturkWorkerCreateMutation, MturkWorkerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MturkWorkerCreateMutation, MturkWorkerCreateMutationVariables>(MturkWorkerCreateDocument, options);
      }
export type MturkWorkerCreateMutationHookResult = ReturnType<typeof useMturkWorkerCreateMutation>;
export type MturkWorkerCreateMutationResult = Apollo.MutationResult<MturkWorkerCreateMutation>;
export type MturkWorkerCreateMutationOptions = Apollo.BaseMutationOptions<MturkWorkerCreateMutation, MturkWorkerCreateMutationVariables>;
export const MturkWorkerRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MturkWorkerRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MturkWorker_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MturkWorkerFragment"}}]}}]}},...MturkWorkerFragmentFragmentDoc.definitions,...MturkWorkerQualificationFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type MturkWorkerRemoveMutationFn = Apollo.MutationFunction<MturkWorkerRemoveMutation, MturkWorkerRemoveMutationVariables>;

/**
 * __useMturkWorkerRemoveMutation__
 *
 * To run a mutation, you first call `useMturkWorkerRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMturkWorkerRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mturkWorkerRemoveMutation, { data, loading, error }] = useMturkWorkerRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMturkWorkerRemoveMutation(baseOptions?: Apollo.MutationHookOptions<MturkWorkerRemoveMutation, MturkWorkerRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MturkWorkerRemoveMutation, MturkWorkerRemoveMutationVariables>(MturkWorkerRemoveDocument, options);
      }
export type MturkWorkerRemoveMutationHookResult = ReturnType<typeof useMturkWorkerRemoveMutation>;
export type MturkWorkerRemoveMutationResult = Apollo.MutationResult<MturkWorkerRemoveMutation>;
export type MturkWorkerRemoveMutationOptions = Apollo.BaseMutationOptions<MturkWorkerRemoveMutation, MturkWorkerRemoveMutationVariables>;
export const MturkWorkerRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MturkWorkerRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MturkWorker_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type MturkWorkerRemoveManyMutationFn = Apollo.MutationFunction<MturkWorkerRemoveManyMutation, MturkWorkerRemoveManyMutationVariables>;

/**
 * __useMturkWorkerRemoveManyMutation__
 *
 * To run a mutation, you first call `useMturkWorkerRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMturkWorkerRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mturkWorkerRemoveManyMutation, { data, loading, error }] = useMturkWorkerRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useMturkWorkerRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<MturkWorkerRemoveManyMutation, MturkWorkerRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MturkWorkerRemoveManyMutation, MturkWorkerRemoveManyMutationVariables>(MturkWorkerRemoveManyDocument, options);
      }
export type MturkWorkerRemoveManyMutationHookResult = ReturnType<typeof useMturkWorkerRemoveManyMutation>;
export type MturkWorkerRemoveManyMutationResult = Apollo.MutationResult<MturkWorkerRemoveManyMutation>;
export type MturkWorkerRemoveManyMutationOptions = Apollo.BaseMutationOptions<MturkWorkerRemoveManyMutation, MturkWorkerRemoveManyMutationVariables>;
export const MturkWorkerAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MturkWorkerAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MturkWorker_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type MturkWorkerAggregateMutationFn = Apollo.MutationFunction<MturkWorkerAggregateMutation, MturkWorkerAggregateMutationVariables>;

/**
 * __useMturkWorkerAggregateMutation__
 *
 * To run a mutation, you first call `useMturkWorkerAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMturkWorkerAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mturkWorkerAggregateMutation, { data, loading, error }] = useMturkWorkerAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useMturkWorkerAggregateMutation(baseOptions?: Apollo.MutationHookOptions<MturkWorkerAggregateMutation, MturkWorkerAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MturkWorkerAggregateMutation, MturkWorkerAggregateMutationVariables>(MturkWorkerAggregateDocument, options);
      }
export type MturkWorkerAggregateMutationHookResult = ReturnType<typeof useMturkWorkerAggregateMutation>;
export type MturkWorkerAggregateMutationResult = Apollo.MutationResult<MturkWorkerAggregateMutation>;
export type MturkWorkerAggregateMutationOptions = Apollo.BaseMutationOptions<MturkWorkerAggregateMutation, MturkWorkerAggregateMutationVariables>;
export const Pv2AttributeDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2AttributeDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2AttributeDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2AttributeDefinitionFragment"}}]}}]}},...Pv2AttributeDefinitionFragmentFragmentDoc.definitions,...ChangelogEntryStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __usePv2AttributeDefinitionQuery__
 *
 * To run a query within a React component, call `usePv2AttributeDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2AttributeDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2AttributeDefinitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePv2AttributeDefinitionQuery(baseOptions: Apollo.QueryHookOptions<Pv2AttributeDefinitionQuery, Pv2AttributeDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2AttributeDefinitionQuery, Pv2AttributeDefinitionQueryVariables>(Pv2AttributeDefinitionDocument, options);
      }
export function usePv2AttributeDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2AttributeDefinitionQuery, Pv2AttributeDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2AttributeDefinitionQuery, Pv2AttributeDefinitionQueryVariables>(Pv2AttributeDefinitionDocument, options);
        }
export type Pv2AttributeDefinitionQueryHookResult = ReturnType<typeof usePv2AttributeDefinitionQuery>;
export type Pv2AttributeDefinitionLazyQueryHookResult = ReturnType<typeof usePv2AttributeDefinitionLazyQuery>;
export type Pv2AttributeDefinitionQueryResult = Apollo.QueryResult<Pv2AttributeDefinitionQuery, Pv2AttributeDefinitionQueryVariables>;
export const Pv2AttributeDefinitionFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2AttributeDefinitionFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2AttributeDefinition_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2AttributeDefinitionFragment"}}]}}]}}]}},...Pv2AttributeDefinitionFragmentFragmentDoc.definitions,...ChangelogEntryStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __usePv2AttributeDefinitionFindQuery__
 *
 * To run a query within a React component, call `usePv2AttributeDefinitionFindQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2AttributeDefinitionFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2AttributeDefinitionFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePv2AttributeDefinitionFindQuery(baseOptions: Apollo.QueryHookOptions<Pv2AttributeDefinitionFindQuery, Pv2AttributeDefinitionFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2AttributeDefinitionFindQuery, Pv2AttributeDefinitionFindQueryVariables>(Pv2AttributeDefinitionFindDocument, options);
      }
export function usePv2AttributeDefinitionFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2AttributeDefinitionFindQuery, Pv2AttributeDefinitionFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2AttributeDefinitionFindQuery, Pv2AttributeDefinitionFindQueryVariables>(Pv2AttributeDefinitionFindDocument, options);
        }
export type Pv2AttributeDefinitionFindQueryHookResult = ReturnType<typeof usePv2AttributeDefinitionFindQuery>;
export type Pv2AttributeDefinitionFindLazyQueryHookResult = ReturnType<typeof usePv2AttributeDefinitionFindLazyQuery>;
export type Pv2AttributeDefinitionFindQueryResult = Apollo.QueryResult<Pv2AttributeDefinitionFindQuery, Pv2AttributeDefinitionFindQueryVariables>;
export const Pv2AttributeDefinitionCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2AttributeDefinitionCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2AttributeDefinition_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __usePv2AttributeDefinitionCountQuery__
 *
 * To run a query within a React component, call `usePv2AttributeDefinitionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2AttributeDefinitionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2AttributeDefinitionCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePv2AttributeDefinitionCountQuery(baseOptions?: Apollo.QueryHookOptions<Pv2AttributeDefinitionCountQuery, Pv2AttributeDefinitionCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2AttributeDefinitionCountQuery, Pv2AttributeDefinitionCountQueryVariables>(Pv2AttributeDefinitionCountDocument, options);
      }
export function usePv2AttributeDefinitionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2AttributeDefinitionCountQuery, Pv2AttributeDefinitionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2AttributeDefinitionCountQuery, Pv2AttributeDefinitionCountQueryVariables>(Pv2AttributeDefinitionCountDocument, options);
        }
export type Pv2AttributeDefinitionCountQueryHookResult = ReturnType<typeof usePv2AttributeDefinitionCountQuery>;
export type Pv2AttributeDefinitionCountLazyQueryHookResult = ReturnType<typeof usePv2AttributeDefinitionCountLazyQuery>;
export type Pv2AttributeDefinitionCountQueryResult = Apollo.QueryResult<Pv2AttributeDefinitionCountQuery, Pv2AttributeDefinitionCountQueryVariables>;
export const Pv2AttributeDefinitionQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2AttributeDefinitionQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2AttributeDefinition_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __usePv2AttributeDefinitionQueryIdsQuery__
 *
 * To run a query within a React component, call `usePv2AttributeDefinitionQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2AttributeDefinitionQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2AttributeDefinitionQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePv2AttributeDefinitionQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<Pv2AttributeDefinitionQueryIdsQuery, Pv2AttributeDefinitionQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2AttributeDefinitionQueryIdsQuery, Pv2AttributeDefinitionQueryIdsQueryVariables>(Pv2AttributeDefinitionQueryIdsDocument, options);
      }
export function usePv2AttributeDefinitionQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2AttributeDefinitionQueryIdsQuery, Pv2AttributeDefinitionQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2AttributeDefinitionQueryIdsQuery, Pv2AttributeDefinitionQueryIdsQueryVariables>(Pv2AttributeDefinitionQueryIdsDocument, options);
        }
export type Pv2AttributeDefinitionQueryIdsQueryHookResult = ReturnType<typeof usePv2AttributeDefinitionQueryIdsQuery>;
export type Pv2AttributeDefinitionQueryIdsLazyQueryHookResult = ReturnType<typeof usePv2AttributeDefinitionQueryIdsLazyQuery>;
export type Pv2AttributeDefinitionQueryIdsQueryResult = Apollo.QueryResult<Pv2AttributeDefinitionQueryIdsQuery, Pv2AttributeDefinitionQueryIdsQueryVariables>;
export const Pv2AttributeDefinitionUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Pv2AttributeDefinitionUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2AttributeDefinitionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2AttributeDefinition_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2AttributeDefinitionFragment"}}]}}]}},...Pv2AttributeDefinitionFragmentFragmentDoc.definitions,...ChangelogEntryStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type Pv2AttributeDefinitionUpdateMutationFn = Apollo.MutationFunction<Pv2AttributeDefinitionUpdateMutation, Pv2AttributeDefinitionUpdateMutationVariables>;

/**
 * __usePv2AttributeDefinitionUpdateMutation__
 *
 * To run a mutation, you first call `usePv2AttributeDefinitionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePv2AttributeDefinitionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pv2AttributeDefinitionUpdateMutation, { data, loading, error }] = usePv2AttributeDefinitionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePv2AttributeDefinitionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Pv2AttributeDefinitionUpdateMutation, Pv2AttributeDefinitionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Pv2AttributeDefinitionUpdateMutation, Pv2AttributeDefinitionUpdateMutationVariables>(Pv2AttributeDefinitionUpdateDocument, options);
      }
export type Pv2AttributeDefinitionUpdateMutationHookResult = ReturnType<typeof usePv2AttributeDefinitionUpdateMutation>;
export type Pv2AttributeDefinitionUpdateMutationResult = Apollo.MutationResult<Pv2AttributeDefinitionUpdateMutation>;
export type Pv2AttributeDefinitionUpdateMutationOptions = Apollo.BaseMutationOptions<Pv2AttributeDefinitionUpdateMutation, Pv2AttributeDefinitionUpdateMutationVariables>;
export const Pv2AttributeDefinitionCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Pv2AttributeDefinitionCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2AttributeDefinitionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2AttributeDefinition_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2AttributeDefinitionFragment"}}]}}]}},...Pv2AttributeDefinitionFragmentFragmentDoc.definitions,...ChangelogEntryStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type Pv2AttributeDefinitionCreateMutationFn = Apollo.MutationFunction<Pv2AttributeDefinitionCreateMutation, Pv2AttributeDefinitionCreateMutationVariables>;

/**
 * __usePv2AttributeDefinitionCreateMutation__
 *
 * To run a mutation, you first call `usePv2AttributeDefinitionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePv2AttributeDefinitionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pv2AttributeDefinitionCreateMutation, { data, loading, error }] = usePv2AttributeDefinitionCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePv2AttributeDefinitionCreateMutation(baseOptions?: Apollo.MutationHookOptions<Pv2AttributeDefinitionCreateMutation, Pv2AttributeDefinitionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Pv2AttributeDefinitionCreateMutation, Pv2AttributeDefinitionCreateMutationVariables>(Pv2AttributeDefinitionCreateDocument, options);
      }
export type Pv2AttributeDefinitionCreateMutationHookResult = ReturnType<typeof usePv2AttributeDefinitionCreateMutation>;
export type Pv2AttributeDefinitionCreateMutationResult = Apollo.MutationResult<Pv2AttributeDefinitionCreateMutation>;
export type Pv2AttributeDefinitionCreateMutationOptions = Apollo.BaseMutationOptions<Pv2AttributeDefinitionCreateMutation, Pv2AttributeDefinitionCreateMutationVariables>;
export const Pv2AttributeDefinitionRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Pv2AttributeDefinitionRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2AttributeDefinition_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2AttributeDefinitionFragment"}}]}}]}},...Pv2AttributeDefinitionFragmentFragmentDoc.definitions,...ChangelogEntryStructFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type Pv2AttributeDefinitionRemoveMutationFn = Apollo.MutationFunction<Pv2AttributeDefinitionRemoveMutation, Pv2AttributeDefinitionRemoveMutationVariables>;

/**
 * __usePv2AttributeDefinitionRemoveMutation__
 *
 * To run a mutation, you first call `usePv2AttributeDefinitionRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePv2AttributeDefinitionRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pv2AttributeDefinitionRemoveMutation, { data, loading, error }] = usePv2AttributeDefinitionRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePv2AttributeDefinitionRemoveMutation(baseOptions?: Apollo.MutationHookOptions<Pv2AttributeDefinitionRemoveMutation, Pv2AttributeDefinitionRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Pv2AttributeDefinitionRemoveMutation, Pv2AttributeDefinitionRemoveMutationVariables>(Pv2AttributeDefinitionRemoveDocument, options);
      }
export type Pv2AttributeDefinitionRemoveMutationHookResult = ReturnType<typeof usePv2AttributeDefinitionRemoveMutation>;
export type Pv2AttributeDefinitionRemoveMutationResult = Apollo.MutationResult<Pv2AttributeDefinitionRemoveMutation>;
export type Pv2AttributeDefinitionRemoveMutationOptions = Apollo.BaseMutationOptions<Pv2AttributeDefinitionRemoveMutation, Pv2AttributeDefinitionRemoveMutationVariables>;
export const Pv2AttributeDefinitionRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Pv2AttributeDefinitionRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2AttributeDefinition_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type Pv2AttributeDefinitionRemoveManyMutationFn = Apollo.MutationFunction<Pv2AttributeDefinitionRemoveManyMutation, Pv2AttributeDefinitionRemoveManyMutationVariables>;

/**
 * __usePv2AttributeDefinitionRemoveManyMutation__
 *
 * To run a mutation, you first call `usePv2AttributeDefinitionRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePv2AttributeDefinitionRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pv2AttributeDefinitionRemoveManyMutation, { data, loading, error }] = usePv2AttributeDefinitionRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePv2AttributeDefinitionRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<Pv2AttributeDefinitionRemoveManyMutation, Pv2AttributeDefinitionRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Pv2AttributeDefinitionRemoveManyMutation, Pv2AttributeDefinitionRemoveManyMutationVariables>(Pv2AttributeDefinitionRemoveManyDocument, options);
      }
export type Pv2AttributeDefinitionRemoveManyMutationHookResult = ReturnType<typeof usePv2AttributeDefinitionRemoveManyMutation>;
export type Pv2AttributeDefinitionRemoveManyMutationResult = Apollo.MutationResult<Pv2AttributeDefinitionRemoveManyMutation>;
export type Pv2AttributeDefinitionRemoveManyMutationOptions = Apollo.BaseMutationOptions<Pv2AttributeDefinitionRemoveManyMutation, Pv2AttributeDefinitionRemoveManyMutationVariables>;
export const Pv2AttributeDefinitionAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Pv2AttributeDefinitionAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2AttributeDefinition_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type Pv2AttributeDefinitionAggregateMutationFn = Apollo.MutationFunction<Pv2AttributeDefinitionAggregateMutation, Pv2AttributeDefinitionAggregateMutationVariables>;

/**
 * __usePv2AttributeDefinitionAggregateMutation__
 *
 * To run a mutation, you first call `usePv2AttributeDefinitionAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePv2AttributeDefinitionAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pv2AttributeDefinitionAggregateMutation, { data, loading, error }] = usePv2AttributeDefinitionAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function usePv2AttributeDefinitionAggregateMutation(baseOptions?: Apollo.MutationHookOptions<Pv2AttributeDefinitionAggregateMutation, Pv2AttributeDefinitionAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Pv2AttributeDefinitionAggregateMutation, Pv2AttributeDefinitionAggregateMutationVariables>(Pv2AttributeDefinitionAggregateDocument, options);
      }
export type Pv2AttributeDefinitionAggregateMutationHookResult = ReturnType<typeof usePv2AttributeDefinitionAggregateMutation>;
export type Pv2AttributeDefinitionAggregateMutationResult = Apollo.MutationResult<Pv2AttributeDefinitionAggregateMutation>;
export type Pv2AttributeDefinitionAggregateMutationOptions = Apollo.BaseMutationOptions<Pv2AttributeDefinitionAggregateMutation, Pv2AttributeDefinitionAggregateMutationVariables>;
export const Pv2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2Fragment"}}]}}]}},...Pv2FragmentFragmentDoc.definitions,...BarcodeStructFragmentFragmentDoc.definitions,...Pv2IdentifierFragmentFragmentDoc.definitions,...Pv2IngestionMetadataFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...Pv2AttributeStructFragmentFragmentDoc.definitions,...Pv2DigitizationStatusFragmentFragmentDoc.definitions,...Pv2DigitizationOutOfStockFragmentFragmentDoc.definitions,...Pv2DigitizationStoreDoneFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __usePv2Query__
 *
 * To run a query within a React component, call `usePv2Query` and pass it any options that fit your needs.
 * When your component renders, `usePv2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePv2Query(baseOptions: Apollo.QueryHookOptions<Pv2Query, Pv2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2Query, Pv2QueryVariables>(Pv2Document, options);
      }
export function usePv2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2Query, Pv2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2Query, Pv2QueryVariables>(Pv2Document, options);
        }
export type Pv2QueryHookResult = ReturnType<typeof usePv2Query>;
export type Pv2LazyQueryHookResult = ReturnType<typeof usePv2LazyQuery>;
export type Pv2QueryResult = Apollo.QueryResult<Pv2Query, Pv2QueryVariables>;
export const Pv2FindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2Find"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2Fragment"}}]}}]}}]}},...Pv2FragmentFragmentDoc.definitions,...BarcodeStructFragmentFragmentDoc.definitions,...Pv2IdentifierFragmentFragmentDoc.definitions,...Pv2IngestionMetadataFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...Pv2AttributeStructFragmentFragmentDoc.definitions,...Pv2DigitizationStatusFragmentFragmentDoc.definitions,...Pv2DigitizationOutOfStockFragmentFragmentDoc.definitions,...Pv2DigitizationStoreDoneFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __usePv2FindQuery__
 *
 * To run a query within a React component, call `usePv2FindQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2FindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2FindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePv2FindQuery(baseOptions: Apollo.QueryHookOptions<Pv2FindQuery, Pv2FindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2FindQuery, Pv2FindQueryVariables>(Pv2FindDocument, options);
      }
export function usePv2FindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2FindQuery, Pv2FindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2FindQuery, Pv2FindQueryVariables>(Pv2FindDocument, options);
        }
export type Pv2FindQueryHookResult = ReturnType<typeof usePv2FindQuery>;
export type Pv2FindLazyQueryHookResult = ReturnType<typeof usePv2FindLazyQuery>;
export type Pv2FindQueryResult = Apollo.QueryResult<Pv2FindQuery, Pv2FindQueryVariables>;
export const Pv2CountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2Count"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __usePv2CountQuery__
 *
 * To run a query within a React component, call `usePv2CountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2CountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2CountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePv2CountQuery(baseOptions?: Apollo.QueryHookOptions<Pv2CountQuery, Pv2CountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2CountQuery, Pv2CountQueryVariables>(Pv2CountDocument, options);
      }
export function usePv2CountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2CountQuery, Pv2CountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2CountQuery, Pv2CountQueryVariables>(Pv2CountDocument, options);
        }
export type Pv2CountQueryHookResult = ReturnType<typeof usePv2CountQuery>;
export type Pv2CountLazyQueryHookResult = ReturnType<typeof usePv2CountLazyQuery>;
export type Pv2CountQueryResult = Apollo.QueryResult<Pv2CountQuery, Pv2CountQueryVariables>;
export const Pv2QueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2QueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __usePv2QueryIdsQuery__
 *
 * To run a query within a React component, call `usePv2QueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2QueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2QueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePv2QueryIdsQuery(baseOptions: Apollo.QueryHookOptions<Pv2QueryIdsQuery, Pv2QueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2QueryIdsQuery, Pv2QueryIdsQueryVariables>(Pv2QueryIdsDocument, options);
      }
export function usePv2QueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2QueryIdsQuery, Pv2QueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2QueryIdsQuery, Pv2QueryIdsQueryVariables>(Pv2QueryIdsDocument, options);
        }
export type Pv2QueryIdsQueryHookResult = ReturnType<typeof usePv2QueryIdsQuery>;
export type Pv2QueryIdsLazyQueryHookResult = ReturnType<typeof usePv2QueryIdsLazyQuery>;
export type Pv2QueryIdsQueryResult = Apollo.QueryResult<Pv2QueryIdsQuery, Pv2QueryIdsQueryVariables>;
export const Pv2UpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Pv2Update"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2Fragment"}}]}}]}},...Pv2FragmentFragmentDoc.definitions,...BarcodeStructFragmentFragmentDoc.definitions,...Pv2IdentifierFragmentFragmentDoc.definitions,...Pv2IngestionMetadataFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...Pv2AttributeStructFragmentFragmentDoc.definitions,...Pv2DigitizationStatusFragmentFragmentDoc.definitions,...Pv2DigitizationOutOfStockFragmentFragmentDoc.definitions,...Pv2DigitizationStoreDoneFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type Pv2UpdateMutationFn = Apollo.MutationFunction<Pv2UpdateMutation, Pv2UpdateMutationVariables>;

/**
 * __usePv2UpdateMutation__
 *
 * To run a mutation, you first call `usePv2UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePv2UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pv2UpdateMutation, { data, loading, error }] = usePv2UpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePv2UpdateMutation(baseOptions?: Apollo.MutationHookOptions<Pv2UpdateMutation, Pv2UpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Pv2UpdateMutation, Pv2UpdateMutationVariables>(Pv2UpdateDocument, options);
      }
export type Pv2UpdateMutationHookResult = ReturnType<typeof usePv2UpdateMutation>;
export type Pv2UpdateMutationResult = Apollo.MutationResult<Pv2UpdateMutation>;
export type Pv2UpdateMutationOptions = Apollo.BaseMutationOptions<Pv2UpdateMutation, Pv2UpdateMutationVariables>;
export const Pv2CreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Pv2Create"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2Fragment"}}]}}]}},...Pv2FragmentFragmentDoc.definitions,...BarcodeStructFragmentFragmentDoc.definitions,...Pv2IdentifierFragmentFragmentDoc.definitions,...Pv2IngestionMetadataFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...Pv2AttributeStructFragmentFragmentDoc.definitions,...Pv2DigitizationStatusFragmentFragmentDoc.definitions,...Pv2DigitizationOutOfStockFragmentFragmentDoc.definitions,...Pv2DigitizationStoreDoneFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type Pv2CreateMutationFn = Apollo.MutationFunction<Pv2CreateMutation, Pv2CreateMutationVariables>;

/**
 * __usePv2CreateMutation__
 *
 * To run a mutation, you first call `usePv2CreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePv2CreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pv2CreateMutation, { data, loading, error }] = usePv2CreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePv2CreateMutation(baseOptions?: Apollo.MutationHookOptions<Pv2CreateMutation, Pv2CreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Pv2CreateMutation, Pv2CreateMutationVariables>(Pv2CreateDocument, options);
      }
export type Pv2CreateMutationHookResult = ReturnType<typeof usePv2CreateMutation>;
export type Pv2CreateMutationResult = Apollo.MutationResult<Pv2CreateMutation>;
export type Pv2CreateMutationOptions = Apollo.BaseMutationOptions<Pv2CreateMutation, Pv2CreateMutationVariables>;
export const Pv2RemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Pv2Remove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pv2Fragment"}}]}}]}},...Pv2FragmentFragmentDoc.definitions,...BarcodeStructFragmentFragmentDoc.definitions,...Pv2IdentifierFragmentFragmentDoc.definitions,...Pv2IngestionMetadataFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...Pv2AttributeStructFragmentFragmentDoc.definitions,...Pv2DigitizationStatusFragmentFragmentDoc.definitions,...Pv2DigitizationOutOfStockFragmentFragmentDoc.definitions,...Pv2DigitizationStoreDoneFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type Pv2RemoveMutationFn = Apollo.MutationFunction<Pv2RemoveMutation, Pv2RemoveMutationVariables>;

/**
 * __usePv2RemoveMutation__
 *
 * To run a mutation, you first call `usePv2RemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePv2RemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pv2RemoveMutation, { data, loading, error }] = usePv2RemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePv2RemoveMutation(baseOptions?: Apollo.MutationHookOptions<Pv2RemoveMutation, Pv2RemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Pv2RemoveMutation, Pv2RemoveMutationVariables>(Pv2RemoveDocument, options);
      }
export type Pv2RemoveMutationHookResult = ReturnType<typeof usePv2RemoveMutation>;
export type Pv2RemoveMutationResult = Apollo.MutationResult<Pv2RemoveMutation>;
export type Pv2RemoveMutationOptions = Apollo.BaseMutationOptions<Pv2RemoveMutation, Pv2RemoveMutationVariables>;
export const Pv2RemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Pv2RemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type Pv2RemoveManyMutationFn = Apollo.MutationFunction<Pv2RemoveManyMutation, Pv2RemoveManyMutationVariables>;

/**
 * __usePv2RemoveManyMutation__
 *
 * To run a mutation, you first call `usePv2RemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePv2RemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pv2RemoveManyMutation, { data, loading, error }] = usePv2RemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePv2RemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<Pv2RemoveManyMutation, Pv2RemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Pv2RemoveManyMutation, Pv2RemoveManyMutationVariables>(Pv2RemoveManyDocument, options);
      }
export type Pv2RemoveManyMutationHookResult = ReturnType<typeof usePv2RemoveManyMutation>;
export type Pv2RemoveManyMutationResult = Apollo.MutationResult<Pv2RemoveManyMutation>;
export type Pv2RemoveManyMutationOptions = Apollo.BaseMutationOptions<Pv2RemoveManyMutation, Pv2RemoveManyMutationVariables>;
export const Pv2AggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Pv2Aggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type Pv2AggregateMutationFn = Apollo.MutationFunction<Pv2AggregateMutation, Pv2AggregateMutationVariables>;

/**
 * __usePv2AggregateMutation__
 *
 * To run a mutation, you first call `usePv2AggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePv2AggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pv2AggregateMutation, { data, loading, error }] = usePv2AggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function usePv2AggregateMutation(baseOptions?: Apollo.MutationHookOptions<Pv2AggregateMutation, Pv2AggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Pv2AggregateMutation, Pv2AggregateMutationVariables>(Pv2AggregateDocument, options);
      }
export type Pv2AggregateMutationHookResult = ReturnType<typeof usePv2AggregateMutation>;
export type Pv2AggregateMutationResult = Apollo.MutationResult<Pv2AggregateMutation>;
export type Pv2AggregateMutationOptions = Apollo.BaseMutationOptions<Pv2AggregateMutation, Pv2AggregateMutationVariables>;
export const TaskDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskDefinitionFragment"}}]}}]}},...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTaskDefinitionQuery__
 *
 * To run a query within a React component, call `useTaskDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDefinitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskDefinitionQuery(baseOptions: Apollo.QueryHookOptions<TaskDefinitionQuery, TaskDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDefinitionQuery, TaskDefinitionQueryVariables>(TaskDefinitionDocument, options);
      }
export function useTaskDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDefinitionQuery, TaskDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDefinitionQuery, TaskDefinitionQueryVariables>(TaskDefinitionDocument, options);
        }
export type TaskDefinitionQueryHookResult = ReturnType<typeof useTaskDefinitionQuery>;
export type TaskDefinitionLazyQueryHookResult = ReturnType<typeof useTaskDefinitionLazyQuery>;
export type TaskDefinitionQueryResult = Apollo.QueryResult<TaskDefinitionQuery, TaskDefinitionQueryVariables>;
export const TaskDefinitionFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskDefinitionFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskDefinition_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskDefinitionFragment"}}]}}]}}]}},...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTaskDefinitionFindQuery__
 *
 * To run a query within a React component, call `useTaskDefinitionFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDefinitionFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDefinitionFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTaskDefinitionFindQuery(baseOptions: Apollo.QueryHookOptions<TaskDefinitionFindQuery, TaskDefinitionFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDefinitionFindQuery, TaskDefinitionFindQueryVariables>(TaskDefinitionFindDocument, options);
      }
export function useTaskDefinitionFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDefinitionFindQuery, TaskDefinitionFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDefinitionFindQuery, TaskDefinitionFindQueryVariables>(TaskDefinitionFindDocument, options);
        }
export type TaskDefinitionFindQueryHookResult = ReturnType<typeof useTaskDefinitionFindQuery>;
export type TaskDefinitionFindLazyQueryHookResult = ReturnType<typeof useTaskDefinitionFindLazyQuery>;
export type TaskDefinitionFindQueryResult = Apollo.QueryResult<TaskDefinitionFindQuery, TaskDefinitionFindQueryVariables>;
export const TaskDefinitionCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskDefinitionCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskDefinition_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useTaskDefinitionCountQuery__
 *
 * To run a query within a React component, call `useTaskDefinitionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDefinitionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDefinitionCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTaskDefinitionCountQuery(baseOptions?: Apollo.QueryHookOptions<TaskDefinitionCountQuery, TaskDefinitionCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDefinitionCountQuery, TaskDefinitionCountQueryVariables>(TaskDefinitionCountDocument, options);
      }
export function useTaskDefinitionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDefinitionCountQuery, TaskDefinitionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDefinitionCountQuery, TaskDefinitionCountQueryVariables>(TaskDefinitionCountDocument, options);
        }
export type TaskDefinitionCountQueryHookResult = ReturnType<typeof useTaskDefinitionCountQuery>;
export type TaskDefinitionCountLazyQueryHookResult = ReturnType<typeof useTaskDefinitionCountLazyQuery>;
export type TaskDefinitionCountQueryResult = Apollo.QueryResult<TaskDefinitionCountQuery, TaskDefinitionCountQueryVariables>;
export const TaskDefinitionQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskDefinitionQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskDefinition_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useTaskDefinitionQueryIdsQuery__
 *
 * To run a query within a React component, call `useTaskDefinitionQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDefinitionQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDefinitionQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTaskDefinitionQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<TaskDefinitionQueryIdsQuery, TaskDefinitionQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDefinitionQueryIdsQuery, TaskDefinitionQueryIdsQueryVariables>(TaskDefinitionQueryIdsDocument, options);
      }
export function useTaskDefinitionQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDefinitionQueryIdsQuery, TaskDefinitionQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDefinitionQueryIdsQuery, TaskDefinitionQueryIdsQueryVariables>(TaskDefinitionQueryIdsDocument, options);
        }
export type TaskDefinitionQueryIdsQueryHookResult = ReturnType<typeof useTaskDefinitionQueryIdsQuery>;
export type TaskDefinitionQueryIdsLazyQueryHookResult = ReturnType<typeof useTaskDefinitionQueryIdsLazyQuery>;
export type TaskDefinitionQueryIdsQueryResult = Apollo.QueryResult<TaskDefinitionQueryIdsQuery, TaskDefinitionQueryIdsQueryVariables>;
export const TaskDefinitionUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskDefinitionUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskDefinitionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskDefinition_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskDefinitionFragment"}}]}}]}},...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TaskDefinitionUpdateMutationFn = Apollo.MutationFunction<TaskDefinitionUpdateMutation, TaskDefinitionUpdateMutationVariables>;

/**
 * __useTaskDefinitionUpdateMutation__
 *
 * To run a mutation, you first call `useTaskDefinitionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskDefinitionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskDefinitionUpdateMutation, { data, loading, error }] = useTaskDefinitionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTaskDefinitionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaskDefinitionUpdateMutation, TaskDefinitionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskDefinitionUpdateMutation, TaskDefinitionUpdateMutationVariables>(TaskDefinitionUpdateDocument, options);
      }
export type TaskDefinitionUpdateMutationHookResult = ReturnType<typeof useTaskDefinitionUpdateMutation>;
export type TaskDefinitionUpdateMutationResult = Apollo.MutationResult<TaskDefinitionUpdateMutation>;
export type TaskDefinitionUpdateMutationOptions = Apollo.BaseMutationOptions<TaskDefinitionUpdateMutation, TaskDefinitionUpdateMutationVariables>;
export const TaskDefinitionCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskDefinitionCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskDefinitionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskDefinition_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskDefinitionFragment"}}]}}]}},...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TaskDefinitionCreateMutationFn = Apollo.MutationFunction<TaskDefinitionCreateMutation, TaskDefinitionCreateMutationVariables>;

/**
 * __useTaskDefinitionCreateMutation__
 *
 * To run a mutation, you first call `useTaskDefinitionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskDefinitionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskDefinitionCreateMutation, { data, loading, error }] = useTaskDefinitionCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTaskDefinitionCreateMutation(baseOptions?: Apollo.MutationHookOptions<TaskDefinitionCreateMutation, TaskDefinitionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskDefinitionCreateMutation, TaskDefinitionCreateMutationVariables>(TaskDefinitionCreateDocument, options);
      }
export type TaskDefinitionCreateMutationHookResult = ReturnType<typeof useTaskDefinitionCreateMutation>;
export type TaskDefinitionCreateMutationResult = Apollo.MutationResult<TaskDefinitionCreateMutation>;
export type TaskDefinitionCreateMutationOptions = Apollo.BaseMutationOptions<TaskDefinitionCreateMutation, TaskDefinitionCreateMutationVariables>;
export const TaskDefinitionRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskDefinitionRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskDefinition_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskDefinitionFragment"}}]}}]}},...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TaskDefinitionRemoveMutationFn = Apollo.MutationFunction<TaskDefinitionRemoveMutation, TaskDefinitionRemoveMutationVariables>;

/**
 * __useTaskDefinitionRemoveMutation__
 *
 * To run a mutation, you first call `useTaskDefinitionRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskDefinitionRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskDefinitionRemoveMutation, { data, loading, error }] = useTaskDefinitionRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskDefinitionRemoveMutation(baseOptions?: Apollo.MutationHookOptions<TaskDefinitionRemoveMutation, TaskDefinitionRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskDefinitionRemoveMutation, TaskDefinitionRemoveMutationVariables>(TaskDefinitionRemoveDocument, options);
      }
export type TaskDefinitionRemoveMutationHookResult = ReturnType<typeof useTaskDefinitionRemoveMutation>;
export type TaskDefinitionRemoveMutationResult = Apollo.MutationResult<TaskDefinitionRemoveMutation>;
export type TaskDefinitionRemoveMutationOptions = Apollo.BaseMutationOptions<TaskDefinitionRemoveMutation, TaskDefinitionRemoveMutationVariables>;
export const TaskDefinitionRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskDefinitionRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskDefinition_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type TaskDefinitionRemoveManyMutationFn = Apollo.MutationFunction<TaskDefinitionRemoveManyMutation, TaskDefinitionRemoveManyMutationVariables>;

/**
 * __useTaskDefinitionRemoveManyMutation__
 *
 * To run a mutation, you first call `useTaskDefinitionRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskDefinitionRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskDefinitionRemoveManyMutation, { data, loading, error }] = useTaskDefinitionRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTaskDefinitionRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<TaskDefinitionRemoveManyMutation, TaskDefinitionRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskDefinitionRemoveManyMutation, TaskDefinitionRemoveManyMutationVariables>(TaskDefinitionRemoveManyDocument, options);
      }
export type TaskDefinitionRemoveManyMutationHookResult = ReturnType<typeof useTaskDefinitionRemoveManyMutation>;
export type TaskDefinitionRemoveManyMutationResult = Apollo.MutationResult<TaskDefinitionRemoveManyMutation>;
export type TaskDefinitionRemoveManyMutationOptions = Apollo.BaseMutationOptions<TaskDefinitionRemoveManyMutation, TaskDefinitionRemoveManyMutationVariables>;
export const TaskDefinitionAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskDefinitionAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskDefinition_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type TaskDefinitionAggregateMutationFn = Apollo.MutationFunction<TaskDefinitionAggregateMutation, TaskDefinitionAggregateMutationVariables>;

/**
 * __useTaskDefinitionAggregateMutation__
 *
 * To run a mutation, you first call `useTaskDefinitionAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskDefinitionAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskDefinitionAggregateMutation, { data, loading, error }] = useTaskDefinitionAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useTaskDefinitionAggregateMutation(baseOptions?: Apollo.MutationHookOptions<TaskDefinitionAggregateMutation, TaskDefinitionAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskDefinitionAggregateMutation, TaskDefinitionAggregateMutationVariables>(TaskDefinitionAggregateDocument, options);
      }
export type TaskDefinitionAggregateMutationHookResult = ReturnType<typeof useTaskDefinitionAggregateMutation>;
export type TaskDefinitionAggregateMutationResult = Apollo.MutationResult<TaskDefinitionAggregateMutation>;
export type TaskDefinitionAggregateMutationOptions = Apollo.BaseMutationOptions<TaskDefinitionAggregateMutation, TaskDefinitionAggregateMutationVariables>;
export const TaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Task"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFragment"}}]}}]}},...TaskFragmentFragmentDoc.definitions,...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions,...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTaskQuery__
 *
 * To run a query within a React component, call `useTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskQuery(baseOptions: Apollo.QueryHookOptions<TaskQuery, TaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
      }
export function useTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQuery, TaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
        }
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>;
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>;
export type TaskQueryResult = Apollo.QueryResult<TaskQuery, TaskQueryVariables>;
export const TaskFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFragment"}}]}}]}}]}},...TaskFragmentFragmentDoc.definitions,...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions,...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTaskFindQuery__
 *
 * To run a query within a React component, call `useTaskFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTaskFindQuery(baseOptions: Apollo.QueryHookOptions<TaskFindQuery, TaskFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFindQuery, TaskFindQueryVariables>(TaskFindDocument, options);
      }
export function useTaskFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFindQuery, TaskFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFindQuery, TaskFindQueryVariables>(TaskFindDocument, options);
        }
export type TaskFindQueryHookResult = ReturnType<typeof useTaskFindQuery>;
export type TaskFindLazyQueryHookResult = ReturnType<typeof useTaskFindLazyQuery>;
export type TaskFindQueryResult = Apollo.QueryResult<TaskFindQuery, TaskFindQueryVariables>;
export const TaskCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useTaskCountQuery__
 *
 * To run a query within a React component, call `useTaskCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTaskCountQuery(baseOptions?: Apollo.QueryHookOptions<TaskCountQuery, TaskCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskCountQuery, TaskCountQueryVariables>(TaskCountDocument, options);
      }
export function useTaskCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskCountQuery, TaskCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskCountQuery, TaskCountQueryVariables>(TaskCountDocument, options);
        }
export type TaskCountQueryHookResult = ReturnType<typeof useTaskCountQuery>;
export type TaskCountLazyQueryHookResult = ReturnType<typeof useTaskCountLazyQuery>;
export type TaskCountQueryResult = Apollo.QueryResult<TaskCountQuery, TaskCountQueryVariables>;
export const TaskQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useTaskQueryIdsQuery__
 *
 * To run a query within a React component, call `useTaskQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTaskQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<TaskQueryIdsQuery, TaskQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQueryIdsQuery, TaskQueryIdsQueryVariables>(TaskQueryIdsDocument, options);
      }
export function useTaskQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQueryIdsQuery, TaskQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQueryIdsQuery, TaskQueryIdsQueryVariables>(TaskQueryIdsDocument, options);
        }
export type TaskQueryIdsQueryHookResult = ReturnType<typeof useTaskQueryIdsQuery>;
export type TaskQueryIdsLazyQueryHookResult = ReturnType<typeof useTaskQueryIdsLazyQuery>;
export type TaskQueryIdsQueryResult = Apollo.QueryResult<TaskQueryIdsQuery, TaskQueryIdsQueryVariables>;
export const TaskUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFragment"}}]}}]}},...TaskFragmentFragmentDoc.definitions,...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions,...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TaskUpdateMutationFn = Apollo.MutationFunction<TaskUpdateMutation, TaskUpdateMutationVariables>;

/**
 * __useTaskUpdateMutation__
 *
 * To run a mutation, you first call `useTaskUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskUpdateMutation, { data, loading, error }] = useTaskUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTaskUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaskUpdateMutation, TaskUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskUpdateMutation, TaskUpdateMutationVariables>(TaskUpdateDocument, options);
      }
export type TaskUpdateMutationHookResult = ReturnType<typeof useTaskUpdateMutation>;
export type TaskUpdateMutationResult = Apollo.MutationResult<TaskUpdateMutation>;
export type TaskUpdateMutationOptions = Apollo.BaseMutationOptions<TaskUpdateMutation, TaskUpdateMutationVariables>;
export const TaskCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFragment"}}]}}]}},...TaskFragmentFragmentDoc.definitions,...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions,...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TaskCreateMutationFn = Apollo.MutationFunction<TaskCreateMutation, TaskCreateMutationVariables>;

/**
 * __useTaskCreateMutation__
 *
 * To run a mutation, you first call `useTaskCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskCreateMutation, { data, loading, error }] = useTaskCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTaskCreateMutation(baseOptions?: Apollo.MutationHookOptions<TaskCreateMutation, TaskCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskCreateMutation, TaskCreateMutationVariables>(TaskCreateDocument, options);
      }
export type TaskCreateMutationHookResult = ReturnType<typeof useTaskCreateMutation>;
export type TaskCreateMutationResult = Apollo.MutationResult<TaskCreateMutation>;
export type TaskCreateMutationOptions = Apollo.BaseMutationOptions<TaskCreateMutation, TaskCreateMutationVariables>;
export const TaskRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFragment"}}]}}]}},...TaskFragmentFragmentDoc.definitions,...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions,...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TaskRemoveMutationFn = Apollo.MutationFunction<TaskRemoveMutation, TaskRemoveMutationVariables>;

/**
 * __useTaskRemoveMutation__
 *
 * To run a mutation, you first call `useTaskRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskRemoveMutation, { data, loading, error }] = useTaskRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskRemoveMutation(baseOptions?: Apollo.MutationHookOptions<TaskRemoveMutation, TaskRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskRemoveMutation, TaskRemoveMutationVariables>(TaskRemoveDocument, options);
      }
export type TaskRemoveMutationHookResult = ReturnType<typeof useTaskRemoveMutation>;
export type TaskRemoveMutationResult = Apollo.MutationResult<TaskRemoveMutation>;
export type TaskRemoveMutationOptions = Apollo.BaseMutationOptions<TaskRemoveMutation, TaskRemoveMutationVariables>;
export const TaskRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type TaskRemoveManyMutationFn = Apollo.MutationFunction<TaskRemoveManyMutation, TaskRemoveManyMutationVariables>;

/**
 * __useTaskRemoveManyMutation__
 *
 * To run a mutation, you first call `useTaskRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskRemoveManyMutation, { data, loading, error }] = useTaskRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTaskRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<TaskRemoveManyMutation, TaskRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskRemoveManyMutation, TaskRemoveManyMutationVariables>(TaskRemoveManyDocument, options);
      }
export type TaskRemoveManyMutationHookResult = ReturnType<typeof useTaskRemoveManyMutation>;
export type TaskRemoveManyMutationResult = Apollo.MutationResult<TaskRemoveManyMutation>;
export type TaskRemoveManyMutationOptions = Apollo.BaseMutationOptions<TaskRemoveManyMutation, TaskRemoveManyMutationVariables>;
export const TaskAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type TaskAggregateMutationFn = Apollo.MutationFunction<TaskAggregateMutation, TaskAggregateMutationVariables>;

/**
 * __useTaskAggregateMutation__
 *
 * To run a mutation, you first call `useTaskAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskAggregateMutation, { data, loading, error }] = useTaskAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useTaskAggregateMutation(baseOptions?: Apollo.MutationHookOptions<TaskAggregateMutation, TaskAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskAggregateMutation, TaskAggregateMutationVariables>(TaskAggregateDocument, options);
      }
export type TaskAggregateMutationHookResult = ReturnType<typeof useTaskAggregateMutation>;
export type TaskAggregateMutationResult = Apollo.MutationResult<TaskAggregateMutation>;
export type TaskAggregateMutationOptions = Apollo.BaseMutationOptions<TaskAggregateMutation, TaskAggregateMutationVariables>;
export const TaxonomyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Taxonomy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Taxonomy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxonomyFragment"}}]}}]}},...TaxonomyFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTaxonomyQuery__
 *
 * To run a query within a React component, call `useTaxonomyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaxonomyQuery(baseOptions: Apollo.QueryHookOptions<TaxonomyQuery, TaxonomyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyQuery, TaxonomyQueryVariables>(TaxonomyDocument, options);
      }
export function useTaxonomyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyQuery, TaxonomyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyQuery, TaxonomyQueryVariables>(TaxonomyDocument, options);
        }
export type TaxonomyQueryHookResult = ReturnType<typeof useTaxonomyQuery>;
export type TaxonomyLazyQueryHookResult = ReturnType<typeof useTaxonomyLazyQuery>;
export type TaxonomyQueryResult = Apollo.QueryResult<TaxonomyQuery, TaxonomyQueryVariables>;
export const TaxonomyFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaxonomyFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Taxonomy_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxonomyFragment"}}]}}]}}]}},...TaxonomyFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTaxonomyFindQuery__
 *
 * To run a query within a React component, call `useTaxonomyFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTaxonomyFindQuery(baseOptions: Apollo.QueryHookOptions<TaxonomyFindQuery, TaxonomyFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyFindQuery, TaxonomyFindQueryVariables>(TaxonomyFindDocument, options);
      }
export function useTaxonomyFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyFindQuery, TaxonomyFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyFindQuery, TaxonomyFindQueryVariables>(TaxonomyFindDocument, options);
        }
export type TaxonomyFindQueryHookResult = ReturnType<typeof useTaxonomyFindQuery>;
export type TaxonomyFindLazyQueryHookResult = ReturnType<typeof useTaxonomyFindLazyQuery>;
export type TaxonomyFindQueryResult = Apollo.QueryResult<TaxonomyFindQuery, TaxonomyFindQueryVariables>;
export const TaxonomyCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaxonomyCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Taxonomy_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useTaxonomyCountQuery__
 *
 * To run a query within a React component, call `useTaxonomyCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTaxonomyCountQuery(baseOptions?: Apollo.QueryHookOptions<TaxonomyCountQuery, TaxonomyCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyCountQuery, TaxonomyCountQueryVariables>(TaxonomyCountDocument, options);
      }
export function useTaxonomyCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyCountQuery, TaxonomyCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyCountQuery, TaxonomyCountQueryVariables>(TaxonomyCountDocument, options);
        }
export type TaxonomyCountQueryHookResult = ReturnType<typeof useTaxonomyCountQuery>;
export type TaxonomyCountLazyQueryHookResult = ReturnType<typeof useTaxonomyCountLazyQuery>;
export type TaxonomyCountQueryResult = Apollo.QueryResult<TaxonomyCountQuery, TaxonomyCountQueryVariables>;
export const TaxonomyQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaxonomyQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Taxonomy_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useTaxonomyQueryIdsQuery__
 *
 * To run a query within a React component, call `useTaxonomyQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTaxonomyQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<TaxonomyQueryIdsQuery, TaxonomyQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyQueryIdsQuery, TaxonomyQueryIdsQueryVariables>(TaxonomyQueryIdsDocument, options);
      }
export function useTaxonomyQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyQueryIdsQuery, TaxonomyQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyQueryIdsQuery, TaxonomyQueryIdsQueryVariables>(TaxonomyQueryIdsDocument, options);
        }
export type TaxonomyQueryIdsQueryHookResult = ReturnType<typeof useTaxonomyQueryIdsQuery>;
export type TaxonomyQueryIdsLazyQueryHookResult = ReturnType<typeof useTaxonomyQueryIdsLazyQuery>;
export type TaxonomyQueryIdsQueryResult = Apollo.QueryResult<TaxonomyQueryIdsQuery, TaxonomyQueryIdsQueryVariables>;
export const TaxonomyUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaxonomyUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaxonomyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Taxonomy_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxonomyFragment"}}]}}]}},...TaxonomyFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TaxonomyUpdateMutationFn = Apollo.MutationFunction<TaxonomyUpdateMutation, TaxonomyUpdateMutationVariables>;

/**
 * __useTaxonomyUpdateMutation__
 *
 * To run a mutation, you first call `useTaxonomyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxonomyUpdateMutation, { data, loading, error }] = useTaxonomyUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTaxonomyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaxonomyUpdateMutation, TaxonomyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaxonomyUpdateMutation, TaxonomyUpdateMutationVariables>(TaxonomyUpdateDocument, options);
      }
export type TaxonomyUpdateMutationHookResult = ReturnType<typeof useTaxonomyUpdateMutation>;
export type TaxonomyUpdateMutationResult = Apollo.MutationResult<TaxonomyUpdateMutation>;
export type TaxonomyUpdateMutationOptions = Apollo.BaseMutationOptions<TaxonomyUpdateMutation, TaxonomyUpdateMutationVariables>;
export const TaxonomyCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaxonomyCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaxonomyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Taxonomy_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxonomyFragment"}}]}}]}},...TaxonomyFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TaxonomyCreateMutationFn = Apollo.MutationFunction<TaxonomyCreateMutation, TaxonomyCreateMutationVariables>;

/**
 * __useTaxonomyCreateMutation__
 *
 * To run a mutation, you first call `useTaxonomyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxonomyCreateMutation, { data, loading, error }] = useTaxonomyCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTaxonomyCreateMutation(baseOptions?: Apollo.MutationHookOptions<TaxonomyCreateMutation, TaxonomyCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaxonomyCreateMutation, TaxonomyCreateMutationVariables>(TaxonomyCreateDocument, options);
      }
export type TaxonomyCreateMutationHookResult = ReturnType<typeof useTaxonomyCreateMutation>;
export type TaxonomyCreateMutationResult = Apollo.MutationResult<TaxonomyCreateMutation>;
export type TaxonomyCreateMutationOptions = Apollo.BaseMutationOptions<TaxonomyCreateMutation, TaxonomyCreateMutationVariables>;
export const TaxonomyRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaxonomyRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Taxonomy_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxonomyFragment"}}]}}]}},...TaxonomyFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TaxonomyRemoveMutationFn = Apollo.MutationFunction<TaxonomyRemoveMutation, TaxonomyRemoveMutationVariables>;

/**
 * __useTaxonomyRemoveMutation__
 *
 * To run a mutation, you first call `useTaxonomyRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxonomyRemoveMutation, { data, loading, error }] = useTaxonomyRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaxonomyRemoveMutation(baseOptions?: Apollo.MutationHookOptions<TaxonomyRemoveMutation, TaxonomyRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaxonomyRemoveMutation, TaxonomyRemoveMutationVariables>(TaxonomyRemoveDocument, options);
      }
export type TaxonomyRemoveMutationHookResult = ReturnType<typeof useTaxonomyRemoveMutation>;
export type TaxonomyRemoveMutationResult = Apollo.MutationResult<TaxonomyRemoveMutation>;
export type TaxonomyRemoveMutationOptions = Apollo.BaseMutationOptions<TaxonomyRemoveMutation, TaxonomyRemoveMutationVariables>;
export const TaxonomyRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaxonomyRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Taxonomy_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type TaxonomyRemoveManyMutationFn = Apollo.MutationFunction<TaxonomyRemoveManyMutation, TaxonomyRemoveManyMutationVariables>;

/**
 * __useTaxonomyRemoveManyMutation__
 *
 * To run a mutation, you first call `useTaxonomyRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxonomyRemoveManyMutation, { data, loading, error }] = useTaxonomyRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTaxonomyRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<TaxonomyRemoveManyMutation, TaxonomyRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaxonomyRemoveManyMutation, TaxonomyRemoveManyMutationVariables>(TaxonomyRemoveManyDocument, options);
      }
export type TaxonomyRemoveManyMutationHookResult = ReturnType<typeof useTaxonomyRemoveManyMutation>;
export type TaxonomyRemoveManyMutationResult = Apollo.MutationResult<TaxonomyRemoveManyMutation>;
export type TaxonomyRemoveManyMutationOptions = Apollo.BaseMutationOptions<TaxonomyRemoveManyMutation, TaxonomyRemoveManyMutationVariables>;
export const TaxonomyAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaxonomyAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Taxonomy_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type TaxonomyAggregateMutationFn = Apollo.MutationFunction<TaxonomyAggregateMutation, TaxonomyAggregateMutationVariables>;

/**
 * __useTaxonomyAggregateMutation__
 *
 * To run a mutation, you first call `useTaxonomyAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxonomyAggregateMutation, { data, loading, error }] = useTaxonomyAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useTaxonomyAggregateMutation(baseOptions?: Apollo.MutationHookOptions<TaxonomyAggregateMutation, TaxonomyAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaxonomyAggregateMutation, TaxonomyAggregateMutationVariables>(TaxonomyAggregateDocument, options);
      }
export type TaxonomyAggregateMutationHookResult = ReturnType<typeof useTaxonomyAggregateMutation>;
export type TaxonomyAggregateMutationResult = Apollo.MutationResult<TaxonomyAggregateMutation>;
export type TaxonomyAggregateMutationOptions = Apollo.BaseMutationOptions<TaxonomyAggregateMutation, TaxonomyAggregateMutationVariables>;
export const TransformerExpressionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransformerExpression"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerExpression"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransformerExpressionFragment"}}]}}]}},...TransformerExpressionFragmentFragmentDoc.definitions,...ChangelogEntryStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTransformerExpressionQuery__
 *
 * To run a query within a React component, call `useTransformerExpressionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransformerExpressionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransformerExpressionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransformerExpressionQuery(baseOptions: Apollo.QueryHookOptions<TransformerExpressionQuery, TransformerExpressionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransformerExpressionQuery, TransformerExpressionQueryVariables>(TransformerExpressionDocument, options);
      }
export function useTransformerExpressionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransformerExpressionQuery, TransformerExpressionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransformerExpressionQuery, TransformerExpressionQueryVariables>(TransformerExpressionDocument, options);
        }
export type TransformerExpressionQueryHookResult = ReturnType<typeof useTransformerExpressionQuery>;
export type TransformerExpressionLazyQueryHookResult = ReturnType<typeof useTransformerExpressionLazyQuery>;
export type TransformerExpressionQueryResult = Apollo.QueryResult<TransformerExpressionQuery, TransformerExpressionQueryVariables>;
export const TransformerExpressionFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransformerExpressionFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerExpression_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransformerExpressionFragment"}}]}}]}}]}},...TransformerExpressionFragmentFragmentDoc.definitions,...ChangelogEntryStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTransformerExpressionFindQuery__
 *
 * To run a query within a React component, call `useTransformerExpressionFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransformerExpressionFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransformerExpressionFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTransformerExpressionFindQuery(baseOptions: Apollo.QueryHookOptions<TransformerExpressionFindQuery, TransformerExpressionFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransformerExpressionFindQuery, TransformerExpressionFindQueryVariables>(TransformerExpressionFindDocument, options);
      }
export function useTransformerExpressionFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransformerExpressionFindQuery, TransformerExpressionFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransformerExpressionFindQuery, TransformerExpressionFindQueryVariables>(TransformerExpressionFindDocument, options);
        }
export type TransformerExpressionFindQueryHookResult = ReturnType<typeof useTransformerExpressionFindQuery>;
export type TransformerExpressionFindLazyQueryHookResult = ReturnType<typeof useTransformerExpressionFindLazyQuery>;
export type TransformerExpressionFindQueryResult = Apollo.QueryResult<TransformerExpressionFindQuery, TransformerExpressionFindQueryVariables>;
export const TransformerExpressionCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransformerExpressionCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerExpression_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useTransformerExpressionCountQuery__
 *
 * To run a query within a React component, call `useTransformerExpressionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransformerExpressionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransformerExpressionCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTransformerExpressionCountQuery(baseOptions?: Apollo.QueryHookOptions<TransformerExpressionCountQuery, TransformerExpressionCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransformerExpressionCountQuery, TransformerExpressionCountQueryVariables>(TransformerExpressionCountDocument, options);
      }
export function useTransformerExpressionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransformerExpressionCountQuery, TransformerExpressionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransformerExpressionCountQuery, TransformerExpressionCountQueryVariables>(TransformerExpressionCountDocument, options);
        }
export type TransformerExpressionCountQueryHookResult = ReturnType<typeof useTransformerExpressionCountQuery>;
export type TransformerExpressionCountLazyQueryHookResult = ReturnType<typeof useTransformerExpressionCountLazyQuery>;
export type TransformerExpressionCountQueryResult = Apollo.QueryResult<TransformerExpressionCountQuery, TransformerExpressionCountQueryVariables>;
export const TransformerExpressionQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransformerExpressionQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerExpression_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useTransformerExpressionQueryIdsQuery__
 *
 * To run a query within a React component, call `useTransformerExpressionQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransformerExpressionQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransformerExpressionQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTransformerExpressionQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<TransformerExpressionQueryIdsQuery, TransformerExpressionQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransformerExpressionQueryIdsQuery, TransformerExpressionQueryIdsQueryVariables>(TransformerExpressionQueryIdsDocument, options);
      }
export function useTransformerExpressionQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransformerExpressionQueryIdsQuery, TransformerExpressionQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransformerExpressionQueryIdsQuery, TransformerExpressionQueryIdsQueryVariables>(TransformerExpressionQueryIdsDocument, options);
        }
export type TransformerExpressionQueryIdsQueryHookResult = ReturnType<typeof useTransformerExpressionQueryIdsQuery>;
export type TransformerExpressionQueryIdsLazyQueryHookResult = ReturnType<typeof useTransformerExpressionQueryIdsLazyQuery>;
export type TransformerExpressionQueryIdsQueryResult = Apollo.QueryResult<TransformerExpressionQueryIdsQuery, TransformerExpressionQueryIdsQueryVariables>;
export const TransformerExpressionUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransformerExpressionUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransformerExpressionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerExpression_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransformerExpressionFragment"}}]}}]}},...TransformerExpressionFragmentFragmentDoc.definitions,...ChangelogEntryStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TransformerExpressionUpdateMutationFn = Apollo.MutationFunction<TransformerExpressionUpdateMutation, TransformerExpressionUpdateMutationVariables>;

/**
 * __useTransformerExpressionUpdateMutation__
 *
 * To run a mutation, you first call `useTransformerExpressionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransformerExpressionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transformerExpressionUpdateMutation, { data, loading, error }] = useTransformerExpressionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTransformerExpressionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TransformerExpressionUpdateMutation, TransformerExpressionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransformerExpressionUpdateMutation, TransformerExpressionUpdateMutationVariables>(TransformerExpressionUpdateDocument, options);
      }
export type TransformerExpressionUpdateMutationHookResult = ReturnType<typeof useTransformerExpressionUpdateMutation>;
export type TransformerExpressionUpdateMutationResult = Apollo.MutationResult<TransformerExpressionUpdateMutation>;
export type TransformerExpressionUpdateMutationOptions = Apollo.BaseMutationOptions<TransformerExpressionUpdateMutation, TransformerExpressionUpdateMutationVariables>;
export const TransformerExpressionCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransformerExpressionCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransformerExpressionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerExpression_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransformerExpressionFragment"}}]}}]}},...TransformerExpressionFragmentFragmentDoc.definitions,...ChangelogEntryStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TransformerExpressionCreateMutationFn = Apollo.MutationFunction<TransformerExpressionCreateMutation, TransformerExpressionCreateMutationVariables>;

/**
 * __useTransformerExpressionCreateMutation__
 *
 * To run a mutation, you first call `useTransformerExpressionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransformerExpressionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transformerExpressionCreateMutation, { data, loading, error }] = useTransformerExpressionCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTransformerExpressionCreateMutation(baseOptions?: Apollo.MutationHookOptions<TransformerExpressionCreateMutation, TransformerExpressionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransformerExpressionCreateMutation, TransformerExpressionCreateMutationVariables>(TransformerExpressionCreateDocument, options);
      }
export type TransformerExpressionCreateMutationHookResult = ReturnType<typeof useTransformerExpressionCreateMutation>;
export type TransformerExpressionCreateMutationResult = Apollo.MutationResult<TransformerExpressionCreateMutation>;
export type TransformerExpressionCreateMutationOptions = Apollo.BaseMutationOptions<TransformerExpressionCreateMutation, TransformerExpressionCreateMutationVariables>;
export const TransformerExpressionRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransformerExpressionRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerExpression_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransformerExpressionFragment"}}]}}]}},...TransformerExpressionFragmentFragmentDoc.definitions,...ChangelogEntryStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TransformerExpressionRemoveMutationFn = Apollo.MutationFunction<TransformerExpressionRemoveMutation, TransformerExpressionRemoveMutationVariables>;

/**
 * __useTransformerExpressionRemoveMutation__
 *
 * To run a mutation, you first call `useTransformerExpressionRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransformerExpressionRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transformerExpressionRemoveMutation, { data, loading, error }] = useTransformerExpressionRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransformerExpressionRemoveMutation(baseOptions?: Apollo.MutationHookOptions<TransformerExpressionRemoveMutation, TransformerExpressionRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransformerExpressionRemoveMutation, TransformerExpressionRemoveMutationVariables>(TransformerExpressionRemoveDocument, options);
      }
export type TransformerExpressionRemoveMutationHookResult = ReturnType<typeof useTransformerExpressionRemoveMutation>;
export type TransformerExpressionRemoveMutationResult = Apollo.MutationResult<TransformerExpressionRemoveMutation>;
export type TransformerExpressionRemoveMutationOptions = Apollo.BaseMutationOptions<TransformerExpressionRemoveMutation, TransformerExpressionRemoveMutationVariables>;
export const TransformerExpressionRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransformerExpressionRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerExpression_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type TransformerExpressionRemoveManyMutationFn = Apollo.MutationFunction<TransformerExpressionRemoveManyMutation, TransformerExpressionRemoveManyMutationVariables>;

/**
 * __useTransformerExpressionRemoveManyMutation__
 *
 * To run a mutation, you first call `useTransformerExpressionRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransformerExpressionRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transformerExpressionRemoveManyMutation, { data, loading, error }] = useTransformerExpressionRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTransformerExpressionRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<TransformerExpressionRemoveManyMutation, TransformerExpressionRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransformerExpressionRemoveManyMutation, TransformerExpressionRemoveManyMutationVariables>(TransformerExpressionRemoveManyDocument, options);
      }
export type TransformerExpressionRemoveManyMutationHookResult = ReturnType<typeof useTransformerExpressionRemoveManyMutation>;
export type TransformerExpressionRemoveManyMutationResult = Apollo.MutationResult<TransformerExpressionRemoveManyMutation>;
export type TransformerExpressionRemoveManyMutationOptions = Apollo.BaseMutationOptions<TransformerExpressionRemoveManyMutation, TransformerExpressionRemoveManyMutationVariables>;
export const TransformerExpressionAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransformerExpressionAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerExpression_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type TransformerExpressionAggregateMutationFn = Apollo.MutationFunction<TransformerExpressionAggregateMutation, TransformerExpressionAggregateMutationVariables>;

/**
 * __useTransformerExpressionAggregateMutation__
 *
 * To run a mutation, you first call `useTransformerExpressionAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransformerExpressionAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transformerExpressionAggregateMutation, { data, loading, error }] = useTransformerExpressionAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useTransformerExpressionAggregateMutation(baseOptions?: Apollo.MutationHookOptions<TransformerExpressionAggregateMutation, TransformerExpressionAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransformerExpressionAggregateMutation, TransformerExpressionAggregateMutationVariables>(TransformerExpressionAggregateDocument, options);
      }
export type TransformerExpressionAggregateMutationHookResult = ReturnType<typeof useTransformerExpressionAggregateMutation>;
export type TransformerExpressionAggregateMutationResult = Apollo.MutationResult<TransformerExpressionAggregateMutation>;
export type TransformerExpressionAggregateMutationOptions = Apollo.BaseMutationOptions<TransformerExpressionAggregateMutation, TransformerExpressionAggregateMutationVariables>;
export const TransformerResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransformerResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransformerResourceFragment"}}]}}]}},...TransformerResourceFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTransformerResourceQuery__
 *
 * To run a query within a React component, call `useTransformerResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransformerResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransformerResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransformerResourceQuery(baseOptions: Apollo.QueryHookOptions<TransformerResourceQuery, TransformerResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransformerResourceQuery, TransformerResourceQueryVariables>(TransformerResourceDocument, options);
      }
export function useTransformerResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransformerResourceQuery, TransformerResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransformerResourceQuery, TransformerResourceQueryVariables>(TransformerResourceDocument, options);
        }
export type TransformerResourceQueryHookResult = ReturnType<typeof useTransformerResourceQuery>;
export type TransformerResourceLazyQueryHookResult = ReturnType<typeof useTransformerResourceLazyQuery>;
export type TransformerResourceQueryResult = Apollo.QueryResult<TransformerResourceQuery, TransformerResourceQueryVariables>;
export const TransformerResourceFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransformerResourceFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerResource_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransformerResourceFragment"}}]}}]}}]}},...TransformerResourceFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTransformerResourceFindQuery__
 *
 * To run a query within a React component, call `useTransformerResourceFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransformerResourceFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransformerResourceFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTransformerResourceFindQuery(baseOptions: Apollo.QueryHookOptions<TransformerResourceFindQuery, TransformerResourceFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransformerResourceFindQuery, TransformerResourceFindQueryVariables>(TransformerResourceFindDocument, options);
      }
export function useTransformerResourceFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransformerResourceFindQuery, TransformerResourceFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransformerResourceFindQuery, TransformerResourceFindQueryVariables>(TransformerResourceFindDocument, options);
        }
export type TransformerResourceFindQueryHookResult = ReturnType<typeof useTransformerResourceFindQuery>;
export type TransformerResourceFindLazyQueryHookResult = ReturnType<typeof useTransformerResourceFindLazyQuery>;
export type TransformerResourceFindQueryResult = Apollo.QueryResult<TransformerResourceFindQuery, TransformerResourceFindQueryVariables>;
export const TransformerResourceCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransformerResourceCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerResource_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useTransformerResourceCountQuery__
 *
 * To run a query within a React component, call `useTransformerResourceCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransformerResourceCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransformerResourceCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTransformerResourceCountQuery(baseOptions?: Apollo.QueryHookOptions<TransformerResourceCountQuery, TransformerResourceCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransformerResourceCountQuery, TransformerResourceCountQueryVariables>(TransformerResourceCountDocument, options);
      }
export function useTransformerResourceCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransformerResourceCountQuery, TransformerResourceCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransformerResourceCountQuery, TransformerResourceCountQueryVariables>(TransformerResourceCountDocument, options);
        }
export type TransformerResourceCountQueryHookResult = ReturnType<typeof useTransformerResourceCountQuery>;
export type TransformerResourceCountLazyQueryHookResult = ReturnType<typeof useTransformerResourceCountLazyQuery>;
export type TransformerResourceCountQueryResult = Apollo.QueryResult<TransformerResourceCountQuery, TransformerResourceCountQueryVariables>;
export const TransformerResourceQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransformerResourceQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerResource_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useTransformerResourceQueryIdsQuery__
 *
 * To run a query within a React component, call `useTransformerResourceQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransformerResourceQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransformerResourceQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTransformerResourceQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<TransformerResourceQueryIdsQuery, TransformerResourceQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransformerResourceQueryIdsQuery, TransformerResourceQueryIdsQueryVariables>(TransformerResourceQueryIdsDocument, options);
      }
export function useTransformerResourceQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransformerResourceQueryIdsQuery, TransformerResourceQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransformerResourceQueryIdsQuery, TransformerResourceQueryIdsQueryVariables>(TransformerResourceQueryIdsDocument, options);
        }
export type TransformerResourceQueryIdsQueryHookResult = ReturnType<typeof useTransformerResourceQueryIdsQuery>;
export type TransformerResourceQueryIdsLazyQueryHookResult = ReturnType<typeof useTransformerResourceQueryIdsLazyQuery>;
export type TransformerResourceQueryIdsQueryResult = Apollo.QueryResult<TransformerResourceQueryIdsQuery, TransformerResourceQueryIdsQueryVariables>;
export const TransformerResourceUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransformerResourceUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransformerResourceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerResource_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransformerResourceFragment"}}]}}]}},...TransformerResourceFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TransformerResourceUpdateMutationFn = Apollo.MutationFunction<TransformerResourceUpdateMutation, TransformerResourceUpdateMutationVariables>;

/**
 * __useTransformerResourceUpdateMutation__
 *
 * To run a mutation, you first call `useTransformerResourceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransformerResourceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transformerResourceUpdateMutation, { data, loading, error }] = useTransformerResourceUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTransformerResourceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TransformerResourceUpdateMutation, TransformerResourceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransformerResourceUpdateMutation, TransformerResourceUpdateMutationVariables>(TransformerResourceUpdateDocument, options);
      }
export type TransformerResourceUpdateMutationHookResult = ReturnType<typeof useTransformerResourceUpdateMutation>;
export type TransformerResourceUpdateMutationResult = Apollo.MutationResult<TransformerResourceUpdateMutation>;
export type TransformerResourceUpdateMutationOptions = Apollo.BaseMutationOptions<TransformerResourceUpdateMutation, TransformerResourceUpdateMutationVariables>;
export const TransformerResourceCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransformerResourceCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransformerResourceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerResource_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransformerResourceFragment"}}]}}]}},...TransformerResourceFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TransformerResourceCreateMutationFn = Apollo.MutationFunction<TransformerResourceCreateMutation, TransformerResourceCreateMutationVariables>;

/**
 * __useTransformerResourceCreateMutation__
 *
 * To run a mutation, you first call `useTransformerResourceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransformerResourceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transformerResourceCreateMutation, { data, loading, error }] = useTransformerResourceCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTransformerResourceCreateMutation(baseOptions?: Apollo.MutationHookOptions<TransformerResourceCreateMutation, TransformerResourceCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransformerResourceCreateMutation, TransformerResourceCreateMutationVariables>(TransformerResourceCreateDocument, options);
      }
export type TransformerResourceCreateMutationHookResult = ReturnType<typeof useTransformerResourceCreateMutation>;
export type TransformerResourceCreateMutationResult = Apollo.MutationResult<TransformerResourceCreateMutation>;
export type TransformerResourceCreateMutationOptions = Apollo.BaseMutationOptions<TransformerResourceCreateMutation, TransformerResourceCreateMutationVariables>;
export const TransformerResourceRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransformerResourceRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerResource_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransformerResourceFragment"}}]}}]}},...TransformerResourceFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TransformerResourceRemoveMutationFn = Apollo.MutationFunction<TransformerResourceRemoveMutation, TransformerResourceRemoveMutationVariables>;

/**
 * __useTransformerResourceRemoveMutation__
 *
 * To run a mutation, you first call `useTransformerResourceRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransformerResourceRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transformerResourceRemoveMutation, { data, loading, error }] = useTransformerResourceRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransformerResourceRemoveMutation(baseOptions?: Apollo.MutationHookOptions<TransformerResourceRemoveMutation, TransformerResourceRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransformerResourceRemoveMutation, TransformerResourceRemoveMutationVariables>(TransformerResourceRemoveDocument, options);
      }
export type TransformerResourceRemoveMutationHookResult = ReturnType<typeof useTransformerResourceRemoveMutation>;
export type TransformerResourceRemoveMutationResult = Apollo.MutationResult<TransformerResourceRemoveMutation>;
export type TransformerResourceRemoveMutationOptions = Apollo.BaseMutationOptions<TransformerResourceRemoveMutation, TransformerResourceRemoveMutationVariables>;
export const TransformerResourceRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransformerResourceRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerResource_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type TransformerResourceRemoveManyMutationFn = Apollo.MutationFunction<TransformerResourceRemoveManyMutation, TransformerResourceRemoveManyMutationVariables>;

/**
 * __useTransformerResourceRemoveManyMutation__
 *
 * To run a mutation, you first call `useTransformerResourceRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransformerResourceRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transformerResourceRemoveManyMutation, { data, loading, error }] = useTransformerResourceRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTransformerResourceRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<TransformerResourceRemoveManyMutation, TransformerResourceRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransformerResourceRemoveManyMutation, TransformerResourceRemoveManyMutationVariables>(TransformerResourceRemoveManyDocument, options);
      }
export type TransformerResourceRemoveManyMutationHookResult = ReturnType<typeof useTransformerResourceRemoveManyMutation>;
export type TransformerResourceRemoveManyMutationResult = Apollo.MutationResult<TransformerResourceRemoveManyMutation>;
export type TransformerResourceRemoveManyMutationOptions = Apollo.BaseMutationOptions<TransformerResourceRemoveManyMutation, TransformerResourceRemoveManyMutationVariables>;
export const TransformerResourceAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransformerResourceAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TransformerResource_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type TransformerResourceAggregateMutationFn = Apollo.MutationFunction<TransformerResourceAggregateMutation, TransformerResourceAggregateMutationVariables>;

/**
 * __useTransformerResourceAggregateMutation__
 *
 * To run a mutation, you first call `useTransformerResourceAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransformerResourceAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transformerResourceAggregateMutation, { data, loading, error }] = useTransformerResourceAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useTransformerResourceAggregateMutation(baseOptions?: Apollo.MutationHookOptions<TransformerResourceAggregateMutation, TransformerResourceAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransformerResourceAggregateMutation, TransformerResourceAggregateMutationVariables>(TransformerResourceAggregateDocument, options);
      }
export type TransformerResourceAggregateMutationHookResult = ReturnType<typeof useTransformerResourceAggregateMutation>;
export type TransformerResourceAggregateMutationResult = Apollo.MutationResult<TransformerResourceAggregateMutation>;
export type TransformerResourceAggregateMutationOptions = Apollo.BaseMutationOptions<TransformerResourceAggregateMutation, TransformerResourceAggregateMutationVariables>;
export const UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"User"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useUserFindQuery__
 *
 * To run a query within a React component, call `useUserFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useUserFindQuery(baseOptions: Apollo.QueryHookOptions<UserFindQuery, UserFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFindQuery, UserFindQueryVariables>(UserFindDocument, options);
      }
export function useUserFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFindQuery, UserFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFindQuery, UserFindQueryVariables>(UserFindDocument, options);
        }
export type UserFindQueryHookResult = ReturnType<typeof useUserFindQuery>;
export type UserFindLazyQueryHookResult = ReturnType<typeof useUserFindLazyQuery>;
export type UserFindQueryResult = Apollo.QueryResult<UserFindQuery, UserFindQueryVariables>;
export const UserCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useUserCountQuery__
 *
 * To run a query within a React component, call `useUserCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUserCountQuery(baseOptions?: Apollo.QueryHookOptions<UserCountQuery, UserCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCountQuery, UserCountQueryVariables>(UserCountDocument, options);
      }
export function useUserCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCountQuery, UserCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCountQuery, UserCountQueryVariables>(UserCountDocument, options);
        }
export type UserCountQueryHookResult = ReturnType<typeof useUserCountQuery>;
export type UserCountLazyQueryHookResult = ReturnType<typeof useUserCountLazyQuery>;
export type UserCountQueryResult = Apollo.QueryResult<UserCountQuery, UserCountQueryVariables>;
export const UserQueryIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserQueryIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User_queryIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useUserQueryIdsQuery__
 *
 * To run a query within a React component, call `useUserQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQueryIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUserQueryIdsQuery(baseOptions: Apollo.QueryHookOptions<UserQueryIdsQuery, UserQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQueryIdsQuery, UserQueryIdsQueryVariables>(UserQueryIdsDocument, options);
      }
export function useUserQueryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQueryIdsQuery, UserQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQueryIdsQuery, UserQueryIdsQueryVariables>(UserQueryIdsDocument, options);
        }
export type UserQueryIdsQueryHookResult = ReturnType<typeof useUserQueryIdsQuery>;
export type UserQueryIdsLazyQueryHookResult = ReturnType<typeof useUserQueryIdsLazyQuery>;
export type UserQueryIdsQueryResult = Apollo.QueryResult<UserQueryIdsQuery, UserQueryIdsQueryVariables>;
export const UserUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const UserCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type UserRemoveMutationFn = Apollo.MutationFunction<UserRemoveMutation, UserRemoveMutationVariables>;

/**
 * __useUserRemoveMutation__
 *
 * To run a mutation, you first call `useUserRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRemoveMutation, { data, loading, error }] = useUserRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserRemoveMutation(baseOptions?: Apollo.MutationHookOptions<UserRemoveMutation, UserRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRemoveMutation, UserRemoveMutationVariables>(UserRemoveDocument, options);
      }
export type UserRemoveMutationHookResult = ReturnType<typeof useUserRemoveMutation>;
export type UserRemoveMutationResult = Apollo.MutationResult<UserRemoveMutation>;
export type UserRemoveMutationOptions = Apollo.BaseMutationOptions<UserRemoveMutation, UserRemoveMutationVariables>;
export const UserRemoveManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserRemoveMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User_removeMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;
export type UserRemoveManyMutationFn = Apollo.MutationFunction<UserRemoveManyMutation, UserRemoveManyMutationVariables>;

/**
 * __useUserRemoveManyMutation__
 *
 * To run a mutation, you first call `useUserRemoveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRemoveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRemoveManyMutation, { data, loading, error }] = useUserRemoveManyMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUserRemoveManyMutation(baseOptions?: Apollo.MutationHookOptions<UserRemoveManyMutation, UserRemoveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRemoveManyMutation, UserRemoveManyMutationVariables>(UserRemoveManyDocument, options);
      }
export type UserRemoveManyMutationHookResult = ReturnType<typeof useUserRemoveManyMutation>;
export type UserRemoveManyMutationResult = Apollo.MutationResult<UserRemoveManyMutation>;
export type UserRemoveManyMutationOptions = Apollo.BaseMutationOptions<UserRemoveManyMutation, UserRemoveManyMutationVariables>;
export const UserAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}]}]}}]} as unknown as DocumentNode;
export type UserAggregateMutationFn = Apollo.MutationFunction<UserAggregateMutation, UserAggregateMutationVariables>;

/**
 * __useUserAggregateMutation__
 *
 * To run a mutation, you first call `useUserAggregateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAggregateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAggregateMutation, { data, loading, error }] = useUserAggregateMutation({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUserAggregateMutation(baseOptions?: Apollo.MutationHookOptions<UserAggregateMutation, UserAggregateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAggregateMutation, UserAggregateMutationVariables>(UserAggregateDocument, options);
      }
export type UserAggregateMutationHookResult = ReturnType<typeof useUserAggregateMutation>;
export type UserAggregateMutationResult = Apollo.MutationResult<UserAggregateMutation>;
export type UserAggregateMutationOptions = Apollo.BaseMutationOptions<UserAggregateMutation, UserAggregateMutationVariables>;
export const AcceptImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageProcessingQueueAcceptInput"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageProcessingQueueAcceptInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AcceptImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"imageProcessingQueueAcceptInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageProcessingQueueAcceptInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successfulSaves"}},{"kind":"Field","name":{"kind":"Name","value":"failedImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"failedImageId"}},{"kind":"Field","name":{"kind":"Name","value":"failureReason"}}]}}]}}]}}]} as unknown as DocumentNode;
export type AcceptImagesMutationFn = Apollo.MutationFunction<AcceptImagesMutation, AcceptImagesMutationVariables>;

/**
 * __useAcceptImagesMutation__
 *
 * To run a mutation, you first call `useAcceptImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptImagesMutation, { data, loading, error }] = useAcceptImagesMutation({
 *   variables: {
 *      imageProcessingQueueAcceptInput: // value for 'imageProcessingQueueAcceptInput'
 *   },
 * });
 */
export function useAcceptImagesMutation(baseOptions?: Apollo.MutationHookOptions<AcceptImagesMutation, AcceptImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptImagesMutation, AcceptImagesMutationVariables>(AcceptImagesDocument, options);
      }
export type AcceptImagesMutationHookResult = ReturnType<typeof useAcceptImagesMutation>;
export type AcceptImagesMutationResult = Apollo.MutationResult<AcceptImagesMutation>;
export type AcceptImagesMutationOptions = Apollo.BaseMutationOptions<AcceptImagesMutation, AcceptImagesMutationVariables>;
export const AddImageToProcessingQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddImageToProcessingQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addImageToProcessingQueueInput"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddImageToProcessingQueueInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddImageToProcessingQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addImageToProcessingQueueInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addImageToProcessingQueueInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successfulSaves"}},{"kind":"Field","name":{"kind":"Name","value":"failedImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"failedImageId"}},{"kind":"Field","name":{"kind":"Name","value":"failureReason"}}]}}]}}]}}]} as unknown as DocumentNode;
export type AddImageToProcessingQueueMutationFn = Apollo.MutationFunction<AddImageToProcessingQueueMutation, AddImageToProcessingQueueMutationVariables>;

/**
 * __useAddImageToProcessingQueueMutation__
 *
 * To run a mutation, you first call `useAddImageToProcessingQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddImageToProcessingQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addImageToProcessingQueueMutation, { data, loading, error }] = useAddImageToProcessingQueueMutation({
 *   variables: {
 *      addImageToProcessingQueueInput: // value for 'addImageToProcessingQueueInput'
 *   },
 * });
 */
export function useAddImageToProcessingQueueMutation(baseOptions?: Apollo.MutationHookOptions<AddImageToProcessingQueueMutation, AddImageToProcessingQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddImageToProcessingQueueMutation, AddImageToProcessingQueueMutationVariables>(AddImageToProcessingQueueDocument, options);
      }
export type AddImageToProcessingQueueMutationHookResult = ReturnType<typeof useAddImageToProcessingQueueMutation>;
export type AddImageToProcessingQueueMutationResult = Apollo.MutationResult<AddImageToProcessingQueueMutation>;
export type AddImageToProcessingQueueMutationOptions = Apollo.BaseMutationOptions<AddImageToProcessingQueueMutation, AddImageToProcessingQueueMutationVariables>;
export const AttributeSalesAssessmentRunDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AttributeSalesAssessmentRun"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"builderBatchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportRunId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AttributeSalesAssessmentRun"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"builderBatchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"builderBatchId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportRunId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportRunId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"executionId"}},{"kind":"Field","name":{"kind":"Name","value":"scriptLogsUrl"}}]}}]}}]} as unknown as DocumentNode;
export type AttributeSalesAssessmentRunMutationFn = Apollo.MutationFunction<AttributeSalesAssessmentRunMutation, AttributeSalesAssessmentRunMutationVariables>;

/**
 * __useAttributeSalesAssessmentRunMutation__
 *
 * To run a mutation, you first call `useAttributeSalesAssessmentRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttributeSalesAssessmentRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attributeSalesAssessmentRunMutation, { data, loading, error }] = useAttributeSalesAssessmentRunMutation({
 *   variables: {
 *      builderBatchId: // value for 'builderBatchId'
 *      reportRunId: // value for 'reportRunId'
 *   },
 * });
 */
export function useAttributeSalesAssessmentRunMutation(baseOptions?: Apollo.MutationHookOptions<AttributeSalesAssessmentRunMutation, AttributeSalesAssessmentRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttributeSalesAssessmentRunMutation, AttributeSalesAssessmentRunMutationVariables>(AttributeSalesAssessmentRunDocument, options);
      }
export type AttributeSalesAssessmentRunMutationHookResult = ReturnType<typeof useAttributeSalesAssessmentRunMutation>;
export type AttributeSalesAssessmentRunMutationResult = Apollo.MutationResult<AttributeSalesAssessmentRunMutation>;
export type AttributeSalesAssessmentRunMutationOptions = Apollo.BaseMutationOptions<AttributeSalesAssessmentRunMutation, AttributeSalesAssessmentRunMutationVariables>;
export const BrandReview_UpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BrandReview_update"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BrandReview_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"opsReview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewStatus"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}},{"kind":"Field","name":{"kind":"Name","value":"survivingBrand"}}]}}]}}]}}]} as unknown as DocumentNode;
export type BrandReview_UpdateMutationFn = Apollo.MutationFunction<BrandReview_UpdateMutation, BrandReview_UpdateMutationVariables>;

/**
 * __useBrandReview_UpdateMutation__
 *
 * To run a mutation, you first call `useBrandReview_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandReview_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandReviewUpdateMutation, { data, loading, error }] = useBrandReview_UpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBrandReview_UpdateMutation(baseOptions?: Apollo.MutationHookOptions<BrandReview_UpdateMutation, BrandReview_UpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandReview_UpdateMutation, BrandReview_UpdateMutationVariables>(BrandReview_UpdateDocument, options);
      }
export type BrandReview_UpdateMutationHookResult = ReturnType<typeof useBrandReview_UpdateMutation>;
export type BrandReview_UpdateMutationResult = Apollo.MutationResult<BrandReview_UpdateMutation>;
export type BrandReview_UpdateMutationOptions = Apollo.BaseMutationOptions<BrandReview_UpdateMutation, BrandReview_UpdateMutationVariables>;
export const ClientTrackerValue_CreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClientTrackerValue_create"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientTrackerValueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientTrackerValue_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export type ClientTrackerValue_CreateMutationFn = Apollo.MutationFunction<ClientTrackerValue_CreateMutation, ClientTrackerValue_CreateMutationVariables>;

/**
 * __useClientTrackerValue_CreateMutation__
 *
 * To run a mutation, you first call `useClientTrackerValue_CreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientTrackerValue_CreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientTrackerValueCreateMutation, { data, loading, error }] = useClientTrackerValue_CreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useClientTrackerValue_CreateMutation(baseOptions?: Apollo.MutationHookOptions<ClientTrackerValue_CreateMutation, ClientTrackerValue_CreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClientTrackerValue_CreateMutation, ClientTrackerValue_CreateMutationVariables>(ClientTrackerValue_CreateDocument, options);
      }
export type ClientTrackerValue_CreateMutationHookResult = ReturnType<typeof useClientTrackerValue_CreateMutation>;
export type ClientTrackerValue_CreateMutationResult = Apollo.MutationResult<ClientTrackerValue_CreateMutation>;
export type ClientTrackerValue_CreateMutationOptions = Apollo.BaseMutationOptions<ClientTrackerValue_CreateMutation, ClientTrackerValue_CreateMutationVariables>;
export const ClientTrackerValue_UpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClientTrackerValue_update"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientTrackerValueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientTrackerValue_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export type ClientTrackerValue_UpdateMutationFn = Apollo.MutationFunction<ClientTrackerValue_UpdateMutation, ClientTrackerValue_UpdateMutationVariables>;

/**
 * __useClientTrackerValue_UpdateMutation__
 *
 * To run a mutation, you first call `useClientTrackerValue_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientTrackerValue_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientTrackerValueUpdateMutation, { data, loading, error }] = useClientTrackerValue_UpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useClientTrackerValue_UpdateMutation(baseOptions?: Apollo.MutationHookOptions<ClientTrackerValue_UpdateMutation, ClientTrackerValue_UpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClientTrackerValue_UpdateMutation, ClientTrackerValue_UpdateMutationVariables>(ClientTrackerValue_UpdateDocument, options);
      }
export type ClientTrackerValue_UpdateMutationHookResult = ReturnType<typeof useClientTrackerValue_UpdateMutation>;
export type ClientTrackerValue_UpdateMutationResult = Apollo.MutationResult<ClientTrackerValue_UpdateMutation>;
export type ClientTrackerValue_UpdateMutationOptions = Apollo.BaseMutationOptions<ClientTrackerValue_UpdateMutation, ClientTrackerValue_UpdateMutationVariables>;
export const ClientTrackerValue_UpsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClientTrackerValue_upsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientTrackerValueUpsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientTrackerValue_upsert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode;
export type ClientTrackerValue_UpsertMutationFn = Apollo.MutationFunction<ClientTrackerValue_UpsertMutation, ClientTrackerValue_UpsertMutationVariables>;

/**
 * __useClientTrackerValue_UpsertMutation__
 *
 * To run a mutation, you first call `useClientTrackerValue_UpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientTrackerValue_UpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientTrackerValueUpsertMutation, { data, loading, error }] = useClientTrackerValue_UpsertMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useClientTrackerValue_UpsertMutation(baseOptions?: Apollo.MutationHookOptions<ClientTrackerValue_UpsertMutation, ClientTrackerValue_UpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClientTrackerValue_UpsertMutation, ClientTrackerValue_UpsertMutationVariables>(ClientTrackerValue_UpsertDocument, options);
      }
export type ClientTrackerValue_UpsertMutationHookResult = ReturnType<typeof useClientTrackerValue_UpsertMutation>;
export type ClientTrackerValue_UpsertMutationResult = Apollo.MutationResult<ClientTrackerValue_UpsertMutation>;
export type ClientTrackerValue_UpsertMutationOptions = Apollo.BaseMutationOptions<ClientTrackerValue_UpsertMutation, ClientTrackerValue_UpsertMutationVariables>;
export const CreateAdminTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAdminToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreateAdminToken"}}]}}]} as unknown as DocumentNode;
export type CreateAdminTokenMutationFn = Apollo.MutationFunction<CreateAdminTokenMutation, CreateAdminTokenMutationVariables>;

/**
 * __useCreateAdminTokenMutation__
 *
 * To run a mutation, you first call `useCreateAdminTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminTokenMutation, { data, loading, error }] = useCreateAdminTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateAdminTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminTokenMutation, CreateAdminTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminTokenMutation, CreateAdminTokenMutationVariables>(CreateAdminTokenDocument, options);
      }
export type CreateAdminTokenMutationHookResult = ReturnType<typeof useCreateAdminTokenMutation>;
export type CreateAdminTokenMutationResult = Apollo.MutationResult<CreateAdminTokenMutation>;
export type CreateAdminTokenMutationOptions = Apollo.BaseMutationOptions<CreateAdminTokenMutation, CreateAdminTokenMutationVariables>;
export const DigitizationGrantUserAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DigitizationGrantUserAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domainId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Digitization_grantUserAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"domainId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domainId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
export type DigitizationGrantUserAccessMutationFn = Apollo.MutationFunction<DigitizationGrantUserAccessMutation, DigitizationGrantUserAccessMutationVariables>;

/**
 * __useDigitizationGrantUserAccessMutation__
 *
 * To run a mutation, you first call `useDigitizationGrantUserAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDigitizationGrantUserAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [digitizationGrantUserAccessMutation, { data, loading, error }] = useDigitizationGrantUserAccessMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDigitizationGrantUserAccessMutation(baseOptions?: Apollo.MutationHookOptions<DigitizationGrantUserAccessMutation, DigitizationGrantUserAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DigitizationGrantUserAccessMutation, DigitizationGrantUserAccessMutationVariables>(DigitizationGrantUserAccessDocument, options);
      }
export type DigitizationGrantUserAccessMutationHookResult = ReturnType<typeof useDigitizationGrantUserAccessMutation>;
export type DigitizationGrantUserAccessMutationResult = Apollo.MutationResult<DigitizationGrantUserAccessMutation>;
export type DigitizationGrantUserAccessMutationOptions = Apollo.BaseMutationOptions<DigitizationGrantUserAccessMutation, DigitizationGrantUserAccessMutationVariables>;
export const FeatureFlags_SetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FeatureFlags_set"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flags"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureFlags_set_flagInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureFlags_set"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"flags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flags"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}}]}}]}}]} as unknown as DocumentNode;
export type FeatureFlags_SetMutationFn = Apollo.MutationFunction<FeatureFlags_SetMutation, FeatureFlags_SetMutationVariables>;

/**
 * __useFeatureFlags_SetMutation__
 *
 * To run a mutation, you first call `useFeatureFlags_SetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlags_SetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureFlagsSetMutation, { data, loading, error }] = useFeatureFlags_SetMutation({
 *   variables: {
 *      flags: // value for 'flags'
 *   },
 * });
 */
export function useFeatureFlags_SetMutation(baseOptions?: Apollo.MutationHookOptions<FeatureFlags_SetMutation, FeatureFlags_SetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeatureFlags_SetMutation, FeatureFlags_SetMutationVariables>(FeatureFlags_SetDocument, options);
      }
export type FeatureFlags_SetMutationHookResult = ReturnType<typeof useFeatureFlags_SetMutation>;
export type FeatureFlags_SetMutationResult = Apollo.MutationResult<FeatureFlags_SetMutation>;
export type FeatureFlags_SetMutationOptions = Apollo.BaseMutationOptions<FeatureFlags_SetMutation, FeatureFlags_SetMutationVariables>;
export const HierarchyMapping_CreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HierarchyMapping_create"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyMappingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"HierarchyMapping_create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingFragment"}}]}}]}},...HierarchyMappingFragmentFragmentDoc.definitions,...TaxonomyFragmentFragmentDoc.definitions,...HierarchyMappingRuleFragmentDoc.definitions,...HierarchyMappingLookupOptionFragmentDoc.definitions,...HierarchyMappingConditionFragmentDoc.definitions,...HierarchyMappingChildRuleFragmentDoc.definitions]} as unknown as DocumentNode;
export type HierarchyMapping_CreateMutationFn = Apollo.MutationFunction<HierarchyMapping_CreateMutation, HierarchyMapping_CreateMutationVariables>;

/**
 * __useHierarchyMapping_CreateMutation__
 *
 * To run a mutation, you first call `useHierarchyMapping_CreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHierarchyMapping_CreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hierarchyMappingCreateMutation, { data, loading, error }] = useHierarchyMapping_CreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useHierarchyMapping_CreateMutation(baseOptions?: Apollo.MutationHookOptions<HierarchyMapping_CreateMutation, HierarchyMapping_CreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HierarchyMapping_CreateMutation, HierarchyMapping_CreateMutationVariables>(HierarchyMapping_CreateDocument, options);
      }
export type HierarchyMapping_CreateMutationHookResult = ReturnType<typeof useHierarchyMapping_CreateMutation>;
export type HierarchyMapping_CreateMutationResult = Apollo.MutationResult<HierarchyMapping_CreateMutation>;
export type HierarchyMapping_CreateMutationOptions = Apollo.BaseMutationOptions<HierarchyMapping_CreateMutation, HierarchyMapping_CreateMutationVariables>;
export const HierarchyMapping_RemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HierarchyMapping_remove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"HierarchyMapping_remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"circanaKeyCat"}}]}}]}}]} as unknown as DocumentNode;
export type HierarchyMapping_RemoveMutationFn = Apollo.MutationFunction<HierarchyMapping_RemoveMutation, HierarchyMapping_RemoveMutationVariables>;

/**
 * __useHierarchyMapping_RemoveMutation__
 *
 * To run a mutation, you first call `useHierarchyMapping_RemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHierarchyMapping_RemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hierarchyMappingRemoveMutation, { data, loading, error }] = useHierarchyMapping_RemoveMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useHierarchyMapping_RemoveMutation(baseOptions?: Apollo.MutationHookOptions<HierarchyMapping_RemoveMutation, HierarchyMapping_RemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HierarchyMapping_RemoveMutation, HierarchyMapping_RemoveMutationVariables>(HierarchyMapping_RemoveDocument, options);
      }
export type HierarchyMapping_RemoveMutationHookResult = ReturnType<typeof useHierarchyMapping_RemoveMutation>;
export type HierarchyMapping_RemoveMutationResult = Apollo.MutationResult<HierarchyMapping_RemoveMutation>;
export type HierarchyMapping_RemoveMutationOptions = Apollo.BaseMutationOptions<HierarchyMapping_RemoveMutation, HierarchyMapping_RemoveMutationVariables>;
export const HierarchyMapping_UpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HierarchyMapping_update"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyMappingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"HierarchyMapping_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingFragment"}}]}}]}},...HierarchyMappingFragmentFragmentDoc.definitions,...TaxonomyFragmentFragmentDoc.definitions,...HierarchyMappingRuleFragmentDoc.definitions,...HierarchyMappingLookupOptionFragmentDoc.definitions,...HierarchyMappingConditionFragmentDoc.definitions,...HierarchyMappingChildRuleFragmentDoc.definitions]} as unknown as DocumentNode;
export type HierarchyMapping_UpdateMutationFn = Apollo.MutationFunction<HierarchyMapping_UpdateMutation, HierarchyMapping_UpdateMutationVariables>;

/**
 * __useHierarchyMapping_UpdateMutation__
 *
 * To run a mutation, you first call `useHierarchyMapping_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHierarchyMapping_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hierarchyMappingUpdateMutation, { data, loading, error }] = useHierarchyMapping_UpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useHierarchyMapping_UpdateMutation(baseOptions?: Apollo.MutationHookOptions<HierarchyMapping_UpdateMutation, HierarchyMapping_UpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HierarchyMapping_UpdateMutation, HierarchyMapping_UpdateMutationVariables>(HierarchyMapping_UpdateDocument, options);
      }
export type HierarchyMapping_UpdateMutationHookResult = ReturnType<typeof useHierarchyMapping_UpdateMutation>;
export type HierarchyMapping_UpdateMutationResult = Apollo.MutationResult<HierarchyMapping_UpdateMutation>;
export type HierarchyMapping_UpdateMutationOptions = Apollo.BaseMutationOptions<HierarchyMapping_UpdateMutation, HierarchyMapping_UpdateMutationVariables>;
export const ModelAddTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ModelAddTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelNameEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModelAddTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matched"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}}]}}]}}]} as unknown as DocumentNode;
export type ModelAddTagMutationFn = Apollo.MutationFunction<ModelAddTagMutation, ModelAddTagMutationVariables>;

/**
 * __useModelAddTagMutation__
 *
 * To run a mutation, you first call `useModelAddTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModelAddTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modelAddTagMutation, { data, loading, error }] = useModelAddTagMutation({
 *   variables: {
 *      model: // value for 'model'
 *      ids: // value for 'ids'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useModelAddTagMutation(baseOptions?: Apollo.MutationHookOptions<ModelAddTagMutation, ModelAddTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModelAddTagMutation, ModelAddTagMutationVariables>(ModelAddTagDocument, options);
      }
export type ModelAddTagMutationHookResult = ReturnType<typeof useModelAddTagMutation>;
export type ModelAddTagMutationResult = Apollo.MutationResult<ModelAddTagMutation>;
export type ModelAddTagMutationOptions = Apollo.BaseMutationOptions<ModelAddTagMutation, ModelAddTagMutationVariables>;
export const ModelRemoveTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ModelRemoveTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelNameEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModelRemoveTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matched"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}}]}}]}}]} as unknown as DocumentNode;
export type ModelRemoveTagMutationFn = Apollo.MutationFunction<ModelRemoveTagMutation, ModelRemoveTagMutationVariables>;

/**
 * __useModelRemoveTagMutation__
 *
 * To run a mutation, you first call `useModelRemoveTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModelRemoveTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modelRemoveTagMutation, { data, loading, error }] = useModelRemoveTagMutation({
 *   variables: {
 *      model: // value for 'model'
 *      ids: // value for 'ids'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useModelRemoveTagMutation(baseOptions?: Apollo.MutationHookOptions<ModelRemoveTagMutation, ModelRemoveTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModelRemoveTagMutation, ModelRemoveTagMutationVariables>(ModelRemoveTagDocument, options);
      }
export type ModelRemoveTagMutationHookResult = ReturnType<typeof useModelRemoveTagMutation>;
export type ModelRemoveTagMutationResult = Apollo.MutationResult<ModelRemoveTagMutation>;
export type ModelRemoveTagMutationOptions = Apollo.BaseMutationOptions<ModelRemoveTagMutation, ModelRemoveTagMutationVariables>;
export const ModelUpdateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ModelUpdateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelNameEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModelUpdateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode;
export type ModelUpdateByIdMutationFn = Apollo.MutationFunction<ModelUpdateByIdMutation, ModelUpdateByIdMutationVariables>;

/**
 * __useModelUpdateByIdMutation__
 *
 * To run a mutation, you first call `useModelUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModelUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modelUpdateByIdMutation, { data, loading, error }] = useModelUpdateByIdMutation({
 *   variables: {
 *      model: // value for 'model'
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useModelUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ModelUpdateByIdMutation, ModelUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModelUpdateByIdMutation, ModelUpdateByIdMutationVariables>(ModelUpdateByIdDocument, options);
      }
export type ModelUpdateByIdMutationHookResult = ReturnType<typeof useModelUpdateByIdMutation>;
export type ModelUpdateByIdMutationResult = Apollo.MutationResult<ModelUpdateByIdMutation>;
export type ModelUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ModelUpdateByIdMutation, ModelUpdateByIdMutationVariables>;
export const PredictionOverride_SaveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PredictionOverride_save"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PredictionOverrideSaveInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PredictionOverride_save"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"savedCount"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cleansedDataId"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}},{"kind":"Field","name":{"kind":"Name","value":"attributeType"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode;
export type PredictionOverride_SaveMutationFn = Apollo.MutationFunction<PredictionOverride_SaveMutation, PredictionOverride_SaveMutationVariables>;

/**
 * __usePredictionOverride_SaveMutation__
 *
 * To run a mutation, you first call `usePredictionOverride_SaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePredictionOverride_SaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [predictionOverrideSaveMutation, { data, loading, error }] = usePredictionOverride_SaveMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePredictionOverride_SaveMutation(baseOptions?: Apollo.MutationHookOptions<PredictionOverride_SaveMutation, PredictionOverride_SaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PredictionOverride_SaveMutation, PredictionOverride_SaveMutationVariables>(PredictionOverride_SaveDocument, options);
      }
export type PredictionOverride_SaveMutationHookResult = ReturnType<typeof usePredictionOverride_SaveMutation>;
export type PredictionOverride_SaveMutationResult = Apollo.MutationResult<PredictionOverride_SaveMutation>;
export type PredictionOverride_SaveMutationOptions = Apollo.BaseMutationOptions<PredictionOverride_SaveMutation, PredictionOverride_SaveMutationVariables>;
export const Pv2IngredientSetReviewStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Pv2IngredientSetReviewStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IngredientReviewStatusEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2IngredientSetReviewStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}]}}]} as unknown as DocumentNode;
export type Pv2IngredientSetReviewStatusMutationFn = Apollo.MutationFunction<Pv2IngredientSetReviewStatusMutation, Pv2IngredientSetReviewStatusMutationVariables>;

/**
 * __usePv2IngredientSetReviewStatusMutation__
 *
 * To run a mutation, you first call `usePv2IngredientSetReviewStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePv2IngredientSetReviewStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pv2IngredientSetReviewStatusMutation, { data, loading, error }] = usePv2IngredientSetReviewStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function usePv2IngredientSetReviewStatusMutation(baseOptions?: Apollo.MutationHookOptions<Pv2IngredientSetReviewStatusMutation, Pv2IngredientSetReviewStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Pv2IngredientSetReviewStatusMutation, Pv2IngredientSetReviewStatusMutationVariables>(Pv2IngredientSetReviewStatusDocument, options);
      }
export type Pv2IngredientSetReviewStatusMutationHookResult = ReturnType<typeof usePv2IngredientSetReviewStatusMutation>;
export type Pv2IngredientSetReviewStatusMutationResult = Apollo.MutationResult<Pv2IngredientSetReviewStatusMutation>;
export type Pv2IngredientSetReviewStatusMutationOptions = Apollo.BaseMutationOptions<Pv2IngredientSetReviewStatusMutation, Pv2IngredientSetReviewStatusMutationVariables>;
export const QcSelfServeRunAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"QcSelfServeRunAnalysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"QCSelfServeRunAnalysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"executionId"}},{"kind":"Field","name":{"kind":"Name","value":"scriptLogsUrl"}}]}}]}}]} as unknown as DocumentNode;
export type QcSelfServeRunAnalysisMutationFn = Apollo.MutationFunction<QcSelfServeRunAnalysisMutation, QcSelfServeRunAnalysisMutationVariables>;

/**
 * __useQcSelfServeRunAnalysisMutation__
 *
 * To run a mutation, you first call `useQcSelfServeRunAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQcSelfServeRunAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [qcSelfServeRunAnalysisMutation, { data, loading, error }] = useQcSelfServeRunAnalysisMutation({
 *   variables: {
 *   },
 * });
 */
export function useQcSelfServeRunAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<QcSelfServeRunAnalysisMutation, QcSelfServeRunAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QcSelfServeRunAnalysisMutation, QcSelfServeRunAnalysisMutationVariables>(QcSelfServeRunAnalysisDocument, options);
      }
export type QcSelfServeRunAnalysisMutationHookResult = ReturnType<typeof useQcSelfServeRunAnalysisMutation>;
export type QcSelfServeRunAnalysisMutationResult = Apollo.MutationResult<QcSelfServeRunAnalysisMutation>;
export type QcSelfServeRunAnalysisMutationOptions = Apollo.BaseMutationOptions<QcSelfServeRunAnalysisMutation, QcSelfServeRunAnalysisMutationVariables>;
export const RejectImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rejectionReason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageRejectionReasonEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processingPriority"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RejectImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"imageIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"rejectionReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rejectionReason"}}},{"kind":"Argument","name":{"kind":"Name","value":"processingPriority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processingPriority"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successfulSaves"}},{"kind":"Field","name":{"kind":"Name","value":"failedImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"failedImageId"}},{"kind":"Field","name":{"kind":"Name","value":"failureReason"}}]}}]}}]}}]} as unknown as DocumentNode;
export type RejectImagesMutationFn = Apollo.MutationFunction<RejectImagesMutation, RejectImagesMutationVariables>;

/**
 * __useRejectImagesMutation__
 *
 * To run a mutation, you first call `useRejectImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectImagesMutation, { data, loading, error }] = useRejectImagesMutation({
 *   variables: {
 *      imageIds: // value for 'imageIds'
 *      rejectionReason: // value for 'rejectionReason'
 *      processingPriority: // value for 'processingPriority'
 *   },
 * });
 */
export function useRejectImagesMutation(baseOptions?: Apollo.MutationHookOptions<RejectImagesMutation, RejectImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectImagesMutation, RejectImagesMutationVariables>(RejectImagesDocument, options);
      }
export type RejectImagesMutationHookResult = ReturnType<typeof useRejectImagesMutation>;
export type RejectImagesMutationResult = Apollo.MutationResult<RejectImagesMutation>;
export type RejectImagesMutationOptions = Apollo.BaseMutationOptions<RejectImagesMutation, RejectImagesMutationVariables>;
export const RestartServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestartService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceNameEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RestartService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"serviceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceName"}}}]}]}}]} as unknown as DocumentNode;
export type RestartServiceMutationFn = Apollo.MutationFunction<RestartServiceMutation, RestartServiceMutationVariables>;

/**
 * __useRestartServiceMutation__
 *
 * To run a mutation, you first call `useRestartServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartServiceMutation, { data, loading, error }] = useRestartServiceMutation({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useRestartServiceMutation(baseOptions?: Apollo.MutationHookOptions<RestartServiceMutation, RestartServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestartServiceMutation, RestartServiceMutationVariables>(RestartServiceDocument, options);
      }
export type RestartServiceMutationHookResult = ReturnType<typeof useRestartServiceMutation>;
export type RestartServiceMutationResult = Apollo.MutationResult<RestartServiceMutation>;
export type RestartServiceMutationOptions = Apollo.BaseMutationOptions<RestartServiceMutation, RestartServiceMutationVariables>;
export const RunScriptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RunScript"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scriptName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScriptKey"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scriptArgs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"runId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RunScript"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"scriptName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scriptName"}}},{"kind":"Argument","name":{"kind":"Name","value":"scriptArgs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scriptArgs"}}},{"kind":"Argument","name":{"kind":"Name","value":"runId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"runId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"executionId"}},{"kind":"Field","name":{"kind":"Name","value":"scriptLogsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode;
export type RunScriptMutationFn = Apollo.MutationFunction<RunScriptMutation, RunScriptMutationVariables>;

/**
 * __useRunScriptMutation__
 *
 * To run a mutation, you first call `useRunScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runScriptMutation, { data, loading, error }] = useRunScriptMutation({
 *   variables: {
 *      scriptName: // value for 'scriptName'
 *      scriptArgs: // value for 'scriptArgs'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useRunScriptMutation(baseOptions?: Apollo.MutationHookOptions<RunScriptMutation, RunScriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunScriptMutation, RunScriptMutationVariables>(RunScriptDocument, options);
      }
export type RunScriptMutationHookResult = ReturnType<typeof useRunScriptMutation>;
export type RunScriptMutationResult = Apollo.MutationResult<RunScriptMutation>;
export type RunScriptMutationOptions = Apollo.BaseMutationOptions<RunScriptMutation, RunScriptMutationVariables>;
export const TaskAssignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskAssign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unassign"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task_assign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"unassign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unassign"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFragment"}}]}}]}},...TaskFragmentFragmentDoc.definitions,...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions,...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TaskAssignMutationFn = Apollo.MutationFunction<TaskAssignMutation, TaskAssignMutationVariables>;

/**
 * __useTaskAssignMutation__
 *
 * To run a mutation, you first call `useTaskAssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskAssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskAssignMutation, { data, loading, error }] = useTaskAssignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      unassign: // value for 'unassign'
 *   },
 * });
 */
export function useTaskAssignMutation(baseOptions?: Apollo.MutationHookOptions<TaskAssignMutation, TaskAssignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskAssignMutation, TaskAssignMutationVariables>(TaskAssignDocument, options);
      }
export type TaskAssignMutationHookResult = ReturnType<typeof useTaskAssignMutation>;
export type TaskAssignMutationResult = Apollo.MutationResult<TaskAssignMutation>;
export type TaskAssignMutationOptions = Apollo.BaseMutationOptions<TaskAssignMutation, TaskAssignMutationVariables>;
export const TaskRetriggerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskRetrigger"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task_retrigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFragment"}}]}}]}},...TaskFragmentFragmentDoc.definitions,...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions,...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TaskRetriggerMutationFn = Apollo.MutationFunction<TaskRetriggerMutation, TaskRetriggerMutationVariables>;

/**
 * __useTaskRetriggerMutation__
 *
 * To run a mutation, you first call `useTaskRetriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskRetriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskRetriggerMutation, { data, loading, error }] = useTaskRetriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskRetriggerMutation(baseOptions?: Apollo.MutationHookOptions<TaskRetriggerMutation, TaskRetriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskRetriggerMutation, TaskRetriggerMutationVariables>(TaskRetriggerDocument, options);
      }
export type TaskRetriggerMutationHookResult = ReturnType<typeof useTaskRetriggerMutation>;
export type TaskRetriggerMutationResult = Apollo.MutationResult<TaskRetriggerMutation>;
export type TaskRetriggerMutationOptions = Apollo.BaseMutationOptions<TaskRetriggerMutation, TaskRetriggerMutationVariables>;
export const TaskSubmitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskSubmit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"errorCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"error"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"result"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task_submit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"error"},"value":{"kind":"Variable","name":{"kind":"Name","value":"error"}}},{"kind":"Argument","name":{"kind":"Name","value":"errorCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"errorCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"result"},"value":{"kind":"Variable","name":{"kind":"Name","value":"result"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFragment"}}]}}]}},...TaskFragmentFragmentDoc.definitions,...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions,...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type TaskSubmitMutationFn = Apollo.MutationFunction<TaskSubmitMutation, TaskSubmitMutationVariables>;

/**
 * __useTaskSubmitMutation__
 *
 * To run a mutation, you first call `useTaskSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskSubmitMutation, { data, loading, error }] = useTaskSubmitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      errorCode: // value for 'errorCode'
 *      error: // value for 'error'
 *      result: // value for 'result'
 *   },
 * });
 */
export function useTaskSubmitMutation(baseOptions?: Apollo.MutationHookOptions<TaskSubmitMutation, TaskSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskSubmitMutation, TaskSubmitMutationVariables>(TaskSubmitDocument, options);
      }
export type TaskSubmitMutationHookResult = ReturnType<typeof useTaskSubmitMutation>;
export type TaskSubmitMutationResult = Apollo.MutationResult<TaskSubmitMutation>;
export type TaskSubmitMutationOptions = Apollo.BaseMutationOptions<TaskSubmitMutation, TaskSubmitMutationVariables>;
export const TriggerBuilderRecomputeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TriggerBuilderRecompute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"runDescription"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"saveComputationToPv2"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pv2Query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formulaIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportSuffix"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TriggerBuilderRecompute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"requestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}}},{"kind":"Argument","name":{"kind":"Name","value":"runDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"runDescription"}}},{"kind":"Argument","name":{"kind":"Name","value":"saveComputationToPv2"},"value":{"kind":"Variable","name":{"kind":"Name","value":"saveComputationToPv2"}}},{"kind":"Argument","name":{"kind":"Name","value":"pv2Query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pv2Query"}}},{"kind":"Argument","name":{"kind":"Name","value":"formulaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formulaIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportSuffix"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportSuffix"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"dagId"}},{"kind":"Field","name":{"kind":"Name","value":"dagRunId"}},{"kind":"Field","name":{"kind":"Name","value":"dagRunUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bqSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"bqDataset"}},{"kind":"Field","name":{"kind":"Name","value":"bqDatasetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bqTables"}},{"kind":"Field","name":{"kind":"Name","value":"alreadyQueued"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode;
export type TriggerBuilderRecomputeMutationFn = Apollo.MutationFunction<TriggerBuilderRecomputeMutation, TriggerBuilderRecomputeMutationVariables>;

/**
 * __useTriggerBuilderRecomputeMutation__
 *
 * To run a mutation, you first call `useTriggerBuilderRecomputeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerBuilderRecomputeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerBuilderRecomputeMutation, { data, loading, error }] = useTriggerBuilderRecomputeMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      runDescription: // value for 'runDescription'
 *      saveComputationToPv2: // value for 'saveComputationToPv2'
 *      pv2Query: // value for 'pv2Query'
 *      formulaIds: // value for 'formulaIds'
 *      reportSuffix: // value for 'reportSuffix'
 *   },
 * });
 */
export function useTriggerBuilderRecomputeMutation(baseOptions?: Apollo.MutationHookOptions<TriggerBuilderRecomputeMutation, TriggerBuilderRecomputeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerBuilderRecomputeMutation, TriggerBuilderRecomputeMutationVariables>(TriggerBuilderRecomputeDocument, options);
      }
export type TriggerBuilderRecomputeMutationHookResult = ReturnType<typeof useTriggerBuilderRecomputeMutation>;
export type TriggerBuilderRecomputeMutationResult = Apollo.MutationResult<TriggerBuilderRecomputeMutation>;
export type TriggerBuilderRecomputeMutationOptions = Apollo.BaseMutationOptions<TriggerBuilderRecomputeMutation, TriggerBuilderRecomputeMutationVariables>;
export const UpdatePv2sForUploadedImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePv2sForUploadedImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UpdatePv2sForUploadedImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"imageIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
export type UpdatePv2sForUploadedImagesMutationFn = Apollo.MutationFunction<UpdatePv2sForUploadedImagesMutation, UpdatePv2sForUploadedImagesMutationVariables>;

/**
 * __useUpdatePv2sForUploadedImagesMutation__
 *
 * To run a mutation, you first call `useUpdatePv2sForUploadedImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePv2sForUploadedImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePv2sForUploadedImagesMutation, { data, loading, error }] = useUpdatePv2sForUploadedImagesMutation({
 *   variables: {
 *      imageIds: // value for 'imageIds'
 *   },
 * });
 */
export function useUpdatePv2sForUploadedImagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePv2sForUploadedImagesMutation, UpdatePv2sForUploadedImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePv2sForUploadedImagesMutation, UpdatePv2sForUploadedImagesMutationVariables>(UpdatePv2sForUploadedImagesDocument, options);
      }
export type UpdatePv2sForUploadedImagesMutationHookResult = ReturnType<typeof useUpdatePv2sForUploadedImagesMutation>;
export type UpdatePv2sForUploadedImagesMutationResult = Apollo.MutationResult<UpdatePv2sForUploadedImagesMutation>;
export type UpdatePv2sForUploadedImagesMutationOptions = Apollo.BaseMutationOptions<UpdatePv2sForUploadedImagesMutation, UpdatePv2sForUploadedImagesMutationVariables>;
export const UploadProcessedImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadProcessedImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UploadProcessedImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
export type UploadProcessedImagesMutationFn = Apollo.MutationFunction<UploadProcessedImagesMutation, UploadProcessedImagesMutationVariables>;

/**
 * __useUploadProcessedImagesMutation__
 *
 * To run a mutation, you first call `useUploadProcessedImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProcessedImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProcessedImagesMutation, { data, loading, error }] = useUploadProcessedImagesMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useUploadProcessedImagesMutation(baseOptions?: Apollo.MutationHookOptions<UploadProcessedImagesMutation, UploadProcessedImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProcessedImagesMutation, UploadProcessedImagesMutationVariables>(UploadProcessedImagesDocument, options);
      }
export type UploadProcessedImagesMutationHookResult = ReturnType<typeof useUploadProcessedImagesMutation>;
export type UploadProcessedImagesMutationResult = Apollo.MutationResult<UploadProcessedImagesMutation>;
export type UploadProcessedImagesMutationOptions = Apollo.BaseMutationOptions<UploadProcessedImagesMutation, UploadProcessedImagesMutationVariables>;
export const UploadPublicAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadPublicAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"s3Key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UploadPublicAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"s3Key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"s3Key"}}},{"kind":"Argument","name":{"kind":"Name","value":"addTimestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addTimestamp"}}}]}]}}]} as unknown as DocumentNode;
export type UploadPublicAssetMutationFn = Apollo.MutationFunction<UploadPublicAssetMutation, UploadPublicAssetMutationVariables>;

/**
 * __useUploadPublicAssetMutation__
 *
 * To run a mutation, you first call `useUploadPublicAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPublicAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPublicAssetMutation, { data, loading, error }] = useUploadPublicAssetMutation({
 *   variables: {
 *      file: // value for 'file'
 *      s3Key: // value for 's3Key'
 *      addTimestamp: // value for 'addTimestamp'
 *   },
 * });
 */
export function useUploadPublicAssetMutation(baseOptions?: Apollo.MutationHookOptions<UploadPublicAssetMutation, UploadPublicAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadPublicAssetMutation, UploadPublicAssetMutationVariables>(UploadPublicAssetDocument, options);
      }
export type UploadPublicAssetMutationHookResult = ReturnType<typeof useUploadPublicAssetMutation>;
export type UploadPublicAssetMutationResult = Apollo.MutationResult<UploadPublicAssetMutation>;
export type UploadPublicAssetMutationOptions = Apollo.BaseMutationOptions<UploadPublicAssetMutation, UploadPublicAssetMutationVariables>;
export const CreateS3PresignedImageProcessingPutUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createS3PresignedImageProcessingPutUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createS3PresignedImageProcessingPutUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}}]}}]} as unknown as DocumentNode;
export type CreateS3PresignedImageProcessingPutUrlMutationFn = Apollo.MutationFunction<CreateS3PresignedImageProcessingPutUrlMutation, CreateS3PresignedImageProcessingPutUrlMutationVariables>;

/**
 * __useCreateS3PresignedImageProcessingPutUrlMutation__
 *
 * To run a mutation, you first call `useCreateS3PresignedImageProcessingPutUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateS3PresignedImageProcessingPutUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createS3PresignedImageProcessingPutUrlMutation, { data, loading, error }] = useCreateS3PresignedImageProcessingPutUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useCreateS3PresignedImageProcessingPutUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateS3PresignedImageProcessingPutUrlMutation, CreateS3PresignedImageProcessingPutUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateS3PresignedImageProcessingPutUrlMutation, CreateS3PresignedImageProcessingPutUrlMutationVariables>(CreateS3PresignedImageProcessingPutUrlDocument, options);
      }
export type CreateS3PresignedImageProcessingPutUrlMutationHookResult = ReturnType<typeof useCreateS3PresignedImageProcessingPutUrlMutation>;
export type CreateS3PresignedImageProcessingPutUrlMutationResult = Apollo.MutationResult<CreateS3PresignedImageProcessingPutUrlMutation>;
export type CreateS3PresignedImageProcessingPutUrlMutationOptions = Apollo.BaseMutationOptions<CreateS3PresignedImageProcessingPutUrlMutation, CreateS3PresignedImageProcessingPutUrlMutationVariables>;
export const CreateTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskDefinition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskDefinition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskDefinition"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}}}]}]}}]} as unknown as DocumentNode;
export type CreateTasksMutationFn = Apollo.MutationFunction<CreateTasksMutation, CreateTasksMutationVariables>;

/**
 * __useCreateTasksMutation__
 *
 * To run a mutation, you first call `useCreateTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTasksMutation, { data, loading, error }] = useCreateTasksMutation({
 *   variables: {
 *      taskDefinition: // value for 'taskDefinition'
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateTasksMutation(baseOptions?: Apollo.MutationHookOptions<CreateTasksMutation, CreateTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTasksMutation, CreateTasksMutationVariables>(CreateTasksDocument, options);
      }
export type CreateTasksMutationHookResult = ReturnType<typeof useCreateTasksMutation>;
export type CreateTasksMutationResult = Apollo.MutationResult<CreateTasksMutation>;
export type CreateTasksMutationOptions = Apollo.BaseMutationOptions<CreateTasksMutation, CreateTasksMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jwt"}},{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAuthenticated"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}}]}},...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const AsinAttributeLevelCoverageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AsinAttributeLevelCoverage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"top25Attribute"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributeThemeType"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AsinAttributeLevelCoverage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"top25Attribute"},"value":{"kind":"Variable","name":{"kind":"Name","value":"top25Attribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributeThemeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributeThemeType"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"top25Attribute"}},{"kind":"Field","name":{"kind":"Name","value":"attributeThemeType"}},{"kind":"Field","alias":{"kind":"Name","value":"totalEligibleUpcs"},"name":{"kind":"Name","value":"totalEligibleAsins"}},{"kind":"Field","alias":{"kind":"Name","value":"upcsWithUnknownValue"},"name":{"kind":"Name","value":"asinsWithUnknownValue"}},{"kind":"Field","alias":{"kind":"Name","value":"upcsWithKnownValue"},"name":{"kind":"Name","value":"asinsWithKnownValue"}},{"kind":"Field","alias":{"kind":"Name","value":"upcUnknownValuePercent"},"name":{"kind":"Name","value":"asinUnknownValuePercent"}},{"kind":"Field","alias":{"kind":"Name","value":"upcKnownValuePercent"},"name":{"kind":"Name","value":"asinKnownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"totalEligibleSales"}},{"kind":"Field","name":{"kind":"Name","value":"salesWithUnknownValue"}},{"kind":"Field","name":{"kind":"Name","value":"salesWithKnownValue"}},{"kind":"Field","name":{"kind":"Name","value":"salesUnknownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"salesKnownValuePercent"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAsinAttributeLevelCoverageQuery__
 *
 * To run a query within a React component, call `useAsinAttributeLevelCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsinAttributeLevelCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsinAttributeLevelCoverageQuery({
 *   variables: {
 *      top25Attribute: // value for 'top25Attribute'
 *      displayName: // value for 'displayName'
 *      attributeThemeType: // value for 'attributeThemeType'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAsinAttributeLevelCoverageQuery(baseOptions?: Apollo.QueryHookOptions<AsinAttributeLevelCoverageQuery, AsinAttributeLevelCoverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsinAttributeLevelCoverageQuery, AsinAttributeLevelCoverageQueryVariables>(AsinAttributeLevelCoverageDocument, options);
      }
export function useAsinAttributeLevelCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsinAttributeLevelCoverageQuery, AsinAttributeLevelCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsinAttributeLevelCoverageQuery, AsinAttributeLevelCoverageQueryVariables>(AsinAttributeLevelCoverageDocument, options);
        }
export type AsinAttributeLevelCoverageQueryHookResult = ReturnType<typeof useAsinAttributeLevelCoverageQuery>;
export type AsinAttributeLevelCoverageLazyQueryHookResult = ReturnType<typeof useAsinAttributeLevelCoverageLazyQuery>;
export type AsinAttributeLevelCoverageQueryResult = Apollo.QueryResult<AsinAttributeLevelCoverageQuery, AsinAttributeLevelCoverageQueryVariables>;
export const AsinSubcategoryLevelCoverageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AsinSubcategoryLevelCoverage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"department"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"top25Attribute"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributeThemeType"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AsinSubcategoryLevelCoverage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"department"},"value":{"kind":"Variable","name":{"kind":"Name","value":"department"}}},{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"top25Attribute"},"value":{"kind":"Variable","name":{"kind":"Name","value":"top25Attribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributeThemeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributeThemeType"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"top25Attribute"}},{"kind":"Field","name":{"kind":"Name","value":"attributeThemeType"}},{"kind":"Field","alias":{"kind":"Name","value":"totalEligibleUpcs"},"name":{"kind":"Name","value":"totalEligibleAsins"}},{"kind":"Field","alias":{"kind":"Name","value":"upcsWithUnknownValue"},"name":{"kind":"Name","value":"asinsWithUnknownValue"}},{"kind":"Field","alias":{"kind":"Name","value":"upcsWithKnownValue"},"name":{"kind":"Name","value":"asinsWithKnownValue"}},{"kind":"Field","alias":{"kind":"Name","value":"upcUnknownValuePercent"},"name":{"kind":"Name","value":"asinUnknownValuePercent"}},{"kind":"Field","alias":{"kind":"Name","value":"upcKnownValuePercent"},"name":{"kind":"Name","value":"asinKnownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"totalEligibleSales"}},{"kind":"Field","name":{"kind":"Name","value":"salesWithUnknownValue"}},{"kind":"Field","name":{"kind":"Name","value":"salesWithKnownValue"}},{"kind":"Field","name":{"kind":"Name","value":"salesUnknownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"salesKnownValuePercent"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAsinSubcategoryLevelCoverageQuery__
 *
 * To run a query within a React component, call `useAsinSubcategoryLevelCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsinSubcategoryLevelCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsinSubcategoryLevelCoverageQuery({
 *   variables: {
 *      department: // value for 'department'
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      top25Attribute: // value for 'top25Attribute'
 *      displayName: // value for 'displayName'
 *      attributeThemeType: // value for 'attributeThemeType'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAsinSubcategoryLevelCoverageQuery(baseOptions?: Apollo.QueryHookOptions<AsinSubcategoryLevelCoverageQuery, AsinSubcategoryLevelCoverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsinSubcategoryLevelCoverageQuery, AsinSubcategoryLevelCoverageQueryVariables>(AsinSubcategoryLevelCoverageDocument, options);
      }
export function useAsinSubcategoryLevelCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsinSubcategoryLevelCoverageQuery, AsinSubcategoryLevelCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsinSubcategoryLevelCoverageQuery, AsinSubcategoryLevelCoverageQueryVariables>(AsinSubcategoryLevelCoverageDocument, options);
        }
export type AsinSubcategoryLevelCoverageQueryHookResult = ReturnType<typeof useAsinSubcategoryLevelCoverageQuery>;
export type AsinSubcategoryLevelCoverageLazyQueryHookResult = ReturnType<typeof useAsinSubcategoryLevelCoverageLazyQuery>;
export type AsinSubcategoryLevelCoverageQueryResult = Apollo.QueryResult<AsinSubcategoryLevelCoverageQuery, AsinSubcategoryLevelCoverageQueryVariables>;
export const AsinLevelCoverageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AsinLevelCoverage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asin"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brand"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"department"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"top25Attribute"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributeThemeType"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AsinLevelCoverage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"asin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asin"}}},{"kind":"Argument","name":{"kind":"Name","value":"brand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brand"}}},{"kind":"Argument","name":{"kind":"Name","value":"department"},"value":{"kind":"Variable","name":{"kind":"Name","value":"department"}}},{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"top25Attribute"},"value":{"kind":"Variable","name":{"kind":"Name","value":"top25Attribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributeThemeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributeThemeType"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"maskedUpc"},"name":{"kind":"Name","value":"asin"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"top25Attribute"}},{"kind":"Field","name":{"kind":"Name","value":"attributeThemeType"}},{"kind":"Field","name":{"kind":"Name","value":"totalDollarSales"}},{"kind":"Field","name":{"kind":"Name","value":"attributeLevelSalesKnownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"attributeLevelSalesKnownValuePercentIncrease"}},{"kind":"Field","name":{"kind":"Name","value":"subcategoryLevelSalesKnownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"subcategoryLevelSalesKnownValuePercentIncrease"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAsinLevelCoverageQuery__
 *
 * To run a query within a React component, call `useAsinLevelCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsinLevelCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsinLevelCoverageQuery({
 *   variables: {
 *      asin: // value for 'asin'
 *      brand: // value for 'brand'
 *      department: // value for 'department'
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      top25Attribute: // value for 'top25Attribute'
 *      displayName: // value for 'displayName'
 *      attributeThemeType: // value for 'attributeThemeType'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAsinLevelCoverageQuery(baseOptions?: Apollo.QueryHookOptions<AsinLevelCoverageQuery, AsinLevelCoverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsinLevelCoverageQuery, AsinLevelCoverageQueryVariables>(AsinLevelCoverageDocument, options);
      }
export function useAsinLevelCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsinLevelCoverageQuery, AsinLevelCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsinLevelCoverageQuery, AsinLevelCoverageQueryVariables>(AsinLevelCoverageDocument, options);
        }
export type AsinLevelCoverageQueryHookResult = ReturnType<typeof useAsinLevelCoverageQuery>;
export type AsinLevelCoverageLazyQueryHookResult = ReturnType<typeof useAsinLevelCoverageLazyQuery>;
export type AsinLevelCoverageQueryResult = Apollo.QueryResult<AsinLevelCoverageQuery, AsinLevelCoverageQueryVariables>;
export const AsinCoverageHierarchyFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AsinCoverageHierarchyFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AsinCoverageHierarchyFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAsinCoverageHierarchyFilterQuery__
 *
 * To run a query within a React component, call `useAsinCoverageHierarchyFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsinCoverageHierarchyFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsinCoverageHierarchyFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useAsinCoverageHierarchyFilterQuery(baseOptions?: Apollo.QueryHookOptions<AsinCoverageHierarchyFilterQuery, AsinCoverageHierarchyFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsinCoverageHierarchyFilterQuery, AsinCoverageHierarchyFilterQueryVariables>(AsinCoverageHierarchyFilterDocument, options);
      }
export function useAsinCoverageHierarchyFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsinCoverageHierarchyFilterQuery, AsinCoverageHierarchyFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsinCoverageHierarchyFilterQuery, AsinCoverageHierarchyFilterQueryVariables>(AsinCoverageHierarchyFilterDocument, options);
        }
export type AsinCoverageHierarchyFilterQueryHookResult = ReturnType<typeof useAsinCoverageHierarchyFilterQuery>;
export type AsinCoverageHierarchyFilterLazyQueryHookResult = ReturnType<typeof useAsinCoverageHierarchyFilterLazyQuery>;
export type AsinCoverageHierarchyFilterQueryResult = Apollo.QueryResult<AsinCoverageHierarchyFilterQuery, AsinCoverageHierarchyFilterQueryVariables>;
export const AsinCoverageAttributeThemeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AsinCoverageAttributeThemeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"department"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AsinCoverageAttributeThemeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"department"},"value":{"kind":"Variable","name":{"kind":"Name","value":"department"}}},{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributeThemeType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAsinCoverageAttributeThemeFilterQuery__
 *
 * To run a query within a React component, call `useAsinCoverageAttributeThemeFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsinCoverageAttributeThemeFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsinCoverageAttributeThemeFilterQuery({
 *   variables: {
 *      department: // value for 'department'
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *   },
 * });
 */
export function useAsinCoverageAttributeThemeFilterQuery(baseOptions?: Apollo.QueryHookOptions<AsinCoverageAttributeThemeFilterQuery, AsinCoverageAttributeThemeFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsinCoverageAttributeThemeFilterQuery, AsinCoverageAttributeThemeFilterQueryVariables>(AsinCoverageAttributeThemeFilterDocument, options);
      }
export function useAsinCoverageAttributeThemeFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsinCoverageAttributeThemeFilterQuery, AsinCoverageAttributeThemeFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsinCoverageAttributeThemeFilterQuery, AsinCoverageAttributeThemeFilterQueryVariables>(AsinCoverageAttributeThemeFilterDocument, options);
        }
export type AsinCoverageAttributeThemeFilterQueryHookResult = ReturnType<typeof useAsinCoverageAttributeThemeFilterQuery>;
export type AsinCoverageAttributeThemeFilterLazyQueryHookResult = ReturnType<typeof useAsinCoverageAttributeThemeFilterLazyQuery>;
export type AsinCoverageAttributeThemeFilterQueryResult = Apollo.QueryResult<AsinCoverageAttributeThemeFilterQuery, AsinCoverageAttributeThemeFilterQueryVariables>;
export const AttributeLevelCoverageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AttributeLevelCoverage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"geography"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"top25Attribute"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributeThemeType"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AttributeLevelCoverage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"geography"},"value":{"kind":"Variable","name":{"kind":"Name","value":"geography"}}},{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}},{"kind":"Argument","name":{"kind":"Name","value":"top25Attribute"},"value":{"kind":"Variable","name":{"kind":"Name","value":"top25Attribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributeThemeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributeThemeType"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geography"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"top25Attribute"}},{"kind":"Field","name":{"kind":"Name","value":"attributeThemeType"}},{"kind":"Field","name":{"kind":"Name","value":"totalEligibleUpcs"}},{"kind":"Field","name":{"kind":"Name","value":"upcsWithUnknownValue"}},{"kind":"Field","name":{"kind":"Name","value":"upcsWithKnownValue"}},{"kind":"Field","name":{"kind":"Name","value":"upcUnknownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"upcKnownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"totalEligibleSales"}},{"kind":"Field","name":{"kind":"Name","value":"salesWithUnknownValue"}},{"kind":"Field","name":{"kind":"Name","value":"salesWithKnownValue"}},{"kind":"Field","name":{"kind":"Name","value":"salesUnknownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"salesKnownValuePercent"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAttributeLevelCoverageQuery__
 *
 * To run a query within a React component, call `useAttributeLevelCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeLevelCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeLevelCoverageQuery({
 *   variables: {
 *      geography: // value for 'geography'
 *      time: // value for 'time'
 *      top25Attribute: // value for 'top25Attribute'
 *      displayName: // value for 'displayName'
 *      attributeThemeType: // value for 'attributeThemeType'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAttributeLevelCoverageQuery(baseOptions: Apollo.QueryHookOptions<AttributeLevelCoverageQuery, AttributeLevelCoverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeLevelCoverageQuery, AttributeLevelCoverageQueryVariables>(AttributeLevelCoverageDocument, options);
      }
export function useAttributeLevelCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeLevelCoverageQuery, AttributeLevelCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeLevelCoverageQuery, AttributeLevelCoverageQueryVariables>(AttributeLevelCoverageDocument, options);
        }
export type AttributeLevelCoverageQueryHookResult = ReturnType<typeof useAttributeLevelCoverageQuery>;
export type AttributeLevelCoverageLazyQueryHookResult = ReturnType<typeof useAttributeLevelCoverageLazyQuery>;
export type AttributeLevelCoverageQueryResult = Apollo.QueryResult<AttributeLevelCoverageQuery, AttributeLevelCoverageQueryVariables>;
export const SubcategoryLevelCoverageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubcategoryLevelCoverage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"department"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"geography"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"top25Attribute"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributeThemeType"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SubcategoryLevelCoverage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"department"},"value":{"kind":"Variable","name":{"kind":"Name","value":"department"}}},{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"geography"},"value":{"kind":"Variable","name":{"kind":"Name","value":"geography"}}},{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}},{"kind":"Argument","name":{"kind":"Name","value":"top25Attribute"},"value":{"kind":"Variable","name":{"kind":"Name","value":"top25Attribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributeThemeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributeThemeType"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geography"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"top25Attribute"}},{"kind":"Field","name":{"kind":"Name","value":"attributeThemeType"}},{"kind":"Field","name":{"kind":"Name","value":"totalEligibleUpcs"}},{"kind":"Field","name":{"kind":"Name","value":"upcsWithUnknownValue"}},{"kind":"Field","name":{"kind":"Name","value":"upcsWithKnownValue"}},{"kind":"Field","name":{"kind":"Name","value":"upcUnknownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"upcKnownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"totalEligibleSales"}},{"kind":"Field","name":{"kind":"Name","value":"salesWithUnknownValue"}},{"kind":"Field","name":{"kind":"Name","value":"salesWithKnownValue"}},{"kind":"Field","name":{"kind":"Name","value":"salesUnknownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"salesKnownValuePercent"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSubcategoryLevelCoverageQuery__
 *
 * To run a query within a React component, call `useSubcategoryLevelCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcategoryLevelCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcategoryLevelCoverageQuery({
 *   variables: {
 *      department: // value for 'department'
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      geography: // value for 'geography'
 *      time: // value for 'time'
 *      top25Attribute: // value for 'top25Attribute'
 *      displayName: // value for 'displayName'
 *      attributeThemeType: // value for 'attributeThemeType'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSubcategoryLevelCoverageQuery(baseOptions: Apollo.QueryHookOptions<SubcategoryLevelCoverageQuery, SubcategoryLevelCoverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubcategoryLevelCoverageQuery, SubcategoryLevelCoverageQueryVariables>(SubcategoryLevelCoverageDocument, options);
      }
export function useSubcategoryLevelCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubcategoryLevelCoverageQuery, SubcategoryLevelCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubcategoryLevelCoverageQuery, SubcategoryLevelCoverageQueryVariables>(SubcategoryLevelCoverageDocument, options);
        }
export type SubcategoryLevelCoverageQueryHookResult = ReturnType<typeof useSubcategoryLevelCoverageQuery>;
export type SubcategoryLevelCoverageLazyQueryHookResult = ReturnType<typeof useSubcategoryLevelCoverageLazyQuery>;
export type SubcategoryLevelCoverageQueryResult = Apollo.QueryResult<SubcategoryLevelCoverageQuery, SubcategoryLevelCoverageQueryVariables>;
export const UpcLevelCoverageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpcLevelCoverage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maskedUpc"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brand"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"department"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"geography"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"top25Attribute"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributeThemeType"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"privateLabel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UpcLevelCoverage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maskedUpc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maskedUpc"}}},{"kind":"Argument","name":{"kind":"Name","value":"brand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brand"}}},{"kind":"Argument","name":{"kind":"Name","value":"department"},"value":{"kind":"Variable","name":{"kind":"Name","value":"department"}}},{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"geography"},"value":{"kind":"Variable","name":{"kind":"Name","value":"geography"}}},{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}},{"kind":"Argument","name":{"kind":"Name","value":"top25Attribute"},"value":{"kind":"Variable","name":{"kind":"Name","value":"top25Attribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributeThemeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributeThemeType"}}},{"kind":"Argument","name":{"kind":"Name","value":"privateLabel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"privateLabel"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geography"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"maskedUpc"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"top25Attribute"}},{"kind":"Field","name":{"kind":"Name","value":"attributeThemeType"}},{"kind":"Field","name":{"kind":"Name","value":"totalDollarSales"}},{"kind":"Field","name":{"kind":"Name","value":"attributeLevelSalesKnownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"attributeLevelSalesKnownValuePercentIncrease"}},{"kind":"Field","name":{"kind":"Name","value":"subcategoryLevelSalesKnownValuePercent"}},{"kind":"Field","name":{"kind":"Name","value":"subcategoryLevelSalesKnownValuePercentIncrease"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUpcLevelCoverageQuery__
 *
 * To run a query within a React component, call `useUpcLevelCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcLevelCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcLevelCoverageQuery({
 *   variables: {
 *      maskedUpc: // value for 'maskedUpc'
 *      brand: // value for 'brand'
 *      department: // value for 'department'
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      geography: // value for 'geography'
 *      time: // value for 'time'
 *      top25Attribute: // value for 'top25Attribute'
 *      displayName: // value for 'displayName'
 *      attributeThemeType: // value for 'attributeThemeType'
 *      privateLabel: // value for 'privateLabel'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUpcLevelCoverageQuery(baseOptions: Apollo.QueryHookOptions<UpcLevelCoverageQuery, UpcLevelCoverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcLevelCoverageQuery, UpcLevelCoverageQueryVariables>(UpcLevelCoverageDocument, options);
      }
export function useUpcLevelCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcLevelCoverageQuery, UpcLevelCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcLevelCoverageQuery, UpcLevelCoverageQueryVariables>(UpcLevelCoverageDocument, options);
        }
export type UpcLevelCoverageQueryHookResult = ReturnType<typeof useUpcLevelCoverageQuery>;
export type UpcLevelCoverageLazyQueryHookResult = ReturnType<typeof useUpcLevelCoverageLazyQuery>;
export type UpcLevelCoverageQueryResult = Apollo.QueryResult<UpcLevelCoverageQuery, UpcLevelCoverageQueryVariables>;
export const AttributeCoverageHierarchyFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AttributeCoverageHierarchyFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AttributeCoverageHierarchyFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAttributeCoverageHierarchyFilterQuery__
 *
 * To run a query within a React component, call `useAttributeCoverageHierarchyFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeCoverageHierarchyFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeCoverageHierarchyFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttributeCoverageHierarchyFilterQuery(baseOptions?: Apollo.QueryHookOptions<AttributeCoverageHierarchyFilterQuery, AttributeCoverageHierarchyFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeCoverageHierarchyFilterQuery, AttributeCoverageHierarchyFilterQueryVariables>(AttributeCoverageHierarchyFilterDocument, options);
      }
export function useAttributeCoverageHierarchyFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeCoverageHierarchyFilterQuery, AttributeCoverageHierarchyFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeCoverageHierarchyFilterQuery, AttributeCoverageHierarchyFilterQueryVariables>(AttributeCoverageHierarchyFilterDocument, options);
        }
export type AttributeCoverageHierarchyFilterQueryHookResult = ReturnType<typeof useAttributeCoverageHierarchyFilterQuery>;
export type AttributeCoverageHierarchyFilterLazyQueryHookResult = ReturnType<typeof useAttributeCoverageHierarchyFilterLazyQuery>;
export type AttributeCoverageHierarchyFilterQueryResult = Apollo.QueryResult<AttributeCoverageHierarchyFilterQuery, AttributeCoverageHierarchyFilterQueryVariables>;
export const AttributeCoverageAttributeThemeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AttributeCoverageAttributeThemeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"department"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"geography"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AttributeCoverageAttributeThemeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"department"},"value":{"kind":"Variable","name":{"kind":"Name","value":"department"}}},{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"geography"},"value":{"kind":"Variable","name":{"kind":"Name","value":"geography"}}},{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributeThemeType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAttributeCoverageAttributeThemeFilterQuery__
 *
 * To run a query within a React component, call `useAttributeCoverageAttributeThemeFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeCoverageAttributeThemeFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeCoverageAttributeThemeFilterQuery({
 *   variables: {
 *      department: // value for 'department'
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      geography: // value for 'geography'
 *      time: // value for 'time'
 *   },
 * });
 */
export function useAttributeCoverageAttributeThemeFilterQuery(baseOptions?: Apollo.QueryHookOptions<AttributeCoverageAttributeThemeFilterQuery, AttributeCoverageAttributeThemeFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeCoverageAttributeThemeFilterQuery, AttributeCoverageAttributeThemeFilterQueryVariables>(AttributeCoverageAttributeThemeFilterDocument, options);
      }
export function useAttributeCoverageAttributeThemeFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeCoverageAttributeThemeFilterQuery, AttributeCoverageAttributeThemeFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeCoverageAttributeThemeFilterQuery, AttributeCoverageAttributeThemeFilterQueryVariables>(AttributeCoverageAttributeThemeFilterDocument, options);
        }
export type AttributeCoverageAttributeThemeFilterQueryHookResult = ReturnType<typeof useAttributeCoverageAttributeThemeFilterQuery>;
export type AttributeCoverageAttributeThemeFilterLazyQueryHookResult = ReturnType<typeof useAttributeCoverageAttributeThemeFilterLazyQuery>;
export type AttributeCoverageAttributeThemeFilterQueryResult = Apollo.QueryResult<AttributeCoverageAttributeThemeFilterQuery, AttributeCoverageAttributeThemeFilterQueryVariables>;
export const AttributeSalesAssessmentAggregationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AttributeSalesAssessmentAggregation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"builderBatchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportRunId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spinsSn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spinsSca"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AttributeSalesAssessmentTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"builderBatchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"builderBatchId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportRunId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportRunId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"spins_sn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spinsSn"}}},{"kind":"Argument","name":{"kind":"Name","value":"spins_sca"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spinsSca"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupValue"}},{"kind":"Field","name":{"kind":"Name","value":"salesPercentChangeYago"}},{"kind":"Field","name":{"kind":"Name","value":"salesPlusOrMinusChgYago"}},{"kind":"Field","name":{"kind":"Name","value":"totalCurrentSales"}},{"kind":"Field","name":{"kind":"Name","value":"totalPreviousSales"}},{"kind":"Field","name":{"kind":"Name","value":"upcCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAttributeSalesAssessmentAggregationQuery__
 *
 * To run a query within a React component, call `useAttributeSalesAssessmentAggregationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeSalesAssessmentAggregationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeSalesAssessmentAggregationQuery({
 *   variables: {
 *      builderBatchId: // value for 'builderBatchId'
 *      reportRunId: // value for 'reportRunId'
 *      groupBy: // value for 'groupBy'
 *      status: // value for 'status'
 *      spinsSn: // value for 'spinsSn'
 *      spinsSca: // value for 'spinsSca'
 *      limit: // value for 'limit'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useAttributeSalesAssessmentAggregationQuery(baseOptions: Apollo.QueryHookOptions<AttributeSalesAssessmentAggregationQuery, AttributeSalesAssessmentAggregationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeSalesAssessmentAggregationQuery, AttributeSalesAssessmentAggregationQueryVariables>(AttributeSalesAssessmentAggregationDocument, options);
      }
export function useAttributeSalesAssessmentAggregationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeSalesAssessmentAggregationQuery, AttributeSalesAssessmentAggregationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeSalesAssessmentAggregationQuery, AttributeSalesAssessmentAggregationQueryVariables>(AttributeSalesAssessmentAggregationDocument, options);
        }
export type AttributeSalesAssessmentAggregationQueryHookResult = ReturnType<typeof useAttributeSalesAssessmentAggregationQuery>;
export type AttributeSalesAssessmentAggregationLazyQueryHookResult = ReturnType<typeof useAttributeSalesAssessmentAggregationLazyQuery>;
export type AttributeSalesAssessmentAggregationQueryResult = Apollo.QueryResult<AttributeSalesAssessmentAggregationQuery, AttributeSalesAssessmentAggregationQueryVariables>;
export const AttributeSalesFilterCombosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AttributeSalesFilterCombos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AttributeSalesFilterCombos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builderBatchId"}},{"kind":"Field","name":{"kind":"Name","value":"reportRunId"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAttributeSalesFilterCombosQuery__
 *
 * To run a query within a React component, call `useAttributeSalesFilterCombosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeSalesFilterCombosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeSalesFilterCombosQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttributeSalesFilterCombosQuery(baseOptions?: Apollo.QueryHookOptions<AttributeSalesFilterCombosQuery, AttributeSalesFilterCombosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeSalesFilterCombosQuery, AttributeSalesFilterCombosQueryVariables>(AttributeSalesFilterCombosDocument, options);
      }
export function useAttributeSalesFilterCombosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeSalesFilterCombosQuery, AttributeSalesFilterCombosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeSalesFilterCombosQuery, AttributeSalesFilterCombosQueryVariables>(AttributeSalesFilterCombosDocument, options);
        }
export type AttributeSalesFilterCombosQueryHookResult = ReturnType<typeof useAttributeSalesFilterCombosQuery>;
export type AttributeSalesFilterCombosLazyQueryHookResult = ReturnType<typeof useAttributeSalesFilterCombosLazyQuery>;
export type AttributeSalesFilterCombosQueryResult = Apollo.QueryResult<AttributeSalesFilterCombosQuery, AttributeSalesFilterCombosQueryVariables>;
export const AttributeSalesAssessmentStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AttributeSalesAssessmentStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"builderBatchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportRunId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spinsSn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spinsSca"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AttributeSalesAssessmentStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"builderBatchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"builderBatchId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportRunId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportRunId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"spins_sn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spinsSn"}}},{"kind":"Argument","name":{"kind":"Name","value":"spins_sca"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spinsSca"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countOfCategory"}},{"kind":"Field","name":{"kind":"Name","value":"countOfSubcategory"}},{"kind":"Field","name":{"kind":"Name","value":"countOfUpc"}},{"kind":"Field","name":{"kind":"Name","value":"countOfUpcInSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"salesPercentChangeYago"}},{"kind":"Field","name":{"kind":"Name","value":"salesPlusOrMinusChgYago"}},{"kind":"Field","name":{"kind":"Name","value":"totalCurrentSales"}},{"kind":"Field","name":{"kind":"Name","value":"totalPreviousSales"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAttributeSalesAssessmentStatsQuery__
 *
 * To run a query within a React component, call `useAttributeSalesAssessmentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeSalesAssessmentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeSalesAssessmentStatsQuery({
 *   variables: {
 *      builderBatchId: // value for 'builderBatchId'
 *      reportRunId: // value for 'reportRunId'
 *      status: // value for 'status'
 *      spinsSn: // value for 'spinsSn'
 *      spinsSca: // value for 'spinsSca'
 *   },
 * });
 */
export function useAttributeSalesAssessmentStatsQuery(baseOptions: Apollo.QueryHookOptions<AttributeSalesAssessmentStatsQuery, AttributeSalesAssessmentStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeSalesAssessmentStatsQuery, AttributeSalesAssessmentStatsQueryVariables>(AttributeSalesAssessmentStatsDocument, options);
      }
export function useAttributeSalesAssessmentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeSalesAssessmentStatsQuery, AttributeSalesAssessmentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeSalesAssessmentStatsQuery, AttributeSalesAssessmentStatsQueryVariables>(AttributeSalesAssessmentStatsDocument, options);
        }
export type AttributeSalesAssessmentStatsQueryHookResult = ReturnType<typeof useAttributeSalesAssessmentStatsQuery>;
export type AttributeSalesAssessmentStatsLazyQueryHookResult = ReturnType<typeof useAttributeSalesAssessmentStatsLazyQuery>;
export type AttributeSalesAssessmentStatsQueryResult = Apollo.QueryResult<AttributeSalesAssessmentStatsQuery, AttributeSalesAssessmentStatsQueryVariables>;
export const AttributeSalesAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AttributeSalesAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"builderBatchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportRunId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spinsSn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spinsSca"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AttributeSalesAssessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"builderBatchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"builderBatchId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportRunId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportRunId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"spins_sn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spinsSn"}}},{"kind":"Argument","name":{"kind":"Name","value":"spins_sca"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spinsSca"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SPINS_UPC"}},{"kind":"Field","name":{"kind":"Name","value":"spins_brand"}},{"kind":"Field","name":{"kind":"Name","value":"spins_description"}},{"kind":"Field","name":{"kind":"Name","value":"spins_department"}},{"kind":"Field","name":{"kind":"Name","value":"spins_category"}},{"kind":"Field","name":{"kind":"Name","value":"spins_subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"salesPercentChangeYago"}},{"kind":"Field","name":{"kind":"Name","value":"salesPlusOrMinusChgYago"}},{"kind":"Field","name":{"kind":"Name","value":"totalCurrentSales"}},{"kind":"Field","name":{"kind":"Name","value":"totalPreviousSales"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAttributeSalesAssessmentQuery__
 *
 * To run a query within a React component, call `useAttributeSalesAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeSalesAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeSalesAssessmentQuery({
 *   variables: {
 *      builderBatchId: // value for 'builderBatchId'
 *      reportRunId: // value for 'reportRunId'
 *      status: // value for 'status'
 *      spinsSn: // value for 'spinsSn'
 *      spinsSca: // value for 'spinsSca'
 *      limit: // value for 'limit'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useAttributeSalesAssessmentQuery(baseOptions: Apollo.QueryHookOptions<AttributeSalesAssessmentQuery, AttributeSalesAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeSalesAssessmentQuery, AttributeSalesAssessmentQueryVariables>(AttributeSalesAssessmentDocument, options);
      }
export function useAttributeSalesAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeSalesAssessmentQuery, AttributeSalesAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeSalesAssessmentQuery, AttributeSalesAssessmentQueryVariables>(AttributeSalesAssessmentDocument, options);
        }
export type AttributeSalesAssessmentQueryHookResult = ReturnType<typeof useAttributeSalesAssessmentQuery>;
export type AttributeSalesAssessmentLazyQueryHookResult = ReturnType<typeof useAttributeSalesAssessmentLazyQuery>;
export type AttributeSalesAssessmentQueryResult = Apollo.QueryResult<AttributeSalesAssessmentQuery, AttributeSalesAssessmentQueryVariables>;
export const BrandReviewFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandReviewFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BrandReview_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"brandA"}},{"kind":"Field","name":{"kind":"Name","value":"brandB"}},{"kind":"Field","name":{"kind":"Name","value":"brandAItemCount"}},{"kind":"Field","name":{"kind":"Name","value":"brandBItemCount"}},{"kind":"Field","name":{"kind":"Name","value":"brandMatchReason"}},{"kind":"Field","name":{"kind":"Name","value":"opsReview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewStatus"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}},{"kind":"Field","name":{"kind":"Name","value":"survivingBrand"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useBrandReviewFindQuery__
 *
 * To run a query within a React component, call `useBrandReviewFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandReviewFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandReviewFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useBrandReviewFindQuery(baseOptions?: Apollo.QueryHookOptions<BrandReviewFindQuery, BrandReviewFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandReviewFindQuery, BrandReviewFindQueryVariables>(BrandReviewFindDocument, options);
      }
export function useBrandReviewFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandReviewFindQuery, BrandReviewFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandReviewFindQuery, BrandReviewFindQueryVariables>(BrandReviewFindDocument, options);
        }
export type BrandReviewFindQueryHookResult = ReturnType<typeof useBrandReviewFindQuery>;
export type BrandReviewFindLazyQueryHookResult = ReturnType<typeof useBrandReviewFindLazyQuery>;
export type BrandReviewFindQueryResult = Apollo.QueryResult<BrandReviewFindQuery, BrandReviewFindQueryVariables>;
export const BrandReviewReasonCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandReviewReasonCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sameNameDifferentSpacing"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oneNameStartsTheOther"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oneNameInsideTheOther"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"possibleMisspelling"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"sameNameDifferentSpacing"},"name":{"kind":"Name","value":"BrandReview_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sameNameDifferentSpacing"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"oneNameStartsTheOther"},"name":{"kind":"Name","value":"BrandReview_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oneNameStartsTheOther"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"oneNameInsideTheOther"},"name":{"kind":"Name","value":"BrandReview_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oneNameInsideTheOther"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"possibleMisspelling"},"name":{"kind":"Name","value":"BrandReview_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"possibleMisspelling"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useBrandReviewReasonCountsQuery__
 *
 * To run a query within a React component, call `useBrandReviewReasonCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandReviewReasonCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandReviewReasonCountsQuery({
 *   variables: {
 *      sameNameDifferentSpacing: // value for 'sameNameDifferentSpacing'
 *      oneNameStartsTheOther: // value for 'oneNameStartsTheOther'
 *      oneNameInsideTheOther: // value for 'oneNameInsideTheOther'
 *      possibleMisspelling: // value for 'possibleMisspelling'
 *   },
 * });
 */
export function useBrandReviewReasonCountsQuery(baseOptions?: Apollo.QueryHookOptions<BrandReviewReasonCountsQuery, BrandReviewReasonCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandReviewReasonCountsQuery, BrandReviewReasonCountsQueryVariables>(BrandReviewReasonCountsDocument, options);
      }
export function useBrandReviewReasonCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandReviewReasonCountsQuery, BrandReviewReasonCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandReviewReasonCountsQuery, BrandReviewReasonCountsQueryVariables>(BrandReviewReasonCountsDocument, options);
        }
export type BrandReviewReasonCountsQueryHookResult = ReturnType<typeof useBrandReviewReasonCountsQuery>;
export type BrandReviewReasonCountsLazyQueryHookResult = ReturnType<typeof useBrandReviewReasonCountsLazyQuery>;
export type BrandReviewReasonCountsQueryResult = Apollo.QueryResult<BrandReviewReasonCountsQuery, BrandReviewReasonCountsQueryVariables>;
export const BrandReviewStatusCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandReviewStatusCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markedForMerge"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ignoreMerge"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notReviewed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"markedForMerge"},"name":{"kind":"Name","value":"BrandReview_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markedForMerge"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"ignoreMerge"},"name":{"kind":"Name","value":"BrandReview_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ignoreMerge"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"notReviewed"},"name":{"kind":"Name","value":"BrandReview_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notReviewed"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useBrandReviewStatusCountsQuery__
 *
 * To run a query within a React component, call `useBrandReviewStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandReviewStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandReviewStatusCountsQuery({
 *   variables: {
 *      markedForMerge: // value for 'markedForMerge'
 *      ignoreMerge: // value for 'ignoreMerge'
 *      notReviewed: // value for 'notReviewed'
 *   },
 * });
 */
export function useBrandReviewStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<BrandReviewStatusCountsQuery, BrandReviewStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandReviewStatusCountsQuery, BrandReviewStatusCountsQueryVariables>(BrandReviewStatusCountsDocument, options);
      }
export function useBrandReviewStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandReviewStatusCountsQuery, BrandReviewStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandReviewStatusCountsQuery, BrandReviewStatusCountsQueryVariables>(BrandReviewStatusCountsDocument, options);
        }
export type BrandReviewStatusCountsQueryHookResult = ReturnType<typeof useBrandReviewStatusCountsQuery>;
export type BrandReviewStatusCountsLazyQueryHookResult = ReturnType<typeof useBrandReviewStatusCountsLazyQuery>;
export type BrandReviewStatusCountsQueryResult = Apollo.QueryResult<BrandReviewStatusCountsQuery, BrandReviewStatusCountsQueryVariables>;
export const BuilderRecomputeRunsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuilderRecomputeRuns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BuilderRecomputeRuns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dagRunId"}},{"kind":"Field","name":{"kind":"Name","value":"dagRunUrl"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"saveComputationToPv2"}},{"kind":"Field","name":{"kind":"Name","value":"runDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bqTables"}},{"kind":"Field","name":{"kind":"Name","value":"bqDatasetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"dataflowJobId"}},{"kind":"Field","name":{"kind":"Name","value":"dataflowState"}},{"kind":"Field","name":{"kind":"Name","value":"dataflowUrl"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useBuilderRecomputeRunsQuery__
 *
 * To run a query within a React component, call `useBuilderRecomputeRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuilderRecomputeRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuilderRecomputeRunsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBuilderRecomputeRunsQuery(baseOptions?: Apollo.QueryHookOptions<BuilderRecomputeRunsQuery, BuilderRecomputeRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuilderRecomputeRunsQuery, BuilderRecomputeRunsQueryVariables>(BuilderRecomputeRunsDocument, options);
      }
export function useBuilderRecomputeRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuilderRecomputeRunsQuery, BuilderRecomputeRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuilderRecomputeRunsQuery, BuilderRecomputeRunsQueryVariables>(BuilderRecomputeRunsDocument, options);
        }
export type BuilderRecomputeRunsQueryHookResult = ReturnType<typeof useBuilderRecomputeRunsQuery>;
export type BuilderRecomputeRunsLazyQueryHookResult = ReturnType<typeof useBuilderRecomputeRunsLazyQuery>;
export type BuilderRecomputeRunsQueryResult = Apollo.QueryResult<BuilderRecomputeRunsQuery, BuilderRecomputeRunsQueryVariables>;
export const ClientFeedbackClientNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientFeedbackClientNames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientFeedbackClientNames"}}]}}]} as unknown as DocumentNode;

/**
 * __useClientFeedbackClientNamesQuery__
 *
 * To run a query within a React component, call `useClientFeedbackClientNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFeedbackClientNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFeedbackClientNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientFeedbackClientNamesQuery(baseOptions?: Apollo.QueryHookOptions<ClientFeedbackClientNamesQuery, ClientFeedbackClientNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFeedbackClientNamesQuery, ClientFeedbackClientNamesQueryVariables>(ClientFeedbackClientNamesDocument, options);
      }
export function useClientFeedbackClientNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFeedbackClientNamesQuery, ClientFeedbackClientNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFeedbackClientNamesQuery, ClientFeedbackClientNamesQueryVariables>(ClientFeedbackClientNamesDocument, options);
        }
export type ClientFeedbackClientNamesQueryHookResult = ReturnType<typeof useClientFeedbackClientNamesQuery>;
export type ClientFeedbackClientNamesLazyQueryHookResult = ReturnType<typeof useClientFeedbackClientNamesLazyQuery>;
export type ClientFeedbackClientNamesQueryResult = Apollo.QueryResult<ClientFeedbackClientNamesQuery, ClientFeedbackClientNamesQueryVariables>;
export const ClientFeedbackPeriodReleasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientFeedbackPeriodReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientFeedbackPeriodReleases"}}]}}]} as unknown as DocumentNode;

/**
 * __useClientFeedbackPeriodReleasesQuery__
 *
 * To run a query within a React component, call `useClientFeedbackPeriodReleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFeedbackPeriodReleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFeedbackPeriodReleasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientFeedbackPeriodReleasesQuery(baseOptions?: Apollo.QueryHookOptions<ClientFeedbackPeriodReleasesQuery, ClientFeedbackPeriodReleasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFeedbackPeriodReleasesQuery, ClientFeedbackPeriodReleasesQueryVariables>(ClientFeedbackPeriodReleasesDocument, options);
      }
export function useClientFeedbackPeriodReleasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFeedbackPeriodReleasesQuery, ClientFeedbackPeriodReleasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFeedbackPeriodReleasesQuery, ClientFeedbackPeriodReleasesQueryVariables>(ClientFeedbackPeriodReleasesDocument, options);
        }
export type ClientFeedbackPeriodReleasesQueryHookResult = ReturnType<typeof useClientFeedbackPeriodReleasesQuery>;
export type ClientFeedbackPeriodReleasesLazyQueryHookResult = ReturnType<typeof useClientFeedbackPeriodReleasesLazyQuery>;
export type ClientFeedbackPeriodReleasesQueryResult = Apollo.QueryResult<ClientFeedbackPeriodReleasesQuery, ClientFeedbackPeriodReleasesQueryVariables>;
export const ClientFeedbackWhoIsSubmittingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientFeedbackWhoIsSubmitting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientFeedbackFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientFeedbackWhoIsSubmitting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"ticketCount"}},{"kind":"Field","name":{"kind":"Name","value":"upcCount"}},{"kind":"Field","name":{"kind":"Name","value":"percentTotalTickets"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useClientFeedbackWhoIsSubmittingQuery__
 *
 * To run a query within a React component, call `useClientFeedbackWhoIsSubmittingQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFeedbackWhoIsSubmittingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFeedbackWhoIsSubmittingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useClientFeedbackWhoIsSubmittingQuery(baseOptions?: Apollo.QueryHookOptions<ClientFeedbackWhoIsSubmittingQuery, ClientFeedbackWhoIsSubmittingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFeedbackWhoIsSubmittingQuery, ClientFeedbackWhoIsSubmittingQueryVariables>(ClientFeedbackWhoIsSubmittingDocument, options);
      }
export function useClientFeedbackWhoIsSubmittingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFeedbackWhoIsSubmittingQuery, ClientFeedbackWhoIsSubmittingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFeedbackWhoIsSubmittingQuery, ClientFeedbackWhoIsSubmittingQueryVariables>(ClientFeedbackWhoIsSubmittingDocument, options);
        }
export type ClientFeedbackWhoIsSubmittingQueryHookResult = ReturnType<typeof useClientFeedbackWhoIsSubmittingQuery>;
export type ClientFeedbackWhoIsSubmittingLazyQueryHookResult = ReturnType<typeof useClientFeedbackWhoIsSubmittingLazyQuery>;
export type ClientFeedbackWhoIsSubmittingQueryResult = Apollo.QueryResult<ClientFeedbackWhoIsSubmittingQuery, ClientFeedbackWhoIsSubmittingQueryVariables>;
export const ClientFeedbackTicketTrendsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientFeedbackTicketTrends"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientFeedbackFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientFeedbackTicketTrends"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"component"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsLast52"}},{"kind":"Field","name":{"kind":"Name","value":"avgWeeklyTickets52"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsLast24"}},{"kind":"Field","name":{"kind":"Name","value":"expectedTickets24"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsLast12"}},{"kind":"Field","name":{"kind":"Name","value":"expectedTickets12"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsLast4"}},{"kind":"Field","name":{"kind":"Name","value":"expectedTickets4"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useClientFeedbackTicketTrendsQuery__
 *
 * To run a query within a React component, call `useClientFeedbackTicketTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFeedbackTicketTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFeedbackTicketTrendsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useClientFeedbackTicketTrendsQuery(baseOptions?: Apollo.QueryHookOptions<ClientFeedbackTicketTrendsQuery, ClientFeedbackTicketTrendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFeedbackTicketTrendsQuery, ClientFeedbackTicketTrendsQueryVariables>(ClientFeedbackTicketTrendsDocument, options);
      }
export function useClientFeedbackTicketTrendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFeedbackTicketTrendsQuery, ClientFeedbackTicketTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFeedbackTicketTrendsQuery, ClientFeedbackTicketTrendsQueryVariables>(ClientFeedbackTicketTrendsDocument, options);
        }
export type ClientFeedbackTicketTrendsQueryHookResult = ReturnType<typeof useClientFeedbackTicketTrendsQuery>;
export type ClientFeedbackTicketTrendsLazyQueryHookResult = ReturnType<typeof useClientFeedbackTicketTrendsLazyQuery>;
export type ClientFeedbackTicketTrendsQueryResult = Apollo.QueryResult<ClientFeedbackTicketTrendsQuery, ClientFeedbackTicketTrendsQueryVariables>;
export const ClientFeedbackAttributeUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientFeedbackAttributeUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientFeedbackFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientFeedbackAttributeUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributeName"}},{"kind":"Field","name":{"kind":"Name","value":"attributeValue"}},{"kind":"Field","name":{"kind":"Name","value":"upcCount"}},{"kind":"Field","name":{"kind":"Name","value":"ticketCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalUpcCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalTicketCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useClientFeedbackAttributeUpdatesQuery__
 *
 * To run a query within a React component, call `useClientFeedbackAttributeUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFeedbackAttributeUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFeedbackAttributeUpdatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useClientFeedbackAttributeUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<ClientFeedbackAttributeUpdatesQuery, ClientFeedbackAttributeUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFeedbackAttributeUpdatesQuery, ClientFeedbackAttributeUpdatesQueryVariables>(ClientFeedbackAttributeUpdatesDocument, options);
      }
export function useClientFeedbackAttributeUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFeedbackAttributeUpdatesQuery, ClientFeedbackAttributeUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFeedbackAttributeUpdatesQuery, ClientFeedbackAttributeUpdatesQueryVariables>(ClientFeedbackAttributeUpdatesDocument, options);
        }
export type ClientFeedbackAttributeUpdatesQueryHookResult = ReturnType<typeof useClientFeedbackAttributeUpdatesQuery>;
export type ClientFeedbackAttributeUpdatesLazyQueryHookResult = ReturnType<typeof useClientFeedbackAttributeUpdatesLazyQuery>;
export type ClientFeedbackAttributeUpdatesQueryResult = Apollo.QueryResult<ClientFeedbackAttributeUpdatesQuery, ClientFeedbackAttributeUpdatesQueryVariables>;
export const ClientFeedbackTicketExtractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientFeedbackTicketExtract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientFeedbackFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDir"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientFeedbackTicketExtract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDir"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDir"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueKey"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"upcCount"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"reporter"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalRowCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useClientFeedbackTicketExtractQuery__
 *
 * To run a query within a React component, call `useClientFeedbackTicketExtractQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFeedbackTicketExtractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFeedbackTicketExtractQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useClientFeedbackTicketExtractQuery(baseOptions?: Apollo.QueryHookOptions<ClientFeedbackTicketExtractQuery, ClientFeedbackTicketExtractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFeedbackTicketExtractQuery, ClientFeedbackTicketExtractQueryVariables>(ClientFeedbackTicketExtractDocument, options);
      }
export function useClientFeedbackTicketExtractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFeedbackTicketExtractQuery, ClientFeedbackTicketExtractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFeedbackTicketExtractQuery, ClientFeedbackTicketExtractQueryVariables>(ClientFeedbackTicketExtractDocument, options);
        }
export type ClientFeedbackTicketExtractQueryHookResult = ReturnType<typeof useClientFeedbackTicketExtractQuery>;
export type ClientFeedbackTicketExtractLazyQueryHookResult = ReturnType<typeof useClientFeedbackTicketExtractLazyQuery>;
export type ClientFeedbackTicketExtractQueryResult = Apollo.QueryResult<ClientFeedbackTicketExtractQuery, ClientFeedbackTicketExtractQueryVariables>;
export const ClientFeedbackCategoryUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientFeedbackCategoryUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientFeedbackFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientFeedbackCategoryUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"upcCount"}},{"kind":"Field","name":{"kind":"Name","value":"ticketCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalUpcCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalTicketCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useClientFeedbackCategoryUpdatesQuery__
 *
 * To run a query within a React component, call `useClientFeedbackCategoryUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFeedbackCategoryUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFeedbackCategoryUpdatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useClientFeedbackCategoryUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<ClientFeedbackCategoryUpdatesQuery, ClientFeedbackCategoryUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFeedbackCategoryUpdatesQuery, ClientFeedbackCategoryUpdatesQueryVariables>(ClientFeedbackCategoryUpdatesDocument, options);
      }
export function useClientFeedbackCategoryUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFeedbackCategoryUpdatesQuery, ClientFeedbackCategoryUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFeedbackCategoryUpdatesQuery, ClientFeedbackCategoryUpdatesQueryVariables>(ClientFeedbackCategoryUpdatesDocument, options);
        }
export type ClientFeedbackCategoryUpdatesQueryHookResult = ReturnType<typeof useClientFeedbackCategoryUpdatesQuery>;
export type ClientFeedbackCategoryUpdatesLazyQueryHookResult = ReturnType<typeof useClientFeedbackCategoryUpdatesLazyQuery>;
export type ClientFeedbackCategoryUpdatesQueryResult = Apollo.QueryResult<ClientFeedbackCategoryUpdatesQuery, ClientFeedbackCategoryUpdatesQueryVariables>;
export const ClientFeedbackProductUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientFeedbackProductUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientFeedbackFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDir"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientFeedbackProductUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDir"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDir"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upc"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"attributeName"}},{"kind":"Field","name":{"kind":"Name","value":"attributeValue"}},{"kind":"Field","name":{"kind":"Name","value":"periodRelease"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalRowCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useClientFeedbackProductUpdatesQuery__
 *
 * To run a query within a React component, call `useClientFeedbackProductUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFeedbackProductUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFeedbackProductUpdatesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useClientFeedbackProductUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<ClientFeedbackProductUpdatesQuery, ClientFeedbackProductUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFeedbackProductUpdatesQuery, ClientFeedbackProductUpdatesQueryVariables>(ClientFeedbackProductUpdatesDocument, options);
      }
export function useClientFeedbackProductUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFeedbackProductUpdatesQuery, ClientFeedbackProductUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFeedbackProductUpdatesQuery, ClientFeedbackProductUpdatesQueryVariables>(ClientFeedbackProductUpdatesDocument, options);
        }
export type ClientFeedbackProductUpdatesQueryHookResult = ReturnType<typeof useClientFeedbackProductUpdatesQuery>;
export type ClientFeedbackProductUpdatesLazyQueryHookResult = ReturnType<typeof useClientFeedbackProductUpdatesLazyQuery>;
export type ClientFeedbackProductUpdatesQueryResult = Apollo.QueryResult<ClientFeedbackProductUpdatesQuery, ClientFeedbackProductUpdatesQueryVariables>;
export const ClientFeedbackRootCausesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientFeedbackRootCauses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientFeedbackFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientFeedbackRootCauses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rootCause"}},{"kind":"Field","name":{"kind":"Name","value":"ticketCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useClientFeedbackRootCausesQuery__
 *
 * To run a query within a React component, call `useClientFeedbackRootCausesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFeedbackRootCausesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFeedbackRootCausesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useClientFeedbackRootCausesQuery(baseOptions?: Apollo.QueryHookOptions<ClientFeedbackRootCausesQuery, ClientFeedbackRootCausesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFeedbackRootCausesQuery, ClientFeedbackRootCausesQueryVariables>(ClientFeedbackRootCausesDocument, options);
      }
export function useClientFeedbackRootCausesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFeedbackRootCausesQuery, ClientFeedbackRootCausesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFeedbackRootCausesQuery, ClientFeedbackRootCausesQueryVariables>(ClientFeedbackRootCausesDocument, options);
        }
export type ClientFeedbackRootCausesQueryHookResult = ReturnType<typeof useClientFeedbackRootCausesQuery>;
export type ClientFeedbackRootCausesLazyQueryHookResult = ReturnType<typeof useClientFeedbackRootCausesLazyQuery>;
export type ClientFeedbackRootCausesQueryResult = Apollo.QueryResult<ClientFeedbackRootCausesQuery, ClientFeedbackRootCausesQueryVariables>;
export const ClientFeedbackAttributeTrendsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientFeedbackAttributeTrends"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientFeedbackFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientFeedbackAttributeTrends"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributeName"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsLast52"}},{"kind":"Field","name":{"kind":"Name","value":"avgWeeklyTickets52"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsLast24"}},{"kind":"Field","name":{"kind":"Name","value":"expectedTickets24"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsLast12"}},{"kind":"Field","name":{"kind":"Name","value":"expectedTickets12"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsLast4"}},{"kind":"Field","name":{"kind":"Name","value":"expectedTickets4"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributeName"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsLast52"}},{"kind":"Field","name":{"kind":"Name","value":"avgWeeklyTickets52"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsLast24"}},{"kind":"Field","name":{"kind":"Name","value":"expectedTickets24"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsLast12"}},{"kind":"Field","name":{"kind":"Name","value":"expectedTickets12"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsLast4"}},{"kind":"Field","name":{"kind":"Name","value":"expectedTickets4"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useClientFeedbackAttributeTrendsQuery__
 *
 * To run a query within a React component, call `useClientFeedbackAttributeTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFeedbackAttributeTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFeedbackAttributeTrendsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useClientFeedbackAttributeTrendsQuery(baseOptions?: Apollo.QueryHookOptions<ClientFeedbackAttributeTrendsQuery, ClientFeedbackAttributeTrendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFeedbackAttributeTrendsQuery, ClientFeedbackAttributeTrendsQueryVariables>(ClientFeedbackAttributeTrendsDocument, options);
      }
export function useClientFeedbackAttributeTrendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFeedbackAttributeTrendsQuery, ClientFeedbackAttributeTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFeedbackAttributeTrendsQuery, ClientFeedbackAttributeTrendsQueryVariables>(ClientFeedbackAttributeTrendsDocument, options);
        }
export type ClientFeedbackAttributeTrendsQueryHookResult = ReturnType<typeof useClientFeedbackAttributeTrendsQuery>;
export type ClientFeedbackAttributeTrendsLazyQueryHookResult = ReturnType<typeof useClientFeedbackAttributeTrendsLazyQuery>;
export type ClientFeedbackAttributeTrendsQueryResult = Apollo.QueryResult<ClientFeedbackAttributeTrendsQuery, ClientFeedbackAttributeTrendsQueryVariables>;
export const ClientTrackerIncorrectAttributeNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientTrackerIncorrectAttributeName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"periodReleaseFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientTrackerIncorrectAttributeName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"periodReleaseFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodReleaseFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"spinsUpc"}},{"kind":"Field","name":{"kind":"Name","value":"attributeName"}},{"kind":"Field","name":{"kind":"Name","value":"jiraAssignee"}},{"kind":"Field","name":{"kind":"Name","value":"jiraClientName"}},{"kind":"Field","name":{"kind":"Name","value":"jiraTicket"}},{"kind":"Field","name":{"kind":"Name","value":"clientValidatedCoding"}},{"kind":"Field","name":{"kind":"Name","value":"periodRelease"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useClientTrackerIncorrectAttributeNameQuery__
 *
 * To run a query within a React component, call `useClientTrackerIncorrectAttributeNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientTrackerIncorrectAttributeNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientTrackerIncorrectAttributeNameQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      searchFilter: // value for 'searchFilter'
 *      periodReleaseFilter: // value for 'periodReleaseFilter'
 *   },
 * });
 */
export function useClientTrackerIncorrectAttributeNameQuery(baseOptions?: Apollo.QueryHookOptions<ClientTrackerIncorrectAttributeNameQuery, ClientTrackerIncorrectAttributeNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientTrackerIncorrectAttributeNameQuery, ClientTrackerIncorrectAttributeNameQueryVariables>(ClientTrackerIncorrectAttributeNameDocument, options);
      }
export function useClientTrackerIncorrectAttributeNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientTrackerIncorrectAttributeNameQuery, ClientTrackerIncorrectAttributeNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientTrackerIncorrectAttributeNameQuery, ClientTrackerIncorrectAttributeNameQueryVariables>(ClientTrackerIncorrectAttributeNameDocument, options);
        }
export type ClientTrackerIncorrectAttributeNameQueryHookResult = ReturnType<typeof useClientTrackerIncorrectAttributeNameQuery>;
export type ClientTrackerIncorrectAttributeNameLazyQueryHookResult = ReturnType<typeof useClientTrackerIncorrectAttributeNameLazyQuery>;
export type ClientTrackerIncorrectAttributeNameQueryResult = Apollo.QueryResult<ClientTrackerIncorrectAttributeNameQuery, ClientTrackerIncorrectAttributeNameQueryVariables>;
export const ClientTrackerMismatchesPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientTrackerMismatchesPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"periodReleaseFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientTrackerMismatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"periodReleaseFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodReleaseFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spinsUpc"}},{"kind":"Field","name":{"kind":"Name","value":"jiraTicket"}},{"kind":"Field","name":{"kind":"Name","value":"jiraClientName"}},{"kind":"Field","name":{"kind":"Name","value":"jiraAssignee"}},{"kind":"Field","name":{"kind":"Name","value":"clientValidatedCoding"}},{"kind":"Field","name":{"kind":"Name","value":"periodRelease"}},{"kind":"Field","name":{"kind":"Name","value":"mismatchedAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"attributeName"}},{"kind":"Field","name":{"kind":"Name","value":"attributeInSpinsAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"clientTrackerValue"}},{"kind":"Field","name":{"kind":"Name","value":"spinsAttributeValue"}},{"kind":"Field","name":{"kind":"Name","value":"mismatchType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useClientTrackerMismatchesPageQuery__
 *
 * To run a query within a React component, call `useClientTrackerMismatchesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientTrackerMismatchesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientTrackerMismatchesPageQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      searchFilter: // value for 'searchFilter'
 *      periodReleaseFilter: // value for 'periodReleaseFilter'
 *   },
 * });
 */
export function useClientTrackerMismatchesPageQuery(baseOptions?: Apollo.QueryHookOptions<ClientTrackerMismatchesPageQuery, ClientTrackerMismatchesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientTrackerMismatchesPageQuery, ClientTrackerMismatchesPageQueryVariables>(ClientTrackerMismatchesPageDocument, options);
      }
export function useClientTrackerMismatchesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientTrackerMismatchesPageQuery, ClientTrackerMismatchesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientTrackerMismatchesPageQuery, ClientTrackerMismatchesPageQueryVariables>(ClientTrackerMismatchesPageDocument, options);
        }
export type ClientTrackerMismatchesPageQueryHookResult = ReturnType<typeof useClientTrackerMismatchesPageQuery>;
export type ClientTrackerMismatchesPageLazyQueryHookResult = ReturnType<typeof useClientTrackerMismatchesPageLazyQuery>;
export type ClientTrackerMismatchesPageQueryResult = Apollo.QueryResult<ClientTrackerMismatchesPageQuery, ClientTrackerMismatchesPageQueryVariables>;
export const ClientTrackerMismatchesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientTrackerMismatchesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"periodReleaseFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientTrackerMismatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"periodReleaseFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodReleaseFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useClientTrackerMismatchesCountQuery__
 *
 * To run a query within a React component, call `useClientTrackerMismatchesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientTrackerMismatchesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientTrackerMismatchesCountQuery({
 *   variables: {
 *      periodReleaseFilter: // value for 'periodReleaseFilter'
 *   },
 * });
 */
export function useClientTrackerMismatchesCountQuery(baseOptions?: Apollo.QueryHookOptions<ClientTrackerMismatchesCountQuery, ClientTrackerMismatchesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientTrackerMismatchesCountQuery, ClientTrackerMismatchesCountQueryVariables>(ClientTrackerMismatchesCountDocument, options);
      }
export function useClientTrackerMismatchesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientTrackerMismatchesCountQuery, ClientTrackerMismatchesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientTrackerMismatchesCountQuery, ClientTrackerMismatchesCountQueryVariables>(ClientTrackerMismatchesCountDocument, options);
        }
export type ClientTrackerMismatchesCountQueryHookResult = ReturnType<typeof useClientTrackerMismatchesCountQuery>;
export type ClientTrackerMismatchesCountLazyQueryHookResult = ReturnType<typeof useClientTrackerMismatchesCountLazyQuery>;
export type ClientTrackerMismatchesCountQueryResult = Apollo.QueryResult<ClientTrackerMismatchesCountQuery, ClientTrackerMismatchesCountQueryVariables>;
export const ClientTrackerValueCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientTrackerValueCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientTrackerValue_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useClientTrackerValueCountQuery__
 *
 * To run a query within a React component, call `useClientTrackerValueCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientTrackerValueCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientTrackerValueCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useClientTrackerValueCountQuery(baseOptions?: Apollo.QueryHookOptions<ClientTrackerValueCountQuery, ClientTrackerValueCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientTrackerValueCountQuery, ClientTrackerValueCountQueryVariables>(ClientTrackerValueCountDocument, options);
      }
export function useClientTrackerValueCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientTrackerValueCountQuery, ClientTrackerValueCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientTrackerValueCountQuery, ClientTrackerValueCountQueryVariables>(ClientTrackerValueCountDocument, options);
        }
export type ClientTrackerValueCountQueryHookResult = ReturnType<typeof useClientTrackerValueCountQuery>;
export type ClientTrackerValueCountLazyQueryHookResult = ReturnType<typeof useClientTrackerValueCountLazyQuery>;
export type ClientTrackerValueCountQueryResult = Apollo.QueryResult<ClientTrackerValueCountQuery, ClientTrackerValueCountQueryVariables>;
export const ClientTrackerValueFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientTrackerValueFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientTrackerValue_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"spinsUpc"}},{"kind":"Field","name":{"kind":"Name","value":"attributeName"}},{"kind":"Field","name":{"kind":"Name","value":"attributeValue"}},{"kind":"Field","name":{"kind":"Name","value":"clientValidatedCoding"}},{"kind":"Field","name":{"kind":"Name","value":"jiraTicket"}},{"kind":"Field","name":{"kind":"Name","value":"jiraClientName"}},{"kind":"Field","name":{"kind":"Name","value":"jiraAssignee"}},{"kind":"Field","name":{"kind":"Name","value":"periodRelease"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useClientTrackerValueFindQuery__
 *
 * To run a query within a React component, call `useClientTrackerValueFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientTrackerValueFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientTrackerValueFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useClientTrackerValueFindQuery(baseOptions?: Apollo.QueryHookOptions<ClientTrackerValueFindQuery, ClientTrackerValueFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientTrackerValueFindQuery, ClientTrackerValueFindQueryVariables>(ClientTrackerValueFindDocument, options);
      }
export function useClientTrackerValueFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientTrackerValueFindQuery, ClientTrackerValueFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientTrackerValueFindQuery, ClientTrackerValueFindQueryVariables>(ClientTrackerValueFindDocument, options);
        }
export type ClientTrackerValueFindQueryHookResult = ReturnType<typeof useClientTrackerValueFindQuery>;
export type ClientTrackerValueFindLazyQueryHookResult = ReturnType<typeof useClientTrackerValueFindLazyQuery>;
export type ClientTrackerValueFindQueryResult = Apollo.QueryResult<ClientTrackerValueFindQuery, ClientTrackerValueFindQueryVariables>;
export const CostAndBillingMonthlyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CostAndBillingMonthly"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numberOfMonths"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Cost_And_Billing_Monthly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"numberOfMonths"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numberOfMonths"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"costs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCostAndBillingMonthlyQuery__
 *
 * To run a query within a React component, call `useCostAndBillingMonthlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostAndBillingMonthlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostAndBillingMonthlyQuery({
 *   variables: {
 *      numberOfMonths: // value for 'numberOfMonths'
 *   },
 * });
 */
export function useCostAndBillingMonthlyQuery(baseOptions: Apollo.QueryHookOptions<CostAndBillingMonthlyQuery, CostAndBillingMonthlyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CostAndBillingMonthlyQuery, CostAndBillingMonthlyQueryVariables>(CostAndBillingMonthlyDocument, options);
      }
export function useCostAndBillingMonthlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CostAndBillingMonthlyQuery, CostAndBillingMonthlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CostAndBillingMonthlyQuery, CostAndBillingMonthlyQueryVariables>(CostAndBillingMonthlyDocument, options);
        }
export type CostAndBillingMonthlyQueryHookResult = ReturnType<typeof useCostAndBillingMonthlyQuery>;
export type CostAndBillingMonthlyLazyQueryHookResult = ReturnType<typeof useCostAndBillingMonthlyLazyQuery>;
export type CostAndBillingMonthlyQueryResult = Apollo.QueryResult<CostAndBillingMonthlyQuery, CostAndBillingMonthlyQueryVariables>;
export const CostAndBillingDailyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CostAndBillingDaily"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Cost_And_Billing_Daily"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"costs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCostAndBillingDailyQuery__
 *
 * To run a query within a React component, call `useCostAndBillingDailyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostAndBillingDailyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostAndBillingDailyQuery({
 *   variables: {
 *   },
 * });
 */
export function useCostAndBillingDailyQuery(baseOptions?: Apollo.QueryHookOptions<CostAndBillingDailyQuery, CostAndBillingDailyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CostAndBillingDailyQuery, CostAndBillingDailyQueryVariables>(CostAndBillingDailyDocument, options);
      }
export function useCostAndBillingDailyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CostAndBillingDailyQuery, CostAndBillingDailyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CostAndBillingDailyQuery, CostAndBillingDailyQueryVariables>(CostAndBillingDailyDocument, options);
        }
export type CostAndBillingDailyQueryHookResult = ReturnType<typeof useCostAndBillingDailyQuery>;
export type CostAndBillingDailyLazyQueryHookResult = ReturnType<typeof useCostAndBillingDailyLazyQuery>;
export type CostAndBillingDailyQueryResult = Apollo.QueryResult<CostAndBillingDailyQuery, CostAndBillingDailyQueryVariables>;
export const CountImagesToProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountImagesToProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pv2Filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tag"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sources"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CountImagesToProcess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pv2Filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pv2Filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"tag"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tag"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"sides"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sides"}}},{"kind":"Argument","name":{"kind":"Name","value":"sources"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sources"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useCountImagesToProcessQuery__
 *
 * To run a query within a React component, call `useCountImagesToProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountImagesToProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountImagesToProcessQuery({
 *   variables: {
 *      pv2Filter: // value for 'pv2Filter'
 *      tag: // value for 'tag'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sides: // value for 'sides'
 *      sources: // value for 'sources'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useCountImagesToProcessQuery(baseOptions?: Apollo.QueryHookOptions<CountImagesToProcessQuery, CountImagesToProcessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountImagesToProcessQuery, CountImagesToProcessQueryVariables>(CountImagesToProcessDocument, options);
      }
export function useCountImagesToProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountImagesToProcessQuery, CountImagesToProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountImagesToProcessQuery, CountImagesToProcessQueryVariables>(CountImagesToProcessDocument, options);
        }
export type CountImagesToProcessQueryHookResult = ReturnType<typeof useCountImagesToProcessQuery>;
export type CountImagesToProcessLazyQueryHookResult = ReturnType<typeof useCountImagesToProcessLazyQuery>;
export type CountImagesToProcessQueryResult = Apollo.QueryResult<CountImagesToProcessQuery, CountImagesToProcessQueryVariables>;
export const DownloadImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloadImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DownloadImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"highPriorityImageCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDownloadImagesQuery__
 *
 * To run a query within a React component, call `useDownloadImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadImagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDownloadImagesQuery(baseOptions?: Apollo.QueryHookOptions<DownloadImagesQuery, DownloadImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadImagesQuery, DownloadImagesQueryVariables>(DownloadImagesDocument, options);
      }
export function useDownloadImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadImagesQuery, DownloadImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadImagesQuery, DownloadImagesQueryVariables>(DownloadImagesDocument, options);
        }
export type DownloadImagesQueryHookResult = ReturnType<typeof useDownloadImagesQuery>;
export type DownloadImagesLazyQueryHookResult = ReturnType<typeof useDownloadImagesLazyQuery>;
export type DownloadImagesQueryResult = Apollo.QueryResult<DownloadImagesQuery, DownloadImagesQueryVariables>;
export const EnvironmentInfo_GetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EnvironmentInfo_get"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EnvironmentInfo_get"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureName"}},{"kind":"Field","name":{"kind":"Name","value":"cloudEnv"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useEnvironmentInfo_GetQuery__
 *
 * To run a query within a React component, call `useEnvironmentInfo_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentInfo_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentInfo_GetQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnvironmentInfo_GetQuery(baseOptions?: Apollo.QueryHookOptions<EnvironmentInfo_GetQuery, EnvironmentInfo_GetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentInfo_GetQuery, EnvironmentInfo_GetQueryVariables>(EnvironmentInfo_GetDocument, options);
      }
export function useEnvironmentInfo_GetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentInfo_GetQuery, EnvironmentInfo_GetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentInfo_GetQuery, EnvironmentInfo_GetQueryVariables>(EnvironmentInfo_GetDocument, options);
        }
export type EnvironmentInfo_GetQueryHookResult = ReturnType<typeof useEnvironmentInfo_GetQuery>;
export type EnvironmentInfo_GetLazyQueryHookResult = ReturnType<typeof useEnvironmentInfo_GetLazyQuery>;
export type EnvironmentInfo_GetQueryResult = Apollo.QueryResult<EnvironmentInfo_GetQuery, EnvironmentInfo_GetQueryVariables>;
export const FeatureFlags_GetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeatureFlags_get"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureFlags_get"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useFeatureFlags_GetQuery__
 *
 * To run a query within a React component, call `useFeatureFlags_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlags_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlags_GetQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureFlags_GetQuery(baseOptions?: Apollo.QueryHookOptions<FeatureFlags_GetQuery, FeatureFlags_GetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureFlags_GetQuery, FeatureFlags_GetQueryVariables>(FeatureFlags_GetDocument, options);
      }
export function useFeatureFlags_GetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlags_GetQuery, FeatureFlags_GetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureFlags_GetQuery, FeatureFlags_GetQueryVariables>(FeatureFlags_GetDocument, options);
        }
export type FeatureFlags_GetQueryHookResult = ReturnType<typeof useFeatureFlags_GetQuery>;
export type FeatureFlags_GetLazyQueryHookResult = ReturnType<typeof useFeatureFlags_GetLazyQuery>;
export type FeatureFlags_GetQueryResult = Apollo.QueryResult<FeatureFlags_GetQuery, FeatureFlags_GetQueryVariables>;
export const FetchImageSidesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchImageSides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FetchImageSides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sides"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useFetchImageSidesQuery__
 *
 * To run a query within a React component, call `useFetchImageSidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchImageSidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchImageSidesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchImageSidesQuery(baseOptions?: Apollo.QueryHookOptions<FetchImageSidesQuery, FetchImageSidesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchImageSidesQuery, FetchImageSidesQueryVariables>(FetchImageSidesDocument, options);
      }
export function useFetchImageSidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchImageSidesQuery, FetchImageSidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchImageSidesQuery, FetchImageSidesQueryVariables>(FetchImageSidesDocument, options);
        }
export type FetchImageSidesQueryHookResult = ReturnType<typeof useFetchImageSidesQuery>;
export type FetchImageSidesLazyQueryHookResult = ReturnType<typeof useFetchImageSidesLazyQuery>;
export type FetchImageSidesQueryResult = Apollo.QueryResult<FetchImageSidesQuery, FetchImageSidesQueryVariables>;
export const FetchImageSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchImageSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FetchImageSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useFetchImageSourcesQuery__
 *
 * To run a query within a React component, call `useFetchImageSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchImageSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchImageSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchImageSourcesQuery(baseOptions?: Apollo.QueryHookOptions<FetchImageSourcesQuery, FetchImageSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchImageSourcesQuery, FetchImageSourcesQueryVariables>(FetchImageSourcesDocument, options);
      }
export function useFetchImageSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchImageSourcesQuery, FetchImageSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchImageSourcesQuery, FetchImageSourcesQueryVariables>(FetchImageSourcesDocument, options);
        }
export type FetchImageSourcesQueryHookResult = ReturnType<typeof useFetchImageSourcesQuery>;
export type FetchImageSourcesLazyQueryHookResult = ReturnType<typeof useFetchImageSourcesLazyQuery>;
export type FetchImageSourcesQueryResult = Apollo.QueryResult<FetchImageSourcesQuery, FetchImageSourcesQueryVariables>;
export const FindImagesToProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindImagesToProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pv2Filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tag"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sources"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FindImagesToProcess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"pv2Filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pv2Filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"tag"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tag"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"sides"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sides"}}},{"kind":"Argument","name":{"kind":"Name","value":"sources"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sources"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pv2Id"}},{"kind":"Field","name":{"kind":"Name","value":"pv2Name"}},{"kind":"Field","name":{"kind":"Name","value":"pv2GTIN"}},{"kind":"Field","name":{"kind":"Name","value":"pv2Domain"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useFindImagesToProcessQuery__
 *
 * To run a query within a React component, call `useFindImagesToProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindImagesToProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindImagesToProcessQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      pv2Filter: // value for 'pv2Filter'
 *      tag: // value for 'tag'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sides: // value for 'sides'
 *      sources: // value for 'sources'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useFindImagesToProcessQuery(baseOptions?: Apollo.QueryHookOptions<FindImagesToProcessQuery, FindImagesToProcessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindImagesToProcessQuery, FindImagesToProcessQueryVariables>(FindImagesToProcessDocument, options);
      }
export function useFindImagesToProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindImagesToProcessQuery, FindImagesToProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindImagesToProcessQuery, FindImagesToProcessQueryVariables>(FindImagesToProcessDocument, options);
        }
export type FindImagesToProcessQueryHookResult = ReturnType<typeof useFindImagesToProcessQuery>;
export type FindImagesToProcessLazyQueryHookResult = ReturnType<typeof useFindImagesToProcessLazyQuery>;
export type FindImagesToProcessQueryResult = Apollo.QueryResult<FindImagesToProcessQuery, FindImagesToProcessQueryVariables>;
export const GenerateTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GenerateToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGenerateTokenQuery__
 *
 * To run a query within a React component, call `useGenerateTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateTokenQuery(baseOptions?: Apollo.QueryHookOptions<GenerateTokenQuery, GenerateTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateTokenQuery, GenerateTokenQueryVariables>(GenerateTokenDocument, options);
      }
export function useGenerateTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateTokenQuery, GenerateTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateTokenQuery, GenerateTokenQueryVariables>(GenerateTokenDocument, options);
        }
export type GenerateTokenQueryHookResult = ReturnType<typeof useGenerateTokenQuery>;
export type GenerateTokenLazyQueryHookResult = ReturnType<typeof useGenerateTokenLazyQuery>;
export type GenerateTokenQueryResult = Apollo.QueryResult<GenerateTokenQuery, GenerateTokenQueryVariables>;
export const GetAllServicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetAllServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"vmLoggingUrl"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetAllServicesQuery__
 *
 * To run a query within a React component, call `useGetAllServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllServicesQuery, GetAllServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllServicesQuery, GetAllServicesQueryVariables>(GetAllServicesDocument, options);
      }
export function useGetAllServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllServicesQuery, GetAllServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllServicesQuery, GetAllServicesQueryVariables>(GetAllServicesDocument, options);
        }
export type GetAllServicesQueryHookResult = ReturnType<typeof useGetAllServicesQuery>;
export type GetAllServicesLazyQueryHookResult = ReturnType<typeof useGetAllServicesLazyQuery>;
export type GetAllServicesQueryResult = Apollo.QueryResult<GetAllServicesQuery, GetAllServicesQueryVariables>;
export const GetSignedFileLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSignedFileLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetSignedFileLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetSignedFileLinkQuery__
 *
 * To run a query within a React component, call `useGetSignedFileLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedFileLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedFileLinkQuery({
 *   variables: {
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetSignedFileLinkQuery(baseOptions: Apollo.QueryHookOptions<GetSignedFileLinkQuery, GetSignedFileLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedFileLinkQuery, GetSignedFileLinkQueryVariables>(GetSignedFileLinkDocument, options);
      }
export function useGetSignedFileLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedFileLinkQuery, GetSignedFileLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedFileLinkQuery, GetSignedFileLinkQueryVariables>(GetSignedFileLinkDocument, options);
        }
export type GetSignedFileLinkQueryHookResult = ReturnType<typeof useGetSignedFileLinkQuery>;
export type GetSignedFileLinkLazyQueryHookResult = ReturnType<typeof useGetSignedFileLinkLazyQuery>;
export type GetSignedFileLinkQueryResult = Apollo.QueryResult<GetSignedFileLinkQuery, GetSignedFileLinkQueryVariables>;
export const ModelCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ModelCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelNameEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputList"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListVariable"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModelCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputList"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputList"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useModelCountQuery__
 *
 * To run a query within a React component, call `useModelCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelCountQuery({
 *   variables: {
 *      model: // value for 'model'
 *      query: // value for 'query'
 *      inputList: // value for 'inputList'
 *   },
 * });
 */
export function useModelCountQuery(baseOptions: Apollo.QueryHookOptions<ModelCountQuery, ModelCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelCountQuery, ModelCountQueryVariables>(ModelCountDocument, options);
      }
export function useModelCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelCountQuery, ModelCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelCountQuery, ModelCountQueryVariables>(ModelCountDocument, options);
        }
export type ModelCountQueryHookResult = ReturnType<typeof useModelCountQuery>;
export type ModelCountLazyQueryHookResult = ReturnType<typeof useModelCountLazyQuery>;
export type ModelCountQueryResult = Apollo.QueryResult<ModelCountQuery, ModelCountQueryVariables>;
export const HierarchyMapping_FindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HierarchyMapping_find"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"HierarchyMapping_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingFragment"}}]}}]}}]}},...HierarchyMappingFragmentFragmentDoc.definitions,...TaxonomyFragmentFragmentDoc.definitions,...HierarchyMappingRuleFragmentDoc.definitions,...HierarchyMappingLookupOptionFragmentDoc.definitions,...HierarchyMappingConditionFragmentDoc.definitions,...HierarchyMappingChildRuleFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useHierarchyMapping_FindQuery__
 *
 * To run a query within a React component, call `useHierarchyMapping_FindQuery` and pass it any options that fit your needs.
 * When your component renders, `useHierarchyMapping_FindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHierarchyMapping_FindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useHierarchyMapping_FindQuery(baseOptions?: Apollo.QueryHookOptions<HierarchyMapping_FindQuery, HierarchyMapping_FindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HierarchyMapping_FindQuery, HierarchyMapping_FindQueryVariables>(HierarchyMapping_FindDocument, options);
      }
export function useHierarchyMapping_FindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HierarchyMapping_FindQuery, HierarchyMapping_FindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HierarchyMapping_FindQuery, HierarchyMapping_FindQueryVariables>(HierarchyMapping_FindDocument, options);
        }
export type HierarchyMapping_FindQueryHookResult = ReturnType<typeof useHierarchyMapping_FindQuery>;
export type HierarchyMapping_FindLazyQueryHookResult = ReturnType<typeof useHierarchyMapping_FindLazyQuery>;
export type HierarchyMapping_FindQueryResult = Apollo.QueryResult<HierarchyMapping_FindQuery, HierarchyMapping_FindQueryVariables>;
export const HierarchyMappingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HierarchyMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"HierarchyMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingFragment"}}]}}]}},...HierarchyMappingFragmentFragmentDoc.definitions,...TaxonomyFragmentFragmentDoc.definitions,...HierarchyMappingRuleFragmentDoc.definitions,...HierarchyMappingLookupOptionFragmentDoc.definitions,...HierarchyMappingConditionFragmentDoc.definitions,...HierarchyMappingChildRuleFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useHierarchyMappingQuery__
 *
 * To run a query within a React component, call `useHierarchyMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useHierarchyMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHierarchyMappingQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useHierarchyMappingQuery(baseOptions: Apollo.QueryHookOptions<HierarchyMappingQuery, HierarchyMappingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HierarchyMappingQuery, HierarchyMappingQueryVariables>(HierarchyMappingDocument, options);
      }
export function useHierarchyMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HierarchyMappingQuery, HierarchyMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HierarchyMappingQuery, HierarchyMappingQueryVariables>(HierarchyMappingDocument, options);
        }
export type HierarchyMappingQueryHookResult = ReturnType<typeof useHierarchyMappingQuery>;
export type HierarchyMappingLazyQueryHookResult = ReturnType<typeof useHierarchyMappingLazyQuery>;
export type HierarchyMappingQueryResult = Apollo.QueryResult<HierarchyMappingQuery, HierarchyMappingQueryVariables>;
export const HierarchyMapping_BulkEvaluateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HierarchyMapping_bulkEvaluate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pv2Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"HierarchyMapping_bulkEvaluate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pv2Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pv2Ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingBulkEvaluationResultItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keycatInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingKeycatInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hierarchies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingTaxonomyInfo"}}]}}]}}]}},...HierarchyMappingBulkEvaluationResultItemFragmentDoc.definitions,...HierarchyMappingAttributeValueFragmentDoc.definitions,...HierarchyMappingKeycatInfoFragmentDoc.definitions,...HierarchyMappingTaxonomyInfoFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useHierarchyMapping_BulkEvaluateQuery__
 *
 * To run a query within a React component, call `useHierarchyMapping_BulkEvaluateQuery` and pass it any options that fit your needs.
 * When your component renders, `useHierarchyMapping_BulkEvaluateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHierarchyMapping_BulkEvaluateQuery({
 *   variables: {
 *      pv2Ids: // value for 'pv2Ids'
 *   },
 * });
 */
export function useHierarchyMapping_BulkEvaluateQuery(baseOptions: Apollo.QueryHookOptions<HierarchyMapping_BulkEvaluateQuery, HierarchyMapping_BulkEvaluateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HierarchyMapping_BulkEvaluateQuery, HierarchyMapping_BulkEvaluateQueryVariables>(HierarchyMapping_BulkEvaluateDocument, options);
      }
export function useHierarchyMapping_BulkEvaluateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HierarchyMapping_BulkEvaluateQuery, HierarchyMapping_BulkEvaluateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HierarchyMapping_BulkEvaluateQuery, HierarchyMapping_BulkEvaluateQueryVariables>(HierarchyMapping_BulkEvaluateDocument, options);
        }
export type HierarchyMapping_BulkEvaluateQueryHookResult = ReturnType<typeof useHierarchyMapping_BulkEvaluateQuery>;
export type HierarchyMapping_BulkEvaluateLazyQueryHookResult = ReturnType<typeof useHierarchyMapping_BulkEvaluateLazyQuery>;
export type HierarchyMapping_BulkEvaluateQueryResult = Apollo.QueryResult<HierarchyMapping_BulkEvaluateQuery, HierarchyMapping_BulkEvaluateQueryVariables>;
export const HierarchyMapping_EvaluateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HierarchyMapping_evaluate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pv2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mapping"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HierarchyMappingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"HierarchyMapping_evaluate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pv2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pv2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"mapping"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mapping"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mappedTaxonomyId"}},{"kind":"Field","name":{"kind":"Name","value":"keycat"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicable"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HierarchyMappingOuterRuleEvaluation"}}]}}]}}]}},...HierarchyMappingOuterRuleEvaluationFragmentDoc.definitions,...HierarchyMappingLeafRuleEvaluationFragmentDoc.definitions,...HierarchyConditionEvaluationFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useHierarchyMapping_EvaluateQuery__
 *
 * To run a query within a React component, call `useHierarchyMapping_EvaluateQuery` and pass it any options that fit your needs.
 * When your component renders, `useHierarchyMapping_EvaluateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHierarchyMapping_EvaluateQuery({
 *   variables: {
 *      pv2Id: // value for 'pv2Id'
 *      mapping: // value for 'mapping'
 *   },
 * });
 */
export function useHierarchyMapping_EvaluateQuery(baseOptions: Apollo.QueryHookOptions<HierarchyMapping_EvaluateQuery, HierarchyMapping_EvaluateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HierarchyMapping_EvaluateQuery, HierarchyMapping_EvaluateQueryVariables>(HierarchyMapping_EvaluateDocument, options);
      }
export function useHierarchyMapping_EvaluateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HierarchyMapping_EvaluateQuery, HierarchyMapping_EvaluateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HierarchyMapping_EvaluateQuery, HierarchyMapping_EvaluateQueryVariables>(HierarchyMapping_EvaluateDocument, options);
        }
export type HierarchyMapping_EvaluateQueryHookResult = ReturnType<typeof useHierarchyMapping_EvaluateQuery>;
export type HierarchyMapping_EvaluateLazyQueryHookResult = ReturnType<typeof useHierarchyMapping_EvaluateLazyQuery>;
export type HierarchyMapping_EvaluateQueryResult = Apollo.QueryResult<HierarchyMapping_EvaluateQuery, HierarchyMapping_EvaluateQueryVariables>;
export const HistoryGetSummariesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HistoryGetSummaries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"HistoryGet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"modelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"modelId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useHistoryGetSummariesQuery__
 *
 * To run a query within a React component, call `useHistoryGetSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoryGetSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryGetSummariesQuery({
 *   variables: {
 *      model: // value for 'model'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useHistoryGetSummariesQuery(baseOptions: Apollo.QueryHookOptions<HistoryGetSummariesQuery, HistoryGetSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoryGetSummariesQuery, HistoryGetSummariesQueryVariables>(HistoryGetSummariesDocument, options);
      }
export function useHistoryGetSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoryGetSummariesQuery, HistoryGetSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoryGetSummariesQuery, HistoryGetSummariesQueryVariables>(HistoryGetSummariesDocument, options);
        }
export type HistoryGetSummariesQueryHookResult = ReturnType<typeof useHistoryGetSummariesQuery>;
export type HistoryGetSummariesLazyQueryHookResult = ReturnType<typeof useHistoryGetSummariesLazyQuery>;
export type HistoryGetSummariesQueryResult = Apollo.QueryResult<HistoryGetSummariesQuery, HistoryGetSummariesQueryVariables>;
export const HistoryGetVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HistoryGetVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"HistoryGetVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"modelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"modelId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useHistoryGetVersionQuery__
 *
 * To run a query within a React component, call `useHistoryGetVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoryGetVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryGetVersionQuery({
 *   variables: {
 *      model: // value for 'model'
 *      modelId: // value for 'modelId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useHistoryGetVersionQuery(baseOptions: Apollo.QueryHookOptions<HistoryGetVersionQuery, HistoryGetVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoryGetVersionQuery, HistoryGetVersionQueryVariables>(HistoryGetVersionDocument, options);
      }
export function useHistoryGetVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoryGetVersionQuery, HistoryGetVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoryGetVersionQuery, HistoryGetVersionQueryVariables>(HistoryGetVersionDocument, options);
        }
export type HistoryGetVersionQueryHookResult = ReturnType<typeof useHistoryGetVersionQuery>;
export type HistoryGetVersionLazyQueryHookResult = ReturnType<typeof useHistoryGetVersionLazyQuery>;
export type HistoryGetVersionQueryResult = Apollo.QueryResult<HistoryGetVersionQuery, HistoryGetVersionQueryVariables>;
export const ImageAnnotatorInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImageAnnotatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ImageAnnotator_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"durationInSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"prerequisites"}},{"kind":"Field","name":{"kind":"Name","value":"annotations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_position"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"prerequisites"}},{"kind":"Field","name":{"kind":"Name","value":"ref_name"}},{"kind":"Field","name":{"kind":"Name","value":"reference_confidence_value"}},{"kind":"Field","name":{"kind":"Name","value":"returns"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useImageAnnotatorInfoQuery__
 *
 * To run a query within a React component, call `useImageAnnotatorInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageAnnotatorInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageAnnotatorInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useImageAnnotatorInfoQuery(baseOptions?: Apollo.QueryHookOptions<ImageAnnotatorInfoQuery, ImageAnnotatorInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageAnnotatorInfoQuery, ImageAnnotatorInfoQueryVariables>(ImageAnnotatorInfoDocument, options);
      }
export function useImageAnnotatorInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageAnnotatorInfoQuery, ImageAnnotatorInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageAnnotatorInfoQuery, ImageAnnotatorInfoQueryVariables>(ImageAnnotatorInfoDocument, options);
        }
export type ImageAnnotatorInfoQueryHookResult = ReturnType<typeof useImageAnnotatorInfoQuery>;
export type ImageAnnotatorInfoLazyQueryHookResult = ReturnType<typeof useImageAnnotatorInfoLazyQuery>;
export type ImageAnnotatorInfoQueryResult = Apollo.QueryResult<ImageAnnotatorInfoQuery, ImageAnnotatorInfoQueryVariables>;
export const ImageProcessingQueueStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImageProcessingQueueStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ImageProcessingQueueStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highPriorityImageCount"}},{"kind":"Field","name":{"kind":"Name","value":"regularPriorityImageCount"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedImageCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useImageProcessingQueueStatsQuery__
 *
 * To run a query within a React component, call `useImageProcessingQueueStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageProcessingQueueStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageProcessingQueueStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useImageProcessingQueueStatsQuery(baseOptions?: Apollo.QueryHookOptions<ImageProcessingQueueStatsQuery, ImageProcessingQueueStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageProcessingQueueStatsQuery, ImageProcessingQueueStatsQueryVariables>(ImageProcessingQueueStatsDocument, options);
      }
export function useImageProcessingQueueStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageProcessingQueueStatsQuery, ImageProcessingQueueStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageProcessingQueueStatsQuery, ImageProcessingQueueStatsQueryVariables>(ImageProcessingQueueStatsDocument, options);
        }
export type ImageProcessingQueueStatsQueryHookResult = ReturnType<typeof useImageProcessingQueueStatsQuery>;
export type ImageProcessingQueueStatsLazyQueryHookResult = ReturnType<typeof useImageProcessingQueueStatsLazyQuery>;
export type ImageProcessingQueueStatsQueryResult = Apollo.QueryResult<ImageProcessingQueueStatsQuery, ImageProcessingQueueStatsQueryVariables>;
export const IngredientDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IngredientDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IngredientDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pv2Total"}},{"kind":"Field","name":{"kind":"Name","value":"leafTaxonomies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"breadcrumb"}},{"kind":"Field","name":{"kind":"Name","value":"pv2Count"}},{"kind":"Field","name":{"kind":"Name","value":"pv2s"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ingredientAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useIngredientDetailsQuery__
 *
 * To run a query within a React component, call `useIngredientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIngredientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngredientDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIngredientDetailsQuery(baseOptions: Apollo.QueryHookOptions<IngredientDetailsQuery, IngredientDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IngredientDetailsQuery, IngredientDetailsQueryVariables>(IngredientDetailsDocument, options);
      }
export function useIngredientDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IngredientDetailsQuery, IngredientDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IngredientDetailsQuery, IngredientDetailsQueryVariables>(IngredientDetailsDocument, options);
        }
export type IngredientDetailsQueryHookResult = ReturnType<typeof useIngredientDetailsQuery>;
export type IngredientDetailsLazyQueryHookResult = ReturnType<typeof useIngredientDetailsLazyQuery>;
export type IngredientDetailsQueryResult = Apollo.QueryResult<IngredientDetailsQuery, IngredientDetailsQueryVariables>;
export const IngredientFormulaReferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IngredientFormulaReferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ingredientName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IngredientFormulaReferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ingredientName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ingredientName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formulas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useIngredientFormulaReferencesQuery__
 *
 * To run a query within a React component, call `useIngredientFormulaReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIngredientFormulaReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngredientFormulaReferencesQuery({
 *   variables: {
 *      ingredientName: // value for 'ingredientName'
 *   },
 * });
 */
export function useIngredientFormulaReferencesQuery(baseOptions: Apollo.QueryHookOptions<IngredientFormulaReferencesQuery, IngredientFormulaReferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IngredientFormulaReferencesQuery, IngredientFormulaReferencesQueryVariables>(IngredientFormulaReferencesDocument, options);
      }
export function useIngredientFormulaReferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IngredientFormulaReferencesQuery, IngredientFormulaReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IngredientFormulaReferencesQuery, IngredientFormulaReferencesQueryVariables>(IngredientFormulaReferencesDocument, options);
        }
export type IngredientFormulaReferencesQueryHookResult = ReturnType<typeof useIngredientFormulaReferencesQuery>;
export type IngredientFormulaReferencesLazyQueryHookResult = ReturnType<typeof useIngredientFormulaReferencesLazyQuery>;
export type IngredientFormulaReferencesQueryResult = Apollo.QueryResult<IngredientFormulaReferencesQuery, IngredientFormulaReferencesQueryVariables>;
export const NewItemActivationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewItemActivation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upc"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentCompany"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stagedCompany"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentBrand"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stagedBrand"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descriptionChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcategoryChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizeChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uomChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"positionChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandpositionChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"producttypeChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plcChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifiedAttributeChanges"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numberOfAttributesWithChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expectedChangeForAtLeastOneAttribute"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conventionalChannelStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conventionalChannelStatusDetails"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proprietaryChannelStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proprietaryChannelStatusDetails"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"NewItemActivation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"upc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upc"}}},{"kind":"Argument","name":{"kind":"Name","value":"currentCompany"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentCompany"}}},{"kind":"Argument","name":{"kind":"Name","value":"stagedCompany"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stagedCompany"}}},{"kind":"Argument","name":{"kind":"Name","value":"currentBrand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentBrand"}}},{"kind":"Argument","name":{"kind":"Name","value":"stagedBrand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stagedBrand"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"compChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"descriptionChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descriptionChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"departmentChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcategoryChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcategoryChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizeChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizeChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"uomChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uomChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"packChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"positionChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"positionChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandpositionChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandpositionChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"producttypeChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"producttypeChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"plcChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plcChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"identifiedAttributeChanges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifiedAttributeChanges"}}},{"kind":"Argument","name":{"kind":"Name","value":"numberOfAttributesWithChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numberOfAttributesWithChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"expectedChangeForAtLeastOneAttribute"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expectedChangeForAtLeastOneAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"conventionalChannelStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conventionalChannelStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"conventionalChannelStatusDetails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conventionalChannelStatusDetails"}}},{"kind":"Argument","name":{"kind":"Name","value":"proprietaryChannelStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proprietaryChannelStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"proprietaryChannelStatusDetails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proprietaryChannelStatusDetails"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upc"}},{"kind":"Field","name":{"kind":"Name","value":"stagedCompany"}},{"kind":"Field","name":{"kind":"Name","value":"currentCompany"}},{"kind":"Field","name":{"kind":"Name","value":"compChange"}},{"kind":"Field","name":{"kind":"Name","value":"currentBrand"}},{"kind":"Field","name":{"kind":"Name","value":"stagedBrand"}},{"kind":"Field","name":{"kind":"Name","value":"brandChange"}},{"kind":"Field","name":{"kind":"Name","value":"currentProductDescription"}},{"kind":"Field","name":{"kind":"Name","value":"stagedProductDescription"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionChange"}},{"kind":"Field","name":{"kind":"Name","value":"currentDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"stagedDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"departmentChange"}},{"kind":"Field","name":{"kind":"Name","value":"currentCategory"}},{"kind":"Field","name":{"kind":"Name","value":"stagedCategory"}},{"kind":"Field","name":{"kind":"Name","value":"categoryChange"}},{"kind":"Field","name":{"kind":"Name","value":"currentSubcategory"}},{"kind":"Field","name":{"kind":"Name","value":"stagedSubcategory"}},{"kind":"Field","name":{"kind":"Name","value":"subcategoryChange"}},{"kind":"Field","name":{"kind":"Name","value":"currentSize"}},{"kind":"Field","name":{"kind":"Name","value":"stagedSize"}},{"kind":"Field","name":{"kind":"Name","value":"sizeChange"}},{"kind":"Field","name":{"kind":"Name","value":"currentUnitOfMeasure"}},{"kind":"Field","name":{"kind":"Name","value":"stagedUnitOfMeasure"}},{"kind":"Field","name":{"kind":"Name","value":"uomChange"}},{"kind":"Field","name":{"kind":"Name","value":"currentPackCount"}},{"kind":"Field","name":{"kind":"Name","value":"stagedPackCount"}},{"kind":"Field","name":{"kind":"Name","value":"packChange"}},{"kind":"Field","name":{"kind":"Name","value":"currentPositioningGroup"}},{"kind":"Field","name":{"kind":"Name","value":"stagedPositioningGroup"}},{"kind":"Field","name":{"kind":"Name","value":"positionChange"}},{"kind":"Field","name":{"kind":"Name","value":"currentBrandPosition"}},{"kind":"Field","name":{"kind":"Name","value":"stagedBrandPosition"}},{"kind":"Field","name":{"kind":"Name","value":"brandpositionChange"}},{"kind":"Field","name":{"kind":"Name","value":"currentProductType"}},{"kind":"Field","name":{"kind":"Name","value":"stagedProductType"}},{"kind":"Field","name":{"kind":"Name","value":"producttypeChange"}},{"kind":"Field","name":{"kind":"Name","value":"currentPrivateLabelConventional"}},{"kind":"Field","name":{"kind":"Name","value":"stagedPrivateLabelConventional"}},{"kind":"Field","name":{"kind":"Name","value":"plcChange"}},{"kind":"Field","name":{"kind":"Name","value":"identifiedAttributeChanges"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfAttributesWithChange"}},{"kind":"Field","name":{"kind":"Name","value":"expectedChangeForAtLeastOneAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"conventionalChannelStatus"}},{"kind":"Field","name":{"kind":"Name","value":"conventionalChannelStatusDetails"}},{"kind":"Field","name":{"kind":"Name","value":"proprietaryChannelStatus"}},{"kind":"Field","name":{"kind":"Name","value":"proprietaryChannelStatusDetails"}},{"kind":"Field","name":{"kind":"Name","value":"newUpc"}},{"kind":"Field","name":{"kind":"Name","value":"upcEan13"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useNewItemActivationQuery__
 *
 * To run a query within a React component, call `useNewItemActivationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewItemActivationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewItemActivationQuery({
 *   variables: {
 *      upc: // value for 'upc'
 *      currentCompany: // value for 'currentCompany'
 *      stagedCompany: // value for 'stagedCompany'
 *      currentBrand: // value for 'currentBrand'
 *      stagedBrand: // value for 'stagedBrand'
 *      brandChange: // value for 'brandChange'
 *      compChange: // value for 'compChange'
 *      descriptionChange: // value for 'descriptionChange'
 *      departmentChange: // value for 'departmentChange'
 *      categoryChange: // value for 'categoryChange'
 *      subcategoryChange: // value for 'subcategoryChange'
 *      sizeChange: // value for 'sizeChange'
 *      uomChange: // value for 'uomChange'
 *      packChange: // value for 'packChange'
 *      positionChange: // value for 'positionChange'
 *      brandpositionChange: // value for 'brandpositionChange'
 *      producttypeChange: // value for 'producttypeChange'
 *      plcChange: // value for 'plcChange'
 *      identifiedAttributeChanges: // value for 'identifiedAttributeChanges'
 *      numberOfAttributesWithChange: // value for 'numberOfAttributesWithChange'
 *      expectedChangeForAtLeastOneAttribute: // value for 'expectedChangeForAtLeastOneAttribute'
 *      conventionalChannelStatus: // value for 'conventionalChannelStatus'
 *      conventionalChannelStatusDetails: // value for 'conventionalChannelStatusDetails'
 *      proprietaryChannelStatus: // value for 'proprietaryChannelStatus'
 *      proprietaryChannelStatusDetails: // value for 'proprietaryChannelStatusDetails'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useNewItemActivationQuery(baseOptions?: Apollo.QueryHookOptions<NewItemActivationQuery, NewItemActivationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewItemActivationQuery, NewItemActivationQueryVariables>(NewItemActivationDocument, options);
      }
export function useNewItemActivationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewItemActivationQuery, NewItemActivationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewItemActivationQuery, NewItemActivationQueryVariables>(NewItemActivationDocument, options);
        }
export type NewItemActivationQueryHookResult = ReturnType<typeof useNewItemActivationQuery>;
export type NewItemActivationLazyQueryHookResult = ReturnType<typeof useNewItemActivationLazyQuery>;
export type NewItemActivationQueryResult = Apollo.QueryResult<NewItemActivationQuery, NewItemActivationQueryVariables>;
export const ActivationStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActivationStatusFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActivationStatusFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conventionalChannelStatus"}},{"kind":"Field","name":{"kind":"Name","value":"conventionalChannelStatusDetails"}},{"kind":"Field","name":{"kind":"Name","value":"proprietaryChannelStatus"}},{"kind":"Field","name":{"kind":"Name","value":"proprietaryChannelStatusDetails"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useActivationStatusFilterQuery__
 *
 * To run a query within a React component, call `useActivationStatusFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivationStatusFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivationStatusFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivationStatusFilterQuery(baseOptions?: Apollo.QueryHookOptions<ActivationStatusFilterQuery, ActivationStatusFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivationStatusFilterQuery, ActivationStatusFilterQueryVariables>(ActivationStatusFilterDocument, options);
      }
export function useActivationStatusFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivationStatusFilterQuery, ActivationStatusFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivationStatusFilterQuery, ActivationStatusFilterQueryVariables>(ActivationStatusFilterDocument, options);
        }
export type ActivationStatusFilterQueryHookResult = ReturnType<typeof useActivationStatusFilterQuery>;
export type ActivationStatusFilterLazyQueryHookResult = ReturnType<typeof useActivationStatusFilterLazyQuery>;
export type ActivationStatusFilterQueryResult = Apollo.QueryResult<ActivationStatusFilterQuery, ActivationStatusFilterQueryVariables>;
export const NewItemActivationCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewItemActivationCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upc"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentCompany"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stagedCompany"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentBrand"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stagedBrand"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descriptionChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcategoryChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizeChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uomChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"positionChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandpositionChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"producttypeChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plcChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifiedAttributeChanges"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numberOfAttributesWithChange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expectedChangeForAtLeastOneAttribute"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conventionalChannelStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conventionalChannelStatusDetails"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proprietaryChannelStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proprietaryChannelStatusDetails"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"NewItemActivationCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"upc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upc"}}},{"kind":"Argument","name":{"kind":"Name","value":"currentCompany"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentCompany"}}},{"kind":"Argument","name":{"kind":"Name","value":"stagedCompany"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stagedCompany"}}},{"kind":"Argument","name":{"kind":"Name","value":"currentBrand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentBrand"}}},{"kind":"Argument","name":{"kind":"Name","value":"stagedBrand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stagedBrand"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"compChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"descriptionChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descriptionChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"departmentChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcategoryChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcategoryChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizeChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizeChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"uomChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uomChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"packChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"positionChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"positionChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandpositionChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandpositionChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"producttypeChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"producttypeChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"plcChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plcChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"identifiedAttributeChanges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifiedAttributeChanges"}}},{"kind":"Argument","name":{"kind":"Name","value":"numberOfAttributesWithChange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numberOfAttributesWithChange"}}},{"kind":"Argument","name":{"kind":"Name","value":"expectedChangeForAtLeastOneAttribute"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expectedChangeForAtLeastOneAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"conventionalChannelStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conventionalChannelStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"conventionalChannelStatusDetails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conventionalChannelStatusDetails"}}},{"kind":"Argument","name":{"kind":"Name","value":"proprietaryChannelStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proprietaryChannelStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"proprietaryChannelStatusDetails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proprietaryChannelStatusDetails"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemCount"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useNewItemActivationCountQuery__
 *
 * To run a query within a React component, call `useNewItemActivationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewItemActivationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewItemActivationCountQuery({
 *   variables: {
 *      upc: // value for 'upc'
 *      currentCompany: // value for 'currentCompany'
 *      stagedCompany: // value for 'stagedCompany'
 *      currentBrand: // value for 'currentBrand'
 *      stagedBrand: // value for 'stagedBrand'
 *      brandChange: // value for 'brandChange'
 *      compChange: // value for 'compChange'
 *      descriptionChange: // value for 'descriptionChange'
 *      departmentChange: // value for 'departmentChange'
 *      categoryChange: // value for 'categoryChange'
 *      subcategoryChange: // value for 'subcategoryChange'
 *      sizeChange: // value for 'sizeChange'
 *      uomChange: // value for 'uomChange'
 *      packChange: // value for 'packChange'
 *      positionChange: // value for 'positionChange'
 *      brandpositionChange: // value for 'brandpositionChange'
 *      producttypeChange: // value for 'producttypeChange'
 *      plcChange: // value for 'plcChange'
 *      identifiedAttributeChanges: // value for 'identifiedAttributeChanges'
 *      numberOfAttributesWithChange: // value for 'numberOfAttributesWithChange'
 *      expectedChangeForAtLeastOneAttribute: // value for 'expectedChangeForAtLeastOneAttribute'
 *      conventionalChannelStatus: // value for 'conventionalChannelStatus'
 *      conventionalChannelStatusDetails: // value for 'conventionalChannelStatusDetails'
 *      proprietaryChannelStatus: // value for 'proprietaryChannelStatus'
 *      proprietaryChannelStatusDetails: // value for 'proprietaryChannelStatusDetails'
 *   },
 * });
 */
export function useNewItemActivationCountQuery(baseOptions?: Apollo.QueryHookOptions<NewItemActivationCountQuery, NewItemActivationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewItemActivationCountQuery, NewItemActivationCountQueryVariables>(NewItemActivationCountDocument, options);
      }
export function useNewItemActivationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewItemActivationCountQuery, NewItemActivationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewItemActivationCountQuery, NewItemActivationCountQueryVariables>(NewItemActivationCountDocument, options);
        }
export type NewItemActivationCountQueryHookResult = ReturnType<typeof useNewItemActivationCountQuery>;
export type NewItemActivationCountLazyQueryHookResult = ReturnType<typeof useNewItemActivationCountLazyQuery>;
export type NewItemActivationCountQueryResult = Apollo.QueryResult<NewItemActivationCountQuery, NewItemActivationCountQueryVariables>;
export const MiddlewareFormulasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MiddlewareFormulas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Formula_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"runInPv2Middleware"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMiddlewareFormulasQuery__
 *
 * To run a query within a React component, call `useMiddlewareFormulasQuery` and pass it any options that fit your needs.
 * When your component renders, `useMiddlewareFormulasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMiddlewareFormulasQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMiddlewareFormulasQuery(baseOptions?: Apollo.QueryHookOptions<MiddlewareFormulasQuery, MiddlewareFormulasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MiddlewareFormulasQuery, MiddlewareFormulasQueryVariables>(MiddlewareFormulasDocument, options);
      }
export function useMiddlewareFormulasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MiddlewareFormulasQuery, MiddlewareFormulasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MiddlewareFormulasQuery, MiddlewareFormulasQueryVariables>(MiddlewareFormulasDocument, options);
        }
export type MiddlewareFormulasQueryHookResult = ReturnType<typeof useMiddlewareFormulasQuery>;
export type MiddlewareFormulasLazyQueryHookResult = ReturnType<typeof useMiddlewareFormulasLazyQuery>;
export type MiddlewareFormulasQueryResult = Apollo.QueryResult<MiddlewareFormulasQuery, MiddlewareFormulasQueryVariables>;
export const ModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Model"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelNameEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Model"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasHistoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"isTaggable"}},{"kind":"Field","name":{"kind":"Name","value":"collectionName"}},{"kind":"Field","name":{"kind":"Name","value":"columns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModelColumnInfo"}}]}}]}}]}},...ModelColumnInfoFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useModelQuery__
 *
 * To run a query within a React component, call `useModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelQuery({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useModelQuery(baseOptions: Apollo.QueryHookOptions<ModelQuery, ModelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
      }
export function useModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelQuery, ModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
        }
export type ModelQueryHookResult = ReturnType<typeof useModelQuery>;
export type ModelLazyQueryHookResult = ReturnType<typeof useModelLazyQuery>;
export type ModelQueryResult = Apollo.QueryResult<ModelQuery, ModelQueryVariables>;
export const Pv2AttributeDefinitions_SchemaFieldsWithTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2AttributeDefinitions_schemaFieldsWithTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2AttributeDefinitions_schemaFieldsWithTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeTypeWithFieldTypes"}}]}}]}},...AttributeTypeWithFieldTypesFragmentDoc.definitions,...ModelColumnInfoFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __usePv2AttributeDefinitions_SchemaFieldsWithTypesQuery__
 *
 * To run a query within a React component, call `usePv2AttributeDefinitions_SchemaFieldsWithTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2AttributeDefinitions_SchemaFieldsWithTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2AttributeDefinitions_SchemaFieldsWithTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePv2AttributeDefinitions_SchemaFieldsWithTypesQuery(baseOptions?: Apollo.QueryHookOptions<Pv2AttributeDefinitions_SchemaFieldsWithTypesQuery, Pv2AttributeDefinitions_SchemaFieldsWithTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2AttributeDefinitions_SchemaFieldsWithTypesQuery, Pv2AttributeDefinitions_SchemaFieldsWithTypesQueryVariables>(Pv2AttributeDefinitions_SchemaFieldsWithTypesDocument, options);
      }
export function usePv2AttributeDefinitions_SchemaFieldsWithTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2AttributeDefinitions_SchemaFieldsWithTypesQuery, Pv2AttributeDefinitions_SchemaFieldsWithTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2AttributeDefinitions_SchemaFieldsWithTypesQuery, Pv2AttributeDefinitions_SchemaFieldsWithTypesQueryVariables>(Pv2AttributeDefinitions_SchemaFieldsWithTypesDocument, options);
        }
export type Pv2AttributeDefinitions_SchemaFieldsWithTypesQueryHookResult = ReturnType<typeof usePv2AttributeDefinitions_SchemaFieldsWithTypesQuery>;
export type Pv2AttributeDefinitions_SchemaFieldsWithTypesLazyQueryHookResult = ReturnType<typeof usePv2AttributeDefinitions_SchemaFieldsWithTypesLazyQuery>;
export type Pv2AttributeDefinitions_SchemaFieldsWithTypesQueryResult = Apollo.QueryResult<Pv2AttributeDefinitions_SchemaFieldsWithTypesQuery, Pv2AttributeDefinitions_SchemaFieldsWithTypesQueryVariables>;
export const ModelAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ModelAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelNameEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sample"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allowDiskUse"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputList"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListVariable"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModelAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sample"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sample"}}},{"kind":"Argument","name":{"kind":"Name","value":"allowDiskUse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allowDiskUse"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputList"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputList"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stageIndex"}},{"kind":"Field","name":{"kind":"Name","value":"results"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useModelAggregateQuery__
 *
 * To run a query within a React component, call `useModelAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelAggregateQuery({
 *   variables: {
 *      model: // value for 'model'
 *      pipeline: // value for 'pipeline'
 *      limit: // value for 'limit'
 *      sample: // value for 'sample'
 *      allowDiskUse: // value for 'allowDiskUse'
 *      inputList: // value for 'inputList'
 *   },
 * });
 */
export function useModelAggregateQuery(baseOptions: Apollo.QueryHookOptions<ModelAggregateQuery, ModelAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelAggregateQuery, ModelAggregateQueryVariables>(ModelAggregateDocument, options);
      }
export function useModelAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelAggregateQuery, ModelAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelAggregateQuery, ModelAggregateQueryVariables>(ModelAggregateDocument, options);
        }
export type ModelAggregateQueryHookResult = ReturnType<typeof useModelAggregateQuery>;
export type ModelAggregateLazyQueryHookResult = ReturnType<typeof useModelAggregateLazyQuery>;
export type ModelAggregateQueryResult = Apollo.QueryResult<ModelAggregateQuery, ModelAggregateQueryVariables>;
export const ModelDistinctCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ModelDistinctCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelNameEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"field"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"defaultValue":{"kind":"StringValue","value":"_id","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unwind"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModelDistinctCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"Variable","name":{"kind":"Name","value":"field"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"unwind"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unwind"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useModelDistinctCountQuery__
 *
 * To run a query within a React component, call `useModelDistinctCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelDistinctCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelDistinctCountQuery({
 *   variables: {
 *      model: // value for 'model'
 *      field: // value for 'field'
 *      query: // value for 'query'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      unwind: // value for 'unwind'
 *   },
 * });
 */
export function useModelDistinctCountQuery(baseOptions: Apollo.QueryHookOptions<ModelDistinctCountQuery, ModelDistinctCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelDistinctCountQuery, ModelDistinctCountQueryVariables>(ModelDistinctCountDocument, options);
      }
export function useModelDistinctCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelDistinctCountQuery, ModelDistinctCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelDistinctCountQuery, ModelDistinctCountQueryVariables>(ModelDistinctCountDocument, options);
        }
export type ModelDistinctCountQueryHookResult = ReturnType<typeof useModelDistinctCountQuery>;
export type ModelDistinctCountLazyQueryHookResult = ReturnType<typeof useModelDistinctCountLazyQuery>;
export type ModelDistinctCountQueryResult = Apollo.QueryResult<ModelDistinctCountQuery, ModelDistinctCountQueryVariables>;
export const ModelFindByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ModelFindById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelNameEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"select"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"populate"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"virtuals"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModelFindById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"select"},"value":{"kind":"Variable","name":{"kind":"Name","value":"select"}}},{"kind":"Argument","name":{"kind":"Name","value":"populate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"populate"}}},{"kind":"Argument","name":{"kind":"Name","value":"virtuals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"virtuals"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useModelFindByIdQuery__
 *
 * To run a query within a React component, call `useModelFindByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelFindByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelFindByIdQuery({
 *   variables: {
 *      model: // value for 'model'
 *      id: // value for 'id'
 *      select: // value for 'select'
 *      populate: // value for 'populate'
 *      virtuals: // value for 'virtuals'
 *   },
 * });
 */
export function useModelFindByIdQuery(baseOptions: Apollo.QueryHookOptions<ModelFindByIdQuery, ModelFindByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelFindByIdQuery, ModelFindByIdQueryVariables>(ModelFindByIdDocument, options);
      }
export function useModelFindByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelFindByIdQuery, ModelFindByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelFindByIdQuery, ModelFindByIdQueryVariables>(ModelFindByIdDocument, options);
        }
export type ModelFindByIdQueryHookResult = ReturnType<typeof useModelFindByIdQuery>;
export type ModelFindByIdLazyQueryHookResult = ReturnType<typeof useModelFindByIdLazyQuery>;
export type ModelFindByIdQueryResult = Apollo.QueryResult<ModelFindByIdQuery, ModelFindByIdQueryVariables>;
export const ModelFindManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ModelFindMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelNameEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputList"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListVariable"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"select"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModelFindMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"project"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project"}}},{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputList"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputList"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"select"},"value":{"kind":"Variable","name":{"kind":"Name","value":"select"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useModelFindManyQuery__
 *
 * To run a query within a React component, call `useModelFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelFindManyQuery({
 *   variables: {
 *      model: // value for 'model'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      project: // value for 'project'
 *      distinct: // value for 'distinct'
 *      inputList: // value for 'inputList'
 *      sort: // value for 'sort'
 *      select: // value for 'select'
 *   },
 * });
 */
export function useModelFindManyQuery(baseOptions: Apollo.QueryHookOptions<ModelFindManyQuery, ModelFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelFindManyQuery, ModelFindManyQueryVariables>(ModelFindManyDocument, options);
      }
export function useModelFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelFindManyQuery, ModelFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelFindManyQuery, ModelFindManyQueryVariables>(ModelFindManyDocument, options);
        }
export type ModelFindManyQueryHookResult = ReturnType<typeof useModelFindManyQuery>;
export type ModelFindManyLazyQueryHookResult = ReturnType<typeof useModelFindManyLazyQuery>;
export type ModelFindManyQueryResult = Apollo.QueryResult<ModelFindManyQuery, ModelFindManyQueryVariables>;
export const ModelTagNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ModelTagNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelNameEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModelTagNames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useModelTagNamesQuery__
 *
 * To run a query within a React component, call `useModelTagNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelTagNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelTagNamesQuery({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useModelTagNamesQuery(baseOptions: Apollo.QueryHookOptions<ModelTagNamesQuery, ModelTagNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelTagNamesQuery, ModelTagNamesQueryVariables>(ModelTagNamesDocument, options);
      }
export function useModelTagNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelTagNamesQuery, ModelTagNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelTagNamesQuery, ModelTagNamesQueryVariables>(ModelTagNamesDocument, options);
        }
export type ModelTagNamesQueryHookResult = ReturnType<typeof useModelTagNamesQuery>;
export type ModelTagNamesLazyQueryHookResult = ReturnType<typeof useModelTagNamesLazyQuery>;
export type ModelTagNamesQueryResult = Apollo.QueryResult<ModelTagNamesQuery, ModelTagNamesQueryVariables>;
export const ModelTagCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ModelTagCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelNameEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"names"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModelTagCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"names"},"value":{"kind":"Variable","name":{"kind":"Name","value":"names"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useModelTagCountsQuery__
 *
 * To run a query within a React component, call `useModelTagCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelTagCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelTagCountsQuery({
 *   variables: {
 *      model: // value for 'model'
 *      names: // value for 'names'
 *   },
 * });
 */
export function useModelTagCountsQuery(baseOptions: Apollo.QueryHookOptions<ModelTagCountsQuery, ModelTagCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelTagCountsQuery, ModelTagCountsQueryVariables>(ModelTagCountsDocument, options);
      }
export function useModelTagCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelTagCountsQuery, ModelTagCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelTagCountsQuery, ModelTagCountsQueryVariables>(ModelTagCountsDocument, options);
        }
export type ModelTagCountsQueryHookResult = ReturnType<typeof useModelTagCountsQuery>;
export type ModelTagCountsLazyQueryHookResult = ReturnType<typeof useModelTagCountsLazyQuery>;
export type ModelTagCountsQueryResult = Apollo.QueryResult<ModelTagCountsQuery, ModelTagCountsQueryVariables>;
export const ModelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Models"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Models"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isTaggable"}},{"kind":"Field","name":{"kind":"Name","value":"hasHistoryTracking"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useModelsQuery__
 *
 * To run a query within a React component, call `useModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelsQuery(baseOptions?: Apollo.QueryHookOptions<ModelsQuery, ModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelsQuery, ModelsQueryVariables>(ModelsDocument, options);
      }
export function useModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelsQuery, ModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelsQuery, ModelsQueryVariables>(ModelsDocument, options);
        }
export type ModelsQueryHookResult = ReturnType<typeof useModelsQuery>;
export type ModelsLazyQueryHookResult = ReturnType<typeof useModelsLazyQuery>;
export type ModelsQueryResult = Apollo.QueryResult<ModelsQuery, ModelsQueryVariables>;
export const PredictionOverrideAllowedValuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PredictionOverrideAllowedValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PredictionOverride_allowedValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcategory"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributeType"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __usePredictionOverrideAllowedValuesQuery__
 *
 * To run a query within a React component, call `usePredictionOverrideAllowedValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredictionOverrideAllowedValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredictionOverrideAllowedValuesQuery({
 *   variables: {
 *      subcategory: // value for 'subcategory'
 *   },
 * });
 */
export function usePredictionOverrideAllowedValuesQuery(baseOptions: Apollo.QueryHookOptions<PredictionOverrideAllowedValuesQuery, PredictionOverrideAllowedValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredictionOverrideAllowedValuesQuery, PredictionOverrideAllowedValuesQueryVariables>(PredictionOverrideAllowedValuesDocument, options);
      }
export function usePredictionOverrideAllowedValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredictionOverrideAllowedValuesQuery, PredictionOverrideAllowedValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredictionOverrideAllowedValuesQuery, PredictionOverrideAllowedValuesQueryVariables>(PredictionOverrideAllowedValuesDocument, options);
        }
export type PredictionOverrideAllowedValuesQueryHookResult = ReturnType<typeof usePredictionOverrideAllowedValuesQuery>;
export type PredictionOverrideAllowedValuesLazyQueryHookResult = ReturnType<typeof usePredictionOverrideAllowedValuesLazyQuery>;
export type PredictionOverrideAllowedValuesQueryResult = Apollo.QueryResult<PredictionOverrideAllowedValuesQuery, PredictionOverrideAllowedValuesQueryVariables>;
export const PredictionOverrideBulkLookupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PredictionOverrideBulkLookup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CleansedData_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gtin"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asins"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __usePredictionOverrideBulkLookupQuery__
 *
 * To run a query within a React component, call `usePredictionOverrideBulkLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredictionOverrideBulkLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredictionOverrideBulkLookupQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePredictionOverrideBulkLookupQuery(baseOptions?: Apollo.QueryHookOptions<PredictionOverrideBulkLookupQuery, PredictionOverrideBulkLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredictionOverrideBulkLookupQuery, PredictionOverrideBulkLookupQueryVariables>(PredictionOverrideBulkLookupDocument, options);
      }
export function usePredictionOverrideBulkLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredictionOverrideBulkLookupQuery, PredictionOverrideBulkLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredictionOverrideBulkLookupQuery, PredictionOverrideBulkLookupQueryVariables>(PredictionOverrideBulkLookupDocument, options);
        }
export type PredictionOverrideBulkLookupQueryHookResult = ReturnType<typeof usePredictionOverrideBulkLookupQuery>;
export type PredictionOverrideBulkLookupLazyQueryHookResult = ReturnType<typeof usePredictionOverrideBulkLookupLazyQuery>;
export type PredictionOverrideBulkLookupQueryResult = Apollo.QueryResult<PredictionOverrideBulkLookupQuery, PredictionOverrideBulkLookupQueryVariables>;
export const PredictionOverrideCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PredictionOverrideCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CleansedData_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __usePredictionOverrideCountQuery__
 *
 * To run a query within a React component, call `usePredictionOverrideCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredictionOverrideCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredictionOverrideCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePredictionOverrideCountQuery(baseOptions?: Apollo.QueryHookOptions<PredictionOverrideCountQuery, PredictionOverrideCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredictionOverrideCountQuery, PredictionOverrideCountQueryVariables>(PredictionOverrideCountDocument, options);
      }
export function usePredictionOverrideCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredictionOverrideCountQuery, PredictionOverrideCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredictionOverrideCountQuery, PredictionOverrideCountQueryVariables>(PredictionOverrideCountDocument, options);
        }
export type PredictionOverrideCountQueryHookResult = ReturnType<typeof usePredictionOverrideCountQuery>;
export type PredictionOverrideCountLazyQueryHookResult = ReturnType<typeof usePredictionOverrideCountLazyQuery>;
export type PredictionOverrideCountQueryResult = Apollo.QueryResult<PredictionOverrideCountQuery, PredictionOverrideCountQueryVariables>;
export const PredictionOverrideFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PredictionOverrideFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CleansedData_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gtin"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asins"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"age"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flavor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"functionalIngredient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthFocus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceSpecific"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitOfMeasure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"asin"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __usePredictionOverrideFindQuery__
 *
 * To run a query within a React component, call `usePredictionOverrideFindQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredictionOverrideFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredictionOverrideFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePredictionOverrideFindQuery(baseOptions?: Apollo.QueryHookOptions<PredictionOverrideFindQuery, PredictionOverrideFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredictionOverrideFindQuery, PredictionOverrideFindQueryVariables>(PredictionOverrideFindDocument, options);
      }
export function usePredictionOverrideFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredictionOverrideFindQuery, PredictionOverrideFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredictionOverrideFindQuery, PredictionOverrideFindQueryVariables>(PredictionOverrideFindDocument, options);
        }
export type PredictionOverrideFindQueryHookResult = ReturnType<typeof usePredictionOverrideFindQuery>;
export type PredictionOverrideFindLazyQueryHookResult = ReturnType<typeof usePredictionOverrideFindLazyQuery>;
export type PredictionOverrideFindQueryResult = Apollo.QueryResult<PredictionOverrideFindQuery, PredictionOverrideFindQueryVariables>;
export const Pv2AttributeDefinitionCreateAttributeSchemaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2AttributeDefinitionCreateAttributeSchema"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributeDefinition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2AttributeDefinitionInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"full"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2AttributeDefinition_createAttributeSchema"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributeDefinition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributeDefinition"}}},{"kind":"Argument","name":{"kind":"Name","value":"full"},"value":{"kind":"Variable","name":{"kind":"Name","value":"full"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __usePv2AttributeDefinitionCreateAttributeSchemaQuery__
 *
 * To run a query within a React component, call `usePv2AttributeDefinitionCreateAttributeSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2AttributeDefinitionCreateAttributeSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2AttributeDefinitionCreateAttributeSchemaQuery({
 *   variables: {
 *      attributeDefinition: // value for 'attributeDefinition'
 *      full: // value for 'full'
 *   },
 * });
 */
export function usePv2AttributeDefinitionCreateAttributeSchemaQuery(baseOptions: Apollo.QueryHookOptions<Pv2AttributeDefinitionCreateAttributeSchemaQuery, Pv2AttributeDefinitionCreateAttributeSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2AttributeDefinitionCreateAttributeSchemaQuery, Pv2AttributeDefinitionCreateAttributeSchemaQueryVariables>(Pv2AttributeDefinitionCreateAttributeSchemaDocument, options);
      }
export function usePv2AttributeDefinitionCreateAttributeSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2AttributeDefinitionCreateAttributeSchemaQuery, Pv2AttributeDefinitionCreateAttributeSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2AttributeDefinitionCreateAttributeSchemaQuery, Pv2AttributeDefinitionCreateAttributeSchemaQueryVariables>(Pv2AttributeDefinitionCreateAttributeSchemaDocument, options);
        }
export type Pv2AttributeDefinitionCreateAttributeSchemaQueryHookResult = ReturnType<typeof usePv2AttributeDefinitionCreateAttributeSchemaQuery>;
export type Pv2AttributeDefinitionCreateAttributeSchemaLazyQueryHookResult = ReturnType<typeof usePv2AttributeDefinitionCreateAttributeSchemaLazyQuery>;
export type Pv2AttributeDefinitionCreateAttributeSchemaQueryResult = Apollo.QueryResult<Pv2AttributeDefinitionCreateAttributeSchemaQuery, Pv2AttributeDefinitionCreateAttributeSchemaQueryVariables>;
export const Pv2FetchIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2FetchIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2_searchIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"expression"},"value":{"kind":"ObjectValue","fields":[]}}]}]}}]} as unknown as DocumentNode;

/**
 * __usePv2FetchIdsQuery__
 *
 * To run a query within a React component, call `usePv2FetchIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2FetchIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2FetchIdsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePv2FetchIdsQuery(baseOptions: Apollo.QueryHookOptions<Pv2FetchIdsQuery, Pv2FetchIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2FetchIdsQuery, Pv2FetchIdsQueryVariables>(Pv2FetchIdsDocument, options);
      }
export function usePv2FetchIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2FetchIdsQuery, Pv2FetchIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2FetchIdsQuery, Pv2FetchIdsQueryVariables>(Pv2FetchIdsDocument, options);
        }
export type Pv2FetchIdsQueryHookResult = ReturnType<typeof usePv2FetchIdsQuery>;
export type Pv2FetchIdsLazyQueryHookResult = ReturnType<typeof usePv2FetchIdsLazyQuery>;
export type Pv2FetchIdsQueryResult = Apollo.QueryResult<Pv2FetchIdsQuery, Pv2FetchIdsQueryVariables>;
export const Pv2SpinsUpcFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2SpinsUpcFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"spinsUpc"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __usePv2SpinsUpcFindQuery__
 *
 * To run a query within a React component, call `usePv2SpinsUpcFindQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2SpinsUpcFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2SpinsUpcFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePv2SpinsUpcFindQuery(baseOptions: Apollo.QueryHookOptions<Pv2SpinsUpcFindQuery, Pv2SpinsUpcFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2SpinsUpcFindQuery, Pv2SpinsUpcFindQueryVariables>(Pv2SpinsUpcFindDocument, options);
      }
export function usePv2SpinsUpcFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2SpinsUpcFindQuery, Pv2SpinsUpcFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2SpinsUpcFindQuery, Pv2SpinsUpcFindQueryVariables>(Pv2SpinsUpcFindDocument, options);
        }
export type Pv2SpinsUpcFindQueryHookResult = ReturnType<typeof usePv2SpinsUpcFindQuery>;
export type Pv2SpinsUpcFindLazyQueryHookResult = ReturnType<typeof usePv2SpinsUpcFindLazyQuery>;
export type Pv2SpinsUpcFindQueryResult = Apollo.QueryResult<Pv2SpinsUpcFindQuery, Pv2SpinsUpcFindQueryVariables>;
export const Pv2Ingredients_SearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2Ingredients_search"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2IngredientComponentTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameFilters"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withReviewStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2Ingredients_search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentType"}}},{"kind":"Argument","name":{"kind":"Name","value":"nameFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"withReviewStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withReviewStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pv2Count"}},{"kind":"Field","name":{"kind":"Name","value":"reviewStatus"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __usePv2Ingredients_SearchQuery__
 *
 * To run a query within a React component, call `usePv2Ingredients_SearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2Ingredients_SearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2Ingredients_SearchQuery({
 *   variables: {
 *      componentType: // value for 'componentType'
 *      nameFilters: // value for 'nameFilters'
 *      withReviewStatus: // value for 'withReviewStatus'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePv2Ingredients_SearchQuery(baseOptions?: Apollo.QueryHookOptions<Pv2Ingredients_SearchQuery, Pv2Ingredients_SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2Ingredients_SearchQuery, Pv2Ingredients_SearchQueryVariables>(Pv2Ingredients_SearchDocument, options);
      }
export function usePv2Ingredients_SearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2Ingredients_SearchQuery, Pv2Ingredients_SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2Ingredients_SearchQuery, Pv2Ingredients_SearchQueryVariables>(Pv2Ingredients_SearchDocument, options);
        }
export type Pv2Ingredients_SearchQueryHookResult = ReturnType<typeof usePv2Ingredients_SearchQuery>;
export type Pv2Ingredients_SearchLazyQueryHookResult = ReturnType<typeof usePv2Ingredients_SearchLazyQuery>;
export type Pv2Ingredients_SearchQueryResult = Apollo.QueryResult<Pv2Ingredients_SearchQuery, Pv2Ingredients_SearchQueryVariables>;
export const Pv2sByIngredients_SearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pv2sByIngredients_search"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pv2IngredientComponentTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ingredientFilters"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"falsePositives"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Pv2sByIngredients_search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentType"}}},{"kind":"Argument","name":{"kind":"Name","value":"ingredientFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ingredientFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"falsePositives"},"value":{"kind":"Variable","name":{"kind":"Name","value":"falsePositives"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gtin"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"breadcrumb"}},{"kind":"Field","name":{"kind":"Name","value":"ingredientStatement"}},{"kind":"Field","name":{"kind":"Name","value":"matchedNames"}},{"kind":"Field","name":{"kind":"Name","value":"matchedTerms"}},{"kind":"Field","name":{"kind":"Name","value":"falsePositiveMatches"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __usePv2sByIngredients_SearchQuery__
 *
 * To run a query within a React component, call `usePv2sByIngredients_SearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePv2sByIngredients_SearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePv2sByIngredients_SearchQuery({
 *   variables: {
 *      componentType: // value for 'componentType'
 *      ingredientFilters: // value for 'ingredientFilters'
 *      falsePositives: // value for 'falsePositives'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePv2sByIngredients_SearchQuery(baseOptions: Apollo.QueryHookOptions<Pv2sByIngredients_SearchQuery, Pv2sByIngredients_SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pv2sByIngredients_SearchQuery, Pv2sByIngredients_SearchQueryVariables>(Pv2sByIngredients_SearchDocument, options);
      }
export function usePv2sByIngredients_SearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pv2sByIngredients_SearchQuery, Pv2sByIngredients_SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pv2sByIngredients_SearchQuery, Pv2sByIngredients_SearchQueryVariables>(Pv2sByIngredients_SearchDocument, options);
        }
export type Pv2sByIngredients_SearchQueryHookResult = ReturnType<typeof usePv2sByIngredients_SearchQuery>;
export type Pv2sByIngredients_SearchLazyQueryHookResult = ReturnType<typeof usePv2sByIngredients_SearchLazyQuery>;
export type Pv2sByIngredients_SearchQueryResult = Apollo.QueryResult<Pv2sByIngredients_SearchQuery, Pv2sByIngredients_SearchQueryVariables>;
export const QcSelfServeSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QcSelfServeSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QCSelfServeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"QCSelfServeSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"dadCount"}},{"kind":"Field","name":{"kind":"Name","value":"prCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedDate"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useQcSelfServeSummaryQuery__
 *
 * To run a query within a React component, call `useQcSelfServeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQcSelfServeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQcSelfServeSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useQcSelfServeSummaryQuery(baseOptions?: Apollo.QueryHookOptions<QcSelfServeSummaryQuery, QcSelfServeSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QcSelfServeSummaryQuery, QcSelfServeSummaryQueryVariables>(QcSelfServeSummaryDocument, options);
      }
export function useQcSelfServeSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QcSelfServeSummaryQuery, QcSelfServeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QcSelfServeSummaryQuery, QcSelfServeSummaryQueryVariables>(QcSelfServeSummaryDocument, options);
        }
export type QcSelfServeSummaryQueryHookResult = ReturnType<typeof useQcSelfServeSummaryQuery>;
export type QcSelfServeSummaryLazyQueryHookResult = ReturnType<typeof useQcSelfServeSummaryLazyQuery>;
export type QcSelfServeSummaryQueryResult = Apollo.QueryResult<QcSelfServeSummaryQuery, QcSelfServeSummaryQueryVariables>;
export const QcSelfServeCheckCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QcSelfServeCheckCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QCSelfServeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"QCSelfServeCheckCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkId"}},{"kind":"Field","name":{"kind":"Name","value":"checkDescription"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useQcSelfServeCheckCountsQuery__
 *
 * To run a query within a React component, call `useQcSelfServeCheckCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQcSelfServeCheckCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQcSelfServeCheckCountsQuery({
 *   variables: {
 *      team: // value for 'team'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useQcSelfServeCheckCountsQuery(baseOptions?: Apollo.QueryHookOptions<QcSelfServeCheckCountsQuery, QcSelfServeCheckCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QcSelfServeCheckCountsQuery, QcSelfServeCheckCountsQueryVariables>(QcSelfServeCheckCountsDocument, options);
      }
export function useQcSelfServeCheckCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QcSelfServeCheckCountsQuery, QcSelfServeCheckCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QcSelfServeCheckCountsQuery, QcSelfServeCheckCountsQueryVariables>(QcSelfServeCheckCountsDocument, options);
        }
export type QcSelfServeCheckCountsQueryHookResult = ReturnType<typeof useQcSelfServeCheckCountsQuery>;
export type QcSelfServeCheckCountsLazyQueryHookResult = ReturnType<typeof useQcSelfServeCheckCountsLazyQuery>;
export type QcSelfServeCheckCountsQueryResult = Apollo.QueryResult<QcSelfServeCheckCountsQuery, QcSelfServeCheckCountsQueryVariables>;
export const QcSelfServeCheckDescriptionCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QcSelfServeCheckDescriptionCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QCSelfServeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDir"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"QCSelfServeCheckDescriptionCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDir"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDir"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkId"}},{"kind":"Field","name":{"kind":"Name","value":"checkDescription"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useQcSelfServeCheckDescriptionCountsQuery__
 *
 * To run a query within a React component, call `useQcSelfServeCheckDescriptionCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQcSelfServeCheckDescriptionCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQcSelfServeCheckDescriptionCountsQuery({
 *   variables: {
 *      team: // value for 'team'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortDir: // value for 'sortDir'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useQcSelfServeCheckDescriptionCountsQuery(baseOptions?: Apollo.QueryHookOptions<QcSelfServeCheckDescriptionCountsQuery, QcSelfServeCheckDescriptionCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QcSelfServeCheckDescriptionCountsQuery, QcSelfServeCheckDescriptionCountsQueryVariables>(QcSelfServeCheckDescriptionCountsDocument, options);
      }
export function useQcSelfServeCheckDescriptionCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QcSelfServeCheckDescriptionCountsQuery, QcSelfServeCheckDescriptionCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QcSelfServeCheckDescriptionCountsQuery, QcSelfServeCheckDescriptionCountsQueryVariables>(QcSelfServeCheckDescriptionCountsDocument, options);
        }
export type QcSelfServeCheckDescriptionCountsQueryHookResult = ReturnType<typeof useQcSelfServeCheckDescriptionCountsQuery>;
export type QcSelfServeCheckDescriptionCountsLazyQueryHookResult = ReturnType<typeof useQcSelfServeCheckDescriptionCountsLazyQuery>;
export type QcSelfServeCheckDescriptionCountsQueryResult = Apollo.QueryResult<QcSelfServeCheckDescriptionCountsQuery, QcSelfServeCheckDescriptionCountsQueryVariables>;
export const QcSelfServeFilterOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QcSelfServeFilterOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"QCSelfServeFilterOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"checkId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useQcSelfServeFilterOptionsQuery__
 *
 * To run a query within a React component, call `useQcSelfServeFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQcSelfServeFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQcSelfServeFilterOptionsQuery({
 *   variables: {
 *      team: // value for 'team'
 *   },
 * });
 */
export function useQcSelfServeFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<QcSelfServeFilterOptionsQuery, QcSelfServeFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QcSelfServeFilterOptionsQuery, QcSelfServeFilterOptionsQueryVariables>(QcSelfServeFilterOptionsDocument, options);
      }
export function useQcSelfServeFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QcSelfServeFilterOptionsQuery, QcSelfServeFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QcSelfServeFilterOptionsQuery, QcSelfServeFilterOptionsQueryVariables>(QcSelfServeFilterOptionsDocument, options);
        }
export type QcSelfServeFilterOptionsQueryHookResult = ReturnType<typeof useQcSelfServeFilterOptionsQuery>;
export type QcSelfServeFilterOptionsLazyQueryHookResult = ReturnType<typeof useQcSelfServeFilterOptionsLazyQuery>;
export type QcSelfServeFilterOptionsQueryResult = Apollo.QueryResult<QcSelfServeFilterOptionsQuery, QcSelfServeFilterOptionsQueryVariables>;
export const QcSelfServeBrandOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QcSelfServeBrandOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"QCSelfServeBrandOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"team"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useQcSelfServeBrandOptionsQuery__
 *
 * To run a query within a React component, call `useQcSelfServeBrandOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQcSelfServeBrandOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQcSelfServeBrandOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      team: // value for 'team'
 *   },
 * });
 */
export function useQcSelfServeBrandOptionsQuery(baseOptions: Apollo.QueryHookOptions<QcSelfServeBrandOptionsQuery, QcSelfServeBrandOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QcSelfServeBrandOptionsQuery, QcSelfServeBrandOptionsQueryVariables>(QcSelfServeBrandOptionsDocument, options);
      }
export function useQcSelfServeBrandOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QcSelfServeBrandOptionsQuery, QcSelfServeBrandOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QcSelfServeBrandOptionsQuery, QcSelfServeBrandOptionsQueryVariables>(QcSelfServeBrandOptionsDocument, options);
        }
export type QcSelfServeBrandOptionsQueryHookResult = ReturnType<typeof useQcSelfServeBrandOptionsQuery>;
export type QcSelfServeBrandOptionsLazyQueryHookResult = ReturnType<typeof useQcSelfServeBrandOptionsLazyQuery>;
export type QcSelfServeBrandOptionsQueryResult = Apollo.QueryResult<QcSelfServeBrandOptionsQuery, QcSelfServeBrandOptionsQueryVariables>;
export const QcSelfServeRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QcSelfServeRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QCSelfServeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDir"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"QCSelfServeRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDir"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDir"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"checkId"}},{"kind":"Field","name":{"kind":"Name","value":"checkDescription"}},{"kind":"Field","name":{"kind":"Name","value":"expectedOutcome"}},{"kind":"Field","name":{"kind":"Name","value":"pv2Id"}},{"kind":"Field","name":{"kind":"Name","value":"spinsUpc"}},{"kind":"Field","name":{"kind":"Name","value":"mfrCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"primaryAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"primaryValue"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryValue"}},{"kind":"Field","name":{"kind":"Name","value":"conflictingAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"conflictingValue"}},{"kind":"Field","name":{"kind":"Name","value":"expectedValue"}},{"kind":"Field","name":{"kind":"Name","value":"peerSupport"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"unitOfMeasure"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"functionalIngredient"}},{"kind":"Field","name":{"kind":"Name","value":"functionalIngredientFlag"}},{"kind":"Field","name":{"kind":"Name","value":"organic"}},{"kind":"Field","name":{"kind":"Name","value":"delivered"}},{"kind":"Field","name":{"kind":"Name","value":"lowConfidence"}},{"kind":"Field","name":{"kind":"Name","value":"pvlProp"}},{"kind":"Field","name":{"kind":"Name","value":"pvlConv"}},{"kind":"Field","name":{"kind":"Name","value":"channelProp"}},{"kind":"Field","name":{"kind":"Name","value":"channelConv"}},{"kind":"Field","name":{"kind":"Name","value":"firstFlaggedDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysSinceFlagged"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useQcSelfServeRowsQuery__
 *
 * To run a query within a React component, call `useQcSelfServeRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQcSelfServeRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQcSelfServeRowsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortDir: // value for 'sortDir'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useQcSelfServeRowsQuery(baseOptions?: Apollo.QueryHookOptions<QcSelfServeRowsQuery, QcSelfServeRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QcSelfServeRowsQuery, QcSelfServeRowsQueryVariables>(QcSelfServeRowsDocument, options);
      }
export function useQcSelfServeRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QcSelfServeRowsQuery, QcSelfServeRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QcSelfServeRowsQuery, QcSelfServeRowsQueryVariables>(QcSelfServeRowsDocument, options);
        }
export type QcSelfServeRowsQueryHookResult = ReturnType<typeof useQcSelfServeRowsQuery>;
export type QcSelfServeRowsLazyQueryHookResult = ReturnType<typeof useQcSelfServeRowsLazyQuery>;
export type QcSelfServeRowsQueryResult = Apollo.QueryResult<QcSelfServeRowsQuery, QcSelfServeRowsQueryVariables>;
export const ScriptsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScriptsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCircana"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ScriptsList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isCircana"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCircana"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScriptMetadataSummary"}}]}}]}},...ScriptMetadataSummaryFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useScriptsListQuery__
 *
 * To run a query within a React component, call `useScriptsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useScriptsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScriptsListQuery({
 *   variables: {
 *      isCircana: // value for 'isCircana'
 *   },
 * });
 */
export function useScriptsListQuery(baseOptions?: Apollo.QueryHookOptions<ScriptsListQuery, ScriptsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScriptsListQuery, ScriptsListQueryVariables>(ScriptsListDocument, options);
      }
export function useScriptsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScriptsListQuery, ScriptsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScriptsListQuery, ScriptsListQueryVariables>(ScriptsListDocument, options);
        }
export type ScriptsListQueryHookResult = ReturnType<typeof useScriptsListQuery>;
export type ScriptsListLazyQueryHookResult = ReturnType<typeof useScriptsListLazyQuery>;
export type ScriptsListQueryResult = Apollo.QueryResult<ScriptsListQuery, ScriptsListQueryVariables>;
export const ScriptInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScriptInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scriptKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScriptKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ScriptInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scriptKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScriptMetadataDetail"}}]}}]}},...ScriptMetadataDetailFragmentDoc.definitions,...ScriptMetadataSummaryFragmentDoc.definitions,...ScriptRunInfoFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useScriptInfoQuery__
 *
 * To run a query within a React component, call `useScriptInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useScriptInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScriptInfoQuery({
 *   variables: {
 *      scriptKey: // value for 'scriptKey'
 *   },
 * });
 */
export function useScriptInfoQuery(baseOptions?: Apollo.QueryHookOptions<ScriptInfoQuery, ScriptInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScriptInfoQuery, ScriptInfoQueryVariables>(ScriptInfoDocument, options);
      }
export function useScriptInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScriptInfoQuery, ScriptInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScriptInfoQuery, ScriptInfoQueryVariables>(ScriptInfoDocument, options);
        }
export type ScriptInfoQueryHookResult = ReturnType<typeof useScriptInfoQuery>;
export type ScriptInfoLazyQueryHookResult = ReturnType<typeof useScriptInfoLazyQuery>;
export type ScriptInfoQueryResult = Apollo.QueryResult<ScriptInfoQuery, ScriptInfoQueryVariables>;
export const GetServiceHeartbeatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServiceHeartbeat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ServiceHeartbeat_check"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"heartbeats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRunning"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastCheckedTimestamp"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetServiceHeartbeatQuery__
 *
 * To run a query within a React component, call `useGetServiceHeartbeatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceHeartbeatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceHeartbeatQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServiceHeartbeatQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceHeartbeatQuery, GetServiceHeartbeatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceHeartbeatQuery, GetServiceHeartbeatQueryVariables>(GetServiceHeartbeatDocument, options);
      }
export function useGetServiceHeartbeatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceHeartbeatQuery, GetServiceHeartbeatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceHeartbeatQuery, GetServiceHeartbeatQueryVariables>(GetServiceHeartbeatDocument, options);
        }
export type GetServiceHeartbeatQueryHookResult = ReturnType<typeof useGetServiceHeartbeatQuery>;
export type GetServiceHeartbeatLazyQueryHookResult = ReturnType<typeof useGetServiceHeartbeatLazyQuery>;
export type GetServiceHeartbeatQueryResult = Apollo.QueryResult<GetServiceHeartbeatQuery, GetServiceHeartbeatQueryVariables>;
export const SpinsAttributeType_NamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SpinsAttributeType_names"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"1000"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"displayName","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SpinsAttributeType_query"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSpinsAttributeType_NamesQuery__
 *
 * To run a query within a React component, call `useSpinsAttributeType_NamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpinsAttributeType_NamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpinsAttributeType_NamesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSpinsAttributeType_NamesQuery(baseOptions?: Apollo.QueryHookOptions<SpinsAttributeType_NamesQuery, SpinsAttributeType_NamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpinsAttributeType_NamesQuery, SpinsAttributeType_NamesQueryVariables>(SpinsAttributeType_NamesDocument, options);
      }
export function useSpinsAttributeType_NamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpinsAttributeType_NamesQuery, SpinsAttributeType_NamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpinsAttributeType_NamesQuery, SpinsAttributeType_NamesQueryVariables>(SpinsAttributeType_NamesDocument, options);
        }
export type SpinsAttributeType_NamesQueryHookResult = ReturnType<typeof useSpinsAttributeType_NamesQuery>;
export type SpinsAttributeType_NamesLazyQueryHookResult = ReturnType<typeof useSpinsAttributeType_NamesLazyQuery>;
export type SpinsAttributeType_NamesQueryResult = Apollo.QueryResult<SpinsAttributeType_NamesQuery, SpinsAttributeType_NamesQueryVariables>;
export const TaskDefinitionSummaryFindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskDefinitionSummaryFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskDefinition_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskDefinitionSummaryFragment"}}]}}]}}]}},...TaskDefinitionSummaryFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTaskDefinitionSummaryFindQuery__
 *
 * To run a query within a React component, call `useTaskDefinitionSummaryFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDefinitionSummaryFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDefinitionSummaryFindQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTaskDefinitionSummaryFindQuery(baseOptions: Apollo.QueryHookOptions<TaskDefinitionSummaryFindQuery, TaskDefinitionSummaryFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDefinitionSummaryFindQuery, TaskDefinitionSummaryFindQueryVariables>(TaskDefinitionSummaryFindDocument, options);
      }
export function useTaskDefinitionSummaryFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDefinitionSummaryFindQuery, TaskDefinitionSummaryFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDefinitionSummaryFindQuery, TaskDefinitionSummaryFindQueryVariables>(TaskDefinitionSummaryFindDocument, options);
        }
export type TaskDefinitionSummaryFindQueryHookResult = ReturnType<typeof useTaskDefinitionSummaryFindQuery>;
export type TaskDefinitionSummaryFindLazyQueryHookResult = ReturnType<typeof useTaskDefinitionSummaryFindLazyQuery>;
export type TaskDefinitionSummaryFindQueryResult = Apollo.QueryResult<TaskDefinitionSummaryFindQuery, TaskDefinitionSummaryFindQueryVariables>;
export const TaskDefinitionDataRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskDefinitionDataRequirements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectId"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskDefinitionTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskDefinition_dataRequirements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"config"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DataRequirementFragment"}}]}}]}},...DataRequirementFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTaskDefinitionDataRequirementsQuery__
 *
 * To run a query within a React component, call `useTaskDefinitionDataRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDefinitionDataRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDefinitionDataRequirementsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *      type: // value for 'type'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useTaskDefinitionDataRequirementsQuery(baseOptions: Apollo.QueryHookOptions<TaskDefinitionDataRequirementsQuery, TaskDefinitionDataRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDefinitionDataRequirementsQuery, TaskDefinitionDataRequirementsQueryVariables>(TaskDefinitionDataRequirementsDocument, options);
      }
export function useTaskDefinitionDataRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDefinitionDataRequirementsQuery, TaskDefinitionDataRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDefinitionDataRequirementsQuery, TaskDefinitionDataRequirementsQueryVariables>(TaskDefinitionDataRequirementsDocument, options);
        }
export type TaskDefinitionDataRequirementsQueryHookResult = ReturnType<typeof useTaskDefinitionDataRequirementsQuery>;
export type TaskDefinitionDataRequirementsLazyQueryHookResult = ReturnType<typeof useTaskDefinitionDataRequirementsLazyQuery>;
export type TaskDefinitionDataRequirementsQueryResult = Apollo.QueryResult<TaskDefinitionDataRequirementsQuery, TaskDefinitionDataRequirementsQueryVariables>;
export const TaskDefinitionsWorkflowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskDefinitionsWorkflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskDefinitions_workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskDefinitionWorkflowNodeFragment"}}]}}]}}]}},...TaskDefinitionWorkflowNodeFragmentFragmentDoc.definitions,...TaskDefinitionWorkflowChildFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTaskDefinitionsWorkflowQuery__
 *
 * To run a query within a React component, call `useTaskDefinitionsWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDefinitionsWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDefinitionsWorkflowQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskDefinitionsWorkflowQuery(baseOptions?: Apollo.QueryHookOptions<TaskDefinitionsWorkflowQuery, TaskDefinitionsWorkflowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDefinitionsWorkflowQuery, TaskDefinitionsWorkflowQueryVariables>(TaskDefinitionsWorkflowDocument, options);
      }
export function useTaskDefinitionsWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDefinitionsWorkflowQuery, TaskDefinitionsWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDefinitionsWorkflowQuery, TaskDefinitionsWorkflowQueryVariables>(TaskDefinitionsWorkflowDocument, options);
        }
export type TaskDefinitionsWorkflowQueryHookResult = ReturnType<typeof useTaskDefinitionsWorkflowQuery>;
export type TaskDefinitionsWorkflowLazyQueryHookResult = ReturnType<typeof useTaskDefinitionsWorkflowLazyQuery>;
export type TaskDefinitionsWorkflowQueryResult = Apollo.QueryResult<TaskDefinitionsWorkflowQuery, TaskDefinitionsWorkflowQueryVariables>;
export const TaskFindPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskFindPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Task_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFragment"}}]}}]}}]}},...TaskFragmentFragmentDoc.definitions,...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions,...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTaskFindPageQuery__
 *
 * To run a query within a React component, call `useTaskFindPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFindPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFindPageQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTaskFindPageQuery(baseOptions: Apollo.QueryHookOptions<TaskFindPageQuery, TaskFindPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFindPageQuery, TaskFindPageQueryVariables>(TaskFindPageDocument, options);
      }
export function useTaskFindPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFindPageQuery, TaskFindPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFindPageQuery, TaskFindPageQueryVariables>(TaskFindPageDocument, options);
        }
export type TaskFindPageQueryHookResult = ReturnType<typeof useTaskFindPageQuery>;
export type TaskFindPageLazyQueryHookResult = ReturnType<typeof useTaskFindPageLazyQuery>;
export type TaskFindPageQueryResult = Apollo.QueryResult<TaskFindPageQuery, TaskFindPageQueryVariables>;
export const TaskQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TaskQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalTask"}}]}}]}}]}},...InternalTaskFragmentDoc.definitions,...TaskFragmentFragmentDoc.definitions,...TaskDefinitionFragmentFragmentDoc.definitions,...TagStructFragmentFragmentDoc.definitions,...DataRequirementFragmentFragmentDoc.definitions,...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useTaskQueueQuery__
 *
 * To run a query within a React component, call `useTaskQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQueueQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTaskQueueQuery(baseOptions?: Apollo.QueryHookOptions<TaskQueueQuery, TaskQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQueueQuery, TaskQueueQueryVariables>(TaskQueueDocument, options);
      }
export function useTaskQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQueueQuery, TaskQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQueueQuery, TaskQueueQueryVariables>(TaskQueueDocument, options);
        }
export type TaskQueueQueryHookResult = ReturnType<typeof useTaskQueueQuery>;
export type TaskQueueLazyQueryHookResult = ReturnType<typeof useTaskQueueLazyQuery>;
export type TaskQueueQueryResult = Apollo.QueryResult<TaskQueueQuery, TaskQueueQueryVariables>;
export const CompanyAutocompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyAutocomplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Company_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCompanyAutocompleteQuery__
 *
 * To run a query within a React component, call `useCompanyAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAutocompleteQuery({
 *   variables: {
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCompanyAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<CompanyAutocompleteQuery, CompanyAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAutocompleteQuery, CompanyAutocompleteQueryVariables>(CompanyAutocompleteDocument, options);
      }
export function useCompanyAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAutocompleteQuery, CompanyAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAutocompleteQuery, CompanyAutocompleteQueryVariables>(CompanyAutocompleteDocument, options);
        }
export type CompanyAutocompleteQueryHookResult = ReturnType<typeof useCompanyAutocompleteQuery>;
export type CompanyAutocompleteLazyQueryHookResult = ReturnType<typeof useCompanyAutocompleteLazyQuery>;
export type CompanyAutocompleteQueryResult = Apollo.QueryResult<CompanyAutocompleteQuery, CompanyAutocompleteQueryVariables>;
export const FormulaAutocompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormulaAutocomplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Formula_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useFormulaAutocompleteQuery__
 *
 * To run a query within a React component, call `useFormulaAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaAutocompleteQuery({
 *   variables: {
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFormulaAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<FormulaAutocompleteQuery, FormulaAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulaAutocompleteQuery, FormulaAutocompleteQueryVariables>(FormulaAutocompleteDocument, options);
      }
export function useFormulaAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulaAutocompleteQuery, FormulaAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulaAutocompleteQuery, FormulaAutocompleteQueryVariables>(FormulaAutocompleteDocument, options);
        }
export type FormulaAutocompleteQueryHookResult = ReturnType<typeof useFormulaAutocompleteQuery>;
export type FormulaAutocompleteLazyQueryHookResult = ReturnType<typeof useFormulaAutocompleteLazyQuery>;
export type FormulaAutocompleteQueryResult = Apollo.QueryResult<FormulaAutocompleteQuery, FormulaAutocompleteQueryVariables>;
export const FormulaResourceAutocompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormulaResourceAutocomplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormulaResource_find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useFormulaResourceAutocompleteQuery__
 *
 * To run a query within a React component, call `useFormulaResourceAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaResourceAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaResourceAutocompleteQuery({
 *   variables: {
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFormulaResourceAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<FormulaResourceAutocompleteQuery, FormulaResourceAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulaResourceAutocompleteQuery, FormulaResourceAutocompleteQueryVariables>(FormulaResourceAutocompleteDocument, options);
      }
export function useFormulaResourceAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulaResourceAutocompleteQuery, FormulaResourceAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulaResourceAutocompleteQuery, FormulaResourceAutocompleteQueryVariables>(FormulaResourceAutocompleteDocument, options);
        }
export type FormulaResourceAutocompleteQueryHookResult = ReturnType<typeof useFormulaResourceAutocompleteQuery>;
export type FormulaResourceAutocompleteLazyQueryHookResult = ReturnType<typeof useFormulaResourceAutocompleteLazyQuery>;
export type FormulaResourceAutocompleteQueryResult = Apollo.QueryResult<FormulaResourceAutocompleteQuery, FormulaResourceAutocompleteQueryVariables>;
export const SpinsBrandValuesAutocompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SpinsBrandValuesAutocomplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startsWith"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SpinsBrandValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startsWith"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startsWith"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useSpinsBrandValuesAutocompleteQuery__
 *
 * To run a query within a React component, call `useSpinsBrandValuesAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpinsBrandValuesAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpinsBrandValuesAutocompleteQuery({
 *   variables: {
 *      startsWith: // value for 'startsWith'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSpinsBrandValuesAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<SpinsBrandValuesAutocompleteQuery, SpinsBrandValuesAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpinsBrandValuesAutocompleteQuery, SpinsBrandValuesAutocompleteQueryVariables>(SpinsBrandValuesAutocompleteDocument, options);
      }
export function useSpinsBrandValuesAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpinsBrandValuesAutocompleteQuery, SpinsBrandValuesAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpinsBrandValuesAutocompleteQuery, SpinsBrandValuesAutocompleteQueryVariables>(SpinsBrandValuesAutocompleteDocument, options);
        }
export type SpinsBrandValuesAutocompleteQueryHookResult = ReturnType<typeof useSpinsBrandValuesAutocompleteQuery>;
export type SpinsBrandValuesAutocompleteLazyQueryHookResult = ReturnType<typeof useSpinsBrandValuesAutocompleteLazyQuery>;
export type SpinsBrandValuesAutocompleteQueryResult = Apollo.QueryResult<SpinsBrandValuesAutocompleteQuery, SpinsBrandValuesAutocompleteQueryVariables>;
export const SessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAuthenticated"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},...UserFragmentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useSessionQuery__
 *
 * To run a query within a React component, call `useSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionQuery(baseOptions?: Apollo.QueryHookOptions<SessionQuery, SessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
      }
export function useSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionQuery, SessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
        }
export type SessionQueryHookResult = ReturnType<typeof useSessionQuery>;
export type SessionLazyQueryHookResult = ReturnType<typeof useSessionLazyQuery>;
export type SessionQueryResult = Apollo.QueryResult<SessionQuery, SessionQueryVariables>;
export const namedOperations = {
  Query: {
    BuilderBatch: 'BuilderBatch',
    BuilderBatchFind: 'BuilderBatchFind',
    BuilderBatchCount: 'BuilderBatchCount',
    BuilderBatchQueryIds: 'BuilderBatchQueryIds',
    CompanySignupRequest: 'CompanySignupRequest',
    CompanySignupRequestFind: 'CompanySignupRequestFind',
    CompanySignupRequestCount: 'CompanySignupRequestCount',
    CompanySignupRequestQueryIds: 'CompanySignupRequestQueryIds',
    Config: 'Config',
    ConfigFind: 'ConfigFind',
    ConfigCount: 'ConfigCount',
    ConfigQueryIds: 'ConfigQueryIds',
    Domain: 'Domain',
    DomainFind: 'DomainFind',
    DomainCount: 'DomainCount',
    DomainQueryIds: 'DomainQueryIds',
    FormInstruction: 'FormInstruction',
    FormInstructionFind: 'FormInstructionFind',
    FormInstructionCount: 'FormInstructionCount',
    FormInstructionQueryIds: 'FormInstructionQueryIds',
    Form: 'Form',
    FormFind: 'FormFind',
    FormCount: 'FormCount',
    FormQueryIds: 'FormQueryIds',
    Formula: 'Formula',
    FormulaFind: 'FormulaFind',
    FormulaCount: 'FormulaCount',
    FormulaQueryIds: 'FormulaQueryIds',
    FormulaResource: 'FormulaResource',
    FormulaResourceFind: 'FormulaResourceFind',
    FormulaResourceCount: 'FormulaResourceCount',
    FormulaResourceQueryIds: 'FormulaResourceQueryIds',
    Image: 'Image',
    ImageFind: 'ImageFind',
    ImageCount: 'ImageCount',
    ImageQueryIds: 'ImageQueryIds',
    MturkWorker: 'MturkWorker',
    MturkWorkerFind: 'MturkWorkerFind',
    MturkWorkerCount: 'MturkWorkerCount',
    MturkWorkerQueryIds: 'MturkWorkerQueryIds',
    Pv2AttributeDefinition: 'Pv2AttributeDefinition',
    Pv2AttributeDefinitionFind: 'Pv2AttributeDefinitionFind',
    Pv2AttributeDefinitionCount: 'Pv2AttributeDefinitionCount',
    Pv2AttributeDefinitionQueryIds: 'Pv2AttributeDefinitionQueryIds',
    Pv2: 'Pv2',
    Pv2Find: 'Pv2Find',
    Pv2Count: 'Pv2Count',
    Pv2QueryIds: 'Pv2QueryIds',
    TaskDefinition: 'TaskDefinition',
    TaskDefinitionFind: 'TaskDefinitionFind',
    TaskDefinitionCount: 'TaskDefinitionCount',
    TaskDefinitionQueryIds: 'TaskDefinitionQueryIds',
    Task: 'Task',
    TaskFind: 'TaskFind',
    TaskCount: 'TaskCount',
    TaskQueryIds: 'TaskQueryIds',
    Taxonomy: 'Taxonomy',
    TaxonomyFind: 'TaxonomyFind',
    TaxonomyCount: 'TaxonomyCount',
    TaxonomyQueryIds: 'TaxonomyQueryIds',
    TransformerExpression: 'TransformerExpression',
    TransformerExpressionFind: 'TransformerExpressionFind',
    TransformerExpressionCount: 'TransformerExpressionCount',
    TransformerExpressionQueryIds: 'TransformerExpressionQueryIds',
    TransformerResource: 'TransformerResource',
    TransformerResourceFind: 'TransformerResourceFind',
    TransformerResourceCount: 'TransformerResourceCount',
    TransformerResourceQueryIds: 'TransformerResourceQueryIds',
    User: 'User',
    UserFind: 'UserFind',
    UserCount: 'UserCount',
    UserQueryIds: 'UserQueryIds',
    AsinAttributeLevelCoverage: 'AsinAttributeLevelCoverage',
    AsinSubcategoryLevelCoverage: 'AsinSubcategoryLevelCoverage',
    AsinLevelCoverage: 'AsinLevelCoverage',
    AsinCoverageHierarchyFilter: 'AsinCoverageHierarchyFilter',
    AsinCoverageAttributeThemeFilter: 'AsinCoverageAttributeThemeFilter',
    AttributeLevelCoverage: 'AttributeLevelCoverage',
    SubcategoryLevelCoverage: 'SubcategoryLevelCoverage',
    UpcLevelCoverage: 'UpcLevelCoverage',
    AttributeCoverageHierarchyFilter: 'AttributeCoverageHierarchyFilter',
    AttributeCoverageAttributeThemeFilter: 'AttributeCoverageAttributeThemeFilter',
    AttributeSalesAssessmentAggregation: 'AttributeSalesAssessmentAggregation',
    AttributeSalesFilterCombos: 'AttributeSalesFilterCombos',
    AttributeSalesAssessmentStats: 'AttributeSalesAssessmentStats',
    AttributeSalesAssessment: 'AttributeSalesAssessment',
    BrandReviewFind: 'BrandReviewFind',
    BrandReviewReasonCounts: 'BrandReviewReasonCounts',
    BrandReviewStatusCounts: 'BrandReviewStatusCounts',
    BuilderRecomputeRuns: 'BuilderRecomputeRuns',
    ClientFeedbackClientNames: 'ClientFeedbackClientNames',
    ClientFeedbackPeriodReleases: 'ClientFeedbackPeriodReleases',
    ClientFeedbackWhoIsSubmitting: 'ClientFeedbackWhoIsSubmitting',
    ClientFeedbackTicketTrends: 'ClientFeedbackTicketTrends',
    ClientFeedbackAttributeUpdates: 'ClientFeedbackAttributeUpdates',
    ClientFeedbackTicketExtract: 'ClientFeedbackTicketExtract',
    ClientFeedbackCategoryUpdates: 'ClientFeedbackCategoryUpdates',
    ClientFeedbackProductUpdates: 'ClientFeedbackProductUpdates',
    ClientFeedbackRootCauses: 'ClientFeedbackRootCauses',
    ClientFeedbackAttributeTrends: 'ClientFeedbackAttributeTrends',
    ClientTrackerIncorrectAttributeName: 'ClientTrackerIncorrectAttributeName',
    ClientTrackerMismatchesPage: 'ClientTrackerMismatchesPage',
    ClientTrackerMismatchesCount: 'ClientTrackerMismatchesCount',
    ClientTrackerValueCount: 'ClientTrackerValueCount',
    ClientTrackerValueFind: 'ClientTrackerValueFind',
    CostAndBillingMonthly: 'CostAndBillingMonthly',
    CostAndBillingDaily: 'CostAndBillingDaily',
    CountImagesToProcess: 'CountImagesToProcess',
    DownloadImages: 'DownloadImages',
    EnvironmentInfo_get: 'EnvironmentInfo_get',
    FeatureFlags_get: 'FeatureFlags_get',
    FetchImageSides: 'FetchImageSides',
    FetchImageSources: 'FetchImageSources',
    FindImagesToProcess: 'FindImagesToProcess',
    GenerateToken: 'GenerateToken',
    GetAllServices: 'GetAllServices',
    GetSignedFileLink: 'GetSignedFileLink',
    ModelCount: 'ModelCount',
    HierarchyMapping_find: 'HierarchyMapping_find',
    HierarchyMapping: 'HierarchyMapping',
    HierarchyMapping_bulkEvaluate: 'HierarchyMapping_bulkEvaluate',
    HierarchyMapping_evaluate: 'HierarchyMapping_evaluate',
    HistoryGetSummaries: 'HistoryGetSummaries',
    HistoryGetVersion: 'HistoryGetVersion',
    ImageAnnotatorInfo: 'ImageAnnotatorInfo',
    ImageProcessingQueueStats: 'ImageProcessingQueueStats',
    IngredientDetails: 'IngredientDetails',
    IngredientFormulaReferences: 'IngredientFormulaReferences',
    NewItemActivation: 'NewItemActivation',
    ActivationStatusFilter: 'ActivationStatusFilter',
    NewItemActivationCount: 'NewItemActivationCount',
    MiddlewareFormulas: 'MiddlewareFormulas',
    Model: 'Model',
    Pv2AttributeDefinitions_schemaFieldsWithTypes: 'Pv2AttributeDefinitions_schemaFieldsWithTypes',
    ModelAggregate: 'ModelAggregate',
    ModelDistinctCount: 'ModelDistinctCount',
    ModelFindById: 'ModelFindById',
    ModelFindMany: 'ModelFindMany',
    ModelTagNames: 'ModelTagNames',
    ModelTagCounts: 'ModelTagCounts',
    Models: 'Models',
    PredictionOverrideAllowedValues: 'PredictionOverrideAllowedValues',
    PredictionOverrideBulkLookup: 'PredictionOverrideBulkLookup',
    PredictionOverrideCount: 'PredictionOverrideCount',
    PredictionOverrideFind: 'PredictionOverrideFind',
    Pv2AttributeDefinitionCreateAttributeSchema: 'Pv2AttributeDefinitionCreateAttributeSchema',
    Pv2FetchIds: 'Pv2FetchIds',
    Pv2SpinsUpcFind: 'Pv2SpinsUpcFind',
    Pv2Ingredients_search: 'Pv2Ingredients_search',
    Pv2sByIngredients_search: 'Pv2sByIngredients_search',
    QcSelfServeSummary: 'QcSelfServeSummary',
    QcSelfServeCheckCounts: 'QcSelfServeCheckCounts',
    QcSelfServeCheckDescriptionCounts: 'QcSelfServeCheckDescriptionCounts',
    QcSelfServeFilterOptions: 'QcSelfServeFilterOptions',
    QcSelfServeBrandOptions: 'QcSelfServeBrandOptions',
    QcSelfServeRows: 'QcSelfServeRows',
    ScriptsList: 'ScriptsList',
    ScriptInfo: 'ScriptInfo',
    GetServiceHeartbeat: 'GetServiceHeartbeat',
    SpinsAttributeType_names: 'SpinsAttributeType_names',
    TaskDefinitionSummaryFind: 'TaskDefinitionSummaryFind',
    TaskDefinitionDataRequirements: 'TaskDefinitionDataRequirements',
    TaskDefinitionsWorkflow: 'TaskDefinitionsWorkflow',
    TaskFindPage: 'TaskFindPage',
    TaskQueue: 'TaskQueue',
    CompanyAutocomplete: 'CompanyAutocomplete',
    FormulaAutocomplete: 'FormulaAutocomplete',
    FormulaResourceAutocomplete: 'FormulaResourceAutocomplete',
    SpinsBrandValuesAutocomplete: 'SpinsBrandValuesAutocomplete',
    session: 'session'
  },
  Mutation: {
    BuilderBatchUpdate: 'BuilderBatchUpdate',
    BuilderBatchCreate: 'BuilderBatchCreate',
    BuilderBatchRemove: 'BuilderBatchRemove',
    BuilderBatchRemoveMany: 'BuilderBatchRemoveMany',
    BuilderBatchAggregate: 'BuilderBatchAggregate',
    CompanySignupRequestUpdate: 'CompanySignupRequestUpdate',
    CompanySignupRequestCreate: 'CompanySignupRequestCreate',
    CompanySignupRequestRemove: 'CompanySignupRequestRemove',
    CompanySignupRequestRemoveMany: 'CompanySignupRequestRemoveMany',
    CompanySignupRequestAggregate: 'CompanySignupRequestAggregate',
    ConfigUpdate: 'ConfigUpdate',
    ConfigCreate: 'ConfigCreate',
    ConfigRemove: 'ConfigRemove',
    ConfigRemoveMany: 'ConfigRemoveMany',
    ConfigAggregate: 'ConfigAggregate',
    DomainUpdate: 'DomainUpdate',
    DomainCreate: 'DomainCreate',
    DomainRemove: 'DomainRemove',
    DomainRemoveMany: 'DomainRemoveMany',
    DomainAggregate: 'DomainAggregate',
    FormInstructionUpdate: 'FormInstructionUpdate',
    FormInstructionCreate: 'FormInstructionCreate',
    FormInstructionRemove: 'FormInstructionRemove',
    FormInstructionRemoveMany: 'FormInstructionRemoveMany',
    FormInstructionAggregate: 'FormInstructionAggregate',
    FormUpdate: 'FormUpdate',
    FormCreate: 'FormCreate',
    FormRemove: 'FormRemove',
    FormRemoveMany: 'FormRemoveMany',
    FormAggregate: 'FormAggregate',
    FormulaUpdate: 'FormulaUpdate',
    FormulaCreate: 'FormulaCreate',
    FormulaRemove: 'FormulaRemove',
    FormulaRemoveMany: 'FormulaRemoveMany',
    FormulaAggregate: 'FormulaAggregate',
    FormulaResourceUpdate: 'FormulaResourceUpdate',
    FormulaResourceCreate: 'FormulaResourceCreate',
    FormulaResourceRemove: 'FormulaResourceRemove',
    FormulaResourceRemoveMany: 'FormulaResourceRemoveMany',
    FormulaResourceAggregate: 'FormulaResourceAggregate',
    ImageUpdate: 'ImageUpdate',
    Image_create: 'Image_create',
    ImageRemove: 'ImageRemove',
    ImageRemoveMany: 'ImageRemoveMany',
    ImageAggregate: 'ImageAggregate',
    MturkWorkerUpdate: 'MturkWorkerUpdate',
    MturkWorkerCreate: 'MturkWorkerCreate',
    MturkWorkerRemove: 'MturkWorkerRemove',
    MturkWorkerRemoveMany: 'MturkWorkerRemoveMany',
    MturkWorkerAggregate: 'MturkWorkerAggregate',
    Pv2AttributeDefinitionUpdate: 'Pv2AttributeDefinitionUpdate',
    Pv2AttributeDefinitionCreate: 'Pv2AttributeDefinitionCreate',
    Pv2AttributeDefinitionRemove: 'Pv2AttributeDefinitionRemove',
    Pv2AttributeDefinitionRemoveMany: 'Pv2AttributeDefinitionRemoveMany',
    Pv2AttributeDefinitionAggregate: 'Pv2AttributeDefinitionAggregate',
    Pv2Update: 'Pv2Update',
    Pv2Create: 'Pv2Create',
    Pv2Remove: 'Pv2Remove',
    Pv2RemoveMany: 'Pv2RemoveMany',
    Pv2Aggregate: 'Pv2Aggregate',
    TaskDefinitionUpdate: 'TaskDefinitionUpdate',
    TaskDefinitionCreate: 'TaskDefinitionCreate',
    TaskDefinitionRemove: 'TaskDefinitionRemove',
    TaskDefinitionRemoveMany: 'TaskDefinitionRemoveMany',
    TaskDefinitionAggregate: 'TaskDefinitionAggregate',
    TaskUpdate: 'TaskUpdate',
    TaskCreate: 'TaskCreate',
    TaskRemove: 'TaskRemove',
    TaskRemoveMany: 'TaskRemoveMany',
    TaskAggregate: 'TaskAggregate',
    TaxonomyUpdate: 'TaxonomyUpdate',
    TaxonomyCreate: 'TaxonomyCreate',
    TaxonomyRemove: 'TaxonomyRemove',
    TaxonomyRemoveMany: 'TaxonomyRemoveMany',
    TaxonomyAggregate: 'TaxonomyAggregate',
    TransformerExpressionUpdate: 'TransformerExpressionUpdate',
    TransformerExpressionCreate: 'TransformerExpressionCreate',
    TransformerExpressionRemove: 'TransformerExpressionRemove',
    TransformerExpressionRemoveMany: 'TransformerExpressionRemoveMany',
    TransformerExpressionAggregate: 'TransformerExpressionAggregate',
    TransformerResourceUpdate: 'TransformerResourceUpdate',
    TransformerResourceCreate: 'TransformerResourceCreate',
    TransformerResourceRemove: 'TransformerResourceRemove',
    TransformerResourceRemoveMany: 'TransformerResourceRemoveMany',
    TransformerResourceAggregate: 'TransformerResourceAggregate',
    UserUpdate: 'UserUpdate',
    UserCreate: 'UserCreate',
    UserRemove: 'UserRemove',
    UserRemoveMany: 'UserRemoveMany',
    UserAggregate: 'UserAggregate',
    AcceptImages: 'AcceptImages',
    AddImageToProcessingQueue: 'AddImageToProcessingQueue',
    AttributeSalesAssessmentRun: 'AttributeSalesAssessmentRun',
    BrandReview_update: 'BrandReview_update',
    ClientTrackerValue_create: 'ClientTrackerValue_create',
    ClientTrackerValue_update: 'ClientTrackerValue_update',
    ClientTrackerValue_upsert: 'ClientTrackerValue_upsert',
    CreateAdminToken: 'CreateAdminToken',
    DigitizationGrantUserAccess: 'DigitizationGrantUserAccess',
    FeatureFlags_set: 'FeatureFlags_set',
    HierarchyMapping_create: 'HierarchyMapping_create',
    HierarchyMapping_remove: 'HierarchyMapping_remove',
    HierarchyMapping_update: 'HierarchyMapping_update',
    ModelAddTag: 'ModelAddTag',
    ModelRemoveTag: 'ModelRemoveTag',
    ModelUpdateById: 'ModelUpdateById',
    PredictionOverride_save: 'PredictionOverride_save',
    Pv2IngredientSetReviewStatus: 'Pv2IngredientSetReviewStatus',
    QcSelfServeRunAnalysis: 'QcSelfServeRunAnalysis',
    RejectImages: 'RejectImages',
    RestartService: 'RestartService',
    RunScript: 'RunScript',
    TaskAssign: 'TaskAssign',
    TaskRetrigger: 'TaskRetrigger',
    TaskSubmit: 'TaskSubmit',
    TriggerBuilderRecompute: 'TriggerBuilderRecompute',
    UpdatePv2sForUploadedImages: 'UpdatePv2sForUploadedImages',
    UploadProcessedImages: 'UploadProcessedImages',
    UploadPublicAsset: 'UploadPublicAsset',
    createS3PresignedImageProcessingPutUrl: 'createS3PresignedImageProcessingPutUrl',
    createTasks: 'createTasks',
    login: 'login'
  },
  Fragment: {
    BarcodeStructFragment: 'BarcodeStructFragment',
    BuilderBatchFragment: 'BuilderBatchFragment',
    ChangelogEntryStructFragment: 'ChangelogEntryStructFragment',
    CompanySignupRequestFragment: 'CompanySignupRequestFragment',
    ConfigFragment: 'ConfigFragment',
    DataRequirementFragment: 'DataRequirementFragment',
    DomainCompanyFragment: 'DomainCompanyFragment',
    DomainFragment: 'DomainFragment',
    DomainTaxonomyFragment: 'DomainTaxonomyFragment',
    DomainUserFragment: 'DomainUserFragment',
    FormFragment: 'FormFragment',
    FormInstructionFragment: 'FormInstructionFragment',
    FormulaFragment: 'FormulaFragment',
    FormulaResourceFragment: 'FormulaResourceFragment',
    ImageFragment: 'ImageFragment',
    ImageUrlFragment: 'ImageUrlFragment',
    MturkWorkerFragment: 'MturkWorkerFragment',
    MturkWorkerQualificationFragment: 'MturkWorkerQualificationFragment',
    Pv2AttributeDefinitionFragment: 'Pv2AttributeDefinitionFragment',
    Pv2AttributeStructFragment: 'Pv2AttributeStructFragment',
    Pv2DigitizationOutOfStockFragment: 'Pv2DigitizationOutOfStockFragment',
    Pv2DigitizationStatusFragment: 'Pv2DigitizationStatusFragment',
    Pv2DigitizationStoreDoneFragment: 'Pv2DigitizationStoreDoneFragment',
    Pv2Fragment: 'Pv2Fragment',
    Pv2IdentifierFragment: 'Pv2IdentifierFragment',
    Pv2IngestionMetadataFragment: 'Pv2IngestionMetadataFragment',
    ScannedBarcodesFragment: 'ScannedBarcodesFragment',
    TagStructFragment: 'TagStructFragment',
    TaskDefinitionFragment: 'TaskDefinitionFragment',
    TaskFragment: 'TaskFragment',
    TaxonomyFragment: 'TaxonomyFragment',
    TransformerExpressionFragment: 'TransformerExpressionFragment',
    TransformerResourceFragment: 'TransformerResourceFragment',
    UserFragment: 'UserFragment',
    HierarchyMappingFragment: 'HierarchyMappingFragment',
    HierarchyMappingChildRule: 'HierarchyMappingChildRule',
    HierarchyMappingRule: 'HierarchyMappingRule',
    HierarchyMappingCondition: 'HierarchyMappingCondition',
    HierarchyMappingLookupOption: 'HierarchyMappingLookupOption',
    HierarchyMappingBulkEvaluationResultItem: 'HierarchyMappingBulkEvaluationResultItem',
    HierarchyMappingAttributeValue: 'HierarchyMappingAttributeValue',
    HierarchyMappingTaxonomyInfo: 'HierarchyMappingTaxonomyInfo',
    HierarchyMappingKeycatInfo: 'HierarchyMappingKeycatInfo',
    HierarchyMappingLeafRuleEvaluation: 'HierarchyMappingLeafRuleEvaluation',
    HierarchyMappingOuterRuleEvaluation: 'HierarchyMappingOuterRuleEvaluation',
    HierarchyConditionEvaluation: 'HierarchyConditionEvaluation',
    AttributeTypeWithFieldTypes: 'AttributeTypeWithFieldTypes',
    ModelColumnInfo: 'ModelColumnInfo',
    ScriptMetadataSummary: 'ScriptMetadataSummary',
    ScriptMetadataDetail: 'ScriptMetadataDetail',
    ScriptRunInfo: 'ScriptRunInfo',
    TaskDefinitionSummaryFragment: 'TaskDefinitionSummaryFragment',
    TaskDefinitionWorkflowNodeFragment: 'TaskDefinitionWorkflowNodeFragment',
    TaskDefinitionWorkflowChildFragment: 'TaskDefinitionWorkflowChildFragment',
    InternalTask: 'InternalTask'
  }
}